/*eslint-disable*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const sync_pb = $root.sync_pb = (() => {

    /**
     * Namespace sync_pb.
     * @exports sync_pb
     * @namespace
     */
    const sync_pb = {};

    sync_pb.ProfilingData = (function() {

        /**
         * Properties of a ProfilingData.
         * @memberof sync_pb
         * @interface IProfilingData
         * @property {number|Long|null} [metaDataWriteTime] ProfilingData metaDataWriteTime
         * @property {number|Long|null} [fileDataWriteTime] ProfilingData fileDataWriteTime
         * @property {number|Long|null} [userLookupTime] ProfilingData userLookupTime
         * @property {number|Long|null} [metaDataReadTime] ProfilingData metaDataReadTime
         * @property {number|Long|null} [fileDataReadTime] ProfilingData fileDataReadTime
         * @property {number|Long|null} [totalRequestTime] ProfilingData totalRequestTime
         */

        /**
         * Constructs a new ProfilingData.
         * @memberof sync_pb
         * @classdesc Represents a ProfilingData.
         * @implements IProfilingData
         * @constructor
         * @param {sync_pb.IProfilingData=} [properties] Properties to set
         */
        function ProfilingData(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ProfilingData metaDataWriteTime.
         * @member {number|Long} metaDataWriteTime
         * @memberof sync_pb.ProfilingData
         * @instance
         */
        ProfilingData.prototype.metaDataWriteTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ProfilingData fileDataWriteTime.
         * @member {number|Long} fileDataWriteTime
         * @memberof sync_pb.ProfilingData
         * @instance
         */
        ProfilingData.prototype.fileDataWriteTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ProfilingData userLookupTime.
         * @member {number|Long} userLookupTime
         * @memberof sync_pb.ProfilingData
         * @instance
         */
        ProfilingData.prototype.userLookupTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ProfilingData metaDataReadTime.
         * @member {number|Long} metaDataReadTime
         * @memberof sync_pb.ProfilingData
         * @instance
         */
        ProfilingData.prototype.metaDataReadTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ProfilingData fileDataReadTime.
         * @member {number|Long} fileDataReadTime
         * @memberof sync_pb.ProfilingData
         * @instance
         */
        ProfilingData.prototype.fileDataReadTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ProfilingData totalRequestTime.
         * @member {number|Long} totalRequestTime
         * @memberof sync_pb.ProfilingData
         * @instance
         */
        ProfilingData.prototype.totalRequestTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new ProfilingData instance using the specified properties.
         * @function create
         * @memberof sync_pb.ProfilingData
         * @static
         * @param {sync_pb.IProfilingData=} [properties] Properties to set
         * @returns {sync_pb.ProfilingData} ProfilingData instance
         */
        ProfilingData.create = function create(properties) {
            return new ProfilingData(properties);
        };

        /**
         * Encodes the specified ProfilingData message. Does not implicitly {@link sync_pb.ProfilingData.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ProfilingData
         * @static
         * @param {sync_pb.IProfilingData} message ProfilingData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProfilingData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.metaDataWriteTime != null && Object.hasOwnProperty.call(message, "metaDataWriteTime"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.metaDataWriteTime);
            if (message.fileDataWriteTime != null && Object.hasOwnProperty.call(message, "fileDataWriteTime"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.fileDataWriteTime);
            if (message.userLookupTime != null && Object.hasOwnProperty.call(message, "userLookupTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.userLookupTime);
            if (message.metaDataReadTime != null && Object.hasOwnProperty.call(message, "metaDataReadTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.metaDataReadTime);
            if (message.fileDataReadTime != null && Object.hasOwnProperty.call(message, "fileDataReadTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.fileDataReadTime);
            if (message.totalRequestTime != null && Object.hasOwnProperty.call(message, "totalRequestTime"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.totalRequestTime);
            return writer;
        };

        /**
         * Encodes the specified ProfilingData message, length delimited. Does not implicitly {@link sync_pb.ProfilingData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ProfilingData
         * @static
         * @param {sync_pb.IProfilingData} message ProfilingData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProfilingData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ProfilingData message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ProfilingData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ProfilingData} ProfilingData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProfilingData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ProfilingData();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.metaDataWriteTime = reader.int64();
                    break;
                case 2:
                    message.fileDataWriteTime = reader.int64();
                    break;
                case 3:
                    message.userLookupTime = reader.int64();
                    break;
                case 4:
                    message.metaDataReadTime = reader.int64();
                    break;
                case 5:
                    message.fileDataReadTime = reader.int64();
                    break;
                case 6:
                    message.totalRequestTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ProfilingData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ProfilingData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ProfilingData} ProfilingData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProfilingData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ProfilingData message.
         * @function verify
         * @memberof sync_pb.ProfilingData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ProfilingData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.metaDataWriteTime != null && message.hasOwnProperty("metaDataWriteTime"))
                if (!$util.isInteger(message.metaDataWriteTime) && !(message.metaDataWriteTime && $util.isInteger(message.metaDataWriteTime.low) && $util.isInteger(message.metaDataWriteTime.high)))
                    return "metaDataWriteTime: integer|Long expected";
            if (message.fileDataWriteTime != null && message.hasOwnProperty("fileDataWriteTime"))
                if (!$util.isInteger(message.fileDataWriteTime) && !(message.fileDataWriteTime && $util.isInteger(message.fileDataWriteTime.low) && $util.isInteger(message.fileDataWriteTime.high)))
                    return "fileDataWriteTime: integer|Long expected";
            if (message.userLookupTime != null && message.hasOwnProperty("userLookupTime"))
                if (!$util.isInteger(message.userLookupTime) && !(message.userLookupTime && $util.isInteger(message.userLookupTime.low) && $util.isInteger(message.userLookupTime.high)))
                    return "userLookupTime: integer|Long expected";
            if (message.metaDataReadTime != null && message.hasOwnProperty("metaDataReadTime"))
                if (!$util.isInteger(message.metaDataReadTime) && !(message.metaDataReadTime && $util.isInteger(message.metaDataReadTime.low) && $util.isInteger(message.metaDataReadTime.high)))
                    return "metaDataReadTime: integer|Long expected";
            if (message.fileDataReadTime != null && message.hasOwnProperty("fileDataReadTime"))
                if (!$util.isInteger(message.fileDataReadTime) && !(message.fileDataReadTime && $util.isInteger(message.fileDataReadTime.low) && $util.isInteger(message.fileDataReadTime.high)))
                    return "fileDataReadTime: integer|Long expected";
            if (message.totalRequestTime != null && message.hasOwnProperty("totalRequestTime"))
                if (!$util.isInteger(message.totalRequestTime) && !(message.totalRequestTime && $util.isInteger(message.totalRequestTime.low) && $util.isInteger(message.totalRequestTime.high)))
                    return "totalRequestTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a ProfilingData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ProfilingData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ProfilingData} ProfilingData
         */
        ProfilingData.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ProfilingData)
                return object;
            let message = new $root.sync_pb.ProfilingData();
            if (object.metaDataWriteTime != null)
                if ($util.Long)
                    (message.metaDataWriteTime = $util.Long.fromValue(object.metaDataWriteTime)).unsigned = false;
                else if (typeof object.metaDataWriteTime === "string")
                    message.metaDataWriteTime = parseInt(object.metaDataWriteTime, 10);
                else if (typeof object.metaDataWriteTime === "number")
                    message.metaDataWriteTime = object.metaDataWriteTime;
                else if (typeof object.metaDataWriteTime === "object")
                    message.metaDataWriteTime = new $util.LongBits(object.metaDataWriteTime.low >>> 0, object.metaDataWriteTime.high >>> 0).toNumber();
            if (object.fileDataWriteTime != null)
                if ($util.Long)
                    (message.fileDataWriteTime = $util.Long.fromValue(object.fileDataWriteTime)).unsigned = false;
                else if (typeof object.fileDataWriteTime === "string")
                    message.fileDataWriteTime = parseInt(object.fileDataWriteTime, 10);
                else if (typeof object.fileDataWriteTime === "number")
                    message.fileDataWriteTime = object.fileDataWriteTime;
                else if (typeof object.fileDataWriteTime === "object")
                    message.fileDataWriteTime = new $util.LongBits(object.fileDataWriteTime.low >>> 0, object.fileDataWriteTime.high >>> 0).toNumber();
            if (object.userLookupTime != null)
                if ($util.Long)
                    (message.userLookupTime = $util.Long.fromValue(object.userLookupTime)).unsigned = false;
                else if (typeof object.userLookupTime === "string")
                    message.userLookupTime = parseInt(object.userLookupTime, 10);
                else if (typeof object.userLookupTime === "number")
                    message.userLookupTime = object.userLookupTime;
                else if (typeof object.userLookupTime === "object")
                    message.userLookupTime = new $util.LongBits(object.userLookupTime.low >>> 0, object.userLookupTime.high >>> 0).toNumber();
            if (object.metaDataReadTime != null)
                if ($util.Long)
                    (message.metaDataReadTime = $util.Long.fromValue(object.metaDataReadTime)).unsigned = false;
                else if (typeof object.metaDataReadTime === "string")
                    message.metaDataReadTime = parseInt(object.metaDataReadTime, 10);
                else if (typeof object.metaDataReadTime === "number")
                    message.metaDataReadTime = object.metaDataReadTime;
                else if (typeof object.metaDataReadTime === "object")
                    message.metaDataReadTime = new $util.LongBits(object.metaDataReadTime.low >>> 0, object.metaDataReadTime.high >>> 0).toNumber();
            if (object.fileDataReadTime != null)
                if ($util.Long)
                    (message.fileDataReadTime = $util.Long.fromValue(object.fileDataReadTime)).unsigned = false;
                else if (typeof object.fileDataReadTime === "string")
                    message.fileDataReadTime = parseInt(object.fileDataReadTime, 10);
                else if (typeof object.fileDataReadTime === "number")
                    message.fileDataReadTime = object.fileDataReadTime;
                else if (typeof object.fileDataReadTime === "object")
                    message.fileDataReadTime = new $util.LongBits(object.fileDataReadTime.low >>> 0, object.fileDataReadTime.high >>> 0).toNumber();
            if (object.totalRequestTime != null)
                if ($util.Long)
                    (message.totalRequestTime = $util.Long.fromValue(object.totalRequestTime)).unsigned = false;
                else if (typeof object.totalRequestTime === "string")
                    message.totalRequestTime = parseInt(object.totalRequestTime, 10);
                else if (typeof object.totalRequestTime === "number")
                    message.totalRequestTime = object.totalRequestTime;
                else if (typeof object.totalRequestTime === "object")
                    message.totalRequestTime = new $util.LongBits(object.totalRequestTime.low >>> 0, object.totalRequestTime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a ProfilingData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ProfilingData
         * @static
         * @param {sync_pb.ProfilingData} message ProfilingData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ProfilingData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.metaDataWriteTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.metaDataWriteTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.fileDataWriteTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fileDataWriteTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.userLookupTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.userLookupTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.metaDataReadTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.metaDataReadTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.fileDataReadTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fileDataReadTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.totalRequestTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.totalRequestTime = options.longs === String ? "0" : 0;
            }
            if (message.metaDataWriteTime != null && message.hasOwnProperty("metaDataWriteTime"))
                if (typeof message.metaDataWriteTime === "number")
                    object.metaDataWriteTime = options.longs === String ? String(message.metaDataWriteTime) : message.metaDataWriteTime;
                else
                    object.metaDataWriteTime = options.longs === String ? $util.Long.prototype.toString.call(message.metaDataWriteTime) : options.longs === Number ? new $util.LongBits(message.metaDataWriteTime.low >>> 0, message.metaDataWriteTime.high >>> 0).toNumber() : message.metaDataWriteTime;
            if (message.fileDataWriteTime != null && message.hasOwnProperty("fileDataWriteTime"))
                if (typeof message.fileDataWriteTime === "number")
                    object.fileDataWriteTime = options.longs === String ? String(message.fileDataWriteTime) : message.fileDataWriteTime;
                else
                    object.fileDataWriteTime = options.longs === String ? $util.Long.prototype.toString.call(message.fileDataWriteTime) : options.longs === Number ? new $util.LongBits(message.fileDataWriteTime.low >>> 0, message.fileDataWriteTime.high >>> 0).toNumber() : message.fileDataWriteTime;
            if (message.userLookupTime != null && message.hasOwnProperty("userLookupTime"))
                if (typeof message.userLookupTime === "number")
                    object.userLookupTime = options.longs === String ? String(message.userLookupTime) : message.userLookupTime;
                else
                    object.userLookupTime = options.longs === String ? $util.Long.prototype.toString.call(message.userLookupTime) : options.longs === Number ? new $util.LongBits(message.userLookupTime.low >>> 0, message.userLookupTime.high >>> 0).toNumber() : message.userLookupTime;
            if (message.metaDataReadTime != null && message.hasOwnProperty("metaDataReadTime"))
                if (typeof message.metaDataReadTime === "number")
                    object.metaDataReadTime = options.longs === String ? String(message.metaDataReadTime) : message.metaDataReadTime;
                else
                    object.metaDataReadTime = options.longs === String ? $util.Long.prototype.toString.call(message.metaDataReadTime) : options.longs === Number ? new $util.LongBits(message.metaDataReadTime.low >>> 0, message.metaDataReadTime.high >>> 0).toNumber() : message.metaDataReadTime;
            if (message.fileDataReadTime != null && message.hasOwnProperty("fileDataReadTime"))
                if (typeof message.fileDataReadTime === "number")
                    object.fileDataReadTime = options.longs === String ? String(message.fileDataReadTime) : message.fileDataReadTime;
                else
                    object.fileDataReadTime = options.longs === String ? $util.Long.prototype.toString.call(message.fileDataReadTime) : options.longs === Number ? new $util.LongBits(message.fileDataReadTime.low >>> 0, message.fileDataReadTime.high >>> 0).toNumber() : message.fileDataReadTime;
            if (message.totalRequestTime != null && message.hasOwnProperty("totalRequestTime"))
                if (typeof message.totalRequestTime === "number")
                    object.totalRequestTime = options.longs === String ? String(message.totalRequestTime) : message.totalRequestTime;
                else
                    object.totalRequestTime = options.longs === String ? $util.Long.prototype.toString.call(message.totalRequestTime) : options.longs === Number ? new $util.LongBits(message.totalRequestTime.low >>> 0, message.totalRequestTime.high >>> 0).toNumber() : message.totalRequestTime;
            return object;
        };

        /**
         * Converts this ProfilingData to JSON.
         * @function toJSON
         * @memberof sync_pb.ProfilingData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ProfilingData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ProfilingData;
    })();

    sync_pb.EntitySpecifics = (function() {

        /**
         * Properties of an EntitySpecifics.
         * @memberof sync_pb
         * @interface IEntitySpecifics
         * @property {sync_pb.IEncryptedData|null} [encrypted] EntitySpecifics encrypted
         * @property {sync_pb.IManagedUserSpecifics|null} [managedUser] EntitySpecifics managedUser
         * @property {sync_pb.IManagedUserSharedSettingSpecifics|null} [managedUserSharedSetting] EntitySpecifics managedUserSharedSetting
         * @property {sync_pb.IBookmarkSpecifics|null} [bookmark] EntitySpecifics bookmark
         * @property {sync_pb.ITypedUrlSpecifics|null} [typedUrl] EntitySpecifics typedUrl
         * @property {sync_pb.INigoriSpecifics|null} [nigori] EntitySpecifics nigori
         * @property {sync_pb.IDeviceInfoSpecifics|null} [deviceInfo] EntitySpecifics deviceInfo
         * @property {sync_pb.IExperimentsSpecifics|null} [experiments] EntitySpecifics experiments
         * @property {sync_pb.ISyncedNotificationSpecifics|null} [syncedNotification] EntitySpecifics syncedNotification
         * @property {sync_pb.ISyncedNotificationAppInfoSpecifics|null} [syncedNotificationAppInfo] EntitySpecifics syncedNotificationAppInfo
         * @property {sync_pb.IPasswordSpecifics|null} [password] EntitySpecifics password
         * @property {sync_pb.ISessionSpecifics|null} [session] EntitySpecifics session
         * @property {sync_pb.IHistoryDeleteDirectiveSpecifics|null} [historyDeleteDirective] EntitySpecifics historyDeleteDirective
         * @property {sync_pb.IPreferenceSpecifics|null} [preference] EntitySpecifics preference
         */

        /**
         * Constructs a new EntitySpecifics.
         * @memberof sync_pb
         * @classdesc Represents an EntitySpecifics.
         * @implements IEntitySpecifics
         * @constructor
         * @param {sync_pb.IEntitySpecifics=} [properties] Properties to set
         */
        function EntitySpecifics(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EntitySpecifics encrypted.
         * @member {sync_pb.IEncryptedData|null|undefined} encrypted
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        EntitySpecifics.prototype.encrypted = null;

        /**
         * EntitySpecifics managedUser.
         * @member {sync_pb.IManagedUserSpecifics|null|undefined} managedUser
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        EntitySpecifics.prototype.managedUser = null;

        /**
         * EntitySpecifics managedUserSharedSetting.
         * @member {sync_pb.IManagedUserSharedSettingSpecifics|null|undefined} managedUserSharedSetting
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        EntitySpecifics.prototype.managedUserSharedSetting = null;

        /**
         * EntitySpecifics bookmark.
         * @member {sync_pb.IBookmarkSpecifics|null|undefined} bookmark
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        EntitySpecifics.prototype.bookmark = null;

        /**
         * EntitySpecifics typedUrl.
         * @member {sync_pb.ITypedUrlSpecifics|null|undefined} typedUrl
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        EntitySpecifics.prototype.typedUrl = null;

        /**
         * EntitySpecifics nigori.
         * @member {sync_pb.INigoriSpecifics|null|undefined} nigori
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        EntitySpecifics.prototype.nigori = null;

        /**
         * EntitySpecifics deviceInfo.
         * @member {sync_pb.IDeviceInfoSpecifics|null|undefined} deviceInfo
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        EntitySpecifics.prototype.deviceInfo = null;

        /**
         * EntitySpecifics experiments.
         * @member {sync_pb.IExperimentsSpecifics|null|undefined} experiments
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        EntitySpecifics.prototype.experiments = null;

        /**
         * EntitySpecifics syncedNotification.
         * @member {sync_pb.ISyncedNotificationSpecifics|null|undefined} syncedNotification
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        EntitySpecifics.prototype.syncedNotification = null;

        /**
         * EntitySpecifics syncedNotificationAppInfo.
         * @member {sync_pb.ISyncedNotificationAppInfoSpecifics|null|undefined} syncedNotificationAppInfo
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        EntitySpecifics.prototype.syncedNotificationAppInfo = null;

        /**
         * EntitySpecifics password.
         * @member {sync_pb.IPasswordSpecifics|null|undefined} password
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        EntitySpecifics.prototype.password = null;

        /**
         * EntitySpecifics session.
         * @member {sync_pb.ISessionSpecifics|null|undefined} session
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        EntitySpecifics.prototype.session = null;

        /**
         * EntitySpecifics historyDeleteDirective.
         * @member {sync_pb.IHistoryDeleteDirectiveSpecifics|null|undefined} historyDeleteDirective
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        EntitySpecifics.prototype.historyDeleteDirective = null;

        /**
         * EntitySpecifics preference.
         * @member {sync_pb.IPreferenceSpecifics|null|undefined} preference
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        EntitySpecifics.prototype.preference = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * EntitySpecifics specificsVariant.
         * @member {"managedUser"|"managedUserSharedSetting"|"bookmark"|"typedUrl"|"nigori"|"deviceInfo"|"experiments"|"syncedNotification"|"syncedNotificationAppInfo"|"password"|"session"|"historyDeleteDirective"|"preference"|undefined} specificsVariant
         * @memberof sync_pb.EntitySpecifics
         * @instance
         */
        Object.defineProperty(EntitySpecifics.prototype, "specificsVariant", {
            get: $util.oneOfGetter($oneOfFields = ["managedUser", "managedUserSharedSetting", "bookmark", "typedUrl", "nigori", "deviceInfo", "experiments", "syncedNotification", "syncedNotificationAppInfo", "password", "session", "historyDeleteDirective", "preference"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new EntitySpecifics instance using the specified properties.
         * @function create
         * @memberof sync_pb.EntitySpecifics
         * @static
         * @param {sync_pb.IEntitySpecifics=} [properties] Properties to set
         * @returns {sync_pb.EntitySpecifics} EntitySpecifics instance
         */
        EntitySpecifics.create = function create(properties) {
            return new EntitySpecifics(properties);
        };

        /**
         * Encodes the specified EntitySpecifics message. Does not implicitly {@link sync_pb.EntitySpecifics.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.EntitySpecifics
         * @static
         * @param {sync_pb.IEntitySpecifics} message EntitySpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntitySpecifics.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.encrypted != null && Object.hasOwnProperty.call(message, "encrypted"))
                $root.sync_pb.EncryptedData.encode(message.encrypted, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.bookmark != null && Object.hasOwnProperty.call(message, "bookmark"))
                $root.sync_pb.BookmarkSpecifics.encode(message.bookmark, writer.uint32(/* id 32904, wireType 2 =*/263234).fork()).ldelim();
            if (message.preference != null && Object.hasOwnProperty.call(message, "preference"))
                $root.sync_pb.PreferenceSpecifics.encode(message.preference, writer.uint32(/* id 37702, wireType 2 =*/301618).fork()).ldelim();
            if (message.typedUrl != null && Object.hasOwnProperty.call(message, "typedUrl"))
                $root.sync_pb.TypedUrlSpecifics.encode(message.typedUrl, writer.uint32(/* id 40781, wireType 2 =*/326250).fork()).ldelim();
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                $root.sync_pb.PasswordSpecifics.encode(message.password, writer.uint32(/* id 45873, wireType 2 =*/366986).fork()).ldelim();
            if (message.nigori != null && Object.hasOwnProperty.call(message, "nigori"))
                $root.sync_pb.NigoriSpecifics.encode(message.nigori, writer.uint32(/* id 47745, wireType 2 =*/381962).fork()).ldelim();
            if (message.session != null && Object.hasOwnProperty.call(message, "session"))
                $root.sync_pb.SessionSpecifics.encode(message.session, writer.uint32(/* id 50119, wireType 2 =*/400954).fork()).ldelim();
            if (message.historyDeleteDirective != null && Object.hasOwnProperty.call(message, "historyDeleteDirective"))
                $root.sync_pb.HistoryDeleteDirectiveSpecifics.encode(message.historyDeleteDirective, writer.uint32(/* id 150251, wireType 2 =*/1202010).fork()).ldelim();
            if (message.syncedNotification != null && Object.hasOwnProperty.call(message, "syncedNotification"))
                $root.sync_pb.SyncedNotificationSpecifics.encode(message.syncedNotification, writer.uint32(/* id 153108, wireType 2 =*/1224866).fork()).ldelim();
            if (message.deviceInfo != null && Object.hasOwnProperty.call(message, "deviceInfo"))
                $root.sync_pb.DeviceInfoSpecifics.encode(message.deviceInfo, writer.uint32(/* id 154522, wireType 2 =*/1236178).fork()).ldelim();
            if (message.experiments != null && Object.hasOwnProperty.call(message, "experiments"))
                $root.sync_pb.ExperimentsSpecifics.encode(message.experiments, writer.uint32(/* id 161496, wireType 2 =*/1291970).fork()).ldelim();
            if (message.managedUser != null && Object.hasOwnProperty.call(message, "managedUser"))
                $root.sync_pb.ManagedUserSpecifics.encode(message.managedUser, writer.uint32(/* id 194582, wireType 2 =*/1556658).fork()).ldelim();
            if (message.managedUserSharedSetting != null && Object.hasOwnProperty.call(message, "managedUserSharedSetting"))
                $root.sync_pb.ManagedUserSharedSettingSpecifics.encode(message.managedUserSharedSetting, writer.uint32(/* id 202026, wireType 2 =*/1616210).fork()).ldelim();
            if (message.syncedNotificationAppInfo != null && Object.hasOwnProperty.call(message, "syncedNotificationAppInfo"))
                $root.sync_pb.SyncedNotificationAppInfoSpecifics.encode(message.syncedNotificationAppInfo, writer.uint32(/* id 235816, wireType 2 =*/1886530).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified EntitySpecifics message, length delimited. Does not implicitly {@link sync_pb.EntitySpecifics.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.EntitySpecifics
         * @static
         * @param {sync_pb.IEntitySpecifics} message EntitySpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EntitySpecifics.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EntitySpecifics message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.EntitySpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.EntitySpecifics} EntitySpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntitySpecifics.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.EntitySpecifics();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.encrypted = $root.sync_pb.EncryptedData.decode(reader, reader.uint32());
                    break;
                case 194582:
                    message.managedUser = $root.sync_pb.ManagedUserSpecifics.decode(reader, reader.uint32());
                    break;
                case 202026:
                    message.managedUserSharedSetting = $root.sync_pb.ManagedUserSharedSettingSpecifics.decode(reader, reader.uint32());
                    break;
                case 32904:
                    message.bookmark = $root.sync_pb.BookmarkSpecifics.decode(reader, reader.uint32());
                    break;
                case 40781:
                    message.typedUrl = $root.sync_pb.TypedUrlSpecifics.decode(reader, reader.uint32());
                    break;
                case 47745:
                    message.nigori = $root.sync_pb.NigoriSpecifics.decode(reader, reader.uint32());
                    break;
                case 154522:
                    message.deviceInfo = $root.sync_pb.DeviceInfoSpecifics.decode(reader, reader.uint32());
                    break;
                case 161496:
                    message.experiments = $root.sync_pb.ExperimentsSpecifics.decode(reader, reader.uint32());
                    break;
                case 153108:
                    message.syncedNotification = $root.sync_pb.SyncedNotificationSpecifics.decode(reader, reader.uint32());
                    break;
                case 235816:
                    message.syncedNotificationAppInfo = $root.sync_pb.SyncedNotificationAppInfoSpecifics.decode(reader, reader.uint32());
                    break;
                case 45873:
                    message.password = $root.sync_pb.PasswordSpecifics.decode(reader, reader.uint32());
                    break;
                case 50119:
                    message.session = $root.sync_pb.SessionSpecifics.decode(reader, reader.uint32());
                    break;
                case 150251:
                    message.historyDeleteDirective = $root.sync_pb.HistoryDeleteDirectiveSpecifics.decode(reader, reader.uint32());
                    break;
                case 37702:
                    message.preference = $root.sync_pb.PreferenceSpecifics.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EntitySpecifics message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.EntitySpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.EntitySpecifics} EntitySpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EntitySpecifics.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EntitySpecifics message.
         * @function verify
         * @memberof sync_pb.EntitySpecifics
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EntitySpecifics.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.encrypted != null && message.hasOwnProperty("encrypted")) {
                let error = $root.sync_pb.EncryptedData.verify(message.encrypted);
                if (error)
                    return "encrypted." + error;
            }
            if (message.managedUser != null && message.hasOwnProperty("managedUser")) {
                properties.specificsVariant = 1;
                {
                    let error = $root.sync_pb.ManagedUserSpecifics.verify(message.managedUser);
                    if (error)
                        return "managedUser." + error;
                }
            }
            if (message.managedUserSharedSetting != null && message.hasOwnProperty("managedUserSharedSetting")) {
                if (properties.specificsVariant === 1)
                    return "specificsVariant: multiple values";
                properties.specificsVariant = 1;
                {
                    let error = $root.sync_pb.ManagedUserSharedSettingSpecifics.verify(message.managedUserSharedSetting);
                    if (error)
                        return "managedUserSharedSetting." + error;
                }
            }
            if (message.bookmark != null && message.hasOwnProperty("bookmark")) {
                if (properties.specificsVariant === 1)
                    return "specificsVariant: multiple values";
                properties.specificsVariant = 1;
                {
                    let error = $root.sync_pb.BookmarkSpecifics.verify(message.bookmark);
                    if (error)
                        return "bookmark." + error;
                }
            }
            if (message.typedUrl != null && message.hasOwnProperty("typedUrl")) {
                if (properties.specificsVariant === 1)
                    return "specificsVariant: multiple values";
                properties.specificsVariant = 1;
                {
                    let error = $root.sync_pb.TypedUrlSpecifics.verify(message.typedUrl);
                    if (error)
                        return "typedUrl." + error;
                }
            }
            if (message.nigori != null && message.hasOwnProperty("nigori")) {
                if (properties.specificsVariant === 1)
                    return "specificsVariant: multiple values";
                properties.specificsVariant = 1;
                {
                    let error = $root.sync_pb.NigoriSpecifics.verify(message.nigori);
                    if (error)
                        return "nigori." + error;
                }
            }
            if (message.deviceInfo != null && message.hasOwnProperty("deviceInfo")) {
                if (properties.specificsVariant === 1)
                    return "specificsVariant: multiple values";
                properties.specificsVariant = 1;
                {
                    let error = $root.sync_pb.DeviceInfoSpecifics.verify(message.deviceInfo);
                    if (error)
                        return "deviceInfo." + error;
                }
            }
            if (message.experiments != null && message.hasOwnProperty("experiments")) {
                if (properties.specificsVariant === 1)
                    return "specificsVariant: multiple values";
                properties.specificsVariant = 1;
                {
                    let error = $root.sync_pb.ExperimentsSpecifics.verify(message.experiments);
                    if (error)
                        return "experiments." + error;
                }
            }
            if (message.syncedNotification != null && message.hasOwnProperty("syncedNotification")) {
                if (properties.specificsVariant === 1)
                    return "specificsVariant: multiple values";
                properties.specificsVariant = 1;
                {
                    let error = $root.sync_pb.SyncedNotificationSpecifics.verify(message.syncedNotification);
                    if (error)
                        return "syncedNotification." + error;
                }
            }
            if (message.syncedNotificationAppInfo != null && message.hasOwnProperty("syncedNotificationAppInfo")) {
                if (properties.specificsVariant === 1)
                    return "specificsVariant: multiple values";
                properties.specificsVariant = 1;
                {
                    let error = $root.sync_pb.SyncedNotificationAppInfoSpecifics.verify(message.syncedNotificationAppInfo);
                    if (error)
                        return "syncedNotificationAppInfo." + error;
                }
            }
            if (message.password != null && message.hasOwnProperty("password")) {
                if (properties.specificsVariant === 1)
                    return "specificsVariant: multiple values";
                properties.specificsVariant = 1;
                {
                    let error = $root.sync_pb.PasswordSpecifics.verify(message.password);
                    if (error)
                        return "password." + error;
                }
            }
            if (message.session != null && message.hasOwnProperty("session")) {
                if (properties.specificsVariant === 1)
                    return "specificsVariant: multiple values";
                properties.specificsVariant = 1;
                {
                    let error = $root.sync_pb.SessionSpecifics.verify(message.session);
                    if (error)
                        return "session." + error;
                }
            }
            if (message.historyDeleteDirective != null && message.hasOwnProperty("historyDeleteDirective")) {
                if (properties.specificsVariant === 1)
                    return "specificsVariant: multiple values";
                properties.specificsVariant = 1;
                {
                    let error = $root.sync_pb.HistoryDeleteDirectiveSpecifics.verify(message.historyDeleteDirective);
                    if (error)
                        return "historyDeleteDirective." + error;
                }
            }
            if (message.preference != null && message.hasOwnProperty("preference")) {
                if (properties.specificsVariant === 1)
                    return "specificsVariant: multiple values";
                properties.specificsVariant = 1;
                {
                    let error = $root.sync_pb.PreferenceSpecifics.verify(message.preference);
                    if (error)
                        return "preference." + error;
                }
            }
            return null;
        };

        /**
         * Creates an EntitySpecifics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.EntitySpecifics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.EntitySpecifics} EntitySpecifics
         */
        EntitySpecifics.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.EntitySpecifics)
                return object;
            let message = new $root.sync_pb.EntitySpecifics();
            if (object.encrypted != null) {
                if (typeof object.encrypted !== "object")
                    throw TypeError(".sync_pb.EntitySpecifics.encrypted: object expected");
                message.encrypted = $root.sync_pb.EncryptedData.fromObject(object.encrypted);
            }
            if (object.managedUser != null) {
                if (typeof object.managedUser !== "object")
                    throw TypeError(".sync_pb.EntitySpecifics.managedUser: object expected");
                message.managedUser = $root.sync_pb.ManagedUserSpecifics.fromObject(object.managedUser);
            }
            if (object.managedUserSharedSetting != null) {
                if (typeof object.managedUserSharedSetting !== "object")
                    throw TypeError(".sync_pb.EntitySpecifics.managedUserSharedSetting: object expected");
                message.managedUserSharedSetting = $root.sync_pb.ManagedUserSharedSettingSpecifics.fromObject(object.managedUserSharedSetting);
            }
            if (object.bookmark != null) {
                if (typeof object.bookmark !== "object")
                    throw TypeError(".sync_pb.EntitySpecifics.bookmark: object expected");
                message.bookmark = $root.sync_pb.BookmarkSpecifics.fromObject(object.bookmark);
            }
            if (object.typedUrl != null) {
                if (typeof object.typedUrl !== "object")
                    throw TypeError(".sync_pb.EntitySpecifics.typedUrl: object expected");
                message.typedUrl = $root.sync_pb.TypedUrlSpecifics.fromObject(object.typedUrl);
            }
            if (object.nigori != null) {
                if (typeof object.nigori !== "object")
                    throw TypeError(".sync_pb.EntitySpecifics.nigori: object expected");
                message.nigori = $root.sync_pb.NigoriSpecifics.fromObject(object.nigori);
            }
            if (object.deviceInfo != null) {
                if (typeof object.deviceInfo !== "object")
                    throw TypeError(".sync_pb.EntitySpecifics.deviceInfo: object expected");
                message.deviceInfo = $root.sync_pb.DeviceInfoSpecifics.fromObject(object.deviceInfo);
            }
            if (object.experiments != null) {
                if (typeof object.experiments !== "object")
                    throw TypeError(".sync_pb.EntitySpecifics.experiments: object expected");
                message.experiments = $root.sync_pb.ExperimentsSpecifics.fromObject(object.experiments);
            }
            if (object.syncedNotification != null) {
                if (typeof object.syncedNotification !== "object")
                    throw TypeError(".sync_pb.EntitySpecifics.syncedNotification: object expected");
                message.syncedNotification = $root.sync_pb.SyncedNotificationSpecifics.fromObject(object.syncedNotification);
            }
            if (object.syncedNotificationAppInfo != null) {
                if (typeof object.syncedNotificationAppInfo !== "object")
                    throw TypeError(".sync_pb.EntitySpecifics.syncedNotificationAppInfo: object expected");
                message.syncedNotificationAppInfo = $root.sync_pb.SyncedNotificationAppInfoSpecifics.fromObject(object.syncedNotificationAppInfo);
            }
            if (object.password != null) {
                if (typeof object.password !== "object")
                    throw TypeError(".sync_pb.EntitySpecifics.password: object expected");
                message.password = $root.sync_pb.PasswordSpecifics.fromObject(object.password);
            }
            if (object.session != null) {
                if (typeof object.session !== "object")
                    throw TypeError(".sync_pb.EntitySpecifics.session: object expected");
                message.session = $root.sync_pb.SessionSpecifics.fromObject(object.session);
            }
            if (object.historyDeleteDirective != null) {
                if (typeof object.historyDeleteDirective !== "object")
                    throw TypeError(".sync_pb.EntitySpecifics.historyDeleteDirective: object expected");
                message.historyDeleteDirective = $root.sync_pb.HistoryDeleteDirectiveSpecifics.fromObject(object.historyDeleteDirective);
            }
            if (object.preference != null) {
                if (typeof object.preference !== "object")
                    throw TypeError(".sync_pb.EntitySpecifics.preference: object expected");
                message.preference = $root.sync_pb.PreferenceSpecifics.fromObject(object.preference);
            }
            return message;
        };

        /**
         * Creates a plain object from an EntitySpecifics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.EntitySpecifics
         * @static
         * @param {sync_pb.EntitySpecifics} message EntitySpecifics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EntitySpecifics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.encrypted = null;
            if (message.encrypted != null && message.hasOwnProperty("encrypted"))
                object.encrypted = $root.sync_pb.EncryptedData.toObject(message.encrypted, options);
            if (message.bookmark != null && message.hasOwnProperty("bookmark")) {
                object.bookmark = $root.sync_pb.BookmarkSpecifics.toObject(message.bookmark, options);
                if (options.oneofs)
                    object.specificsVariant = "bookmark";
            }
            if (message.preference != null && message.hasOwnProperty("preference")) {
                object.preference = $root.sync_pb.PreferenceSpecifics.toObject(message.preference, options);
                if (options.oneofs)
                    object.specificsVariant = "preference";
            }
            if (message.typedUrl != null && message.hasOwnProperty("typedUrl")) {
                object.typedUrl = $root.sync_pb.TypedUrlSpecifics.toObject(message.typedUrl, options);
                if (options.oneofs)
                    object.specificsVariant = "typedUrl";
            }
            if (message.password != null && message.hasOwnProperty("password")) {
                object.password = $root.sync_pb.PasswordSpecifics.toObject(message.password, options);
                if (options.oneofs)
                    object.specificsVariant = "password";
            }
            if (message.nigori != null && message.hasOwnProperty("nigori")) {
                object.nigori = $root.sync_pb.NigoriSpecifics.toObject(message.nigori, options);
                if (options.oneofs)
                    object.specificsVariant = "nigori";
            }
            if (message.session != null && message.hasOwnProperty("session")) {
                object.session = $root.sync_pb.SessionSpecifics.toObject(message.session, options);
                if (options.oneofs)
                    object.specificsVariant = "session";
            }
            if (message.historyDeleteDirective != null && message.hasOwnProperty("historyDeleteDirective")) {
                object.historyDeleteDirective = $root.sync_pb.HistoryDeleteDirectiveSpecifics.toObject(message.historyDeleteDirective, options);
                if (options.oneofs)
                    object.specificsVariant = "historyDeleteDirective";
            }
            if (message.syncedNotification != null && message.hasOwnProperty("syncedNotification")) {
                object.syncedNotification = $root.sync_pb.SyncedNotificationSpecifics.toObject(message.syncedNotification, options);
                if (options.oneofs)
                    object.specificsVariant = "syncedNotification";
            }
            if (message.deviceInfo != null && message.hasOwnProperty("deviceInfo")) {
                object.deviceInfo = $root.sync_pb.DeviceInfoSpecifics.toObject(message.deviceInfo, options);
                if (options.oneofs)
                    object.specificsVariant = "deviceInfo";
            }
            if (message.experiments != null && message.hasOwnProperty("experiments")) {
                object.experiments = $root.sync_pb.ExperimentsSpecifics.toObject(message.experiments, options);
                if (options.oneofs)
                    object.specificsVariant = "experiments";
            }
            if (message.managedUser != null && message.hasOwnProperty("managedUser")) {
                object.managedUser = $root.sync_pb.ManagedUserSpecifics.toObject(message.managedUser, options);
                if (options.oneofs)
                    object.specificsVariant = "managedUser";
            }
            if (message.managedUserSharedSetting != null && message.hasOwnProperty("managedUserSharedSetting")) {
                object.managedUserSharedSetting = $root.sync_pb.ManagedUserSharedSettingSpecifics.toObject(message.managedUserSharedSetting, options);
                if (options.oneofs)
                    object.specificsVariant = "managedUserSharedSetting";
            }
            if (message.syncedNotificationAppInfo != null && message.hasOwnProperty("syncedNotificationAppInfo")) {
                object.syncedNotificationAppInfo = $root.sync_pb.SyncedNotificationAppInfoSpecifics.toObject(message.syncedNotificationAppInfo, options);
                if (options.oneofs)
                    object.specificsVariant = "syncedNotificationAppInfo";
            }
            return object;
        };

        /**
         * Converts this EntitySpecifics to JSON.
         * @function toJSON
         * @memberof sync_pb.EntitySpecifics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EntitySpecifics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EntitySpecifics;
    })();

    sync_pb.SyncEntity = (function() {

        /**
         * Properties of a SyncEntity.
         * @memberof sync_pb
         * @interface ISyncEntity
         * @property {string|null} [idString] SyncEntity idString
         * @property {string|null} [parentIdString] SyncEntity parentIdString
         * @property {string|null} [oldParentId] SyncEntity oldParentId
         * @property {number|Long} version SyncEntity version
         * @property {number|Long|null} [mtime] SyncEntity mtime
         * @property {number|Long|null} [ctime] SyncEntity ctime
         * @property {string} name SyncEntity name
         * @property {string|null} [nonUniqueName] SyncEntity nonUniqueName
         * @property {string|null} [serverDefinedUniqueTag] SyncEntity serverDefinedUniqueTag
         * @property {number|Long|null} [positionInParent] SyncEntity positionInParent
         * @property {string|null} [insertAfterItemId] SyncEntity insertAfterItemId
         * @property {boolean|null} [deleted] SyncEntity deleted
         * @property {string|null} [originatorCacheGuid] SyncEntity originatorCacheGuid
         * @property {string|null} [originatorClientItemId] SyncEntity originatorClientItemId
         * @property {sync_pb.IEntitySpecifics|null} [specifics] SyncEntity specifics
         * @property {boolean|null} [folder] SyncEntity folder
         * @property {string|null} [clientDefinedUniqueTag] SyncEntity clientDefinedUniqueTag
         * @property {Uint8Array|null} [ordinalInParent] SyncEntity ordinalInParent
         * @property {sync_pb.IUniquePosition|null} [uniquePosition] SyncEntity uniquePosition
         */

        /**
         * Constructs a new SyncEntity.
         * @memberof sync_pb
         * @classdesc Represents a SyncEntity.
         * @implements ISyncEntity
         * @constructor
         * @param {sync_pb.ISyncEntity=} [properties] Properties to set
         */
        function SyncEntity(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncEntity idString.
         * @member {string} idString
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.idString = "";

        /**
         * SyncEntity parentIdString.
         * @member {string} parentIdString
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.parentIdString = "";

        /**
         * SyncEntity oldParentId.
         * @member {string} oldParentId
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.oldParentId = "";

        /**
         * SyncEntity version.
         * @member {number|Long} version
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.version = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SyncEntity mtime.
         * @member {number|Long} mtime
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.mtime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SyncEntity ctime.
         * @member {number|Long} ctime
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.ctime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SyncEntity name.
         * @member {string} name
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.name = "";

        /**
         * SyncEntity nonUniqueName.
         * @member {string} nonUniqueName
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.nonUniqueName = "";

        /**
         * SyncEntity serverDefinedUniqueTag.
         * @member {string} serverDefinedUniqueTag
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.serverDefinedUniqueTag = "";

        /**
         * SyncEntity positionInParent.
         * @member {number|Long} positionInParent
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.positionInParent = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SyncEntity insertAfterItemId.
         * @member {string} insertAfterItemId
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.insertAfterItemId = "";

        /**
         * SyncEntity deleted.
         * @member {boolean} deleted
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.deleted = false;

        /**
         * SyncEntity originatorCacheGuid.
         * @member {string} originatorCacheGuid
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.originatorCacheGuid = "";

        /**
         * SyncEntity originatorClientItemId.
         * @member {string} originatorClientItemId
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.originatorClientItemId = "";

        /**
         * SyncEntity specifics.
         * @member {sync_pb.IEntitySpecifics|null|undefined} specifics
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.specifics = null;

        /**
         * SyncEntity folder.
         * @member {boolean} folder
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.folder = false;

        /**
         * SyncEntity clientDefinedUniqueTag.
         * @member {string} clientDefinedUniqueTag
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.clientDefinedUniqueTag = "";

        /**
         * SyncEntity ordinalInParent.
         * @member {Uint8Array} ordinalInParent
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.ordinalInParent = $util.newBuffer([]);

        /**
         * SyncEntity uniquePosition.
         * @member {sync_pb.IUniquePosition|null|undefined} uniquePosition
         * @memberof sync_pb.SyncEntity
         * @instance
         */
        SyncEntity.prototype.uniquePosition = null;

        /**
         * Creates a new SyncEntity instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncEntity
         * @static
         * @param {sync_pb.ISyncEntity=} [properties] Properties to set
         * @returns {sync_pb.SyncEntity} SyncEntity instance
         */
        SyncEntity.create = function create(properties) {
            return new SyncEntity(properties);
        };

        /**
         * Encodes the specified SyncEntity message. Does not implicitly {@link sync_pb.SyncEntity.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncEntity
         * @static
         * @param {sync_pb.ISyncEntity} message SyncEntity message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncEntity.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.idString != null && Object.hasOwnProperty.call(message, "idString"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.idString);
            if (message.parentIdString != null && Object.hasOwnProperty.call(message, "parentIdString"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.parentIdString);
            if (message.oldParentId != null && Object.hasOwnProperty.call(message, "oldParentId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.oldParentId);
            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.version);
            if (message.mtime != null && Object.hasOwnProperty.call(message, "mtime"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.mtime);
            if (message.ctime != null && Object.hasOwnProperty.call(message, "ctime"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.ctime);
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.name);
            if (message.nonUniqueName != null && Object.hasOwnProperty.call(message, "nonUniqueName"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.nonUniqueName);
            if (message.serverDefinedUniqueTag != null && Object.hasOwnProperty.call(message, "serverDefinedUniqueTag"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.serverDefinedUniqueTag);
            if (message.positionInParent != null && Object.hasOwnProperty.call(message, "positionInParent"))
                writer.uint32(/* id 15, wireType 0 =*/120).int64(message.positionInParent);
            if (message.insertAfterItemId != null && Object.hasOwnProperty.call(message, "insertAfterItemId"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.insertAfterItemId);
            if (message.deleted != null && Object.hasOwnProperty.call(message, "deleted"))
                writer.uint32(/* id 18, wireType 0 =*/144).bool(message.deleted);
            if (message.originatorCacheGuid != null && Object.hasOwnProperty.call(message, "originatorCacheGuid"))
                writer.uint32(/* id 19, wireType 2 =*/154).string(message.originatorCacheGuid);
            if (message.originatorClientItemId != null && Object.hasOwnProperty.call(message, "originatorClientItemId"))
                writer.uint32(/* id 20, wireType 2 =*/162).string(message.originatorClientItemId);
            if (message.specifics != null && Object.hasOwnProperty.call(message, "specifics"))
                $root.sync_pb.EntitySpecifics.encode(message.specifics, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
            if (message.folder != null && Object.hasOwnProperty.call(message, "folder"))
                writer.uint32(/* id 22, wireType 0 =*/176).bool(message.folder);
            if (message.clientDefinedUniqueTag != null && Object.hasOwnProperty.call(message, "clientDefinedUniqueTag"))
                writer.uint32(/* id 23, wireType 2 =*/186).string(message.clientDefinedUniqueTag);
            if (message.ordinalInParent != null && Object.hasOwnProperty.call(message, "ordinalInParent"))
                writer.uint32(/* id 24, wireType 2 =*/194).bytes(message.ordinalInParent);
            if (message.uniquePosition != null && Object.hasOwnProperty.call(message, "uniquePosition"))
                $root.sync_pb.UniquePosition.encode(message.uniquePosition, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SyncEntity message, length delimited. Does not implicitly {@link sync_pb.SyncEntity.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncEntity
         * @static
         * @param {sync_pb.ISyncEntity} message SyncEntity message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncEntity.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncEntity message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncEntity
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncEntity} SyncEntity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncEntity.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncEntity();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.idString = reader.string();
                    break;
                case 2:
                    message.parentIdString = reader.string();
                    break;
                case 3:
                    message.oldParentId = reader.string();
                    break;
                case 4:
                    message.version = reader.int64();
                    break;
                case 5:
                    message.mtime = reader.int64();
                    break;
                case 6:
                    message.ctime = reader.int64();
                    break;
                case 7:
                    message.name = reader.string();
                    break;
                case 8:
                    message.nonUniqueName = reader.string();
                    break;
                case 10:
                    message.serverDefinedUniqueTag = reader.string();
                    break;
                case 15:
                    message.positionInParent = reader.int64();
                    break;
                case 16:
                    message.insertAfterItemId = reader.string();
                    break;
                case 18:
                    message.deleted = reader.bool();
                    break;
                case 19:
                    message.originatorCacheGuid = reader.string();
                    break;
                case 20:
                    message.originatorClientItemId = reader.string();
                    break;
                case 21:
                    message.specifics = $root.sync_pb.EntitySpecifics.decode(reader, reader.uint32());
                    break;
                case 22:
                    message.folder = reader.bool();
                    break;
                case 23:
                    message.clientDefinedUniqueTag = reader.string();
                    break;
                case 24:
                    message.ordinalInParent = reader.bytes();
                    break;
                case 25:
                    message.uniquePosition = $root.sync_pb.UniquePosition.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("version"))
                throw $util.ProtocolError("missing required 'version'", { instance: message });
            if (!message.hasOwnProperty("name"))
                throw $util.ProtocolError("missing required 'name'", { instance: message });
            return message;
        };

        /**
         * Decodes a SyncEntity message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncEntity
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncEntity} SyncEntity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncEntity.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncEntity message.
         * @function verify
         * @memberof sync_pb.SyncEntity
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncEntity.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.idString != null && message.hasOwnProperty("idString"))
                if (!$util.isString(message.idString))
                    return "idString: string expected";
            if (message.parentIdString != null && message.hasOwnProperty("parentIdString"))
                if (!$util.isString(message.parentIdString))
                    return "parentIdString: string expected";
            if (message.oldParentId != null && message.hasOwnProperty("oldParentId"))
                if (!$util.isString(message.oldParentId))
                    return "oldParentId: string expected";
            if (!$util.isInteger(message.version) && !(message.version && $util.isInteger(message.version.low) && $util.isInteger(message.version.high)))
                return "version: integer|Long expected";
            if (message.mtime != null && message.hasOwnProperty("mtime"))
                if (!$util.isInteger(message.mtime) && !(message.mtime && $util.isInteger(message.mtime.low) && $util.isInteger(message.mtime.high)))
                    return "mtime: integer|Long expected";
            if (message.ctime != null && message.hasOwnProperty("ctime"))
                if (!$util.isInteger(message.ctime) && !(message.ctime && $util.isInteger(message.ctime.low) && $util.isInteger(message.ctime.high)))
                    return "ctime: integer|Long expected";
            if (!$util.isString(message.name))
                return "name: string expected";
            if (message.nonUniqueName != null && message.hasOwnProperty("nonUniqueName"))
                if (!$util.isString(message.nonUniqueName))
                    return "nonUniqueName: string expected";
            if (message.serverDefinedUniqueTag != null && message.hasOwnProperty("serverDefinedUniqueTag"))
                if (!$util.isString(message.serverDefinedUniqueTag))
                    return "serverDefinedUniqueTag: string expected";
            if (message.positionInParent != null && message.hasOwnProperty("positionInParent"))
                if (!$util.isInteger(message.positionInParent) && !(message.positionInParent && $util.isInteger(message.positionInParent.low) && $util.isInteger(message.positionInParent.high)))
                    return "positionInParent: integer|Long expected";
            if (message.insertAfterItemId != null && message.hasOwnProperty("insertAfterItemId"))
                if (!$util.isString(message.insertAfterItemId))
                    return "insertAfterItemId: string expected";
            if (message.deleted != null && message.hasOwnProperty("deleted"))
                if (typeof message.deleted !== "boolean")
                    return "deleted: boolean expected";
            if (message.originatorCacheGuid != null && message.hasOwnProperty("originatorCacheGuid"))
                if (!$util.isString(message.originatorCacheGuid))
                    return "originatorCacheGuid: string expected";
            if (message.originatorClientItemId != null && message.hasOwnProperty("originatorClientItemId"))
                if (!$util.isString(message.originatorClientItemId))
                    return "originatorClientItemId: string expected";
            if (message.specifics != null && message.hasOwnProperty("specifics")) {
                let error = $root.sync_pb.EntitySpecifics.verify(message.specifics);
                if (error)
                    return "specifics." + error;
            }
            if (message.folder != null && message.hasOwnProperty("folder"))
                if (typeof message.folder !== "boolean")
                    return "folder: boolean expected";
            if (message.clientDefinedUniqueTag != null && message.hasOwnProperty("clientDefinedUniqueTag"))
                if (!$util.isString(message.clientDefinedUniqueTag))
                    return "clientDefinedUniqueTag: string expected";
            if (message.ordinalInParent != null && message.hasOwnProperty("ordinalInParent"))
                if (!(message.ordinalInParent && typeof message.ordinalInParent.length === "number" || $util.isString(message.ordinalInParent)))
                    return "ordinalInParent: buffer expected";
            if (message.uniquePosition != null && message.hasOwnProperty("uniquePosition")) {
                let error = $root.sync_pb.UniquePosition.verify(message.uniquePosition);
                if (error)
                    return "uniquePosition." + error;
            }
            return null;
        };

        /**
         * Creates a SyncEntity message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncEntity
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncEntity} SyncEntity
         */
        SyncEntity.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncEntity)
                return object;
            let message = new $root.sync_pb.SyncEntity();
            if (object.idString != null)
                message.idString = String(object.idString);
            if (object.parentIdString != null)
                message.parentIdString = String(object.parentIdString);
            if (object.oldParentId != null)
                message.oldParentId = String(object.oldParentId);
            if (object.version != null)
                if ($util.Long)
                    (message.version = $util.Long.fromValue(object.version)).unsigned = false;
                else if (typeof object.version === "string")
                    message.version = parseInt(object.version, 10);
                else if (typeof object.version === "number")
                    message.version = object.version;
                else if (typeof object.version === "object")
                    message.version = new $util.LongBits(object.version.low >>> 0, object.version.high >>> 0).toNumber();
            if (object.mtime != null)
                if ($util.Long)
                    (message.mtime = $util.Long.fromValue(object.mtime)).unsigned = false;
                else if (typeof object.mtime === "string")
                    message.mtime = parseInt(object.mtime, 10);
                else if (typeof object.mtime === "number")
                    message.mtime = object.mtime;
                else if (typeof object.mtime === "object")
                    message.mtime = new $util.LongBits(object.mtime.low >>> 0, object.mtime.high >>> 0).toNumber();
            if (object.ctime != null)
                if ($util.Long)
                    (message.ctime = $util.Long.fromValue(object.ctime)).unsigned = false;
                else if (typeof object.ctime === "string")
                    message.ctime = parseInt(object.ctime, 10);
                else if (typeof object.ctime === "number")
                    message.ctime = object.ctime;
                else if (typeof object.ctime === "object")
                    message.ctime = new $util.LongBits(object.ctime.low >>> 0, object.ctime.high >>> 0).toNumber();
            if (object.name != null)
                message.name = String(object.name);
            if (object.nonUniqueName != null)
                message.nonUniqueName = String(object.nonUniqueName);
            if (object.serverDefinedUniqueTag != null)
                message.serverDefinedUniqueTag = String(object.serverDefinedUniqueTag);
            if (object.positionInParent != null)
                if ($util.Long)
                    (message.positionInParent = $util.Long.fromValue(object.positionInParent)).unsigned = false;
                else if (typeof object.positionInParent === "string")
                    message.positionInParent = parseInt(object.positionInParent, 10);
                else if (typeof object.positionInParent === "number")
                    message.positionInParent = object.positionInParent;
                else if (typeof object.positionInParent === "object")
                    message.positionInParent = new $util.LongBits(object.positionInParent.low >>> 0, object.positionInParent.high >>> 0).toNumber();
            if (object.insertAfterItemId != null)
                message.insertAfterItemId = String(object.insertAfterItemId);
            if (object.deleted != null)
                message.deleted = Boolean(object.deleted);
            if (object.originatorCacheGuid != null)
                message.originatorCacheGuid = String(object.originatorCacheGuid);
            if (object.originatorClientItemId != null)
                message.originatorClientItemId = String(object.originatorClientItemId);
            if (object.specifics != null) {
                if (typeof object.specifics !== "object")
                    throw TypeError(".sync_pb.SyncEntity.specifics: object expected");
                message.specifics = $root.sync_pb.EntitySpecifics.fromObject(object.specifics);
            }
            if (object.folder != null)
                message.folder = Boolean(object.folder);
            if (object.clientDefinedUniqueTag != null)
                message.clientDefinedUniqueTag = String(object.clientDefinedUniqueTag);
            if (object.ordinalInParent != null)
                if (typeof object.ordinalInParent === "string")
                    $util.base64.decode(object.ordinalInParent, message.ordinalInParent = $util.newBuffer($util.base64.length(object.ordinalInParent)), 0);
                else if (object.ordinalInParent.length)
                    message.ordinalInParent = object.ordinalInParent;
            if (object.uniquePosition != null) {
                if (typeof object.uniquePosition !== "object")
                    throw TypeError(".sync_pb.SyncEntity.uniquePosition: object expected");
                message.uniquePosition = $root.sync_pb.UniquePosition.fromObject(object.uniquePosition);
            }
            return message;
        };

        /**
         * Creates a plain object from a SyncEntity message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncEntity
         * @static
         * @param {sync_pb.SyncEntity} message SyncEntity
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncEntity.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.idString = "";
                object.parentIdString = "";
                object.oldParentId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.version = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.version = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.mtime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.mtime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.ctime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ctime = options.longs === String ? "0" : 0;
                object.name = "";
                object.nonUniqueName = "";
                object.serverDefinedUniqueTag = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.positionInParent = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.positionInParent = options.longs === String ? "0" : 0;
                object.insertAfterItemId = "";
                object.deleted = false;
                object.originatorCacheGuid = "";
                object.originatorClientItemId = "";
                object.specifics = null;
                object.folder = false;
                object.clientDefinedUniqueTag = "";
                if (options.bytes === String)
                    object.ordinalInParent = "";
                else {
                    object.ordinalInParent = [];
                    if (options.bytes !== Array)
                        object.ordinalInParent = $util.newBuffer(object.ordinalInParent);
                }
                object.uniquePosition = null;
            }
            if (message.idString != null && message.hasOwnProperty("idString"))
                object.idString = message.idString;
            if (message.parentIdString != null && message.hasOwnProperty("parentIdString"))
                object.parentIdString = message.parentIdString;
            if (message.oldParentId != null && message.hasOwnProperty("oldParentId"))
                object.oldParentId = message.oldParentId;
            if (message.version != null && message.hasOwnProperty("version"))
                if (typeof message.version === "number")
                    object.version = options.longs === String ? String(message.version) : message.version;
                else
                    object.version = options.longs === String ? $util.Long.prototype.toString.call(message.version) : options.longs === Number ? new $util.LongBits(message.version.low >>> 0, message.version.high >>> 0).toNumber() : message.version;
            if (message.mtime != null && message.hasOwnProperty("mtime"))
                if (typeof message.mtime === "number")
                    object.mtime = options.longs === String ? String(message.mtime) : message.mtime;
                else
                    object.mtime = options.longs === String ? $util.Long.prototype.toString.call(message.mtime) : options.longs === Number ? new $util.LongBits(message.mtime.low >>> 0, message.mtime.high >>> 0).toNumber() : message.mtime;
            if (message.ctime != null && message.hasOwnProperty("ctime"))
                if (typeof message.ctime === "number")
                    object.ctime = options.longs === String ? String(message.ctime) : message.ctime;
                else
                    object.ctime = options.longs === String ? $util.Long.prototype.toString.call(message.ctime) : options.longs === Number ? new $util.LongBits(message.ctime.low >>> 0, message.ctime.high >>> 0).toNumber() : message.ctime;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.nonUniqueName != null && message.hasOwnProperty("nonUniqueName"))
                object.nonUniqueName = message.nonUniqueName;
            if (message.serverDefinedUniqueTag != null && message.hasOwnProperty("serverDefinedUniqueTag"))
                object.serverDefinedUniqueTag = message.serverDefinedUniqueTag;
            if (message.positionInParent != null && message.hasOwnProperty("positionInParent"))
                if (typeof message.positionInParent === "number")
                    object.positionInParent = options.longs === String ? String(message.positionInParent) : message.positionInParent;
                else
                    object.positionInParent = options.longs === String ? $util.Long.prototype.toString.call(message.positionInParent) : options.longs === Number ? new $util.LongBits(message.positionInParent.low >>> 0, message.positionInParent.high >>> 0).toNumber() : message.positionInParent;
            if (message.insertAfterItemId != null && message.hasOwnProperty("insertAfterItemId"))
                object.insertAfterItemId = message.insertAfterItemId;
            if (message.deleted != null && message.hasOwnProperty("deleted"))
                object.deleted = message.deleted;
            if (message.originatorCacheGuid != null && message.hasOwnProperty("originatorCacheGuid"))
                object.originatorCacheGuid = message.originatorCacheGuid;
            if (message.originatorClientItemId != null && message.hasOwnProperty("originatorClientItemId"))
                object.originatorClientItemId = message.originatorClientItemId;
            if (message.specifics != null && message.hasOwnProperty("specifics"))
                object.specifics = $root.sync_pb.EntitySpecifics.toObject(message.specifics, options);
            if (message.folder != null && message.hasOwnProperty("folder"))
                object.folder = message.folder;
            if (message.clientDefinedUniqueTag != null && message.hasOwnProperty("clientDefinedUniqueTag"))
                object.clientDefinedUniqueTag = message.clientDefinedUniqueTag;
            if (message.ordinalInParent != null && message.hasOwnProperty("ordinalInParent"))
                object.ordinalInParent = options.bytes === String ? $util.base64.encode(message.ordinalInParent, 0, message.ordinalInParent.length) : options.bytes === Array ? Array.prototype.slice.call(message.ordinalInParent) : message.ordinalInParent;
            if (message.uniquePosition != null && message.hasOwnProperty("uniquePosition"))
                object.uniquePosition = $root.sync_pb.UniquePosition.toObject(message.uniquePosition, options);
            return object;
        };

        /**
         * Converts this SyncEntity to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncEntity
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncEntity.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncEntity;
    })();

    sync_pb.ChromiumExtensionsActivity = (function() {

        /**
         * Properties of a ChromiumExtensionsActivity.
         * @memberof sync_pb
         * @interface IChromiumExtensionsActivity
         * @property {string|null} [extensionId] ChromiumExtensionsActivity extensionId
         * @property {number|null} [bookmarkWritesSinceLastCommit] ChromiumExtensionsActivity bookmarkWritesSinceLastCommit
         */

        /**
         * Constructs a new ChromiumExtensionsActivity.
         * @memberof sync_pb
         * @classdesc Represents a ChromiumExtensionsActivity.
         * @implements IChromiumExtensionsActivity
         * @constructor
         * @param {sync_pb.IChromiumExtensionsActivity=} [properties] Properties to set
         */
        function ChromiumExtensionsActivity(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChromiumExtensionsActivity extensionId.
         * @member {string} extensionId
         * @memberof sync_pb.ChromiumExtensionsActivity
         * @instance
         */
        ChromiumExtensionsActivity.prototype.extensionId = "";

        /**
         * ChromiumExtensionsActivity bookmarkWritesSinceLastCommit.
         * @member {number} bookmarkWritesSinceLastCommit
         * @memberof sync_pb.ChromiumExtensionsActivity
         * @instance
         */
        ChromiumExtensionsActivity.prototype.bookmarkWritesSinceLastCommit = 0;

        /**
         * Creates a new ChromiumExtensionsActivity instance using the specified properties.
         * @function create
         * @memberof sync_pb.ChromiumExtensionsActivity
         * @static
         * @param {sync_pb.IChromiumExtensionsActivity=} [properties] Properties to set
         * @returns {sync_pb.ChromiumExtensionsActivity} ChromiumExtensionsActivity instance
         */
        ChromiumExtensionsActivity.create = function create(properties) {
            return new ChromiumExtensionsActivity(properties);
        };

        /**
         * Encodes the specified ChromiumExtensionsActivity message. Does not implicitly {@link sync_pb.ChromiumExtensionsActivity.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ChromiumExtensionsActivity
         * @static
         * @param {sync_pb.IChromiumExtensionsActivity} message ChromiumExtensionsActivity message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChromiumExtensionsActivity.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.extensionId != null && Object.hasOwnProperty.call(message, "extensionId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.extensionId);
            if (message.bookmarkWritesSinceLastCommit != null && Object.hasOwnProperty.call(message, "bookmarkWritesSinceLastCommit"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.bookmarkWritesSinceLastCommit);
            return writer;
        };

        /**
         * Encodes the specified ChromiumExtensionsActivity message, length delimited. Does not implicitly {@link sync_pb.ChromiumExtensionsActivity.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ChromiumExtensionsActivity
         * @static
         * @param {sync_pb.IChromiumExtensionsActivity} message ChromiumExtensionsActivity message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChromiumExtensionsActivity.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChromiumExtensionsActivity message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ChromiumExtensionsActivity
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ChromiumExtensionsActivity} ChromiumExtensionsActivity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChromiumExtensionsActivity.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ChromiumExtensionsActivity();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.extensionId = reader.string();
                    break;
                case 2:
                    message.bookmarkWritesSinceLastCommit = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChromiumExtensionsActivity message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ChromiumExtensionsActivity
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ChromiumExtensionsActivity} ChromiumExtensionsActivity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChromiumExtensionsActivity.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChromiumExtensionsActivity message.
         * @function verify
         * @memberof sync_pb.ChromiumExtensionsActivity
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChromiumExtensionsActivity.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.extensionId != null && message.hasOwnProperty("extensionId"))
                if (!$util.isString(message.extensionId))
                    return "extensionId: string expected";
            if (message.bookmarkWritesSinceLastCommit != null && message.hasOwnProperty("bookmarkWritesSinceLastCommit"))
                if (!$util.isInteger(message.bookmarkWritesSinceLastCommit))
                    return "bookmarkWritesSinceLastCommit: integer expected";
            return null;
        };

        /**
         * Creates a ChromiumExtensionsActivity message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ChromiumExtensionsActivity
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ChromiumExtensionsActivity} ChromiumExtensionsActivity
         */
        ChromiumExtensionsActivity.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ChromiumExtensionsActivity)
                return object;
            let message = new $root.sync_pb.ChromiumExtensionsActivity();
            if (object.extensionId != null)
                message.extensionId = String(object.extensionId);
            if (object.bookmarkWritesSinceLastCommit != null)
                message.bookmarkWritesSinceLastCommit = object.bookmarkWritesSinceLastCommit >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ChromiumExtensionsActivity message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ChromiumExtensionsActivity
         * @static
         * @param {sync_pb.ChromiumExtensionsActivity} message ChromiumExtensionsActivity
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChromiumExtensionsActivity.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.extensionId = "";
                object.bookmarkWritesSinceLastCommit = 0;
            }
            if (message.extensionId != null && message.hasOwnProperty("extensionId"))
                object.extensionId = message.extensionId;
            if (message.bookmarkWritesSinceLastCommit != null && message.hasOwnProperty("bookmarkWritesSinceLastCommit"))
                object.bookmarkWritesSinceLastCommit = message.bookmarkWritesSinceLastCommit;
            return object;
        };

        /**
         * Converts this ChromiumExtensionsActivity to JSON.
         * @function toJSON
         * @memberof sync_pb.ChromiumExtensionsActivity
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChromiumExtensionsActivity.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ChromiumExtensionsActivity;
    })();

    sync_pb.ClientConfigParams = (function() {

        /**
         * Properties of a ClientConfigParams.
         * @memberof sync_pb
         * @interface IClientConfigParams
         * @property {Array.<number>|null} [enabledTypeIds] ClientConfigParams enabledTypeIds
         * @property {boolean|null} [tabsDatatypeEnabled] ClientConfigParams tabsDatatypeEnabled
         * @property {boolean|null} [cookieJarMismatch] ClientConfigParams cookieJarMismatch
         */

        /**
         * Constructs a new ClientConfigParams.
         * @memberof sync_pb
         * @classdesc Represents a ClientConfigParams.
         * @implements IClientConfigParams
         * @constructor
         * @param {sync_pb.IClientConfigParams=} [properties] Properties to set
         */
        function ClientConfigParams(properties) {
            this.enabledTypeIds = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClientConfigParams enabledTypeIds.
         * @member {Array.<number>} enabledTypeIds
         * @memberof sync_pb.ClientConfigParams
         * @instance
         */
        ClientConfigParams.prototype.enabledTypeIds = $util.emptyArray;

        /**
         * ClientConfigParams tabsDatatypeEnabled.
         * @member {boolean} tabsDatatypeEnabled
         * @memberof sync_pb.ClientConfigParams
         * @instance
         */
        ClientConfigParams.prototype.tabsDatatypeEnabled = false;

        /**
         * ClientConfigParams cookieJarMismatch.
         * @member {boolean} cookieJarMismatch
         * @memberof sync_pb.ClientConfigParams
         * @instance
         */
        ClientConfigParams.prototype.cookieJarMismatch = false;

        /**
         * Creates a new ClientConfigParams instance using the specified properties.
         * @function create
         * @memberof sync_pb.ClientConfigParams
         * @static
         * @param {sync_pb.IClientConfigParams=} [properties] Properties to set
         * @returns {sync_pb.ClientConfigParams} ClientConfigParams instance
         */
        ClientConfigParams.create = function create(properties) {
            return new ClientConfigParams(properties);
        };

        /**
         * Encodes the specified ClientConfigParams message. Does not implicitly {@link sync_pb.ClientConfigParams.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ClientConfigParams
         * @static
         * @param {sync_pb.IClientConfigParams} message ClientConfigParams message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientConfigParams.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.enabledTypeIds != null && message.enabledTypeIds.length)
                for (let i = 0; i < message.enabledTypeIds.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.enabledTypeIds[i]);
            if (message.tabsDatatypeEnabled != null && Object.hasOwnProperty.call(message, "tabsDatatypeEnabled"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.tabsDatatypeEnabled);
            if (message.cookieJarMismatch != null && Object.hasOwnProperty.call(message, "cookieJarMismatch"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.cookieJarMismatch);
            return writer;
        };

        /**
         * Encodes the specified ClientConfigParams message, length delimited. Does not implicitly {@link sync_pb.ClientConfigParams.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ClientConfigParams
         * @static
         * @param {sync_pb.IClientConfigParams} message ClientConfigParams message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientConfigParams.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClientConfigParams message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ClientConfigParams
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ClientConfigParams} ClientConfigParams
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientConfigParams.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ClientConfigParams();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.enabledTypeIds && message.enabledTypeIds.length))
                        message.enabledTypeIds = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.enabledTypeIds.push(reader.int32());
                    } else
                        message.enabledTypeIds.push(reader.int32());
                    break;
                case 2:
                    message.tabsDatatypeEnabled = reader.bool();
                    break;
                case 3:
                    message.cookieJarMismatch = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ClientConfigParams message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ClientConfigParams
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ClientConfigParams} ClientConfigParams
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientConfigParams.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClientConfigParams message.
         * @function verify
         * @memberof sync_pb.ClientConfigParams
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClientConfigParams.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.enabledTypeIds != null && message.hasOwnProperty("enabledTypeIds")) {
                if (!Array.isArray(message.enabledTypeIds))
                    return "enabledTypeIds: array expected";
                for (let i = 0; i < message.enabledTypeIds.length; ++i)
                    if (!$util.isInteger(message.enabledTypeIds[i]))
                        return "enabledTypeIds: integer[] expected";
            }
            if (message.tabsDatatypeEnabled != null && message.hasOwnProperty("tabsDatatypeEnabled"))
                if (typeof message.tabsDatatypeEnabled !== "boolean")
                    return "tabsDatatypeEnabled: boolean expected";
            if (message.cookieJarMismatch != null && message.hasOwnProperty("cookieJarMismatch"))
                if (typeof message.cookieJarMismatch !== "boolean")
                    return "cookieJarMismatch: boolean expected";
            return null;
        };

        /**
         * Creates a ClientConfigParams message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ClientConfigParams
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ClientConfigParams} ClientConfigParams
         */
        ClientConfigParams.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ClientConfigParams)
                return object;
            let message = new $root.sync_pb.ClientConfigParams();
            if (object.enabledTypeIds) {
                if (!Array.isArray(object.enabledTypeIds))
                    throw TypeError(".sync_pb.ClientConfigParams.enabledTypeIds: array expected");
                message.enabledTypeIds = [];
                for (let i = 0; i < object.enabledTypeIds.length; ++i)
                    message.enabledTypeIds[i] = object.enabledTypeIds[i] | 0;
            }
            if (object.tabsDatatypeEnabled != null)
                message.tabsDatatypeEnabled = Boolean(object.tabsDatatypeEnabled);
            if (object.cookieJarMismatch != null)
                message.cookieJarMismatch = Boolean(object.cookieJarMismatch);
            return message;
        };

        /**
         * Creates a plain object from a ClientConfigParams message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ClientConfigParams
         * @static
         * @param {sync_pb.ClientConfigParams} message ClientConfigParams
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClientConfigParams.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.enabledTypeIds = [];
            if (options.defaults) {
                object.tabsDatatypeEnabled = false;
                object.cookieJarMismatch = false;
            }
            if (message.enabledTypeIds && message.enabledTypeIds.length) {
                object.enabledTypeIds = [];
                for (let j = 0; j < message.enabledTypeIds.length; ++j)
                    object.enabledTypeIds[j] = message.enabledTypeIds[j];
            }
            if (message.tabsDatatypeEnabled != null && message.hasOwnProperty("tabsDatatypeEnabled"))
                object.tabsDatatypeEnabled = message.tabsDatatypeEnabled;
            if (message.cookieJarMismatch != null && message.hasOwnProperty("cookieJarMismatch"))
                object.cookieJarMismatch = message.cookieJarMismatch;
            return object;
        };

        /**
         * Converts this ClientConfigParams to JSON.
         * @function toJSON
         * @memberof sync_pb.ClientConfigParams
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClientConfigParams.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClientConfigParams;
    })();

    sync_pb.CommitMessage = (function() {

        /**
         * Properties of a CommitMessage.
         * @memberof sync_pb
         * @interface ICommitMessage
         * @property {Array.<sync_pb.ISyncEntity>|null} [entries] CommitMessage entries
         * @property {string|null} [cacheGuid] CommitMessage cacheGuid
         * @property {Array.<sync_pb.IChromiumExtensionsActivity>|null} [extensionsActivity] CommitMessage extensionsActivity
         * @property {sync_pb.IClientConfigParams|null} [configParams] CommitMessage configParams
         * @property {Array.<sync_pb.IDataTypeContext>|null} [clientContexts] CommitMessage clientContexts
         * @property {string|null} [padding] CommitMessage padding
         */

        /**
         * Constructs a new CommitMessage.
         * @memberof sync_pb
         * @classdesc Represents a CommitMessage.
         * @implements ICommitMessage
         * @constructor
         * @param {sync_pb.ICommitMessage=} [properties] Properties to set
         */
        function CommitMessage(properties) {
            this.entries = [];
            this.extensionsActivity = [];
            this.clientContexts = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CommitMessage entries.
         * @member {Array.<sync_pb.ISyncEntity>} entries
         * @memberof sync_pb.CommitMessage
         * @instance
         */
        CommitMessage.prototype.entries = $util.emptyArray;

        /**
         * CommitMessage cacheGuid.
         * @member {string} cacheGuid
         * @memberof sync_pb.CommitMessage
         * @instance
         */
        CommitMessage.prototype.cacheGuid = "";

        /**
         * CommitMessage extensionsActivity.
         * @member {Array.<sync_pb.IChromiumExtensionsActivity>} extensionsActivity
         * @memberof sync_pb.CommitMessage
         * @instance
         */
        CommitMessage.prototype.extensionsActivity = $util.emptyArray;

        /**
         * CommitMessage configParams.
         * @member {sync_pb.IClientConfigParams|null|undefined} configParams
         * @memberof sync_pb.CommitMessage
         * @instance
         */
        CommitMessage.prototype.configParams = null;

        /**
         * CommitMessage clientContexts.
         * @member {Array.<sync_pb.IDataTypeContext>} clientContexts
         * @memberof sync_pb.CommitMessage
         * @instance
         */
        CommitMessage.prototype.clientContexts = $util.emptyArray;

        /**
         * CommitMessage padding.
         * @member {string} padding
         * @memberof sync_pb.CommitMessage
         * @instance
         */
        CommitMessage.prototype.padding = "";

        /**
         * Creates a new CommitMessage instance using the specified properties.
         * @function create
         * @memberof sync_pb.CommitMessage
         * @static
         * @param {sync_pb.ICommitMessage=} [properties] Properties to set
         * @returns {sync_pb.CommitMessage} CommitMessage instance
         */
        CommitMessage.create = function create(properties) {
            return new CommitMessage(properties);
        };

        /**
         * Encodes the specified CommitMessage message. Does not implicitly {@link sync_pb.CommitMessage.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.CommitMessage
         * @static
         * @param {sync_pb.ICommitMessage} message CommitMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CommitMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.entries != null && message.entries.length)
                for (let i = 0; i < message.entries.length; ++i)
                    $root.sync_pb.SyncEntity.encode(message.entries[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.cacheGuid != null && Object.hasOwnProperty.call(message, "cacheGuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.cacheGuid);
            if (message.extensionsActivity != null && message.extensionsActivity.length)
                for (let i = 0; i < message.extensionsActivity.length; ++i)
                    $root.sync_pb.ChromiumExtensionsActivity.encode(message.extensionsActivity[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.configParams != null && Object.hasOwnProperty.call(message, "configParams"))
                $root.sync_pb.ClientConfigParams.encode(message.configParams, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.clientContexts != null && message.clientContexts.length)
                for (let i = 0; i < message.clientContexts.length; ++i)
                    $root.sync_pb.DataTypeContext.encode(message.clientContexts[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.padding != null && Object.hasOwnProperty.call(message, "padding"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.padding);
            return writer;
        };

        /**
         * Encodes the specified CommitMessage message, length delimited. Does not implicitly {@link sync_pb.CommitMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.CommitMessage
         * @static
         * @param {sync_pb.ICommitMessage} message CommitMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CommitMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CommitMessage message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.CommitMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.CommitMessage} CommitMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CommitMessage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.CommitMessage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.entries && message.entries.length))
                        message.entries = [];
                    message.entries.push($root.sync_pb.SyncEntity.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.cacheGuid = reader.string();
                    break;
                case 3:
                    if (!(message.extensionsActivity && message.extensionsActivity.length))
                        message.extensionsActivity = [];
                    message.extensionsActivity.push($root.sync_pb.ChromiumExtensionsActivity.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.configParams = $root.sync_pb.ClientConfigParams.decode(reader, reader.uint32());
                    break;
                case 5:
                    if (!(message.clientContexts && message.clientContexts.length))
                        message.clientContexts = [];
                    message.clientContexts.push($root.sync_pb.DataTypeContext.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.padding = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CommitMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.CommitMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.CommitMessage} CommitMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CommitMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CommitMessage message.
         * @function verify
         * @memberof sync_pb.CommitMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CommitMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.entries != null && message.hasOwnProperty("entries")) {
                if (!Array.isArray(message.entries))
                    return "entries: array expected";
                for (let i = 0; i < message.entries.length; ++i) {
                    let error = $root.sync_pb.SyncEntity.verify(message.entries[i]);
                    if (error)
                        return "entries." + error;
                }
            }
            if (message.cacheGuid != null && message.hasOwnProperty("cacheGuid"))
                if (!$util.isString(message.cacheGuid))
                    return "cacheGuid: string expected";
            if (message.extensionsActivity != null && message.hasOwnProperty("extensionsActivity")) {
                if (!Array.isArray(message.extensionsActivity))
                    return "extensionsActivity: array expected";
                for (let i = 0; i < message.extensionsActivity.length; ++i) {
                    let error = $root.sync_pb.ChromiumExtensionsActivity.verify(message.extensionsActivity[i]);
                    if (error)
                        return "extensionsActivity." + error;
                }
            }
            if (message.configParams != null && message.hasOwnProperty("configParams")) {
                let error = $root.sync_pb.ClientConfigParams.verify(message.configParams);
                if (error)
                    return "configParams." + error;
            }
            if (message.clientContexts != null && message.hasOwnProperty("clientContexts")) {
                if (!Array.isArray(message.clientContexts))
                    return "clientContexts: array expected";
                for (let i = 0; i < message.clientContexts.length; ++i) {
                    let error = $root.sync_pb.DataTypeContext.verify(message.clientContexts[i]);
                    if (error)
                        return "clientContexts." + error;
                }
            }
            if (message.padding != null && message.hasOwnProperty("padding"))
                if (!$util.isString(message.padding))
                    return "padding: string expected";
            return null;
        };

        /**
         * Creates a CommitMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.CommitMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.CommitMessage} CommitMessage
         */
        CommitMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.CommitMessage)
                return object;
            let message = new $root.sync_pb.CommitMessage();
            if (object.entries) {
                if (!Array.isArray(object.entries))
                    throw TypeError(".sync_pb.CommitMessage.entries: array expected");
                message.entries = [];
                for (let i = 0; i < object.entries.length; ++i) {
                    if (typeof object.entries[i] !== "object")
                        throw TypeError(".sync_pb.CommitMessage.entries: object expected");
                    message.entries[i] = $root.sync_pb.SyncEntity.fromObject(object.entries[i]);
                }
            }
            if (object.cacheGuid != null)
                message.cacheGuid = String(object.cacheGuid);
            if (object.extensionsActivity) {
                if (!Array.isArray(object.extensionsActivity))
                    throw TypeError(".sync_pb.CommitMessage.extensionsActivity: array expected");
                message.extensionsActivity = [];
                for (let i = 0; i < object.extensionsActivity.length; ++i) {
                    if (typeof object.extensionsActivity[i] !== "object")
                        throw TypeError(".sync_pb.CommitMessage.extensionsActivity: object expected");
                    message.extensionsActivity[i] = $root.sync_pb.ChromiumExtensionsActivity.fromObject(object.extensionsActivity[i]);
                }
            }
            if (object.configParams != null) {
                if (typeof object.configParams !== "object")
                    throw TypeError(".sync_pb.CommitMessage.configParams: object expected");
                message.configParams = $root.sync_pb.ClientConfigParams.fromObject(object.configParams);
            }
            if (object.clientContexts) {
                if (!Array.isArray(object.clientContexts))
                    throw TypeError(".sync_pb.CommitMessage.clientContexts: array expected");
                message.clientContexts = [];
                for (let i = 0; i < object.clientContexts.length; ++i) {
                    if (typeof object.clientContexts[i] !== "object")
                        throw TypeError(".sync_pb.CommitMessage.clientContexts: object expected");
                    message.clientContexts[i] = $root.sync_pb.DataTypeContext.fromObject(object.clientContexts[i]);
                }
            }
            if (object.padding != null)
                message.padding = String(object.padding);
            return message;
        };

        /**
         * Creates a plain object from a CommitMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.CommitMessage
         * @static
         * @param {sync_pb.CommitMessage} message CommitMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CommitMessage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.entries = [];
                object.extensionsActivity = [];
                object.clientContexts = [];
            }
            if (options.defaults) {
                object.cacheGuid = "";
                object.configParams = null;
                object.padding = "";
            }
            if (message.entries && message.entries.length) {
                object.entries = [];
                for (let j = 0; j < message.entries.length; ++j)
                    object.entries[j] = $root.sync_pb.SyncEntity.toObject(message.entries[j], options);
            }
            if (message.cacheGuid != null && message.hasOwnProperty("cacheGuid"))
                object.cacheGuid = message.cacheGuid;
            if (message.extensionsActivity && message.extensionsActivity.length) {
                object.extensionsActivity = [];
                for (let j = 0; j < message.extensionsActivity.length; ++j)
                    object.extensionsActivity[j] = $root.sync_pb.ChromiumExtensionsActivity.toObject(message.extensionsActivity[j], options);
            }
            if (message.configParams != null && message.hasOwnProperty("configParams"))
                object.configParams = $root.sync_pb.ClientConfigParams.toObject(message.configParams, options);
            if (message.clientContexts && message.clientContexts.length) {
                object.clientContexts = [];
                for (let j = 0; j < message.clientContexts.length; ++j)
                    object.clientContexts[j] = $root.sync_pb.DataTypeContext.toObject(message.clientContexts[j], options);
            }
            if (message.padding != null && message.hasOwnProperty("padding"))
                object.padding = message.padding;
            return object;
        };

        /**
         * Converts this CommitMessage to JSON.
         * @function toJSON
         * @memberof sync_pb.CommitMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CommitMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CommitMessage;
    })();

    sync_pb.GetUpdateTriggers = (function() {

        /**
         * Properties of a GetUpdateTriggers.
         * @memberof sync_pb
         * @interface IGetUpdateTriggers
         * @property {Array.<string>|null} [notificationHint] GetUpdateTriggers notificationHint
         * @property {boolean|null} [clientDroppedHints] GetUpdateTriggers clientDroppedHints
         * @property {boolean|null} [invalidationsOutOfSync] GetUpdateTriggers invalidationsOutOfSync
         * @property {number|Long|null} [localModificationNudges] GetUpdateTriggers localModificationNudges
         * @property {number|Long|null} [datatypeRefreshNudges] GetUpdateTriggers datatypeRefreshNudges
         * @property {boolean|null} [serverDroppedHints] GetUpdateTriggers serverDroppedHints
         * @property {boolean|null} [initialSyncInProgress] GetUpdateTriggers initialSyncInProgress
         * @property {boolean|null} [syncForResolveConflictInProgress] GetUpdateTriggers syncForResolveConflictInProgress
         */

        /**
         * Constructs a new GetUpdateTriggers.
         * @memberof sync_pb
         * @classdesc Represents a GetUpdateTriggers.
         * @implements IGetUpdateTriggers
         * @constructor
         * @param {sync_pb.IGetUpdateTriggers=} [properties] Properties to set
         */
        function GetUpdateTriggers(properties) {
            this.notificationHint = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUpdateTriggers notificationHint.
         * @member {Array.<string>} notificationHint
         * @memberof sync_pb.GetUpdateTriggers
         * @instance
         */
        GetUpdateTriggers.prototype.notificationHint = $util.emptyArray;

        /**
         * GetUpdateTriggers clientDroppedHints.
         * @member {boolean} clientDroppedHints
         * @memberof sync_pb.GetUpdateTriggers
         * @instance
         */
        GetUpdateTriggers.prototype.clientDroppedHints = false;

        /**
         * GetUpdateTriggers invalidationsOutOfSync.
         * @member {boolean} invalidationsOutOfSync
         * @memberof sync_pb.GetUpdateTriggers
         * @instance
         */
        GetUpdateTriggers.prototype.invalidationsOutOfSync = false;

        /**
         * GetUpdateTriggers localModificationNudges.
         * @member {number|Long} localModificationNudges
         * @memberof sync_pb.GetUpdateTriggers
         * @instance
         */
        GetUpdateTriggers.prototype.localModificationNudges = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * GetUpdateTriggers datatypeRefreshNudges.
         * @member {number|Long} datatypeRefreshNudges
         * @memberof sync_pb.GetUpdateTriggers
         * @instance
         */
        GetUpdateTriggers.prototype.datatypeRefreshNudges = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * GetUpdateTriggers serverDroppedHints.
         * @member {boolean} serverDroppedHints
         * @memberof sync_pb.GetUpdateTriggers
         * @instance
         */
        GetUpdateTriggers.prototype.serverDroppedHints = false;

        /**
         * GetUpdateTriggers initialSyncInProgress.
         * @member {boolean} initialSyncInProgress
         * @memberof sync_pb.GetUpdateTriggers
         * @instance
         */
        GetUpdateTriggers.prototype.initialSyncInProgress = false;

        /**
         * GetUpdateTriggers syncForResolveConflictInProgress.
         * @member {boolean} syncForResolveConflictInProgress
         * @memberof sync_pb.GetUpdateTriggers
         * @instance
         */
        GetUpdateTriggers.prototype.syncForResolveConflictInProgress = false;

        /**
         * Creates a new GetUpdateTriggers instance using the specified properties.
         * @function create
         * @memberof sync_pb.GetUpdateTriggers
         * @static
         * @param {sync_pb.IGetUpdateTriggers=} [properties] Properties to set
         * @returns {sync_pb.GetUpdateTriggers} GetUpdateTriggers instance
         */
        GetUpdateTriggers.create = function create(properties) {
            return new GetUpdateTriggers(properties);
        };

        /**
         * Encodes the specified GetUpdateTriggers message. Does not implicitly {@link sync_pb.GetUpdateTriggers.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.GetUpdateTriggers
         * @static
         * @param {sync_pb.IGetUpdateTriggers} message GetUpdateTriggers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUpdateTriggers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.notificationHint != null && message.notificationHint.length)
                for (let i = 0; i < message.notificationHint.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.notificationHint[i]);
            if (message.clientDroppedHints != null && Object.hasOwnProperty.call(message, "clientDroppedHints"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.clientDroppedHints);
            if (message.invalidationsOutOfSync != null && Object.hasOwnProperty.call(message, "invalidationsOutOfSync"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.invalidationsOutOfSync);
            if (message.localModificationNudges != null && Object.hasOwnProperty.call(message, "localModificationNudges"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.localModificationNudges);
            if (message.datatypeRefreshNudges != null && Object.hasOwnProperty.call(message, "datatypeRefreshNudges"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.datatypeRefreshNudges);
            if (message.serverDroppedHints != null && Object.hasOwnProperty.call(message, "serverDroppedHints"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.serverDroppedHints);
            if (message.initialSyncInProgress != null && Object.hasOwnProperty.call(message, "initialSyncInProgress"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.initialSyncInProgress);
            if (message.syncForResolveConflictInProgress != null && Object.hasOwnProperty.call(message, "syncForResolveConflictInProgress"))
                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.syncForResolveConflictInProgress);
            return writer;
        };

        /**
         * Encodes the specified GetUpdateTriggers message, length delimited. Does not implicitly {@link sync_pb.GetUpdateTriggers.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.GetUpdateTriggers
         * @static
         * @param {sync_pb.IGetUpdateTriggers} message GetUpdateTriggers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUpdateTriggers.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetUpdateTriggers message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.GetUpdateTriggers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.GetUpdateTriggers} GetUpdateTriggers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUpdateTriggers.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.GetUpdateTriggers();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.notificationHint && message.notificationHint.length))
                        message.notificationHint = [];
                    message.notificationHint.push(reader.string());
                    break;
                case 2:
                    message.clientDroppedHints = reader.bool();
                    break;
                case 3:
                    message.invalidationsOutOfSync = reader.bool();
                    break;
                case 4:
                    message.localModificationNudges = reader.int64();
                    break;
                case 5:
                    message.datatypeRefreshNudges = reader.int64();
                    break;
                case 6:
                    message.serverDroppedHints = reader.bool();
                    break;
                case 7:
                    message.initialSyncInProgress = reader.bool();
                    break;
                case 8:
                    message.syncForResolveConflictInProgress = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetUpdateTriggers message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.GetUpdateTriggers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.GetUpdateTriggers} GetUpdateTriggers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUpdateTriggers.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetUpdateTriggers message.
         * @function verify
         * @memberof sync_pb.GetUpdateTriggers
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetUpdateTriggers.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.notificationHint != null && message.hasOwnProperty("notificationHint")) {
                if (!Array.isArray(message.notificationHint))
                    return "notificationHint: array expected";
                for (let i = 0; i < message.notificationHint.length; ++i)
                    if (!$util.isString(message.notificationHint[i]))
                        return "notificationHint: string[] expected";
            }
            if (message.clientDroppedHints != null && message.hasOwnProperty("clientDroppedHints"))
                if (typeof message.clientDroppedHints !== "boolean")
                    return "clientDroppedHints: boolean expected";
            if (message.invalidationsOutOfSync != null && message.hasOwnProperty("invalidationsOutOfSync"))
                if (typeof message.invalidationsOutOfSync !== "boolean")
                    return "invalidationsOutOfSync: boolean expected";
            if (message.localModificationNudges != null && message.hasOwnProperty("localModificationNudges"))
                if (!$util.isInteger(message.localModificationNudges) && !(message.localModificationNudges && $util.isInteger(message.localModificationNudges.low) && $util.isInteger(message.localModificationNudges.high)))
                    return "localModificationNudges: integer|Long expected";
            if (message.datatypeRefreshNudges != null && message.hasOwnProperty("datatypeRefreshNudges"))
                if (!$util.isInteger(message.datatypeRefreshNudges) && !(message.datatypeRefreshNudges && $util.isInteger(message.datatypeRefreshNudges.low) && $util.isInteger(message.datatypeRefreshNudges.high)))
                    return "datatypeRefreshNudges: integer|Long expected";
            if (message.serverDroppedHints != null && message.hasOwnProperty("serverDroppedHints"))
                if (typeof message.serverDroppedHints !== "boolean")
                    return "serverDroppedHints: boolean expected";
            if (message.initialSyncInProgress != null && message.hasOwnProperty("initialSyncInProgress"))
                if (typeof message.initialSyncInProgress !== "boolean")
                    return "initialSyncInProgress: boolean expected";
            if (message.syncForResolveConflictInProgress != null && message.hasOwnProperty("syncForResolveConflictInProgress"))
                if (typeof message.syncForResolveConflictInProgress !== "boolean")
                    return "syncForResolveConflictInProgress: boolean expected";
            return null;
        };

        /**
         * Creates a GetUpdateTriggers message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.GetUpdateTriggers
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.GetUpdateTriggers} GetUpdateTriggers
         */
        GetUpdateTriggers.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.GetUpdateTriggers)
                return object;
            let message = new $root.sync_pb.GetUpdateTriggers();
            if (object.notificationHint) {
                if (!Array.isArray(object.notificationHint))
                    throw TypeError(".sync_pb.GetUpdateTriggers.notificationHint: array expected");
                message.notificationHint = [];
                for (let i = 0; i < object.notificationHint.length; ++i)
                    message.notificationHint[i] = String(object.notificationHint[i]);
            }
            if (object.clientDroppedHints != null)
                message.clientDroppedHints = Boolean(object.clientDroppedHints);
            if (object.invalidationsOutOfSync != null)
                message.invalidationsOutOfSync = Boolean(object.invalidationsOutOfSync);
            if (object.localModificationNudges != null)
                if ($util.Long)
                    (message.localModificationNudges = $util.Long.fromValue(object.localModificationNudges)).unsigned = false;
                else if (typeof object.localModificationNudges === "string")
                    message.localModificationNudges = parseInt(object.localModificationNudges, 10);
                else if (typeof object.localModificationNudges === "number")
                    message.localModificationNudges = object.localModificationNudges;
                else if (typeof object.localModificationNudges === "object")
                    message.localModificationNudges = new $util.LongBits(object.localModificationNudges.low >>> 0, object.localModificationNudges.high >>> 0).toNumber();
            if (object.datatypeRefreshNudges != null)
                if ($util.Long)
                    (message.datatypeRefreshNudges = $util.Long.fromValue(object.datatypeRefreshNudges)).unsigned = false;
                else if (typeof object.datatypeRefreshNudges === "string")
                    message.datatypeRefreshNudges = parseInt(object.datatypeRefreshNudges, 10);
                else if (typeof object.datatypeRefreshNudges === "number")
                    message.datatypeRefreshNudges = object.datatypeRefreshNudges;
                else if (typeof object.datatypeRefreshNudges === "object")
                    message.datatypeRefreshNudges = new $util.LongBits(object.datatypeRefreshNudges.low >>> 0, object.datatypeRefreshNudges.high >>> 0).toNumber();
            if (object.serverDroppedHints != null)
                message.serverDroppedHints = Boolean(object.serverDroppedHints);
            if (object.initialSyncInProgress != null)
                message.initialSyncInProgress = Boolean(object.initialSyncInProgress);
            if (object.syncForResolveConflictInProgress != null)
                message.syncForResolveConflictInProgress = Boolean(object.syncForResolveConflictInProgress);
            return message;
        };

        /**
         * Creates a plain object from a GetUpdateTriggers message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.GetUpdateTriggers
         * @static
         * @param {sync_pb.GetUpdateTriggers} message GetUpdateTriggers
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUpdateTriggers.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.notificationHint = [];
            if (options.defaults) {
                object.clientDroppedHints = false;
                object.invalidationsOutOfSync = false;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.localModificationNudges = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.localModificationNudges = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.datatypeRefreshNudges = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.datatypeRefreshNudges = options.longs === String ? "0" : 0;
                object.serverDroppedHints = false;
                object.initialSyncInProgress = false;
                object.syncForResolveConflictInProgress = false;
            }
            if (message.notificationHint && message.notificationHint.length) {
                object.notificationHint = [];
                for (let j = 0; j < message.notificationHint.length; ++j)
                    object.notificationHint[j] = message.notificationHint[j];
            }
            if (message.clientDroppedHints != null && message.hasOwnProperty("clientDroppedHints"))
                object.clientDroppedHints = message.clientDroppedHints;
            if (message.invalidationsOutOfSync != null && message.hasOwnProperty("invalidationsOutOfSync"))
                object.invalidationsOutOfSync = message.invalidationsOutOfSync;
            if (message.localModificationNudges != null && message.hasOwnProperty("localModificationNudges"))
                if (typeof message.localModificationNudges === "number")
                    object.localModificationNudges = options.longs === String ? String(message.localModificationNudges) : message.localModificationNudges;
                else
                    object.localModificationNudges = options.longs === String ? $util.Long.prototype.toString.call(message.localModificationNudges) : options.longs === Number ? new $util.LongBits(message.localModificationNudges.low >>> 0, message.localModificationNudges.high >>> 0).toNumber() : message.localModificationNudges;
            if (message.datatypeRefreshNudges != null && message.hasOwnProperty("datatypeRefreshNudges"))
                if (typeof message.datatypeRefreshNudges === "number")
                    object.datatypeRefreshNudges = options.longs === String ? String(message.datatypeRefreshNudges) : message.datatypeRefreshNudges;
                else
                    object.datatypeRefreshNudges = options.longs === String ? $util.Long.prototype.toString.call(message.datatypeRefreshNudges) : options.longs === Number ? new $util.LongBits(message.datatypeRefreshNudges.low >>> 0, message.datatypeRefreshNudges.high >>> 0).toNumber() : message.datatypeRefreshNudges;
            if (message.serverDroppedHints != null && message.hasOwnProperty("serverDroppedHints"))
                object.serverDroppedHints = message.serverDroppedHints;
            if (message.initialSyncInProgress != null && message.hasOwnProperty("initialSyncInProgress"))
                object.initialSyncInProgress = message.initialSyncInProgress;
            if (message.syncForResolveConflictInProgress != null && message.hasOwnProperty("syncForResolveConflictInProgress"))
                object.syncForResolveConflictInProgress = message.syncForResolveConflictInProgress;
            return object;
        };

        /**
         * Converts this GetUpdateTriggers to JSON.
         * @function toJSON
         * @memberof sync_pb.GetUpdateTriggers
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUpdateTriggers.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUpdateTriggers;
    })();

    sync_pb.GarbageCollectionDirective = (function() {

        /**
         * Properties of a GarbageCollectionDirective.
         * @memberof sync_pb
         * @interface IGarbageCollectionDirective
         * @property {sync_pb.GarbageCollectionDirective.Type|null} [type] GarbageCollectionDirective type
         * @property {number|Long|null} [versionWatermark] GarbageCollectionDirective versionWatermark
         * @property {number|null} [ageWatermarkInDays] GarbageCollectionDirective ageWatermarkInDays
         */

        /**
         * Constructs a new GarbageCollectionDirective.
         * @memberof sync_pb
         * @classdesc Represents a GarbageCollectionDirective.
         * @implements IGarbageCollectionDirective
         * @constructor
         * @param {sync_pb.IGarbageCollectionDirective=} [properties] Properties to set
         */
        function GarbageCollectionDirective(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GarbageCollectionDirective type.
         * @member {sync_pb.GarbageCollectionDirective.Type} type
         * @memberof sync_pb.GarbageCollectionDirective
         * @instance
         */
        GarbageCollectionDirective.prototype.type = 0;

        /**
         * GarbageCollectionDirective versionWatermark.
         * @member {number|Long} versionWatermark
         * @memberof sync_pb.GarbageCollectionDirective
         * @instance
         */
        GarbageCollectionDirective.prototype.versionWatermark = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * GarbageCollectionDirective ageWatermarkInDays.
         * @member {number} ageWatermarkInDays
         * @memberof sync_pb.GarbageCollectionDirective
         * @instance
         */
        GarbageCollectionDirective.prototype.ageWatermarkInDays = 0;

        /**
         * Creates a new GarbageCollectionDirective instance using the specified properties.
         * @function create
         * @memberof sync_pb.GarbageCollectionDirective
         * @static
         * @param {sync_pb.IGarbageCollectionDirective=} [properties] Properties to set
         * @returns {sync_pb.GarbageCollectionDirective} GarbageCollectionDirective instance
         */
        GarbageCollectionDirective.create = function create(properties) {
            return new GarbageCollectionDirective(properties);
        };

        /**
         * Encodes the specified GarbageCollectionDirective message. Does not implicitly {@link sync_pb.GarbageCollectionDirective.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.GarbageCollectionDirective
         * @static
         * @param {sync_pb.IGarbageCollectionDirective} message GarbageCollectionDirective message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GarbageCollectionDirective.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
            if (message.versionWatermark != null && Object.hasOwnProperty.call(message, "versionWatermark"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.versionWatermark);
            if (message.ageWatermarkInDays != null && Object.hasOwnProperty.call(message, "ageWatermarkInDays"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.ageWatermarkInDays);
            return writer;
        };

        /**
         * Encodes the specified GarbageCollectionDirective message, length delimited. Does not implicitly {@link sync_pb.GarbageCollectionDirective.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.GarbageCollectionDirective
         * @static
         * @param {sync_pb.IGarbageCollectionDirective} message GarbageCollectionDirective message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GarbageCollectionDirective.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GarbageCollectionDirective message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.GarbageCollectionDirective
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.GarbageCollectionDirective} GarbageCollectionDirective
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GarbageCollectionDirective.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.GarbageCollectionDirective();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.versionWatermark = reader.int64();
                    break;
                case 3:
                    message.ageWatermarkInDays = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GarbageCollectionDirective message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.GarbageCollectionDirective
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.GarbageCollectionDirective} GarbageCollectionDirective
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GarbageCollectionDirective.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GarbageCollectionDirective message.
         * @function verify
         * @memberof sync_pb.GarbageCollectionDirective
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GarbageCollectionDirective.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.type != null && message.hasOwnProperty("type"))
                switch (message.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.versionWatermark != null && message.hasOwnProperty("versionWatermark"))
                if (!$util.isInteger(message.versionWatermark) && !(message.versionWatermark && $util.isInteger(message.versionWatermark.low) && $util.isInteger(message.versionWatermark.high)))
                    return "versionWatermark: integer|Long expected";
            if (message.ageWatermarkInDays != null && message.hasOwnProperty("ageWatermarkInDays"))
                if (!$util.isInteger(message.ageWatermarkInDays))
                    return "ageWatermarkInDays: integer expected";
            return null;
        };

        /**
         * Creates a GarbageCollectionDirective message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.GarbageCollectionDirective
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.GarbageCollectionDirective} GarbageCollectionDirective
         */
        GarbageCollectionDirective.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.GarbageCollectionDirective)
                return object;
            let message = new $root.sync_pb.GarbageCollectionDirective();
            switch (object.type) {
            case "UNKNOWN":
            case 0:
                message.type = 0;
                break;
            case "VERSION_WATERMARK":
            case 1:
                message.type = 1;
                break;
            case "AGE_WATERMARK":
            case 2:
                message.type = 2;
                break;
            case "DEPRECATED_MAX_ITEM_COUNT":
            case 3:
                message.type = 3;
                break;
            }
            if (object.versionWatermark != null)
                if ($util.Long)
                    (message.versionWatermark = $util.Long.fromValue(object.versionWatermark)).unsigned = false;
                else if (typeof object.versionWatermark === "string")
                    message.versionWatermark = parseInt(object.versionWatermark, 10);
                else if (typeof object.versionWatermark === "number")
                    message.versionWatermark = object.versionWatermark;
                else if (typeof object.versionWatermark === "object")
                    message.versionWatermark = new $util.LongBits(object.versionWatermark.low >>> 0, object.versionWatermark.high >>> 0).toNumber();
            if (object.ageWatermarkInDays != null)
                message.ageWatermarkInDays = object.ageWatermarkInDays | 0;
            return message;
        };

        /**
         * Creates a plain object from a GarbageCollectionDirective message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.GarbageCollectionDirective
         * @static
         * @param {sync_pb.GarbageCollectionDirective} message GarbageCollectionDirective
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GarbageCollectionDirective.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.type = options.enums === String ? "UNKNOWN" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.versionWatermark = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.versionWatermark = options.longs === String ? "0" : 0;
                object.ageWatermarkInDays = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.sync_pb.GarbageCollectionDirective.Type[message.type] : message.type;
            if (message.versionWatermark != null && message.hasOwnProperty("versionWatermark"))
                if (typeof message.versionWatermark === "number")
                    object.versionWatermark = options.longs === String ? String(message.versionWatermark) : message.versionWatermark;
                else
                    object.versionWatermark = options.longs === String ? $util.Long.prototype.toString.call(message.versionWatermark) : options.longs === Number ? new $util.LongBits(message.versionWatermark.low >>> 0, message.versionWatermark.high >>> 0).toNumber() : message.versionWatermark;
            if (message.ageWatermarkInDays != null && message.hasOwnProperty("ageWatermarkInDays"))
                object.ageWatermarkInDays = message.ageWatermarkInDays;
            return object;
        };

        /**
         * Converts this GarbageCollectionDirective to JSON.
         * @function toJSON
         * @memberof sync_pb.GarbageCollectionDirective
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GarbageCollectionDirective.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Type enum.
         * @name sync_pb.GarbageCollectionDirective.Type
         * @enum {number}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} VERSION_WATERMARK=1 VERSION_WATERMARK value
         * @property {number} AGE_WATERMARK=2 AGE_WATERMARK value
         * @property {number} DEPRECATED_MAX_ITEM_COUNT=3 DEPRECATED_MAX_ITEM_COUNT value
         */
        GarbageCollectionDirective.Type = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "VERSION_WATERMARK"] = 1;
            values[valuesById[2] = "AGE_WATERMARK"] = 2;
            values[valuesById[3] = "DEPRECATED_MAX_ITEM_COUNT"] = 3;
            return values;
        })();

        return GarbageCollectionDirective;
    })();

    sync_pb.DataTypeProgressMarker = (function() {

        /**
         * Properties of a DataTypeProgressMarker.
         * @memberof sync_pb
         * @interface IDataTypeProgressMarker
         * @property {number|null} [dataTypeId] DataTypeProgressMarker dataTypeId
         * @property {Uint8Array|null} [token] DataTypeProgressMarker token
         * @property {number|Long|null} [timestampTokenForMigration] DataTypeProgressMarker timestampTokenForMigration
         * @property {string|null} [notificationHint] DataTypeProgressMarker notificationHint
         * @property {sync_pb.IGetUpdateTriggers|null} [getUpdateTriggers] DataTypeProgressMarker getUpdateTriggers
         * @property {sync_pb.IGarbageCollectionDirective|null} [gcDirective] DataTypeProgressMarker gcDirective
         */

        /**
         * Constructs a new DataTypeProgressMarker.
         * @memberof sync_pb
         * @classdesc Represents a DataTypeProgressMarker.
         * @implements IDataTypeProgressMarker
         * @constructor
         * @param {sync_pb.IDataTypeProgressMarker=} [properties] Properties to set
         */
        function DataTypeProgressMarker(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DataTypeProgressMarker dataTypeId.
         * @member {number} dataTypeId
         * @memberof sync_pb.DataTypeProgressMarker
         * @instance
         */
        DataTypeProgressMarker.prototype.dataTypeId = 0;

        /**
         * DataTypeProgressMarker token.
         * @member {Uint8Array} token
         * @memberof sync_pb.DataTypeProgressMarker
         * @instance
         */
        DataTypeProgressMarker.prototype.token = $util.newBuffer([]);

        /**
         * DataTypeProgressMarker timestampTokenForMigration.
         * @member {number|Long} timestampTokenForMigration
         * @memberof sync_pb.DataTypeProgressMarker
         * @instance
         */
        DataTypeProgressMarker.prototype.timestampTokenForMigration = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * DataTypeProgressMarker notificationHint.
         * @member {string} notificationHint
         * @memberof sync_pb.DataTypeProgressMarker
         * @instance
         */
        DataTypeProgressMarker.prototype.notificationHint = "";

        /**
         * DataTypeProgressMarker getUpdateTriggers.
         * @member {sync_pb.IGetUpdateTriggers|null|undefined} getUpdateTriggers
         * @memberof sync_pb.DataTypeProgressMarker
         * @instance
         */
        DataTypeProgressMarker.prototype.getUpdateTriggers = null;

        /**
         * DataTypeProgressMarker gcDirective.
         * @member {sync_pb.IGarbageCollectionDirective|null|undefined} gcDirective
         * @memberof sync_pb.DataTypeProgressMarker
         * @instance
         */
        DataTypeProgressMarker.prototype.gcDirective = null;

        /**
         * Creates a new DataTypeProgressMarker instance using the specified properties.
         * @function create
         * @memberof sync_pb.DataTypeProgressMarker
         * @static
         * @param {sync_pb.IDataTypeProgressMarker=} [properties] Properties to set
         * @returns {sync_pb.DataTypeProgressMarker} DataTypeProgressMarker instance
         */
        DataTypeProgressMarker.create = function create(properties) {
            return new DataTypeProgressMarker(properties);
        };

        /**
         * Encodes the specified DataTypeProgressMarker message. Does not implicitly {@link sync_pb.DataTypeProgressMarker.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.DataTypeProgressMarker
         * @static
         * @param {sync_pb.IDataTypeProgressMarker} message DataTypeProgressMarker message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DataTypeProgressMarker.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.dataTypeId != null && Object.hasOwnProperty.call(message, "dataTypeId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dataTypeId);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.token);
            if (message.timestampTokenForMigration != null && Object.hasOwnProperty.call(message, "timestampTokenForMigration"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.timestampTokenForMigration);
            if (message.notificationHint != null && Object.hasOwnProperty.call(message, "notificationHint"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.notificationHint);
            if (message.getUpdateTriggers != null && Object.hasOwnProperty.call(message, "getUpdateTriggers"))
                $root.sync_pb.GetUpdateTriggers.encode(message.getUpdateTriggers, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.gcDirective != null && Object.hasOwnProperty.call(message, "gcDirective"))
                $root.sync_pb.GarbageCollectionDirective.encode(message.gcDirective, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified DataTypeProgressMarker message, length delimited. Does not implicitly {@link sync_pb.DataTypeProgressMarker.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.DataTypeProgressMarker
         * @static
         * @param {sync_pb.IDataTypeProgressMarker} message DataTypeProgressMarker message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DataTypeProgressMarker.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DataTypeProgressMarker message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.DataTypeProgressMarker
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.DataTypeProgressMarker} DataTypeProgressMarker
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DataTypeProgressMarker.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.DataTypeProgressMarker();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.dataTypeId = reader.int32();
                    break;
                case 2:
                    message.token = reader.bytes();
                    break;
                case 3:
                    message.timestampTokenForMigration = reader.int64();
                    break;
                case 4:
                    message.notificationHint = reader.string();
                    break;
                case 5:
                    message.getUpdateTriggers = $root.sync_pb.GetUpdateTriggers.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.gcDirective = $root.sync_pb.GarbageCollectionDirective.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DataTypeProgressMarker message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.DataTypeProgressMarker
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.DataTypeProgressMarker} DataTypeProgressMarker
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DataTypeProgressMarker.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DataTypeProgressMarker message.
         * @function verify
         * @memberof sync_pb.DataTypeProgressMarker
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DataTypeProgressMarker.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.dataTypeId != null && message.hasOwnProperty("dataTypeId"))
                if (!$util.isInteger(message.dataTypeId))
                    return "dataTypeId: integer expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!(message.token && typeof message.token.length === "number" || $util.isString(message.token)))
                    return "token: buffer expected";
            if (message.timestampTokenForMigration != null && message.hasOwnProperty("timestampTokenForMigration"))
                if (!$util.isInteger(message.timestampTokenForMigration) && !(message.timestampTokenForMigration && $util.isInteger(message.timestampTokenForMigration.low) && $util.isInteger(message.timestampTokenForMigration.high)))
                    return "timestampTokenForMigration: integer|Long expected";
            if (message.notificationHint != null && message.hasOwnProperty("notificationHint"))
                if (!$util.isString(message.notificationHint))
                    return "notificationHint: string expected";
            if (message.getUpdateTriggers != null && message.hasOwnProperty("getUpdateTriggers")) {
                let error = $root.sync_pb.GetUpdateTriggers.verify(message.getUpdateTriggers);
                if (error)
                    return "getUpdateTriggers." + error;
            }
            if (message.gcDirective != null && message.hasOwnProperty("gcDirective")) {
                let error = $root.sync_pb.GarbageCollectionDirective.verify(message.gcDirective);
                if (error)
                    return "gcDirective." + error;
            }
            return null;
        };

        /**
         * Creates a DataTypeProgressMarker message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.DataTypeProgressMarker
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.DataTypeProgressMarker} DataTypeProgressMarker
         */
        DataTypeProgressMarker.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.DataTypeProgressMarker)
                return object;
            let message = new $root.sync_pb.DataTypeProgressMarker();
            if (object.dataTypeId != null)
                message.dataTypeId = object.dataTypeId | 0;
            if (object.token != null)
                if (typeof object.token === "string")
                    $util.base64.decode(object.token, message.token = $util.newBuffer($util.base64.length(object.token)), 0);
                else if (object.token.length)
                    message.token = object.token;
            if (object.timestampTokenForMigration != null)
                if ($util.Long)
                    (message.timestampTokenForMigration = $util.Long.fromValue(object.timestampTokenForMigration)).unsigned = false;
                else if (typeof object.timestampTokenForMigration === "string")
                    message.timestampTokenForMigration = parseInt(object.timestampTokenForMigration, 10);
                else if (typeof object.timestampTokenForMigration === "number")
                    message.timestampTokenForMigration = object.timestampTokenForMigration;
                else if (typeof object.timestampTokenForMigration === "object")
                    message.timestampTokenForMigration = new $util.LongBits(object.timestampTokenForMigration.low >>> 0, object.timestampTokenForMigration.high >>> 0).toNumber();
            if (object.notificationHint != null)
                message.notificationHint = String(object.notificationHint);
            if (object.getUpdateTriggers != null) {
                if (typeof object.getUpdateTriggers !== "object")
                    throw TypeError(".sync_pb.DataTypeProgressMarker.getUpdateTriggers: object expected");
                message.getUpdateTriggers = $root.sync_pb.GetUpdateTriggers.fromObject(object.getUpdateTriggers);
            }
            if (object.gcDirective != null) {
                if (typeof object.gcDirective !== "object")
                    throw TypeError(".sync_pb.DataTypeProgressMarker.gcDirective: object expected");
                message.gcDirective = $root.sync_pb.GarbageCollectionDirective.fromObject(object.gcDirective);
            }
            return message;
        };

        /**
         * Creates a plain object from a DataTypeProgressMarker message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.DataTypeProgressMarker
         * @static
         * @param {sync_pb.DataTypeProgressMarker} message DataTypeProgressMarker
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DataTypeProgressMarker.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.dataTypeId = 0;
                if (options.bytes === String)
                    object.token = "";
                else {
                    object.token = [];
                    if (options.bytes !== Array)
                        object.token = $util.newBuffer(object.token);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.timestampTokenForMigration = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestampTokenForMigration = options.longs === String ? "0" : 0;
                object.notificationHint = "";
                object.getUpdateTriggers = null;
                object.gcDirective = null;
            }
            if (message.dataTypeId != null && message.hasOwnProperty("dataTypeId"))
                object.dataTypeId = message.dataTypeId;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = options.bytes === String ? $util.base64.encode(message.token, 0, message.token.length) : options.bytes === Array ? Array.prototype.slice.call(message.token) : message.token;
            if (message.timestampTokenForMigration != null && message.hasOwnProperty("timestampTokenForMigration"))
                if (typeof message.timestampTokenForMigration === "number")
                    object.timestampTokenForMigration = options.longs === String ? String(message.timestampTokenForMigration) : message.timestampTokenForMigration;
                else
                    object.timestampTokenForMigration = options.longs === String ? $util.Long.prototype.toString.call(message.timestampTokenForMigration) : options.longs === Number ? new $util.LongBits(message.timestampTokenForMigration.low >>> 0, message.timestampTokenForMigration.high >>> 0).toNumber() : message.timestampTokenForMigration;
            if (message.notificationHint != null && message.hasOwnProperty("notificationHint"))
                object.notificationHint = message.notificationHint;
            if (message.getUpdateTriggers != null && message.hasOwnProperty("getUpdateTriggers"))
                object.getUpdateTriggers = $root.sync_pb.GetUpdateTriggers.toObject(message.getUpdateTriggers, options);
            if (message.gcDirective != null && message.hasOwnProperty("gcDirective"))
                object.gcDirective = $root.sync_pb.GarbageCollectionDirective.toObject(message.gcDirective, options);
            return object;
        };

        /**
         * Converts this DataTypeProgressMarker to JSON.
         * @function toJSON
         * @memberof sync_pb.DataTypeProgressMarker
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DataTypeProgressMarker.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DataTypeProgressMarker;
    })();

    sync_pb.GetUpdatesMessage = (function() {

        /**
         * Properties of a GetUpdatesMessage.
         * @memberof sync_pb
         * @interface IGetUpdatesMessage
         * @property {sync_pb.IGetUpdatesCallerInfo|null} [callerInfo] GetUpdatesMessage callerInfo
         * @property {boolean|null} [fetchFolders] GetUpdatesMessage fetchFolders
         * @property {number|null} [batchSize] GetUpdatesMessage batchSize
         * @property {Array.<sync_pb.IDataTypeProgressMarker>|null} [fromProgressMarker] GetUpdatesMessage fromProgressMarker
         * @property {boolean|null} [streaming] GetUpdatesMessage streaming
         * @property {boolean|null} [needEncryptionKey] GetUpdatesMessage needEncryptionKey
         * @property {boolean|null} [createMobileBookmarksFolder] GetUpdatesMessage createMobileBookmarksFolder
         * @property {sync_pb.SyncEnums.GetUpdatesOrigin|null} [getUpdatesOrigin] GetUpdatesMessage getUpdatesOrigin
         * @property {boolean|null} [isRetry] GetUpdatesMessage isRetry
         * @property {Array.<sync_pb.IDataTypeContext>|null} [clientContexts] GetUpdatesMessage clientContexts
         */

        /**
         * Constructs a new GetUpdatesMessage.
         * @memberof sync_pb
         * @classdesc Represents a GetUpdatesMessage.
         * @implements IGetUpdatesMessage
         * @constructor
         * @param {sync_pb.IGetUpdatesMessage=} [properties] Properties to set
         */
        function GetUpdatesMessage(properties) {
            this.fromProgressMarker = [];
            this.clientContexts = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUpdatesMessage callerInfo.
         * @member {sync_pb.IGetUpdatesCallerInfo|null|undefined} callerInfo
         * @memberof sync_pb.GetUpdatesMessage
         * @instance
         */
        GetUpdatesMessage.prototype.callerInfo = null;

        /**
         * GetUpdatesMessage fetchFolders.
         * @member {boolean} fetchFolders
         * @memberof sync_pb.GetUpdatesMessage
         * @instance
         */
        GetUpdatesMessage.prototype.fetchFolders = true;

        /**
         * GetUpdatesMessage batchSize.
         * @member {number} batchSize
         * @memberof sync_pb.GetUpdatesMessage
         * @instance
         */
        GetUpdatesMessage.prototype.batchSize = 0;

        /**
         * GetUpdatesMessage fromProgressMarker.
         * @member {Array.<sync_pb.IDataTypeProgressMarker>} fromProgressMarker
         * @memberof sync_pb.GetUpdatesMessage
         * @instance
         */
        GetUpdatesMessage.prototype.fromProgressMarker = $util.emptyArray;

        /**
         * GetUpdatesMessage streaming.
         * @member {boolean} streaming
         * @memberof sync_pb.GetUpdatesMessage
         * @instance
         */
        GetUpdatesMessage.prototype.streaming = false;

        /**
         * GetUpdatesMessage needEncryptionKey.
         * @member {boolean} needEncryptionKey
         * @memberof sync_pb.GetUpdatesMessage
         * @instance
         */
        GetUpdatesMessage.prototype.needEncryptionKey = false;

        /**
         * GetUpdatesMessage createMobileBookmarksFolder.
         * @member {boolean} createMobileBookmarksFolder
         * @memberof sync_pb.GetUpdatesMessage
         * @instance
         */
        GetUpdatesMessage.prototype.createMobileBookmarksFolder = false;

        /**
         * GetUpdatesMessage getUpdatesOrigin.
         * @member {sync_pb.SyncEnums.GetUpdatesOrigin} getUpdatesOrigin
         * @memberof sync_pb.GetUpdatesMessage
         * @instance
         */
        GetUpdatesMessage.prototype.getUpdatesOrigin = 0;

        /**
         * GetUpdatesMessage isRetry.
         * @member {boolean} isRetry
         * @memberof sync_pb.GetUpdatesMessage
         * @instance
         */
        GetUpdatesMessage.prototype.isRetry = false;

        /**
         * GetUpdatesMessage clientContexts.
         * @member {Array.<sync_pb.IDataTypeContext>} clientContexts
         * @memberof sync_pb.GetUpdatesMessage
         * @instance
         */
        GetUpdatesMessage.prototype.clientContexts = $util.emptyArray;

        /**
         * Creates a new GetUpdatesMessage instance using the specified properties.
         * @function create
         * @memberof sync_pb.GetUpdatesMessage
         * @static
         * @param {sync_pb.IGetUpdatesMessage=} [properties] Properties to set
         * @returns {sync_pb.GetUpdatesMessage} GetUpdatesMessage instance
         */
        GetUpdatesMessage.create = function create(properties) {
            return new GetUpdatesMessage(properties);
        };

        /**
         * Encodes the specified GetUpdatesMessage message. Does not implicitly {@link sync_pb.GetUpdatesMessage.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.GetUpdatesMessage
         * @static
         * @param {sync_pb.IGetUpdatesMessage} message GetUpdatesMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUpdatesMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.callerInfo != null && Object.hasOwnProperty.call(message, "callerInfo"))
                $root.sync_pb.GetUpdatesCallerInfo.encode(message.callerInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.fetchFolders != null && Object.hasOwnProperty.call(message, "fetchFolders"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.fetchFolders);
            if (message.batchSize != null && Object.hasOwnProperty.call(message, "batchSize"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.batchSize);
            if (message.fromProgressMarker != null && message.fromProgressMarker.length)
                for (let i = 0; i < message.fromProgressMarker.length; ++i)
                    $root.sync_pb.DataTypeProgressMarker.encode(message.fromProgressMarker[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.streaming != null && Object.hasOwnProperty.call(message, "streaming"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.streaming);
            if (message.needEncryptionKey != null && Object.hasOwnProperty.call(message, "needEncryptionKey"))
                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.needEncryptionKey);
            if (message.getUpdatesOrigin != null && Object.hasOwnProperty.call(message, "getUpdatesOrigin"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.getUpdatesOrigin);
            if (message.isRetry != null && Object.hasOwnProperty.call(message, "isRetry"))
                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isRetry);
            if (message.clientContexts != null && message.clientContexts.length)
                for (let i = 0; i < message.clientContexts.length; ++i)
                    $root.sync_pb.DataTypeContext.encode(message.clientContexts[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
            if (message.createMobileBookmarksFolder != null && Object.hasOwnProperty.call(message, "createMobileBookmarksFolder"))
                writer.uint32(/* id 1000, wireType 0 =*/8000).bool(message.createMobileBookmarksFolder);
            return writer;
        };

        /**
         * Encodes the specified GetUpdatesMessage message, length delimited. Does not implicitly {@link sync_pb.GetUpdatesMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.GetUpdatesMessage
         * @static
         * @param {sync_pb.IGetUpdatesMessage} message GetUpdatesMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUpdatesMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetUpdatesMessage message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.GetUpdatesMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.GetUpdatesMessage} GetUpdatesMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUpdatesMessage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.GetUpdatesMessage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.callerInfo = $root.sync_pb.GetUpdatesCallerInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.fetchFolders = reader.bool();
                    break;
                case 5:
                    message.batchSize = reader.int32();
                    break;
                case 6:
                    if (!(message.fromProgressMarker && message.fromProgressMarker.length))
                        message.fromProgressMarker = [];
                    message.fromProgressMarker.push($root.sync_pb.DataTypeProgressMarker.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.streaming = reader.bool();
                    break;
                case 8:
                    message.needEncryptionKey = reader.bool();
                    break;
                case 1000:
                    message.createMobileBookmarksFolder = reader.bool();
                    break;
                case 9:
                    message.getUpdatesOrigin = reader.int32();
                    break;
                case 10:
                    message.isRetry = reader.bool();
                    break;
                case 11:
                    if (!(message.clientContexts && message.clientContexts.length))
                        message.clientContexts = [];
                    message.clientContexts.push($root.sync_pb.DataTypeContext.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetUpdatesMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.GetUpdatesMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.GetUpdatesMessage} GetUpdatesMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUpdatesMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetUpdatesMessage message.
         * @function verify
         * @memberof sync_pb.GetUpdatesMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetUpdatesMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.callerInfo != null && message.hasOwnProperty("callerInfo")) {
                let error = $root.sync_pb.GetUpdatesCallerInfo.verify(message.callerInfo);
                if (error)
                    return "callerInfo." + error;
            }
            if (message.fetchFolders != null && message.hasOwnProperty("fetchFolders"))
                if (typeof message.fetchFolders !== "boolean")
                    return "fetchFolders: boolean expected";
            if (message.batchSize != null && message.hasOwnProperty("batchSize"))
                if (!$util.isInteger(message.batchSize))
                    return "batchSize: integer expected";
            if (message.fromProgressMarker != null && message.hasOwnProperty("fromProgressMarker")) {
                if (!Array.isArray(message.fromProgressMarker))
                    return "fromProgressMarker: array expected";
                for (let i = 0; i < message.fromProgressMarker.length; ++i) {
                    let error = $root.sync_pb.DataTypeProgressMarker.verify(message.fromProgressMarker[i]);
                    if (error)
                        return "fromProgressMarker." + error;
                }
            }
            if (message.streaming != null && message.hasOwnProperty("streaming"))
                if (typeof message.streaming !== "boolean")
                    return "streaming: boolean expected";
            if (message.needEncryptionKey != null && message.hasOwnProperty("needEncryptionKey"))
                if (typeof message.needEncryptionKey !== "boolean")
                    return "needEncryptionKey: boolean expected";
            if (message.createMobileBookmarksFolder != null && message.hasOwnProperty("createMobileBookmarksFolder"))
                if (typeof message.createMobileBookmarksFolder !== "boolean")
                    return "createMobileBookmarksFolder: boolean expected";
            if (message.getUpdatesOrigin != null && message.hasOwnProperty("getUpdatesOrigin"))
                switch (message.getUpdatesOrigin) {
                default:
                    return "getUpdatesOrigin: enum value expected";
                case 0:
                case 4:
                case 7:
                case 8:
                case 9:
                case 10:
                case 12:
                case 13:
                case 14:
                    break;
                }
            if (message.isRetry != null && message.hasOwnProperty("isRetry"))
                if (typeof message.isRetry !== "boolean")
                    return "isRetry: boolean expected";
            if (message.clientContexts != null && message.hasOwnProperty("clientContexts")) {
                if (!Array.isArray(message.clientContexts))
                    return "clientContexts: array expected";
                for (let i = 0; i < message.clientContexts.length; ++i) {
                    let error = $root.sync_pb.DataTypeContext.verify(message.clientContexts[i]);
                    if (error)
                        return "clientContexts." + error;
                }
            }
            return null;
        };

        /**
         * Creates a GetUpdatesMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.GetUpdatesMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.GetUpdatesMessage} GetUpdatesMessage
         */
        GetUpdatesMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.GetUpdatesMessage)
                return object;
            let message = new $root.sync_pb.GetUpdatesMessage();
            if (object.callerInfo != null) {
                if (typeof object.callerInfo !== "object")
                    throw TypeError(".sync_pb.GetUpdatesMessage.callerInfo: object expected");
                message.callerInfo = $root.sync_pb.GetUpdatesCallerInfo.fromObject(object.callerInfo);
            }
            if (object.fetchFolders != null)
                message.fetchFolders = Boolean(object.fetchFolders);
            if (object.batchSize != null)
                message.batchSize = object.batchSize | 0;
            if (object.fromProgressMarker) {
                if (!Array.isArray(object.fromProgressMarker))
                    throw TypeError(".sync_pb.GetUpdatesMessage.fromProgressMarker: array expected");
                message.fromProgressMarker = [];
                for (let i = 0; i < object.fromProgressMarker.length; ++i) {
                    if (typeof object.fromProgressMarker[i] !== "object")
                        throw TypeError(".sync_pb.GetUpdatesMessage.fromProgressMarker: object expected");
                    message.fromProgressMarker[i] = $root.sync_pb.DataTypeProgressMarker.fromObject(object.fromProgressMarker[i]);
                }
            }
            if (object.streaming != null)
                message.streaming = Boolean(object.streaming);
            if (object.needEncryptionKey != null)
                message.needEncryptionKey = Boolean(object.needEncryptionKey);
            if (object.createMobileBookmarksFolder != null)
                message.createMobileBookmarksFolder = Boolean(object.createMobileBookmarksFolder);
            switch (object.getUpdatesOrigin) {
            case "UNKNOWN_ORIGIN":
            case 0:
                message.getUpdatesOrigin = 0;
                break;
            case "PERIODIC":
            case 4:
                message.getUpdatesOrigin = 4;
                break;
            case "NEWLY_SUPPORTED_DATATYPE":
            case 7:
                message.getUpdatesOrigin = 7;
                break;
            case "MIGRATION":
            case 8:
                message.getUpdatesOrigin = 8;
                break;
            case "NEW_CLIENT":
            case 9:
                message.getUpdatesOrigin = 9;
                break;
            case "RECONFIGURATION":
            case 10:
                message.getUpdatesOrigin = 10;
                break;
            case "GU_TRIGGER":
            case 12:
                message.getUpdatesOrigin = 12;
                break;
            case "RETRY":
            case 13:
                message.getUpdatesOrigin = 13;
                break;
            case "PROGRAMMATIC":
            case 14:
                message.getUpdatesOrigin = 14;
                break;
            }
            if (object.isRetry != null)
                message.isRetry = Boolean(object.isRetry);
            if (object.clientContexts) {
                if (!Array.isArray(object.clientContexts))
                    throw TypeError(".sync_pb.GetUpdatesMessage.clientContexts: array expected");
                message.clientContexts = [];
                for (let i = 0; i < object.clientContexts.length; ++i) {
                    if (typeof object.clientContexts[i] !== "object")
                        throw TypeError(".sync_pb.GetUpdatesMessage.clientContexts: object expected");
                    message.clientContexts[i] = $root.sync_pb.DataTypeContext.fromObject(object.clientContexts[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetUpdatesMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.GetUpdatesMessage
         * @static
         * @param {sync_pb.GetUpdatesMessage} message GetUpdatesMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUpdatesMessage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.fromProgressMarker = [];
                object.clientContexts = [];
            }
            if (options.defaults) {
                object.callerInfo = null;
                object.fetchFolders = true;
                object.batchSize = 0;
                object.streaming = false;
                object.needEncryptionKey = false;
                object.getUpdatesOrigin = options.enums === String ? "UNKNOWN_ORIGIN" : 0;
                object.isRetry = false;
                object.createMobileBookmarksFolder = false;
            }
            if (message.callerInfo != null && message.hasOwnProperty("callerInfo"))
                object.callerInfo = $root.sync_pb.GetUpdatesCallerInfo.toObject(message.callerInfo, options);
            if (message.fetchFolders != null && message.hasOwnProperty("fetchFolders"))
                object.fetchFolders = message.fetchFolders;
            if (message.batchSize != null && message.hasOwnProperty("batchSize"))
                object.batchSize = message.batchSize;
            if (message.fromProgressMarker && message.fromProgressMarker.length) {
                object.fromProgressMarker = [];
                for (let j = 0; j < message.fromProgressMarker.length; ++j)
                    object.fromProgressMarker[j] = $root.sync_pb.DataTypeProgressMarker.toObject(message.fromProgressMarker[j], options);
            }
            if (message.streaming != null && message.hasOwnProperty("streaming"))
                object.streaming = message.streaming;
            if (message.needEncryptionKey != null && message.hasOwnProperty("needEncryptionKey"))
                object.needEncryptionKey = message.needEncryptionKey;
            if (message.getUpdatesOrigin != null && message.hasOwnProperty("getUpdatesOrigin"))
                object.getUpdatesOrigin = options.enums === String ? $root.sync_pb.SyncEnums.GetUpdatesOrigin[message.getUpdatesOrigin] : message.getUpdatesOrigin;
            if (message.isRetry != null && message.hasOwnProperty("isRetry"))
                object.isRetry = message.isRetry;
            if (message.clientContexts && message.clientContexts.length) {
                object.clientContexts = [];
                for (let j = 0; j < message.clientContexts.length; ++j)
                    object.clientContexts[j] = $root.sync_pb.DataTypeContext.toObject(message.clientContexts[j], options);
            }
            if (message.createMobileBookmarksFolder != null && message.hasOwnProperty("createMobileBookmarksFolder"))
                object.createMobileBookmarksFolder = message.createMobileBookmarksFolder;
            return object;
        };

        /**
         * Converts this GetUpdatesMessage to JSON.
         * @function toJSON
         * @memberof sync_pb.GetUpdatesMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUpdatesMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUpdatesMessage;
    })();

    sync_pb.ClearServerDataMessage = (function() {

        /**
         * Properties of a ClearServerDataMessage.
         * @memberof sync_pb
         * @interface IClearServerDataMessage
         */

        /**
         * Constructs a new ClearServerDataMessage.
         * @memberof sync_pb
         * @classdesc Represents a ClearServerDataMessage.
         * @implements IClearServerDataMessage
         * @constructor
         * @param {sync_pb.IClearServerDataMessage=} [properties] Properties to set
         */
        function ClearServerDataMessage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ClearServerDataMessage instance using the specified properties.
         * @function create
         * @memberof sync_pb.ClearServerDataMessage
         * @static
         * @param {sync_pb.IClearServerDataMessage=} [properties] Properties to set
         * @returns {sync_pb.ClearServerDataMessage} ClearServerDataMessage instance
         */
        ClearServerDataMessage.create = function create(properties) {
            return new ClearServerDataMessage(properties);
        };

        /**
         * Encodes the specified ClearServerDataMessage message. Does not implicitly {@link sync_pb.ClearServerDataMessage.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ClearServerDataMessage
         * @static
         * @param {sync_pb.IClearServerDataMessage} message ClearServerDataMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClearServerDataMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ClearServerDataMessage message, length delimited. Does not implicitly {@link sync_pb.ClearServerDataMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ClearServerDataMessage
         * @static
         * @param {sync_pb.IClearServerDataMessage} message ClearServerDataMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClearServerDataMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClearServerDataMessage message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ClearServerDataMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ClearServerDataMessage} ClearServerDataMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClearServerDataMessage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ClearServerDataMessage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ClearServerDataMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ClearServerDataMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ClearServerDataMessage} ClearServerDataMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClearServerDataMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClearServerDataMessage message.
         * @function verify
         * @memberof sync_pb.ClearServerDataMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClearServerDataMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a ClearServerDataMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ClearServerDataMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ClearServerDataMessage} ClearServerDataMessage
         */
        ClearServerDataMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ClearServerDataMessage)
                return object;
            return new $root.sync_pb.ClearServerDataMessage();
        };

        /**
         * Creates a plain object from a ClearServerDataMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ClearServerDataMessage
         * @static
         * @param {sync_pb.ClearServerDataMessage} message ClearServerDataMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClearServerDataMessage.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ClearServerDataMessage to JSON.
         * @function toJSON
         * @memberof sync_pb.ClearServerDataMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClearServerDataMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClearServerDataMessage;
    })();

    sync_pb.ClearServerDataResponse = (function() {

        /**
         * Properties of a ClearServerDataResponse.
         * @memberof sync_pb
         * @interface IClearServerDataResponse
         */

        /**
         * Constructs a new ClearServerDataResponse.
         * @memberof sync_pb
         * @classdesc Represents a ClearServerDataResponse.
         * @implements IClearServerDataResponse
         * @constructor
         * @param {sync_pb.IClearServerDataResponse=} [properties] Properties to set
         */
        function ClearServerDataResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ClearServerDataResponse instance using the specified properties.
         * @function create
         * @memberof sync_pb.ClearServerDataResponse
         * @static
         * @param {sync_pb.IClearServerDataResponse=} [properties] Properties to set
         * @returns {sync_pb.ClearServerDataResponse} ClearServerDataResponse instance
         */
        ClearServerDataResponse.create = function create(properties) {
            return new ClearServerDataResponse(properties);
        };

        /**
         * Encodes the specified ClearServerDataResponse message. Does not implicitly {@link sync_pb.ClearServerDataResponse.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ClearServerDataResponse
         * @static
         * @param {sync_pb.IClearServerDataResponse} message ClearServerDataResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClearServerDataResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ClearServerDataResponse message, length delimited. Does not implicitly {@link sync_pb.ClearServerDataResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ClearServerDataResponse
         * @static
         * @param {sync_pb.IClearServerDataResponse} message ClearServerDataResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClearServerDataResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClearServerDataResponse message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ClearServerDataResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ClearServerDataResponse} ClearServerDataResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClearServerDataResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ClearServerDataResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ClearServerDataResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ClearServerDataResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ClearServerDataResponse} ClearServerDataResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClearServerDataResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClearServerDataResponse message.
         * @function verify
         * @memberof sync_pb.ClearServerDataResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClearServerDataResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a ClearServerDataResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ClearServerDataResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ClearServerDataResponse} ClearServerDataResponse
         */
        ClearServerDataResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ClearServerDataResponse)
                return object;
            return new $root.sync_pb.ClearServerDataResponse();
        };

        /**
         * Creates a plain object from a ClearServerDataResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ClearServerDataResponse
         * @static
         * @param {sync_pb.ClearServerDataResponse} message ClearServerDataResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClearServerDataResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ClearServerDataResponse to JSON.
         * @function toJSON
         * @memberof sync_pb.ClearServerDataResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClearServerDataResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClearServerDataResponse;
    })();

    sync_pb.ChipBag = (function() {

        /**
         * Properties of a ChipBag.
         * @memberof sync_pb
         * @interface IChipBag
         * @property {Uint8Array|null} [serverChips] ChipBag serverChips
         */

        /**
         * Constructs a new ChipBag.
         * @memberof sync_pb
         * @classdesc Represents a ChipBag.
         * @implements IChipBag
         * @constructor
         * @param {sync_pb.IChipBag=} [properties] Properties to set
         */
        function ChipBag(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChipBag serverChips.
         * @member {Uint8Array} serverChips
         * @memberof sync_pb.ChipBag
         * @instance
         */
        ChipBag.prototype.serverChips = $util.newBuffer([]);

        /**
         * Creates a new ChipBag instance using the specified properties.
         * @function create
         * @memberof sync_pb.ChipBag
         * @static
         * @param {sync_pb.IChipBag=} [properties] Properties to set
         * @returns {sync_pb.ChipBag} ChipBag instance
         */
        ChipBag.create = function create(properties) {
            return new ChipBag(properties);
        };

        /**
         * Encodes the specified ChipBag message. Does not implicitly {@link sync_pb.ChipBag.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ChipBag
         * @static
         * @param {sync_pb.IChipBag} message ChipBag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChipBag.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.serverChips != null && Object.hasOwnProperty.call(message, "serverChips"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.serverChips);
            return writer;
        };

        /**
         * Encodes the specified ChipBag message, length delimited. Does not implicitly {@link sync_pb.ChipBag.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ChipBag
         * @static
         * @param {sync_pb.IChipBag} message ChipBag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChipBag.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChipBag message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ChipBag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ChipBag} ChipBag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChipBag.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ChipBag();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.serverChips = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChipBag message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ChipBag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ChipBag} ChipBag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChipBag.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChipBag message.
         * @function verify
         * @memberof sync_pb.ChipBag
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChipBag.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.serverChips != null && message.hasOwnProperty("serverChips"))
                if (!(message.serverChips && typeof message.serverChips.length === "number" || $util.isString(message.serverChips)))
                    return "serverChips: buffer expected";
            return null;
        };

        /**
         * Creates a ChipBag message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ChipBag
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ChipBag} ChipBag
         */
        ChipBag.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ChipBag)
                return object;
            let message = new $root.sync_pb.ChipBag();
            if (object.serverChips != null)
                if (typeof object.serverChips === "string")
                    $util.base64.decode(object.serverChips, message.serverChips = $util.newBuffer($util.base64.length(object.serverChips)), 0);
                else if (object.serverChips.length)
                    message.serverChips = object.serverChips;
            return message;
        };

        /**
         * Creates a plain object from a ChipBag message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ChipBag
         * @static
         * @param {sync_pb.ChipBag} message ChipBag
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChipBag.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.serverChips = "";
                else {
                    object.serverChips = [];
                    if (options.bytes !== Array)
                        object.serverChips = $util.newBuffer(object.serverChips);
                }
            if (message.serverChips != null && message.hasOwnProperty("serverChips"))
                object.serverChips = options.bytes === String ? $util.base64.encode(message.serverChips, 0, message.serverChips.length) : options.bytes === Array ? Array.prototype.slice.call(message.serverChips) : message.serverChips;
            return object;
        };

        /**
         * Converts this ChipBag to JSON.
         * @function toJSON
         * @memberof sync_pb.ChipBag
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChipBag.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ChipBag;
    })();

    sync_pb.ClientStatus = (function() {

        /**
         * Properties of a ClientStatus.
         * @memberof sync_pb
         * @interface IClientStatus
         * @property {boolean|null} [hierarchyConflictDetected] ClientStatus hierarchyConflictDetected
         * @property {boolean|null} [isSyncFeatureEnabled] ClientStatus isSyncFeatureEnabled
         */

        /**
         * Constructs a new ClientStatus.
         * @memberof sync_pb
         * @classdesc Represents a ClientStatus.
         * @implements IClientStatus
         * @constructor
         * @param {sync_pb.IClientStatus=} [properties] Properties to set
         */
        function ClientStatus(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClientStatus hierarchyConflictDetected.
         * @member {boolean} hierarchyConflictDetected
         * @memberof sync_pb.ClientStatus
         * @instance
         */
        ClientStatus.prototype.hierarchyConflictDetected = false;

        /**
         * ClientStatus isSyncFeatureEnabled.
         * @member {boolean} isSyncFeatureEnabled
         * @memberof sync_pb.ClientStatus
         * @instance
         */
        ClientStatus.prototype.isSyncFeatureEnabled = false;

        /**
         * Creates a new ClientStatus instance using the specified properties.
         * @function create
         * @memberof sync_pb.ClientStatus
         * @static
         * @param {sync_pb.IClientStatus=} [properties] Properties to set
         * @returns {sync_pb.ClientStatus} ClientStatus instance
         */
        ClientStatus.create = function create(properties) {
            return new ClientStatus(properties);
        };

        /**
         * Encodes the specified ClientStatus message. Does not implicitly {@link sync_pb.ClientStatus.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ClientStatus
         * @static
         * @param {sync_pb.IClientStatus} message ClientStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientStatus.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.hierarchyConflictDetected != null && Object.hasOwnProperty.call(message, "hierarchyConflictDetected"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.hierarchyConflictDetected);
            if (message.isSyncFeatureEnabled != null && Object.hasOwnProperty.call(message, "isSyncFeatureEnabled"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isSyncFeatureEnabled);
            return writer;
        };

        /**
         * Encodes the specified ClientStatus message, length delimited. Does not implicitly {@link sync_pb.ClientStatus.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ClientStatus
         * @static
         * @param {sync_pb.IClientStatus} message ClientStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientStatus.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClientStatus message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ClientStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ClientStatus} ClientStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientStatus.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ClientStatus();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.hierarchyConflictDetected = reader.bool();
                    break;
                case 2:
                    message.isSyncFeatureEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ClientStatus message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ClientStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ClientStatus} ClientStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientStatus.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClientStatus message.
         * @function verify
         * @memberof sync_pb.ClientStatus
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClientStatus.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.hierarchyConflictDetected != null && message.hasOwnProperty("hierarchyConflictDetected"))
                if (typeof message.hierarchyConflictDetected !== "boolean")
                    return "hierarchyConflictDetected: boolean expected";
            if (message.isSyncFeatureEnabled != null && message.hasOwnProperty("isSyncFeatureEnabled"))
                if (typeof message.isSyncFeatureEnabled !== "boolean")
                    return "isSyncFeatureEnabled: boolean expected";
            return null;
        };

        /**
         * Creates a ClientStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ClientStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ClientStatus} ClientStatus
         */
        ClientStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ClientStatus)
                return object;
            let message = new $root.sync_pb.ClientStatus();
            if (object.hierarchyConflictDetected != null)
                message.hierarchyConflictDetected = Boolean(object.hierarchyConflictDetected);
            if (object.isSyncFeatureEnabled != null)
                message.isSyncFeatureEnabled = Boolean(object.isSyncFeatureEnabled);
            return message;
        };

        /**
         * Creates a plain object from a ClientStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ClientStatus
         * @static
         * @param {sync_pb.ClientStatus} message ClientStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClientStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.hierarchyConflictDetected = false;
                object.isSyncFeatureEnabled = false;
            }
            if (message.hierarchyConflictDetected != null && message.hasOwnProperty("hierarchyConflictDetected"))
                object.hierarchyConflictDetected = message.hierarchyConflictDetected;
            if (message.isSyncFeatureEnabled != null && message.hasOwnProperty("isSyncFeatureEnabled"))
                object.isSyncFeatureEnabled = message.isSyncFeatureEnabled;
            return object;
        };

        /**
         * Converts this ClientStatus to JSON.
         * @function toJSON
         * @memberof sync_pb.ClientStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClientStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClientStatus;
    })();

    sync_pb.DataTypeContext = (function() {

        /**
         * Properties of a DataTypeContext.
         * @memberof sync_pb
         * @interface IDataTypeContext
         * @property {number|null} [dataTypeId] DataTypeContext dataTypeId
         * @property {Uint8Array|null} [context] DataTypeContext context
         * @property {number|Long|null} [version] DataTypeContext version
         */

        /**
         * Constructs a new DataTypeContext.
         * @memberof sync_pb
         * @classdesc Represents a DataTypeContext.
         * @implements IDataTypeContext
         * @constructor
         * @param {sync_pb.IDataTypeContext=} [properties] Properties to set
         */
        function DataTypeContext(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DataTypeContext dataTypeId.
         * @member {number} dataTypeId
         * @memberof sync_pb.DataTypeContext
         * @instance
         */
        DataTypeContext.prototype.dataTypeId = 0;

        /**
         * DataTypeContext context.
         * @member {Uint8Array} context
         * @memberof sync_pb.DataTypeContext
         * @instance
         */
        DataTypeContext.prototype.context = $util.newBuffer([]);

        /**
         * DataTypeContext version.
         * @member {number|Long} version
         * @memberof sync_pb.DataTypeContext
         * @instance
         */
        DataTypeContext.prototype.version = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new DataTypeContext instance using the specified properties.
         * @function create
         * @memberof sync_pb.DataTypeContext
         * @static
         * @param {sync_pb.IDataTypeContext=} [properties] Properties to set
         * @returns {sync_pb.DataTypeContext} DataTypeContext instance
         */
        DataTypeContext.create = function create(properties) {
            return new DataTypeContext(properties);
        };

        /**
         * Encodes the specified DataTypeContext message. Does not implicitly {@link sync_pb.DataTypeContext.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.DataTypeContext
         * @static
         * @param {sync_pb.IDataTypeContext} message DataTypeContext message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DataTypeContext.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.dataTypeId != null && Object.hasOwnProperty.call(message, "dataTypeId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dataTypeId);
            if (message.context != null && Object.hasOwnProperty.call(message, "context"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.context);
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.version);
            return writer;
        };

        /**
         * Encodes the specified DataTypeContext message, length delimited. Does not implicitly {@link sync_pb.DataTypeContext.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.DataTypeContext
         * @static
         * @param {sync_pb.IDataTypeContext} message DataTypeContext message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DataTypeContext.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DataTypeContext message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.DataTypeContext
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.DataTypeContext} DataTypeContext
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DataTypeContext.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.DataTypeContext();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.dataTypeId = reader.int32();
                    break;
                case 2:
                    message.context = reader.bytes();
                    break;
                case 3:
                    message.version = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DataTypeContext message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.DataTypeContext
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.DataTypeContext} DataTypeContext
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DataTypeContext.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DataTypeContext message.
         * @function verify
         * @memberof sync_pb.DataTypeContext
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DataTypeContext.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.dataTypeId != null && message.hasOwnProperty("dataTypeId"))
                if (!$util.isInteger(message.dataTypeId))
                    return "dataTypeId: integer expected";
            if (message.context != null && message.hasOwnProperty("context"))
                if (!(message.context && typeof message.context.length === "number" || $util.isString(message.context)))
                    return "context: buffer expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isInteger(message.version) && !(message.version && $util.isInteger(message.version.low) && $util.isInteger(message.version.high)))
                    return "version: integer|Long expected";
            return null;
        };

        /**
         * Creates a DataTypeContext message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.DataTypeContext
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.DataTypeContext} DataTypeContext
         */
        DataTypeContext.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.DataTypeContext)
                return object;
            let message = new $root.sync_pb.DataTypeContext();
            if (object.dataTypeId != null)
                message.dataTypeId = object.dataTypeId | 0;
            if (object.context != null)
                if (typeof object.context === "string")
                    $util.base64.decode(object.context, message.context = $util.newBuffer($util.base64.length(object.context)), 0);
                else if (object.context.length)
                    message.context = object.context;
            if (object.version != null)
                if ($util.Long)
                    (message.version = $util.Long.fromValue(object.version)).unsigned = false;
                else if (typeof object.version === "string")
                    message.version = parseInt(object.version, 10);
                else if (typeof object.version === "number")
                    message.version = object.version;
                else if (typeof object.version === "object")
                    message.version = new $util.LongBits(object.version.low >>> 0, object.version.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a DataTypeContext message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.DataTypeContext
         * @static
         * @param {sync_pb.DataTypeContext} message DataTypeContext
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DataTypeContext.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.dataTypeId = 0;
                if (options.bytes === String)
                    object.context = "";
                else {
                    object.context = [];
                    if (options.bytes !== Array)
                        object.context = $util.newBuffer(object.context);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.version = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.version = options.longs === String ? "0" : 0;
            }
            if (message.dataTypeId != null && message.hasOwnProperty("dataTypeId"))
                object.dataTypeId = message.dataTypeId;
            if (message.context != null && message.hasOwnProperty("context"))
                object.context = options.bytes === String ? $util.base64.encode(message.context, 0, message.context.length) : options.bytes === Array ? Array.prototype.slice.call(message.context) : message.context;
            if (message.version != null && message.hasOwnProperty("version"))
                if (typeof message.version === "number")
                    object.version = options.longs === String ? String(message.version) : message.version;
                else
                    object.version = options.longs === String ? $util.Long.prototype.toString.call(message.version) : options.longs === Number ? new $util.LongBits(message.version.low >>> 0, message.version.high >>> 0).toNumber() : message.version;
            return object;
        };

        /**
         * Converts this DataTypeContext to JSON.
         * @function toJSON
         * @memberof sync_pb.DataTypeContext
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DataTypeContext.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DataTypeContext;
    })();

    sync_pb.ClientToServerMessage = (function() {

        /**
         * Properties of a ClientToServerMessage.
         * @memberof sync_pb
         * @interface IClientToServerMessage
         * @property {string} share ClientToServerMessage share
         * @property {number|null} [protocolVersion] ClientToServerMessage protocolVersion
         * @property {sync_pb.ClientToServerMessage.Contents} messageContents ClientToServerMessage messageContents
         * @property {sync_pb.ICommitMessage|null} [commit] ClientToServerMessage commit
         * @property {sync_pb.IGetUpdatesMessage|null} [getUpdates] ClientToServerMessage getUpdates
         * @property {string|null} [storeBirthday] ClientToServerMessage storeBirthday
         * @property {boolean|null} [syncProblemDetected] ClientToServerMessage syncProblemDetected
         * @property {sync_pb.IDebugInfo|null} [debugInfo] ClientToServerMessage debugInfo
         * @property {sync_pb.IChipBag|null} [bagOfChips] ClientToServerMessage bagOfChips
         * @property {string|null} [apiKey] ClientToServerMessage apiKey
         * @property {sync_pb.IClientStatus|null} [clientStatus] ClientToServerMessage clientStatus
         * @property {string|null} [invalidatorClientId] ClientToServerMessage invalidatorClientId
         * @property {sync_pb.IClearServerDataMessage|null} [clearServerData] ClientToServerMessage clearServerData
         */

        /**
         * Constructs a new ClientToServerMessage.
         * @memberof sync_pb
         * @classdesc Represents a ClientToServerMessage.
         * @implements IClientToServerMessage
         * @constructor
         * @param {sync_pb.IClientToServerMessage=} [properties] Properties to set
         */
        function ClientToServerMessage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClientToServerMessage share.
         * @member {string} share
         * @memberof sync_pb.ClientToServerMessage
         * @instance
         */
        ClientToServerMessage.prototype.share = "";

        /**
         * ClientToServerMessage protocolVersion.
         * @member {number} protocolVersion
         * @memberof sync_pb.ClientToServerMessage
         * @instance
         */
        ClientToServerMessage.prototype.protocolVersion = 52;

        /**
         * ClientToServerMessage messageContents.
         * @member {sync_pb.ClientToServerMessage.Contents} messageContents
         * @memberof sync_pb.ClientToServerMessage
         * @instance
         */
        ClientToServerMessage.prototype.messageContents = 1;

        /**
         * ClientToServerMessage commit.
         * @member {sync_pb.ICommitMessage|null|undefined} commit
         * @memberof sync_pb.ClientToServerMessage
         * @instance
         */
        ClientToServerMessage.prototype.commit = null;

        /**
         * ClientToServerMessage getUpdates.
         * @member {sync_pb.IGetUpdatesMessage|null|undefined} getUpdates
         * @memberof sync_pb.ClientToServerMessage
         * @instance
         */
        ClientToServerMessage.prototype.getUpdates = null;

        /**
         * ClientToServerMessage storeBirthday.
         * @member {string} storeBirthday
         * @memberof sync_pb.ClientToServerMessage
         * @instance
         */
        ClientToServerMessage.prototype.storeBirthday = "";

        /**
         * ClientToServerMessage syncProblemDetected.
         * @member {boolean} syncProblemDetected
         * @memberof sync_pb.ClientToServerMessage
         * @instance
         */
        ClientToServerMessage.prototype.syncProblemDetected = false;

        /**
         * ClientToServerMessage debugInfo.
         * @member {sync_pb.IDebugInfo|null|undefined} debugInfo
         * @memberof sync_pb.ClientToServerMessage
         * @instance
         */
        ClientToServerMessage.prototype.debugInfo = null;

        /**
         * ClientToServerMessage bagOfChips.
         * @member {sync_pb.IChipBag|null|undefined} bagOfChips
         * @memberof sync_pb.ClientToServerMessage
         * @instance
         */
        ClientToServerMessage.prototype.bagOfChips = null;

        /**
         * ClientToServerMessage apiKey.
         * @member {string} apiKey
         * @memberof sync_pb.ClientToServerMessage
         * @instance
         */
        ClientToServerMessage.prototype.apiKey = "";

        /**
         * ClientToServerMessage clientStatus.
         * @member {sync_pb.IClientStatus|null|undefined} clientStatus
         * @memberof sync_pb.ClientToServerMessage
         * @instance
         */
        ClientToServerMessage.prototype.clientStatus = null;

        /**
         * ClientToServerMessage invalidatorClientId.
         * @member {string} invalidatorClientId
         * @memberof sync_pb.ClientToServerMessage
         * @instance
         */
        ClientToServerMessage.prototype.invalidatorClientId = "";

        /**
         * ClientToServerMessage clearServerData.
         * @member {sync_pb.IClearServerDataMessage|null|undefined} clearServerData
         * @memberof sync_pb.ClientToServerMessage
         * @instance
         */
        ClientToServerMessage.prototype.clearServerData = null;

        /**
         * Creates a new ClientToServerMessage instance using the specified properties.
         * @function create
         * @memberof sync_pb.ClientToServerMessage
         * @static
         * @param {sync_pb.IClientToServerMessage=} [properties] Properties to set
         * @returns {sync_pb.ClientToServerMessage} ClientToServerMessage instance
         */
        ClientToServerMessage.create = function create(properties) {
            return new ClientToServerMessage(properties);
        };

        /**
         * Encodes the specified ClientToServerMessage message. Does not implicitly {@link sync_pb.ClientToServerMessage.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ClientToServerMessage
         * @static
         * @param {sync_pb.IClientToServerMessage} message ClientToServerMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientToServerMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.share);
            if (message.protocolVersion != null && Object.hasOwnProperty.call(message, "protocolVersion"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.protocolVersion);
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.messageContents);
            if (message.commit != null && Object.hasOwnProperty.call(message, "commit"))
                $root.sync_pb.CommitMessage.encode(message.commit, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.getUpdates != null && Object.hasOwnProperty.call(message, "getUpdates"))
                $root.sync_pb.GetUpdatesMessage.encode(message.getUpdates, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.storeBirthday != null && Object.hasOwnProperty.call(message, "storeBirthday"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.storeBirthday);
            if (message.syncProblemDetected != null && Object.hasOwnProperty.call(message, "syncProblemDetected"))
                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.syncProblemDetected);
            if (message.debugInfo != null && Object.hasOwnProperty.call(message, "debugInfo"))
                $root.sync_pb.DebugInfo.encode(message.debugInfo, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            if (message.bagOfChips != null && Object.hasOwnProperty.call(message, "bagOfChips"))
                $root.sync_pb.ChipBag.encode(message.bagOfChips, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
            if (message.apiKey != null && Object.hasOwnProperty.call(message, "apiKey"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.apiKey);
            if (message.clientStatus != null && Object.hasOwnProperty.call(message, "clientStatus"))
                $root.sync_pb.ClientStatus.encode(message.clientStatus, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.invalidatorClientId != null && Object.hasOwnProperty.call(message, "invalidatorClientId"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.invalidatorClientId);
            if (message.clearServerData != null && Object.hasOwnProperty.call(message, "clearServerData"))
                $root.sync_pb.ClearServerDataMessage.encode(message.clearServerData, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ClientToServerMessage message, length delimited. Does not implicitly {@link sync_pb.ClientToServerMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ClientToServerMessage
         * @static
         * @param {sync_pb.IClientToServerMessage} message ClientToServerMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientToServerMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClientToServerMessage message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ClientToServerMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ClientToServerMessage} ClientToServerMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientToServerMessage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ClientToServerMessage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.share = reader.string();
                    break;
                case 2:
                    message.protocolVersion = reader.int32();
                    break;
                case 3:
                    message.messageContents = reader.int32();
                    break;
                case 4:
                    message.commit = $root.sync_pb.CommitMessage.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.getUpdates = $root.sync_pb.GetUpdatesMessage.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.storeBirthday = reader.string();
                    break;
                case 8:
                    message.syncProblemDetected = reader.bool();
                    break;
                case 10:
                    message.debugInfo = $root.sync_pb.DebugInfo.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.bagOfChips = $root.sync_pb.ChipBag.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.apiKey = reader.string();
                    break;
                case 13:
                    message.clientStatus = $root.sync_pb.ClientStatus.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.invalidatorClientId = reader.string();
                    break;
                case 15:
                    message.clearServerData = $root.sync_pb.ClearServerDataMessage.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("share"))
                throw $util.ProtocolError("missing required 'share'", { instance: message });
            if (!message.hasOwnProperty("messageContents"))
                throw $util.ProtocolError("missing required 'messageContents'", { instance: message });
            return message;
        };

        /**
         * Decodes a ClientToServerMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ClientToServerMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ClientToServerMessage} ClientToServerMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientToServerMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClientToServerMessage message.
         * @function verify
         * @memberof sync_pb.ClientToServerMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClientToServerMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.share))
                return "share: string expected";
            if (message.protocolVersion != null && message.hasOwnProperty("protocolVersion"))
                if (!$util.isInteger(message.protocolVersion))
                    return "protocolVersion: integer expected";
            switch (message.messageContents) {
            default:
                return "messageContents: enum value expected";
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
            if (message.commit != null && message.hasOwnProperty("commit")) {
                let error = $root.sync_pb.CommitMessage.verify(message.commit);
                if (error)
                    return "commit." + error;
            }
            if (message.getUpdates != null && message.hasOwnProperty("getUpdates")) {
                let error = $root.sync_pb.GetUpdatesMessage.verify(message.getUpdates);
                if (error)
                    return "getUpdates." + error;
            }
            if (message.storeBirthday != null && message.hasOwnProperty("storeBirthday"))
                if (!$util.isString(message.storeBirthday))
                    return "storeBirthday: string expected";
            if (message.syncProblemDetected != null && message.hasOwnProperty("syncProblemDetected"))
                if (typeof message.syncProblemDetected !== "boolean")
                    return "syncProblemDetected: boolean expected";
            if (message.debugInfo != null && message.hasOwnProperty("debugInfo")) {
                let error = $root.sync_pb.DebugInfo.verify(message.debugInfo);
                if (error)
                    return "debugInfo." + error;
            }
            if (message.bagOfChips != null && message.hasOwnProperty("bagOfChips")) {
                let error = $root.sync_pb.ChipBag.verify(message.bagOfChips);
                if (error)
                    return "bagOfChips." + error;
            }
            if (message.apiKey != null && message.hasOwnProperty("apiKey"))
                if (!$util.isString(message.apiKey))
                    return "apiKey: string expected";
            if (message.clientStatus != null && message.hasOwnProperty("clientStatus")) {
                let error = $root.sync_pb.ClientStatus.verify(message.clientStatus);
                if (error)
                    return "clientStatus." + error;
            }
            if (message.invalidatorClientId != null && message.hasOwnProperty("invalidatorClientId"))
                if (!$util.isString(message.invalidatorClientId))
                    return "invalidatorClientId: string expected";
            if (message.clearServerData != null && message.hasOwnProperty("clearServerData")) {
                let error = $root.sync_pb.ClearServerDataMessage.verify(message.clearServerData);
                if (error)
                    return "clearServerData." + error;
            }
            return null;
        };

        /**
         * Creates a ClientToServerMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ClientToServerMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ClientToServerMessage} ClientToServerMessage
         */
        ClientToServerMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ClientToServerMessage)
                return object;
            let message = new $root.sync_pb.ClientToServerMessage();
            if (object.share != null)
                message.share = String(object.share);
            if (object.protocolVersion != null)
                message.protocolVersion = object.protocolVersion | 0;
            switch (object.messageContents) {
            case "COMMIT":
            case 1:
                message.messageContents = 1;
                break;
            case "GET_UPDATES":
            case 2:
                message.messageContents = 2;
                break;
            case "DEPRECATED_3":
            case 3:
                message.messageContents = 3;
                break;
            case "DEPRECATED_4":
            case 4:
                message.messageContents = 4;
                break;
            case "CLEAR_SERVER_DATA":
            case 5:
                message.messageContents = 5;
                break;
            }
            if (object.commit != null) {
                if (typeof object.commit !== "object")
                    throw TypeError(".sync_pb.ClientToServerMessage.commit: object expected");
                message.commit = $root.sync_pb.CommitMessage.fromObject(object.commit);
            }
            if (object.getUpdates != null) {
                if (typeof object.getUpdates !== "object")
                    throw TypeError(".sync_pb.ClientToServerMessage.getUpdates: object expected");
                message.getUpdates = $root.sync_pb.GetUpdatesMessage.fromObject(object.getUpdates);
            }
            if (object.storeBirthday != null)
                message.storeBirthday = String(object.storeBirthday);
            if (object.syncProblemDetected != null)
                message.syncProblemDetected = Boolean(object.syncProblemDetected);
            if (object.debugInfo != null) {
                if (typeof object.debugInfo !== "object")
                    throw TypeError(".sync_pb.ClientToServerMessage.debugInfo: object expected");
                message.debugInfo = $root.sync_pb.DebugInfo.fromObject(object.debugInfo);
            }
            if (object.bagOfChips != null) {
                if (typeof object.bagOfChips !== "object")
                    throw TypeError(".sync_pb.ClientToServerMessage.bagOfChips: object expected");
                message.bagOfChips = $root.sync_pb.ChipBag.fromObject(object.bagOfChips);
            }
            if (object.apiKey != null)
                message.apiKey = String(object.apiKey);
            if (object.clientStatus != null) {
                if (typeof object.clientStatus !== "object")
                    throw TypeError(".sync_pb.ClientToServerMessage.clientStatus: object expected");
                message.clientStatus = $root.sync_pb.ClientStatus.fromObject(object.clientStatus);
            }
            if (object.invalidatorClientId != null)
                message.invalidatorClientId = String(object.invalidatorClientId);
            if (object.clearServerData != null) {
                if (typeof object.clearServerData !== "object")
                    throw TypeError(".sync_pb.ClientToServerMessage.clearServerData: object expected");
                message.clearServerData = $root.sync_pb.ClearServerDataMessage.fromObject(object.clearServerData);
            }
            return message;
        };

        /**
         * Creates a plain object from a ClientToServerMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ClientToServerMessage
         * @static
         * @param {sync_pb.ClientToServerMessage} message ClientToServerMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClientToServerMessage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.share = "";
                object.protocolVersion = 52;
                object.messageContents = options.enums === String ? "COMMIT" : 1;
                object.commit = null;
                object.getUpdates = null;
                object.storeBirthday = "";
                object.syncProblemDetected = false;
                object.debugInfo = null;
                object.bagOfChips = null;
                object.apiKey = "";
                object.clientStatus = null;
                object.invalidatorClientId = "";
                object.clearServerData = null;
            }
            if (message.share != null && message.hasOwnProperty("share"))
                object.share = message.share;
            if (message.protocolVersion != null && message.hasOwnProperty("protocolVersion"))
                object.protocolVersion = message.protocolVersion;
            if (message.messageContents != null && message.hasOwnProperty("messageContents"))
                object.messageContents = options.enums === String ? $root.sync_pb.ClientToServerMessage.Contents[message.messageContents] : message.messageContents;
            if (message.commit != null && message.hasOwnProperty("commit"))
                object.commit = $root.sync_pb.CommitMessage.toObject(message.commit, options);
            if (message.getUpdates != null && message.hasOwnProperty("getUpdates"))
                object.getUpdates = $root.sync_pb.GetUpdatesMessage.toObject(message.getUpdates, options);
            if (message.storeBirthday != null && message.hasOwnProperty("storeBirthday"))
                object.storeBirthday = message.storeBirthday;
            if (message.syncProblemDetected != null && message.hasOwnProperty("syncProblemDetected"))
                object.syncProblemDetected = message.syncProblemDetected;
            if (message.debugInfo != null && message.hasOwnProperty("debugInfo"))
                object.debugInfo = $root.sync_pb.DebugInfo.toObject(message.debugInfo, options);
            if (message.bagOfChips != null && message.hasOwnProperty("bagOfChips"))
                object.bagOfChips = $root.sync_pb.ChipBag.toObject(message.bagOfChips, options);
            if (message.apiKey != null && message.hasOwnProperty("apiKey"))
                object.apiKey = message.apiKey;
            if (message.clientStatus != null && message.hasOwnProperty("clientStatus"))
                object.clientStatus = $root.sync_pb.ClientStatus.toObject(message.clientStatus, options);
            if (message.invalidatorClientId != null && message.hasOwnProperty("invalidatorClientId"))
                object.invalidatorClientId = message.invalidatorClientId;
            if (message.clearServerData != null && message.hasOwnProperty("clearServerData"))
                object.clearServerData = $root.sync_pb.ClearServerDataMessage.toObject(message.clearServerData, options);
            return object;
        };

        /**
         * Converts this ClientToServerMessage to JSON.
         * @function toJSON
         * @memberof sync_pb.ClientToServerMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClientToServerMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Contents enum.
         * @name sync_pb.ClientToServerMessage.Contents
         * @enum {number}
         * @property {number} COMMIT=1 COMMIT value
         * @property {number} GET_UPDATES=2 GET_UPDATES value
         * @property {number} DEPRECATED_3=3 DEPRECATED_3 value
         * @property {number} DEPRECATED_4=4 DEPRECATED_4 value
         * @property {number} CLEAR_SERVER_DATA=5 CLEAR_SERVER_DATA value
         */
        ClientToServerMessage.Contents = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "COMMIT"] = 1;
            values[valuesById[2] = "GET_UPDATES"] = 2;
            values[valuesById[3] = "DEPRECATED_3"] = 3;
            values[valuesById[4] = "DEPRECATED_4"] = 4;
            values[valuesById[5] = "CLEAR_SERVER_DATA"] = 5;
            return values;
        })();

        return ClientToServerMessage;
    })();

    sync_pb.GetCrashInfoRequest = (function() {

        /**
         * Properties of a GetCrashInfoRequest.
         * @memberof sync_pb
         * @interface IGetCrashInfoRequest
         * @property {string|null} [crashId] GetCrashInfoRequest crashId
         * @property {number|Long|null} [crashTimeMillis] GetCrashInfoRequest crashTimeMillis
         */

        /**
         * Constructs a new GetCrashInfoRequest.
         * @memberof sync_pb
         * @classdesc Represents a GetCrashInfoRequest.
         * @implements IGetCrashInfoRequest
         * @constructor
         * @param {sync_pb.IGetCrashInfoRequest=} [properties] Properties to set
         */
        function GetCrashInfoRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetCrashInfoRequest crashId.
         * @member {string} crashId
         * @memberof sync_pb.GetCrashInfoRequest
         * @instance
         */
        GetCrashInfoRequest.prototype.crashId = "";

        /**
         * GetCrashInfoRequest crashTimeMillis.
         * @member {number|Long} crashTimeMillis
         * @memberof sync_pb.GetCrashInfoRequest
         * @instance
         */
        GetCrashInfoRequest.prototype.crashTimeMillis = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new GetCrashInfoRequest instance using the specified properties.
         * @function create
         * @memberof sync_pb.GetCrashInfoRequest
         * @static
         * @param {sync_pb.IGetCrashInfoRequest=} [properties] Properties to set
         * @returns {sync_pb.GetCrashInfoRequest} GetCrashInfoRequest instance
         */
        GetCrashInfoRequest.create = function create(properties) {
            return new GetCrashInfoRequest(properties);
        };

        /**
         * Encodes the specified GetCrashInfoRequest message. Does not implicitly {@link sync_pb.GetCrashInfoRequest.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.GetCrashInfoRequest
         * @static
         * @param {sync_pb.IGetCrashInfoRequest} message GetCrashInfoRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetCrashInfoRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.crashId != null && Object.hasOwnProperty.call(message, "crashId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.crashId);
            if (message.crashTimeMillis != null && Object.hasOwnProperty.call(message, "crashTimeMillis"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.crashTimeMillis);
            return writer;
        };

        /**
         * Encodes the specified GetCrashInfoRequest message, length delimited. Does not implicitly {@link sync_pb.GetCrashInfoRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.GetCrashInfoRequest
         * @static
         * @param {sync_pb.IGetCrashInfoRequest} message GetCrashInfoRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetCrashInfoRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetCrashInfoRequest message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.GetCrashInfoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.GetCrashInfoRequest} GetCrashInfoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetCrashInfoRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.GetCrashInfoRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.crashId = reader.string();
                    break;
                case 2:
                    message.crashTimeMillis = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetCrashInfoRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.GetCrashInfoRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.GetCrashInfoRequest} GetCrashInfoRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetCrashInfoRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetCrashInfoRequest message.
         * @function verify
         * @memberof sync_pb.GetCrashInfoRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetCrashInfoRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.crashId != null && message.hasOwnProperty("crashId"))
                if (!$util.isString(message.crashId))
                    return "crashId: string expected";
            if (message.crashTimeMillis != null && message.hasOwnProperty("crashTimeMillis"))
                if (!$util.isInteger(message.crashTimeMillis) && !(message.crashTimeMillis && $util.isInteger(message.crashTimeMillis.low) && $util.isInteger(message.crashTimeMillis.high)))
                    return "crashTimeMillis: integer|Long expected";
            return null;
        };

        /**
         * Creates a GetCrashInfoRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.GetCrashInfoRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.GetCrashInfoRequest} GetCrashInfoRequest
         */
        GetCrashInfoRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.GetCrashInfoRequest)
                return object;
            let message = new $root.sync_pb.GetCrashInfoRequest();
            if (object.crashId != null)
                message.crashId = String(object.crashId);
            if (object.crashTimeMillis != null)
                if ($util.Long)
                    (message.crashTimeMillis = $util.Long.fromValue(object.crashTimeMillis)).unsigned = false;
                else if (typeof object.crashTimeMillis === "string")
                    message.crashTimeMillis = parseInt(object.crashTimeMillis, 10);
                else if (typeof object.crashTimeMillis === "number")
                    message.crashTimeMillis = object.crashTimeMillis;
                else if (typeof object.crashTimeMillis === "object")
                    message.crashTimeMillis = new $util.LongBits(object.crashTimeMillis.low >>> 0, object.crashTimeMillis.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a GetCrashInfoRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.GetCrashInfoRequest
         * @static
         * @param {sync_pb.GetCrashInfoRequest} message GetCrashInfoRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetCrashInfoRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.crashId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.crashTimeMillis = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.crashTimeMillis = options.longs === String ? "0" : 0;
            }
            if (message.crashId != null && message.hasOwnProperty("crashId"))
                object.crashId = message.crashId;
            if (message.crashTimeMillis != null && message.hasOwnProperty("crashTimeMillis"))
                if (typeof message.crashTimeMillis === "number")
                    object.crashTimeMillis = options.longs === String ? String(message.crashTimeMillis) : message.crashTimeMillis;
                else
                    object.crashTimeMillis = options.longs === String ? $util.Long.prototype.toString.call(message.crashTimeMillis) : options.longs === Number ? new $util.LongBits(message.crashTimeMillis.low >>> 0, message.crashTimeMillis.high >>> 0).toNumber() : message.crashTimeMillis;
            return object;
        };

        /**
         * Converts this GetCrashInfoRequest to JSON.
         * @function toJSON
         * @memberof sync_pb.GetCrashInfoRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetCrashInfoRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetCrashInfoRequest;
    })();

    sync_pb.GetCrashInfoResponse = (function() {

        /**
         * Properties of a GetCrashInfoResponse.
         * @memberof sync_pb
         * @interface IGetCrashInfoResponse
         * @property {string|null} [stackId] GetCrashInfoResponse stackId
         * @property {number|Long|null} [crashTimeMillis] GetCrashInfoResponse crashTimeMillis
         */

        /**
         * Constructs a new GetCrashInfoResponse.
         * @memberof sync_pb
         * @classdesc Represents a GetCrashInfoResponse.
         * @implements IGetCrashInfoResponse
         * @constructor
         * @param {sync_pb.IGetCrashInfoResponse=} [properties] Properties to set
         */
        function GetCrashInfoResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetCrashInfoResponse stackId.
         * @member {string} stackId
         * @memberof sync_pb.GetCrashInfoResponse
         * @instance
         */
        GetCrashInfoResponse.prototype.stackId = "";

        /**
         * GetCrashInfoResponse crashTimeMillis.
         * @member {number|Long} crashTimeMillis
         * @memberof sync_pb.GetCrashInfoResponse
         * @instance
         */
        GetCrashInfoResponse.prototype.crashTimeMillis = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new GetCrashInfoResponse instance using the specified properties.
         * @function create
         * @memberof sync_pb.GetCrashInfoResponse
         * @static
         * @param {sync_pb.IGetCrashInfoResponse=} [properties] Properties to set
         * @returns {sync_pb.GetCrashInfoResponse} GetCrashInfoResponse instance
         */
        GetCrashInfoResponse.create = function create(properties) {
            return new GetCrashInfoResponse(properties);
        };

        /**
         * Encodes the specified GetCrashInfoResponse message. Does not implicitly {@link sync_pb.GetCrashInfoResponse.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.GetCrashInfoResponse
         * @static
         * @param {sync_pb.IGetCrashInfoResponse} message GetCrashInfoResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetCrashInfoResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.stackId != null && Object.hasOwnProperty.call(message, "stackId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.stackId);
            if (message.crashTimeMillis != null && Object.hasOwnProperty.call(message, "crashTimeMillis"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.crashTimeMillis);
            return writer;
        };

        /**
         * Encodes the specified GetCrashInfoResponse message, length delimited. Does not implicitly {@link sync_pb.GetCrashInfoResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.GetCrashInfoResponse
         * @static
         * @param {sync_pb.IGetCrashInfoResponse} message GetCrashInfoResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetCrashInfoResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetCrashInfoResponse message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.GetCrashInfoResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.GetCrashInfoResponse} GetCrashInfoResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetCrashInfoResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.GetCrashInfoResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.stackId = reader.string();
                    break;
                case 2:
                    message.crashTimeMillis = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetCrashInfoResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.GetCrashInfoResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.GetCrashInfoResponse} GetCrashInfoResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetCrashInfoResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetCrashInfoResponse message.
         * @function verify
         * @memberof sync_pb.GetCrashInfoResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetCrashInfoResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.stackId != null && message.hasOwnProperty("stackId"))
                if (!$util.isString(message.stackId))
                    return "stackId: string expected";
            if (message.crashTimeMillis != null && message.hasOwnProperty("crashTimeMillis"))
                if (!$util.isInteger(message.crashTimeMillis) && !(message.crashTimeMillis && $util.isInteger(message.crashTimeMillis.low) && $util.isInteger(message.crashTimeMillis.high)))
                    return "crashTimeMillis: integer|Long expected";
            return null;
        };

        /**
         * Creates a GetCrashInfoResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.GetCrashInfoResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.GetCrashInfoResponse} GetCrashInfoResponse
         */
        GetCrashInfoResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.GetCrashInfoResponse)
                return object;
            let message = new $root.sync_pb.GetCrashInfoResponse();
            if (object.stackId != null)
                message.stackId = String(object.stackId);
            if (object.crashTimeMillis != null)
                if ($util.Long)
                    (message.crashTimeMillis = $util.Long.fromValue(object.crashTimeMillis)).unsigned = false;
                else if (typeof object.crashTimeMillis === "string")
                    message.crashTimeMillis = parseInt(object.crashTimeMillis, 10);
                else if (typeof object.crashTimeMillis === "number")
                    message.crashTimeMillis = object.crashTimeMillis;
                else if (typeof object.crashTimeMillis === "object")
                    message.crashTimeMillis = new $util.LongBits(object.crashTimeMillis.low >>> 0, object.crashTimeMillis.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a GetCrashInfoResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.GetCrashInfoResponse
         * @static
         * @param {sync_pb.GetCrashInfoResponse} message GetCrashInfoResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetCrashInfoResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.stackId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.crashTimeMillis = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.crashTimeMillis = options.longs === String ? "0" : 0;
            }
            if (message.stackId != null && message.hasOwnProperty("stackId"))
                object.stackId = message.stackId;
            if (message.crashTimeMillis != null && message.hasOwnProperty("crashTimeMillis"))
                if (typeof message.crashTimeMillis === "number")
                    object.crashTimeMillis = options.longs === String ? String(message.crashTimeMillis) : message.crashTimeMillis;
                else
                    object.crashTimeMillis = options.longs === String ? $util.Long.prototype.toString.call(message.crashTimeMillis) : options.longs === Number ? new $util.LongBits(message.crashTimeMillis.low >>> 0, message.crashTimeMillis.high >>> 0).toNumber() : message.crashTimeMillis;
            return object;
        };

        /**
         * Converts this GetCrashInfoResponse to JSON.
         * @function toJSON
         * @memberof sync_pb.GetCrashInfoResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetCrashInfoResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetCrashInfoResponse;
    })();

    sync_pb.CommitResponse = (function() {

        /**
         * Properties of a CommitResponse.
         * @memberof sync_pb
         * @interface ICommitResponse
         * @property {Array.<sync_pb.CommitResponse.IEntryResponse>|null} [entryResponse] CommitResponse entryResponse
         */

        /**
         * Constructs a new CommitResponse.
         * @memberof sync_pb
         * @classdesc Represents a CommitResponse.
         * @implements ICommitResponse
         * @constructor
         * @param {sync_pb.ICommitResponse=} [properties] Properties to set
         */
        function CommitResponse(properties) {
            this.entryResponse = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CommitResponse entryResponse.
         * @member {Array.<sync_pb.CommitResponse.IEntryResponse>} entryResponse
         * @memberof sync_pb.CommitResponse
         * @instance
         */
        CommitResponse.prototype.entryResponse = $util.emptyArray;

        /**
         * Creates a new CommitResponse instance using the specified properties.
         * @function create
         * @memberof sync_pb.CommitResponse
         * @static
         * @param {sync_pb.ICommitResponse=} [properties] Properties to set
         * @returns {sync_pb.CommitResponse} CommitResponse instance
         */
        CommitResponse.create = function create(properties) {
            return new CommitResponse(properties);
        };

        /**
         * Encodes the specified CommitResponse message. Does not implicitly {@link sync_pb.CommitResponse.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.CommitResponse
         * @static
         * @param {sync_pb.ICommitResponse} message CommitResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CommitResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.entryResponse != null && message.entryResponse.length)
                for (let i = 0; i < message.entryResponse.length; ++i)
                    $root.sync_pb.CommitResponse.EntryResponse.encode(message.entryResponse[i], writer.uint32(/* id 1, wireType 3 =*/11)).uint32(/* id 1, wireType 4 =*/12);
            return writer;
        };

        /**
         * Encodes the specified CommitResponse message, length delimited. Does not implicitly {@link sync_pb.CommitResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.CommitResponse
         * @static
         * @param {sync_pb.ICommitResponse} message CommitResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CommitResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CommitResponse message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.CommitResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.CommitResponse} CommitResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CommitResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.CommitResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.entryResponse && message.entryResponse.length))
                        message.entryResponse = [];
                    message.entryResponse.push($root.sync_pb.CommitResponse.EntryResponse.decode(reader));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CommitResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.CommitResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.CommitResponse} CommitResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CommitResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CommitResponse message.
         * @function verify
         * @memberof sync_pb.CommitResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CommitResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.entryResponse != null && message.hasOwnProperty("entryResponse")) {
                if (!Array.isArray(message.entryResponse))
                    return "entryResponse: array expected";
                for (let i = 0; i < message.entryResponse.length; ++i) {
                    let error = $root.sync_pb.CommitResponse.EntryResponse.verify(message.entryResponse[i]);
                    if (error)
                        return "entryResponse." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CommitResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.CommitResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.CommitResponse} CommitResponse
         */
        CommitResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.CommitResponse)
                return object;
            let message = new $root.sync_pb.CommitResponse();
            if (object.entryResponse) {
                if (!Array.isArray(object.entryResponse))
                    throw TypeError(".sync_pb.CommitResponse.entryResponse: array expected");
                message.entryResponse = [];
                for (let i = 0; i < object.entryResponse.length; ++i) {
                    if (typeof object.entryResponse[i] !== "object")
                        throw TypeError(".sync_pb.CommitResponse.entryResponse: object expected");
                    message.entryResponse[i] = $root.sync_pb.CommitResponse.EntryResponse.fromObject(object.entryResponse[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CommitResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.CommitResponse
         * @static
         * @param {sync_pb.CommitResponse} message CommitResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CommitResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.entryResponse = [];
            if (message.entryResponse && message.entryResponse.length) {
                object.entryResponse = [];
                for (let j = 0; j < message.entryResponse.length; ++j)
                    object.entryResponse[j] = $root.sync_pb.CommitResponse.EntryResponse.toObject(message.entryResponse[j], options);
            }
            return object;
        };

        /**
         * Converts this CommitResponse to JSON.
         * @function toJSON
         * @memberof sync_pb.CommitResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CommitResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * ResponseType enum.
         * @name sync_pb.CommitResponse.ResponseType
         * @enum {number}
         * @property {number} SUCCESS=1 SUCCESS value
         * @property {number} CONFLICT=2 CONFLICT value
         * @property {number} RETRY=3 RETRY value
         * @property {number} INVALID_MESSAGE=4 INVALID_MESSAGE value
         * @property {number} OVER_QUOTA=5 OVER_QUOTA value
         * @property {number} TRANSIENT_ERROR=6 TRANSIENT_ERROR value
         */
        CommitResponse.ResponseType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "SUCCESS"] = 1;
            values[valuesById[2] = "CONFLICT"] = 2;
            values[valuesById[3] = "RETRY"] = 3;
            values[valuesById[4] = "INVALID_MESSAGE"] = 4;
            values[valuesById[5] = "OVER_QUOTA"] = 5;
            values[valuesById[6] = "TRANSIENT_ERROR"] = 6;
            return values;
        })();

        CommitResponse.EntryResponse = (function() {

            /**
             * Properties of an EntryResponse.
             * @memberof sync_pb.CommitResponse
             * @interface IEntryResponse
             * @property {sync_pb.CommitResponse.ResponseType} responseType EntryResponse responseType
             * @property {string|null} [idString] EntryResponse idString
             * @property {string|null} [parentIdString] EntryResponse parentIdString
             * @property {number|Long|null} [version] EntryResponse version
             * @property {string|null} [name] EntryResponse name
             * @property {string|null} [nonUniqueName] EntryResponse nonUniqueName
             * @property {string|null} [errorMessage] EntryResponse errorMessage
             * @property {number|Long|null} [mtime] EntryResponse mtime
             */

            /**
             * Constructs a new EntryResponse.
             * @memberof sync_pb.CommitResponse
             * @classdesc Represents an EntryResponse.
             * @implements IEntryResponse
             * @constructor
             * @param {sync_pb.CommitResponse.IEntryResponse=} [properties] Properties to set
             */
            function EntryResponse(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EntryResponse responseType.
             * @member {sync_pb.CommitResponse.ResponseType} responseType
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @instance
             */
            EntryResponse.prototype.responseType = 1;

            /**
             * EntryResponse idString.
             * @member {string} idString
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @instance
             */
            EntryResponse.prototype.idString = "";

            /**
             * EntryResponse parentIdString.
             * @member {string} parentIdString
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @instance
             */
            EntryResponse.prototype.parentIdString = "";

            /**
             * EntryResponse version.
             * @member {number|Long} version
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @instance
             */
            EntryResponse.prototype.version = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * EntryResponse name.
             * @member {string} name
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @instance
             */
            EntryResponse.prototype.name = "";

            /**
             * EntryResponse nonUniqueName.
             * @member {string} nonUniqueName
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @instance
             */
            EntryResponse.prototype.nonUniqueName = "";

            /**
             * EntryResponse errorMessage.
             * @member {string} errorMessage
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @instance
             */
            EntryResponse.prototype.errorMessage = "";

            /**
             * EntryResponse mtime.
             * @member {number|Long} mtime
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @instance
             */
            EntryResponse.prototype.mtime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new EntryResponse instance using the specified properties.
             * @function create
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @static
             * @param {sync_pb.CommitResponse.IEntryResponse=} [properties] Properties to set
             * @returns {sync_pb.CommitResponse.EntryResponse} EntryResponse instance
             */
            EntryResponse.create = function create(properties) {
                return new EntryResponse(properties);
            };

            /**
             * Encodes the specified EntryResponse message. Does not implicitly {@link sync_pb.CommitResponse.EntryResponse.verify|verify} messages.
             * @function encode
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @static
             * @param {sync_pb.CommitResponse.IEntryResponse} message EntryResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EntryResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.responseType);
                if (message.idString != null && Object.hasOwnProperty.call(message, "idString"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.idString);
                if (message.parentIdString != null && Object.hasOwnProperty.call(message, "parentIdString"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.parentIdString);
                if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int64(message.version);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.name);
                if (message.nonUniqueName != null && Object.hasOwnProperty.call(message, "nonUniqueName"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.nonUniqueName);
                if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.errorMessage);
                if (message.mtime != null && Object.hasOwnProperty.call(message, "mtime"))
                    writer.uint32(/* id 10, wireType 0 =*/80).int64(message.mtime);
                return writer;
            };

            /**
             * Encodes the specified EntryResponse message, length delimited. Does not implicitly {@link sync_pb.CommitResponse.EntryResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @static
             * @param {sync_pb.CommitResponse.IEntryResponse} message EntryResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EntryResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EntryResponse message from the specified reader or buffer.
             * @function decode
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync_pb.CommitResponse.EntryResponse} EntryResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EntryResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.CommitResponse.EntryResponse();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if ((tag & 7) === 4)
                        break;
                    switch (tag >>> 3) {
                    case 2:
                        message.responseType = reader.int32();
                        break;
                    case 3:
                        message.idString = reader.string();
                        break;
                    case 4:
                        message.parentIdString = reader.string();
                        break;
                    case 6:
                        message.version = reader.int64();
                        break;
                    case 7:
                        message.name = reader.string();
                        break;
                    case 8:
                        message.nonUniqueName = reader.string();
                        break;
                    case 9:
                        message.errorMessage = reader.string();
                        break;
                    case 10:
                        message.mtime = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("responseType"))
                    throw $util.ProtocolError("missing required 'responseType'", { instance: message });
                return message;
            };

            /**
             * Decodes an EntryResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync_pb.CommitResponse.EntryResponse} EntryResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EntryResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EntryResponse message.
             * @function verify
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EntryResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                switch (message.responseType) {
                default:
                    return "responseType: enum value expected";
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
                }
                if (message.idString != null && message.hasOwnProperty("idString"))
                    if (!$util.isString(message.idString))
                        return "idString: string expected";
                if (message.parentIdString != null && message.hasOwnProperty("parentIdString"))
                    if (!$util.isString(message.parentIdString))
                        return "parentIdString: string expected";
                if (message.version != null && message.hasOwnProperty("version"))
                    if (!$util.isInteger(message.version) && !(message.version && $util.isInteger(message.version.low) && $util.isInteger(message.version.high)))
                        return "version: integer|Long expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.nonUniqueName != null && message.hasOwnProperty("nonUniqueName"))
                    if (!$util.isString(message.nonUniqueName))
                        return "nonUniqueName: string expected";
                if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                    if (!$util.isString(message.errorMessage))
                        return "errorMessage: string expected";
                if (message.mtime != null && message.hasOwnProperty("mtime"))
                    if (!$util.isInteger(message.mtime) && !(message.mtime && $util.isInteger(message.mtime.low) && $util.isInteger(message.mtime.high)))
                        return "mtime: integer|Long expected";
                return null;
            };

            /**
             * Creates an EntryResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync_pb.CommitResponse.EntryResponse} EntryResponse
             */
            EntryResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.sync_pb.CommitResponse.EntryResponse)
                    return object;
                let message = new $root.sync_pb.CommitResponse.EntryResponse();
                switch (object.responseType) {
                case "SUCCESS":
                case 1:
                    message.responseType = 1;
                    break;
                case "CONFLICT":
                case 2:
                    message.responseType = 2;
                    break;
                case "RETRY":
                case 3:
                    message.responseType = 3;
                    break;
                case "INVALID_MESSAGE":
                case 4:
                    message.responseType = 4;
                    break;
                case "OVER_QUOTA":
                case 5:
                    message.responseType = 5;
                    break;
                case "TRANSIENT_ERROR":
                case 6:
                    message.responseType = 6;
                    break;
                }
                if (object.idString != null)
                    message.idString = String(object.idString);
                if (object.parentIdString != null)
                    message.parentIdString = String(object.parentIdString);
                if (object.version != null)
                    if ($util.Long)
                        (message.version = $util.Long.fromValue(object.version)).unsigned = false;
                    else if (typeof object.version === "string")
                        message.version = parseInt(object.version, 10);
                    else if (typeof object.version === "number")
                        message.version = object.version;
                    else if (typeof object.version === "object")
                        message.version = new $util.LongBits(object.version.low >>> 0, object.version.high >>> 0).toNumber();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.nonUniqueName != null)
                    message.nonUniqueName = String(object.nonUniqueName);
                if (object.errorMessage != null)
                    message.errorMessage = String(object.errorMessage);
                if (object.mtime != null)
                    if ($util.Long)
                        (message.mtime = $util.Long.fromValue(object.mtime)).unsigned = false;
                    else if (typeof object.mtime === "string")
                        message.mtime = parseInt(object.mtime, 10);
                    else if (typeof object.mtime === "number")
                        message.mtime = object.mtime;
                    else if (typeof object.mtime === "object")
                        message.mtime = new $util.LongBits(object.mtime.low >>> 0, object.mtime.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from an EntryResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @static
             * @param {sync_pb.CommitResponse.EntryResponse} message EntryResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EntryResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.responseType = options.enums === String ? "SUCCESS" : 1;
                    object.idString = "";
                    object.parentIdString = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.version = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.version = options.longs === String ? "0" : 0;
                    object.name = "";
                    object.nonUniqueName = "";
                    object.errorMessage = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.mtime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.mtime = options.longs === String ? "0" : 0;
                }
                if (message.responseType != null && message.hasOwnProperty("responseType"))
                    object.responseType = options.enums === String ? $root.sync_pb.CommitResponse.ResponseType[message.responseType] : message.responseType;
                if (message.idString != null && message.hasOwnProperty("idString"))
                    object.idString = message.idString;
                if (message.parentIdString != null && message.hasOwnProperty("parentIdString"))
                    object.parentIdString = message.parentIdString;
                if (message.version != null && message.hasOwnProperty("version"))
                    if (typeof message.version === "number")
                        object.version = options.longs === String ? String(message.version) : message.version;
                    else
                        object.version = options.longs === String ? $util.Long.prototype.toString.call(message.version) : options.longs === Number ? new $util.LongBits(message.version.low >>> 0, message.version.high >>> 0).toNumber() : message.version;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.nonUniqueName != null && message.hasOwnProperty("nonUniqueName"))
                    object.nonUniqueName = message.nonUniqueName;
                if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                    object.errorMessage = message.errorMessage;
                if (message.mtime != null && message.hasOwnProperty("mtime"))
                    if (typeof message.mtime === "number")
                        object.mtime = options.longs === String ? String(message.mtime) : message.mtime;
                    else
                        object.mtime = options.longs === String ? $util.Long.prototype.toString.call(message.mtime) : options.longs === Number ? new $util.LongBits(message.mtime.low >>> 0, message.mtime.high >>> 0).toNumber() : message.mtime;
                return object;
            };

            /**
             * Converts this EntryResponse to JSON.
             * @function toJSON
             * @memberof sync_pb.CommitResponse.EntryResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EntryResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EntryResponse;
        })();

        return CommitResponse;
    })();

    sync_pb.GetUpdatesResponse = (function() {

        /**
         * Properties of a GetUpdatesResponse.
         * @memberof sync_pb
         * @interface IGetUpdatesResponse
         * @property {Array.<sync_pb.ISyncEntity>|null} [entries] GetUpdatesResponse entries
         * @property {number|Long|null} [changesRemaining] GetUpdatesResponse changesRemaining
         * @property {Array.<sync_pb.IDataTypeProgressMarker>|null} [newProgressMarker] GetUpdatesResponse newProgressMarker
         * @property {Array.<Uint8Array>|null} [encryptionKeys] GetUpdatesResponse encryptionKeys
         * @property {Array.<sync_pb.IDataTypeContext>|null} [contextMutations] GetUpdatesResponse contextMutations
         */

        /**
         * Constructs a new GetUpdatesResponse.
         * @memberof sync_pb
         * @classdesc Represents a GetUpdatesResponse.
         * @implements IGetUpdatesResponse
         * @constructor
         * @param {sync_pb.IGetUpdatesResponse=} [properties] Properties to set
         */
        function GetUpdatesResponse(properties) {
            this.entries = [];
            this.newProgressMarker = [];
            this.encryptionKeys = [];
            this.contextMutations = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUpdatesResponse entries.
         * @member {Array.<sync_pb.ISyncEntity>} entries
         * @memberof sync_pb.GetUpdatesResponse
         * @instance
         */
        GetUpdatesResponse.prototype.entries = $util.emptyArray;

        /**
         * GetUpdatesResponse changesRemaining.
         * @member {number|Long} changesRemaining
         * @memberof sync_pb.GetUpdatesResponse
         * @instance
         */
        GetUpdatesResponse.prototype.changesRemaining = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * GetUpdatesResponse newProgressMarker.
         * @member {Array.<sync_pb.IDataTypeProgressMarker>} newProgressMarker
         * @memberof sync_pb.GetUpdatesResponse
         * @instance
         */
        GetUpdatesResponse.prototype.newProgressMarker = $util.emptyArray;

        /**
         * GetUpdatesResponse encryptionKeys.
         * @member {Array.<Uint8Array>} encryptionKeys
         * @memberof sync_pb.GetUpdatesResponse
         * @instance
         */
        GetUpdatesResponse.prototype.encryptionKeys = $util.emptyArray;

        /**
         * GetUpdatesResponse contextMutations.
         * @member {Array.<sync_pb.IDataTypeContext>} contextMutations
         * @memberof sync_pb.GetUpdatesResponse
         * @instance
         */
        GetUpdatesResponse.prototype.contextMutations = $util.emptyArray;

        /**
         * Creates a new GetUpdatesResponse instance using the specified properties.
         * @function create
         * @memberof sync_pb.GetUpdatesResponse
         * @static
         * @param {sync_pb.IGetUpdatesResponse=} [properties] Properties to set
         * @returns {sync_pb.GetUpdatesResponse} GetUpdatesResponse instance
         */
        GetUpdatesResponse.create = function create(properties) {
            return new GetUpdatesResponse(properties);
        };

        /**
         * Encodes the specified GetUpdatesResponse message. Does not implicitly {@link sync_pb.GetUpdatesResponse.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.GetUpdatesResponse
         * @static
         * @param {sync_pb.IGetUpdatesResponse} message GetUpdatesResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUpdatesResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.entries != null && message.entries.length)
                for (let i = 0; i < message.entries.length; ++i)
                    $root.sync_pb.SyncEntity.encode(message.entries[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.changesRemaining != null && Object.hasOwnProperty.call(message, "changesRemaining"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.changesRemaining);
            if (message.newProgressMarker != null && message.newProgressMarker.length)
                for (let i = 0; i < message.newProgressMarker.length; ++i)
                    $root.sync_pb.DataTypeProgressMarker.encode(message.newProgressMarker[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.encryptionKeys != null && message.encryptionKeys.length)
                for (let i = 0; i < message.encryptionKeys.length; ++i)
                    writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.encryptionKeys[i]);
            if (message.contextMutations != null && message.contextMutations.length)
                for (let i = 0; i < message.contextMutations.length; ++i)
                    $root.sync_pb.DataTypeContext.encode(message.contextMutations[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified GetUpdatesResponse message, length delimited. Does not implicitly {@link sync_pb.GetUpdatesResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.GetUpdatesResponse
         * @static
         * @param {sync_pb.IGetUpdatesResponse} message GetUpdatesResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUpdatesResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetUpdatesResponse message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.GetUpdatesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.GetUpdatesResponse} GetUpdatesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUpdatesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.GetUpdatesResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.entries && message.entries.length))
                        message.entries = [];
                    message.entries.push($root.sync_pb.SyncEntity.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.changesRemaining = reader.int64();
                    break;
                case 5:
                    if (!(message.newProgressMarker && message.newProgressMarker.length))
                        message.newProgressMarker = [];
                    message.newProgressMarker.push($root.sync_pb.DataTypeProgressMarker.decode(reader, reader.uint32()));
                    break;
                case 6:
                    if (!(message.encryptionKeys && message.encryptionKeys.length))
                        message.encryptionKeys = [];
                    message.encryptionKeys.push(reader.bytes());
                    break;
                case 7:
                    if (!(message.contextMutations && message.contextMutations.length))
                        message.contextMutations = [];
                    message.contextMutations.push($root.sync_pb.DataTypeContext.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetUpdatesResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.GetUpdatesResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.GetUpdatesResponse} GetUpdatesResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUpdatesResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetUpdatesResponse message.
         * @function verify
         * @memberof sync_pb.GetUpdatesResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetUpdatesResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.entries != null && message.hasOwnProperty("entries")) {
                if (!Array.isArray(message.entries))
                    return "entries: array expected";
                for (let i = 0; i < message.entries.length; ++i) {
                    let error = $root.sync_pb.SyncEntity.verify(message.entries[i]);
                    if (error)
                        return "entries." + error;
                }
            }
            if (message.changesRemaining != null && message.hasOwnProperty("changesRemaining"))
                if (!$util.isInteger(message.changesRemaining) && !(message.changesRemaining && $util.isInteger(message.changesRemaining.low) && $util.isInteger(message.changesRemaining.high)))
                    return "changesRemaining: integer|Long expected";
            if (message.newProgressMarker != null && message.hasOwnProperty("newProgressMarker")) {
                if (!Array.isArray(message.newProgressMarker))
                    return "newProgressMarker: array expected";
                for (let i = 0; i < message.newProgressMarker.length; ++i) {
                    let error = $root.sync_pb.DataTypeProgressMarker.verify(message.newProgressMarker[i]);
                    if (error)
                        return "newProgressMarker." + error;
                }
            }
            if (message.encryptionKeys != null && message.hasOwnProperty("encryptionKeys")) {
                if (!Array.isArray(message.encryptionKeys))
                    return "encryptionKeys: array expected";
                for (let i = 0; i < message.encryptionKeys.length; ++i)
                    if (!(message.encryptionKeys[i] && typeof message.encryptionKeys[i].length === "number" || $util.isString(message.encryptionKeys[i])))
                        return "encryptionKeys: buffer[] expected";
            }
            if (message.contextMutations != null && message.hasOwnProperty("contextMutations")) {
                if (!Array.isArray(message.contextMutations))
                    return "contextMutations: array expected";
                for (let i = 0; i < message.contextMutations.length; ++i) {
                    let error = $root.sync_pb.DataTypeContext.verify(message.contextMutations[i]);
                    if (error)
                        return "contextMutations." + error;
                }
            }
            return null;
        };

        /**
         * Creates a GetUpdatesResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.GetUpdatesResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.GetUpdatesResponse} GetUpdatesResponse
         */
        GetUpdatesResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.GetUpdatesResponse)
                return object;
            let message = new $root.sync_pb.GetUpdatesResponse();
            if (object.entries) {
                if (!Array.isArray(object.entries))
                    throw TypeError(".sync_pb.GetUpdatesResponse.entries: array expected");
                message.entries = [];
                for (let i = 0; i < object.entries.length; ++i) {
                    if (typeof object.entries[i] !== "object")
                        throw TypeError(".sync_pb.GetUpdatesResponse.entries: object expected");
                    message.entries[i] = $root.sync_pb.SyncEntity.fromObject(object.entries[i]);
                }
            }
            if (object.changesRemaining != null)
                if ($util.Long)
                    (message.changesRemaining = $util.Long.fromValue(object.changesRemaining)).unsigned = false;
                else if (typeof object.changesRemaining === "string")
                    message.changesRemaining = parseInt(object.changesRemaining, 10);
                else if (typeof object.changesRemaining === "number")
                    message.changesRemaining = object.changesRemaining;
                else if (typeof object.changesRemaining === "object")
                    message.changesRemaining = new $util.LongBits(object.changesRemaining.low >>> 0, object.changesRemaining.high >>> 0).toNumber();
            if (object.newProgressMarker) {
                if (!Array.isArray(object.newProgressMarker))
                    throw TypeError(".sync_pb.GetUpdatesResponse.newProgressMarker: array expected");
                message.newProgressMarker = [];
                for (let i = 0; i < object.newProgressMarker.length; ++i) {
                    if (typeof object.newProgressMarker[i] !== "object")
                        throw TypeError(".sync_pb.GetUpdatesResponse.newProgressMarker: object expected");
                    message.newProgressMarker[i] = $root.sync_pb.DataTypeProgressMarker.fromObject(object.newProgressMarker[i]);
                }
            }
            if (object.encryptionKeys) {
                if (!Array.isArray(object.encryptionKeys))
                    throw TypeError(".sync_pb.GetUpdatesResponse.encryptionKeys: array expected");
                message.encryptionKeys = [];
                for (let i = 0; i < object.encryptionKeys.length; ++i)
                    if (typeof object.encryptionKeys[i] === "string")
                        $util.base64.decode(object.encryptionKeys[i], message.encryptionKeys[i] = $util.newBuffer($util.base64.length(object.encryptionKeys[i])), 0);
                    else if (object.encryptionKeys[i].length)
                        message.encryptionKeys[i] = object.encryptionKeys[i];
            }
            if (object.contextMutations) {
                if (!Array.isArray(object.contextMutations))
                    throw TypeError(".sync_pb.GetUpdatesResponse.contextMutations: array expected");
                message.contextMutations = [];
                for (let i = 0; i < object.contextMutations.length; ++i) {
                    if (typeof object.contextMutations[i] !== "object")
                        throw TypeError(".sync_pb.GetUpdatesResponse.contextMutations: object expected");
                    message.contextMutations[i] = $root.sync_pb.DataTypeContext.fromObject(object.contextMutations[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetUpdatesResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.GetUpdatesResponse
         * @static
         * @param {sync_pb.GetUpdatesResponse} message GetUpdatesResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUpdatesResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.entries = [];
                object.newProgressMarker = [];
                object.encryptionKeys = [];
                object.contextMutations = [];
            }
            if (options.defaults)
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.changesRemaining = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.changesRemaining = options.longs === String ? "0" : 0;
            if (message.entries && message.entries.length) {
                object.entries = [];
                for (let j = 0; j < message.entries.length; ++j)
                    object.entries[j] = $root.sync_pb.SyncEntity.toObject(message.entries[j], options);
            }
            if (message.changesRemaining != null && message.hasOwnProperty("changesRemaining"))
                if (typeof message.changesRemaining === "number")
                    object.changesRemaining = options.longs === String ? String(message.changesRemaining) : message.changesRemaining;
                else
                    object.changesRemaining = options.longs === String ? $util.Long.prototype.toString.call(message.changesRemaining) : options.longs === Number ? new $util.LongBits(message.changesRemaining.low >>> 0, message.changesRemaining.high >>> 0).toNumber() : message.changesRemaining;
            if (message.newProgressMarker && message.newProgressMarker.length) {
                object.newProgressMarker = [];
                for (let j = 0; j < message.newProgressMarker.length; ++j)
                    object.newProgressMarker[j] = $root.sync_pb.DataTypeProgressMarker.toObject(message.newProgressMarker[j], options);
            }
            if (message.encryptionKeys && message.encryptionKeys.length) {
                object.encryptionKeys = [];
                for (let j = 0; j < message.encryptionKeys.length; ++j)
                    object.encryptionKeys[j] = options.bytes === String ? $util.base64.encode(message.encryptionKeys[j], 0, message.encryptionKeys[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.encryptionKeys[j]) : message.encryptionKeys[j];
            }
            if (message.contextMutations && message.contextMutations.length) {
                object.contextMutations = [];
                for (let j = 0; j < message.contextMutations.length; ++j)
                    object.contextMutations[j] = $root.sync_pb.DataTypeContext.toObject(message.contextMutations[j], options);
            }
            return object;
        };

        /**
         * Converts this GetUpdatesResponse to JSON.
         * @function toJSON
         * @memberof sync_pb.GetUpdatesResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUpdatesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUpdatesResponse;
    })();

    sync_pb.ClientToServerResponse = (function() {

        /**
         * Properties of a ClientToServerResponse.
         * @memberof sync_pb
         * @interface IClientToServerResponse
         * @property {sync_pb.ICommitResponse|null} [commit] ClientToServerResponse commit
         * @property {sync_pb.IGetUpdatesResponse|null} [getUpdates] ClientToServerResponse getUpdates
         * @property {sync_pb.SyncEnums.ErrorType|null} [errorCode] ClientToServerResponse errorCode
         * @property {string|null} [errorMessage] ClientToServerResponse errorMessage
         * @property {string|null} [storeBirthday] ClientToServerResponse storeBirthday
         * @property {sync_pb.IClientCommand|null} [clientCommand] ClientToServerResponse clientCommand
         * @property {sync_pb.IProfilingData|null} [profilingData] ClientToServerResponse profilingData
         * @property {Array.<number>|null} [migratedDataTypeId] ClientToServerResponse migratedDataTypeId
         * @property {sync_pb.ClientToServerResponse.IError|null} [error] ClientToServerResponse error
         * @property {sync_pb.IChipBag|null} [newBagOfChips] ClientToServerResponse newBagOfChips
         * @property {sync_pb.IClearServerDataResponse|null} [clearServerData] ClientToServerResponse clearServerData
         */

        /**
         * Constructs a new ClientToServerResponse.
         * @memberof sync_pb
         * @classdesc Represents a ClientToServerResponse.
         * @implements IClientToServerResponse
         * @constructor
         * @param {sync_pb.IClientToServerResponse=} [properties] Properties to set
         */
        function ClientToServerResponse(properties) {
            this.migratedDataTypeId = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClientToServerResponse commit.
         * @member {sync_pb.ICommitResponse|null|undefined} commit
         * @memberof sync_pb.ClientToServerResponse
         * @instance
         */
        ClientToServerResponse.prototype.commit = null;

        /**
         * ClientToServerResponse getUpdates.
         * @member {sync_pb.IGetUpdatesResponse|null|undefined} getUpdates
         * @memberof sync_pb.ClientToServerResponse
         * @instance
         */
        ClientToServerResponse.prototype.getUpdates = null;

        /**
         * ClientToServerResponse errorCode.
         * @member {sync_pb.SyncEnums.ErrorType} errorCode
         * @memberof sync_pb.ClientToServerResponse
         * @instance
         */
        ClientToServerResponse.prototype.errorCode = 100;

        /**
         * ClientToServerResponse errorMessage.
         * @member {string} errorMessage
         * @memberof sync_pb.ClientToServerResponse
         * @instance
         */
        ClientToServerResponse.prototype.errorMessage = "";

        /**
         * ClientToServerResponse storeBirthday.
         * @member {string} storeBirthday
         * @memberof sync_pb.ClientToServerResponse
         * @instance
         */
        ClientToServerResponse.prototype.storeBirthday = "";

        /**
         * ClientToServerResponse clientCommand.
         * @member {sync_pb.IClientCommand|null|undefined} clientCommand
         * @memberof sync_pb.ClientToServerResponse
         * @instance
         */
        ClientToServerResponse.prototype.clientCommand = null;

        /**
         * ClientToServerResponse profilingData.
         * @member {sync_pb.IProfilingData|null|undefined} profilingData
         * @memberof sync_pb.ClientToServerResponse
         * @instance
         */
        ClientToServerResponse.prototype.profilingData = null;

        /**
         * ClientToServerResponse migratedDataTypeId.
         * @member {Array.<number>} migratedDataTypeId
         * @memberof sync_pb.ClientToServerResponse
         * @instance
         */
        ClientToServerResponse.prototype.migratedDataTypeId = $util.emptyArray;

        /**
         * ClientToServerResponse error.
         * @member {sync_pb.ClientToServerResponse.IError|null|undefined} error
         * @memberof sync_pb.ClientToServerResponse
         * @instance
         */
        ClientToServerResponse.prototype.error = null;

        /**
         * ClientToServerResponse newBagOfChips.
         * @member {sync_pb.IChipBag|null|undefined} newBagOfChips
         * @memberof sync_pb.ClientToServerResponse
         * @instance
         */
        ClientToServerResponse.prototype.newBagOfChips = null;

        /**
         * ClientToServerResponse clearServerData.
         * @member {sync_pb.IClearServerDataResponse|null|undefined} clearServerData
         * @memberof sync_pb.ClientToServerResponse
         * @instance
         */
        ClientToServerResponse.prototype.clearServerData = null;

        /**
         * Creates a new ClientToServerResponse instance using the specified properties.
         * @function create
         * @memberof sync_pb.ClientToServerResponse
         * @static
         * @param {sync_pb.IClientToServerResponse=} [properties] Properties to set
         * @returns {sync_pb.ClientToServerResponse} ClientToServerResponse instance
         */
        ClientToServerResponse.create = function create(properties) {
            return new ClientToServerResponse(properties);
        };

        /**
         * Encodes the specified ClientToServerResponse message. Does not implicitly {@link sync_pb.ClientToServerResponse.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ClientToServerResponse
         * @static
         * @param {sync_pb.IClientToServerResponse} message ClientToServerResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientToServerResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.commit != null && Object.hasOwnProperty.call(message, "commit"))
                $root.sync_pb.CommitResponse.encode(message.commit, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.getUpdates != null && Object.hasOwnProperty.call(message, "getUpdates"))
                $root.sync_pb.GetUpdatesResponse.encode(message.getUpdates, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.errorCode);
            if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.errorMessage);
            if (message.storeBirthday != null && Object.hasOwnProperty.call(message, "storeBirthday"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.storeBirthday);
            if (message.clientCommand != null && Object.hasOwnProperty.call(message, "clientCommand"))
                $root.sync_pb.ClientCommand.encode(message.clientCommand, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.profilingData != null && Object.hasOwnProperty.call(message, "profilingData"))
                $root.sync_pb.ProfilingData.encode(message.profilingData, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.migratedDataTypeId != null && message.migratedDataTypeId.length)
                for (let i = 0; i < message.migratedDataTypeId.length; ++i)
                    writer.uint32(/* id 12, wireType 0 =*/96).int32(message.migratedDataTypeId[i]);
            if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                $root.sync_pb.ClientToServerResponse.Error.encode(message.error, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.newBagOfChips != null && Object.hasOwnProperty.call(message, "newBagOfChips"))
                $root.sync_pb.ChipBag.encode(message.newBagOfChips, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
            if (message.clearServerData != null && Object.hasOwnProperty.call(message, "clearServerData"))
                $root.sync_pb.ClearServerDataResponse.encode(message.clearServerData, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ClientToServerResponse message, length delimited. Does not implicitly {@link sync_pb.ClientToServerResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ClientToServerResponse
         * @static
         * @param {sync_pb.IClientToServerResponse} message ClientToServerResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientToServerResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClientToServerResponse message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ClientToServerResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ClientToServerResponse} ClientToServerResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientToServerResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ClientToServerResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.commit = $root.sync_pb.CommitResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.getUpdates = $root.sync_pb.GetUpdatesResponse.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.errorCode = reader.int32();
                    break;
                case 5:
                    message.errorMessage = reader.string();
                    break;
                case 6:
                    message.storeBirthday = reader.string();
                    break;
                case 7:
                    message.clientCommand = $root.sync_pb.ClientCommand.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.profilingData = $root.sync_pb.ProfilingData.decode(reader, reader.uint32());
                    break;
                case 12:
                    if (!(message.migratedDataTypeId && message.migratedDataTypeId.length))
                        message.migratedDataTypeId = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.migratedDataTypeId.push(reader.int32());
                    } else
                        message.migratedDataTypeId.push(reader.int32());
                    break;
                case 13:
                    message.error = $root.sync_pb.ClientToServerResponse.Error.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.newBagOfChips = $root.sync_pb.ChipBag.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.clearServerData = $root.sync_pb.ClearServerDataResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ClientToServerResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ClientToServerResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ClientToServerResponse} ClientToServerResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientToServerResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClientToServerResponse message.
         * @function verify
         * @memberof sync_pb.ClientToServerResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClientToServerResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.commit != null && message.hasOwnProperty("commit")) {
                let error = $root.sync_pb.CommitResponse.verify(message.commit);
                if (error)
                    return "commit." + error;
            }
            if (message.getUpdates != null && message.hasOwnProperty("getUpdates")) {
                let error = $root.sync_pb.GetUpdatesResponse.verify(message.getUpdates);
                if (error)
                    return "getUpdates." + error;
            }
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                switch (message.errorCode) {
                default:
                    return "errorCode: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 100:
                    break;
                }
            if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                if (!$util.isString(message.errorMessage))
                    return "errorMessage: string expected";
            if (message.storeBirthday != null && message.hasOwnProperty("storeBirthday"))
                if (!$util.isString(message.storeBirthday))
                    return "storeBirthday: string expected";
            if (message.clientCommand != null && message.hasOwnProperty("clientCommand")) {
                let error = $root.sync_pb.ClientCommand.verify(message.clientCommand);
                if (error)
                    return "clientCommand." + error;
            }
            if (message.profilingData != null && message.hasOwnProperty("profilingData")) {
                let error = $root.sync_pb.ProfilingData.verify(message.profilingData);
                if (error)
                    return "profilingData." + error;
            }
            if (message.migratedDataTypeId != null && message.hasOwnProperty("migratedDataTypeId")) {
                if (!Array.isArray(message.migratedDataTypeId))
                    return "migratedDataTypeId: array expected";
                for (let i = 0; i < message.migratedDataTypeId.length; ++i)
                    if (!$util.isInteger(message.migratedDataTypeId[i]))
                        return "migratedDataTypeId: integer[] expected";
            }
            if (message.error != null && message.hasOwnProperty("error")) {
                let error = $root.sync_pb.ClientToServerResponse.Error.verify(message.error);
                if (error)
                    return "error." + error;
            }
            if (message.newBagOfChips != null && message.hasOwnProperty("newBagOfChips")) {
                let error = $root.sync_pb.ChipBag.verify(message.newBagOfChips);
                if (error)
                    return "newBagOfChips." + error;
            }
            if (message.clearServerData != null && message.hasOwnProperty("clearServerData")) {
                let error = $root.sync_pb.ClearServerDataResponse.verify(message.clearServerData);
                if (error)
                    return "clearServerData." + error;
            }
            return null;
        };

        /**
         * Creates a ClientToServerResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ClientToServerResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ClientToServerResponse} ClientToServerResponse
         */
        ClientToServerResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ClientToServerResponse)
                return object;
            let message = new $root.sync_pb.ClientToServerResponse();
            if (object.commit != null) {
                if (typeof object.commit !== "object")
                    throw TypeError(".sync_pb.ClientToServerResponse.commit: object expected");
                message.commit = $root.sync_pb.CommitResponse.fromObject(object.commit);
            }
            if (object.getUpdates != null) {
                if (typeof object.getUpdates !== "object")
                    throw TypeError(".sync_pb.ClientToServerResponse.getUpdates: object expected");
                message.getUpdates = $root.sync_pb.GetUpdatesResponse.fromObject(object.getUpdates);
            }
            switch (object.errorCode) {
            case "SUCCESS":
            case 0:
                message.errorCode = 0;
                break;
            case "DEPRECATED_ACCESS_DENIED":
            case 1:
                message.errorCode = 1;
                break;
            case "NOT_MY_BIRTHDAY":
            case 2:
                message.errorCode = 2;
                break;
            case "THROTTLED":
            case 3:
                message.errorCode = 3;
                break;
            case "DEPRECATED_AUTH_EXPIRED":
            case 4:
                message.errorCode = 4;
                break;
            case "DEPRECATED_USER_NOT_ACTIVATED":
            case 5:
                message.errorCode = 5;
                break;
            case "DEPRECATED_AUTH_INVALID":
            case 6:
                message.errorCode = 6;
                break;
            case "CLEAR_PENDING":
            case 7:
                message.errorCode = 7;
                break;
            case "TRANSIENT_ERROR":
            case 8:
                message.errorCode = 8;
                break;
            case "MIGRATION_DONE":
            case 9:
                message.errorCode = 9;
                break;
            case "DISABLED_BY_ADMIN":
            case 10:
                message.errorCode = 10;
                break;
            case "DEPRECATED_USER_ROLLBACK":
            case 11:
                message.errorCode = 11;
                break;
            case "PARTIAL_FAILURE":
            case 12:
                message.errorCode = 12;
                break;
            case "CLIENT_DATA_OBSOLETE":
            case 13:
                message.errorCode = 13;
                break;
            case "UNKNOWN":
            case 100:
                message.errorCode = 100;
                break;
            }
            if (object.errorMessage != null)
                message.errorMessage = String(object.errorMessage);
            if (object.storeBirthday != null)
                message.storeBirthday = String(object.storeBirthday);
            if (object.clientCommand != null) {
                if (typeof object.clientCommand !== "object")
                    throw TypeError(".sync_pb.ClientToServerResponse.clientCommand: object expected");
                message.clientCommand = $root.sync_pb.ClientCommand.fromObject(object.clientCommand);
            }
            if (object.profilingData != null) {
                if (typeof object.profilingData !== "object")
                    throw TypeError(".sync_pb.ClientToServerResponse.profilingData: object expected");
                message.profilingData = $root.sync_pb.ProfilingData.fromObject(object.profilingData);
            }
            if (object.migratedDataTypeId) {
                if (!Array.isArray(object.migratedDataTypeId))
                    throw TypeError(".sync_pb.ClientToServerResponse.migratedDataTypeId: array expected");
                message.migratedDataTypeId = [];
                for (let i = 0; i < object.migratedDataTypeId.length; ++i)
                    message.migratedDataTypeId[i] = object.migratedDataTypeId[i] | 0;
            }
            if (object.error != null) {
                if (typeof object.error !== "object")
                    throw TypeError(".sync_pb.ClientToServerResponse.error: object expected");
                message.error = $root.sync_pb.ClientToServerResponse.Error.fromObject(object.error);
            }
            if (object.newBagOfChips != null) {
                if (typeof object.newBagOfChips !== "object")
                    throw TypeError(".sync_pb.ClientToServerResponse.newBagOfChips: object expected");
                message.newBagOfChips = $root.sync_pb.ChipBag.fromObject(object.newBagOfChips);
            }
            if (object.clearServerData != null) {
                if (typeof object.clearServerData !== "object")
                    throw TypeError(".sync_pb.ClientToServerResponse.clearServerData: object expected");
                message.clearServerData = $root.sync_pb.ClearServerDataResponse.fromObject(object.clearServerData);
            }
            return message;
        };

        /**
         * Creates a plain object from a ClientToServerResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ClientToServerResponse
         * @static
         * @param {sync_pb.ClientToServerResponse} message ClientToServerResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClientToServerResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.migratedDataTypeId = [];
            if (options.defaults) {
                object.commit = null;
                object.getUpdates = null;
                object.errorCode = options.enums === String ? "UNKNOWN" : 100;
                object.errorMessage = "";
                object.storeBirthday = "";
                object.clientCommand = null;
                object.profilingData = null;
                object.error = null;
                object.newBagOfChips = null;
                object.clearServerData = null;
            }
            if (message.commit != null && message.hasOwnProperty("commit"))
                object.commit = $root.sync_pb.CommitResponse.toObject(message.commit, options);
            if (message.getUpdates != null && message.hasOwnProperty("getUpdates"))
                object.getUpdates = $root.sync_pb.GetUpdatesResponse.toObject(message.getUpdates, options);
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                object.errorCode = options.enums === String ? $root.sync_pb.SyncEnums.ErrorType[message.errorCode] : message.errorCode;
            if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                object.errorMessage = message.errorMessage;
            if (message.storeBirthday != null && message.hasOwnProperty("storeBirthday"))
                object.storeBirthday = message.storeBirthday;
            if (message.clientCommand != null && message.hasOwnProperty("clientCommand"))
                object.clientCommand = $root.sync_pb.ClientCommand.toObject(message.clientCommand, options);
            if (message.profilingData != null && message.hasOwnProperty("profilingData"))
                object.profilingData = $root.sync_pb.ProfilingData.toObject(message.profilingData, options);
            if (message.migratedDataTypeId && message.migratedDataTypeId.length) {
                object.migratedDataTypeId = [];
                for (let j = 0; j < message.migratedDataTypeId.length; ++j)
                    object.migratedDataTypeId[j] = message.migratedDataTypeId[j];
            }
            if (message.error != null && message.hasOwnProperty("error"))
                object.error = $root.sync_pb.ClientToServerResponse.Error.toObject(message.error, options);
            if (message.newBagOfChips != null && message.hasOwnProperty("newBagOfChips"))
                object.newBagOfChips = $root.sync_pb.ChipBag.toObject(message.newBagOfChips, options);
            if (message.clearServerData != null && message.hasOwnProperty("clearServerData"))
                object.clearServerData = $root.sync_pb.ClearServerDataResponse.toObject(message.clearServerData, options);
            return object;
        };

        /**
         * Converts this ClientToServerResponse to JSON.
         * @function toJSON
         * @memberof sync_pb.ClientToServerResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClientToServerResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        ClientToServerResponse.Error = (function() {

            /**
             * Properties of an Error.
             * @memberof sync_pb.ClientToServerResponse
             * @interface IError
             * @property {sync_pb.SyncEnums.ErrorType|null} [errorType] Error errorType
             * @property {string|null} [errorDescription] Error errorDescription
             * @property {string|null} [url] Error url
             * @property {sync_pb.SyncEnums.Action|null} [action] Error action
             * @property {Array.<number>|null} [errorDataTypeIds] Error errorDataTypeIds
             */

            /**
             * Constructs a new Error.
             * @memberof sync_pb.ClientToServerResponse
             * @classdesc Represents an Error.
             * @implements IError
             * @constructor
             * @param {sync_pb.ClientToServerResponse.IError=} [properties] Properties to set
             */
            function Error(properties) {
                this.errorDataTypeIds = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Error errorType.
             * @member {sync_pb.SyncEnums.ErrorType} errorType
             * @memberof sync_pb.ClientToServerResponse.Error
             * @instance
             */
            Error.prototype.errorType = 100;

            /**
             * Error errorDescription.
             * @member {string} errorDescription
             * @memberof sync_pb.ClientToServerResponse.Error
             * @instance
             */
            Error.prototype.errorDescription = "";

            /**
             * Error url.
             * @member {string} url
             * @memberof sync_pb.ClientToServerResponse.Error
             * @instance
             */
            Error.prototype.url = "";

            /**
             * Error action.
             * @member {sync_pb.SyncEnums.Action} action
             * @memberof sync_pb.ClientToServerResponse.Error
             * @instance
             */
            Error.prototype.action = 5;

            /**
             * Error errorDataTypeIds.
             * @member {Array.<number>} errorDataTypeIds
             * @memberof sync_pb.ClientToServerResponse.Error
             * @instance
             */
            Error.prototype.errorDataTypeIds = $util.emptyArray;

            /**
             * Creates a new Error instance using the specified properties.
             * @function create
             * @memberof sync_pb.ClientToServerResponse.Error
             * @static
             * @param {sync_pb.ClientToServerResponse.IError=} [properties] Properties to set
             * @returns {sync_pb.ClientToServerResponse.Error} Error instance
             */
            Error.create = function create(properties) {
                return new Error(properties);
            };

            /**
             * Encodes the specified Error message. Does not implicitly {@link sync_pb.ClientToServerResponse.Error.verify|verify} messages.
             * @function encode
             * @memberof sync_pb.ClientToServerResponse.Error
             * @static
             * @param {sync_pb.ClientToServerResponse.IError} message Error message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Error.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.errorType != null && Object.hasOwnProperty.call(message, "errorType"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errorType);
                if (message.errorDescription != null && Object.hasOwnProperty.call(message, "errorDescription"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.errorDescription);
                if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.url);
                if (message.action != null && Object.hasOwnProperty.call(message, "action"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.action);
                if (message.errorDataTypeIds != null && message.errorDataTypeIds.length)
                    for (let i = 0; i < message.errorDataTypeIds.length; ++i)
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.errorDataTypeIds[i]);
                return writer;
            };

            /**
             * Encodes the specified Error message, length delimited. Does not implicitly {@link sync_pb.ClientToServerResponse.Error.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync_pb.ClientToServerResponse.Error
             * @static
             * @param {sync_pb.ClientToServerResponse.IError} message Error message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Error.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Error message from the specified reader or buffer.
             * @function decode
             * @memberof sync_pb.ClientToServerResponse.Error
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync_pb.ClientToServerResponse.Error} Error
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Error.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ClientToServerResponse.Error();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.errorType = reader.int32();
                        break;
                    case 2:
                        message.errorDescription = reader.string();
                        break;
                    case 3:
                        message.url = reader.string();
                        break;
                    case 4:
                        message.action = reader.int32();
                        break;
                    case 5:
                        if (!(message.errorDataTypeIds && message.errorDataTypeIds.length))
                            message.errorDataTypeIds = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.errorDataTypeIds.push(reader.int32());
                        } else
                            message.errorDataTypeIds.push(reader.int32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Error message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync_pb.ClientToServerResponse.Error
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync_pb.ClientToServerResponse.Error} Error
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Error.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Error message.
             * @function verify
             * @memberof sync_pb.ClientToServerResponse.Error
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Error.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.errorType != null && message.hasOwnProperty("errorType"))
                    switch (message.errorType) {
                    default:
                        return "errorType: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 100:
                        break;
                    }
                if (message.errorDescription != null && message.hasOwnProperty("errorDescription"))
                    if (!$util.isString(message.errorDescription))
                        return "errorDescription: string expected";
                if (message.url != null && message.hasOwnProperty("url"))
                    if (!$util.isString(message.url))
                        return "url: string expected";
                if (message.action != null && message.hasOwnProperty("action"))
                    switch (message.action) {
                    default:
                        return "action: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    }
                if (message.errorDataTypeIds != null && message.hasOwnProperty("errorDataTypeIds")) {
                    if (!Array.isArray(message.errorDataTypeIds))
                        return "errorDataTypeIds: array expected";
                    for (let i = 0; i < message.errorDataTypeIds.length; ++i)
                        if (!$util.isInteger(message.errorDataTypeIds[i]))
                            return "errorDataTypeIds: integer[] expected";
                }
                return null;
            };

            /**
             * Creates an Error message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync_pb.ClientToServerResponse.Error
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync_pb.ClientToServerResponse.Error} Error
             */
            Error.fromObject = function fromObject(object) {
                if (object instanceof $root.sync_pb.ClientToServerResponse.Error)
                    return object;
                let message = new $root.sync_pb.ClientToServerResponse.Error();
                switch (object.errorType) {
                case "SUCCESS":
                case 0:
                    message.errorType = 0;
                    break;
                case "DEPRECATED_ACCESS_DENIED":
                case 1:
                    message.errorType = 1;
                    break;
                case "NOT_MY_BIRTHDAY":
                case 2:
                    message.errorType = 2;
                    break;
                case "THROTTLED":
                case 3:
                    message.errorType = 3;
                    break;
                case "DEPRECATED_AUTH_EXPIRED":
                case 4:
                    message.errorType = 4;
                    break;
                case "DEPRECATED_USER_NOT_ACTIVATED":
                case 5:
                    message.errorType = 5;
                    break;
                case "DEPRECATED_AUTH_INVALID":
                case 6:
                    message.errorType = 6;
                    break;
                case "CLEAR_PENDING":
                case 7:
                    message.errorType = 7;
                    break;
                case "TRANSIENT_ERROR":
                case 8:
                    message.errorType = 8;
                    break;
                case "MIGRATION_DONE":
                case 9:
                    message.errorType = 9;
                    break;
                case "DISABLED_BY_ADMIN":
                case 10:
                    message.errorType = 10;
                    break;
                case "DEPRECATED_USER_ROLLBACK":
                case 11:
                    message.errorType = 11;
                    break;
                case "PARTIAL_FAILURE":
                case 12:
                    message.errorType = 12;
                    break;
                case "CLIENT_DATA_OBSOLETE":
                case 13:
                    message.errorType = 13;
                    break;
                case "UNKNOWN":
                case 100:
                    message.errorType = 100;
                    break;
                }
                if (object.errorDescription != null)
                    message.errorDescription = String(object.errorDescription);
                if (object.url != null)
                    message.url = String(object.url);
                switch (object.action) {
                case "UPGRADE_CLIENT":
                case 0:
                    message.action = 0;
                    break;
                case "DEPRECATED_CLEAR_USER_DATA_AND_RESYNC":
                case 1:
                    message.action = 1;
                    break;
                case "DEPRECATED_ENABLE_SYNC_ON_ACCOUNT":
                case 2:
                    message.action = 2;
                    break;
                case "DEPRECATED_STOP_AND_RESTART_SYNC":
                case 3:
                    message.action = 3;
                    break;
                case "DEPRECATED_DISABLE_SYNC_ON_CLIENT":
                case 4:
                    message.action = 4;
                    break;
                case "UNKNOWN_ACTION":
                case 5:
                    message.action = 5;
                    break;
                }
                if (object.errorDataTypeIds) {
                    if (!Array.isArray(object.errorDataTypeIds))
                        throw TypeError(".sync_pb.ClientToServerResponse.Error.errorDataTypeIds: array expected");
                    message.errorDataTypeIds = [];
                    for (let i = 0; i < object.errorDataTypeIds.length; ++i)
                        message.errorDataTypeIds[i] = object.errorDataTypeIds[i] | 0;
                }
                return message;
            };

            /**
             * Creates a plain object from an Error message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync_pb.ClientToServerResponse.Error
             * @static
             * @param {sync_pb.ClientToServerResponse.Error} message Error
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Error.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.errorDataTypeIds = [];
                if (options.defaults) {
                    object.errorType = options.enums === String ? "UNKNOWN" : 100;
                    object.errorDescription = "";
                    object.url = "";
                    object.action = options.enums === String ? "UNKNOWN_ACTION" : 5;
                }
                if (message.errorType != null && message.hasOwnProperty("errorType"))
                    object.errorType = options.enums === String ? $root.sync_pb.SyncEnums.ErrorType[message.errorType] : message.errorType;
                if (message.errorDescription != null && message.hasOwnProperty("errorDescription"))
                    object.errorDescription = message.errorDescription;
                if (message.url != null && message.hasOwnProperty("url"))
                    object.url = message.url;
                if (message.action != null && message.hasOwnProperty("action"))
                    object.action = options.enums === String ? $root.sync_pb.SyncEnums.Action[message.action] : message.action;
                if (message.errorDataTypeIds && message.errorDataTypeIds.length) {
                    object.errorDataTypeIds = [];
                    for (let j = 0; j < message.errorDataTypeIds.length; ++j)
                        object.errorDataTypeIds[j] = message.errorDataTypeIds[j];
                }
                return object;
            };

            /**
             * Converts this Error to JSON.
             * @function toJSON
             * @memberof sync_pb.ClientToServerResponse.Error
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Error.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Error;
        })();

        return ClientToServerResponse;
    })();

    sync_pb.EventRequest = (function() {

        /**
         * Properties of an EventRequest.
         * @memberof sync_pb
         * @interface IEventRequest
         * @property {sync_pb.ISyncDisabledEvent|null} [syncDisabled] EventRequest syncDisabled
         */

        /**
         * Constructs a new EventRequest.
         * @memberof sync_pb
         * @classdesc Represents an EventRequest.
         * @implements IEventRequest
         * @constructor
         * @param {sync_pb.IEventRequest=} [properties] Properties to set
         */
        function EventRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EventRequest syncDisabled.
         * @member {sync_pb.ISyncDisabledEvent|null|undefined} syncDisabled
         * @memberof sync_pb.EventRequest
         * @instance
         */
        EventRequest.prototype.syncDisabled = null;

        /**
         * Creates a new EventRequest instance using the specified properties.
         * @function create
         * @memberof sync_pb.EventRequest
         * @static
         * @param {sync_pb.IEventRequest=} [properties] Properties to set
         * @returns {sync_pb.EventRequest} EventRequest instance
         */
        EventRequest.create = function create(properties) {
            return new EventRequest(properties);
        };

        /**
         * Encodes the specified EventRequest message. Does not implicitly {@link sync_pb.EventRequest.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.EventRequest
         * @static
         * @param {sync_pb.IEventRequest} message EventRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.syncDisabled != null && Object.hasOwnProperty.call(message, "syncDisabled"))
                $root.sync_pb.SyncDisabledEvent.encode(message.syncDisabled, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified EventRequest message, length delimited. Does not implicitly {@link sync_pb.EventRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.EventRequest
         * @static
         * @param {sync_pb.IEventRequest} message EventRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EventRequest message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.EventRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.EventRequest} EventRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.EventRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.syncDisabled = $root.sync_pb.SyncDisabledEvent.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EventRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.EventRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.EventRequest} EventRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EventRequest message.
         * @function verify
         * @memberof sync_pb.EventRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EventRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.syncDisabled != null && message.hasOwnProperty("syncDisabled")) {
                let error = $root.sync_pb.SyncDisabledEvent.verify(message.syncDisabled);
                if (error)
                    return "syncDisabled." + error;
            }
            return null;
        };

        /**
         * Creates an EventRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.EventRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.EventRequest} EventRequest
         */
        EventRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.EventRequest)
                return object;
            let message = new $root.sync_pb.EventRequest();
            if (object.syncDisabled != null) {
                if (typeof object.syncDisabled !== "object")
                    throw TypeError(".sync_pb.EventRequest.syncDisabled: object expected");
                message.syncDisabled = $root.sync_pb.SyncDisabledEvent.fromObject(object.syncDisabled);
            }
            return message;
        };

        /**
         * Creates a plain object from an EventRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.EventRequest
         * @static
         * @param {sync_pb.EventRequest} message EventRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EventRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.syncDisabled = null;
            if (message.syncDisabled != null && message.hasOwnProperty("syncDisabled"))
                object.syncDisabled = $root.sync_pb.SyncDisabledEvent.toObject(message.syncDisabled, options);
            return object;
        };

        /**
         * Converts this EventRequest to JSON.
         * @function toJSON
         * @memberof sync_pb.EventRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EventRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EventRequest;
    })();

    sync_pb.EventResponse = (function() {

        /**
         * Properties of an EventResponse.
         * @memberof sync_pb
         * @interface IEventResponse
         */

        /**
         * Constructs a new EventResponse.
         * @memberof sync_pb
         * @classdesc Represents an EventResponse.
         * @implements IEventResponse
         * @constructor
         * @param {sync_pb.IEventResponse=} [properties] Properties to set
         */
        function EventResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new EventResponse instance using the specified properties.
         * @function create
         * @memberof sync_pb.EventResponse
         * @static
         * @param {sync_pb.IEventResponse=} [properties] Properties to set
         * @returns {sync_pb.EventResponse} EventResponse instance
         */
        EventResponse.create = function create(properties) {
            return new EventResponse(properties);
        };

        /**
         * Encodes the specified EventResponse message. Does not implicitly {@link sync_pb.EventResponse.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.EventResponse
         * @static
         * @param {sync_pb.IEventResponse} message EventResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified EventResponse message, length delimited. Does not implicitly {@link sync_pb.EventResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.EventResponse
         * @static
         * @param {sync_pb.IEventResponse} message EventResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EventResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EventResponse message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.EventResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.EventResponse} EventResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.EventResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EventResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.EventResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.EventResponse} EventResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EventResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EventResponse message.
         * @function verify
         * @memberof sync_pb.EventResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EventResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an EventResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.EventResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.EventResponse} EventResponse
         */
        EventResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.EventResponse)
                return object;
            return new $root.sync_pb.EventResponse();
        };

        /**
         * Creates a plain object from an EventResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.EventResponse
         * @static
         * @param {sync_pb.EventResponse} message EventResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EventResponse.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this EventResponse to JSON.
         * @function toJSON
         * @memberof sync_pb.EventResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EventResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EventResponse;
    })();

    sync_pb.SyncDisabledEvent = (function() {

        /**
         * Properties of a SyncDisabledEvent.
         * @memberof sync_pb
         * @interface ISyncDisabledEvent
         * @property {string|null} [cacheGuid] SyncDisabledEvent cacheGuid
         * @property {string|null} [storeBirthday] SyncDisabledEvent storeBirthday
         */

        /**
         * Constructs a new SyncDisabledEvent.
         * @memberof sync_pb
         * @classdesc Represents a SyncDisabledEvent.
         * @implements ISyncDisabledEvent
         * @constructor
         * @param {sync_pb.ISyncDisabledEvent=} [properties] Properties to set
         */
        function SyncDisabledEvent(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncDisabledEvent cacheGuid.
         * @member {string} cacheGuid
         * @memberof sync_pb.SyncDisabledEvent
         * @instance
         */
        SyncDisabledEvent.prototype.cacheGuid = "";

        /**
         * SyncDisabledEvent storeBirthday.
         * @member {string} storeBirthday
         * @memberof sync_pb.SyncDisabledEvent
         * @instance
         */
        SyncDisabledEvent.prototype.storeBirthday = "";

        /**
         * Creates a new SyncDisabledEvent instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncDisabledEvent
         * @static
         * @param {sync_pb.ISyncDisabledEvent=} [properties] Properties to set
         * @returns {sync_pb.SyncDisabledEvent} SyncDisabledEvent instance
         */
        SyncDisabledEvent.create = function create(properties) {
            return new SyncDisabledEvent(properties);
        };

        /**
         * Encodes the specified SyncDisabledEvent message. Does not implicitly {@link sync_pb.SyncDisabledEvent.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncDisabledEvent
         * @static
         * @param {sync_pb.ISyncDisabledEvent} message SyncDisabledEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncDisabledEvent.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cacheGuid != null && Object.hasOwnProperty.call(message, "cacheGuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.cacheGuid);
            if (message.storeBirthday != null && Object.hasOwnProperty.call(message, "storeBirthday"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.storeBirthday);
            return writer;
        };

        /**
         * Encodes the specified SyncDisabledEvent message, length delimited. Does not implicitly {@link sync_pb.SyncDisabledEvent.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncDisabledEvent
         * @static
         * @param {sync_pb.ISyncDisabledEvent} message SyncDisabledEvent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncDisabledEvent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncDisabledEvent message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncDisabledEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncDisabledEvent} SyncDisabledEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncDisabledEvent.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncDisabledEvent();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.cacheGuid = reader.string();
                    break;
                case 2:
                    message.storeBirthday = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncDisabledEvent message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncDisabledEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncDisabledEvent} SyncDisabledEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncDisabledEvent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncDisabledEvent message.
         * @function verify
         * @memberof sync_pb.SyncDisabledEvent
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncDisabledEvent.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.cacheGuid != null && message.hasOwnProperty("cacheGuid"))
                if (!$util.isString(message.cacheGuid))
                    return "cacheGuid: string expected";
            if (message.storeBirthday != null && message.hasOwnProperty("storeBirthday"))
                if (!$util.isString(message.storeBirthday))
                    return "storeBirthday: string expected";
            return null;
        };

        /**
         * Creates a SyncDisabledEvent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncDisabledEvent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncDisabledEvent} SyncDisabledEvent
         */
        SyncDisabledEvent.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncDisabledEvent)
                return object;
            let message = new $root.sync_pb.SyncDisabledEvent();
            if (object.cacheGuid != null)
                message.cacheGuid = String(object.cacheGuid);
            if (object.storeBirthday != null)
                message.storeBirthday = String(object.storeBirthday);
            return message;
        };

        /**
         * Creates a plain object from a SyncDisabledEvent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncDisabledEvent
         * @static
         * @param {sync_pb.SyncDisabledEvent} message SyncDisabledEvent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncDisabledEvent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.cacheGuid = "";
                object.storeBirthday = "";
            }
            if (message.cacheGuid != null && message.hasOwnProperty("cacheGuid"))
                object.cacheGuid = message.cacheGuid;
            if (message.storeBirthday != null && message.hasOwnProperty("storeBirthday"))
                object.storeBirthday = message.storeBirthday;
            return object;
        };

        /**
         * Converts this SyncDisabledEvent to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncDisabledEvent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncDisabledEvent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncDisabledEvent;
    })();

    sync_pb.SyncEnums = (function() {

        /**
         * Properties of a SyncEnums.
         * @memberof sync_pb
         * @interface ISyncEnums
         */

        /**
         * Constructs a new SyncEnums.
         * @memberof sync_pb
         * @classdesc Represents a SyncEnums.
         * @implements ISyncEnums
         * @constructor
         * @param {sync_pb.ISyncEnums=} [properties] Properties to set
         */
        function SyncEnums(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SyncEnums instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncEnums
         * @static
         * @param {sync_pb.ISyncEnums=} [properties] Properties to set
         * @returns {sync_pb.SyncEnums} SyncEnums instance
         */
        SyncEnums.create = function create(properties) {
            return new SyncEnums(properties);
        };

        /**
         * Encodes the specified SyncEnums message. Does not implicitly {@link sync_pb.SyncEnums.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncEnums
         * @static
         * @param {sync_pb.ISyncEnums} message SyncEnums message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncEnums.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified SyncEnums message, length delimited. Does not implicitly {@link sync_pb.SyncEnums.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncEnums
         * @static
         * @param {sync_pb.ISyncEnums} message SyncEnums message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncEnums.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncEnums message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncEnums
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncEnums} SyncEnums
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncEnums.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncEnums();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncEnums message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncEnums
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncEnums} SyncEnums
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncEnums.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncEnums message.
         * @function verify
         * @memberof sync_pb.SyncEnums
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncEnums.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a SyncEnums message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncEnums
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncEnums} SyncEnums
         */
        SyncEnums.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncEnums)
                return object;
            return new $root.sync_pb.SyncEnums();
        };

        /**
         * Creates a plain object from a SyncEnums message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncEnums
         * @static
         * @param {sync_pb.SyncEnums} message SyncEnums
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncEnums.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SyncEnums to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncEnums
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncEnums.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * SingletonDebugEventType enum.
         * @name sync_pb.SyncEnums.SingletonDebugEventType
         * @enum {number}
         * @property {number} CONNECTION_STATUS_CHANGE=1 CONNECTION_STATUS_CHANGE value
         * @property {number} UPDATED_TOKEN=2 UPDATED_TOKEN value
         * @property {number} PASSPHRASE_REQUIRED=3 PASSPHRASE_REQUIRED value
         * @property {number} PASSPHRASE_ACCEPTED=4 PASSPHRASE_ACCEPTED value
         * @property {number} INITIALIZATION_COMPLETE=5 INITIALIZATION_COMPLETE value
         * @property {number} STOP_SYNCING_PERMANENTLY=6 STOP_SYNCING_PERMANENTLY value
         * @property {number} ENCRYPTION_COMPLETE=7 ENCRYPTION_COMPLETE value
         * @property {number} ACTIONABLE_ERROR=8 ACTIONABLE_ERROR value
         * @property {number} ENCRYPTED_TYPES_CHANGED=9 ENCRYPTED_TYPES_CHANGED value
         * @property {number} PASSPHRASE_TYPE_CHANGED=10 PASSPHRASE_TYPE_CHANGED value
         * @property {number} KEYSTORE_TOKEN_UPDATED=11 KEYSTORE_TOKEN_UPDATED value
         * @property {number} CONFIGURE_COMPLETE=12 CONFIGURE_COMPLETE value
         * @property {number} BOOTSTRAP_TOKEN_UPDATED=13 BOOTSTRAP_TOKEN_UPDATED value
         * @property {number} TRUSTED_VAULT_KEY_REQUIRED=14 TRUSTED_VAULT_KEY_REQUIRED value
         * @property {number} TRUSTED_VAULT_KEY_ACCEPTED=15 TRUSTED_VAULT_KEY_ACCEPTED value
         */
        SyncEnums.SingletonDebugEventType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "CONNECTION_STATUS_CHANGE"] = 1;
            values[valuesById[2] = "UPDATED_TOKEN"] = 2;
            values[valuesById[3] = "PASSPHRASE_REQUIRED"] = 3;
            values[valuesById[4] = "PASSPHRASE_ACCEPTED"] = 4;
            values[valuesById[5] = "INITIALIZATION_COMPLETE"] = 5;
            values[valuesById[6] = "STOP_SYNCING_PERMANENTLY"] = 6;
            values[valuesById[7] = "ENCRYPTION_COMPLETE"] = 7;
            values[valuesById[8] = "ACTIONABLE_ERROR"] = 8;
            values[valuesById[9] = "ENCRYPTED_TYPES_CHANGED"] = 9;
            values[valuesById[10] = "PASSPHRASE_TYPE_CHANGED"] = 10;
            values[valuesById[11] = "KEYSTORE_TOKEN_UPDATED"] = 11;
            values[valuesById[12] = "CONFIGURE_COMPLETE"] = 12;
            values[valuesById[13] = "BOOTSTRAP_TOKEN_UPDATED"] = 13;
            values[valuesById[14] = "TRUSTED_VAULT_KEY_REQUIRED"] = 14;
            values[valuesById[15] = "TRUSTED_VAULT_KEY_ACCEPTED"] = 15;
            return values;
        })();

        /**
         * PageTransition enum.
         * @name sync_pb.SyncEnums.PageTransition
         * @enum {number}
         * @property {number} LINK=0 LINK value
         * @property {number} TYPED=1 TYPED value
         * @property {number} AUTO_BOOKMARK=2 AUTO_BOOKMARK value
         * @property {number} AUTO_SUBFRAME=3 AUTO_SUBFRAME value
         * @property {number} MANUAL_SUBFRAME=4 MANUAL_SUBFRAME value
         * @property {number} GENERATED=5 GENERATED value
         * @property {number} AUTO_TOPLEVEL=6 AUTO_TOPLEVEL value
         * @property {number} FORM_SUBMIT=7 FORM_SUBMIT value
         * @property {number} RELOAD=8 RELOAD value
         * @property {number} KEYWORD=9 KEYWORD value
         * @property {number} KEYWORD_GENERATED=10 KEYWORD_GENERATED value
         */
        SyncEnums.PageTransition = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "LINK"] = 0;
            values[valuesById[1] = "TYPED"] = 1;
            values[valuesById[2] = "AUTO_BOOKMARK"] = 2;
            values[valuesById[3] = "AUTO_SUBFRAME"] = 3;
            values[valuesById[4] = "MANUAL_SUBFRAME"] = 4;
            values[valuesById[5] = "GENERATED"] = 5;
            values[valuesById[6] = "AUTO_TOPLEVEL"] = 6;
            values[valuesById[7] = "FORM_SUBMIT"] = 7;
            values[valuesById[8] = "RELOAD"] = 8;
            values[valuesById[9] = "KEYWORD"] = 9;
            values[valuesById[10] = "KEYWORD_GENERATED"] = 10;
            return values;
        })();

        /**
         * PageTransitionRedirectType enum.
         * @name sync_pb.SyncEnums.PageTransitionRedirectType
         * @enum {number}
         * @property {number} CLIENT_REDIRECT=1 CLIENT_REDIRECT value
         * @property {number} SERVER_REDIRECT=2 SERVER_REDIRECT value
         */
        SyncEnums.PageTransitionRedirectType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "CLIENT_REDIRECT"] = 1;
            values[valuesById[2] = "SERVER_REDIRECT"] = 2;
            return values;
        })();

        /**
         * ErrorType enum.
         * @name sync_pb.SyncEnums.ErrorType
         * @enum {number}
         * @property {number} SUCCESS=0 SUCCESS value
         * @property {number} DEPRECATED_ACCESS_DENIED=1 DEPRECATED_ACCESS_DENIED value
         * @property {number} NOT_MY_BIRTHDAY=2 NOT_MY_BIRTHDAY value
         * @property {number} THROTTLED=3 THROTTLED value
         * @property {number} DEPRECATED_AUTH_EXPIRED=4 DEPRECATED_AUTH_EXPIRED value
         * @property {number} DEPRECATED_USER_NOT_ACTIVATED=5 DEPRECATED_USER_NOT_ACTIVATED value
         * @property {number} DEPRECATED_AUTH_INVALID=6 DEPRECATED_AUTH_INVALID value
         * @property {number} CLEAR_PENDING=7 CLEAR_PENDING value
         * @property {number} TRANSIENT_ERROR=8 TRANSIENT_ERROR value
         * @property {number} MIGRATION_DONE=9 MIGRATION_DONE value
         * @property {number} DISABLED_BY_ADMIN=10 DISABLED_BY_ADMIN value
         * @property {number} DEPRECATED_USER_ROLLBACK=11 DEPRECATED_USER_ROLLBACK value
         * @property {number} PARTIAL_FAILURE=12 PARTIAL_FAILURE value
         * @property {number} CLIENT_DATA_OBSOLETE=13 CLIENT_DATA_OBSOLETE value
         * @property {number} UNKNOWN=100 UNKNOWN value
         */
        SyncEnums.ErrorType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SUCCESS"] = 0;
            values[valuesById[1] = "DEPRECATED_ACCESS_DENIED"] = 1;
            values[valuesById[2] = "NOT_MY_BIRTHDAY"] = 2;
            values[valuesById[3] = "THROTTLED"] = 3;
            values[valuesById[4] = "DEPRECATED_AUTH_EXPIRED"] = 4;
            values[valuesById[5] = "DEPRECATED_USER_NOT_ACTIVATED"] = 5;
            values[valuesById[6] = "DEPRECATED_AUTH_INVALID"] = 6;
            values[valuesById[7] = "CLEAR_PENDING"] = 7;
            values[valuesById[8] = "TRANSIENT_ERROR"] = 8;
            values[valuesById[9] = "MIGRATION_DONE"] = 9;
            values[valuesById[10] = "DISABLED_BY_ADMIN"] = 10;
            values[valuesById[11] = "DEPRECATED_USER_ROLLBACK"] = 11;
            values[valuesById[12] = "PARTIAL_FAILURE"] = 12;
            values[valuesById[13] = "CLIENT_DATA_OBSOLETE"] = 13;
            values[valuesById[100] = "UNKNOWN"] = 100;
            return values;
        })();

        /**
         * Action enum.
         * @name sync_pb.SyncEnums.Action
         * @enum {number}
         * @property {number} UPGRADE_CLIENT=0 UPGRADE_CLIENT value
         * @property {number} DEPRECATED_CLEAR_USER_DATA_AND_RESYNC=1 DEPRECATED_CLEAR_USER_DATA_AND_RESYNC value
         * @property {number} DEPRECATED_ENABLE_SYNC_ON_ACCOUNT=2 DEPRECATED_ENABLE_SYNC_ON_ACCOUNT value
         * @property {number} DEPRECATED_STOP_AND_RESTART_SYNC=3 DEPRECATED_STOP_AND_RESTART_SYNC value
         * @property {number} DEPRECATED_DISABLE_SYNC_ON_CLIENT=4 DEPRECATED_DISABLE_SYNC_ON_CLIENT value
         * @property {number} UNKNOWN_ACTION=5 UNKNOWN_ACTION value
         */
        SyncEnums.Action = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UPGRADE_CLIENT"] = 0;
            values[valuesById[1] = "DEPRECATED_CLEAR_USER_DATA_AND_RESYNC"] = 1;
            values[valuesById[2] = "DEPRECATED_ENABLE_SYNC_ON_ACCOUNT"] = 2;
            values[valuesById[3] = "DEPRECATED_STOP_AND_RESTART_SYNC"] = 3;
            values[valuesById[4] = "DEPRECATED_DISABLE_SYNC_ON_CLIENT"] = 4;
            values[valuesById[5] = "UNKNOWN_ACTION"] = 5;
            return values;
        })();

        /**
         * DeviceType enum.
         * @name sync_pb.SyncEnums.DeviceType
         * @enum {number}
         * @property {number} TYPE_UNSET=0 TYPE_UNSET value
         * @property {number} TYPE_WIN=1 TYPE_WIN value
         * @property {number} TYPE_MAC=2 TYPE_MAC value
         * @property {number} TYPE_LINUX=3 TYPE_LINUX value
         * @property {number} TYPE_CROS=4 TYPE_CROS value
         * @property {number} TYPE_OTHER=5 TYPE_OTHER value
         * @property {number} TYPE_PHONE=6 TYPE_PHONE value
         * @property {number} TYPE_TABLET=7 TYPE_TABLET value
         */
        SyncEnums.DeviceType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "TYPE_UNSET"] = 0;
            values[valuesById[1] = "TYPE_WIN"] = 1;
            values[valuesById[2] = "TYPE_MAC"] = 2;
            values[valuesById[3] = "TYPE_LINUX"] = 3;
            values[valuesById[4] = "TYPE_CROS"] = 4;
            values[valuesById[5] = "TYPE_OTHER"] = 5;
            values[valuesById[6] = "TYPE_PHONE"] = 6;
            values[valuesById[7] = "TYPE_TABLET"] = 7;
            return values;
        })();

        /**
         * GetUpdatesOrigin enum.
         * @name sync_pb.SyncEnums.GetUpdatesOrigin
         * @enum {number}
         * @property {number} UNKNOWN_ORIGIN=0 UNKNOWN_ORIGIN value
         * @property {number} PERIODIC=4 PERIODIC value
         * @property {number} NEWLY_SUPPORTED_DATATYPE=7 NEWLY_SUPPORTED_DATATYPE value
         * @property {number} MIGRATION=8 MIGRATION value
         * @property {number} NEW_CLIENT=9 NEW_CLIENT value
         * @property {number} RECONFIGURATION=10 RECONFIGURATION value
         * @property {number} GU_TRIGGER=12 GU_TRIGGER value
         * @property {number} RETRY=13 RETRY value
         * @property {number} PROGRAMMATIC=14 PROGRAMMATIC value
         */
        SyncEnums.GetUpdatesOrigin = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN_ORIGIN"] = 0;
            values[valuesById[4] = "PERIODIC"] = 4;
            values[valuesById[7] = "NEWLY_SUPPORTED_DATATYPE"] = 7;
            values[valuesById[8] = "MIGRATION"] = 8;
            values[valuesById[9] = "NEW_CLIENT"] = 9;
            values[valuesById[10] = "RECONFIGURATION"] = 10;
            values[valuesById[12] = "GU_TRIGGER"] = 12;
            values[valuesById[13] = "RETRY"] = 13;
            values[valuesById[14] = "PROGRAMMATIC"] = 14;
            return values;
        })();

        return SyncEnums;
    })();

    sync_pb.TypedUrlSpecifics = (function() {

        /**
         * Properties of a TypedUrlSpecifics.
         * @memberof sync_pb
         * @interface ITypedUrlSpecifics
         * @property {string|null} [url] TypedUrlSpecifics url
         * @property {string|null} [title] TypedUrlSpecifics title
         * @property {boolean|null} [hidden] TypedUrlSpecifics hidden
         * @property {Array.<number|Long>|null} [visits] TypedUrlSpecifics visits
         * @property {Array.<number>|null} [visitTransitions] TypedUrlSpecifics visitTransitions
         */

        /**
         * Constructs a new TypedUrlSpecifics.
         * @memberof sync_pb
         * @classdesc Represents a TypedUrlSpecifics.
         * @implements ITypedUrlSpecifics
         * @constructor
         * @param {sync_pb.ITypedUrlSpecifics=} [properties] Properties to set
         */
        function TypedUrlSpecifics(properties) {
            this.visits = [];
            this.visitTransitions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TypedUrlSpecifics url.
         * @member {string} url
         * @memberof sync_pb.TypedUrlSpecifics
         * @instance
         */
        TypedUrlSpecifics.prototype.url = "";

        /**
         * TypedUrlSpecifics title.
         * @member {string} title
         * @memberof sync_pb.TypedUrlSpecifics
         * @instance
         */
        TypedUrlSpecifics.prototype.title = "";

        /**
         * TypedUrlSpecifics hidden.
         * @member {boolean} hidden
         * @memberof sync_pb.TypedUrlSpecifics
         * @instance
         */
        TypedUrlSpecifics.prototype.hidden = false;

        /**
         * TypedUrlSpecifics visits.
         * @member {Array.<number|Long>} visits
         * @memberof sync_pb.TypedUrlSpecifics
         * @instance
         */
        TypedUrlSpecifics.prototype.visits = $util.emptyArray;

        /**
         * TypedUrlSpecifics visitTransitions.
         * @member {Array.<number>} visitTransitions
         * @memberof sync_pb.TypedUrlSpecifics
         * @instance
         */
        TypedUrlSpecifics.prototype.visitTransitions = $util.emptyArray;

        /**
         * Creates a new TypedUrlSpecifics instance using the specified properties.
         * @function create
         * @memberof sync_pb.TypedUrlSpecifics
         * @static
         * @param {sync_pb.ITypedUrlSpecifics=} [properties] Properties to set
         * @returns {sync_pb.TypedUrlSpecifics} TypedUrlSpecifics instance
         */
        TypedUrlSpecifics.create = function create(properties) {
            return new TypedUrlSpecifics(properties);
        };

        /**
         * Encodes the specified TypedUrlSpecifics message. Does not implicitly {@link sync_pb.TypedUrlSpecifics.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.TypedUrlSpecifics
         * @static
         * @param {sync_pb.ITypedUrlSpecifics} message TypedUrlSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TypedUrlSpecifics.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.url);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.hidden != null && Object.hasOwnProperty.call(message, "hidden"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.hidden);
            if (message.visits != null && message.visits.length) {
                writer.uint32(/* id 7, wireType 2 =*/58).fork();
                for (let i = 0; i < message.visits.length; ++i)
                    writer.int64(message.visits[i]);
                writer.ldelim();
            }
            if (message.visitTransitions != null && message.visitTransitions.length) {
                writer.uint32(/* id 8, wireType 2 =*/66).fork();
                for (let i = 0; i < message.visitTransitions.length; ++i)
                    writer.int32(message.visitTransitions[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified TypedUrlSpecifics message, length delimited. Does not implicitly {@link sync_pb.TypedUrlSpecifics.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.TypedUrlSpecifics
         * @static
         * @param {sync_pb.ITypedUrlSpecifics} message TypedUrlSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TypedUrlSpecifics.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TypedUrlSpecifics message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.TypedUrlSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.TypedUrlSpecifics} TypedUrlSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TypedUrlSpecifics.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.TypedUrlSpecifics();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.url = reader.string();
                    break;
                case 2:
                    message.title = reader.string();
                    break;
                case 4:
                    message.hidden = reader.bool();
                    break;
                case 7:
                    if (!(message.visits && message.visits.length))
                        message.visits = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.visits.push(reader.int64());
                    } else
                        message.visits.push(reader.int64());
                    break;
                case 8:
                    if (!(message.visitTransitions && message.visitTransitions.length))
                        message.visitTransitions = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.visitTransitions.push(reader.int32());
                    } else
                        message.visitTransitions.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TypedUrlSpecifics message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.TypedUrlSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.TypedUrlSpecifics} TypedUrlSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TypedUrlSpecifics.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TypedUrlSpecifics message.
         * @function verify
         * @memberof sync_pb.TypedUrlSpecifics
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TypedUrlSpecifics.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.hidden != null && message.hasOwnProperty("hidden"))
                if (typeof message.hidden !== "boolean")
                    return "hidden: boolean expected";
            if (message.visits != null && message.hasOwnProperty("visits")) {
                if (!Array.isArray(message.visits))
                    return "visits: array expected";
                for (let i = 0; i < message.visits.length; ++i)
                    if (!$util.isInteger(message.visits[i]) && !(message.visits[i] && $util.isInteger(message.visits[i].low) && $util.isInteger(message.visits[i].high)))
                        return "visits: integer|Long[] expected";
            }
            if (message.visitTransitions != null && message.hasOwnProperty("visitTransitions")) {
                if (!Array.isArray(message.visitTransitions))
                    return "visitTransitions: array expected";
                for (let i = 0; i < message.visitTransitions.length; ++i)
                    if (!$util.isInteger(message.visitTransitions[i]))
                        return "visitTransitions: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a TypedUrlSpecifics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.TypedUrlSpecifics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.TypedUrlSpecifics} TypedUrlSpecifics
         */
        TypedUrlSpecifics.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.TypedUrlSpecifics)
                return object;
            let message = new $root.sync_pb.TypedUrlSpecifics();
            if (object.url != null)
                message.url = String(object.url);
            if (object.title != null)
                message.title = String(object.title);
            if (object.hidden != null)
                message.hidden = Boolean(object.hidden);
            if (object.visits) {
                if (!Array.isArray(object.visits))
                    throw TypeError(".sync_pb.TypedUrlSpecifics.visits: array expected");
                message.visits = [];
                for (let i = 0; i < object.visits.length; ++i)
                    if ($util.Long)
                        (message.visits[i] = $util.Long.fromValue(object.visits[i])).unsigned = false;
                    else if (typeof object.visits[i] === "string")
                        message.visits[i] = parseInt(object.visits[i], 10);
                    else if (typeof object.visits[i] === "number")
                        message.visits[i] = object.visits[i];
                    else if (typeof object.visits[i] === "object")
                        message.visits[i] = new $util.LongBits(object.visits[i].low >>> 0, object.visits[i].high >>> 0).toNumber();
            }
            if (object.visitTransitions) {
                if (!Array.isArray(object.visitTransitions))
                    throw TypeError(".sync_pb.TypedUrlSpecifics.visitTransitions: array expected");
                message.visitTransitions = [];
                for (let i = 0; i < object.visitTransitions.length; ++i)
                    message.visitTransitions[i] = object.visitTransitions[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a TypedUrlSpecifics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.TypedUrlSpecifics
         * @static
         * @param {sync_pb.TypedUrlSpecifics} message TypedUrlSpecifics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TypedUrlSpecifics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.visits = [];
                object.visitTransitions = [];
            }
            if (options.defaults) {
                object.url = "";
                object.title = "";
                object.hidden = false;
            }
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.hidden != null && message.hasOwnProperty("hidden"))
                object.hidden = message.hidden;
            if (message.visits && message.visits.length) {
                object.visits = [];
                for (let j = 0; j < message.visits.length; ++j)
                    if (typeof message.visits[j] === "number")
                        object.visits[j] = options.longs === String ? String(message.visits[j]) : message.visits[j];
                    else
                        object.visits[j] = options.longs === String ? $util.Long.prototype.toString.call(message.visits[j]) : options.longs === Number ? new $util.LongBits(message.visits[j].low >>> 0, message.visits[j].high >>> 0).toNumber() : message.visits[j];
            }
            if (message.visitTransitions && message.visitTransitions.length) {
                object.visitTransitions = [];
                for (let j = 0; j < message.visitTransitions.length; ++j)
                    object.visitTransitions[j] = message.visitTransitions[j];
            }
            return object;
        };

        /**
         * Converts this TypedUrlSpecifics to JSON.
         * @function toJSON
         * @memberof sync_pb.TypedUrlSpecifics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TypedUrlSpecifics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TypedUrlSpecifics;
    })();

    sync_pb.NigoriKey = (function() {

        /**
         * Properties of a NigoriKey.
         * @memberof sync_pb
         * @interface INigoriKey
         * @property {string|null} [deprecatedName] NigoriKey deprecatedName
         * @property {Uint8Array|null} [deprecatedUserKey] NigoriKey deprecatedUserKey
         * @property {Uint8Array|null} [encryptionKey] NigoriKey encryptionKey
         * @property {Uint8Array|null} [macKey] NigoriKey macKey
         */

        /**
         * Constructs a new NigoriKey.
         * @memberof sync_pb
         * @classdesc Represents a NigoriKey.
         * @implements INigoriKey
         * @constructor
         * @param {sync_pb.INigoriKey=} [properties] Properties to set
         */
        function NigoriKey(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NigoriKey deprecatedName.
         * @member {string} deprecatedName
         * @memberof sync_pb.NigoriKey
         * @instance
         */
        NigoriKey.prototype.deprecatedName = "";

        /**
         * NigoriKey deprecatedUserKey.
         * @member {Uint8Array} deprecatedUserKey
         * @memberof sync_pb.NigoriKey
         * @instance
         */
        NigoriKey.prototype.deprecatedUserKey = $util.newBuffer([]);

        /**
         * NigoriKey encryptionKey.
         * @member {Uint8Array} encryptionKey
         * @memberof sync_pb.NigoriKey
         * @instance
         */
        NigoriKey.prototype.encryptionKey = $util.newBuffer([]);

        /**
         * NigoriKey macKey.
         * @member {Uint8Array} macKey
         * @memberof sync_pb.NigoriKey
         * @instance
         */
        NigoriKey.prototype.macKey = $util.newBuffer([]);

        /**
         * Creates a new NigoriKey instance using the specified properties.
         * @function create
         * @memberof sync_pb.NigoriKey
         * @static
         * @param {sync_pb.INigoriKey=} [properties] Properties to set
         * @returns {sync_pb.NigoriKey} NigoriKey instance
         */
        NigoriKey.create = function create(properties) {
            return new NigoriKey(properties);
        };

        /**
         * Encodes the specified NigoriKey message. Does not implicitly {@link sync_pb.NigoriKey.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.NigoriKey
         * @static
         * @param {sync_pb.INigoriKey} message NigoriKey message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NigoriKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.deprecatedName != null && Object.hasOwnProperty.call(message, "deprecatedName"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.deprecatedName);
            if (message.deprecatedUserKey != null && Object.hasOwnProperty.call(message, "deprecatedUserKey"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.deprecatedUserKey);
            if (message.encryptionKey != null && Object.hasOwnProperty.call(message, "encryptionKey"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.encryptionKey);
            if (message.macKey != null && Object.hasOwnProperty.call(message, "macKey"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.macKey);
            return writer;
        };

        /**
         * Encodes the specified NigoriKey message, length delimited. Does not implicitly {@link sync_pb.NigoriKey.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.NigoriKey
         * @static
         * @param {sync_pb.INigoriKey} message NigoriKey message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NigoriKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NigoriKey message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.NigoriKey
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.NigoriKey} NigoriKey
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NigoriKey.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.NigoriKey();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.deprecatedName = reader.string();
                    break;
                case 2:
                    message.deprecatedUserKey = reader.bytes();
                    break;
                case 3:
                    message.encryptionKey = reader.bytes();
                    break;
                case 4:
                    message.macKey = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NigoriKey message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.NigoriKey
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.NigoriKey} NigoriKey
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NigoriKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NigoriKey message.
         * @function verify
         * @memberof sync_pb.NigoriKey
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NigoriKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.deprecatedName != null && message.hasOwnProperty("deprecatedName"))
                if (!$util.isString(message.deprecatedName))
                    return "deprecatedName: string expected";
            if (message.deprecatedUserKey != null && message.hasOwnProperty("deprecatedUserKey"))
                if (!(message.deprecatedUserKey && typeof message.deprecatedUserKey.length === "number" || $util.isString(message.deprecatedUserKey)))
                    return "deprecatedUserKey: buffer expected";
            if (message.encryptionKey != null && message.hasOwnProperty("encryptionKey"))
                if (!(message.encryptionKey && typeof message.encryptionKey.length === "number" || $util.isString(message.encryptionKey)))
                    return "encryptionKey: buffer expected";
            if (message.macKey != null && message.hasOwnProperty("macKey"))
                if (!(message.macKey && typeof message.macKey.length === "number" || $util.isString(message.macKey)))
                    return "macKey: buffer expected";
            return null;
        };

        /**
         * Creates a NigoriKey message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.NigoriKey
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.NigoriKey} NigoriKey
         */
        NigoriKey.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.NigoriKey)
                return object;
            let message = new $root.sync_pb.NigoriKey();
            if (object.deprecatedName != null)
                message.deprecatedName = String(object.deprecatedName);
            if (object.deprecatedUserKey != null)
                if (typeof object.deprecatedUserKey === "string")
                    $util.base64.decode(object.deprecatedUserKey, message.deprecatedUserKey = $util.newBuffer($util.base64.length(object.deprecatedUserKey)), 0);
                else if (object.deprecatedUserKey.length)
                    message.deprecatedUserKey = object.deprecatedUserKey;
            if (object.encryptionKey != null)
                if (typeof object.encryptionKey === "string")
                    $util.base64.decode(object.encryptionKey, message.encryptionKey = $util.newBuffer($util.base64.length(object.encryptionKey)), 0);
                else if (object.encryptionKey.length)
                    message.encryptionKey = object.encryptionKey;
            if (object.macKey != null)
                if (typeof object.macKey === "string")
                    $util.base64.decode(object.macKey, message.macKey = $util.newBuffer($util.base64.length(object.macKey)), 0);
                else if (object.macKey.length)
                    message.macKey = object.macKey;
            return message;
        };

        /**
         * Creates a plain object from a NigoriKey message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.NigoriKey
         * @static
         * @param {sync_pb.NigoriKey} message NigoriKey
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NigoriKey.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.deprecatedName = "";
                if (options.bytes === String)
                    object.deprecatedUserKey = "";
                else {
                    object.deprecatedUserKey = [];
                    if (options.bytes !== Array)
                        object.deprecatedUserKey = $util.newBuffer(object.deprecatedUserKey);
                }
                if (options.bytes === String)
                    object.encryptionKey = "";
                else {
                    object.encryptionKey = [];
                    if (options.bytes !== Array)
                        object.encryptionKey = $util.newBuffer(object.encryptionKey);
                }
                if (options.bytes === String)
                    object.macKey = "";
                else {
                    object.macKey = [];
                    if (options.bytes !== Array)
                        object.macKey = $util.newBuffer(object.macKey);
                }
            }
            if (message.deprecatedName != null && message.hasOwnProperty("deprecatedName"))
                object.deprecatedName = message.deprecatedName;
            if (message.deprecatedUserKey != null && message.hasOwnProperty("deprecatedUserKey"))
                object.deprecatedUserKey = options.bytes === String ? $util.base64.encode(message.deprecatedUserKey, 0, message.deprecatedUserKey.length) : options.bytes === Array ? Array.prototype.slice.call(message.deprecatedUserKey) : message.deprecatedUserKey;
            if (message.encryptionKey != null && message.hasOwnProperty("encryptionKey"))
                object.encryptionKey = options.bytes === String ? $util.base64.encode(message.encryptionKey, 0, message.encryptionKey.length) : options.bytes === Array ? Array.prototype.slice.call(message.encryptionKey) : message.encryptionKey;
            if (message.macKey != null && message.hasOwnProperty("macKey"))
                object.macKey = options.bytes === String ? $util.base64.encode(message.macKey, 0, message.macKey.length) : options.bytes === Array ? Array.prototype.slice.call(message.macKey) : message.macKey;
            return object;
        };

        /**
         * Converts this NigoriKey to JSON.
         * @function toJSON
         * @memberof sync_pb.NigoriKey
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NigoriKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NigoriKey;
    })();

    sync_pb.NigoriKeyBag = (function() {

        /**
         * Properties of a NigoriKeyBag.
         * @memberof sync_pb
         * @interface INigoriKeyBag
         * @property {Array.<sync_pb.INigoriKey>|null} [key] NigoriKeyBag key
         */

        /**
         * Constructs a new NigoriKeyBag.
         * @memberof sync_pb
         * @classdesc Represents a NigoriKeyBag.
         * @implements INigoriKeyBag
         * @constructor
         * @param {sync_pb.INigoriKeyBag=} [properties] Properties to set
         */
        function NigoriKeyBag(properties) {
            this.key = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NigoriKeyBag key.
         * @member {Array.<sync_pb.INigoriKey>} key
         * @memberof sync_pb.NigoriKeyBag
         * @instance
         */
        NigoriKeyBag.prototype.key = $util.emptyArray;

        /**
         * Creates a new NigoriKeyBag instance using the specified properties.
         * @function create
         * @memberof sync_pb.NigoriKeyBag
         * @static
         * @param {sync_pb.INigoriKeyBag=} [properties] Properties to set
         * @returns {sync_pb.NigoriKeyBag} NigoriKeyBag instance
         */
        NigoriKeyBag.create = function create(properties) {
            return new NigoriKeyBag(properties);
        };

        /**
         * Encodes the specified NigoriKeyBag message. Does not implicitly {@link sync_pb.NigoriKeyBag.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.NigoriKeyBag
         * @static
         * @param {sync_pb.INigoriKeyBag} message NigoriKeyBag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NigoriKeyBag.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.key != null && message.key.length)
                for (let i = 0; i < message.key.length; ++i)
                    $root.sync_pb.NigoriKey.encode(message.key[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified NigoriKeyBag message, length delimited. Does not implicitly {@link sync_pb.NigoriKeyBag.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.NigoriKeyBag
         * @static
         * @param {sync_pb.INigoriKeyBag} message NigoriKeyBag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NigoriKeyBag.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NigoriKeyBag message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.NigoriKeyBag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.NigoriKeyBag} NigoriKeyBag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NigoriKeyBag.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.NigoriKeyBag();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    if (!(message.key && message.key.length))
                        message.key = [];
                    message.key.push($root.sync_pb.NigoriKey.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NigoriKeyBag message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.NigoriKeyBag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.NigoriKeyBag} NigoriKeyBag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NigoriKeyBag.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NigoriKeyBag message.
         * @function verify
         * @memberof sync_pb.NigoriKeyBag
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NigoriKeyBag.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!Array.isArray(message.key))
                    return "key: array expected";
                for (let i = 0; i < message.key.length; ++i) {
                    let error = $root.sync_pb.NigoriKey.verify(message.key[i]);
                    if (error)
                        return "key." + error;
                }
            }
            return null;
        };

        /**
         * Creates a NigoriKeyBag message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.NigoriKeyBag
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.NigoriKeyBag} NigoriKeyBag
         */
        NigoriKeyBag.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.NigoriKeyBag)
                return object;
            let message = new $root.sync_pb.NigoriKeyBag();
            if (object.key) {
                if (!Array.isArray(object.key))
                    throw TypeError(".sync_pb.NigoriKeyBag.key: array expected");
                message.key = [];
                for (let i = 0; i < object.key.length; ++i) {
                    if (typeof object.key[i] !== "object")
                        throw TypeError(".sync_pb.NigoriKeyBag.key: object expected");
                    message.key[i] = $root.sync_pb.NigoriKey.fromObject(object.key[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a NigoriKeyBag message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.NigoriKeyBag
         * @static
         * @param {sync_pb.NigoriKeyBag} message NigoriKeyBag
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NigoriKeyBag.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.key = [];
            if (message.key && message.key.length) {
                object.key = [];
                for (let j = 0; j < message.key.length; ++j)
                    object.key[j] = $root.sync_pb.NigoriKey.toObject(message.key[j], options);
            }
            return object;
        };

        /**
         * Converts this NigoriKeyBag to JSON.
         * @function toJSON
         * @memberof sync_pb.NigoriKeyBag
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NigoriKeyBag.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NigoriKeyBag;
    })();

    sync_pb.NigoriSpecifics = (function() {

        /**
         * Properties of a NigoriSpecifics.
         * @memberof sync_pb
         * @interface INigoriSpecifics
         * @property {sync_pb.IEncryptedData|null} [encryptionKeybag] NigoriSpecifics encryptionKeybag
         * @property {boolean|null} [keybagIsFrozen] NigoriSpecifics keybagIsFrozen
         * @property {boolean|null} [encryptBookmarks] NigoriSpecifics encryptBookmarks
         * @property {boolean|null} [encryptPreferences] NigoriSpecifics encryptPreferences
         * @property {boolean|null} [encryptAutofillProfile] NigoriSpecifics encryptAutofillProfile
         * @property {boolean|null} [encryptAutofill] NigoriSpecifics encryptAutofill
         * @property {boolean|null} [encryptThemes] NigoriSpecifics encryptThemes
         * @property {boolean|null} [encryptTypedUrls] NigoriSpecifics encryptTypedUrls
         * @property {boolean|null} [encryptExtensions] NigoriSpecifics encryptExtensions
         * @property {boolean|null} [encryptSessions] NigoriSpecifics encryptSessions
         * @property {boolean|null} [encryptApps] NigoriSpecifics encryptApps
         * @property {boolean|null} [encryptSearchEngines] NigoriSpecifics encryptSearchEngines
         * @property {boolean|null} [encryptEverything] NigoriSpecifics encryptEverything
         * @property {boolean|null} [encryptExtensionSettings] NigoriSpecifics encryptExtensionSettings
         * @property {boolean|null} [encryptAppNotifications] NigoriSpecifics encryptAppNotifications
         * @property {boolean|null} [encryptAppSettings] NigoriSpecifics encryptAppSettings
         * @property {boolean|null} [syncTabFavicons] NigoriSpecifics syncTabFavicons
         * @property {number|null} [passphraseType] NigoriSpecifics passphraseType
         * @property {sync_pb.IEncryptedData|null} [keystoreDecryptorToken] NigoriSpecifics keystoreDecryptorToken
         * @property {number|Long|null} [keystoreMigrationTime] NigoriSpecifics keystoreMigrationTime
         * @property {number|Long|null} [customPassphraseTime] NigoriSpecifics customPassphraseTime
         * @property {boolean|null} [encryptDictionary] NigoriSpecifics encryptDictionary
         * @property {boolean|null} [encryptFaviconImages] NigoriSpecifics encryptFaviconImages
         * @property {boolean|null} [encryptFaviconTracking] NigoriSpecifics encryptFaviconTracking
         * @property {boolean|null} [encryptAppList] NigoriSpecifics encryptAppList
         * @property {boolean|null} [encryptAutofillWalletMetadata] NigoriSpecifics encryptAutofillWalletMetadata
         * @property {boolean|null} [serverOnlyWasMissingKeystoreMigrationTime] NigoriSpecifics serverOnlyWasMissingKeystoreMigrationTime
         * @property {boolean|null} [encryptArcPackage] NigoriSpecifics encryptArcPackage
         * @property {boolean|null} [encryptPrinters] NigoriSpecifics encryptPrinters
         * @property {boolean|null} [encryptReadingList] NigoriSpecifics encryptReadingList
         * @property {boolean|null} [encryptMountainShares] NigoriSpecifics encryptMountainShares
         * @property {number|null} [customPassphraseKeyDerivationMethod] NigoriSpecifics customPassphraseKeyDerivationMethod
         * @property {string|null} [customPassphraseKeyDerivationSalt] NigoriSpecifics customPassphraseKeyDerivationSalt
         * @property {boolean|null} [encryptSendTabToSelf] NigoriSpecifics encryptSendTabToSelf
         * @property {boolean|null} [encryptWebApps] NigoriSpecifics encryptWebApps
         * @property {boolean|null} [encryptOsPreferences] NigoriSpecifics encryptOsPreferences
         * @property {sync_pb.IEncryptedData|null} [operaEncryptionKeybag] NigoriSpecifics operaEncryptionKeybag
         * @property {boolean|null} [operaKeybagIsFrozen] NigoriSpecifics operaKeybagIsFrozen
         * @property {number|Long|null} [operaCustomPassphraseTime] NigoriSpecifics operaCustomPassphraseTime
         * @property {sync_pb.IEncryptedData|null} [opEncryptionKeybag] NigoriSpecifics opEncryptionKeybag
         * @property {boolean|null} [opKeybagIsFrozen] NigoriSpecifics opKeybagIsFrozen
         * @property {number|Long|null} [opCustomPassphraseTime] NigoriSpecifics opCustomPassphraseTime
         */

        /**
         * Constructs a new NigoriSpecifics.
         * @memberof sync_pb
         * @classdesc Represents a NigoriSpecifics.
         * @implements INigoriSpecifics
         * @constructor
         * @param {sync_pb.INigoriSpecifics=} [properties] Properties to set
         */
        function NigoriSpecifics(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NigoriSpecifics encryptionKeybag.
         * @member {sync_pb.IEncryptedData|null|undefined} encryptionKeybag
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptionKeybag = null;

        /**
         * NigoriSpecifics keybagIsFrozen.
         * @member {boolean} keybagIsFrozen
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.keybagIsFrozen = false;

        /**
         * NigoriSpecifics encryptBookmarks.
         * @member {boolean} encryptBookmarks
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptBookmarks = false;

        /**
         * NigoriSpecifics encryptPreferences.
         * @member {boolean} encryptPreferences
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptPreferences = false;

        /**
         * NigoriSpecifics encryptAutofillProfile.
         * @member {boolean} encryptAutofillProfile
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptAutofillProfile = false;

        /**
         * NigoriSpecifics encryptAutofill.
         * @member {boolean} encryptAutofill
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptAutofill = false;

        /**
         * NigoriSpecifics encryptThemes.
         * @member {boolean} encryptThemes
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptThemes = false;

        /**
         * NigoriSpecifics encryptTypedUrls.
         * @member {boolean} encryptTypedUrls
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptTypedUrls = false;

        /**
         * NigoriSpecifics encryptExtensions.
         * @member {boolean} encryptExtensions
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptExtensions = false;

        /**
         * NigoriSpecifics encryptSessions.
         * @member {boolean} encryptSessions
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptSessions = false;

        /**
         * NigoriSpecifics encryptApps.
         * @member {boolean} encryptApps
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptApps = false;

        /**
         * NigoriSpecifics encryptSearchEngines.
         * @member {boolean} encryptSearchEngines
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptSearchEngines = false;

        /**
         * NigoriSpecifics encryptEverything.
         * @member {boolean} encryptEverything
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptEverything = false;

        /**
         * NigoriSpecifics encryptExtensionSettings.
         * @member {boolean} encryptExtensionSettings
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptExtensionSettings = false;

        /**
         * NigoriSpecifics encryptAppNotifications.
         * @member {boolean} encryptAppNotifications
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptAppNotifications = false;

        /**
         * NigoriSpecifics encryptAppSettings.
         * @member {boolean} encryptAppSettings
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptAppSettings = false;

        /**
         * NigoriSpecifics syncTabFavicons.
         * @member {boolean} syncTabFavicons
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.syncTabFavicons = false;

        /**
         * NigoriSpecifics passphraseType.
         * @member {number} passphraseType
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.passphraseType = 1;

        /**
         * NigoriSpecifics keystoreDecryptorToken.
         * @member {sync_pb.IEncryptedData|null|undefined} keystoreDecryptorToken
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.keystoreDecryptorToken = null;

        /**
         * NigoriSpecifics keystoreMigrationTime.
         * @member {number|Long} keystoreMigrationTime
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.keystoreMigrationTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * NigoriSpecifics customPassphraseTime.
         * @member {number|Long} customPassphraseTime
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.customPassphraseTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * NigoriSpecifics encryptDictionary.
         * @member {boolean} encryptDictionary
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptDictionary = false;

        /**
         * NigoriSpecifics encryptFaviconImages.
         * @member {boolean} encryptFaviconImages
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptFaviconImages = false;

        /**
         * NigoriSpecifics encryptFaviconTracking.
         * @member {boolean} encryptFaviconTracking
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptFaviconTracking = false;

        /**
         * NigoriSpecifics encryptAppList.
         * @member {boolean} encryptAppList
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptAppList = false;

        /**
         * NigoriSpecifics encryptAutofillWalletMetadata.
         * @member {boolean} encryptAutofillWalletMetadata
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptAutofillWalletMetadata = false;

        /**
         * NigoriSpecifics serverOnlyWasMissingKeystoreMigrationTime.
         * @member {boolean} serverOnlyWasMissingKeystoreMigrationTime
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.serverOnlyWasMissingKeystoreMigrationTime = false;

        /**
         * NigoriSpecifics encryptArcPackage.
         * @member {boolean} encryptArcPackage
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptArcPackage = false;

        /**
         * NigoriSpecifics encryptPrinters.
         * @member {boolean} encryptPrinters
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptPrinters = false;

        /**
         * NigoriSpecifics encryptReadingList.
         * @member {boolean} encryptReadingList
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptReadingList = false;

        /**
         * NigoriSpecifics encryptMountainShares.
         * @member {boolean} encryptMountainShares
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptMountainShares = false;

        /**
         * NigoriSpecifics customPassphraseKeyDerivationMethod.
         * @member {number} customPassphraseKeyDerivationMethod
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.customPassphraseKeyDerivationMethod = 0;

        /**
         * NigoriSpecifics customPassphraseKeyDerivationSalt.
         * @member {string} customPassphraseKeyDerivationSalt
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.customPassphraseKeyDerivationSalt = "";

        /**
         * NigoriSpecifics encryptSendTabToSelf.
         * @member {boolean} encryptSendTabToSelf
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptSendTabToSelf = false;

        /**
         * NigoriSpecifics encryptWebApps.
         * @member {boolean} encryptWebApps
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptWebApps = false;

        /**
         * NigoriSpecifics encryptOsPreferences.
         * @member {boolean} encryptOsPreferences
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.encryptOsPreferences = false;

        /**
         * NigoriSpecifics operaEncryptionKeybag.
         * @member {sync_pb.IEncryptedData|null|undefined} operaEncryptionKeybag
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.operaEncryptionKeybag = null;

        /**
         * NigoriSpecifics operaKeybagIsFrozen.
         * @member {boolean} operaKeybagIsFrozen
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.operaKeybagIsFrozen = false;

        /**
         * NigoriSpecifics operaCustomPassphraseTime.
         * @member {number|Long} operaCustomPassphraseTime
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.operaCustomPassphraseTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * NigoriSpecifics opEncryptionKeybag.
         * @member {sync_pb.IEncryptedData|null|undefined} opEncryptionKeybag
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.opEncryptionKeybag = null;

        /**
         * NigoriSpecifics opKeybagIsFrozen.
         * @member {boolean} opKeybagIsFrozen
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.opKeybagIsFrozen = false;

        /**
         * NigoriSpecifics opCustomPassphraseTime.
         * @member {number|Long} opCustomPassphraseTime
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         */
        NigoriSpecifics.prototype.opCustomPassphraseTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new NigoriSpecifics instance using the specified properties.
         * @function create
         * @memberof sync_pb.NigoriSpecifics
         * @static
         * @param {sync_pb.INigoriSpecifics=} [properties] Properties to set
         * @returns {sync_pb.NigoriSpecifics} NigoriSpecifics instance
         */
        NigoriSpecifics.create = function create(properties) {
            return new NigoriSpecifics(properties);
        };

        /**
         * Encodes the specified NigoriSpecifics message. Does not implicitly {@link sync_pb.NigoriSpecifics.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.NigoriSpecifics
         * @static
         * @param {sync_pb.INigoriSpecifics} message NigoriSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NigoriSpecifics.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.encryptionKeybag != null && Object.hasOwnProperty.call(message, "encryptionKeybag"))
                $root.sync_pb.EncryptedData.encode(message.encryptionKeybag, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.keybagIsFrozen != null && Object.hasOwnProperty.call(message, "keybagIsFrozen"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.keybagIsFrozen);
            if (message.encryptBookmarks != null && Object.hasOwnProperty.call(message, "encryptBookmarks"))
                writer.uint32(/* id 13, wireType 0 =*/104).bool(message.encryptBookmarks);
            if (message.encryptPreferences != null && Object.hasOwnProperty.call(message, "encryptPreferences"))
                writer.uint32(/* id 14, wireType 0 =*/112).bool(message.encryptPreferences);
            if (message.encryptAutofillProfile != null && Object.hasOwnProperty.call(message, "encryptAutofillProfile"))
                writer.uint32(/* id 15, wireType 0 =*/120).bool(message.encryptAutofillProfile);
            if (message.encryptAutofill != null && Object.hasOwnProperty.call(message, "encryptAutofill"))
                writer.uint32(/* id 16, wireType 0 =*/128).bool(message.encryptAutofill);
            if (message.encryptThemes != null && Object.hasOwnProperty.call(message, "encryptThemes"))
                writer.uint32(/* id 17, wireType 0 =*/136).bool(message.encryptThemes);
            if (message.encryptTypedUrls != null && Object.hasOwnProperty.call(message, "encryptTypedUrls"))
                writer.uint32(/* id 18, wireType 0 =*/144).bool(message.encryptTypedUrls);
            if (message.encryptExtensions != null && Object.hasOwnProperty.call(message, "encryptExtensions"))
                writer.uint32(/* id 19, wireType 0 =*/152).bool(message.encryptExtensions);
            if (message.encryptSessions != null && Object.hasOwnProperty.call(message, "encryptSessions"))
                writer.uint32(/* id 20, wireType 0 =*/160).bool(message.encryptSessions);
            if (message.encryptApps != null && Object.hasOwnProperty.call(message, "encryptApps"))
                writer.uint32(/* id 21, wireType 0 =*/168).bool(message.encryptApps);
            if (message.encryptSearchEngines != null && Object.hasOwnProperty.call(message, "encryptSearchEngines"))
                writer.uint32(/* id 22, wireType 0 =*/176).bool(message.encryptSearchEngines);
            if (message.encryptEverything != null && Object.hasOwnProperty.call(message, "encryptEverything"))
                writer.uint32(/* id 24, wireType 0 =*/192).bool(message.encryptEverything);
            if (message.encryptExtensionSettings != null && Object.hasOwnProperty.call(message, "encryptExtensionSettings"))
                writer.uint32(/* id 25, wireType 0 =*/200).bool(message.encryptExtensionSettings);
            if (message.encryptAppNotifications != null && Object.hasOwnProperty.call(message, "encryptAppNotifications"))
                writer.uint32(/* id 26, wireType 0 =*/208).bool(message.encryptAppNotifications);
            if (message.encryptAppSettings != null && Object.hasOwnProperty.call(message, "encryptAppSettings"))
                writer.uint32(/* id 27, wireType 0 =*/216).bool(message.encryptAppSettings);
            if (message.syncTabFavicons != null && Object.hasOwnProperty.call(message, "syncTabFavicons"))
                writer.uint32(/* id 29, wireType 0 =*/232).bool(message.syncTabFavicons);
            if (message.passphraseType != null && Object.hasOwnProperty.call(message, "passphraseType"))
                writer.uint32(/* id 30, wireType 0 =*/240).int32(message.passphraseType);
            if (message.keystoreDecryptorToken != null && Object.hasOwnProperty.call(message, "keystoreDecryptorToken"))
                $root.sync_pb.EncryptedData.encode(message.keystoreDecryptorToken, writer.uint32(/* id 31, wireType 2 =*/250).fork()).ldelim();
            if (message.keystoreMigrationTime != null && Object.hasOwnProperty.call(message, "keystoreMigrationTime"))
                writer.uint32(/* id 32, wireType 0 =*/256).int64(message.keystoreMigrationTime);
            if (message.customPassphraseTime != null && Object.hasOwnProperty.call(message, "customPassphraseTime"))
                writer.uint32(/* id 33, wireType 0 =*/264).int64(message.customPassphraseTime);
            if (message.encryptDictionary != null && Object.hasOwnProperty.call(message, "encryptDictionary"))
                writer.uint32(/* id 34, wireType 0 =*/272).bool(message.encryptDictionary);
            if (message.encryptFaviconImages != null && Object.hasOwnProperty.call(message, "encryptFaviconImages"))
                writer.uint32(/* id 35, wireType 0 =*/280).bool(message.encryptFaviconImages);
            if (message.encryptFaviconTracking != null && Object.hasOwnProperty.call(message, "encryptFaviconTracking"))
                writer.uint32(/* id 36, wireType 0 =*/288).bool(message.encryptFaviconTracking);
            if (message.encryptAppList != null && Object.hasOwnProperty.call(message, "encryptAppList"))
                writer.uint32(/* id 38, wireType 0 =*/304).bool(message.encryptAppList);
            if (message.encryptAutofillWalletMetadata != null && Object.hasOwnProperty.call(message, "encryptAutofillWalletMetadata"))
                writer.uint32(/* id 39, wireType 0 =*/312).bool(message.encryptAutofillWalletMetadata);
            if (message.serverOnlyWasMissingKeystoreMigrationTime != null && Object.hasOwnProperty.call(message, "serverOnlyWasMissingKeystoreMigrationTime"))
                writer.uint32(/* id 40, wireType 0 =*/320).bool(message.serverOnlyWasMissingKeystoreMigrationTime);
            if (message.encryptArcPackage != null && Object.hasOwnProperty.call(message, "encryptArcPackage"))
                writer.uint32(/* id 41, wireType 0 =*/328).bool(message.encryptArcPackage);
            if (message.encryptPrinters != null && Object.hasOwnProperty.call(message, "encryptPrinters"))
                writer.uint32(/* id 42, wireType 0 =*/336).bool(message.encryptPrinters);
            if (message.encryptReadingList != null && Object.hasOwnProperty.call(message, "encryptReadingList"))
                writer.uint32(/* id 43, wireType 0 =*/344).bool(message.encryptReadingList);
            if (message.encryptMountainShares != null && Object.hasOwnProperty.call(message, "encryptMountainShares"))
                writer.uint32(/* id 44, wireType 0 =*/352).bool(message.encryptMountainShares);
            if (message.customPassphraseKeyDerivationMethod != null && Object.hasOwnProperty.call(message, "customPassphraseKeyDerivationMethod"))
                writer.uint32(/* id 45, wireType 0 =*/360).int32(message.customPassphraseKeyDerivationMethod);
            if (message.customPassphraseKeyDerivationSalt != null && Object.hasOwnProperty.call(message, "customPassphraseKeyDerivationSalt"))
                writer.uint32(/* id 46, wireType 2 =*/370).string(message.customPassphraseKeyDerivationSalt);
            if (message.encryptSendTabToSelf != null && Object.hasOwnProperty.call(message, "encryptSendTabToSelf"))
                writer.uint32(/* id 47, wireType 0 =*/376).bool(message.encryptSendTabToSelf);
            if (message.encryptWebApps != null && Object.hasOwnProperty.call(message, "encryptWebApps"))
                writer.uint32(/* id 48, wireType 0 =*/384).bool(message.encryptWebApps);
            if (message.encryptOsPreferences != null && Object.hasOwnProperty.call(message, "encryptOsPreferences"))
                writer.uint32(/* id 49, wireType 0 =*/392).bool(message.encryptOsPreferences);
            if (message.operaEncryptionKeybag != null && Object.hasOwnProperty.call(message, "operaEncryptionKeybag"))
                $root.sync_pb.EncryptedData.encode(message.operaEncryptionKeybag, writer.uint32(/* id 1000, wireType 2 =*/8002).fork()).ldelim();
            if (message.operaKeybagIsFrozen != null && Object.hasOwnProperty.call(message, "operaKeybagIsFrozen"))
                writer.uint32(/* id 1001, wireType 0 =*/8008).bool(message.operaKeybagIsFrozen);
            if (message.operaCustomPassphraseTime != null && Object.hasOwnProperty.call(message, "operaCustomPassphraseTime"))
                writer.uint32(/* id 1002, wireType 0 =*/8016).int64(message.operaCustomPassphraseTime);
            if (message.opEncryptionKeybag != null && Object.hasOwnProperty.call(message, "opEncryptionKeybag"))
                $root.sync_pb.EncryptedData.encode(message.opEncryptionKeybag, writer.uint32(/* id 1003, wireType 2 =*/8026).fork()).ldelim();
            if (message.opKeybagIsFrozen != null && Object.hasOwnProperty.call(message, "opKeybagIsFrozen"))
                writer.uint32(/* id 1004, wireType 0 =*/8032).bool(message.opKeybagIsFrozen);
            if (message.opCustomPassphraseTime != null && Object.hasOwnProperty.call(message, "opCustomPassphraseTime"))
                writer.uint32(/* id 1005, wireType 0 =*/8040).int64(message.opCustomPassphraseTime);
            return writer;
        };

        /**
         * Encodes the specified NigoriSpecifics message, length delimited. Does not implicitly {@link sync_pb.NigoriSpecifics.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.NigoriSpecifics
         * @static
         * @param {sync_pb.INigoriSpecifics} message NigoriSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NigoriSpecifics.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NigoriSpecifics message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.NigoriSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.NigoriSpecifics} NigoriSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NigoriSpecifics.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.NigoriSpecifics();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.encryptionKeybag = $root.sync_pb.EncryptedData.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.keybagIsFrozen = reader.bool();
                    break;
                case 13:
                    message.encryptBookmarks = reader.bool();
                    break;
                case 14:
                    message.encryptPreferences = reader.bool();
                    break;
                case 15:
                    message.encryptAutofillProfile = reader.bool();
                    break;
                case 16:
                    message.encryptAutofill = reader.bool();
                    break;
                case 17:
                    message.encryptThemes = reader.bool();
                    break;
                case 18:
                    message.encryptTypedUrls = reader.bool();
                    break;
                case 19:
                    message.encryptExtensions = reader.bool();
                    break;
                case 20:
                    message.encryptSessions = reader.bool();
                    break;
                case 21:
                    message.encryptApps = reader.bool();
                    break;
                case 22:
                    message.encryptSearchEngines = reader.bool();
                    break;
                case 24:
                    message.encryptEverything = reader.bool();
                    break;
                case 25:
                    message.encryptExtensionSettings = reader.bool();
                    break;
                case 26:
                    message.encryptAppNotifications = reader.bool();
                    break;
                case 27:
                    message.encryptAppSettings = reader.bool();
                    break;
                case 29:
                    message.syncTabFavicons = reader.bool();
                    break;
                case 30:
                    message.passphraseType = reader.int32();
                    break;
                case 31:
                    message.keystoreDecryptorToken = $root.sync_pb.EncryptedData.decode(reader, reader.uint32());
                    break;
                case 32:
                    message.keystoreMigrationTime = reader.int64();
                    break;
                case 33:
                    message.customPassphraseTime = reader.int64();
                    break;
                case 34:
                    message.encryptDictionary = reader.bool();
                    break;
                case 35:
                    message.encryptFaviconImages = reader.bool();
                    break;
                case 36:
                    message.encryptFaviconTracking = reader.bool();
                    break;
                case 38:
                    message.encryptAppList = reader.bool();
                    break;
                case 39:
                    message.encryptAutofillWalletMetadata = reader.bool();
                    break;
                case 40:
                    message.serverOnlyWasMissingKeystoreMigrationTime = reader.bool();
                    break;
                case 41:
                    message.encryptArcPackage = reader.bool();
                    break;
                case 42:
                    message.encryptPrinters = reader.bool();
                    break;
                case 43:
                    message.encryptReadingList = reader.bool();
                    break;
                case 44:
                    message.encryptMountainShares = reader.bool();
                    break;
                case 45:
                    message.customPassphraseKeyDerivationMethod = reader.int32();
                    break;
                case 46:
                    message.customPassphraseKeyDerivationSalt = reader.string();
                    break;
                case 47:
                    message.encryptSendTabToSelf = reader.bool();
                    break;
                case 48:
                    message.encryptWebApps = reader.bool();
                    break;
                case 49:
                    message.encryptOsPreferences = reader.bool();
                    break;
                case 1000:
                    message.operaEncryptionKeybag = $root.sync_pb.EncryptedData.decode(reader, reader.uint32());
                    break;
                case 1001:
                    message.operaKeybagIsFrozen = reader.bool();
                    break;
                case 1002:
                    message.operaCustomPassphraseTime = reader.int64();
                    break;
                case 1003:
                    message.opEncryptionKeybag = $root.sync_pb.EncryptedData.decode(reader, reader.uint32());
                    break;
                case 1004:
                    message.opKeybagIsFrozen = reader.bool();
                    break;
                case 1005:
                    message.opCustomPassphraseTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NigoriSpecifics message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.NigoriSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.NigoriSpecifics} NigoriSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NigoriSpecifics.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NigoriSpecifics message.
         * @function verify
         * @memberof sync_pb.NigoriSpecifics
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NigoriSpecifics.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.encryptionKeybag != null && message.hasOwnProperty("encryptionKeybag")) {
                let error = $root.sync_pb.EncryptedData.verify(message.encryptionKeybag);
                if (error)
                    return "encryptionKeybag." + error;
            }
            if (message.keybagIsFrozen != null && message.hasOwnProperty("keybagIsFrozen"))
                if (typeof message.keybagIsFrozen !== "boolean")
                    return "keybagIsFrozen: boolean expected";
            if (message.encryptBookmarks != null && message.hasOwnProperty("encryptBookmarks"))
                if (typeof message.encryptBookmarks !== "boolean")
                    return "encryptBookmarks: boolean expected";
            if (message.encryptPreferences != null && message.hasOwnProperty("encryptPreferences"))
                if (typeof message.encryptPreferences !== "boolean")
                    return "encryptPreferences: boolean expected";
            if (message.encryptAutofillProfile != null && message.hasOwnProperty("encryptAutofillProfile"))
                if (typeof message.encryptAutofillProfile !== "boolean")
                    return "encryptAutofillProfile: boolean expected";
            if (message.encryptAutofill != null && message.hasOwnProperty("encryptAutofill"))
                if (typeof message.encryptAutofill !== "boolean")
                    return "encryptAutofill: boolean expected";
            if (message.encryptThemes != null && message.hasOwnProperty("encryptThemes"))
                if (typeof message.encryptThemes !== "boolean")
                    return "encryptThemes: boolean expected";
            if (message.encryptTypedUrls != null && message.hasOwnProperty("encryptTypedUrls"))
                if (typeof message.encryptTypedUrls !== "boolean")
                    return "encryptTypedUrls: boolean expected";
            if (message.encryptExtensions != null && message.hasOwnProperty("encryptExtensions"))
                if (typeof message.encryptExtensions !== "boolean")
                    return "encryptExtensions: boolean expected";
            if (message.encryptSessions != null && message.hasOwnProperty("encryptSessions"))
                if (typeof message.encryptSessions !== "boolean")
                    return "encryptSessions: boolean expected";
            if (message.encryptApps != null && message.hasOwnProperty("encryptApps"))
                if (typeof message.encryptApps !== "boolean")
                    return "encryptApps: boolean expected";
            if (message.encryptSearchEngines != null && message.hasOwnProperty("encryptSearchEngines"))
                if (typeof message.encryptSearchEngines !== "boolean")
                    return "encryptSearchEngines: boolean expected";
            if (message.encryptEverything != null && message.hasOwnProperty("encryptEverything"))
                if (typeof message.encryptEverything !== "boolean")
                    return "encryptEverything: boolean expected";
            if (message.encryptExtensionSettings != null && message.hasOwnProperty("encryptExtensionSettings"))
                if (typeof message.encryptExtensionSettings !== "boolean")
                    return "encryptExtensionSettings: boolean expected";
            if (message.encryptAppNotifications != null && message.hasOwnProperty("encryptAppNotifications"))
                if (typeof message.encryptAppNotifications !== "boolean")
                    return "encryptAppNotifications: boolean expected";
            if (message.encryptAppSettings != null && message.hasOwnProperty("encryptAppSettings"))
                if (typeof message.encryptAppSettings !== "boolean")
                    return "encryptAppSettings: boolean expected";
            if (message.syncTabFavicons != null && message.hasOwnProperty("syncTabFavicons"))
                if (typeof message.syncTabFavicons !== "boolean")
                    return "syncTabFavicons: boolean expected";
            if (message.passphraseType != null && message.hasOwnProperty("passphraseType"))
                if (!$util.isInteger(message.passphraseType))
                    return "passphraseType: integer expected";
            if (message.keystoreDecryptorToken != null && message.hasOwnProperty("keystoreDecryptorToken")) {
                let error = $root.sync_pb.EncryptedData.verify(message.keystoreDecryptorToken);
                if (error)
                    return "keystoreDecryptorToken." + error;
            }
            if (message.keystoreMigrationTime != null && message.hasOwnProperty("keystoreMigrationTime"))
                if (!$util.isInteger(message.keystoreMigrationTime) && !(message.keystoreMigrationTime && $util.isInteger(message.keystoreMigrationTime.low) && $util.isInteger(message.keystoreMigrationTime.high)))
                    return "keystoreMigrationTime: integer|Long expected";
            if (message.customPassphraseTime != null && message.hasOwnProperty("customPassphraseTime"))
                if (!$util.isInteger(message.customPassphraseTime) && !(message.customPassphraseTime && $util.isInteger(message.customPassphraseTime.low) && $util.isInteger(message.customPassphraseTime.high)))
                    return "customPassphraseTime: integer|Long expected";
            if (message.encryptDictionary != null && message.hasOwnProperty("encryptDictionary"))
                if (typeof message.encryptDictionary !== "boolean")
                    return "encryptDictionary: boolean expected";
            if (message.encryptFaviconImages != null && message.hasOwnProperty("encryptFaviconImages"))
                if (typeof message.encryptFaviconImages !== "boolean")
                    return "encryptFaviconImages: boolean expected";
            if (message.encryptFaviconTracking != null && message.hasOwnProperty("encryptFaviconTracking"))
                if (typeof message.encryptFaviconTracking !== "boolean")
                    return "encryptFaviconTracking: boolean expected";
            if (message.encryptAppList != null && message.hasOwnProperty("encryptAppList"))
                if (typeof message.encryptAppList !== "boolean")
                    return "encryptAppList: boolean expected";
            if (message.encryptAutofillWalletMetadata != null && message.hasOwnProperty("encryptAutofillWalletMetadata"))
                if (typeof message.encryptAutofillWalletMetadata !== "boolean")
                    return "encryptAutofillWalletMetadata: boolean expected";
            if (message.serverOnlyWasMissingKeystoreMigrationTime != null && message.hasOwnProperty("serverOnlyWasMissingKeystoreMigrationTime"))
                if (typeof message.serverOnlyWasMissingKeystoreMigrationTime !== "boolean")
                    return "serverOnlyWasMissingKeystoreMigrationTime: boolean expected";
            if (message.encryptArcPackage != null && message.hasOwnProperty("encryptArcPackage"))
                if (typeof message.encryptArcPackage !== "boolean")
                    return "encryptArcPackage: boolean expected";
            if (message.encryptPrinters != null && message.hasOwnProperty("encryptPrinters"))
                if (typeof message.encryptPrinters !== "boolean")
                    return "encryptPrinters: boolean expected";
            if (message.encryptReadingList != null && message.hasOwnProperty("encryptReadingList"))
                if (typeof message.encryptReadingList !== "boolean")
                    return "encryptReadingList: boolean expected";
            if (message.encryptMountainShares != null && message.hasOwnProperty("encryptMountainShares"))
                if (typeof message.encryptMountainShares !== "boolean")
                    return "encryptMountainShares: boolean expected";
            if (message.customPassphraseKeyDerivationMethod != null && message.hasOwnProperty("customPassphraseKeyDerivationMethod"))
                if (!$util.isInteger(message.customPassphraseKeyDerivationMethod))
                    return "customPassphraseKeyDerivationMethod: integer expected";
            if (message.customPassphraseKeyDerivationSalt != null && message.hasOwnProperty("customPassphraseKeyDerivationSalt"))
                if (!$util.isString(message.customPassphraseKeyDerivationSalt))
                    return "customPassphraseKeyDerivationSalt: string expected";
            if (message.encryptSendTabToSelf != null && message.hasOwnProperty("encryptSendTabToSelf"))
                if (typeof message.encryptSendTabToSelf !== "boolean")
                    return "encryptSendTabToSelf: boolean expected";
            if (message.encryptWebApps != null && message.hasOwnProperty("encryptWebApps"))
                if (typeof message.encryptWebApps !== "boolean")
                    return "encryptWebApps: boolean expected";
            if (message.encryptOsPreferences != null && message.hasOwnProperty("encryptOsPreferences"))
                if (typeof message.encryptOsPreferences !== "boolean")
                    return "encryptOsPreferences: boolean expected";
            if (message.operaEncryptionKeybag != null && message.hasOwnProperty("operaEncryptionKeybag")) {
                let error = $root.sync_pb.EncryptedData.verify(message.operaEncryptionKeybag);
                if (error)
                    return "operaEncryptionKeybag." + error;
            }
            if (message.operaKeybagIsFrozen != null && message.hasOwnProperty("operaKeybagIsFrozen"))
                if (typeof message.operaKeybagIsFrozen !== "boolean")
                    return "operaKeybagIsFrozen: boolean expected";
            if (message.operaCustomPassphraseTime != null && message.hasOwnProperty("operaCustomPassphraseTime"))
                if (!$util.isInteger(message.operaCustomPassphraseTime) && !(message.operaCustomPassphraseTime && $util.isInteger(message.operaCustomPassphraseTime.low) && $util.isInteger(message.operaCustomPassphraseTime.high)))
                    return "operaCustomPassphraseTime: integer|Long expected";
            if (message.opEncryptionKeybag != null && message.hasOwnProperty("opEncryptionKeybag")) {
                let error = $root.sync_pb.EncryptedData.verify(message.opEncryptionKeybag);
                if (error)
                    return "opEncryptionKeybag." + error;
            }
            if (message.opKeybagIsFrozen != null && message.hasOwnProperty("opKeybagIsFrozen"))
                if (typeof message.opKeybagIsFrozen !== "boolean")
                    return "opKeybagIsFrozen: boolean expected";
            if (message.opCustomPassphraseTime != null && message.hasOwnProperty("opCustomPassphraseTime"))
                if (!$util.isInteger(message.opCustomPassphraseTime) && !(message.opCustomPassphraseTime && $util.isInteger(message.opCustomPassphraseTime.low) && $util.isInteger(message.opCustomPassphraseTime.high)))
                    return "opCustomPassphraseTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a NigoriSpecifics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.NigoriSpecifics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.NigoriSpecifics} NigoriSpecifics
         */
        NigoriSpecifics.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.NigoriSpecifics)
                return object;
            let message = new $root.sync_pb.NigoriSpecifics();
            if (object.encryptionKeybag != null) {
                if (typeof object.encryptionKeybag !== "object")
                    throw TypeError(".sync_pb.NigoriSpecifics.encryptionKeybag: object expected");
                message.encryptionKeybag = $root.sync_pb.EncryptedData.fromObject(object.encryptionKeybag);
            }
            if (object.keybagIsFrozen != null)
                message.keybagIsFrozen = Boolean(object.keybagIsFrozen);
            if (object.encryptBookmarks != null)
                message.encryptBookmarks = Boolean(object.encryptBookmarks);
            if (object.encryptPreferences != null)
                message.encryptPreferences = Boolean(object.encryptPreferences);
            if (object.encryptAutofillProfile != null)
                message.encryptAutofillProfile = Boolean(object.encryptAutofillProfile);
            if (object.encryptAutofill != null)
                message.encryptAutofill = Boolean(object.encryptAutofill);
            if (object.encryptThemes != null)
                message.encryptThemes = Boolean(object.encryptThemes);
            if (object.encryptTypedUrls != null)
                message.encryptTypedUrls = Boolean(object.encryptTypedUrls);
            if (object.encryptExtensions != null)
                message.encryptExtensions = Boolean(object.encryptExtensions);
            if (object.encryptSessions != null)
                message.encryptSessions = Boolean(object.encryptSessions);
            if (object.encryptApps != null)
                message.encryptApps = Boolean(object.encryptApps);
            if (object.encryptSearchEngines != null)
                message.encryptSearchEngines = Boolean(object.encryptSearchEngines);
            if (object.encryptEverything != null)
                message.encryptEverything = Boolean(object.encryptEverything);
            if (object.encryptExtensionSettings != null)
                message.encryptExtensionSettings = Boolean(object.encryptExtensionSettings);
            if (object.encryptAppNotifications != null)
                message.encryptAppNotifications = Boolean(object.encryptAppNotifications);
            if (object.encryptAppSettings != null)
                message.encryptAppSettings = Boolean(object.encryptAppSettings);
            if (object.syncTabFavicons != null)
                message.syncTabFavicons = Boolean(object.syncTabFavicons);
            if (object.passphraseType != null)
                message.passphraseType = object.passphraseType | 0;
            if (object.keystoreDecryptorToken != null) {
                if (typeof object.keystoreDecryptorToken !== "object")
                    throw TypeError(".sync_pb.NigoriSpecifics.keystoreDecryptorToken: object expected");
                message.keystoreDecryptorToken = $root.sync_pb.EncryptedData.fromObject(object.keystoreDecryptorToken);
            }
            if (object.keystoreMigrationTime != null)
                if ($util.Long)
                    (message.keystoreMigrationTime = $util.Long.fromValue(object.keystoreMigrationTime)).unsigned = false;
                else if (typeof object.keystoreMigrationTime === "string")
                    message.keystoreMigrationTime = parseInt(object.keystoreMigrationTime, 10);
                else if (typeof object.keystoreMigrationTime === "number")
                    message.keystoreMigrationTime = object.keystoreMigrationTime;
                else if (typeof object.keystoreMigrationTime === "object")
                    message.keystoreMigrationTime = new $util.LongBits(object.keystoreMigrationTime.low >>> 0, object.keystoreMigrationTime.high >>> 0).toNumber();
            if (object.customPassphraseTime != null)
                if ($util.Long)
                    (message.customPassphraseTime = $util.Long.fromValue(object.customPassphraseTime)).unsigned = false;
                else if (typeof object.customPassphraseTime === "string")
                    message.customPassphraseTime = parseInt(object.customPassphraseTime, 10);
                else if (typeof object.customPassphraseTime === "number")
                    message.customPassphraseTime = object.customPassphraseTime;
                else if (typeof object.customPassphraseTime === "object")
                    message.customPassphraseTime = new $util.LongBits(object.customPassphraseTime.low >>> 0, object.customPassphraseTime.high >>> 0).toNumber();
            if (object.encryptDictionary != null)
                message.encryptDictionary = Boolean(object.encryptDictionary);
            if (object.encryptFaviconImages != null)
                message.encryptFaviconImages = Boolean(object.encryptFaviconImages);
            if (object.encryptFaviconTracking != null)
                message.encryptFaviconTracking = Boolean(object.encryptFaviconTracking);
            if (object.encryptAppList != null)
                message.encryptAppList = Boolean(object.encryptAppList);
            if (object.encryptAutofillWalletMetadata != null)
                message.encryptAutofillWalletMetadata = Boolean(object.encryptAutofillWalletMetadata);
            if (object.serverOnlyWasMissingKeystoreMigrationTime != null)
                message.serverOnlyWasMissingKeystoreMigrationTime = Boolean(object.serverOnlyWasMissingKeystoreMigrationTime);
            if (object.encryptArcPackage != null)
                message.encryptArcPackage = Boolean(object.encryptArcPackage);
            if (object.encryptPrinters != null)
                message.encryptPrinters = Boolean(object.encryptPrinters);
            if (object.encryptReadingList != null)
                message.encryptReadingList = Boolean(object.encryptReadingList);
            if (object.encryptMountainShares != null)
                message.encryptMountainShares = Boolean(object.encryptMountainShares);
            if (object.customPassphraseKeyDerivationMethod != null)
                message.customPassphraseKeyDerivationMethod = object.customPassphraseKeyDerivationMethod | 0;
            if (object.customPassphraseKeyDerivationSalt != null)
                message.customPassphraseKeyDerivationSalt = String(object.customPassphraseKeyDerivationSalt);
            if (object.encryptSendTabToSelf != null)
                message.encryptSendTabToSelf = Boolean(object.encryptSendTabToSelf);
            if (object.encryptWebApps != null)
                message.encryptWebApps = Boolean(object.encryptWebApps);
            if (object.encryptOsPreferences != null)
                message.encryptOsPreferences = Boolean(object.encryptOsPreferences);
            if (object.operaEncryptionKeybag != null) {
                if (typeof object.operaEncryptionKeybag !== "object")
                    throw TypeError(".sync_pb.NigoriSpecifics.operaEncryptionKeybag: object expected");
                message.operaEncryptionKeybag = $root.sync_pb.EncryptedData.fromObject(object.operaEncryptionKeybag);
            }
            if (object.operaKeybagIsFrozen != null)
                message.operaKeybagIsFrozen = Boolean(object.operaKeybagIsFrozen);
            if (object.operaCustomPassphraseTime != null)
                if ($util.Long)
                    (message.operaCustomPassphraseTime = $util.Long.fromValue(object.operaCustomPassphraseTime)).unsigned = false;
                else if (typeof object.operaCustomPassphraseTime === "string")
                    message.operaCustomPassphraseTime = parseInt(object.operaCustomPassphraseTime, 10);
                else if (typeof object.operaCustomPassphraseTime === "number")
                    message.operaCustomPassphraseTime = object.operaCustomPassphraseTime;
                else if (typeof object.operaCustomPassphraseTime === "object")
                    message.operaCustomPassphraseTime = new $util.LongBits(object.operaCustomPassphraseTime.low >>> 0, object.operaCustomPassphraseTime.high >>> 0).toNumber();
            if (object.opEncryptionKeybag != null) {
                if (typeof object.opEncryptionKeybag !== "object")
                    throw TypeError(".sync_pb.NigoriSpecifics.opEncryptionKeybag: object expected");
                message.opEncryptionKeybag = $root.sync_pb.EncryptedData.fromObject(object.opEncryptionKeybag);
            }
            if (object.opKeybagIsFrozen != null)
                message.opKeybagIsFrozen = Boolean(object.opKeybagIsFrozen);
            if (object.opCustomPassphraseTime != null)
                if ($util.Long)
                    (message.opCustomPassphraseTime = $util.Long.fromValue(object.opCustomPassphraseTime)).unsigned = false;
                else if (typeof object.opCustomPassphraseTime === "string")
                    message.opCustomPassphraseTime = parseInt(object.opCustomPassphraseTime, 10);
                else if (typeof object.opCustomPassphraseTime === "number")
                    message.opCustomPassphraseTime = object.opCustomPassphraseTime;
                else if (typeof object.opCustomPassphraseTime === "object")
                    message.opCustomPassphraseTime = new $util.LongBits(object.opCustomPassphraseTime.low >>> 0, object.opCustomPassphraseTime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a NigoriSpecifics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.NigoriSpecifics
         * @static
         * @param {sync_pb.NigoriSpecifics} message NigoriSpecifics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NigoriSpecifics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.encryptionKeybag = null;
                object.keybagIsFrozen = false;
                object.encryptBookmarks = false;
                object.encryptPreferences = false;
                object.encryptAutofillProfile = false;
                object.encryptAutofill = false;
                object.encryptThemes = false;
                object.encryptTypedUrls = false;
                object.encryptExtensions = false;
                object.encryptSessions = false;
                object.encryptApps = false;
                object.encryptSearchEngines = false;
                object.encryptEverything = false;
                object.encryptExtensionSettings = false;
                object.encryptAppNotifications = false;
                object.encryptAppSettings = false;
                object.syncTabFavicons = false;
                object.passphraseType = 1;
                object.keystoreDecryptorToken = null;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.keystoreMigrationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.keystoreMigrationTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.customPassphraseTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.customPassphraseTime = options.longs === String ? "0" : 0;
                object.encryptDictionary = false;
                object.encryptFaviconImages = false;
                object.encryptFaviconTracking = false;
                object.encryptAppList = false;
                object.encryptAutofillWalletMetadata = false;
                object.serverOnlyWasMissingKeystoreMigrationTime = false;
                object.encryptArcPackage = false;
                object.encryptPrinters = false;
                object.encryptReadingList = false;
                object.encryptMountainShares = false;
                object.customPassphraseKeyDerivationMethod = 0;
                object.customPassphraseKeyDerivationSalt = "";
                object.encryptSendTabToSelf = false;
                object.encryptWebApps = false;
                object.encryptOsPreferences = false;
                object.operaEncryptionKeybag = null;
                object.operaKeybagIsFrozen = false;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.operaCustomPassphraseTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.operaCustomPassphraseTime = options.longs === String ? "0" : 0;
                object.opEncryptionKeybag = null;
                object.opKeybagIsFrozen = false;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.opCustomPassphraseTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.opCustomPassphraseTime = options.longs === String ? "0" : 0;
            }
            if (message.encryptionKeybag != null && message.hasOwnProperty("encryptionKeybag"))
                object.encryptionKeybag = $root.sync_pb.EncryptedData.toObject(message.encryptionKeybag, options);
            if (message.keybagIsFrozen != null && message.hasOwnProperty("keybagIsFrozen"))
                object.keybagIsFrozen = message.keybagIsFrozen;
            if (message.encryptBookmarks != null && message.hasOwnProperty("encryptBookmarks"))
                object.encryptBookmarks = message.encryptBookmarks;
            if (message.encryptPreferences != null && message.hasOwnProperty("encryptPreferences"))
                object.encryptPreferences = message.encryptPreferences;
            if (message.encryptAutofillProfile != null && message.hasOwnProperty("encryptAutofillProfile"))
                object.encryptAutofillProfile = message.encryptAutofillProfile;
            if (message.encryptAutofill != null && message.hasOwnProperty("encryptAutofill"))
                object.encryptAutofill = message.encryptAutofill;
            if (message.encryptThemes != null && message.hasOwnProperty("encryptThemes"))
                object.encryptThemes = message.encryptThemes;
            if (message.encryptTypedUrls != null && message.hasOwnProperty("encryptTypedUrls"))
                object.encryptTypedUrls = message.encryptTypedUrls;
            if (message.encryptExtensions != null && message.hasOwnProperty("encryptExtensions"))
                object.encryptExtensions = message.encryptExtensions;
            if (message.encryptSessions != null && message.hasOwnProperty("encryptSessions"))
                object.encryptSessions = message.encryptSessions;
            if (message.encryptApps != null && message.hasOwnProperty("encryptApps"))
                object.encryptApps = message.encryptApps;
            if (message.encryptSearchEngines != null && message.hasOwnProperty("encryptSearchEngines"))
                object.encryptSearchEngines = message.encryptSearchEngines;
            if (message.encryptEverything != null && message.hasOwnProperty("encryptEverything"))
                object.encryptEverything = message.encryptEverything;
            if (message.encryptExtensionSettings != null && message.hasOwnProperty("encryptExtensionSettings"))
                object.encryptExtensionSettings = message.encryptExtensionSettings;
            if (message.encryptAppNotifications != null && message.hasOwnProperty("encryptAppNotifications"))
                object.encryptAppNotifications = message.encryptAppNotifications;
            if (message.encryptAppSettings != null && message.hasOwnProperty("encryptAppSettings"))
                object.encryptAppSettings = message.encryptAppSettings;
            if (message.syncTabFavicons != null && message.hasOwnProperty("syncTabFavicons"))
                object.syncTabFavicons = message.syncTabFavicons;
            if (message.passphraseType != null && message.hasOwnProperty("passphraseType"))
                object.passphraseType = message.passphraseType;
            if (message.keystoreDecryptorToken != null && message.hasOwnProperty("keystoreDecryptorToken"))
                object.keystoreDecryptorToken = $root.sync_pb.EncryptedData.toObject(message.keystoreDecryptorToken, options);
            if (message.keystoreMigrationTime != null && message.hasOwnProperty("keystoreMigrationTime"))
                if (typeof message.keystoreMigrationTime === "number")
                    object.keystoreMigrationTime = options.longs === String ? String(message.keystoreMigrationTime) : message.keystoreMigrationTime;
                else
                    object.keystoreMigrationTime = options.longs === String ? $util.Long.prototype.toString.call(message.keystoreMigrationTime) : options.longs === Number ? new $util.LongBits(message.keystoreMigrationTime.low >>> 0, message.keystoreMigrationTime.high >>> 0).toNumber() : message.keystoreMigrationTime;
            if (message.customPassphraseTime != null && message.hasOwnProperty("customPassphraseTime"))
                if (typeof message.customPassphraseTime === "number")
                    object.customPassphraseTime = options.longs === String ? String(message.customPassphraseTime) : message.customPassphraseTime;
                else
                    object.customPassphraseTime = options.longs === String ? $util.Long.prototype.toString.call(message.customPassphraseTime) : options.longs === Number ? new $util.LongBits(message.customPassphraseTime.low >>> 0, message.customPassphraseTime.high >>> 0).toNumber() : message.customPassphraseTime;
            if (message.encryptDictionary != null && message.hasOwnProperty("encryptDictionary"))
                object.encryptDictionary = message.encryptDictionary;
            if (message.encryptFaviconImages != null && message.hasOwnProperty("encryptFaviconImages"))
                object.encryptFaviconImages = message.encryptFaviconImages;
            if (message.encryptFaviconTracking != null && message.hasOwnProperty("encryptFaviconTracking"))
                object.encryptFaviconTracking = message.encryptFaviconTracking;
            if (message.encryptAppList != null && message.hasOwnProperty("encryptAppList"))
                object.encryptAppList = message.encryptAppList;
            if (message.encryptAutofillWalletMetadata != null && message.hasOwnProperty("encryptAutofillWalletMetadata"))
                object.encryptAutofillWalletMetadata = message.encryptAutofillWalletMetadata;
            if (message.serverOnlyWasMissingKeystoreMigrationTime != null && message.hasOwnProperty("serverOnlyWasMissingKeystoreMigrationTime"))
                object.serverOnlyWasMissingKeystoreMigrationTime = message.serverOnlyWasMissingKeystoreMigrationTime;
            if (message.encryptArcPackage != null && message.hasOwnProperty("encryptArcPackage"))
                object.encryptArcPackage = message.encryptArcPackage;
            if (message.encryptPrinters != null && message.hasOwnProperty("encryptPrinters"))
                object.encryptPrinters = message.encryptPrinters;
            if (message.encryptReadingList != null && message.hasOwnProperty("encryptReadingList"))
                object.encryptReadingList = message.encryptReadingList;
            if (message.encryptMountainShares != null && message.hasOwnProperty("encryptMountainShares"))
                object.encryptMountainShares = message.encryptMountainShares;
            if (message.customPassphraseKeyDerivationMethod != null && message.hasOwnProperty("customPassphraseKeyDerivationMethod"))
                object.customPassphraseKeyDerivationMethod = message.customPassphraseKeyDerivationMethod;
            if (message.customPassphraseKeyDerivationSalt != null && message.hasOwnProperty("customPassphraseKeyDerivationSalt"))
                object.customPassphraseKeyDerivationSalt = message.customPassphraseKeyDerivationSalt;
            if (message.encryptSendTabToSelf != null && message.hasOwnProperty("encryptSendTabToSelf"))
                object.encryptSendTabToSelf = message.encryptSendTabToSelf;
            if (message.encryptWebApps != null && message.hasOwnProperty("encryptWebApps"))
                object.encryptWebApps = message.encryptWebApps;
            if (message.encryptOsPreferences != null && message.hasOwnProperty("encryptOsPreferences"))
                object.encryptOsPreferences = message.encryptOsPreferences;
            if (message.operaEncryptionKeybag != null && message.hasOwnProperty("operaEncryptionKeybag"))
                object.operaEncryptionKeybag = $root.sync_pb.EncryptedData.toObject(message.operaEncryptionKeybag, options);
            if (message.operaKeybagIsFrozen != null && message.hasOwnProperty("operaKeybagIsFrozen"))
                object.operaKeybagIsFrozen = message.operaKeybagIsFrozen;
            if (message.operaCustomPassphraseTime != null && message.hasOwnProperty("operaCustomPassphraseTime"))
                if (typeof message.operaCustomPassphraseTime === "number")
                    object.operaCustomPassphraseTime = options.longs === String ? String(message.operaCustomPassphraseTime) : message.operaCustomPassphraseTime;
                else
                    object.operaCustomPassphraseTime = options.longs === String ? $util.Long.prototype.toString.call(message.operaCustomPassphraseTime) : options.longs === Number ? new $util.LongBits(message.operaCustomPassphraseTime.low >>> 0, message.operaCustomPassphraseTime.high >>> 0).toNumber() : message.operaCustomPassphraseTime;
            if (message.opEncryptionKeybag != null && message.hasOwnProperty("opEncryptionKeybag"))
                object.opEncryptionKeybag = $root.sync_pb.EncryptedData.toObject(message.opEncryptionKeybag, options);
            if (message.opKeybagIsFrozen != null && message.hasOwnProperty("opKeybagIsFrozen"))
                object.opKeybagIsFrozen = message.opKeybagIsFrozen;
            if (message.opCustomPassphraseTime != null && message.hasOwnProperty("opCustomPassphraseTime"))
                if (typeof message.opCustomPassphraseTime === "number")
                    object.opCustomPassphraseTime = options.longs === String ? String(message.opCustomPassphraseTime) : message.opCustomPassphraseTime;
                else
                    object.opCustomPassphraseTime = options.longs === String ? $util.Long.prototype.toString.call(message.opCustomPassphraseTime) : options.longs === Number ? new $util.LongBits(message.opCustomPassphraseTime.low >>> 0, message.opCustomPassphraseTime.high >>> 0).toNumber() : message.opCustomPassphraseTime;
            return object;
        };

        /**
         * Converts this NigoriSpecifics to JSON.
         * @function toJSON
         * @memberof sync_pb.NigoriSpecifics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NigoriSpecifics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * PassphraseType enum.
         * @name sync_pb.NigoriSpecifics.PassphraseType
         * @enum {number}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} IMPLICIT_PASSPHRASE=1 IMPLICIT_PASSPHRASE value
         * @property {number} KEYSTORE_PASSPHRASE=2 KEYSTORE_PASSPHRASE value
         * @property {number} FROZEN_IMPLICIT_PASSPHRASE=3 FROZEN_IMPLICIT_PASSPHRASE value
         * @property {number} CUSTOM_PASSPHRASE=4 CUSTOM_PASSPHRASE value
         * @property {number} TRUSTED_VAULT_PASSPHRASE=5 TRUSTED_VAULT_PASSPHRASE value
         */
        NigoriSpecifics.PassphraseType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "IMPLICIT_PASSPHRASE"] = 1;
            values[valuesById[2] = "KEYSTORE_PASSPHRASE"] = 2;
            values[valuesById[3] = "FROZEN_IMPLICIT_PASSPHRASE"] = 3;
            values[valuesById[4] = "CUSTOM_PASSPHRASE"] = 4;
            values[valuesById[5] = "TRUSTED_VAULT_PASSPHRASE"] = 5;
            return values;
        })();

        /**
         * KeyDerivationMethod enum.
         * @name sync_pb.NigoriSpecifics.KeyDerivationMethod
         * @enum {number}
         * @property {number} UNSPECIFIED=0 UNSPECIFIED value
         * @property {number} PBKDF2_HMAC_SHA1_1003=1 PBKDF2_HMAC_SHA1_1003 value
         * @property {number} SCRYPT_8192_8_11=2 SCRYPT_8192_8_11 value
         */
        NigoriSpecifics.KeyDerivationMethod = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNSPECIFIED"] = 0;
            values[valuesById[1] = "PBKDF2_HMAC_SHA1_1003"] = 1;
            values[valuesById[2] = "SCRYPT_8192_8_11"] = 2;
            return values;
        })();

        return NigoriSpecifics;
    })();

    sync_pb.EncryptedData = (function() {

        /**
         * Properties of an EncryptedData.
         * @memberof sync_pb
         * @interface IEncryptedData
         * @property {string|null} [keyName] EncryptedData keyName
         * @property {string|null} [blob] EncryptedData blob
         */

        /**
         * Constructs a new EncryptedData.
         * @memberof sync_pb
         * @classdesc Represents an EncryptedData.
         * @implements IEncryptedData
         * @constructor
         * @param {sync_pb.IEncryptedData=} [properties] Properties to set
         */
        function EncryptedData(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EncryptedData keyName.
         * @member {string} keyName
         * @memberof sync_pb.EncryptedData
         * @instance
         */
        EncryptedData.prototype.keyName = "";

        /**
         * EncryptedData blob.
         * @member {string} blob
         * @memberof sync_pb.EncryptedData
         * @instance
         */
        EncryptedData.prototype.blob = "";

        /**
         * Creates a new EncryptedData instance using the specified properties.
         * @function create
         * @memberof sync_pb.EncryptedData
         * @static
         * @param {sync_pb.IEncryptedData=} [properties] Properties to set
         * @returns {sync_pb.EncryptedData} EncryptedData instance
         */
        EncryptedData.create = function create(properties) {
            return new EncryptedData(properties);
        };

        /**
         * Encodes the specified EncryptedData message. Does not implicitly {@link sync_pb.EncryptedData.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.EncryptedData
         * @static
         * @param {sync_pb.IEncryptedData} message EncryptedData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EncryptedData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.keyName != null && Object.hasOwnProperty.call(message, "keyName"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.keyName);
            if (message.blob != null && Object.hasOwnProperty.call(message, "blob"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.blob);
            return writer;
        };

        /**
         * Encodes the specified EncryptedData message, length delimited. Does not implicitly {@link sync_pb.EncryptedData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.EncryptedData
         * @static
         * @param {sync_pb.IEncryptedData} message EncryptedData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EncryptedData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EncryptedData message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.EncryptedData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.EncryptedData} EncryptedData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EncryptedData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.EncryptedData();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.keyName = reader.string();
                    break;
                case 2:
                    message.blob = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EncryptedData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.EncryptedData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.EncryptedData} EncryptedData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EncryptedData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EncryptedData message.
         * @function verify
         * @memberof sync_pb.EncryptedData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EncryptedData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.keyName != null && message.hasOwnProperty("keyName"))
                if (!$util.isString(message.keyName))
                    return "keyName: string expected";
            if (message.blob != null && message.hasOwnProperty("blob"))
                if (!$util.isString(message.blob))
                    return "blob: string expected";
            return null;
        };

        /**
         * Creates an EncryptedData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.EncryptedData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.EncryptedData} EncryptedData
         */
        EncryptedData.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.EncryptedData)
                return object;
            let message = new $root.sync_pb.EncryptedData();
            if (object.keyName != null)
                message.keyName = String(object.keyName);
            if (object.blob != null)
                message.blob = String(object.blob);
            return message;
        };

        /**
         * Creates a plain object from an EncryptedData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.EncryptedData
         * @static
         * @param {sync_pb.EncryptedData} message EncryptedData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EncryptedData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.keyName = "";
                object.blob = "";
            }
            if (message.keyName != null && message.hasOwnProperty("keyName"))
                object.keyName = message.keyName;
            if (message.blob != null && message.hasOwnProperty("blob"))
                object.blob = message.blob;
            return object;
        };

        /**
         * Converts this EncryptedData to JSON.
         * @function toJSON
         * @memberof sync_pb.EncryptedData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EncryptedData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EncryptedData;
    })();

    sync_pb.DeviceInfoSpecifics = (function() {

        /**
         * Properties of a DeviceInfoSpecifics.
         * @memberof sync_pb
         * @interface IDeviceInfoSpecifics
         * @property {string|null} [cacheGuid] DeviceInfoSpecifics cacheGuid
         * @property {string|null} [clientName] DeviceInfoSpecifics clientName
         * @property {sync_pb.SyncEnums.DeviceType|null} [deviceType] DeviceInfoSpecifics deviceType
         * @property {string|null} [syncUserAgent] DeviceInfoSpecifics syncUserAgent
         * @property {string|null} [chromeVersion] DeviceInfoSpecifics chromeVersion
         * @property {number|Long|null} [deprecatedBackupTimestamp] DeviceInfoSpecifics deprecatedBackupTimestamp
         * @property {string|null} [signinScopedDeviceId] DeviceInfoSpecifics signinScopedDeviceId
         * @property {number|Long|null} [lastUpdatedTimestamp] DeviceInfoSpecifics lastUpdatedTimestamp
         * @property {sync_pb.IFeatureSpecificFields|null} [featureFields] DeviceInfoSpecifics featureFields
         * @property {sync_pb.ISharingSpecificFields|null} [sharingFields] DeviceInfoSpecifics sharingFields
         * @property {string|null} [model] DeviceInfoSpecifics model
         * @property {string|null} [manufacturer] DeviceInfoSpecifics manufacturer
         * @property {number|null} [pulseIntervalInMinutes] DeviceInfoSpecifics pulseIntervalInMinutes
         */

        /**
         * Constructs a new DeviceInfoSpecifics.
         * @memberof sync_pb
         * @classdesc Represents a DeviceInfoSpecifics.
         * @implements IDeviceInfoSpecifics
         * @constructor
         * @param {sync_pb.IDeviceInfoSpecifics=} [properties] Properties to set
         */
        function DeviceInfoSpecifics(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeviceInfoSpecifics cacheGuid.
         * @member {string} cacheGuid
         * @memberof sync_pb.DeviceInfoSpecifics
         * @instance
         */
        DeviceInfoSpecifics.prototype.cacheGuid = "";

        /**
         * DeviceInfoSpecifics clientName.
         * @member {string} clientName
         * @memberof sync_pb.DeviceInfoSpecifics
         * @instance
         */
        DeviceInfoSpecifics.prototype.clientName = "";

        /**
         * DeviceInfoSpecifics deviceType.
         * @member {sync_pb.SyncEnums.DeviceType} deviceType
         * @memberof sync_pb.DeviceInfoSpecifics
         * @instance
         */
        DeviceInfoSpecifics.prototype.deviceType = 0;

        /**
         * DeviceInfoSpecifics syncUserAgent.
         * @member {string} syncUserAgent
         * @memberof sync_pb.DeviceInfoSpecifics
         * @instance
         */
        DeviceInfoSpecifics.prototype.syncUserAgent = "";

        /**
         * DeviceInfoSpecifics chromeVersion.
         * @member {string} chromeVersion
         * @memberof sync_pb.DeviceInfoSpecifics
         * @instance
         */
        DeviceInfoSpecifics.prototype.chromeVersion = "";

        /**
         * DeviceInfoSpecifics deprecatedBackupTimestamp.
         * @member {number|Long} deprecatedBackupTimestamp
         * @memberof sync_pb.DeviceInfoSpecifics
         * @instance
         */
        DeviceInfoSpecifics.prototype.deprecatedBackupTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * DeviceInfoSpecifics signinScopedDeviceId.
         * @member {string} signinScopedDeviceId
         * @memberof sync_pb.DeviceInfoSpecifics
         * @instance
         */
        DeviceInfoSpecifics.prototype.signinScopedDeviceId = "";

        /**
         * DeviceInfoSpecifics lastUpdatedTimestamp.
         * @member {number|Long} lastUpdatedTimestamp
         * @memberof sync_pb.DeviceInfoSpecifics
         * @instance
         */
        DeviceInfoSpecifics.prototype.lastUpdatedTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * DeviceInfoSpecifics featureFields.
         * @member {sync_pb.IFeatureSpecificFields|null|undefined} featureFields
         * @memberof sync_pb.DeviceInfoSpecifics
         * @instance
         */
        DeviceInfoSpecifics.prototype.featureFields = null;

        /**
         * DeviceInfoSpecifics sharingFields.
         * @member {sync_pb.ISharingSpecificFields|null|undefined} sharingFields
         * @memberof sync_pb.DeviceInfoSpecifics
         * @instance
         */
        DeviceInfoSpecifics.prototype.sharingFields = null;

        /**
         * DeviceInfoSpecifics model.
         * @member {string} model
         * @memberof sync_pb.DeviceInfoSpecifics
         * @instance
         */
        DeviceInfoSpecifics.prototype.model = "";

        /**
         * DeviceInfoSpecifics manufacturer.
         * @member {string} manufacturer
         * @memberof sync_pb.DeviceInfoSpecifics
         * @instance
         */
        DeviceInfoSpecifics.prototype.manufacturer = "";

        /**
         * DeviceInfoSpecifics pulseIntervalInMinutes.
         * @member {number} pulseIntervalInMinutes
         * @memberof sync_pb.DeviceInfoSpecifics
         * @instance
         */
        DeviceInfoSpecifics.prototype.pulseIntervalInMinutes = 0;

        /**
         * Creates a new DeviceInfoSpecifics instance using the specified properties.
         * @function create
         * @memberof sync_pb.DeviceInfoSpecifics
         * @static
         * @param {sync_pb.IDeviceInfoSpecifics=} [properties] Properties to set
         * @returns {sync_pb.DeviceInfoSpecifics} DeviceInfoSpecifics instance
         */
        DeviceInfoSpecifics.create = function create(properties) {
            return new DeviceInfoSpecifics(properties);
        };

        /**
         * Encodes the specified DeviceInfoSpecifics message. Does not implicitly {@link sync_pb.DeviceInfoSpecifics.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.DeviceInfoSpecifics
         * @static
         * @param {sync_pb.IDeviceInfoSpecifics} message DeviceInfoSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeviceInfoSpecifics.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cacheGuid != null && Object.hasOwnProperty.call(message, "cacheGuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.cacheGuid);
            if (message.clientName != null && Object.hasOwnProperty.call(message, "clientName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.clientName);
            if (message.deviceType != null && Object.hasOwnProperty.call(message, "deviceType"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.deviceType);
            if (message.syncUserAgent != null && Object.hasOwnProperty.call(message, "syncUserAgent"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.syncUserAgent);
            if (message.chromeVersion != null && Object.hasOwnProperty.call(message, "chromeVersion"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.chromeVersion);
            if (message.deprecatedBackupTimestamp != null && Object.hasOwnProperty.call(message, "deprecatedBackupTimestamp"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.deprecatedBackupTimestamp);
            if (message.signinScopedDeviceId != null && Object.hasOwnProperty.call(message, "signinScopedDeviceId"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.signinScopedDeviceId);
            if (message.lastUpdatedTimestamp != null && Object.hasOwnProperty.call(message, "lastUpdatedTimestamp"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.lastUpdatedTimestamp);
            if (message.featureFields != null && Object.hasOwnProperty.call(message, "featureFields"))
                $root.sync_pb.FeatureSpecificFields.encode(message.featureFields, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            if (message.sharingFields != null && Object.hasOwnProperty.call(message, "sharingFields"))
                $root.sync_pb.SharingSpecificFields.encode(message.sharingFields, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.model);
            if (message.manufacturer != null && Object.hasOwnProperty.call(message, "manufacturer"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.manufacturer);
            if (message.pulseIntervalInMinutes != null && Object.hasOwnProperty.call(message, "pulseIntervalInMinutes"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.pulseIntervalInMinutes);
            return writer;
        };

        /**
         * Encodes the specified DeviceInfoSpecifics message, length delimited. Does not implicitly {@link sync_pb.DeviceInfoSpecifics.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.DeviceInfoSpecifics
         * @static
         * @param {sync_pb.IDeviceInfoSpecifics} message DeviceInfoSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeviceInfoSpecifics.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeviceInfoSpecifics message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.DeviceInfoSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.DeviceInfoSpecifics} DeviceInfoSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeviceInfoSpecifics.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.DeviceInfoSpecifics();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.cacheGuid = reader.string();
                    break;
                case 2:
                    message.clientName = reader.string();
                    break;
                case 3:
                    message.deviceType = reader.int32();
                    break;
                case 4:
                    message.syncUserAgent = reader.string();
                    break;
                case 5:
                    message.chromeVersion = reader.string();
                    break;
                case 6:
                    message.deprecatedBackupTimestamp = reader.int64();
                    break;
                case 7:
                    message.signinScopedDeviceId = reader.string();
                    break;
                case 8:
                    message.lastUpdatedTimestamp = reader.int64();
                    break;
                case 9:
                    message.featureFields = $root.sync_pb.FeatureSpecificFields.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.sharingFields = $root.sync_pb.SharingSpecificFields.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.model = reader.string();
                    break;
                case 12:
                    message.manufacturer = reader.string();
                    break;
                case 13:
                    message.pulseIntervalInMinutes = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeviceInfoSpecifics message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.DeviceInfoSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.DeviceInfoSpecifics} DeviceInfoSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeviceInfoSpecifics.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeviceInfoSpecifics message.
         * @function verify
         * @memberof sync_pb.DeviceInfoSpecifics
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeviceInfoSpecifics.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.cacheGuid != null && message.hasOwnProperty("cacheGuid"))
                if (!$util.isString(message.cacheGuid))
                    return "cacheGuid: string expected";
            if (message.clientName != null && message.hasOwnProperty("clientName"))
                if (!$util.isString(message.clientName))
                    return "clientName: string expected";
            if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                switch (message.deviceType) {
                default:
                    return "deviceType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                    break;
                }
            if (message.syncUserAgent != null && message.hasOwnProperty("syncUserAgent"))
                if (!$util.isString(message.syncUserAgent))
                    return "syncUserAgent: string expected";
            if (message.chromeVersion != null && message.hasOwnProperty("chromeVersion"))
                if (!$util.isString(message.chromeVersion))
                    return "chromeVersion: string expected";
            if (message.deprecatedBackupTimestamp != null && message.hasOwnProperty("deprecatedBackupTimestamp"))
                if (!$util.isInteger(message.deprecatedBackupTimestamp) && !(message.deprecatedBackupTimestamp && $util.isInteger(message.deprecatedBackupTimestamp.low) && $util.isInteger(message.deprecatedBackupTimestamp.high)))
                    return "deprecatedBackupTimestamp: integer|Long expected";
            if (message.signinScopedDeviceId != null && message.hasOwnProperty("signinScopedDeviceId"))
                if (!$util.isString(message.signinScopedDeviceId))
                    return "signinScopedDeviceId: string expected";
            if (message.lastUpdatedTimestamp != null && message.hasOwnProperty("lastUpdatedTimestamp"))
                if (!$util.isInteger(message.lastUpdatedTimestamp) && !(message.lastUpdatedTimestamp && $util.isInteger(message.lastUpdatedTimestamp.low) && $util.isInteger(message.lastUpdatedTimestamp.high)))
                    return "lastUpdatedTimestamp: integer|Long expected";
            if (message.featureFields != null && message.hasOwnProperty("featureFields")) {
                let error = $root.sync_pb.FeatureSpecificFields.verify(message.featureFields);
                if (error)
                    return "featureFields." + error;
            }
            if (message.sharingFields != null && message.hasOwnProperty("sharingFields")) {
                let error = $root.sync_pb.SharingSpecificFields.verify(message.sharingFields);
                if (error)
                    return "sharingFields." + error;
            }
            if (message.model != null && message.hasOwnProperty("model"))
                if (!$util.isString(message.model))
                    return "model: string expected";
            if (message.manufacturer != null && message.hasOwnProperty("manufacturer"))
                if (!$util.isString(message.manufacturer))
                    return "manufacturer: string expected";
            if (message.pulseIntervalInMinutes != null && message.hasOwnProperty("pulseIntervalInMinutes"))
                if (!$util.isInteger(message.pulseIntervalInMinutes))
                    return "pulseIntervalInMinutes: integer expected";
            return null;
        };

        /**
         * Creates a DeviceInfoSpecifics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.DeviceInfoSpecifics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.DeviceInfoSpecifics} DeviceInfoSpecifics
         */
        DeviceInfoSpecifics.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.DeviceInfoSpecifics)
                return object;
            let message = new $root.sync_pb.DeviceInfoSpecifics();
            if (object.cacheGuid != null)
                message.cacheGuid = String(object.cacheGuid);
            if (object.clientName != null)
                message.clientName = String(object.clientName);
            switch (object.deviceType) {
            case "TYPE_UNSET":
            case 0:
                message.deviceType = 0;
                break;
            case "TYPE_WIN":
            case 1:
                message.deviceType = 1;
                break;
            case "TYPE_MAC":
            case 2:
                message.deviceType = 2;
                break;
            case "TYPE_LINUX":
            case 3:
                message.deviceType = 3;
                break;
            case "TYPE_CROS":
            case 4:
                message.deviceType = 4;
                break;
            case "TYPE_OTHER":
            case 5:
                message.deviceType = 5;
                break;
            case "TYPE_PHONE":
            case 6:
                message.deviceType = 6;
                break;
            case "TYPE_TABLET":
            case 7:
                message.deviceType = 7;
                break;
            }
            if (object.syncUserAgent != null)
                message.syncUserAgent = String(object.syncUserAgent);
            if (object.chromeVersion != null)
                message.chromeVersion = String(object.chromeVersion);
            if (object.deprecatedBackupTimestamp != null)
                if ($util.Long)
                    (message.deprecatedBackupTimestamp = $util.Long.fromValue(object.deprecatedBackupTimestamp)).unsigned = false;
                else if (typeof object.deprecatedBackupTimestamp === "string")
                    message.deprecatedBackupTimestamp = parseInt(object.deprecatedBackupTimestamp, 10);
                else if (typeof object.deprecatedBackupTimestamp === "number")
                    message.deprecatedBackupTimestamp = object.deprecatedBackupTimestamp;
                else if (typeof object.deprecatedBackupTimestamp === "object")
                    message.deprecatedBackupTimestamp = new $util.LongBits(object.deprecatedBackupTimestamp.low >>> 0, object.deprecatedBackupTimestamp.high >>> 0).toNumber();
            if (object.signinScopedDeviceId != null)
                message.signinScopedDeviceId = String(object.signinScopedDeviceId);
            if (object.lastUpdatedTimestamp != null)
                if ($util.Long)
                    (message.lastUpdatedTimestamp = $util.Long.fromValue(object.lastUpdatedTimestamp)).unsigned = false;
                else if (typeof object.lastUpdatedTimestamp === "string")
                    message.lastUpdatedTimestamp = parseInt(object.lastUpdatedTimestamp, 10);
                else if (typeof object.lastUpdatedTimestamp === "number")
                    message.lastUpdatedTimestamp = object.lastUpdatedTimestamp;
                else if (typeof object.lastUpdatedTimestamp === "object")
                    message.lastUpdatedTimestamp = new $util.LongBits(object.lastUpdatedTimestamp.low >>> 0, object.lastUpdatedTimestamp.high >>> 0).toNumber();
            if (object.featureFields != null) {
                if (typeof object.featureFields !== "object")
                    throw TypeError(".sync_pb.DeviceInfoSpecifics.featureFields: object expected");
                message.featureFields = $root.sync_pb.FeatureSpecificFields.fromObject(object.featureFields);
            }
            if (object.sharingFields != null) {
                if (typeof object.sharingFields !== "object")
                    throw TypeError(".sync_pb.DeviceInfoSpecifics.sharingFields: object expected");
                message.sharingFields = $root.sync_pb.SharingSpecificFields.fromObject(object.sharingFields);
            }
            if (object.model != null)
                message.model = String(object.model);
            if (object.manufacturer != null)
                message.manufacturer = String(object.manufacturer);
            if (object.pulseIntervalInMinutes != null)
                message.pulseIntervalInMinutes = object.pulseIntervalInMinutes | 0;
            return message;
        };

        /**
         * Creates a plain object from a DeviceInfoSpecifics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.DeviceInfoSpecifics
         * @static
         * @param {sync_pb.DeviceInfoSpecifics} message DeviceInfoSpecifics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeviceInfoSpecifics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.cacheGuid = "";
                object.clientName = "";
                object.deviceType = options.enums === String ? "TYPE_UNSET" : 0;
                object.syncUserAgent = "";
                object.chromeVersion = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.deprecatedBackupTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deprecatedBackupTimestamp = options.longs === String ? "0" : 0;
                object.signinScopedDeviceId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.lastUpdatedTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastUpdatedTimestamp = options.longs === String ? "0" : 0;
                object.featureFields = null;
                object.sharingFields = null;
                object.model = "";
                object.manufacturer = "";
                object.pulseIntervalInMinutes = 0;
            }
            if (message.cacheGuid != null && message.hasOwnProperty("cacheGuid"))
                object.cacheGuid = message.cacheGuid;
            if (message.clientName != null && message.hasOwnProperty("clientName"))
                object.clientName = message.clientName;
            if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                object.deviceType = options.enums === String ? $root.sync_pb.SyncEnums.DeviceType[message.deviceType] : message.deviceType;
            if (message.syncUserAgent != null && message.hasOwnProperty("syncUserAgent"))
                object.syncUserAgent = message.syncUserAgent;
            if (message.chromeVersion != null && message.hasOwnProperty("chromeVersion"))
                object.chromeVersion = message.chromeVersion;
            if (message.deprecatedBackupTimestamp != null && message.hasOwnProperty("deprecatedBackupTimestamp"))
                if (typeof message.deprecatedBackupTimestamp === "number")
                    object.deprecatedBackupTimestamp = options.longs === String ? String(message.deprecatedBackupTimestamp) : message.deprecatedBackupTimestamp;
                else
                    object.deprecatedBackupTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.deprecatedBackupTimestamp) : options.longs === Number ? new $util.LongBits(message.deprecatedBackupTimestamp.low >>> 0, message.deprecatedBackupTimestamp.high >>> 0).toNumber() : message.deprecatedBackupTimestamp;
            if (message.signinScopedDeviceId != null && message.hasOwnProperty("signinScopedDeviceId"))
                object.signinScopedDeviceId = message.signinScopedDeviceId;
            if (message.lastUpdatedTimestamp != null && message.hasOwnProperty("lastUpdatedTimestamp"))
                if (typeof message.lastUpdatedTimestamp === "number")
                    object.lastUpdatedTimestamp = options.longs === String ? String(message.lastUpdatedTimestamp) : message.lastUpdatedTimestamp;
                else
                    object.lastUpdatedTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdatedTimestamp) : options.longs === Number ? new $util.LongBits(message.lastUpdatedTimestamp.low >>> 0, message.lastUpdatedTimestamp.high >>> 0).toNumber() : message.lastUpdatedTimestamp;
            if (message.featureFields != null && message.hasOwnProperty("featureFields"))
                object.featureFields = $root.sync_pb.FeatureSpecificFields.toObject(message.featureFields, options);
            if (message.sharingFields != null && message.hasOwnProperty("sharingFields"))
                object.sharingFields = $root.sync_pb.SharingSpecificFields.toObject(message.sharingFields, options);
            if (message.model != null && message.hasOwnProperty("model"))
                object.model = message.model;
            if (message.manufacturer != null && message.hasOwnProperty("manufacturer"))
                object.manufacturer = message.manufacturer;
            if (message.pulseIntervalInMinutes != null && message.hasOwnProperty("pulseIntervalInMinutes"))
                object.pulseIntervalInMinutes = message.pulseIntervalInMinutes;
            return object;
        };

        /**
         * Converts this DeviceInfoSpecifics to JSON.
         * @function toJSON
         * @memberof sync_pb.DeviceInfoSpecifics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeviceInfoSpecifics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DeviceInfoSpecifics;
    })();

    sync_pb.FeatureSpecificFields = (function() {

        /**
         * Properties of a FeatureSpecificFields.
         * @memberof sync_pb
         * @interface IFeatureSpecificFields
         * @property {boolean|null} [sendTabToSelfReceivingEnabled] FeatureSpecificFields sendTabToSelfReceivingEnabled
         */

        /**
         * Constructs a new FeatureSpecificFields.
         * @memberof sync_pb
         * @classdesc Represents a FeatureSpecificFields.
         * @implements IFeatureSpecificFields
         * @constructor
         * @param {sync_pb.IFeatureSpecificFields=} [properties] Properties to set
         */
        function FeatureSpecificFields(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FeatureSpecificFields sendTabToSelfReceivingEnabled.
         * @member {boolean} sendTabToSelfReceivingEnabled
         * @memberof sync_pb.FeatureSpecificFields
         * @instance
         */
        FeatureSpecificFields.prototype.sendTabToSelfReceivingEnabled = false;

        /**
         * Creates a new FeatureSpecificFields instance using the specified properties.
         * @function create
         * @memberof sync_pb.FeatureSpecificFields
         * @static
         * @param {sync_pb.IFeatureSpecificFields=} [properties] Properties to set
         * @returns {sync_pb.FeatureSpecificFields} FeatureSpecificFields instance
         */
        FeatureSpecificFields.create = function create(properties) {
            return new FeatureSpecificFields(properties);
        };

        /**
         * Encodes the specified FeatureSpecificFields message. Does not implicitly {@link sync_pb.FeatureSpecificFields.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.FeatureSpecificFields
         * @static
         * @param {sync_pb.IFeatureSpecificFields} message FeatureSpecificFields message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FeatureSpecificFields.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sendTabToSelfReceivingEnabled != null && Object.hasOwnProperty.call(message, "sendTabToSelfReceivingEnabled"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.sendTabToSelfReceivingEnabled);
            return writer;
        };

        /**
         * Encodes the specified FeatureSpecificFields message, length delimited. Does not implicitly {@link sync_pb.FeatureSpecificFields.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.FeatureSpecificFields
         * @static
         * @param {sync_pb.IFeatureSpecificFields} message FeatureSpecificFields message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FeatureSpecificFields.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FeatureSpecificFields message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.FeatureSpecificFields
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.FeatureSpecificFields} FeatureSpecificFields
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FeatureSpecificFields.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.FeatureSpecificFields();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.sendTabToSelfReceivingEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FeatureSpecificFields message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.FeatureSpecificFields
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.FeatureSpecificFields} FeatureSpecificFields
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FeatureSpecificFields.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FeatureSpecificFields message.
         * @function verify
         * @memberof sync_pb.FeatureSpecificFields
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FeatureSpecificFields.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sendTabToSelfReceivingEnabled != null && message.hasOwnProperty("sendTabToSelfReceivingEnabled"))
                if (typeof message.sendTabToSelfReceivingEnabled !== "boolean")
                    return "sendTabToSelfReceivingEnabled: boolean expected";
            return null;
        };

        /**
         * Creates a FeatureSpecificFields message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.FeatureSpecificFields
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.FeatureSpecificFields} FeatureSpecificFields
         */
        FeatureSpecificFields.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.FeatureSpecificFields)
                return object;
            let message = new $root.sync_pb.FeatureSpecificFields();
            if (object.sendTabToSelfReceivingEnabled != null)
                message.sendTabToSelfReceivingEnabled = Boolean(object.sendTabToSelfReceivingEnabled);
            return message;
        };

        /**
         * Creates a plain object from a FeatureSpecificFields message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.FeatureSpecificFields
         * @static
         * @param {sync_pb.FeatureSpecificFields} message FeatureSpecificFields
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FeatureSpecificFields.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.sendTabToSelfReceivingEnabled = false;
            if (message.sendTabToSelfReceivingEnabled != null && message.hasOwnProperty("sendTabToSelfReceivingEnabled"))
                object.sendTabToSelfReceivingEnabled = message.sendTabToSelfReceivingEnabled;
            return object;
        };

        /**
         * Converts this FeatureSpecificFields to JSON.
         * @function toJSON
         * @memberof sync_pb.FeatureSpecificFields
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FeatureSpecificFields.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FeatureSpecificFields;
    })();

    sync_pb.SharingSpecificFields = (function() {

        /**
         * Properties of a SharingSpecificFields.
         * @memberof sync_pb
         * @interface ISharingSpecificFields
         * @property {string|null} [fcmToken] SharingSpecificFields fcmToken
         * @property {Uint8Array|null} [p256dh] SharingSpecificFields p256dh
         * @property {Uint8Array|null} [authSecret] SharingSpecificFields authSecret
         * @property {Array.<sync_pb.SharingSpecificFields.EnabledFeatures>|null} [enabledFeatures] SharingSpecificFields enabledFeatures
         * @property {string|null} [senderIdFcmTokenDeprecated] SharingSpecificFields senderIdFcmTokenDeprecated
         * @property {Uint8Array|null} [senderIdP256dhDeprecated] SharingSpecificFields senderIdP256dhDeprecated
         * @property {Uint8Array|null} [senderIdAuthSecretDeprecated] SharingSpecificFields senderIdAuthSecretDeprecated
         * @property {string|null} [senderIdFcmTokenV2] SharingSpecificFields senderIdFcmTokenV2
         * @property {Uint8Array|null} [senderIdP256dhV2] SharingSpecificFields senderIdP256dhV2
         * @property {Uint8Array|null} [senderIdAuthSecretV2] SharingSpecificFields senderIdAuthSecretV2
         */

        /**
         * Constructs a new SharingSpecificFields.
         * @memberof sync_pb
         * @classdesc Represents a SharingSpecificFields.
         * @implements ISharingSpecificFields
         * @constructor
         * @param {sync_pb.ISharingSpecificFields=} [properties] Properties to set
         */
        function SharingSpecificFields(properties) {
            this.enabledFeatures = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SharingSpecificFields fcmToken.
         * @member {string} fcmToken
         * @memberof sync_pb.SharingSpecificFields
         * @instance
         */
        SharingSpecificFields.prototype.fcmToken = "";

        /**
         * SharingSpecificFields p256dh.
         * @member {Uint8Array} p256dh
         * @memberof sync_pb.SharingSpecificFields
         * @instance
         */
        SharingSpecificFields.prototype.p256dh = $util.newBuffer([]);

        /**
         * SharingSpecificFields authSecret.
         * @member {Uint8Array} authSecret
         * @memberof sync_pb.SharingSpecificFields
         * @instance
         */
        SharingSpecificFields.prototype.authSecret = $util.newBuffer([]);

        /**
         * SharingSpecificFields enabledFeatures.
         * @member {Array.<sync_pb.SharingSpecificFields.EnabledFeatures>} enabledFeatures
         * @memberof sync_pb.SharingSpecificFields
         * @instance
         */
        SharingSpecificFields.prototype.enabledFeatures = $util.emptyArray;

        /**
         * SharingSpecificFields senderIdFcmTokenDeprecated.
         * @member {string} senderIdFcmTokenDeprecated
         * @memberof sync_pb.SharingSpecificFields
         * @instance
         */
        SharingSpecificFields.prototype.senderIdFcmTokenDeprecated = "";

        /**
         * SharingSpecificFields senderIdP256dhDeprecated.
         * @member {Uint8Array} senderIdP256dhDeprecated
         * @memberof sync_pb.SharingSpecificFields
         * @instance
         */
        SharingSpecificFields.prototype.senderIdP256dhDeprecated = $util.newBuffer([]);

        /**
         * SharingSpecificFields senderIdAuthSecretDeprecated.
         * @member {Uint8Array} senderIdAuthSecretDeprecated
         * @memberof sync_pb.SharingSpecificFields
         * @instance
         */
        SharingSpecificFields.prototype.senderIdAuthSecretDeprecated = $util.newBuffer([]);

        /**
         * SharingSpecificFields senderIdFcmTokenV2.
         * @member {string} senderIdFcmTokenV2
         * @memberof sync_pb.SharingSpecificFields
         * @instance
         */
        SharingSpecificFields.prototype.senderIdFcmTokenV2 = "";

        /**
         * SharingSpecificFields senderIdP256dhV2.
         * @member {Uint8Array} senderIdP256dhV2
         * @memberof sync_pb.SharingSpecificFields
         * @instance
         */
        SharingSpecificFields.prototype.senderIdP256dhV2 = $util.newBuffer([]);

        /**
         * SharingSpecificFields senderIdAuthSecretV2.
         * @member {Uint8Array} senderIdAuthSecretV2
         * @memberof sync_pb.SharingSpecificFields
         * @instance
         */
        SharingSpecificFields.prototype.senderIdAuthSecretV2 = $util.newBuffer([]);

        /**
         * Creates a new SharingSpecificFields instance using the specified properties.
         * @function create
         * @memberof sync_pb.SharingSpecificFields
         * @static
         * @param {sync_pb.ISharingSpecificFields=} [properties] Properties to set
         * @returns {sync_pb.SharingSpecificFields} SharingSpecificFields instance
         */
        SharingSpecificFields.create = function create(properties) {
            return new SharingSpecificFields(properties);
        };

        /**
         * Encodes the specified SharingSpecificFields message. Does not implicitly {@link sync_pb.SharingSpecificFields.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SharingSpecificFields
         * @static
         * @param {sync_pb.ISharingSpecificFields} message SharingSpecificFields message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SharingSpecificFields.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fcmToken != null && Object.hasOwnProperty.call(message, "fcmToken"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fcmToken);
            if (message.p256dh != null && Object.hasOwnProperty.call(message, "p256dh"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.p256dh);
            if (message.authSecret != null && Object.hasOwnProperty.call(message, "authSecret"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.authSecret);
            if (message.enabledFeatures != null && message.enabledFeatures.length)
                for (let i = 0; i < message.enabledFeatures.length; ++i)
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.enabledFeatures[i]);
            if (message.senderIdFcmTokenDeprecated != null && Object.hasOwnProperty.call(message, "senderIdFcmTokenDeprecated"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.senderIdFcmTokenDeprecated);
            if (message.senderIdP256dhDeprecated != null && Object.hasOwnProperty.call(message, "senderIdP256dhDeprecated"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.senderIdP256dhDeprecated);
            if (message.senderIdAuthSecretDeprecated != null && Object.hasOwnProperty.call(message, "senderIdAuthSecretDeprecated"))
                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.senderIdAuthSecretDeprecated);
            if (message.senderIdFcmTokenV2 != null && Object.hasOwnProperty.call(message, "senderIdFcmTokenV2"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.senderIdFcmTokenV2);
            if (message.senderIdP256dhV2 != null && Object.hasOwnProperty.call(message, "senderIdP256dhV2"))
                writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.senderIdP256dhV2);
            if (message.senderIdAuthSecretV2 != null && Object.hasOwnProperty.call(message, "senderIdAuthSecretV2"))
                writer.uint32(/* id 10, wireType 2 =*/82).bytes(message.senderIdAuthSecretV2);
            return writer;
        };

        /**
         * Encodes the specified SharingSpecificFields message, length delimited. Does not implicitly {@link sync_pb.SharingSpecificFields.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SharingSpecificFields
         * @static
         * @param {sync_pb.ISharingSpecificFields} message SharingSpecificFields message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SharingSpecificFields.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SharingSpecificFields message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SharingSpecificFields
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SharingSpecificFields} SharingSpecificFields
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SharingSpecificFields.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SharingSpecificFields();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fcmToken = reader.string();
                    break;
                case 2:
                    message.p256dh = reader.bytes();
                    break;
                case 3:
                    message.authSecret = reader.bytes();
                    break;
                case 4:
                    if (!(message.enabledFeatures && message.enabledFeatures.length))
                        message.enabledFeatures = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.enabledFeatures.push(reader.int32());
                    } else
                        message.enabledFeatures.push(reader.int32());
                    break;
                case 5:
                    message.senderIdFcmTokenDeprecated = reader.string();
                    break;
                case 6:
                    message.senderIdP256dhDeprecated = reader.bytes();
                    break;
                case 7:
                    message.senderIdAuthSecretDeprecated = reader.bytes();
                    break;
                case 8:
                    message.senderIdFcmTokenV2 = reader.string();
                    break;
                case 9:
                    message.senderIdP256dhV2 = reader.bytes();
                    break;
                case 10:
                    message.senderIdAuthSecretV2 = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SharingSpecificFields message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SharingSpecificFields
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SharingSpecificFields} SharingSpecificFields
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SharingSpecificFields.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SharingSpecificFields message.
         * @function verify
         * @memberof sync_pb.SharingSpecificFields
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SharingSpecificFields.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fcmToken != null && message.hasOwnProperty("fcmToken"))
                if (!$util.isString(message.fcmToken))
                    return "fcmToken: string expected";
            if (message.p256dh != null && message.hasOwnProperty("p256dh"))
                if (!(message.p256dh && typeof message.p256dh.length === "number" || $util.isString(message.p256dh)))
                    return "p256dh: buffer expected";
            if (message.authSecret != null && message.hasOwnProperty("authSecret"))
                if (!(message.authSecret && typeof message.authSecret.length === "number" || $util.isString(message.authSecret)))
                    return "authSecret: buffer expected";
            if (message.enabledFeatures != null && message.hasOwnProperty("enabledFeatures")) {
                if (!Array.isArray(message.enabledFeatures))
                    return "enabledFeatures: array expected";
                for (let i = 0; i < message.enabledFeatures.length; ++i)
                    switch (message.enabledFeatures[i]) {
                    default:
                        return "enabledFeatures: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                        break;
                    }
            }
            if (message.senderIdFcmTokenDeprecated != null && message.hasOwnProperty("senderIdFcmTokenDeprecated"))
                if (!$util.isString(message.senderIdFcmTokenDeprecated))
                    return "senderIdFcmTokenDeprecated: string expected";
            if (message.senderIdP256dhDeprecated != null && message.hasOwnProperty("senderIdP256dhDeprecated"))
                if (!(message.senderIdP256dhDeprecated && typeof message.senderIdP256dhDeprecated.length === "number" || $util.isString(message.senderIdP256dhDeprecated)))
                    return "senderIdP256dhDeprecated: buffer expected";
            if (message.senderIdAuthSecretDeprecated != null && message.hasOwnProperty("senderIdAuthSecretDeprecated"))
                if (!(message.senderIdAuthSecretDeprecated && typeof message.senderIdAuthSecretDeprecated.length === "number" || $util.isString(message.senderIdAuthSecretDeprecated)))
                    return "senderIdAuthSecretDeprecated: buffer expected";
            if (message.senderIdFcmTokenV2 != null && message.hasOwnProperty("senderIdFcmTokenV2"))
                if (!$util.isString(message.senderIdFcmTokenV2))
                    return "senderIdFcmTokenV2: string expected";
            if (message.senderIdP256dhV2 != null && message.hasOwnProperty("senderIdP256dhV2"))
                if (!(message.senderIdP256dhV2 && typeof message.senderIdP256dhV2.length === "number" || $util.isString(message.senderIdP256dhV2)))
                    return "senderIdP256dhV2: buffer expected";
            if (message.senderIdAuthSecretV2 != null && message.hasOwnProperty("senderIdAuthSecretV2"))
                if (!(message.senderIdAuthSecretV2 && typeof message.senderIdAuthSecretV2.length === "number" || $util.isString(message.senderIdAuthSecretV2)))
                    return "senderIdAuthSecretV2: buffer expected";
            return null;
        };

        /**
         * Creates a SharingSpecificFields message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SharingSpecificFields
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SharingSpecificFields} SharingSpecificFields
         */
        SharingSpecificFields.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SharingSpecificFields)
                return object;
            let message = new $root.sync_pb.SharingSpecificFields();
            if (object.fcmToken != null)
                message.fcmToken = String(object.fcmToken);
            if (object.p256dh != null)
                if (typeof object.p256dh === "string")
                    $util.base64.decode(object.p256dh, message.p256dh = $util.newBuffer($util.base64.length(object.p256dh)), 0);
                else if (object.p256dh.length)
                    message.p256dh = object.p256dh;
            if (object.authSecret != null)
                if (typeof object.authSecret === "string")
                    $util.base64.decode(object.authSecret, message.authSecret = $util.newBuffer($util.base64.length(object.authSecret)), 0);
                else if (object.authSecret.length)
                    message.authSecret = object.authSecret;
            if (object.enabledFeatures) {
                if (!Array.isArray(object.enabledFeatures))
                    throw TypeError(".sync_pb.SharingSpecificFields.enabledFeatures: array expected");
                message.enabledFeatures = [];
                for (let i = 0; i < object.enabledFeatures.length; ++i)
                    switch (object.enabledFeatures[i]) {
                    default:
                    case "UNKNOWN":
                    case 0:
                        message.enabledFeatures[i] = 0;
                        break;
                    case "CLICK_TO_CALL_VAPID":
                    case 1:
                        message.enabledFeatures[i] = 1;
                        break;
                    case "SHARED_CLIPBOARD_VAPID":
                    case 2:
                        message.enabledFeatures[i] = 2;
                        break;
                    case "SMS_FETCHER":
                    case 3:
                        message.enabledFeatures[i] = 3;
                        break;
                    case "REMOTE_COPY":
                    case 4:
                        message.enabledFeatures[i] = 4;
                        break;
                    case "PEER_CONNECTION":
                    case 5:
                        message.enabledFeatures[i] = 5;
                        break;
                    case "DISCOVERY":
                    case 6:
                        message.enabledFeatures[i] = 6;
                        break;
                    case "CLICK_TO_CALL_V2":
                    case 7:
                        message.enabledFeatures[i] = 7;
                        break;
                    case "SHARED_CLIPBOARD_V2":
                    case 8:
                        message.enabledFeatures[i] = 8;
                        break;
                    }
            }
            if (object.senderIdFcmTokenDeprecated != null)
                message.senderIdFcmTokenDeprecated = String(object.senderIdFcmTokenDeprecated);
            if (object.senderIdP256dhDeprecated != null)
                if (typeof object.senderIdP256dhDeprecated === "string")
                    $util.base64.decode(object.senderIdP256dhDeprecated, message.senderIdP256dhDeprecated = $util.newBuffer($util.base64.length(object.senderIdP256dhDeprecated)), 0);
                else if (object.senderIdP256dhDeprecated.length)
                    message.senderIdP256dhDeprecated = object.senderIdP256dhDeprecated;
            if (object.senderIdAuthSecretDeprecated != null)
                if (typeof object.senderIdAuthSecretDeprecated === "string")
                    $util.base64.decode(object.senderIdAuthSecretDeprecated, message.senderIdAuthSecretDeprecated = $util.newBuffer($util.base64.length(object.senderIdAuthSecretDeprecated)), 0);
                else if (object.senderIdAuthSecretDeprecated.length)
                    message.senderIdAuthSecretDeprecated = object.senderIdAuthSecretDeprecated;
            if (object.senderIdFcmTokenV2 != null)
                message.senderIdFcmTokenV2 = String(object.senderIdFcmTokenV2);
            if (object.senderIdP256dhV2 != null)
                if (typeof object.senderIdP256dhV2 === "string")
                    $util.base64.decode(object.senderIdP256dhV2, message.senderIdP256dhV2 = $util.newBuffer($util.base64.length(object.senderIdP256dhV2)), 0);
                else if (object.senderIdP256dhV2.length)
                    message.senderIdP256dhV2 = object.senderIdP256dhV2;
            if (object.senderIdAuthSecretV2 != null)
                if (typeof object.senderIdAuthSecretV2 === "string")
                    $util.base64.decode(object.senderIdAuthSecretV2, message.senderIdAuthSecretV2 = $util.newBuffer($util.base64.length(object.senderIdAuthSecretV2)), 0);
                else if (object.senderIdAuthSecretV2.length)
                    message.senderIdAuthSecretV2 = object.senderIdAuthSecretV2;
            return message;
        };

        /**
         * Creates a plain object from a SharingSpecificFields message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SharingSpecificFields
         * @static
         * @param {sync_pb.SharingSpecificFields} message SharingSpecificFields
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SharingSpecificFields.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.enabledFeatures = [];
            if (options.defaults) {
                object.fcmToken = "";
                if (options.bytes === String)
                    object.p256dh = "";
                else {
                    object.p256dh = [];
                    if (options.bytes !== Array)
                        object.p256dh = $util.newBuffer(object.p256dh);
                }
                if (options.bytes === String)
                    object.authSecret = "";
                else {
                    object.authSecret = [];
                    if (options.bytes !== Array)
                        object.authSecret = $util.newBuffer(object.authSecret);
                }
                object.senderIdFcmTokenDeprecated = "";
                if (options.bytes === String)
                    object.senderIdP256dhDeprecated = "";
                else {
                    object.senderIdP256dhDeprecated = [];
                    if (options.bytes !== Array)
                        object.senderIdP256dhDeprecated = $util.newBuffer(object.senderIdP256dhDeprecated);
                }
                if (options.bytes === String)
                    object.senderIdAuthSecretDeprecated = "";
                else {
                    object.senderIdAuthSecretDeprecated = [];
                    if (options.bytes !== Array)
                        object.senderIdAuthSecretDeprecated = $util.newBuffer(object.senderIdAuthSecretDeprecated);
                }
                object.senderIdFcmTokenV2 = "";
                if (options.bytes === String)
                    object.senderIdP256dhV2 = "";
                else {
                    object.senderIdP256dhV2 = [];
                    if (options.bytes !== Array)
                        object.senderIdP256dhV2 = $util.newBuffer(object.senderIdP256dhV2);
                }
                if (options.bytes === String)
                    object.senderIdAuthSecretV2 = "";
                else {
                    object.senderIdAuthSecretV2 = [];
                    if (options.bytes !== Array)
                        object.senderIdAuthSecretV2 = $util.newBuffer(object.senderIdAuthSecretV2);
                }
            }
            if (message.fcmToken != null && message.hasOwnProperty("fcmToken"))
                object.fcmToken = message.fcmToken;
            if (message.p256dh != null && message.hasOwnProperty("p256dh"))
                object.p256dh = options.bytes === String ? $util.base64.encode(message.p256dh, 0, message.p256dh.length) : options.bytes === Array ? Array.prototype.slice.call(message.p256dh) : message.p256dh;
            if (message.authSecret != null && message.hasOwnProperty("authSecret"))
                object.authSecret = options.bytes === String ? $util.base64.encode(message.authSecret, 0, message.authSecret.length) : options.bytes === Array ? Array.prototype.slice.call(message.authSecret) : message.authSecret;
            if (message.enabledFeatures && message.enabledFeatures.length) {
                object.enabledFeatures = [];
                for (let j = 0; j < message.enabledFeatures.length; ++j)
                    object.enabledFeatures[j] = options.enums === String ? $root.sync_pb.SharingSpecificFields.EnabledFeatures[message.enabledFeatures[j]] : message.enabledFeatures[j];
            }
            if (message.senderIdFcmTokenDeprecated != null && message.hasOwnProperty("senderIdFcmTokenDeprecated"))
                object.senderIdFcmTokenDeprecated = message.senderIdFcmTokenDeprecated;
            if (message.senderIdP256dhDeprecated != null && message.hasOwnProperty("senderIdP256dhDeprecated"))
                object.senderIdP256dhDeprecated = options.bytes === String ? $util.base64.encode(message.senderIdP256dhDeprecated, 0, message.senderIdP256dhDeprecated.length) : options.bytes === Array ? Array.prototype.slice.call(message.senderIdP256dhDeprecated) : message.senderIdP256dhDeprecated;
            if (message.senderIdAuthSecretDeprecated != null && message.hasOwnProperty("senderIdAuthSecretDeprecated"))
                object.senderIdAuthSecretDeprecated = options.bytes === String ? $util.base64.encode(message.senderIdAuthSecretDeprecated, 0, message.senderIdAuthSecretDeprecated.length) : options.bytes === Array ? Array.prototype.slice.call(message.senderIdAuthSecretDeprecated) : message.senderIdAuthSecretDeprecated;
            if (message.senderIdFcmTokenV2 != null && message.hasOwnProperty("senderIdFcmTokenV2"))
                object.senderIdFcmTokenV2 = message.senderIdFcmTokenV2;
            if (message.senderIdP256dhV2 != null && message.hasOwnProperty("senderIdP256dhV2"))
                object.senderIdP256dhV2 = options.bytes === String ? $util.base64.encode(message.senderIdP256dhV2, 0, message.senderIdP256dhV2.length) : options.bytes === Array ? Array.prototype.slice.call(message.senderIdP256dhV2) : message.senderIdP256dhV2;
            if (message.senderIdAuthSecretV2 != null && message.hasOwnProperty("senderIdAuthSecretV2"))
                object.senderIdAuthSecretV2 = options.bytes === String ? $util.base64.encode(message.senderIdAuthSecretV2, 0, message.senderIdAuthSecretV2.length) : options.bytes === Array ? Array.prototype.slice.call(message.senderIdAuthSecretV2) : message.senderIdAuthSecretV2;
            return object;
        };

        /**
         * Converts this SharingSpecificFields to JSON.
         * @function toJSON
         * @memberof sync_pb.SharingSpecificFields
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SharingSpecificFields.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * EnabledFeatures enum.
         * @name sync_pb.SharingSpecificFields.EnabledFeatures
         * @enum {number}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} CLICK_TO_CALL_VAPID=1 CLICK_TO_CALL_VAPID value
         * @property {number} SHARED_CLIPBOARD_VAPID=2 SHARED_CLIPBOARD_VAPID value
         * @property {number} SMS_FETCHER=3 SMS_FETCHER value
         * @property {number} REMOTE_COPY=4 REMOTE_COPY value
         * @property {number} PEER_CONNECTION=5 PEER_CONNECTION value
         * @property {number} DISCOVERY=6 DISCOVERY value
         * @property {number} CLICK_TO_CALL_V2=7 CLICK_TO_CALL_V2 value
         * @property {number} SHARED_CLIPBOARD_V2=8 SHARED_CLIPBOARD_V2 value
         */
        SharingSpecificFields.EnabledFeatures = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "CLICK_TO_CALL_VAPID"] = 1;
            values[valuesById[2] = "SHARED_CLIPBOARD_VAPID"] = 2;
            values[valuesById[3] = "SMS_FETCHER"] = 3;
            values[valuesById[4] = "REMOTE_COPY"] = 4;
            values[valuesById[5] = "PEER_CONNECTION"] = 5;
            values[valuesById[6] = "DISCOVERY"] = 6;
            values[valuesById[7] = "CLICK_TO_CALL_V2"] = 7;
            values[valuesById[8] = "SHARED_CLIPBOARD_V2"] = 8;
            return values;
        })();

        return SharingSpecificFields;
    })();

    sync_pb.KeystoreEncryptionFlags = (function() {

        /**
         * Properties of a KeystoreEncryptionFlags.
         * @memberof sync_pb
         * @interface IKeystoreEncryptionFlags
         * @property {boolean|null} [enabled] KeystoreEncryptionFlags enabled
         */

        /**
         * Constructs a new KeystoreEncryptionFlags.
         * @memberof sync_pb
         * @classdesc Represents a KeystoreEncryptionFlags.
         * @implements IKeystoreEncryptionFlags
         * @constructor
         * @param {sync_pb.IKeystoreEncryptionFlags=} [properties] Properties to set
         */
        function KeystoreEncryptionFlags(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * KeystoreEncryptionFlags enabled.
         * @member {boolean} enabled
         * @memberof sync_pb.KeystoreEncryptionFlags
         * @instance
         */
        KeystoreEncryptionFlags.prototype.enabled = false;

        /**
         * Creates a new KeystoreEncryptionFlags instance using the specified properties.
         * @function create
         * @memberof sync_pb.KeystoreEncryptionFlags
         * @static
         * @param {sync_pb.IKeystoreEncryptionFlags=} [properties] Properties to set
         * @returns {sync_pb.KeystoreEncryptionFlags} KeystoreEncryptionFlags instance
         */
        KeystoreEncryptionFlags.create = function create(properties) {
            return new KeystoreEncryptionFlags(properties);
        };

        /**
         * Encodes the specified KeystoreEncryptionFlags message. Does not implicitly {@link sync_pb.KeystoreEncryptionFlags.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.KeystoreEncryptionFlags
         * @static
         * @param {sync_pb.IKeystoreEncryptionFlags} message KeystoreEncryptionFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KeystoreEncryptionFlags.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enabled);
            return writer;
        };

        /**
         * Encodes the specified KeystoreEncryptionFlags message, length delimited. Does not implicitly {@link sync_pb.KeystoreEncryptionFlags.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.KeystoreEncryptionFlags
         * @static
         * @param {sync_pb.IKeystoreEncryptionFlags} message KeystoreEncryptionFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KeystoreEncryptionFlags.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a KeystoreEncryptionFlags message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.KeystoreEncryptionFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.KeystoreEncryptionFlags} KeystoreEncryptionFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KeystoreEncryptionFlags.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.KeystoreEncryptionFlags();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a KeystoreEncryptionFlags message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.KeystoreEncryptionFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.KeystoreEncryptionFlags} KeystoreEncryptionFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KeystoreEncryptionFlags.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a KeystoreEncryptionFlags message.
         * @function verify
         * @memberof sync_pb.KeystoreEncryptionFlags
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        KeystoreEncryptionFlags.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                if (typeof message.enabled !== "boolean")
                    return "enabled: boolean expected";
            return null;
        };

        /**
         * Creates a KeystoreEncryptionFlags message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.KeystoreEncryptionFlags
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.KeystoreEncryptionFlags} KeystoreEncryptionFlags
         */
        KeystoreEncryptionFlags.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.KeystoreEncryptionFlags)
                return object;
            let message = new $root.sync_pb.KeystoreEncryptionFlags();
            if (object.enabled != null)
                message.enabled = Boolean(object.enabled);
            return message;
        };

        /**
         * Creates a plain object from a KeystoreEncryptionFlags message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.KeystoreEncryptionFlags
         * @static
         * @param {sync_pb.KeystoreEncryptionFlags} message KeystoreEncryptionFlags
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        KeystoreEncryptionFlags.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.enabled = false;
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                object.enabled = message.enabled;
            return object;
        };

        /**
         * Converts this KeystoreEncryptionFlags to JSON.
         * @function toJSON
         * @memberof sync_pb.KeystoreEncryptionFlags
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        KeystoreEncryptionFlags.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return KeystoreEncryptionFlags;
    })();

    sync_pb.HistoryDeleteDirectives = (function() {

        /**
         * Properties of a HistoryDeleteDirectives.
         * @memberof sync_pb
         * @interface IHistoryDeleteDirectives
         * @property {boolean|null} [enabled] HistoryDeleteDirectives enabled
         */

        /**
         * Constructs a new HistoryDeleteDirectives.
         * @memberof sync_pb
         * @classdesc Represents a HistoryDeleteDirectives.
         * @implements IHistoryDeleteDirectives
         * @constructor
         * @param {sync_pb.IHistoryDeleteDirectives=} [properties] Properties to set
         */
        function HistoryDeleteDirectives(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HistoryDeleteDirectives enabled.
         * @member {boolean} enabled
         * @memberof sync_pb.HistoryDeleteDirectives
         * @instance
         */
        HistoryDeleteDirectives.prototype.enabled = false;

        /**
         * Creates a new HistoryDeleteDirectives instance using the specified properties.
         * @function create
         * @memberof sync_pb.HistoryDeleteDirectives
         * @static
         * @param {sync_pb.IHistoryDeleteDirectives=} [properties] Properties to set
         * @returns {sync_pb.HistoryDeleteDirectives} HistoryDeleteDirectives instance
         */
        HistoryDeleteDirectives.create = function create(properties) {
            return new HistoryDeleteDirectives(properties);
        };

        /**
         * Encodes the specified HistoryDeleteDirectives message. Does not implicitly {@link sync_pb.HistoryDeleteDirectives.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.HistoryDeleteDirectives
         * @static
         * @param {sync_pb.IHistoryDeleteDirectives} message HistoryDeleteDirectives message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HistoryDeleteDirectives.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enabled);
            return writer;
        };

        /**
         * Encodes the specified HistoryDeleteDirectives message, length delimited. Does not implicitly {@link sync_pb.HistoryDeleteDirectives.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.HistoryDeleteDirectives
         * @static
         * @param {sync_pb.IHistoryDeleteDirectives} message HistoryDeleteDirectives message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HistoryDeleteDirectives.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a HistoryDeleteDirectives message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.HistoryDeleteDirectives
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.HistoryDeleteDirectives} HistoryDeleteDirectives
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HistoryDeleteDirectives.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.HistoryDeleteDirectives();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a HistoryDeleteDirectives message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.HistoryDeleteDirectives
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.HistoryDeleteDirectives} HistoryDeleteDirectives
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HistoryDeleteDirectives.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a HistoryDeleteDirectives message.
         * @function verify
         * @memberof sync_pb.HistoryDeleteDirectives
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        HistoryDeleteDirectives.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                if (typeof message.enabled !== "boolean")
                    return "enabled: boolean expected";
            return null;
        };

        /**
         * Creates a HistoryDeleteDirectives message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.HistoryDeleteDirectives
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.HistoryDeleteDirectives} HistoryDeleteDirectives
         */
        HistoryDeleteDirectives.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.HistoryDeleteDirectives)
                return object;
            let message = new $root.sync_pb.HistoryDeleteDirectives();
            if (object.enabled != null)
                message.enabled = Boolean(object.enabled);
            return message;
        };

        /**
         * Creates a plain object from a HistoryDeleteDirectives message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.HistoryDeleteDirectives
         * @static
         * @param {sync_pb.HistoryDeleteDirectives} message HistoryDeleteDirectives
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HistoryDeleteDirectives.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.enabled = false;
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                object.enabled = message.enabled;
            return object;
        };

        /**
         * Converts this HistoryDeleteDirectives to JSON.
         * @function toJSON
         * @memberof sync_pb.HistoryDeleteDirectives
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HistoryDeleteDirectives.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HistoryDeleteDirectives;
    })();

    sync_pb.AutofillCullingFlags = (function() {

        /**
         * Properties of an AutofillCullingFlags.
         * @memberof sync_pb
         * @interface IAutofillCullingFlags
         * @property {boolean|null} [enabled] AutofillCullingFlags enabled
         */

        /**
         * Constructs a new AutofillCullingFlags.
         * @memberof sync_pb
         * @classdesc Represents an AutofillCullingFlags.
         * @implements IAutofillCullingFlags
         * @constructor
         * @param {sync_pb.IAutofillCullingFlags=} [properties] Properties to set
         */
        function AutofillCullingFlags(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AutofillCullingFlags enabled.
         * @member {boolean} enabled
         * @memberof sync_pb.AutofillCullingFlags
         * @instance
         */
        AutofillCullingFlags.prototype.enabled = false;

        /**
         * Creates a new AutofillCullingFlags instance using the specified properties.
         * @function create
         * @memberof sync_pb.AutofillCullingFlags
         * @static
         * @param {sync_pb.IAutofillCullingFlags=} [properties] Properties to set
         * @returns {sync_pb.AutofillCullingFlags} AutofillCullingFlags instance
         */
        AutofillCullingFlags.create = function create(properties) {
            return new AutofillCullingFlags(properties);
        };

        /**
         * Encodes the specified AutofillCullingFlags message. Does not implicitly {@link sync_pb.AutofillCullingFlags.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.AutofillCullingFlags
         * @static
         * @param {sync_pb.IAutofillCullingFlags} message AutofillCullingFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AutofillCullingFlags.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enabled);
            return writer;
        };

        /**
         * Encodes the specified AutofillCullingFlags message, length delimited. Does not implicitly {@link sync_pb.AutofillCullingFlags.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.AutofillCullingFlags
         * @static
         * @param {sync_pb.IAutofillCullingFlags} message AutofillCullingFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AutofillCullingFlags.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AutofillCullingFlags message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.AutofillCullingFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.AutofillCullingFlags} AutofillCullingFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AutofillCullingFlags.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.AutofillCullingFlags();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AutofillCullingFlags message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.AutofillCullingFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.AutofillCullingFlags} AutofillCullingFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AutofillCullingFlags.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AutofillCullingFlags message.
         * @function verify
         * @memberof sync_pb.AutofillCullingFlags
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AutofillCullingFlags.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                if (typeof message.enabled !== "boolean")
                    return "enabled: boolean expected";
            return null;
        };

        /**
         * Creates an AutofillCullingFlags message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.AutofillCullingFlags
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.AutofillCullingFlags} AutofillCullingFlags
         */
        AutofillCullingFlags.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.AutofillCullingFlags)
                return object;
            let message = new $root.sync_pb.AutofillCullingFlags();
            if (object.enabled != null)
                message.enabled = Boolean(object.enabled);
            return message;
        };

        /**
         * Creates a plain object from an AutofillCullingFlags message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.AutofillCullingFlags
         * @static
         * @param {sync_pb.AutofillCullingFlags} message AutofillCullingFlags
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AutofillCullingFlags.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.enabled = false;
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                object.enabled = message.enabled;
            return object;
        };

        /**
         * Converts this AutofillCullingFlags to JSON.
         * @function toJSON
         * @memberof sync_pb.AutofillCullingFlags
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AutofillCullingFlags.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AutofillCullingFlags;
    })();

    sync_pb.FaviconSyncFlags = (function() {

        /**
         * Properties of a FaviconSyncFlags.
         * @memberof sync_pb
         * @interface IFaviconSyncFlags
         * @property {boolean|null} [enabled] FaviconSyncFlags enabled
         * @property {number|null} [faviconSyncLimit] FaviconSyncFlags faviconSyncLimit
         */

        /**
         * Constructs a new FaviconSyncFlags.
         * @memberof sync_pb
         * @classdesc Represents a FaviconSyncFlags.
         * @implements IFaviconSyncFlags
         * @constructor
         * @param {sync_pb.IFaviconSyncFlags=} [properties] Properties to set
         */
        function FaviconSyncFlags(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FaviconSyncFlags enabled.
         * @member {boolean} enabled
         * @memberof sync_pb.FaviconSyncFlags
         * @instance
         */
        FaviconSyncFlags.prototype.enabled = false;

        /**
         * FaviconSyncFlags faviconSyncLimit.
         * @member {number} faviconSyncLimit
         * @memberof sync_pb.FaviconSyncFlags
         * @instance
         */
        FaviconSyncFlags.prototype.faviconSyncLimit = 200;

        /**
         * Creates a new FaviconSyncFlags instance using the specified properties.
         * @function create
         * @memberof sync_pb.FaviconSyncFlags
         * @static
         * @param {sync_pb.IFaviconSyncFlags=} [properties] Properties to set
         * @returns {sync_pb.FaviconSyncFlags} FaviconSyncFlags instance
         */
        FaviconSyncFlags.create = function create(properties) {
            return new FaviconSyncFlags(properties);
        };

        /**
         * Encodes the specified FaviconSyncFlags message. Does not implicitly {@link sync_pb.FaviconSyncFlags.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.FaviconSyncFlags
         * @static
         * @param {sync_pb.IFaviconSyncFlags} message FaviconSyncFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FaviconSyncFlags.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enabled);
            if (message.faviconSyncLimit != null && Object.hasOwnProperty.call(message, "faviconSyncLimit"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.faviconSyncLimit);
            return writer;
        };

        /**
         * Encodes the specified FaviconSyncFlags message, length delimited. Does not implicitly {@link sync_pb.FaviconSyncFlags.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.FaviconSyncFlags
         * @static
         * @param {sync_pb.IFaviconSyncFlags} message FaviconSyncFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FaviconSyncFlags.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FaviconSyncFlags message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.FaviconSyncFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.FaviconSyncFlags} FaviconSyncFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FaviconSyncFlags.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.FaviconSyncFlags();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.enabled = reader.bool();
                    break;
                case 2:
                    message.faviconSyncLimit = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FaviconSyncFlags message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.FaviconSyncFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.FaviconSyncFlags} FaviconSyncFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FaviconSyncFlags.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FaviconSyncFlags message.
         * @function verify
         * @memberof sync_pb.FaviconSyncFlags
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FaviconSyncFlags.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                if (typeof message.enabled !== "boolean")
                    return "enabled: boolean expected";
            if (message.faviconSyncLimit != null && message.hasOwnProperty("faviconSyncLimit"))
                if (!$util.isInteger(message.faviconSyncLimit))
                    return "faviconSyncLimit: integer expected";
            return null;
        };

        /**
         * Creates a FaviconSyncFlags message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.FaviconSyncFlags
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.FaviconSyncFlags} FaviconSyncFlags
         */
        FaviconSyncFlags.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.FaviconSyncFlags)
                return object;
            let message = new $root.sync_pb.FaviconSyncFlags();
            if (object.enabled != null)
                message.enabled = Boolean(object.enabled);
            if (object.faviconSyncLimit != null)
                message.faviconSyncLimit = object.faviconSyncLimit | 0;
            return message;
        };

        /**
         * Creates a plain object from a FaviconSyncFlags message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.FaviconSyncFlags
         * @static
         * @param {sync_pb.FaviconSyncFlags} message FaviconSyncFlags
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FaviconSyncFlags.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.enabled = false;
                object.faviconSyncLimit = 200;
            }
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                object.enabled = message.enabled;
            if (message.faviconSyncLimit != null && message.hasOwnProperty("faviconSyncLimit"))
                object.faviconSyncLimit = message.faviconSyncLimit;
            return object;
        };

        /**
         * Converts this FaviconSyncFlags to JSON.
         * @function toJSON
         * @memberof sync_pb.FaviconSyncFlags
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FaviconSyncFlags.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FaviconSyncFlags;
    })();

    sync_pb.PreCommitUpdateAvoidanceFlags = (function() {

        /**
         * Properties of a PreCommitUpdateAvoidanceFlags.
         * @memberof sync_pb
         * @interface IPreCommitUpdateAvoidanceFlags
         * @property {boolean|null} [enabled] PreCommitUpdateAvoidanceFlags enabled
         */

        /**
         * Constructs a new PreCommitUpdateAvoidanceFlags.
         * @memberof sync_pb
         * @classdesc Represents a PreCommitUpdateAvoidanceFlags.
         * @implements IPreCommitUpdateAvoidanceFlags
         * @constructor
         * @param {sync_pb.IPreCommitUpdateAvoidanceFlags=} [properties] Properties to set
         */
        function PreCommitUpdateAvoidanceFlags(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PreCommitUpdateAvoidanceFlags enabled.
         * @member {boolean} enabled
         * @memberof sync_pb.PreCommitUpdateAvoidanceFlags
         * @instance
         */
        PreCommitUpdateAvoidanceFlags.prototype.enabled = false;

        /**
         * Creates a new PreCommitUpdateAvoidanceFlags instance using the specified properties.
         * @function create
         * @memberof sync_pb.PreCommitUpdateAvoidanceFlags
         * @static
         * @param {sync_pb.IPreCommitUpdateAvoidanceFlags=} [properties] Properties to set
         * @returns {sync_pb.PreCommitUpdateAvoidanceFlags} PreCommitUpdateAvoidanceFlags instance
         */
        PreCommitUpdateAvoidanceFlags.create = function create(properties) {
            return new PreCommitUpdateAvoidanceFlags(properties);
        };

        /**
         * Encodes the specified PreCommitUpdateAvoidanceFlags message. Does not implicitly {@link sync_pb.PreCommitUpdateAvoidanceFlags.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.PreCommitUpdateAvoidanceFlags
         * @static
         * @param {sync_pb.IPreCommitUpdateAvoidanceFlags} message PreCommitUpdateAvoidanceFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PreCommitUpdateAvoidanceFlags.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enabled);
            return writer;
        };

        /**
         * Encodes the specified PreCommitUpdateAvoidanceFlags message, length delimited. Does not implicitly {@link sync_pb.PreCommitUpdateAvoidanceFlags.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.PreCommitUpdateAvoidanceFlags
         * @static
         * @param {sync_pb.IPreCommitUpdateAvoidanceFlags} message PreCommitUpdateAvoidanceFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PreCommitUpdateAvoidanceFlags.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PreCommitUpdateAvoidanceFlags message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.PreCommitUpdateAvoidanceFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.PreCommitUpdateAvoidanceFlags} PreCommitUpdateAvoidanceFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PreCommitUpdateAvoidanceFlags.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.PreCommitUpdateAvoidanceFlags();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PreCommitUpdateAvoidanceFlags message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.PreCommitUpdateAvoidanceFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.PreCommitUpdateAvoidanceFlags} PreCommitUpdateAvoidanceFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PreCommitUpdateAvoidanceFlags.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PreCommitUpdateAvoidanceFlags message.
         * @function verify
         * @memberof sync_pb.PreCommitUpdateAvoidanceFlags
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PreCommitUpdateAvoidanceFlags.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                if (typeof message.enabled !== "boolean")
                    return "enabled: boolean expected";
            return null;
        };

        /**
         * Creates a PreCommitUpdateAvoidanceFlags message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.PreCommitUpdateAvoidanceFlags
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.PreCommitUpdateAvoidanceFlags} PreCommitUpdateAvoidanceFlags
         */
        PreCommitUpdateAvoidanceFlags.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.PreCommitUpdateAvoidanceFlags)
                return object;
            let message = new $root.sync_pb.PreCommitUpdateAvoidanceFlags();
            if (object.enabled != null)
                message.enabled = Boolean(object.enabled);
            return message;
        };

        /**
         * Creates a plain object from a PreCommitUpdateAvoidanceFlags message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.PreCommitUpdateAvoidanceFlags
         * @static
         * @param {sync_pb.PreCommitUpdateAvoidanceFlags} message PreCommitUpdateAvoidanceFlags
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PreCommitUpdateAvoidanceFlags.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.enabled = false;
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                object.enabled = message.enabled;
            return object;
        };

        /**
         * Converts this PreCommitUpdateAvoidanceFlags to JSON.
         * @function toJSON
         * @memberof sync_pb.PreCommitUpdateAvoidanceFlags
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PreCommitUpdateAvoidanceFlags.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PreCommitUpdateAvoidanceFlags;
    })();

    sync_pb.GcmChannelFlags = (function() {

        /**
         * Properties of a GcmChannelFlags.
         * @memberof sync_pb
         * @interface IGcmChannelFlags
         * @property {boolean|null} [enabled] GcmChannelFlags enabled
         */

        /**
         * Constructs a new GcmChannelFlags.
         * @memberof sync_pb
         * @classdesc Represents a GcmChannelFlags.
         * @implements IGcmChannelFlags
         * @constructor
         * @param {sync_pb.IGcmChannelFlags=} [properties] Properties to set
         */
        function GcmChannelFlags(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GcmChannelFlags enabled.
         * @member {boolean} enabled
         * @memberof sync_pb.GcmChannelFlags
         * @instance
         */
        GcmChannelFlags.prototype.enabled = false;

        /**
         * Creates a new GcmChannelFlags instance using the specified properties.
         * @function create
         * @memberof sync_pb.GcmChannelFlags
         * @static
         * @param {sync_pb.IGcmChannelFlags=} [properties] Properties to set
         * @returns {sync_pb.GcmChannelFlags} GcmChannelFlags instance
         */
        GcmChannelFlags.create = function create(properties) {
            return new GcmChannelFlags(properties);
        };

        /**
         * Encodes the specified GcmChannelFlags message. Does not implicitly {@link sync_pb.GcmChannelFlags.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.GcmChannelFlags
         * @static
         * @param {sync_pb.IGcmChannelFlags} message GcmChannelFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GcmChannelFlags.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enabled);
            return writer;
        };

        /**
         * Encodes the specified GcmChannelFlags message, length delimited. Does not implicitly {@link sync_pb.GcmChannelFlags.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.GcmChannelFlags
         * @static
         * @param {sync_pb.IGcmChannelFlags} message GcmChannelFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GcmChannelFlags.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GcmChannelFlags message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.GcmChannelFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.GcmChannelFlags} GcmChannelFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GcmChannelFlags.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.GcmChannelFlags();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GcmChannelFlags message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.GcmChannelFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.GcmChannelFlags} GcmChannelFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GcmChannelFlags.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GcmChannelFlags message.
         * @function verify
         * @memberof sync_pb.GcmChannelFlags
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GcmChannelFlags.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                if (typeof message.enabled !== "boolean")
                    return "enabled: boolean expected";
            return null;
        };

        /**
         * Creates a GcmChannelFlags message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.GcmChannelFlags
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.GcmChannelFlags} GcmChannelFlags
         */
        GcmChannelFlags.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.GcmChannelFlags)
                return object;
            let message = new $root.sync_pb.GcmChannelFlags();
            if (object.enabled != null)
                message.enabled = Boolean(object.enabled);
            return message;
        };

        /**
         * Creates a plain object from a GcmChannelFlags message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.GcmChannelFlags
         * @static
         * @param {sync_pb.GcmChannelFlags} message GcmChannelFlags
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GcmChannelFlags.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.enabled = false;
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                object.enabled = message.enabled;
            return object;
        };

        /**
         * Converts this GcmChannelFlags to JSON.
         * @function toJSON
         * @memberof sync_pb.GcmChannelFlags
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GcmChannelFlags.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GcmChannelFlags;
    })();

    sync_pb.EnhancedBookmarksFlags = (function() {

        /**
         * Properties of an EnhancedBookmarksFlags.
         * @memberof sync_pb
         * @interface IEnhancedBookmarksFlags
         * @property {boolean|null} [enabled] EnhancedBookmarksFlags enabled
         * @property {string|null} [extensionId] EnhancedBookmarksFlags extensionId
         */

        /**
         * Constructs a new EnhancedBookmarksFlags.
         * @memberof sync_pb
         * @classdesc Represents an EnhancedBookmarksFlags.
         * @implements IEnhancedBookmarksFlags
         * @constructor
         * @param {sync_pb.IEnhancedBookmarksFlags=} [properties] Properties to set
         */
        function EnhancedBookmarksFlags(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EnhancedBookmarksFlags enabled.
         * @member {boolean} enabled
         * @memberof sync_pb.EnhancedBookmarksFlags
         * @instance
         */
        EnhancedBookmarksFlags.prototype.enabled = false;

        /**
         * EnhancedBookmarksFlags extensionId.
         * @member {string} extensionId
         * @memberof sync_pb.EnhancedBookmarksFlags
         * @instance
         */
        EnhancedBookmarksFlags.prototype.extensionId = "";

        /**
         * Creates a new EnhancedBookmarksFlags instance using the specified properties.
         * @function create
         * @memberof sync_pb.EnhancedBookmarksFlags
         * @static
         * @param {sync_pb.IEnhancedBookmarksFlags=} [properties] Properties to set
         * @returns {sync_pb.EnhancedBookmarksFlags} EnhancedBookmarksFlags instance
         */
        EnhancedBookmarksFlags.create = function create(properties) {
            return new EnhancedBookmarksFlags(properties);
        };

        /**
         * Encodes the specified EnhancedBookmarksFlags message. Does not implicitly {@link sync_pb.EnhancedBookmarksFlags.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.EnhancedBookmarksFlags
         * @static
         * @param {sync_pb.IEnhancedBookmarksFlags} message EnhancedBookmarksFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnhancedBookmarksFlags.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enabled);
            if (message.extensionId != null && Object.hasOwnProperty.call(message, "extensionId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.extensionId);
            return writer;
        };

        /**
         * Encodes the specified EnhancedBookmarksFlags message, length delimited. Does not implicitly {@link sync_pb.EnhancedBookmarksFlags.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.EnhancedBookmarksFlags
         * @static
         * @param {sync_pb.IEnhancedBookmarksFlags} message EnhancedBookmarksFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnhancedBookmarksFlags.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EnhancedBookmarksFlags message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.EnhancedBookmarksFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.EnhancedBookmarksFlags} EnhancedBookmarksFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnhancedBookmarksFlags.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.EnhancedBookmarksFlags();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.enabled = reader.bool();
                    break;
                case 2:
                    message.extensionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EnhancedBookmarksFlags message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.EnhancedBookmarksFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.EnhancedBookmarksFlags} EnhancedBookmarksFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnhancedBookmarksFlags.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EnhancedBookmarksFlags message.
         * @function verify
         * @memberof sync_pb.EnhancedBookmarksFlags
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EnhancedBookmarksFlags.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                if (typeof message.enabled !== "boolean")
                    return "enabled: boolean expected";
            if (message.extensionId != null && message.hasOwnProperty("extensionId"))
                if (!$util.isString(message.extensionId))
                    return "extensionId: string expected";
            return null;
        };

        /**
         * Creates an EnhancedBookmarksFlags message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.EnhancedBookmarksFlags
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.EnhancedBookmarksFlags} EnhancedBookmarksFlags
         */
        EnhancedBookmarksFlags.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.EnhancedBookmarksFlags)
                return object;
            let message = new $root.sync_pb.EnhancedBookmarksFlags();
            if (object.enabled != null)
                message.enabled = Boolean(object.enabled);
            if (object.extensionId != null)
                message.extensionId = String(object.extensionId);
            return message;
        };

        /**
         * Creates a plain object from an EnhancedBookmarksFlags message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.EnhancedBookmarksFlags
         * @static
         * @param {sync_pb.EnhancedBookmarksFlags} message EnhancedBookmarksFlags
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EnhancedBookmarksFlags.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.enabled = false;
                object.extensionId = "";
            }
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                object.enabled = message.enabled;
            if (message.extensionId != null && message.hasOwnProperty("extensionId"))
                object.extensionId = message.extensionId;
            return object;
        };

        /**
         * Converts this EnhancedBookmarksFlags to JSON.
         * @function toJSON
         * @memberof sync_pb.EnhancedBookmarksFlags
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EnhancedBookmarksFlags.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EnhancedBookmarksFlags;
    })();

    sync_pb.GcmInvalidationsFlags = (function() {

        /**
         * Properties of a GcmInvalidationsFlags.
         * @memberof sync_pb
         * @interface IGcmInvalidationsFlags
         * @property {boolean|null} [enabled] GcmInvalidationsFlags enabled
         */

        /**
         * Constructs a new GcmInvalidationsFlags.
         * @memberof sync_pb
         * @classdesc Represents a GcmInvalidationsFlags.
         * @implements IGcmInvalidationsFlags
         * @constructor
         * @param {sync_pb.IGcmInvalidationsFlags=} [properties] Properties to set
         */
        function GcmInvalidationsFlags(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GcmInvalidationsFlags enabled.
         * @member {boolean} enabled
         * @memberof sync_pb.GcmInvalidationsFlags
         * @instance
         */
        GcmInvalidationsFlags.prototype.enabled = false;

        /**
         * Creates a new GcmInvalidationsFlags instance using the specified properties.
         * @function create
         * @memberof sync_pb.GcmInvalidationsFlags
         * @static
         * @param {sync_pb.IGcmInvalidationsFlags=} [properties] Properties to set
         * @returns {sync_pb.GcmInvalidationsFlags} GcmInvalidationsFlags instance
         */
        GcmInvalidationsFlags.create = function create(properties) {
            return new GcmInvalidationsFlags(properties);
        };

        /**
         * Encodes the specified GcmInvalidationsFlags message. Does not implicitly {@link sync_pb.GcmInvalidationsFlags.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.GcmInvalidationsFlags
         * @static
         * @param {sync_pb.IGcmInvalidationsFlags} message GcmInvalidationsFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GcmInvalidationsFlags.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enabled);
            return writer;
        };

        /**
         * Encodes the specified GcmInvalidationsFlags message, length delimited. Does not implicitly {@link sync_pb.GcmInvalidationsFlags.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.GcmInvalidationsFlags
         * @static
         * @param {sync_pb.IGcmInvalidationsFlags} message GcmInvalidationsFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GcmInvalidationsFlags.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GcmInvalidationsFlags message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.GcmInvalidationsFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.GcmInvalidationsFlags} GcmInvalidationsFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GcmInvalidationsFlags.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.GcmInvalidationsFlags();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GcmInvalidationsFlags message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.GcmInvalidationsFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.GcmInvalidationsFlags} GcmInvalidationsFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GcmInvalidationsFlags.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GcmInvalidationsFlags message.
         * @function verify
         * @memberof sync_pb.GcmInvalidationsFlags
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GcmInvalidationsFlags.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                if (typeof message.enabled !== "boolean")
                    return "enabled: boolean expected";
            return null;
        };

        /**
         * Creates a GcmInvalidationsFlags message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.GcmInvalidationsFlags
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.GcmInvalidationsFlags} GcmInvalidationsFlags
         */
        GcmInvalidationsFlags.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.GcmInvalidationsFlags)
                return object;
            let message = new $root.sync_pb.GcmInvalidationsFlags();
            if (object.enabled != null)
                message.enabled = Boolean(object.enabled);
            return message;
        };

        /**
         * Creates a plain object from a GcmInvalidationsFlags message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.GcmInvalidationsFlags
         * @static
         * @param {sync_pb.GcmInvalidationsFlags} message GcmInvalidationsFlags
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GcmInvalidationsFlags.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.enabled = false;
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                object.enabled = message.enabled;
            return object;
        };

        /**
         * Converts this GcmInvalidationsFlags to JSON.
         * @function toJSON
         * @memberof sync_pb.GcmInvalidationsFlags
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GcmInvalidationsFlags.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GcmInvalidationsFlags;
    })();

    sync_pb.WalletSyncFlags = (function() {

        /**
         * Properties of a WalletSyncFlags.
         * @memberof sync_pb
         * @interface IWalletSyncFlags
         * @property {boolean|null} [enabled] WalletSyncFlags enabled
         */

        /**
         * Constructs a new WalletSyncFlags.
         * @memberof sync_pb
         * @classdesc Represents a WalletSyncFlags.
         * @implements IWalletSyncFlags
         * @constructor
         * @param {sync_pb.IWalletSyncFlags=} [properties] Properties to set
         */
        function WalletSyncFlags(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * WalletSyncFlags enabled.
         * @member {boolean} enabled
         * @memberof sync_pb.WalletSyncFlags
         * @instance
         */
        WalletSyncFlags.prototype.enabled = false;

        /**
         * Creates a new WalletSyncFlags instance using the specified properties.
         * @function create
         * @memberof sync_pb.WalletSyncFlags
         * @static
         * @param {sync_pb.IWalletSyncFlags=} [properties] Properties to set
         * @returns {sync_pb.WalletSyncFlags} WalletSyncFlags instance
         */
        WalletSyncFlags.create = function create(properties) {
            return new WalletSyncFlags(properties);
        };

        /**
         * Encodes the specified WalletSyncFlags message. Does not implicitly {@link sync_pb.WalletSyncFlags.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.WalletSyncFlags
         * @static
         * @param {sync_pb.IWalletSyncFlags} message WalletSyncFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WalletSyncFlags.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enabled);
            return writer;
        };

        /**
         * Encodes the specified WalletSyncFlags message, length delimited. Does not implicitly {@link sync_pb.WalletSyncFlags.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.WalletSyncFlags
         * @static
         * @param {sync_pb.IWalletSyncFlags} message WalletSyncFlags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WalletSyncFlags.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a WalletSyncFlags message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.WalletSyncFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.WalletSyncFlags} WalletSyncFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WalletSyncFlags.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.WalletSyncFlags();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a WalletSyncFlags message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.WalletSyncFlags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.WalletSyncFlags} WalletSyncFlags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WalletSyncFlags.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a WalletSyncFlags message.
         * @function verify
         * @memberof sync_pb.WalletSyncFlags
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        WalletSyncFlags.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                if (typeof message.enabled !== "boolean")
                    return "enabled: boolean expected";
            return null;
        };

        /**
         * Creates a WalletSyncFlags message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.WalletSyncFlags
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.WalletSyncFlags} WalletSyncFlags
         */
        WalletSyncFlags.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.WalletSyncFlags)
                return object;
            let message = new $root.sync_pb.WalletSyncFlags();
            if (object.enabled != null)
                message.enabled = Boolean(object.enabled);
            return message;
        };

        /**
         * Creates a plain object from a WalletSyncFlags message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.WalletSyncFlags
         * @static
         * @param {sync_pb.WalletSyncFlags} message WalletSyncFlags
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        WalletSyncFlags.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.enabled = false;
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                object.enabled = message.enabled;
            return object;
        };

        /**
         * Converts this WalletSyncFlags to JSON.
         * @function toJSON
         * @memberof sync_pb.WalletSyncFlags
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        WalletSyncFlags.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return WalletSyncFlags;
    })();

    sync_pb.ExperimentsSpecifics = (function() {

        /**
         * Properties of an ExperimentsSpecifics.
         * @memberof sync_pb
         * @interface IExperimentsSpecifics
         * @property {sync_pb.IKeystoreEncryptionFlags|null} [keystoreEncryption] ExperimentsSpecifics keystoreEncryption
         * @property {sync_pb.IHistoryDeleteDirectives|null} [historyDeleteDirectives] ExperimentsSpecifics historyDeleteDirectives
         * @property {sync_pb.IAutofillCullingFlags|null} [autofillCulling] ExperimentsSpecifics autofillCulling
         * @property {sync_pb.IFaviconSyncFlags|null} [faviconSync] ExperimentsSpecifics faviconSync
         * @property {sync_pb.IPreCommitUpdateAvoidanceFlags|null} [preCommitUpdateAvoidance] ExperimentsSpecifics preCommitUpdateAvoidance
         * @property {sync_pb.IGcmChannelFlags|null} [gcmChannel] ExperimentsSpecifics gcmChannel
         * @property {sync_pb.IEnhancedBookmarksFlags|null} [obsoleteEnhancedBookmarks] ExperimentsSpecifics obsoleteEnhancedBookmarks
         * @property {sync_pb.IGcmInvalidationsFlags|null} [gcmInvalidations] ExperimentsSpecifics gcmInvalidations
         * @property {sync_pb.IWalletSyncFlags|null} [obsoleteWalletSync] ExperimentsSpecifics obsoleteWalletSync
         */

        /**
         * Constructs a new ExperimentsSpecifics.
         * @memberof sync_pb
         * @classdesc Represents an ExperimentsSpecifics.
         * @implements IExperimentsSpecifics
         * @constructor
         * @param {sync_pb.IExperimentsSpecifics=} [properties] Properties to set
         */
        function ExperimentsSpecifics(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExperimentsSpecifics keystoreEncryption.
         * @member {sync_pb.IKeystoreEncryptionFlags|null|undefined} keystoreEncryption
         * @memberof sync_pb.ExperimentsSpecifics
         * @instance
         */
        ExperimentsSpecifics.prototype.keystoreEncryption = null;

        /**
         * ExperimentsSpecifics historyDeleteDirectives.
         * @member {sync_pb.IHistoryDeleteDirectives|null|undefined} historyDeleteDirectives
         * @memberof sync_pb.ExperimentsSpecifics
         * @instance
         */
        ExperimentsSpecifics.prototype.historyDeleteDirectives = null;

        /**
         * ExperimentsSpecifics autofillCulling.
         * @member {sync_pb.IAutofillCullingFlags|null|undefined} autofillCulling
         * @memberof sync_pb.ExperimentsSpecifics
         * @instance
         */
        ExperimentsSpecifics.prototype.autofillCulling = null;

        /**
         * ExperimentsSpecifics faviconSync.
         * @member {sync_pb.IFaviconSyncFlags|null|undefined} faviconSync
         * @memberof sync_pb.ExperimentsSpecifics
         * @instance
         */
        ExperimentsSpecifics.prototype.faviconSync = null;

        /**
         * ExperimentsSpecifics preCommitUpdateAvoidance.
         * @member {sync_pb.IPreCommitUpdateAvoidanceFlags|null|undefined} preCommitUpdateAvoidance
         * @memberof sync_pb.ExperimentsSpecifics
         * @instance
         */
        ExperimentsSpecifics.prototype.preCommitUpdateAvoidance = null;

        /**
         * ExperimentsSpecifics gcmChannel.
         * @member {sync_pb.IGcmChannelFlags|null|undefined} gcmChannel
         * @memberof sync_pb.ExperimentsSpecifics
         * @instance
         */
        ExperimentsSpecifics.prototype.gcmChannel = null;

        /**
         * ExperimentsSpecifics obsoleteEnhancedBookmarks.
         * @member {sync_pb.IEnhancedBookmarksFlags|null|undefined} obsoleteEnhancedBookmarks
         * @memberof sync_pb.ExperimentsSpecifics
         * @instance
         */
        ExperimentsSpecifics.prototype.obsoleteEnhancedBookmarks = null;

        /**
         * ExperimentsSpecifics gcmInvalidations.
         * @member {sync_pb.IGcmInvalidationsFlags|null|undefined} gcmInvalidations
         * @memberof sync_pb.ExperimentsSpecifics
         * @instance
         */
        ExperimentsSpecifics.prototype.gcmInvalidations = null;

        /**
         * ExperimentsSpecifics obsoleteWalletSync.
         * @member {sync_pb.IWalletSyncFlags|null|undefined} obsoleteWalletSync
         * @memberof sync_pb.ExperimentsSpecifics
         * @instance
         */
        ExperimentsSpecifics.prototype.obsoleteWalletSync = null;

        /**
         * Creates a new ExperimentsSpecifics instance using the specified properties.
         * @function create
         * @memberof sync_pb.ExperimentsSpecifics
         * @static
         * @param {sync_pb.IExperimentsSpecifics=} [properties] Properties to set
         * @returns {sync_pb.ExperimentsSpecifics} ExperimentsSpecifics instance
         */
        ExperimentsSpecifics.create = function create(properties) {
            return new ExperimentsSpecifics(properties);
        };

        /**
         * Encodes the specified ExperimentsSpecifics message. Does not implicitly {@link sync_pb.ExperimentsSpecifics.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ExperimentsSpecifics
         * @static
         * @param {sync_pb.IExperimentsSpecifics} message ExperimentsSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExperimentsSpecifics.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.keystoreEncryption != null && Object.hasOwnProperty.call(message, "keystoreEncryption"))
                $root.sync_pb.KeystoreEncryptionFlags.encode(message.keystoreEncryption, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.historyDeleteDirectives != null && Object.hasOwnProperty.call(message, "historyDeleteDirectives"))
                $root.sync_pb.HistoryDeleteDirectives.encode(message.historyDeleteDirectives, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.autofillCulling != null && Object.hasOwnProperty.call(message, "autofillCulling"))
                $root.sync_pb.AutofillCullingFlags.encode(message.autofillCulling, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.faviconSync != null && Object.hasOwnProperty.call(message, "faviconSync"))
                $root.sync_pb.FaviconSyncFlags.encode(message.faviconSync, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.preCommitUpdateAvoidance != null && Object.hasOwnProperty.call(message, "preCommitUpdateAvoidance"))
                $root.sync_pb.PreCommitUpdateAvoidanceFlags.encode(message.preCommitUpdateAvoidance, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.gcmChannel != null && Object.hasOwnProperty.call(message, "gcmChannel"))
                $root.sync_pb.GcmChannelFlags.encode(message.gcmChannel, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.obsoleteEnhancedBookmarks != null && Object.hasOwnProperty.call(message, "obsoleteEnhancedBookmarks"))
                $root.sync_pb.EnhancedBookmarksFlags.encode(message.obsoleteEnhancedBookmarks, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.gcmInvalidations != null && Object.hasOwnProperty.call(message, "gcmInvalidations"))
                $root.sync_pb.GcmInvalidationsFlags.encode(message.gcmInvalidations, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.obsoleteWalletSync != null && Object.hasOwnProperty.call(message, "obsoleteWalletSync"))
                $root.sync_pb.WalletSyncFlags.encode(message.obsoleteWalletSync, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ExperimentsSpecifics message, length delimited. Does not implicitly {@link sync_pb.ExperimentsSpecifics.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ExperimentsSpecifics
         * @static
         * @param {sync_pb.IExperimentsSpecifics} message ExperimentsSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExperimentsSpecifics.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ExperimentsSpecifics message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ExperimentsSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ExperimentsSpecifics} ExperimentsSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExperimentsSpecifics.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ExperimentsSpecifics();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.keystoreEncryption = $root.sync_pb.KeystoreEncryptionFlags.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.historyDeleteDirectives = $root.sync_pb.HistoryDeleteDirectives.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.autofillCulling = $root.sync_pb.AutofillCullingFlags.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.faviconSync = $root.sync_pb.FaviconSyncFlags.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.preCommitUpdateAvoidance = $root.sync_pb.PreCommitUpdateAvoidanceFlags.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.gcmChannel = $root.sync_pb.GcmChannelFlags.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.obsoleteEnhancedBookmarks = $root.sync_pb.EnhancedBookmarksFlags.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.gcmInvalidations = $root.sync_pb.GcmInvalidationsFlags.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.obsoleteWalletSync = $root.sync_pb.WalletSyncFlags.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ExperimentsSpecifics message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ExperimentsSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ExperimentsSpecifics} ExperimentsSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExperimentsSpecifics.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ExperimentsSpecifics message.
         * @function verify
         * @memberof sync_pb.ExperimentsSpecifics
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ExperimentsSpecifics.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.keystoreEncryption != null && message.hasOwnProperty("keystoreEncryption")) {
                let error = $root.sync_pb.KeystoreEncryptionFlags.verify(message.keystoreEncryption);
                if (error)
                    return "keystoreEncryption." + error;
            }
            if (message.historyDeleteDirectives != null && message.hasOwnProperty("historyDeleteDirectives")) {
                let error = $root.sync_pb.HistoryDeleteDirectives.verify(message.historyDeleteDirectives);
                if (error)
                    return "historyDeleteDirectives." + error;
            }
            if (message.autofillCulling != null && message.hasOwnProperty("autofillCulling")) {
                let error = $root.sync_pb.AutofillCullingFlags.verify(message.autofillCulling);
                if (error)
                    return "autofillCulling." + error;
            }
            if (message.faviconSync != null && message.hasOwnProperty("faviconSync")) {
                let error = $root.sync_pb.FaviconSyncFlags.verify(message.faviconSync);
                if (error)
                    return "faviconSync." + error;
            }
            if (message.preCommitUpdateAvoidance != null && message.hasOwnProperty("preCommitUpdateAvoidance")) {
                let error = $root.sync_pb.PreCommitUpdateAvoidanceFlags.verify(message.preCommitUpdateAvoidance);
                if (error)
                    return "preCommitUpdateAvoidance." + error;
            }
            if (message.gcmChannel != null && message.hasOwnProperty("gcmChannel")) {
                let error = $root.sync_pb.GcmChannelFlags.verify(message.gcmChannel);
                if (error)
                    return "gcmChannel." + error;
            }
            if (message.obsoleteEnhancedBookmarks != null && message.hasOwnProperty("obsoleteEnhancedBookmarks")) {
                let error = $root.sync_pb.EnhancedBookmarksFlags.verify(message.obsoleteEnhancedBookmarks);
                if (error)
                    return "obsoleteEnhancedBookmarks." + error;
            }
            if (message.gcmInvalidations != null && message.hasOwnProperty("gcmInvalidations")) {
                let error = $root.sync_pb.GcmInvalidationsFlags.verify(message.gcmInvalidations);
                if (error)
                    return "gcmInvalidations." + error;
            }
            if (message.obsoleteWalletSync != null && message.hasOwnProperty("obsoleteWalletSync")) {
                let error = $root.sync_pb.WalletSyncFlags.verify(message.obsoleteWalletSync);
                if (error)
                    return "obsoleteWalletSync." + error;
            }
            return null;
        };

        /**
         * Creates an ExperimentsSpecifics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ExperimentsSpecifics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ExperimentsSpecifics} ExperimentsSpecifics
         */
        ExperimentsSpecifics.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ExperimentsSpecifics)
                return object;
            let message = new $root.sync_pb.ExperimentsSpecifics();
            if (object.keystoreEncryption != null) {
                if (typeof object.keystoreEncryption !== "object")
                    throw TypeError(".sync_pb.ExperimentsSpecifics.keystoreEncryption: object expected");
                message.keystoreEncryption = $root.sync_pb.KeystoreEncryptionFlags.fromObject(object.keystoreEncryption);
            }
            if (object.historyDeleteDirectives != null) {
                if (typeof object.historyDeleteDirectives !== "object")
                    throw TypeError(".sync_pb.ExperimentsSpecifics.historyDeleteDirectives: object expected");
                message.historyDeleteDirectives = $root.sync_pb.HistoryDeleteDirectives.fromObject(object.historyDeleteDirectives);
            }
            if (object.autofillCulling != null) {
                if (typeof object.autofillCulling !== "object")
                    throw TypeError(".sync_pb.ExperimentsSpecifics.autofillCulling: object expected");
                message.autofillCulling = $root.sync_pb.AutofillCullingFlags.fromObject(object.autofillCulling);
            }
            if (object.faviconSync != null) {
                if (typeof object.faviconSync !== "object")
                    throw TypeError(".sync_pb.ExperimentsSpecifics.faviconSync: object expected");
                message.faviconSync = $root.sync_pb.FaviconSyncFlags.fromObject(object.faviconSync);
            }
            if (object.preCommitUpdateAvoidance != null) {
                if (typeof object.preCommitUpdateAvoidance !== "object")
                    throw TypeError(".sync_pb.ExperimentsSpecifics.preCommitUpdateAvoidance: object expected");
                message.preCommitUpdateAvoidance = $root.sync_pb.PreCommitUpdateAvoidanceFlags.fromObject(object.preCommitUpdateAvoidance);
            }
            if (object.gcmChannel != null) {
                if (typeof object.gcmChannel !== "object")
                    throw TypeError(".sync_pb.ExperimentsSpecifics.gcmChannel: object expected");
                message.gcmChannel = $root.sync_pb.GcmChannelFlags.fromObject(object.gcmChannel);
            }
            if (object.obsoleteEnhancedBookmarks != null) {
                if (typeof object.obsoleteEnhancedBookmarks !== "object")
                    throw TypeError(".sync_pb.ExperimentsSpecifics.obsoleteEnhancedBookmarks: object expected");
                message.obsoleteEnhancedBookmarks = $root.sync_pb.EnhancedBookmarksFlags.fromObject(object.obsoleteEnhancedBookmarks);
            }
            if (object.gcmInvalidations != null) {
                if (typeof object.gcmInvalidations !== "object")
                    throw TypeError(".sync_pb.ExperimentsSpecifics.gcmInvalidations: object expected");
                message.gcmInvalidations = $root.sync_pb.GcmInvalidationsFlags.fromObject(object.gcmInvalidations);
            }
            if (object.obsoleteWalletSync != null) {
                if (typeof object.obsoleteWalletSync !== "object")
                    throw TypeError(".sync_pb.ExperimentsSpecifics.obsoleteWalletSync: object expected");
                message.obsoleteWalletSync = $root.sync_pb.WalletSyncFlags.fromObject(object.obsoleteWalletSync);
            }
            return message;
        };

        /**
         * Creates a plain object from an ExperimentsSpecifics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ExperimentsSpecifics
         * @static
         * @param {sync_pb.ExperimentsSpecifics} message ExperimentsSpecifics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExperimentsSpecifics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.keystoreEncryption = null;
                object.historyDeleteDirectives = null;
                object.autofillCulling = null;
                object.faviconSync = null;
                object.preCommitUpdateAvoidance = null;
                object.gcmChannel = null;
                object.obsoleteEnhancedBookmarks = null;
                object.gcmInvalidations = null;
                object.obsoleteWalletSync = null;
            }
            if (message.keystoreEncryption != null && message.hasOwnProperty("keystoreEncryption"))
                object.keystoreEncryption = $root.sync_pb.KeystoreEncryptionFlags.toObject(message.keystoreEncryption, options);
            if (message.historyDeleteDirectives != null && message.hasOwnProperty("historyDeleteDirectives"))
                object.historyDeleteDirectives = $root.sync_pb.HistoryDeleteDirectives.toObject(message.historyDeleteDirectives, options);
            if (message.autofillCulling != null && message.hasOwnProperty("autofillCulling"))
                object.autofillCulling = $root.sync_pb.AutofillCullingFlags.toObject(message.autofillCulling, options);
            if (message.faviconSync != null && message.hasOwnProperty("faviconSync"))
                object.faviconSync = $root.sync_pb.FaviconSyncFlags.toObject(message.faviconSync, options);
            if (message.preCommitUpdateAvoidance != null && message.hasOwnProperty("preCommitUpdateAvoidance"))
                object.preCommitUpdateAvoidance = $root.sync_pb.PreCommitUpdateAvoidanceFlags.toObject(message.preCommitUpdateAvoidance, options);
            if (message.gcmChannel != null && message.hasOwnProperty("gcmChannel"))
                object.gcmChannel = $root.sync_pb.GcmChannelFlags.toObject(message.gcmChannel, options);
            if (message.obsoleteEnhancedBookmarks != null && message.hasOwnProperty("obsoleteEnhancedBookmarks"))
                object.obsoleteEnhancedBookmarks = $root.sync_pb.EnhancedBookmarksFlags.toObject(message.obsoleteEnhancedBookmarks, options);
            if (message.gcmInvalidations != null && message.hasOwnProperty("gcmInvalidations"))
                object.gcmInvalidations = $root.sync_pb.GcmInvalidationsFlags.toObject(message.gcmInvalidations, options);
            if (message.obsoleteWalletSync != null && message.hasOwnProperty("obsoleteWalletSync"))
                object.obsoleteWalletSync = $root.sync_pb.WalletSyncFlags.toObject(message.obsoleteWalletSync, options);
            return object;
        };

        /**
         * Converts this ExperimentsSpecifics to JSON.
         * @function toJSON
         * @memberof sync_pb.ExperimentsSpecifics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExperimentsSpecifics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ExperimentsSpecifics;
    })();

    sync_pb.MetaInfo = (function() {

        /**
         * Properties of a MetaInfo.
         * @memberof sync_pb
         * @interface IMetaInfo
         * @property {string|null} [key] MetaInfo key
         * @property {string|null} [value] MetaInfo value
         */

        /**
         * Constructs a new MetaInfo.
         * @memberof sync_pb
         * @classdesc Represents a MetaInfo.
         * @implements IMetaInfo
         * @constructor
         * @param {sync_pb.IMetaInfo=} [properties] Properties to set
         */
        function MetaInfo(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MetaInfo key.
         * @member {string} key
         * @memberof sync_pb.MetaInfo
         * @instance
         */
        MetaInfo.prototype.key = "";

        /**
         * MetaInfo value.
         * @member {string} value
         * @memberof sync_pb.MetaInfo
         * @instance
         */
        MetaInfo.prototype.value = "";

        /**
         * Creates a new MetaInfo instance using the specified properties.
         * @function create
         * @memberof sync_pb.MetaInfo
         * @static
         * @param {sync_pb.IMetaInfo=} [properties] Properties to set
         * @returns {sync_pb.MetaInfo} MetaInfo instance
         */
        MetaInfo.create = function create(properties) {
            return new MetaInfo(properties);
        };

        /**
         * Encodes the specified MetaInfo message. Does not implicitly {@link sync_pb.MetaInfo.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.MetaInfo
         * @static
         * @param {sync_pb.IMetaInfo} message MetaInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MetaInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
            return writer;
        };

        /**
         * Encodes the specified MetaInfo message, length delimited. Does not implicitly {@link sync_pb.MetaInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.MetaInfo
         * @static
         * @param {sync_pb.IMetaInfo} message MetaInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MetaInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MetaInfo message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.MetaInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.MetaInfo} MetaInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MetaInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.MetaInfo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MetaInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.MetaInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.MetaInfo} MetaInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MetaInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MetaInfo message.
         * @function verify
         * @memberof sync_pb.MetaInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MetaInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!$util.isString(message.value))
                    return "value: string expected";
            return null;
        };

        /**
         * Creates a MetaInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.MetaInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.MetaInfo} MetaInfo
         */
        MetaInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.MetaInfo)
                return object;
            let message = new $root.sync_pb.MetaInfo();
            if (object.key != null)
                message.key = String(object.key);
            if (object.value != null)
                message.value = String(object.value);
            return message;
        };

        /**
         * Creates a plain object from a MetaInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.MetaInfo
         * @static
         * @param {sync_pb.MetaInfo} message MetaInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MetaInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.key = "";
                object.value = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            return object;
        };

        /**
         * Converts this MetaInfo to JSON.
         * @function toJSON
         * @memberof sync_pb.MetaInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MetaInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MetaInfo;
    })();

    sync_pb.BookmarkSpecifics = (function() {

        /**
         * Properties of a BookmarkSpecifics.
         * @memberof sync_pb
         * @interface IBookmarkSpecifics
         * @property {string|null} [url] BookmarkSpecifics url
         * @property {Uint8Array|null} [favicon] BookmarkSpecifics favicon
         * @property {string|null} [legacyCanonicalizedTitle] BookmarkSpecifics legacyCanonicalizedTitle
         * @property {number|Long|null} [creationTimeUs] BookmarkSpecifics creationTimeUs
         * @property {string|null} [iconUrl] BookmarkSpecifics iconUrl
         * @property {Array.<sync_pb.IMetaInfo>|null} [metaInfo] BookmarkSpecifics metaInfo
         * @property {string|null} [guid] BookmarkSpecifics guid
         * @property {string|null} [fullTitle] BookmarkSpecifics fullTitle
         */

        /**
         * Constructs a new BookmarkSpecifics.
         * @memberof sync_pb
         * @classdesc Represents a BookmarkSpecifics.
         * @implements IBookmarkSpecifics
         * @constructor
         * @param {sync_pb.IBookmarkSpecifics=} [properties] Properties to set
         */
        function BookmarkSpecifics(properties) {
            this.metaInfo = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BookmarkSpecifics url.
         * @member {string} url
         * @memberof sync_pb.BookmarkSpecifics
         * @instance
         */
        BookmarkSpecifics.prototype.url = "";

        /**
         * BookmarkSpecifics favicon.
         * @member {Uint8Array} favicon
         * @memberof sync_pb.BookmarkSpecifics
         * @instance
         */
        BookmarkSpecifics.prototype.favicon = $util.newBuffer([]);

        /**
         * BookmarkSpecifics legacyCanonicalizedTitle.
         * @member {string} legacyCanonicalizedTitle
         * @memberof sync_pb.BookmarkSpecifics
         * @instance
         */
        BookmarkSpecifics.prototype.legacyCanonicalizedTitle = "";

        /**
         * BookmarkSpecifics creationTimeUs.
         * @member {number|Long} creationTimeUs
         * @memberof sync_pb.BookmarkSpecifics
         * @instance
         */
        BookmarkSpecifics.prototype.creationTimeUs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * BookmarkSpecifics iconUrl.
         * @member {string} iconUrl
         * @memberof sync_pb.BookmarkSpecifics
         * @instance
         */
        BookmarkSpecifics.prototype.iconUrl = "";

        /**
         * BookmarkSpecifics metaInfo.
         * @member {Array.<sync_pb.IMetaInfo>} metaInfo
         * @memberof sync_pb.BookmarkSpecifics
         * @instance
         */
        BookmarkSpecifics.prototype.metaInfo = $util.emptyArray;

        /**
         * BookmarkSpecifics guid.
         * @member {string} guid
         * @memberof sync_pb.BookmarkSpecifics
         * @instance
         */
        BookmarkSpecifics.prototype.guid = "";

        /**
         * BookmarkSpecifics fullTitle.
         * @member {string} fullTitle
         * @memberof sync_pb.BookmarkSpecifics
         * @instance
         */
        BookmarkSpecifics.prototype.fullTitle = "";

        /**
         * Creates a new BookmarkSpecifics instance using the specified properties.
         * @function create
         * @memberof sync_pb.BookmarkSpecifics
         * @static
         * @param {sync_pb.IBookmarkSpecifics=} [properties] Properties to set
         * @returns {sync_pb.BookmarkSpecifics} BookmarkSpecifics instance
         */
        BookmarkSpecifics.create = function create(properties) {
            return new BookmarkSpecifics(properties);
        };

        /**
         * Encodes the specified BookmarkSpecifics message. Does not implicitly {@link sync_pb.BookmarkSpecifics.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.BookmarkSpecifics
         * @static
         * @param {sync_pb.IBookmarkSpecifics} message BookmarkSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BookmarkSpecifics.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.url);
            if (message.favicon != null && Object.hasOwnProperty.call(message, "favicon"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.favicon);
            if (message.legacyCanonicalizedTitle != null && Object.hasOwnProperty.call(message, "legacyCanonicalizedTitle"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.legacyCanonicalizedTitle);
            if (message.creationTimeUs != null && Object.hasOwnProperty.call(message, "creationTimeUs"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.creationTimeUs);
            if (message.iconUrl != null && Object.hasOwnProperty.call(message, "iconUrl"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.iconUrl);
            if (message.metaInfo != null && message.metaInfo.length)
                for (let i = 0; i < message.metaInfo.length; ++i)
                    $root.sync_pb.MetaInfo.encode(message.metaInfo[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.guid != null && Object.hasOwnProperty.call(message, "guid"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.guid);
            if (message.fullTitle != null && Object.hasOwnProperty.call(message, "fullTitle"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.fullTitle);
            return writer;
        };

        /**
         * Encodes the specified BookmarkSpecifics message, length delimited. Does not implicitly {@link sync_pb.BookmarkSpecifics.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.BookmarkSpecifics
         * @static
         * @param {sync_pb.IBookmarkSpecifics} message BookmarkSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BookmarkSpecifics.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BookmarkSpecifics message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.BookmarkSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.BookmarkSpecifics} BookmarkSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BookmarkSpecifics.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.BookmarkSpecifics();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.url = reader.string();
                    break;
                case 2:
                    message.favicon = reader.bytes();
                    break;
                case 3:
                    message.legacyCanonicalizedTitle = reader.string();
                    break;
                case 4:
                    message.creationTimeUs = reader.int64();
                    break;
                case 5:
                    message.iconUrl = reader.string();
                    break;
                case 6:
                    if (!(message.metaInfo && message.metaInfo.length))
                        message.metaInfo = [];
                    message.metaInfo.push($root.sync_pb.MetaInfo.decode(reader, reader.uint32()));
                    break;
                case 10:
                    message.guid = reader.string();
                    break;
                case 11:
                    message.fullTitle = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BookmarkSpecifics message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.BookmarkSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.BookmarkSpecifics} BookmarkSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BookmarkSpecifics.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BookmarkSpecifics message.
         * @function verify
         * @memberof sync_pb.BookmarkSpecifics
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BookmarkSpecifics.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            if (message.favicon != null && message.hasOwnProperty("favicon"))
                if (!(message.favicon && typeof message.favicon.length === "number" || $util.isString(message.favicon)))
                    return "favicon: buffer expected";
            if (message.legacyCanonicalizedTitle != null && message.hasOwnProperty("legacyCanonicalizedTitle"))
                if (!$util.isString(message.legacyCanonicalizedTitle))
                    return "legacyCanonicalizedTitle: string expected";
            if (message.creationTimeUs != null && message.hasOwnProperty("creationTimeUs"))
                if (!$util.isInteger(message.creationTimeUs) && !(message.creationTimeUs && $util.isInteger(message.creationTimeUs.low) && $util.isInteger(message.creationTimeUs.high)))
                    return "creationTimeUs: integer|Long expected";
            if (message.iconUrl != null && message.hasOwnProperty("iconUrl"))
                if (!$util.isString(message.iconUrl))
                    return "iconUrl: string expected";
            if (message.metaInfo != null && message.hasOwnProperty("metaInfo")) {
                if (!Array.isArray(message.metaInfo))
                    return "metaInfo: array expected";
                for (let i = 0; i < message.metaInfo.length; ++i) {
                    let error = $root.sync_pb.MetaInfo.verify(message.metaInfo[i]);
                    if (error)
                        return "metaInfo." + error;
                }
            }
            if (message.guid != null && message.hasOwnProperty("guid"))
                if (!$util.isString(message.guid))
                    return "guid: string expected";
            if (message.fullTitle != null && message.hasOwnProperty("fullTitle"))
                if (!$util.isString(message.fullTitle))
                    return "fullTitle: string expected";
            return null;
        };

        /**
         * Creates a BookmarkSpecifics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.BookmarkSpecifics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.BookmarkSpecifics} BookmarkSpecifics
         */
        BookmarkSpecifics.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.BookmarkSpecifics)
                return object;
            let message = new $root.sync_pb.BookmarkSpecifics();
            if (object.url != null)
                message.url = String(object.url);
            if (object.favicon != null)
                if (typeof object.favicon === "string")
                    $util.base64.decode(object.favicon, message.favicon = $util.newBuffer($util.base64.length(object.favicon)), 0);
                else if (object.favicon.length)
                    message.favicon = object.favicon;
            if (object.legacyCanonicalizedTitle != null)
                message.legacyCanonicalizedTitle = String(object.legacyCanonicalizedTitle);
            if (object.creationTimeUs != null)
                if ($util.Long)
                    (message.creationTimeUs = $util.Long.fromValue(object.creationTimeUs)).unsigned = false;
                else if (typeof object.creationTimeUs === "string")
                    message.creationTimeUs = parseInt(object.creationTimeUs, 10);
                else if (typeof object.creationTimeUs === "number")
                    message.creationTimeUs = object.creationTimeUs;
                else if (typeof object.creationTimeUs === "object")
                    message.creationTimeUs = new $util.LongBits(object.creationTimeUs.low >>> 0, object.creationTimeUs.high >>> 0).toNumber();
            if (object.iconUrl != null)
                message.iconUrl = String(object.iconUrl);
            if (object.metaInfo) {
                if (!Array.isArray(object.metaInfo))
                    throw TypeError(".sync_pb.BookmarkSpecifics.metaInfo: array expected");
                message.metaInfo = [];
                for (let i = 0; i < object.metaInfo.length; ++i) {
                    if (typeof object.metaInfo[i] !== "object")
                        throw TypeError(".sync_pb.BookmarkSpecifics.metaInfo: object expected");
                    message.metaInfo[i] = $root.sync_pb.MetaInfo.fromObject(object.metaInfo[i]);
                }
            }
            if (object.guid != null)
                message.guid = String(object.guid);
            if (object.fullTitle != null)
                message.fullTitle = String(object.fullTitle);
            return message;
        };

        /**
         * Creates a plain object from a BookmarkSpecifics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.BookmarkSpecifics
         * @static
         * @param {sync_pb.BookmarkSpecifics} message BookmarkSpecifics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BookmarkSpecifics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.metaInfo = [];
            if (options.defaults) {
                object.url = "";
                if (options.bytes === String)
                    object.favicon = "";
                else {
                    object.favicon = [];
                    if (options.bytes !== Array)
                        object.favicon = $util.newBuffer(object.favicon);
                }
                object.legacyCanonicalizedTitle = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.creationTimeUs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationTimeUs = options.longs === String ? "0" : 0;
                object.iconUrl = "";
                object.guid = "";
                object.fullTitle = "";
            }
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            if (message.favicon != null && message.hasOwnProperty("favicon"))
                object.favicon = options.bytes === String ? $util.base64.encode(message.favicon, 0, message.favicon.length) : options.bytes === Array ? Array.prototype.slice.call(message.favicon) : message.favicon;
            if (message.legacyCanonicalizedTitle != null && message.hasOwnProperty("legacyCanonicalizedTitle"))
                object.legacyCanonicalizedTitle = message.legacyCanonicalizedTitle;
            if (message.creationTimeUs != null && message.hasOwnProperty("creationTimeUs"))
                if (typeof message.creationTimeUs === "number")
                    object.creationTimeUs = options.longs === String ? String(message.creationTimeUs) : message.creationTimeUs;
                else
                    object.creationTimeUs = options.longs === String ? $util.Long.prototype.toString.call(message.creationTimeUs) : options.longs === Number ? new $util.LongBits(message.creationTimeUs.low >>> 0, message.creationTimeUs.high >>> 0).toNumber() : message.creationTimeUs;
            if (message.iconUrl != null && message.hasOwnProperty("iconUrl"))
                object.iconUrl = message.iconUrl;
            if (message.metaInfo && message.metaInfo.length) {
                object.metaInfo = [];
                for (let j = 0; j < message.metaInfo.length; ++j)
                    object.metaInfo[j] = $root.sync_pb.MetaInfo.toObject(message.metaInfo[j], options);
            }
            if (message.guid != null && message.hasOwnProperty("guid"))
                object.guid = message.guid;
            if (message.fullTitle != null && message.hasOwnProperty("fullTitle"))
                object.fullTitle = message.fullTitle;
            return object;
        };

        /**
         * Converts this BookmarkSpecifics to JSON.
         * @function toJSON
         * @memberof sync_pb.BookmarkSpecifics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BookmarkSpecifics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BookmarkSpecifics;
    })();

    sync_pb.CustomNudgeDelay = (function() {

        /**
         * Properties of a CustomNudgeDelay.
         * @memberof sync_pb
         * @interface ICustomNudgeDelay
         * @property {number|null} [datatypeId] CustomNudgeDelay datatypeId
         * @property {number|null} [delayMs] CustomNudgeDelay delayMs
         */

        /**
         * Constructs a new CustomNudgeDelay.
         * @memberof sync_pb
         * @classdesc Represents a CustomNudgeDelay.
         * @implements ICustomNudgeDelay
         * @constructor
         * @param {sync_pb.ICustomNudgeDelay=} [properties] Properties to set
         */
        function CustomNudgeDelay(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CustomNudgeDelay datatypeId.
         * @member {number} datatypeId
         * @memberof sync_pb.CustomNudgeDelay
         * @instance
         */
        CustomNudgeDelay.prototype.datatypeId = 0;

        /**
         * CustomNudgeDelay delayMs.
         * @member {number} delayMs
         * @memberof sync_pb.CustomNudgeDelay
         * @instance
         */
        CustomNudgeDelay.prototype.delayMs = 0;

        /**
         * Creates a new CustomNudgeDelay instance using the specified properties.
         * @function create
         * @memberof sync_pb.CustomNudgeDelay
         * @static
         * @param {sync_pb.ICustomNudgeDelay=} [properties] Properties to set
         * @returns {sync_pb.CustomNudgeDelay} CustomNudgeDelay instance
         */
        CustomNudgeDelay.create = function create(properties) {
            return new CustomNudgeDelay(properties);
        };

        /**
         * Encodes the specified CustomNudgeDelay message. Does not implicitly {@link sync_pb.CustomNudgeDelay.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.CustomNudgeDelay
         * @static
         * @param {sync_pb.ICustomNudgeDelay} message CustomNudgeDelay message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomNudgeDelay.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.datatypeId != null && Object.hasOwnProperty.call(message, "datatypeId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.datatypeId);
            if (message.delayMs != null && Object.hasOwnProperty.call(message, "delayMs"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.delayMs);
            return writer;
        };

        /**
         * Encodes the specified CustomNudgeDelay message, length delimited. Does not implicitly {@link sync_pb.CustomNudgeDelay.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.CustomNudgeDelay
         * @static
         * @param {sync_pb.ICustomNudgeDelay} message CustomNudgeDelay message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomNudgeDelay.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CustomNudgeDelay message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.CustomNudgeDelay
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.CustomNudgeDelay} CustomNudgeDelay
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomNudgeDelay.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.CustomNudgeDelay();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.datatypeId = reader.int32();
                    break;
                case 2:
                    message.delayMs = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CustomNudgeDelay message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.CustomNudgeDelay
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.CustomNudgeDelay} CustomNudgeDelay
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomNudgeDelay.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CustomNudgeDelay message.
         * @function verify
         * @memberof sync_pb.CustomNudgeDelay
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CustomNudgeDelay.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.datatypeId != null && message.hasOwnProperty("datatypeId"))
                if (!$util.isInteger(message.datatypeId))
                    return "datatypeId: integer expected";
            if (message.delayMs != null && message.hasOwnProperty("delayMs"))
                if (!$util.isInteger(message.delayMs))
                    return "delayMs: integer expected";
            return null;
        };

        /**
         * Creates a CustomNudgeDelay message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.CustomNudgeDelay
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.CustomNudgeDelay} CustomNudgeDelay
         */
        CustomNudgeDelay.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.CustomNudgeDelay)
                return object;
            let message = new $root.sync_pb.CustomNudgeDelay();
            if (object.datatypeId != null)
                message.datatypeId = object.datatypeId | 0;
            if (object.delayMs != null)
                message.delayMs = object.delayMs | 0;
            return message;
        };

        /**
         * Creates a plain object from a CustomNudgeDelay message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.CustomNudgeDelay
         * @static
         * @param {sync_pb.CustomNudgeDelay} message CustomNudgeDelay
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CustomNudgeDelay.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.datatypeId = 0;
                object.delayMs = 0;
            }
            if (message.datatypeId != null && message.hasOwnProperty("datatypeId"))
                object.datatypeId = message.datatypeId;
            if (message.delayMs != null && message.hasOwnProperty("delayMs"))
                object.delayMs = message.delayMs;
            return object;
        };

        /**
         * Converts this CustomNudgeDelay to JSON.
         * @function toJSON
         * @memberof sync_pb.CustomNudgeDelay
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CustomNudgeDelay.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CustomNudgeDelay;
    })();

    sync_pb.ClientCommand = (function() {

        /**
         * Properties of a ClientCommand.
         * @memberof sync_pb
         * @interface IClientCommand
         * @property {number|null} [setSyncPollInterval] ClientCommand setSyncPollInterval
         * @property {number|null} [setSyncLongPollInterval] ClientCommand setSyncLongPollInterval
         * @property {number|null} [maxCommitBatchSize] ClientCommand maxCommitBatchSize
         * @property {number|null} [sessionsCommitDelaySeconds] ClientCommand sessionsCommitDelaySeconds
         * @property {number|null} [throttleDelaySeconds] ClientCommand throttleDelaySeconds
         * @property {number|null} [clientInvalidationHintBufferSize] ClientCommand clientInvalidationHintBufferSize
         * @property {number|null} [guRetryDelaySeconds] ClientCommand guRetryDelaySeconds
         * @property {Array.<sync_pb.ICustomNudgeDelay>|null} [customNudgeDelays] ClientCommand customNudgeDelays
         */

        /**
         * Constructs a new ClientCommand.
         * @memberof sync_pb
         * @classdesc Represents a ClientCommand.
         * @implements IClientCommand
         * @constructor
         * @param {sync_pb.IClientCommand=} [properties] Properties to set
         */
        function ClientCommand(properties) {
            this.customNudgeDelays = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ClientCommand setSyncPollInterval.
         * @member {number} setSyncPollInterval
         * @memberof sync_pb.ClientCommand
         * @instance
         */
        ClientCommand.prototype.setSyncPollInterval = 0;

        /**
         * ClientCommand setSyncLongPollInterval.
         * @member {number} setSyncLongPollInterval
         * @memberof sync_pb.ClientCommand
         * @instance
         */
        ClientCommand.prototype.setSyncLongPollInterval = 0;

        /**
         * ClientCommand maxCommitBatchSize.
         * @member {number} maxCommitBatchSize
         * @memberof sync_pb.ClientCommand
         * @instance
         */
        ClientCommand.prototype.maxCommitBatchSize = 0;

        /**
         * ClientCommand sessionsCommitDelaySeconds.
         * @member {number} sessionsCommitDelaySeconds
         * @memberof sync_pb.ClientCommand
         * @instance
         */
        ClientCommand.prototype.sessionsCommitDelaySeconds = 0;

        /**
         * ClientCommand throttleDelaySeconds.
         * @member {number} throttleDelaySeconds
         * @memberof sync_pb.ClientCommand
         * @instance
         */
        ClientCommand.prototype.throttleDelaySeconds = 0;

        /**
         * ClientCommand clientInvalidationHintBufferSize.
         * @member {number} clientInvalidationHintBufferSize
         * @memberof sync_pb.ClientCommand
         * @instance
         */
        ClientCommand.prototype.clientInvalidationHintBufferSize = 0;

        /**
         * ClientCommand guRetryDelaySeconds.
         * @member {number} guRetryDelaySeconds
         * @memberof sync_pb.ClientCommand
         * @instance
         */
        ClientCommand.prototype.guRetryDelaySeconds = 0;

        /**
         * ClientCommand customNudgeDelays.
         * @member {Array.<sync_pb.ICustomNudgeDelay>} customNudgeDelays
         * @memberof sync_pb.ClientCommand
         * @instance
         */
        ClientCommand.prototype.customNudgeDelays = $util.emptyArray;

        /**
         * Creates a new ClientCommand instance using the specified properties.
         * @function create
         * @memberof sync_pb.ClientCommand
         * @static
         * @param {sync_pb.IClientCommand=} [properties] Properties to set
         * @returns {sync_pb.ClientCommand} ClientCommand instance
         */
        ClientCommand.create = function create(properties) {
            return new ClientCommand(properties);
        };

        /**
         * Encodes the specified ClientCommand message. Does not implicitly {@link sync_pb.ClientCommand.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ClientCommand
         * @static
         * @param {sync_pb.IClientCommand} message ClientCommand message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientCommand.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.setSyncPollInterval != null && Object.hasOwnProperty.call(message, "setSyncPollInterval"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.setSyncPollInterval);
            if (message.setSyncLongPollInterval != null && Object.hasOwnProperty.call(message, "setSyncLongPollInterval"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.setSyncLongPollInterval);
            if (message.maxCommitBatchSize != null && Object.hasOwnProperty.call(message, "maxCommitBatchSize"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.maxCommitBatchSize);
            if (message.sessionsCommitDelaySeconds != null && Object.hasOwnProperty.call(message, "sessionsCommitDelaySeconds"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sessionsCommitDelaySeconds);
            if (message.throttleDelaySeconds != null && Object.hasOwnProperty.call(message, "throttleDelaySeconds"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.throttleDelaySeconds);
            if (message.clientInvalidationHintBufferSize != null && Object.hasOwnProperty.call(message, "clientInvalidationHintBufferSize"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.clientInvalidationHintBufferSize);
            if (message.guRetryDelaySeconds != null && Object.hasOwnProperty.call(message, "guRetryDelaySeconds"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.guRetryDelaySeconds);
            if (message.customNudgeDelays != null && message.customNudgeDelays.length)
                for (let i = 0; i < message.customNudgeDelays.length; ++i)
                    $root.sync_pb.CustomNudgeDelay.encode(message.customNudgeDelays[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ClientCommand message, length delimited. Does not implicitly {@link sync_pb.ClientCommand.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ClientCommand
         * @static
         * @param {sync_pb.IClientCommand} message ClientCommand message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ClientCommand.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ClientCommand message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ClientCommand
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ClientCommand} ClientCommand
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientCommand.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ClientCommand();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.setSyncPollInterval = reader.int32();
                    break;
                case 2:
                    message.setSyncLongPollInterval = reader.int32();
                    break;
                case 3:
                    message.maxCommitBatchSize = reader.int32();
                    break;
                case 4:
                    message.sessionsCommitDelaySeconds = reader.int32();
                    break;
                case 5:
                    message.throttleDelaySeconds = reader.int32();
                    break;
                case 6:
                    message.clientInvalidationHintBufferSize = reader.int32();
                    break;
                case 7:
                    message.guRetryDelaySeconds = reader.int32();
                    break;
                case 8:
                    if (!(message.customNudgeDelays && message.customNudgeDelays.length))
                        message.customNudgeDelays = [];
                    message.customNudgeDelays.push($root.sync_pb.CustomNudgeDelay.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ClientCommand message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ClientCommand
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ClientCommand} ClientCommand
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ClientCommand.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ClientCommand message.
         * @function verify
         * @memberof sync_pb.ClientCommand
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ClientCommand.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.setSyncPollInterval != null && message.hasOwnProperty("setSyncPollInterval"))
                if (!$util.isInteger(message.setSyncPollInterval))
                    return "setSyncPollInterval: integer expected";
            if (message.setSyncLongPollInterval != null && message.hasOwnProperty("setSyncLongPollInterval"))
                if (!$util.isInteger(message.setSyncLongPollInterval))
                    return "setSyncLongPollInterval: integer expected";
            if (message.maxCommitBatchSize != null && message.hasOwnProperty("maxCommitBatchSize"))
                if (!$util.isInteger(message.maxCommitBatchSize))
                    return "maxCommitBatchSize: integer expected";
            if (message.sessionsCommitDelaySeconds != null && message.hasOwnProperty("sessionsCommitDelaySeconds"))
                if (!$util.isInteger(message.sessionsCommitDelaySeconds))
                    return "sessionsCommitDelaySeconds: integer expected";
            if (message.throttleDelaySeconds != null && message.hasOwnProperty("throttleDelaySeconds"))
                if (!$util.isInteger(message.throttleDelaySeconds))
                    return "throttleDelaySeconds: integer expected";
            if (message.clientInvalidationHintBufferSize != null && message.hasOwnProperty("clientInvalidationHintBufferSize"))
                if (!$util.isInteger(message.clientInvalidationHintBufferSize))
                    return "clientInvalidationHintBufferSize: integer expected";
            if (message.guRetryDelaySeconds != null && message.hasOwnProperty("guRetryDelaySeconds"))
                if (!$util.isInteger(message.guRetryDelaySeconds))
                    return "guRetryDelaySeconds: integer expected";
            if (message.customNudgeDelays != null && message.hasOwnProperty("customNudgeDelays")) {
                if (!Array.isArray(message.customNudgeDelays))
                    return "customNudgeDelays: array expected";
                for (let i = 0; i < message.customNudgeDelays.length; ++i) {
                    let error = $root.sync_pb.CustomNudgeDelay.verify(message.customNudgeDelays[i]);
                    if (error)
                        return "customNudgeDelays." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ClientCommand message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ClientCommand
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ClientCommand} ClientCommand
         */
        ClientCommand.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ClientCommand)
                return object;
            let message = new $root.sync_pb.ClientCommand();
            if (object.setSyncPollInterval != null)
                message.setSyncPollInterval = object.setSyncPollInterval | 0;
            if (object.setSyncLongPollInterval != null)
                message.setSyncLongPollInterval = object.setSyncLongPollInterval | 0;
            if (object.maxCommitBatchSize != null)
                message.maxCommitBatchSize = object.maxCommitBatchSize | 0;
            if (object.sessionsCommitDelaySeconds != null)
                message.sessionsCommitDelaySeconds = object.sessionsCommitDelaySeconds | 0;
            if (object.throttleDelaySeconds != null)
                message.throttleDelaySeconds = object.throttleDelaySeconds | 0;
            if (object.clientInvalidationHintBufferSize != null)
                message.clientInvalidationHintBufferSize = object.clientInvalidationHintBufferSize | 0;
            if (object.guRetryDelaySeconds != null)
                message.guRetryDelaySeconds = object.guRetryDelaySeconds | 0;
            if (object.customNudgeDelays) {
                if (!Array.isArray(object.customNudgeDelays))
                    throw TypeError(".sync_pb.ClientCommand.customNudgeDelays: array expected");
                message.customNudgeDelays = [];
                for (let i = 0; i < object.customNudgeDelays.length; ++i) {
                    if (typeof object.customNudgeDelays[i] !== "object")
                        throw TypeError(".sync_pb.ClientCommand.customNudgeDelays: object expected");
                    message.customNudgeDelays[i] = $root.sync_pb.CustomNudgeDelay.fromObject(object.customNudgeDelays[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ClientCommand message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ClientCommand
         * @static
         * @param {sync_pb.ClientCommand} message ClientCommand
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ClientCommand.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.customNudgeDelays = [];
            if (options.defaults) {
                object.setSyncPollInterval = 0;
                object.setSyncLongPollInterval = 0;
                object.maxCommitBatchSize = 0;
                object.sessionsCommitDelaySeconds = 0;
                object.throttleDelaySeconds = 0;
                object.clientInvalidationHintBufferSize = 0;
                object.guRetryDelaySeconds = 0;
            }
            if (message.setSyncPollInterval != null && message.hasOwnProperty("setSyncPollInterval"))
                object.setSyncPollInterval = message.setSyncPollInterval;
            if (message.setSyncLongPollInterval != null && message.hasOwnProperty("setSyncLongPollInterval"))
                object.setSyncLongPollInterval = message.setSyncLongPollInterval;
            if (message.maxCommitBatchSize != null && message.hasOwnProperty("maxCommitBatchSize"))
                object.maxCommitBatchSize = message.maxCommitBatchSize;
            if (message.sessionsCommitDelaySeconds != null && message.hasOwnProperty("sessionsCommitDelaySeconds"))
                object.sessionsCommitDelaySeconds = message.sessionsCommitDelaySeconds;
            if (message.throttleDelaySeconds != null && message.hasOwnProperty("throttleDelaySeconds"))
                object.throttleDelaySeconds = message.throttleDelaySeconds;
            if (message.clientInvalidationHintBufferSize != null && message.hasOwnProperty("clientInvalidationHintBufferSize"))
                object.clientInvalidationHintBufferSize = message.clientInvalidationHintBufferSize;
            if (message.guRetryDelaySeconds != null && message.hasOwnProperty("guRetryDelaySeconds"))
                object.guRetryDelaySeconds = message.guRetryDelaySeconds;
            if (message.customNudgeDelays && message.customNudgeDelays.length) {
                object.customNudgeDelays = [];
                for (let j = 0; j < message.customNudgeDelays.length; ++j)
                    object.customNudgeDelays[j] = $root.sync_pb.CustomNudgeDelay.toObject(message.customNudgeDelays[j], options);
            }
            return object;
        };

        /**
         * Converts this ClientCommand to JSON.
         * @function toJSON
         * @memberof sync_pb.ClientCommand
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ClientCommand.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClientCommand;
    })();

    sync_pb.TypeHint = (function() {

        /**
         * Properties of a TypeHint.
         * @memberof sync_pb
         * @interface ITypeHint
         * @property {number|null} [dataTypeId] TypeHint dataTypeId
         * @property {boolean|null} [hasValidHint] TypeHint hasValidHint
         */

        /**
         * Constructs a new TypeHint.
         * @memberof sync_pb
         * @classdesc Represents a TypeHint.
         * @implements ITypeHint
         * @constructor
         * @param {sync_pb.ITypeHint=} [properties] Properties to set
         */
        function TypeHint(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TypeHint dataTypeId.
         * @member {number} dataTypeId
         * @memberof sync_pb.TypeHint
         * @instance
         */
        TypeHint.prototype.dataTypeId = 0;

        /**
         * TypeHint hasValidHint.
         * @member {boolean} hasValidHint
         * @memberof sync_pb.TypeHint
         * @instance
         */
        TypeHint.prototype.hasValidHint = false;

        /**
         * Creates a new TypeHint instance using the specified properties.
         * @function create
         * @memberof sync_pb.TypeHint
         * @static
         * @param {sync_pb.ITypeHint=} [properties] Properties to set
         * @returns {sync_pb.TypeHint} TypeHint instance
         */
        TypeHint.create = function create(properties) {
            return new TypeHint(properties);
        };

        /**
         * Encodes the specified TypeHint message. Does not implicitly {@link sync_pb.TypeHint.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.TypeHint
         * @static
         * @param {sync_pb.ITypeHint} message TypeHint message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TypeHint.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.dataTypeId != null && Object.hasOwnProperty.call(message, "dataTypeId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dataTypeId);
            if (message.hasValidHint != null && Object.hasOwnProperty.call(message, "hasValidHint"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.hasValidHint);
            return writer;
        };

        /**
         * Encodes the specified TypeHint message, length delimited. Does not implicitly {@link sync_pb.TypeHint.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.TypeHint
         * @static
         * @param {sync_pb.ITypeHint} message TypeHint message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TypeHint.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TypeHint message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.TypeHint
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.TypeHint} TypeHint
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TypeHint.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.TypeHint();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.dataTypeId = reader.int32();
                    break;
                case 2:
                    message.hasValidHint = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TypeHint message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.TypeHint
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.TypeHint} TypeHint
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TypeHint.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TypeHint message.
         * @function verify
         * @memberof sync_pb.TypeHint
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TypeHint.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.dataTypeId != null && message.hasOwnProperty("dataTypeId"))
                if (!$util.isInteger(message.dataTypeId))
                    return "dataTypeId: integer expected";
            if (message.hasValidHint != null && message.hasOwnProperty("hasValidHint"))
                if (typeof message.hasValidHint !== "boolean")
                    return "hasValidHint: boolean expected";
            return null;
        };

        /**
         * Creates a TypeHint message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.TypeHint
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.TypeHint} TypeHint
         */
        TypeHint.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.TypeHint)
                return object;
            let message = new $root.sync_pb.TypeHint();
            if (object.dataTypeId != null)
                message.dataTypeId = object.dataTypeId | 0;
            if (object.hasValidHint != null)
                message.hasValidHint = Boolean(object.hasValidHint);
            return message;
        };

        /**
         * Creates a plain object from a TypeHint message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.TypeHint
         * @static
         * @param {sync_pb.TypeHint} message TypeHint
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TypeHint.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.dataTypeId = 0;
                object.hasValidHint = false;
            }
            if (message.dataTypeId != null && message.hasOwnProperty("dataTypeId"))
                object.dataTypeId = message.dataTypeId;
            if (message.hasValidHint != null && message.hasOwnProperty("hasValidHint"))
                object.hasValidHint = message.hasValidHint;
            return object;
        };

        /**
         * Converts this TypeHint to JSON.
         * @function toJSON
         * @memberof sync_pb.TypeHint
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TypeHint.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TypeHint;
    })();

    sync_pb.SyncCycleCompletedEventInfo = (function() {

        /**
         * Properties of a SyncCycleCompletedEventInfo.
         * @memberof sync_pb
         * @interface ISyncCycleCompletedEventInfo
         * @property {number|null} [numEncryptionConflicts] SyncCycleCompletedEventInfo numEncryptionConflicts
         * @property {number|null} [numHierarchyConflicts] SyncCycleCompletedEventInfo numHierarchyConflicts
         * @property {number|null} [numSimpleConflicts] SyncCycleCompletedEventInfo numSimpleConflicts
         * @property {number|null} [numServerConflicts] SyncCycleCompletedEventInfo numServerConflicts
         * @property {number|null} [numUpdatesDownloaded] SyncCycleCompletedEventInfo numUpdatesDownloaded
         * @property {number|null} [numReflectedUpdatesDownloaded] SyncCycleCompletedEventInfo numReflectedUpdatesDownloaded
         * @property {sync_pb.IGetUpdatesCallerInfo|null} [callerInfo] SyncCycleCompletedEventInfo callerInfo
         * @property {sync_pb.SyncEnums.GetUpdatesOrigin|null} [getUpdatesOrigin] SyncCycleCompletedEventInfo getUpdatesOrigin
         */

        /**
         * Constructs a new SyncCycleCompletedEventInfo.
         * @memberof sync_pb
         * @classdesc Represents a SyncCycleCompletedEventInfo.
         * @implements ISyncCycleCompletedEventInfo
         * @constructor
         * @param {sync_pb.ISyncCycleCompletedEventInfo=} [properties] Properties to set
         */
        function SyncCycleCompletedEventInfo(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncCycleCompletedEventInfo numEncryptionConflicts.
         * @member {number} numEncryptionConflicts
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @instance
         */
        SyncCycleCompletedEventInfo.prototype.numEncryptionConflicts = 0;

        /**
         * SyncCycleCompletedEventInfo numHierarchyConflicts.
         * @member {number} numHierarchyConflicts
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @instance
         */
        SyncCycleCompletedEventInfo.prototype.numHierarchyConflicts = 0;

        /**
         * SyncCycleCompletedEventInfo numSimpleConflicts.
         * @member {number} numSimpleConflicts
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @instance
         */
        SyncCycleCompletedEventInfo.prototype.numSimpleConflicts = 0;

        /**
         * SyncCycleCompletedEventInfo numServerConflicts.
         * @member {number} numServerConflicts
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @instance
         */
        SyncCycleCompletedEventInfo.prototype.numServerConflicts = 0;

        /**
         * SyncCycleCompletedEventInfo numUpdatesDownloaded.
         * @member {number} numUpdatesDownloaded
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @instance
         */
        SyncCycleCompletedEventInfo.prototype.numUpdatesDownloaded = 0;

        /**
         * SyncCycleCompletedEventInfo numReflectedUpdatesDownloaded.
         * @member {number} numReflectedUpdatesDownloaded
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @instance
         */
        SyncCycleCompletedEventInfo.prototype.numReflectedUpdatesDownloaded = 0;

        /**
         * SyncCycleCompletedEventInfo callerInfo.
         * @member {sync_pb.IGetUpdatesCallerInfo|null|undefined} callerInfo
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @instance
         */
        SyncCycleCompletedEventInfo.prototype.callerInfo = null;

        /**
         * SyncCycleCompletedEventInfo getUpdatesOrigin.
         * @member {sync_pb.SyncEnums.GetUpdatesOrigin} getUpdatesOrigin
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @instance
         */
        SyncCycleCompletedEventInfo.prototype.getUpdatesOrigin = 0;

        /**
         * Creates a new SyncCycleCompletedEventInfo instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @static
         * @param {sync_pb.ISyncCycleCompletedEventInfo=} [properties] Properties to set
         * @returns {sync_pb.SyncCycleCompletedEventInfo} SyncCycleCompletedEventInfo instance
         */
        SyncCycleCompletedEventInfo.create = function create(properties) {
            return new SyncCycleCompletedEventInfo(properties);
        };

        /**
         * Encodes the specified SyncCycleCompletedEventInfo message. Does not implicitly {@link sync_pb.SyncCycleCompletedEventInfo.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @static
         * @param {sync_pb.ISyncCycleCompletedEventInfo} message SyncCycleCompletedEventInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncCycleCompletedEventInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.numEncryptionConflicts != null && Object.hasOwnProperty.call(message, "numEncryptionConflicts"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.numEncryptionConflicts);
            if (message.numHierarchyConflicts != null && Object.hasOwnProperty.call(message, "numHierarchyConflicts"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.numHierarchyConflicts);
            if (message.numSimpleConflicts != null && Object.hasOwnProperty.call(message, "numSimpleConflicts"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.numSimpleConflicts);
            if (message.numServerConflicts != null && Object.hasOwnProperty.call(message, "numServerConflicts"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.numServerConflicts);
            if (message.numUpdatesDownloaded != null && Object.hasOwnProperty.call(message, "numUpdatesDownloaded"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.numUpdatesDownloaded);
            if (message.numReflectedUpdatesDownloaded != null && Object.hasOwnProperty.call(message, "numReflectedUpdatesDownloaded"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.numReflectedUpdatesDownloaded);
            if (message.callerInfo != null && Object.hasOwnProperty.call(message, "callerInfo"))
                $root.sync_pb.GetUpdatesCallerInfo.encode(message.callerInfo, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            if (message.getUpdatesOrigin != null && Object.hasOwnProperty.call(message, "getUpdatesOrigin"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.getUpdatesOrigin);
            return writer;
        };

        /**
         * Encodes the specified SyncCycleCompletedEventInfo message, length delimited. Does not implicitly {@link sync_pb.SyncCycleCompletedEventInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @static
         * @param {sync_pb.ISyncCycleCompletedEventInfo} message SyncCycleCompletedEventInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncCycleCompletedEventInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncCycleCompletedEventInfo message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncCycleCompletedEventInfo} SyncCycleCompletedEventInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncCycleCompletedEventInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncCycleCompletedEventInfo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 4:
                    message.numEncryptionConflicts = reader.int32();
                    break;
                case 5:
                    message.numHierarchyConflicts = reader.int32();
                    break;
                case 6:
                    message.numSimpleConflicts = reader.int32();
                    break;
                case 7:
                    message.numServerConflicts = reader.int32();
                    break;
                case 8:
                    message.numUpdatesDownloaded = reader.int32();
                    break;
                case 9:
                    message.numReflectedUpdatesDownloaded = reader.int32();
                    break;
                case 10:
                    message.callerInfo = $root.sync_pb.GetUpdatesCallerInfo.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.getUpdatesOrigin = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncCycleCompletedEventInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncCycleCompletedEventInfo} SyncCycleCompletedEventInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncCycleCompletedEventInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncCycleCompletedEventInfo message.
         * @function verify
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncCycleCompletedEventInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.numEncryptionConflicts != null && message.hasOwnProperty("numEncryptionConflicts"))
                if (!$util.isInteger(message.numEncryptionConflicts))
                    return "numEncryptionConflicts: integer expected";
            if (message.numHierarchyConflicts != null && message.hasOwnProperty("numHierarchyConflicts"))
                if (!$util.isInteger(message.numHierarchyConflicts))
                    return "numHierarchyConflicts: integer expected";
            if (message.numSimpleConflicts != null && message.hasOwnProperty("numSimpleConflicts"))
                if (!$util.isInteger(message.numSimpleConflicts))
                    return "numSimpleConflicts: integer expected";
            if (message.numServerConflicts != null && message.hasOwnProperty("numServerConflicts"))
                if (!$util.isInteger(message.numServerConflicts))
                    return "numServerConflicts: integer expected";
            if (message.numUpdatesDownloaded != null && message.hasOwnProperty("numUpdatesDownloaded"))
                if (!$util.isInteger(message.numUpdatesDownloaded))
                    return "numUpdatesDownloaded: integer expected";
            if (message.numReflectedUpdatesDownloaded != null && message.hasOwnProperty("numReflectedUpdatesDownloaded"))
                if (!$util.isInteger(message.numReflectedUpdatesDownloaded))
                    return "numReflectedUpdatesDownloaded: integer expected";
            if (message.callerInfo != null && message.hasOwnProperty("callerInfo")) {
                let error = $root.sync_pb.GetUpdatesCallerInfo.verify(message.callerInfo);
                if (error)
                    return "callerInfo." + error;
            }
            if (message.getUpdatesOrigin != null && message.hasOwnProperty("getUpdatesOrigin"))
                switch (message.getUpdatesOrigin) {
                default:
                    return "getUpdatesOrigin: enum value expected";
                case 0:
                case 4:
                case 7:
                case 8:
                case 9:
                case 10:
                case 12:
                case 13:
                case 14:
                    break;
                }
            return null;
        };

        /**
         * Creates a SyncCycleCompletedEventInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncCycleCompletedEventInfo} SyncCycleCompletedEventInfo
         */
        SyncCycleCompletedEventInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncCycleCompletedEventInfo)
                return object;
            let message = new $root.sync_pb.SyncCycleCompletedEventInfo();
            if (object.numEncryptionConflicts != null)
                message.numEncryptionConflicts = object.numEncryptionConflicts | 0;
            if (object.numHierarchyConflicts != null)
                message.numHierarchyConflicts = object.numHierarchyConflicts | 0;
            if (object.numSimpleConflicts != null)
                message.numSimpleConflicts = object.numSimpleConflicts | 0;
            if (object.numServerConflicts != null)
                message.numServerConflicts = object.numServerConflicts | 0;
            if (object.numUpdatesDownloaded != null)
                message.numUpdatesDownloaded = object.numUpdatesDownloaded | 0;
            if (object.numReflectedUpdatesDownloaded != null)
                message.numReflectedUpdatesDownloaded = object.numReflectedUpdatesDownloaded | 0;
            if (object.callerInfo != null) {
                if (typeof object.callerInfo !== "object")
                    throw TypeError(".sync_pb.SyncCycleCompletedEventInfo.callerInfo: object expected");
                message.callerInfo = $root.sync_pb.GetUpdatesCallerInfo.fromObject(object.callerInfo);
            }
            switch (object.getUpdatesOrigin) {
            case "UNKNOWN_ORIGIN":
            case 0:
                message.getUpdatesOrigin = 0;
                break;
            case "PERIODIC":
            case 4:
                message.getUpdatesOrigin = 4;
                break;
            case "NEWLY_SUPPORTED_DATATYPE":
            case 7:
                message.getUpdatesOrigin = 7;
                break;
            case "MIGRATION":
            case 8:
                message.getUpdatesOrigin = 8;
                break;
            case "NEW_CLIENT":
            case 9:
                message.getUpdatesOrigin = 9;
                break;
            case "RECONFIGURATION":
            case 10:
                message.getUpdatesOrigin = 10;
                break;
            case "GU_TRIGGER":
            case 12:
                message.getUpdatesOrigin = 12;
                break;
            case "RETRY":
            case 13:
                message.getUpdatesOrigin = 13;
                break;
            case "PROGRAMMATIC":
            case 14:
                message.getUpdatesOrigin = 14;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a SyncCycleCompletedEventInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @static
         * @param {sync_pb.SyncCycleCompletedEventInfo} message SyncCycleCompletedEventInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncCycleCompletedEventInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.numEncryptionConflicts = 0;
                object.numHierarchyConflicts = 0;
                object.numSimpleConflicts = 0;
                object.numServerConflicts = 0;
                object.numUpdatesDownloaded = 0;
                object.numReflectedUpdatesDownloaded = 0;
                object.callerInfo = null;
                object.getUpdatesOrigin = options.enums === String ? "UNKNOWN_ORIGIN" : 0;
            }
            if (message.numEncryptionConflicts != null && message.hasOwnProperty("numEncryptionConflicts"))
                object.numEncryptionConflicts = message.numEncryptionConflicts;
            if (message.numHierarchyConflicts != null && message.hasOwnProperty("numHierarchyConflicts"))
                object.numHierarchyConflicts = message.numHierarchyConflicts;
            if (message.numSimpleConflicts != null && message.hasOwnProperty("numSimpleConflicts"))
                object.numSimpleConflicts = message.numSimpleConflicts;
            if (message.numServerConflicts != null && message.hasOwnProperty("numServerConflicts"))
                object.numServerConflicts = message.numServerConflicts;
            if (message.numUpdatesDownloaded != null && message.hasOwnProperty("numUpdatesDownloaded"))
                object.numUpdatesDownloaded = message.numUpdatesDownloaded;
            if (message.numReflectedUpdatesDownloaded != null && message.hasOwnProperty("numReflectedUpdatesDownloaded"))
                object.numReflectedUpdatesDownloaded = message.numReflectedUpdatesDownloaded;
            if (message.callerInfo != null && message.hasOwnProperty("callerInfo"))
                object.callerInfo = $root.sync_pb.GetUpdatesCallerInfo.toObject(message.callerInfo, options);
            if (message.getUpdatesOrigin != null && message.hasOwnProperty("getUpdatesOrigin"))
                object.getUpdatesOrigin = options.enums === String ? $root.sync_pb.SyncEnums.GetUpdatesOrigin[message.getUpdatesOrigin] : message.getUpdatesOrigin;
            return object;
        };

        /**
         * Converts this SyncCycleCompletedEventInfo to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncCycleCompletedEventInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncCycleCompletedEventInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncCycleCompletedEventInfo;
    })();

    sync_pb.DatatypeAssociationStats = (function() {

        /**
         * Properties of a DatatypeAssociationStats.
         * @memberof sync_pb
         * @interface IDatatypeAssociationStats
         * @property {number|null} [dataTypeId] DatatypeAssociationStats dataTypeId
         * @property {number|null} [numLocalItemsBeforeAssociation] DatatypeAssociationStats numLocalItemsBeforeAssociation
         * @property {number|null} [numSyncItemsBeforeAssociation] DatatypeAssociationStats numSyncItemsBeforeAssociation
         * @property {number|null} [numLocalItemsAfterAssociation] DatatypeAssociationStats numLocalItemsAfterAssociation
         * @property {number|null} [numSyncItemsAfterAssociation] DatatypeAssociationStats numSyncItemsAfterAssociation
         * @property {number|null} [numLocalItemsAdded] DatatypeAssociationStats numLocalItemsAdded
         * @property {number|null} [numLocalItemsDeleted] DatatypeAssociationStats numLocalItemsDeleted
         * @property {number|null} [numLocalItemsModified] DatatypeAssociationStats numLocalItemsModified
         * @property {number|null} [numSyncItemsAdded] DatatypeAssociationStats numSyncItemsAdded
         * @property {number|null} [numSyncItemsDeleted] DatatypeAssociationStats numSyncItemsDeleted
         * @property {number|null} [numSyncItemsModified] DatatypeAssociationStats numSyncItemsModified
         * @property {number|Long|null} [localVersionPreAssociation] DatatypeAssociationStats localVersionPreAssociation
         * @property {number|Long|null} [syncVersionPreAssociation] DatatypeAssociationStats syncVersionPreAssociation
         * @property {boolean|null} [hadError] DatatypeAssociationStats hadError
         * @property {number|Long|null} [downloadWaitTimeUs] DatatypeAssociationStats downloadWaitTimeUs
         * @property {number|Long|null} [downloadTimeUs] DatatypeAssociationStats downloadTimeUs
         * @property {number|Long|null} [associationWaitTimeForHighPriorityUs] DatatypeAssociationStats associationWaitTimeForHighPriorityUs
         * @property {number|Long|null} [associationWaitTimeForSamePriorityUs] DatatypeAssociationStats associationWaitTimeForSamePriorityUs
         * @property {number|Long|null} [associationTimeUs] DatatypeAssociationStats associationTimeUs
         * @property {Array.<number>|null} [highPriorityTypeConfiguredBefore] DatatypeAssociationStats highPriorityTypeConfiguredBefore
         * @property {Array.<number>|null} [samePriorityTypeConfiguredBefore] DatatypeAssociationStats samePriorityTypeConfiguredBefore
         */

        /**
         * Constructs a new DatatypeAssociationStats.
         * @memberof sync_pb
         * @classdesc Represents a DatatypeAssociationStats.
         * @implements IDatatypeAssociationStats
         * @constructor
         * @param {sync_pb.IDatatypeAssociationStats=} [properties] Properties to set
         */
        function DatatypeAssociationStats(properties) {
            this.highPriorityTypeConfiguredBefore = [];
            this.samePriorityTypeConfiguredBefore = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DatatypeAssociationStats dataTypeId.
         * @member {number} dataTypeId
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.dataTypeId = 0;

        /**
         * DatatypeAssociationStats numLocalItemsBeforeAssociation.
         * @member {number} numLocalItemsBeforeAssociation
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.numLocalItemsBeforeAssociation = 0;

        /**
         * DatatypeAssociationStats numSyncItemsBeforeAssociation.
         * @member {number} numSyncItemsBeforeAssociation
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.numSyncItemsBeforeAssociation = 0;

        /**
         * DatatypeAssociationStats numLocalItemsAfterAssociation.
         * @member {number} numLocalItemsAfterAssociation
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.numLocalItemsAfterAssociation = 0;

        /**
         * DatatypeAssociationStats numSyncItemsAfterAssociation.
         * @member {number} numSyncItemsAfterAssociation
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.numSyncItemsAfterAssociation = 0;

        /**
         * DatatypeAssociationStats numLocalItemsAdded.
         * @member {number} numLocalItemsAdded
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.numLocalItemsAdded = 0;

        /**
         * DatatypeAssociationStats numLocalItemsDeleted.
         * @member {number} numLocalItemsDeleted
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.numLocalItemsDeleted = 0;

        /**
         * DatatypeAssociationStats numLocalItemsModified.
         * @member {number} numLocalItemsModified
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.numLocalItemsModified = 0;

        /**
         * DatatypeAssociationStats numSyncItemsAdded.
         * @member {number} numSyncItemsAdded
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.numSyncItemsAdded = 0;

        /**
         * DatatypeAssociationStats numSyncItemsDeleted.
         * @member {number} numSyncItemsDeleted
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.numSyncItemsDeleted = 0;

        /**
         * DatatypeAssociationStats numSyncItemsModified.
         * @member {number} numSyncItemsModified
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.numSyncItemsModified = 0;

        /**
         * DatatypeAssociationStats localVersionPreAssociation.
         * @member {number|Long} localVersionPreAssociation
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.localVersionPreAssociation = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * DatatypeAssociationStats syncVersionPreAssociation.
         * @member {number|Long} syncVersionPreAssociation
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.syncVersionPreAssociation = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * DatatypeAssociationStats hadError.
         * @member {boolean} hadError
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.hadError = false;

        /**
         * DatatypeAssociationStats downloadWaitTimeUs.
         * @member {number|Long} downloadWaitTimeUs
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.downloadWaitTimeUs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * DatatypeAssociationStats downloadTimeUs.
         * @member {number|Long} downloadTimeUs
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.downloadTimeUs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * DatatypeAssociationStats associationWaitTimeForHighPriorityUs.
         * @member {number|Long} associationWaitTimeForHighPriorityUs
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.associationWaitTimeForHighPriorityUs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * DatatypeAssociationStats associationWaitTimeForSamePriorityUs.
         * @member {number|Long} associationWaitTimeForSamePriorityUs
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.associationWaitTimeForSamePriorityUs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * DatatypeAssociationStats associationTimeUs.
         * @member {number|Long} associationTimeUs
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.associationTimeUs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * DatatypeAssociationStats highPriorityTypeConfiguredBefore.
         * @member {Array.<number>} highPriorityTypeConfiguredBefore
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.highPriorityTypeConfiguredBefore = $util.emptyArray;

        /**
         * DatatypeAssociationStats samePriorityTypeConfiguredBefore.
         * @member {Array.<number>} samePriorityTypeConfiguredBefore
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         */
        DatatypeAssociationStats.prototype.samePriorityTypeConfiguredBefore = $util.emptyArray;

        /**
         * Creates a new DatatypeAssociationStats instance using the specified properties.
         * @function create
         * @memberof sync_pb.DatatypeAssociationStats
         * @static
         * @param {sync_pb.IDatatypeAssociationStats=} [properties] Properties to set
         * @returns {sync_pb.DatatypeAssociationStats} DatatypeAssociationStats instance
         */
        DatatypeAssociationStats.create = function create(properties) {
            return new DatatypeAssociationStats(properties);
        };

        /**
         * Encodes the specified DatatypeAssociationStats message. Does not implicitly {@link sync_pb.DatatypeAssociationStats.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.DatatypeAssociationStats
         * @static
         * @param {sync_pb.IDatatypeAssociationStats} message DatatypeAssociationStats message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DatatypeAssociationStats.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.dataTypeId != null && Object.hasOwnProperty.call(message, "dataTypeId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dataTypeId);
            if (message.numLocalItemsBeforeAssociation != null && Object.hasOwnProperty.call(message, "numLocalItemsBeforeAssociation"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.numLocalItemsBeforeAssociation);
            if (message.numSyncItemsBeforeAssociation != null && Object.hasOwnProperty.call(message, "numSyncItemsBeforeAssociation"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.numSyncItemsBeforeAssociation);
            if (message.numLocalItemsAfterAssociation != null && Object.hasOwnProperty.call(message, "numLocalItemsAfterAssociation"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.numLocalItemsAfterAssociation);
            if (message.numSyncItemsAfterAssociation != null && Object.hasOwnProperty.call(message, "numSyncItemsAfterAssociation"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.numSyncItemsAfterAssociation);
            if (message.numLocalItemsAdded != null && Object.hasOwnProperty.call(message, "numLocalItemsAdded"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.numLocalItemsAdded);
            if (message.numLocalItemsDeleted != null && Object.hasOwnProperty.call(message, "numLocalItemsDeleted"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.numLocalItemsDeleted);
            if (message.numLocalItemsModified != null && Object.hasOwnProperty.call(message, "numLocalItemsModified"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.numLocalItemsModified);
            if (message.numSyncItemsAdded != null && Object.hasOwnProperty.call(message, "numSyncItemsAdded"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.numSyncItemsAdded);
            if (message.numSyncItemsDeleted != null && Object.hasOwnProperty.call(message, "numSyncItemsDeleted"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.numSyncItemsDeleted);
            if (message.numSyncItemsModified != null && Object.hasOwnProperty.call(message, "numSyncItemsModified"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.numSyncItemsModified);
            if (message.hadError != null && Object.hasOwnProperty.call(message, "hadError"))
                writer.uint32(/* id 12, wireType 0 =*/96).bool(message.hadError);
            if (message.downloadTimeUs != null && Object.hasOwnProperty.call(message, "downloadTimeUs"))
                writer.uint32(/* id 13, wireType 0 =*/104).int64(message.downloadTimeUs);
            if (message.associationWaitTimeForSamePriorityUs != null && Object.hasOwnProperty.call(message, "associationWaitTimeForSamePriorityUs"))
                writer.uint32(/* id 14, wireType 0 =*/112).int64(message.associationWaitTimeForSamePriorityUs);
            if (message.downloadWaitTimeUs != null && Object.hasOwnProperty.call(message, "downloadWaitTimeUs"))
                writer.uint32(/* id 15, wireType 0 =*/120).int64(message.downloadWaitTimeUs);
            if (message.associationWaitTimeForHighPriorityUs != null && Object.hasOwnProperty.call(message, "associationWaitTimeForHighPriorityUs"))
                writer.uint32(/* id 16, wireType 0 =*/128).int64(message.associationWaitTimeForHighPriorityUs);
            if (message.associationTimeUs != null && Object.hasOwnProperty.call(message, "associationTimeUs"))
                writer.uint32(/* id 17, wireType 0 =*/136).int64(message.associationTimeUs);
            if (message.highPriorityTypeConfiguredBefore != null && message.highPriorityTypeConfiguredBefore.length)
                for (let i = 0; i < message.highPriorityTypeConfiguredBefore.length; ++i)
                    writer.uint32(/* id 18, wireType 0 =*/144).int32(message.highPriorityTypeConfiguredBefore[i]);
            if (message.samePriorityTypeConfiguredBefore != null && message.samePriorityTypeConfiguredBefore.length)
                for (let i = 0; i < message.samePriorityTypeConfiguredBefore.length; ++i)
                    writer.uint32(/* id 19, wireType 0 =*/152).int32(message.samePriorityTypeConfiguredBefore[i]);
            if (message.localVersionPreAssociation != null && Object.hasOwnProperty.call(message, "localVersionPreAssociation"))
                writer.uint32(/* id 20, wireType 0 =*/160).int64(message.localVersionPreAssociation);
            if (message.syncVersionPreAssociation != null && Object.hasOwnProperty.call(message, "syncVersionPreAssociation"))
                writer.uint32(/* id 21, wireType 0 =*/168).int64(message.syncVersionPreAssociation);
            return writer;
        };

        /**
         * Encodes the specified DatatypeAssociationStats message, length delimited. Does not implicitly {@link sync_pb.DatatypeAssociationStats.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.DatatypeAssociationStats
         * @static
         * @param {sync_pb.IDatatypeAssociationStats} message DatatypeAssociationStats message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DatatypeAssociationStats.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DatatypeAssociationStats message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.DatatypeAssociationStats
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.DatatypeAssociationStats} DatatypeAssociationStats
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DatatypeAssociationStats.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.DatatypeAssociationStats();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.dataTypeId = reader.int32();
                    break;
                case 2:
                    message.numLocalItemsBeforeAssociation = reader.int32();
                    break;
                case 3:
                    message.numSyncItemsBeforeAssociation = reader.int32();
                    break;
                case 4:
                    message.numLocalItemsAfterAssociation = reader.int32();
                    break;
                case 5:
                    message.numSyncItemsAfterAssociation = reader.int32();
                    break;
                case 6:
                    message.numLocalItemsAdded = reader.int32();
                    break;
                case 7:
                    message.numLocalItemsDeleted = reader.int32();
                    break;
                case 8:
                    message.numLocalItemsModified = reader.int32();
                    break;
                case 9:
                    message.numSyncItemsAdded = reader.int32();
                    break;
                case 10:
                    message.numSyncItemsDeleted = reader.int32();
                    break;
                case 11:
                    message.numSyncItemsModified = reader.int32();
                    break;
                case 20:
                    message.localVersionPreAssociation = reader.int64();
                    break;
                case 21:
                    message.syncVersionPreAssociation = reader.int64();
                    break;
                case 12:
                    message.hadError = reader.bool();
                    break;
                case 15:
                    message.downloadWaitTimeUs = reader.int64();
                    break;
                case 13:
                    message.downloadTimeUs = reader.int64();
                    break;
                case 16:
                    message.associationWaitTimeForHighPriorityUs = reader.int64();
                    break;
                case 14:
                    message.associationWaitTimeForSamePriorityUs = reader.int64();
                    break;
                case 17:
                    message.associationTimeUs = reader.int64();
                    break;
                case 18:
                    if (!(message.highPriorityTypeConfiguredBefore && message.highPriorityTypeConfiguredBefore.length))
                        message.highPriorityTypeConfiguredBefore = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.highPriorityTypeConfiguredBefore.push(reader.int32());
                    } else
                        message.highPriorityTypeConfiguredBefore.push(reader.int32());
                    break;
                case 19:
                    if (!(message.samePriorityTypeConfiguredBefore && message.samePriorityTypeConfiguredBefore.length))
                        message.samePriorityTypeConfiguredBefore = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.samePriorityTypeConfiguredBefore.push(reader.int32());
                    } else
                        message.samePriorityTypeConfiguredBefore.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DatatypeAssociationStats message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.DatatypeAssociationStats
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.DatatypeAssociationStats} DatatypeAssociationStats
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DatatypeAssociationStats.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DatatypeAssociationStats message.
         * @function verify
         * @memberof sync_pb.DatatypeAssociationStats
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DatatypeAssociationStats.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.dataTypeId != null && message.hasOwnProperty("dataTypeId"))
                if (!$util.isInteger(message.dataTypeId))
                    return "dataTypeId: integer expected";
            if (message.numLocalItemsBeforeAssociation != null && message.hasOwnProperty("numLocalItemsBeforeAssociation"))
                if (!$util.isInteger(message.numLocalItemsBeforeAssociation))
                    return "numLocalItemsBeforeAssociation: integer expected";
            if (message.numSyncItemsBeforeAssociation != null && message.hasOwnProperty("numSyncItemsBeforeAssociation"))
                if (!$util.isInteger(message.numSyncItemsBeforeAssociation))
                    return "numSyncItemsBeforeAssociation: integer expected";
            if (message.numLocalItemsAfterAssociation != null && message.hasOwnProperty("numLocalItemsAfterAssociation"))
                if (!$util.isInteger(message.numLocalItemsAfterAssociation))
                    return "numLocalItemsAfterAssociation: integer expected";
            if (message.numSyncItemsAfterAssociation != null && message.hasOwnProperty("numSyncItemsAfterAssociation"))
                if (!$util.isInteger(message.numSyncItemsAfterAssociation))
                    return "numSyncItemsAfterAssociation: integer expected";
            if (message.numLocalItemsAdded != null && message.hasOwnProperty("numLocalItemsAdded"))
                if (!$util.isInteger(message.numLocalItemsAdded))
                    return "numLocalItemsAdded: integer expected";
            if (message.numLocalItemsDeleted != null && message.hasOwnProperty("numLocalItemsDeleted"))
                if (!$util.isInteger(message.numLocalItemsDeleted))
                    return "numLocalItemsDeleted: integer expected";
            if (message.numLocalItemsModified != null && message.hasOwnProperty("numLocalItemsModified"))
                if (!$util.isInteger(message.numLocalItemsModified))
                    return "numLocalItemsModified: integer expected";
            if (message.numSyncItemsAdded != null && message.hasOwnProperty("numSyncItemsAdded"))
                if (!$util.isInteger(message.numSyncItemsAdded))
                    return "numSyncItemsAdded: integer expected";
            if (message.numSyncItemsDeleted != null && message.hasOwnProperty("numSyncItemsDeleted"))
                if (!$util.isInteger(message.numSyncItemsDeleted))
                    return "numSyncItemsDeleted: integer expected";
            if (message.numSyncItemsModified != null && message.hasOwnProperty("numSyncItemsModified"))
                if (!$util.isInteger(message.numSyncItemsModified))
                    return "numSyncItemsModified: integer expected";
            if (message.localVersionPreAssociation != null && message.hasOwnProperty("localVersionPreAssociation"))
                if (!$util.isInteger(message.localVersionPreAssociation) && !(message.localVersionPreAssociation && $util.isInteger(message.localVersionPreAssociation.low) && $util.isInteger(message.localVersionPreAssociation.high)))
                    return "localVersionPreAssociation: integer|Long expected";
            if (message.syncVersionPreAssociation != null && message.hasOwnProperty("syncVersionPreAssociation"))
                if (!$util.isInteger(message.syncVersionPreAssociation) && !(message.syncVersionPreAssociation && $util.isInteger(message.syncVersionPreAssociation.low) && $util.isInteger(message.syncVersionPreAssociation.high)))
                    return "syncVersionPreAssociation: integer|Long expected";
            if (message.hadError != null && message.hasOwnProperty("hadError"))
                if (typeof message.hadError !== "boolean")
                    return "hadError: boolean expected";
            if (message.downloadWaitTimeUs != null && message.hasOwnProperty("downloadWaitTimeUs"))
                if (!$util.isInteger(message.downloadWaitTimeUs) && !(message.downloadWaitTimeUs && $util.isInteger(message.downloadWaitTimeUs.low) && $util.isInteger(message.downloadWaitTimeUs.high)))
                    return "downloadWaitTimeUs: integer|Long expected";
            if (message.downloadTimeUs != null && message.hasOwnProperty("downloadTimeUs"))
                if (!$util.isInteger(message.downloadTimeUs) && !(message.downloadTimeUs && $util.isInteger(message.downloadTimeUs.low) && $util.isInteger(message.downloadTimeUs.high)))
                    return "downloadTimeUs: integer|Long expected";
            if (message.associationWaitTimeForHighPriorityUs != null && message.hasOwnProperty("associationWaitTimeForHighPriorityUs"))
                if (!$util.isInteger(message.associationWaitTimeForHighPriorityUs) && !(message.associationWaitTimeForHighPriorityUs && $util.isInteger(message.associationWaitTimeForHighPriorityUs.low) && $util.isInteger(message.associationWaitTimeForHighPriorityUs.high)))
                    return "associationWaitTimeForHighPriorityUs: integer|Long expected";
            if (message.associationWaitTimeForSamePriorityUs != null && message.hasOwnProperty("associationWaitTimeForSamePriorityUs"))
                if (!$util.isInteger(message.associationWaitTimeForSamePriorityUs) && !(message.associationWaitTimeForSamePriorityUs && $util.isInteger(message.associationWaitTimeForSamePriorityUs.low) && $util.isInteger(message.associationWaitTimeForSamePriorityUs.high)))
                    return "associationWaitTimeForSamePriorityUs: integer|Long expected";
            if (message.associationTimeUs != null && message.hasOwnProperty("associationTimeUs"))
                if (!$util.isInteger(message.associationTimeUs) && !(message.associationTimeUs && $util.isInteger(message.associationTimeUs.low) && $util.isInteger(message.associationTimeUs.high)))
                    return "associationTimeUs: integer|Long expected";
            if (message.highPriorityTypeConfiguredBefore != null && message.hasOwnProperty("highPriorityTypeConfiguredBefore")) {
                if (!Array.isArray(message.highPriorityTypeConfiguredBefore))
                    return "highPriorityTypeConfiguredBefore: array expected";
                for (let i = 0; i < message.highPriorityTypeConfiguredBefore.length; ++i)
                    if (!$util.isInteger(message.highPriorityTypeConfiguredBefore[i]))
                        return "highPriorityTypeConfiguredBefore: integer[] expected";
            }
            if (message.samePriorityTypeConfiguredBefore != null && message.hasOwnProperty("samePriorityTypeConfiguredBefore")) {
                if (!Array.isArray(message.samePriorityTypeConfiguredBefore))
                    return "samePriorityTypeConfiguredBefore: array expected";
                for (let i = 0; i < message.samePriorityTypeConfiguredBefore.length; ++i)
                    if (!$util.isInteger(message.samePriorityTypeConfiguredBefore[i]))
                        return "samePriorityTypeConfiguredBefore: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a DatatypeAssociationStats message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.DatatypeAssociationStats
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.DatatypeAssociationStats} DatatypeAssociationStats
         */
        DatatypeAssociationStats.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.DatatypeAssociationStats)
                return object;
            let message = new $root.sync_pb.DatatypeAssociationStats();
            if (object.dataTypeId != null)
                message.dataTypeId = object.dataTypeId | 0;
            if (object.numLocalItemsBeforeAssociation != null)
                message.numLocalItemsBeforeAssociation = object.numLocalItemsBeforeAssociation | 0;
            if (object.numSyncItemsBeforeAssociation != null)
                message.numSyncItemsBeforeAssociation = object.numSyncItemsBeforeAssociation | 0;
            if (object.numLocalItemsAfterAssociation != null)
                message.numLocalItemsAfterAssociation = object.numLocalItemsAfterAssociation | 0;
            if (object.numSyncItemsAfterAssociation != null)
                message.numSyncItemsAfterAssociation = object.numSyncItemsAfterAssociation | 0;
            if (object.numLocalItemsAdded != null)
                message.numLocalItemsAdded = object.numLocalItemsAdded | 0;
            if (object.numLocalItemsDeleted != null)
                message.numLocalItemsDeleted = object.numLocalItemsDeleted | 0;
            if (object.numLocalItemsModified != null)
                message.numLocalItemsModified = object.numLocalItemsModified | 0;
            if (object.numSyncItemsAdded != null)
                message.numSyncItemsAdded = object.numSyncItemsAdded | 0;
            if (object.numSyncItemsDeleted != null)
                message.numSyncItemsDeleted = object.numSyncItemsDeleted | 0;
            if (object.numSyncItemsModified != null)
                message.numSyncItemsModified = object.numSyncItemsModified | 0;
            if (object.localVersionPreAssociation != null)
                if ($util.Long)
                    (message.localVersionPreAssociation = $util.Long.fromValue(object.localVersionPreAssociation)).unsigned = false;
                else if (typeof object.localVersionPreAssociation === "string")
                    message.localVersionPreAssociation = parseInt(object.localVersionPreAssociation, 10);
                else if (typeof object.localVersionPreAssociation === "number")
                    message.localVersionPreAssociation = object.localVersionPreAssociation;
                else if (typeof object.localVersionPreAssociation === "object")
                    message.localVersionPreAssociation = new $util.LongBits(object.localVersionPreAssociation.low >>> 0, object.localVersionPreAssociation.high >>> 0).toNumber();
            if (object.syncVersionPreAssociation != null)
                if ($util.Long)
                    (message.syncVersionPreAssociation = $util.Long.fromValue(object.syncVersionPreAssociation)).unsigned = false;
                else if (typeof object.syncVersionPreAssociation === "string")
                    message.syncVersionPreAssociation = parseInt(object.syncVersionPreAssociation, 10);
                else if (typeof object.syncVersionPreAssociation === "number")
                    message.syncVersionPreAssociation = object.syncVersionPreAssociation;
                else if (typeof object.syncVersionPreAssociation === "object")
                    message.syncVersionPreAssociation = new $util.LongBits(object.syncVersionPreAssociation.low >>> 0, object.syncVersionPreAssociation.high >>> 0).toNumber();
            if (object.hadError != null)
                message.hadError = Boolean(object.hadError);
            if (object.downloadWaitTimeUs != null)
                if ($util.Long)
                    (message.downloadWaitTimeUs = $util.Long.fromValue(object.downloadWaitTimeUs)).unsigned = false;
                else if (typeof object.downloadWaitTimeUs === "string")
                    message.downloadWaitTimeUs = parseInt(object.downloadWaitTimeUs, 10);
                else if (typeof object.downloadWaitTimeUs === "number")
                    message.downloadWaitTimeUs = object.downloadWaitTimeUs;
                else if (typeof object.downloadWaitTimeUs === "object")
                    message.downloadWaitTimeUs = new $util.LongBits(object.downloadWaitTimeUs.low >>> 0, object.downloadWaitTimeUs.high >>> 0).toNumber();
            if (object.downloadTimeUs != null)
                if ($util.Long)
                    (message.downloadTimeUs = $util.Long.fromValue(object.downloadTimeUs)).unsigned = false;
                else if (typeof object.downloadTimeUs === "string")
                    message.downloadTimeUs = parseInt(object.downloadTimeUs, 10);
                else if (typeof object.downloadTimeUs === "number")
                    message.downloadTimeUs = object.downloadTimeUs;
                else if (typeof object.downloadTimeUs === "object")
                    message.downloadTimeUs = new $util.LongBits(object.downloadTimeUs.low >>> 0, object.downloadTimeUs.high >>> 0).toNumber();
            if (object.associationWaitTimeForHighPriorityUs != null)
                if ($util.Long)
                    (message.associationWaitTimeForHighPriorityUs = $util.Long.fromValue(object.associationWaitTimeForHighPriorityUs)).unsigned = false;
                else if (typeof object.associationWaitTimeForHighPriorityUs === "string")
                    message.associationWaitTimeForHighPriorityUs = parseInt(object.associationWaitTimeForHighPriorityUs, 10);
                else if (typeof object.associationWaitTimeForHighPriorityUs === "number")
                    message.associationWaitTimeForHighPriorityUs = object.associationWaitTimeForHighPriorityUs;
                else if (typeof object.associationWaitTimeForHighPriorityUs === "object")
                    message.associationWaitTimeForHighPriorityUs = new $util.LongBits(object.associationWaitTimeForHighPriorityUs.low >>> 0, object.associationWaitTimeForHighPriorityUs.high >>> 0).toNumber();
            if (object.associationWaitTimeForSamePriorityUs != null)
                if ($util.Long)
                    (message.associationWaitTimeForSamePriorityUs = $util.Long.fromValue(object.associationWaitTimeForSamePriorityUs)).unsigned = false;
                else if (typeof object.associationWaitTimeForSamePriorityUs === "string")
                    message.associationWaitTimeForSamePriorityUs = parseInt(object.associationWaitTimeForSamePriorityUs, 10);
                else if (typeof object.associationWaitTimeForSamePriorityUs === "number")
                    message.associationWaitTimeForSamePriorityUs = object.associationWaitTimeForSamePriorityUs;
                else if (typeof object.associationWaitTimeForSamePriorityUs === "object")
                    message.associationWaitTimeForSamePriorityUs = new $util.LongBits(object.associationWaitTimeForSamePriorityUs.low >>> 0, object.associationWaitTimeForSamePriorityUs.high >>> 0).toNumber();
            if (object.associationTimeUs != null)
                if ($util.Long)
                    (message.associationTimeUs = $util.Long.fromValue(object.associationTimeUs)).unsigned = false;
                else if (typeof object.associationTimeUs === "string")
                    message.associationTimeUs = parseInt(object.associationTimeUs, 10);
                else if (typeof object.associationTimeUs === "number")
                    message.associationTimeUs = object.associationTimeUs;
                else if (typeof object.associationTimeUs === "object")
                    message.associationTimeUs = new $util.LongBits(object.associationTimeUs.low >>> 0, object.associationTimeUs.high >>> 0).toNumber();
            if (object.highPriorityTypeConfiguredBefore) {
                if (!Array.isArray(object.highPriorityTypeConfiguredBefore))
                    throw TypeError(".sync_pb.DatatypeAssociationStats.highPriorityTypeConfiguredBefore: array expected");
                message.highPriorityTypeConfiguredBefore = [];
                for (let i = 0; i < object.highPriorityTypeConfiguredBefore.length; ++i)
                    message.highPriorityTypeConfiguredBefore[i] = object.highPriorityTypeConfiguredBefore[i] | 0;
            }
            if (object.samePriorityTypeConfiguredBefore) {
                if (!Array.isArray(object.samePriorityTypeConfiguredBefore))
                    throw TypeError(".sync_pb.DatatypeAssociationStats.samePriorityTypeConfiguredBefore: array expected");
                message.samePriorityTypeConfiguredBefore = [];
                for (let i = 0; i < object.samePriorityTypeConfiguredBefore.length; ++i)
                    message.samePriorityTypeConfiguredBefore[i] = object.samePriorityTypeConfiguredBefore[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a DatatypeAssociationStats message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.DatatypeAssociationStats
         * @static
         * @param {sync_pb.DatatypeAssociationStats} message DatatypeAssociationStats
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DatatypeAssociationStats.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.highPriorityTypeConfiguredBefore = [];
                object.samePriorityTypeConfiguredBefore = [];
            }
            if (options.defaults) {
                object.dataTypeId = 0;
                object.numLocalItemsBeforeAssociation = 0;
                object.numSyncItemsBeforeAssociation = 0;
                object.numLocalItemsAfterAssociation = 0;
                object.numSyncItemsAfterAssociation = 0;
                object.numLocalItemsAdded = 0;
                object.numLocalItemsDeleted = 0;
                object.numLocalItemsModified = 0;
                object.numSyncItemsAdded = 0;
                object.numSyncItemsDeleted = 0;
                object.numSyncItemsModified = 0;
                object.hadError = false;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.downloadTimeUs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.downloadTimeUs = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.associationWaitTimeForSamePriorityUs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.associationWaitTimeForSamePriorityUs = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.downloadWaitTimeUs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.downloadWaitTimeUs = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.associationWaitTimeForHighPriorityUs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.associationWaitTimeForHighPriorityUs = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.associationTimeUs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.associationTimeUs = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.localVersionPreAssociation = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.localVersionPreAssociation = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.syncVersionPreAssociation = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.syncVersionPreAssociation = options.longs === String ? "0" : 0;
            }
            if (message.dataTypeId != null && message.hasOwnProperty("dataTypeId"))
                object.dataTypeId = message.dataTypeId;
            if (message.numLocalItemsBeforeAssociation != null && message.hasOwnProperty("numLocalItemsBeforeAssociation"))
                object.numLocalItemsBeforeAssociation = message.numLocalItemsBeforeAssociation;
            if (message.numSyncItemsBeforeAssociation != null && message.hasOwnProperty("numSyncItemsBeforeAssociation"))
                object.numSyncItemsBeforeAssociation = message.numSyncItemsBeforeAssociation;
            if (message.numLocalItemsAfterAssociation != null && message.hasOwnProperty("numLocalItemsAfterAssociation"))
                object.numLocalItemsAfterAssociation = message.numLocalItemsAfterAssociation;
            if (message.numSyncItemsAfterAssociation != null && message.hasOwnProperty("numSyncItemsAfterAssociation"))
                object.numSyncItemsAfterAssociation = message.numSyncItemsAfterAssociation;
            if (message.numLocalItemsAdded != null && message.hasOwnProperty("numLocalItemsAdded"))
                object.numLocalItemsAdded = message.numLocalItemsAdded;
            if (message.numLocalItemsDeleted != null && message.hasOwnProperty("numLocalItemsDeleted"))
                object.numLocalItemsDeleted = message.numLocalItemsDeleted;
            if (message.numLocalItemsModified != null && message.hasOwnProperty("numLocalItemsModified"))
                object.numLocalItemsModified = message.numLocalItemsModified;
            if (message.numSyncItemsAdded != null && message.hasOwnProperty("numSyncItemsAdded"))
                object.numSyncItemsAdded = message.numSyncItemsAdded;
            if (message.numSyncItemsDeleted != null && message.hasOwnProperty("numSyncItemsDeleted"))
                object.numSyncItemsDeleted = message.numSyncItemsDeleted;
            if (message.numSyncItemsModified != null && message.hasOwnProperty("numSyncItemsModified"))
                object.numSyncItemsModified = message.numSyncItemsModified;
            if (message.hadError != null && message.hasOwnProperty("hadError"))
                object.hadError = message.hadError;
            if (message.downloadTimeUs != null && message.hasOwnProperty("downloadTimeUs"))
                if (typeof message.downloadTimeUs === "number")
                    object.downloadTimeUs = options.longs === String ? String(message.downloadTimeUs) : message.downloadTimeUs;
                else
                    object.downloadTimeUs = options.longs === String ? $util.Long.prototype.toString.call(message.downloadTimeUs) : options.longs === Number ? new $util.LongBits(message.downloadTimeUs.low >>> 0, message.downloadTimeUs.high >>> 0).toNumber() : message.downloadTimeUs;
            if (message.associationWaitTimeForSamePriorityUs != null && message.hasOwnProperty("associationWaitTimeForSamePriorityUs"))
                if (typeof message.associationWaitTimeForSamePriorityUs === "number")
                    object.associationWaitTimeForSamePriorityUs = options.longs === String ? String(message.associationWaitTimeForSamePriorityUs) : message.associationWaitTimeForSamePriorityUs;
                else
                    object.associationWaitTimeForSamePriorityUs = options.longs === String ? $util.Long.prototype.toString.call(message.associationWaitTimeForSamePriorityUs) : options.longs === Number ? new $util.LongBits(message.associationWaitTimeForSamePriorityUs.low >>> 0, message.associationWaitTimeForSamePriorityUs.high >>> 0).toNumber() : message.associationWaitTimeForSamePriorityUs;
            if (message.downloadWaitTimeUs != null && message.hasOwnProperty("downloadWaitTimeUs"))
                if (typeof message.downloadWaitTimeUs === "number")
                    object.downloadWaitTimeUs = options.longs === String ? String(message.downloadWaitTimeUs) : message.downloadWaitTimeUs;
                else
                    object.downloadWaitTimeUs = options.longs === String ? $util.Long.prototype.toString.call(message.downloadWaitTimeUs) : options.longs === Number ? new $util.LongBits(message.downloadWaitTimeUs.low >>> 0, message.downloadWaitTimeUs.high >>> 0).toNumber() : message.downloadWaitTimeUs;
            if (message.associationWaitTimeForHighPriorityUs != null && message.hasOwnProperty("associationWaitTimeForHighPriorityUs"))
                if (typeof message.associationWaitTimeForHighPriorityUs === "number")
                    object.associationWaitTimeForHighPriorityUs = options.longs === String ? String(message.associationWaitTimeForHighPriorityUs) : message.associationWaitTimeForHighPriorityUs;
                else
                    object.associationWaitTimeForHighPriorityUs = options.longs === String ? $util.Long.prototype.toString.call(message.associationWaitTimeForHighPriorityUs) : options.longs === Number ? new $util.LongBits(message.associationWaitTimeForHighPriorityUs.low >>> 0, message.associationWaitTimeForHighPriorityUs.high >>> 0).toNumber() : message.associationWaitTimeForHighPriorityUs;
            if (message.associationTimeUs != null && message.hasOwnProperty("associationTimeUs"))
                if (typeof message.associationTimeUs === "number")
                    object.associationTimeUs = options.longs === String ? String(message.associationTimeUs) : message.associationTimeUs;
                else
                    object.associationTimeUs = options.longs === String ? $util.Long.prototype.toString.call(message.associationTimeUs) : options.longs === Number ? new $util.LongBits(message.associationTimeUs.low >>> 0, message.associationTimeUs.high >>> 0).toNumber() : message.associationTimeUs;
            if (message.highPriorityTypeConfiguredBefore && message.highPriorityTypeConfiguredBefore.length) {
                object.highPriorityTypeConfiguredBefore = [];
                for (let j = 0; j < message.highPriorityTypeConfiguredBefore.length; ++j)
                    object.highPriorityTypeConfiguredBefore[j] = message.highPriorityTypeConfiguredBefore[j];
            }
            if (message.samePriorityTypeConfiguredBefore && message.samePriorityTypeConfiguredBefore.length) {
                object.samePriorityTypeConfiguredBefore = [];
                for (let j = 0; j < message.samePriorityTypeConfiguredBefore.length; ++j)
                    object.samePriorityTypeConfiguredBefore[j] = message.samePriorityTypeConfiguredBefore[j];
            }
            if (message.localVersionPreAssociation != null && message.hasOwnProperty("localVersionPreAssociation"))
                if (typeof message.localVersionPreAssociation === "number")
                    object.localVersionPreAssociation = options.longs === String ? String(message.localVersionPreAssociation) : message.localVersionPreAssociation;
                else
                    object.localVersionPreAssociation = options.longs === String ? $util.Long.prototype.toString.call(message.localVersionPreAssociation) : options.longs === Number ? new $util.LongBits(message.localVersionPreAssociation.low >>> 0, message.localVersionPreAssociation.high >>> 0).toNumber() : message.localVersionPreAssociation;
            if (message.syncVersionPreAssociation != null && message.hasOwnProperty("syncVersionPreAssociation"))
                if (typeof message.syncVersionPreAssociation === "number")
                    object.syncVersionPreAssociation = options.longs === String ? String(message.syncVersionPreAssociation) : message.syncVersionPreAssociation;
                else
                    object.syncVersionPreAssociation = options.longs === String ? $util.Long.prototype.toString.call(message.syncVersionPreAssociation) : options.longs === Number ? new $util.LongBits(message.syncVersionPreAssociation.low >>> 0, message.syncVersionPreAssociation.high >>> 0).toNumber() : message.syncVersionPreAssociation;
            return object;
        };

        /**
         * Converts this DatatypeAssociationStats to JSON.
         * @function toJSON
         * @memberof sync_pb.DatatypeAssociationStats
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DatatypeAssociationStats.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DatatypeAssociationStats;
    })();

    sync_pb.DebugEventInfo = (function() {

        /**
         * Properties of a DebugEventInfo.
         * @memberof sync_pb
         * @interface IDebugEventInfo
         * @property {sync_pb.SyncEnums.SingletonDebugEventType|null} [singletonEvent] DebugEventInfo singletonEvent
         * @property {sync_pb.ISyncCycleCompletedEventInfo|null} [syncCycleCompletedEventInfo] DebugEventInfo syncCycleCompletedEventInfo
         * @property {number|null} [nudgingDatatype] DebugEventInfo nudgingDatatype
         * @property {Array.<number>|null} [datatypesNotifiedFromServer] DebugEventInfo datatypesNotifiedFromServer
         * @property {sync_pb.IDatatypeAssociationStats|null} [datatypeAssociationStats] DebugEventInfo datatypeAssociationStats
         */

        /**
         * Constructs a new DebugEventInfo.
         * @memberof sync_pb
         * @classdesc Represents a DebugEventInfo.
         * @implements IDebugEventInfo
         * @constructor
         * @param {sync_pb.IDebugEventInfo=} [properties] Properties to set
         */
        function DebugEventInfo(properties) {
            this.datatypesNotifiedFromServer = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DebugEventInfo singletonEvent.
         * @member {sync_pb.SyncEnums.SingletonDebugEventType} singletonEvent
         * @memberof sync_pb.DebugEventInfo
         * @instance
         */
        DebugEventInfo.prototype.singletonEvent = 1;

        /**
         * DebugEventInfo syncCycleCompletedEventInfo.
         * @member {sync_pb.ISyncCycleCompletedEventInfo|null|undefined} syncCycleCompletedEventInfo
         * @memberof sync_pb.DebugEventInfo
         * @instance
         */
        DebugEventInfo.prototype.syncCycleCompletedEventInfo = null;

        /**
         * DebugEventInfo nudgingDatatype.
         * @member {number} nudgingDatatype
         * @memberof sync_pb.DebugEventInfo
         * @instance
         */
        DebugEventInfo.prototype.nudgingDatatype = 0;

        /**
         * DebugEventInfo datatypesNotifiedFromServer.
         * @member {Array.<number>} datatypesNotifiedFromServer
         * @memberof sync_pb.DebugEventInfo
         * @instance
         */
        DebugEventInfo.prototype.datatypesNotifiedFromServer = $util.emptyArray;

        /**
         * DebugEventInfo datatypeAssociationStats.
         * @member {sync_pb.IDatatypeAssociationStats|null|undefined} datatypeAssociationStats
         * @memberof sync_pb.DebugEventInfo
         * @instance
         */
        DebugEventInfo.prototype.datatypeAssociationStats = null;

        /**
         * Creates a new DebugEventInfo instance using the specified properties.
         * @function create
         * @memberof sync_pb.DebugEventInfo
         * @static
         * @param {sync_pb.IDebugEventInfo=} [properties] Properties to set
         * @returns {sync_pb.DebugEventInfo} DebugEventInfo instance
         */
        DebugEventInfo.create = function create(properties) {
            return new DebugEventInfo(properties);
        };

        /**
         * Encodes the specified DebugEventInfo message. Does not implicitly {@link sync_pb.DebugEventInfo.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.DebugEventInfo
         * @static
         * @param {sync_pb.IDebugEventInfo} message DebugEventInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DebugEventInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.singletonEvent != null && Object.hasOwnProperty.call(message, "singletonEvent"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.singletonEvent);
            if (message.syncCycleCompletedEventInfo != null && Object.hasOwnProperty.call(message, "syncCycleCompletedEventInfo"))
                $root.sync_pb.SyncCycleCompletedEventInfo.encode(message.syncCycleCompletedEventInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.nudgingDatatype != null && Object.hasOwnProperty.call(message, "nudgingDatatype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.nudgingDatatype);
            if (message.datatypesNotifiedFromServer != null && message.datatypesNotifiedFromServer.length)
                for (let i = 0; i < message.datatypesNotifiedFromServer.length; ++i)
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.datatypesNotifiedFromServer[i]);
            if (message.datatypeAssociationStats != null && Object.hasOwnProperty.call(message, "datatypeAssociationStats"))
                $root.sync_pb.DatatypeAssociationStats.encode(message.datatypeAssociationStats, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified DebugEventInfo message, length delimited. Does not implicitly {@link sync_pb.DebugEventInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.DebugEventInfo
         * @static
         * @param {sync_pb.IDebugEventInfo} message DebugEventInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DebugEventInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DebugEventInfo message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.DebugEventInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.DebugEventInfo} DebugEventInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DebugEventInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.DebugEventInfo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.singletonEvent = reader.int32();
                    break;
                case 2:
                    message.syncCycleCompletedEventInfo = $root.sync_pb.SyncCycleCompletedEventInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.nudgingDatatype = reader.int32();
                    break;
                case 4:
                    if (!(message.datatypesNotifiedFromServer && message.datatypesNotifiedFromServer.length))
                        message.datatypesNotifiedFromServer = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.datatypesNotifiedFromServer.push(reader.int32());
                    } else
                        message.datatypesNotifiedFromServer.push(reader.int32());
                    break;
                case 5:
                    message.datatypeAssociationStats = $root.sync_pb.DatatypeAssociationStats.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DebugEventInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.DebugEventInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.DebugEventInfo} DebugEventInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DebugEventInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DebugEventInfo message.
         * @function verify
         * @memberof sync_pb.DebugEventInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DebugEventInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.singletonEvent != null && message.hasOwnProperty("singletonEvent"))
                switch (message.singletonEvent) {
                default:
                    return "singletonEvent: enum value expected";
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                    break;
                }
            if (message.syncCycleCompletedEventInfo != null && message.hasOwnProperty("syncCycleCompletedEventInfo")) {
                let error = $root.sync_pb.SyncCycleCompletedEventInfo.verify(message.syncCycleCompletedEventInfo);
                if (error)
                    return "syncCycleCompletedEventInfo." + error;
            }
            if (message.nudgingDatatype != null && message.hasOwnProperty("nudgingDatatype"))
                if (!$util.isInteger(message.nudgingDatatype))
                    return "nudgingDatatype: integer expected";
            if (message.datatypesNotifiedFromServer != null && message.hasOwnProperty("datatypesNotifiedFromServer")) {
                if (!Array.isArray(message.datatypesNotifiedFromServer))
                    return "datatypesNotifiedFromServer: array expected";
                for (let i = 0; i < message.datatypesNotifiedFromServer.length; ++i)
                    if (!$util.isInteger(message.datatypesNotifiedFromServer[i]))
                        return "datatypesNotifiedFromServer: integer[] expected";
            }
            if (message.datatypeAssociationStats != null && message.hasOwnProperty("datatypeAssociationStats")) {
                let error = $root.sync_pb.DatatypeAssociationStats.verify(message.datatypeAssociationStats);
                if (error)
                    return "datatypeAssociationStats." + error;
            }
            return null;
        };

        /**
         * Creates a DebugEventInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.DebugEventInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.DebugEventInfo} DebugEventInfo
         */
        DebugEventInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.DebugEventInfo)
                return object;
            let message = new $root.sync_pb.DebugEventInfo();
            switch (object.singletonEvent) {
            case "CONNECTION_STATUS_CHANGE":
            case 1:
                message.singletonEvent = 1;
                break;
            case "UPDATED_TOKEN":
            case 2:
                message.singletonEvent = 2;
                break;
            case "PASSPHRASE_REQUIRED":
            case 3:
                message.singletonEvent = 3;
                break;
            case "PASSPHRASE_ACCEPTED":
            case 4:
                message.singletonEvent = 4;
                break;
            case "INITIALIZATION_COMPLETE":
            case 5:
                message.singletonEvent = 5;
                break;
            case "STOP_SYNCING_PERMANENTLY":
            case 6:
                message.singletonEvent = 6;
                break;
            case "ENCRYPTION_COMPLETE":
            case 7:
                message.singletonEvent = 7;
                break;
            case "ACTIONABLE_ERROR":
            case 8:
                message.singletonEvent = 8;
                break;
            case "ENCRYPTED_TYPES_CHANGED":
            case 9:
                message.singletonEvent = 9;
                break;
            case "PASSPHRASE_TYPE_CHANGED":
            case 10:
                message.singletonEvent = 10;
                break;
            case "KEYSTORE_TOKEN_UPDATED":
            case 11:
                message.singletonEvent = 11;
                break;
            case "CONFIGURE_COMPLETE":
            case 12:
                message.singletonEvent = 12;
                break;
            case "BOOTSTRAP_TOKEN_UPDATED":
            case 13:
                message.singletonEvent = 13;
                break;
            case "TRUSTED_VAULT_KEY_REQUIRED":
            case 14:
                message.singletonEvent = 14;
                break;
            case "TRUSTED_VAULT_KEY_ACCEPTED":
            case 15:
                message.singletonEvent = 15;
                break;
            }
            if (object.syncCycleCompletedEventInfo != null) {
                if (typeof object.syncCycleCompletedEventInfo !== "object")
                    throw TypeError(".sync_pb.DebugEventInfo.syncCycleCompletedEventInfo: object expected");
                message.syncCycleCompletedEventInfo = $root.sync_pb.SyncCycleCompletedEventInfo.fromObject(object.syncCycleCompletedEventInfo);
            }
            if (object.nudgingDatatype != null)
                message.nudgingDatatype = object.nudgingDatatype | 0;
            if (object.datatypesNotifiedFromServer) {
                if (!Array.isArray(object.datatypesNotifiedFromServer))
                    throw TypeError(".sync_pb.DebugEventInfo.datatypesNotifiedFromServer: array expected");
                message.datatypesNotifiedFromServer = [];
                for (let i = 0; i < object.datatypesNotifiedFromServer.length; ++i)
                    message.datatypesNotifiedFromServer[i] = object.datatypesNotifiedFromServer[i] | 0;
            }
            if (object.datatypeAssociationStats != null) {
                if (typeof object.datatypeAssociationStats !== "object")
                    throw TypeError(".sync_pb.DebugEventInfo.datatypeAssociationStats: object expected");
                message.datatypeAssociationStats = $root.sync_pb.DatatypeAssociationStats.fromObject(object.datatypeAssociationStats);
            }
            return message;
        };

        /**
         * Creates a plain object from a DebugEventInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.DebugEventInfo
         * @static
         * @param {sync_pb.DebugEventInfo} message DebugEventInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DebugEventInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.datatypesNotifiedFromServer = [];
            if (options.defaults) {
                object.singletonEvent = options.enums === String ? "CONNECTION_STATUS_CHANGE" : 1;
                object.syncCycleCompletedEventInfo = null;
                object.nudgingDatatype = 0;
                object.datatypeAssociationStats = null;
            }
            if (message.singletonEvent != null && message.hasOwnProperty("singletonEvent"))
                object.singletonEvent = options.enums === String ? $root.sync_pb.SyncEnums.SingletonDebugEventType[message.singletonEvent] : message.singletonEvent;
            if (message.syncCycleCompletedEventInfo != null && message.hasOwnProperty("syncCycleCompletedEventInfo"))
                object.syncCycleCompletedEventInfo = $root.sync_pb.SyncCycleCompletedEventInfo.toObject(message.syncCycleCompletedEventInfo, options);
            if (message.nudgingDatatype != null && message.hasOwnProperty("nudgingDatatype"))
                object.nudgingDatatype = message.nudgingDatatype;
            if (message.datatypesNotifiedFromServer && message.datatypesNotifiedFromServer.length) {
                object.datatypesNotifiedFromServer = [];
                for (let j = 0; j < message.datatypesNotifiedFromServer.length; ++j)
                    object.datatypesNotifiedFromServer[j] = message.datatypesNotifiedFromServer[j];
            }
            if (message.datatypeAssociationStats != null && message.hasOwnProperty("datatypeAssociationStats"))
                object.datatypeAssociationStats = $root.sync_pb.DatatypeAssociationStats.toObject(message.datatypeAssociationStats, options);
            return object;
        };

        /**
         * Converts this DebugEventInfo to JSON.
         * @function toJSON
         * @memberof sync_pb.DebugEventInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DebugEventInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DebugEventInfo;
    })();

    sync_pb.DebugInfo = (function() {

        /**
         * Properties of a DebugInfo.
         * @memberof sync_pb
         * @interface IDebugInfo
         * @property {Array.<sync_pb.IDebugEventInfo>|null} [events] DebugInfo events
         * @property {boolean|null} [cryptographerReady] DebugInfo cryptographerReady
         * @property {boolean|null} [cryptographerHasPendingKeys] DebugInfo cryptographerHasPendingKeys
         * @property {boolean|null} [eventsDropped] DebugInfo eventsDropped
         */

        /**
         * Constructs a new DebugInfo.
         * @memberof sync_pb
         * @classdesc Represents a DebugInfo.
         * @implements IDebugInfo
         * @constructor
         * @param {sync_pb.IDebugInfo=} [properties] Properties to set
         */
        function DebugInfo(properties) {
            this.events = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DebugInfo events.
         * @member {Array.<sync_pb.IDebugEventInfo>} events
         * @memberof sync_pb.DebugInfo
         * @instance
         */
        DebugInfo.prototype.events = $util.emptyArray;

        /**
         * DebugInfo cryptographerReady.
         * @member {boolean} cryptographerReady
         * @memberof sync_pb.DebugInfo
         * @instance
         */
        DebugInfo.prototype.cryptographerReady = false;

        /**
         * DebugInfo cryptographerHasPendingKeys.
         * @member {boolean} cryptographerHasPendingKeys
         * @memberof sync_pb.DebugInfo
         * @instance
         */
        DebugInfo.prototype.cryptographerHasPendingKeys = false;

        /**
         * DebugInfo eventsDropped.
         * @member {boolean} eventsDropped
         * @memberof sync_pb.DebugInfo
         * @instance
         */
        DebugInfo.prototype.eventsDropped = false;

        /**
         * Creates a new DebugInfo instance using the specified properties.
         * @function create
         * @memberof sync_pb.DebugInfo
         * @static
         * @param {sync_pb.IDebugInfo=} [properties] Properties to set
         * @returns {sync_pb.DebugInfo} DebugInfo instance
         */
        DebugInfo.create = function create(properties) {
            return new DebugInfo(properties);
        };

        /**
         * Encodes the specified DebugInfo message. Does not implicitly {@link sync_pb.DebugInfo.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.DebugInfo
         * @static
         * @param {sync_pb.IDebugInfo} message DebugInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DebugInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.events != null && message.events.length)
                for (let i = 0; i < message.events.length; ++i)
                    $root.sync_pb.DebugEventInfo.encode(message.events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.cryptographerReady != null && Object.hasOwnProperty.call(message, "cryptographerReady"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.cryptographerReady);
            if (message.cryptographerHasPendingKeys != null && Object.hasOwnProperty.call(message, "cryptographerHasPendingKeys"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.cryptographerHasPendingKeys);
            if (message.eventsDropped != null && Object.hasOwnProperty.call(message, "eventsDropped"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.eventsDropped);
            return writer;
        };

        /**
         * Encodes the specified DebugInfo message, length delimited. Does not implicitly {@link sync_pb.DebugInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.DebugInfo
         * @static
         * @param {sync_pb.IDebugInfo} message DebugInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DebugInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DebugInfo message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.DebugInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.DebugInfo} DebugInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DebugInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.DebugInfo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.events && message.events.length))
                        message.events = [];
                    message.events.push($root.sync_pb.DebugEventInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.cryptographerReady = reader.bool();
                    break;
                case 3:
                    message.cryptographerHasPendingKeys = reader.bool();
                    break;
                case 4:
                    message.eventsDropped = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DebugInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.DebugInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.DebugInfo} DebugInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DebugInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DebugInfo message.
         * @function verify
         * @memberof sync_pb.DebugInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DebugInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.events != null && message.hasOwnProperty("events")) {
                if (!Array.isArray(message.events))
                    return "events: array expected";
                for (let i = 0; i < message.events.length; ++i) {
                    let error = $root.sync_pb.DebugEventInfo.verify(message.events[i]);
                    if (error)
                        return "events." + error;
                }
            }
            if (message.cryptographerReady != null && message.hasOwnProperty("cryptographerReady"))
                if (typeof message.cryptographerReady !== "boolean")
                    return "cryptographerReady: boolean expected";
            if (message.cryptographerHasPendingKeys != null && message.hasOwnProperty("cryptographerHasPendingKeys"))
                if (typeof message.cryptographerHasPendingKeys !== "boolean")
                    return "cryptographerHasPendingKeys: boolean expected";
            if (message.eventsDropped != null && message.hasOwnProperty("eventsDropped"))
                if (typeof message.eventsDropped !== "boolean")
                    return "eventsDropped: boolean expected";
            return null;
        };

        /**
         * Creates a DebugInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.DebugInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.DebugInfo} DebugInfo
         */
        DebugInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.DebugInfo)
                return object;
            let message = new $root.sync_pb.DebugInfo();
            if (object.events) {
                if (!Array.isArray(object.events))
                    throw TypeError(".sync_pb.DebugInfo.events: array expected");
                message.events = [];
                for (let i = 0; i < object.events.length; ++i) {
                    if (typeof object.events[i] !== "object")
                        throw TypeError(".sync_pb.DebugInfo.events: object expected");
                    message.events[i] = $root.sync_pb.DebugEventInfo.fromObject(object.events[i]);
                }
            }
            if (object.cryptographerReady != null)
                message.cryptographerReady = Boolean(object.cryptographerReady);
            if (object.cryptographerHasPendingKeys != null)
                message.cryptographerHasPendingKeys = Boolean(object.cryptographerHasPendingKeys);
            if (object.eventsDropped != null)
                message.eventsDropped = Boolean(object.eventsDropped);
            return message;
        };

        /**
         * Creates a plain object from a DebugInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.DebugInfo
         * @static
         * @param {sync_pb.DebugInfo} message DebugInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DebugInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.events = [];
            if (options.defaults) {
                object.cryptographerReady = false;
                object.cryptographerHasPendingKeys = false;
                object.eventsDropped = false;
            }
            if (message.events && message.events.length) {
                object.events = [];
                for (let j = 0; j < message.events.length; ++j)
                    object.events[j] = $root.sync_pb.DebugEventInfo.toObject(message.events[j], options);
            }
            if (message.cryptographerReady != null && message.hasOwnProperty("cryptographerReady"))
                object.cryptographerReady = message.cryptographerReady;
            if (message.cryptographerHasPendingKeys != null && message.hasOwnProperty("cryptographerHasPendingKeys"))
                object.cryptographerHasPendingKeys = message.cryptographerHasPendingKeys;
            if (message.eventsDropped != null && message.hasOwnProperty("eventsDropped"))
                object.eventsDropped = message.eventsDropped;
            return object;
        };

        /**
         * Converts this DebugInfo to JSON.
         * @function toJSON
         * @memberof sync_pb.DebugInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DebugInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DebugInfo;
    })();

    sync_pb.GetUpdatesCallerInfo = (function() {

        /**
         * Properties of a GetUpdatesCallerInfo.
         * @memberof sync_pb
         * @interface IGetUpdatesCallerInfo
         * @property {sync_pb.GetUpdatesCallerInfo.GetUpdatesSource} source GetUpdatesCallerInfo source
         * @property {boolean|null} [notificationsEnabled] GetUpdatesCallerInfo notificationsEnabled
         */

        /**
         * Constructs a new GetUpdatesCallerInfo.
         * @memberof sync_pb
         * @classdesc Represents a GetUpdatesCallerInfo.
         * @implements IGetUpdatesCallerInfo
         * @constructor
         * @param {sync_pb.IGetUpdatesCallerInfo=} [properties] Properties to set
         */
        function GetUpdatesCallerInfo(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUpdatesCallerInfo source.
         * @member {sync_pb.GetUpdatesCallerInfo.GetUpdatesSource} source
         * @memberof sync_pb.GetUpdatesCallerInfo
         * @instance
         */
        GetUpdatesCallerInfo.prototype.source = 0;

        /**
         * GetUpdatesCallerInfo notificationsEnabled.
         * @member {boolean} notificationsEnabled
         * @memberof sync_pb.GetUpdatesCallerInfo
         * @instance
         */
        GetUpdatesCallerInfo.prototype.notificationsEnabled = false;

        /**
         * Creates a new GetUpdatesCallerInfo instance using the specified properties.
         * @function create
         * @memberof sync_pb.GetUpdatesCallerInfo
         * @static
         * @param {sync_pb.IGetUpdatesCallerInfo=} [properties] Properties to set
         * @returns {sync_pb.GetUpdatesCallerInfo} GetUpdatesCallerInfo instance
         */
        GetUpdatesCallerInfo.create = function create(properties) {
            return new GetUpdatesCallerInfo(properties);
        };

        /**
         * Encodes the specified GetUpdatesCallerInfo message. Does not implicitly {@link sync_pb.GetUpdatesCallerInfo.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.GetUpdatesCallerInfo
         * @static
         * @param {sync_pb.IGetUpdatesCallerInfo} message GetUpdatesCallerInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUpdatesCallerInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.source);
            if (message.notificationsEnabled != null && Object.hasOwnProperty.call(message, "notificationsEnabled"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.notificationsEnabled);
            return writer;
        };

        /**
         * Encodes the specified GetUpdatesCallerInfo message, length delimited. Does not implicitly {@link sync_pb.GetUpdatesCallerInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.GetUpdatesCallerInfo
         * @static
         * @param {sync_pb.IGetUpdatesCallerInfo} message GetUpdatesCallerInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUpdatesCallerInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetUpdatesCallerInfo message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.GetUpdatesCallerInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.GetUpdatesCallerInfo} GetUpdatesCallerInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUpdatesCallerInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.GetUpdatesCallerInfo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.source = reader.int32();
                    break;
                case 2:
                    message.notificationsEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("source"))
                throw $util.ProtocolError("missing required 'source'", { instance: message });
            return message;
        };

        /**
         * Decodes a GetUpdatesCallerInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.GetUpdatesCallerInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.GetUpdatesCallerInfo} GetUpdatesCallerInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUpdatesCallerInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetUpdatesCallerInfo message.
         * @function verify
         * @memberof sync_pb.GetUpdatesCallerInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetUpdatesCallerInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            switch (message.source) {
            default:
                return "source: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 13:
            case 14:
                break;
            }
            if (message.notificationsEnabled != null && message.hasOwnProperty("notificationsEnabled"))
                if (typeof message.notificationsEnabled !== "boolean")
                    return "notificationsEnabled: boolean expected";
            return null;
        };

        /**
         * Creates a GetUpdatesCallerInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.GetUpdatesCallerInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.GetUpdatesCallerInfo} GetUpdatesCallerInfo
         */
        GetUpdatesCallerInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.GetUpdatesCallerInfo)
                return object;
            let message = new $root.sync_pb.GetUpdatesCallerInfo();
            switch (object.source) {
            case "UNKNOWN":
            case 0:
                message.source = 0;
                break;
            case "FIRST_UPDATE":
            case 1:
                message.source = 1;
                break;
            case "LOCAL":
            case 2:
                message.source = 2;
                break;
            case "NOTIFICATION":
            case 3:
                message.source = 3;
                break;
            case "PERIODIC":
            case 4:
                message.source = 4;
                break;
            case "SYNC_CYCLE_CONTINUATION":
            case 5:
                message.source = 5;
                break;
            case "NEWLY_SUPPORTED_DATATYPE":
            case 7:
                message.source = 7;
                break;
            case "MIGRATION":
            case 8:
                message.source = 8;
                break;
            case "NEW_CLIENT":
            case 9:
                message.source = 9;
                break;
            case "RECONFIGURATION":
            case 10:
                message.source = 10;
                break;
            case "DATATYPE_REFRESH":
            case 11:
                message.source = 11;
                break;
            case "RETRY":
            case 13:
                message.source = 13;
                break;
            case "PROGRAMMATIC":
            case 14:
                message.source = 14;
                break;
            }
            if (object.notificationsEnabled != null)
                message.notificationsEnabled = Boolean(object.notificationsEnabled);
            return message;
        };

        /**
         * Creates a plain object from a GetUpdatesCallerInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.GetUpdatesCallerInfo
         * @static
         * @param {sync_pb.GetUpdatesCallerInfo} message GetUpdatesCallerInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUpdatesCallerInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.source = options.enums === String ? "UNKNOWN" : 0;
                object.notificationsEnabled = false;
            }
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = options.enums === String ? $root.sync_pb.GetUpdatesCallerInfo.GetUpdatesSource[message.source] : message.source;
            if (message.notificationsEnabled != null && message.hasOwnProperty("notificationsEnabled"))
                object.notificationsEnabled = message.notificationsEnabled;
            return object;
        };

        /**
         * Converts this GetUpdatesCallerInfo to JSON.
         * @function toJSON
         * @memberof sync_pb.GetUpdatesCallerInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUpdatesCallerInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * GetUpdatesSource enum.
         * @name sync_pb.GetUpdatesCallerInfo.GetUpdatesSource
         * @enum {number}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} FIRST_UPDATE=1 FIRST_UPDATE value
         * @property {number} LOCAL=2 LOCAL value
         * @property {number} NOTIFICATION=3 NOTIFICATION value
         * @property {number} PERIODIC=4 PERIODIC value
         * @property {number} SYNC_CYCLE_CONTINUATION=5 SYNC_CYCLE_CONTINUATION value
         * @property {number} NEWLY_SUPPORTED_DATATYPE=7 NEWLY_SUPPORTED_DATATYPE value
         * @property {number} MIGRATION=8 MIGRATION value
         * @property {number} NEW_CLIENT=9 NEW_CLIENT value
         * @property {number} RECONFIGURATION=10 RECONFIGURATION value
         * @property {number} DATATYPE_REFRESH=11 DATATYPE_REFRESH value
         * @property {number} RETRY=13 RETRY value
         * @property {number} PROGRAMMATIC=14 PROGRAMMATIC value
         */
        GetUpdatesCallerInfo.GetUpdatesSource = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "FIRST_UPDATE"] = 1;
            values[valuesById[2] = "LOCAL"] = 2;
            values[valuesById[3] = "NOTIFICATION"] = 3;
            values[valuesById[4] = "PERIODIC"] = 4;
            values[valuesById[5] = "SYNC_CYCLE_CONTINUATION"] = 5;
            values[valuesById[7] = "NEWLY_SUPPORTED_DATATYPE"] = 7;
            values[valuesById[8] = "MIGRATION"] = 8;
            values[valuesById[9] = "NEW_CLIENT"] = 9;
            values[valuesById[10] = "RECONFIGURATION"] = 10;
            values[valuesById[11] = "DATATYPE_REFRESH"] = 11;
            values[valuesById[13] = "RETRY"] = 13;
            values[valuesById[14] = "PROGRAMMATIC"] = 14;
            return values;
        })();

        return GetUpdatesCallerInfo;
    })();

    sync_pb.ManagedUserSharedSettingSpecifics = (function() {

        /**
         * Properties of a ManagedUserSharedSettingSpecifics.
         * @memberof sync_pb
         * @interface IManagedUserSharedSettingSpecifics
         * @property {string|null} [muId] ManagedUserSharedSettingSpecifics muId
         * @property {string|null} [key] ManagedUserSharedSettingSpecifics key
         * @property {string|null} [value] ManagedUserSharedSettingSpecifics value
         * @property {boolean|null} [acknowledged] ManagedUserSharedSettingSpecifics acknowledged
         */

        /**
         * Constructs a new ManagedUserSharedSettingSpecifics.
         * @memberof sync_pb
         * @classdesc Represents a ManagedUserSharedSettingSpecifics.
         * @implements IManagedUserSharedSettingSpecifics
         * @constructor
         * @param {sync_pb.IManagedUserSharedSettingSpecifics=} [properties] Properties to set
         */
        function ManagedUserSharedSettingSpecifics(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ManagedUserSharedSettingSpecifics muId.
         * @member {string} muId
         * @memberof sync_pb.ManagedUserSharedSettingSpecifics
         * @instance
         */
        ManagedUserSharedSettingSpecifics.prototype.muId = "";

        /**
         * ManagedUserSharedSettingSpecifics key.
         * @member {string} key
         * @memberof sync_pb.ManagedUserSharedSettingSpecifics
         * @instance
         */
        ManagedUserSharedSettingSpecifics.prototype.key = "";

        /**
         * ManagedUserSharedSettingSpecifics value.
         * @member {string} value
         * @memberof sync_pb.ManagedUserSharedSettingSpecifics
         * @instance
         */
        ManagedUserSharedSettingSpecifics.prototype.value = "";

        /**
         * ManagedUserSharedSettingSpecifics acknowledged.
         * @member {boolean} acknowledged
         * @memberof sync_pb.ManagedUserSharedSettingSpecifics
         * @instance
         */
        ManagedUserSharedSettingSpecifics.prototype.acknowledged = false;

        /**
         * Creates a new ManagedUserSharedSettingSpecifics instance using the specified properties.
         * @function create
         * @memberof sync_pb.ManagedUserSharedSettingSpecifics
         * @static
         * @param {sync_pb.IManagedUserSharedSettingSpecifics=} [properties] Properties to set
         * @returns {sync_pb.ManagedUserSharedSettingSpecifics} ManagedUserSharedSettingSpecifics instance
         */
        ManagedUserSharedSettingSpecifics.create = function create(properties) {
            return new ManagedUserSharedSettingSpecifics(properties);
        };

        /**
         * Encodes the specified ManagedUserSharedSettingSpecifics message. Does not implicitly {@link sync_pb.ManagedUserSharedSettingSpecifics.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ManagedUserSharedSettingSpecifics
         * @static
         * @param {sync_pb.IManagedUserSharedSettingSpecifics} message ManagedUserSharedSettingSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ManagedUserSharedSettingSpecifics.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.muId != null && Object.hasOwnProperty.call(message, "muId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.muId);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.key);
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.value);
            if (message.acknowledged != null && Object.hasOwnProperty.call(message, "acknowledged"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.acknowledged);
            return writer;
        };

        /**
         * Encodes the specified ManagedUserSharedSettingSpecifics message, length delimited. Does not implicitly {@link sync_pb.ManagedUserSharedSettingSpecifics.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ManagedUserSharedSettingSpecifics
         * @static
         * @param {sync_pb.IManagedUserSharedSettingSpecifics} message ManagedUserSharedSettingSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ManagedUserSharedSettingSpecifics.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ManagedUserSharedSettingSpecifics message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ManagedUserSharedSettingSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ManagedUserSharedSettingSpecifics} ManagedUserSharedSettingSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ManagedUserSharedSettingSpecifics.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ManagedUserSharedSettingSpecifics();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.muId = reader.string();
                    break;
                case 2:
                    message.key = reader.string();
                    break;
                case 3:
                    message.value = reader.string();
                    break;
                case 4:
                    message.acknowledged = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ManagedUserSharedSettingSpecifics message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ManagedUserSharedSettingSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ManagedUserSharedSettingSpecifics} ManagedUserSharedSettingSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ManagedUserSharedSettingSpecifics.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ManagedUserSharedSettingSpecifics message.
         * @function verify
         * @memberof sync_pb.ManagedUserSharedSettingSpecifics
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ManagedUserSharedSettingSpecifics.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.muId != null && message.hasOwnProperty("muId"))
                if (!$util.isString(message.muId))
                    return "muId: string expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!$util.isString(message.value))
                    return "value: string expected";
            if (message.acknowledged != null && message.hasOwnProperty("acknowledged"))
                if (typeof message.acknowledged !== "boolean")
                    return "acknowledged: boolean expected";
            return null;
        };

        /**
         * Creates a ManagedUserSharedSettingSpecifics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ManagedUserSharedSettingSpecifics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ManagedUserSharedSettingSpecifics} ManagedUserSharedSettingSpecifics
         */
        ManagedUserSharedSettingSpecifics.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ManagedUserSharedSettingSpecifics)
                return object;
            let message = new $root.sync_pb.ManagedUserSharedSettingSpecifics();
            if (object.muId != null)
                message.muId = String(object.muId);
            if (object.key != null)
                message.key = String(object.key);
            if (object.value != null)
                message.value = String(object.value);
            if (object.acknowledged != null)
                message.acknowledged = Boolean(object.acknowledged);
            return message;
        };

        /**
         * Creates a plain object from a ManagedUserSharedSettingSpecifics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ManagedUserSharedSettingSpecifics
         * @static
         * @param {sync_pb.ManagedUserSharedSettingSpecifics} message ManagedUserSharedSettingSpecifics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ManagedUserSharedSettingSpecifics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.muId = "";
                object.key = "";
                object.value = "";
                object.acknowledged = false;
            }
            if (message.muId != null && message.hasOwnProperty("muId"))
                object.muId = message.muId;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            if (message.acknowledged != null && message.hasOwnProperty("acknowledged"))
                object.acknowledged = message.acknowledged;
            return object;
        };

        /**
         * Converts this ManagedUserSharedSettingSpecifics to JSON.
         * @function toJSON
         * @memberof sync_pb.ManagedUserSharedSettingSpecifics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ManagedUserSharedSettingSpecifics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ManagedUserSharedSettingSpecifics;
    })();

    sync_pb.ManagedUserSpecifics = (function() {

        /**
         * Properties of a ManagedUserSpecifics.
         * @memberof sync_pb
         * @interface IManagedUserSpecifics
         * @property {string|null} [id] ManagedUserSpecifics id
         * @property {string|null} [name] ManagedUserSpecifics name
         * @property {boolean|null} [acknowledged] ManagedUserSpecifics acknowledged
         * @property {string|null} [masterKey] ManagedUserSpecifics masterKey
         * @property {string|null} [chromeAvatar] ManagedUserSpecifics chromeAvatar
         * @property {string|null} [chromeosAvatar] ManagedUserSpecifics chromeosAvatar
         * @property {string|null} [passwordSignatureKey] ManagedUserSpecifics passwordSignatureKey
         * @property {string|null} [passwordEncryptionKey] ManagedUserSpecifics passwordEncryptionKey
         */

        /**
         * Constructs a new ManagedUserSpecifics.
         * @memberof sync_pb
         * @classdesc Represents a ManagedUserSpecifics.
         * @implements IManagedUserSpecifics
         * @constructor
         * @param {sync_pb.IManagedUserSpecifics=} [properties] Properties to set
         */
        function ManagedUserSpecifics(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ManagedUserSpecifics id.
         * @member {string} id
         * @memberof sync_pb.ManagedUserSpecifics
         * @instance
         */
        ManagedUserSpecifics.prototype.id = "";

        /**
         * ManagedUserSpecifics name.
         * @member {string} name
         * @memberof sync_pb.ManagedUserSpecifics
         * @instance
         */
        ManagedUserSpecifics.prototype.name = "";

        /**
         * ManagedUserSpecifics acknowledged.
         * @member {boolean} acknowledged
         * @memberof sync_pb.ManagedUserSpecifics
         * @instance
         */
        ManagedUserSpecifics.prototype.acknowledged = false;

        /**
         * ManagedUserSpecifics masterKey.
         * @member {string} masterKey
         * @memberof sync_pb.ManagedUserSpecifics
         * @instance
         */
        ManagedUserSpecifics.prototype.masterKey = "";

        /**
         * ManagedUserSpecifics chromeAvatar.
         * @member {string} chromeAvatar
         * @memberof sync_pb.ManagedUserSpecifics
         * @instance
         */
        ManagedUserSpecifics.prototype.chromeAvatar = "";

        /**
         * ManagedUserSpecifics chromeosAvatar.
         * @member {string} chromeosAvatar
         * @memberof sync_pb.ManagedUserSpecifics
         * @instance
         */
        ManagedUserSpecifics.prototype.chromeosAvatar = "";

        /**
         * ManagedUserSpecifics passwordSignatureKey.
         * @member {string} passwordSignatureKey
         * @memberof sync_pb.ManagedUserSpecifics
         * @instance
         */
        ManagedUserSpecifics.prototype.passwordSignatureKey = "";

        /**
         * ManagedUserSpecifics passwordEncryptionKey.
         * @member {string} passwordEncryptionKey
         * @memberof sync_pb.ManagedUserSpecifics
         * @instance
         */
        ManagedUserSpecifics.prototype.passwordEncryptionKey = "";

        /**
         * Creates a new ManagedUserSpecifics instance using the specified properties.
         * @function create
         * @memberof sync_pb.ManagedUserSpecifics
         * @static
         * @param {sync_pb.IManagedUserSpecifics=} [properties] Properties to set
         * @returns {sync_pb.ManagedUserSpecifics} ManagedUserSpecifics instance
         */
        ManagedUserSpecifics.create = function create(properties) {
            return new ManagedUserSpecifics(properties);
        };

        /**
         * Encodes the specified ManagedUserSpecifics message. Does not implicitly {@link sync_pb.ManagedUserSpecifics.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ManagedUserSpecifics
         * @static
         * @param {sync_pb.IManagedUserSpecifics} message ManagedUserSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ManagedUserSpecifics.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.acknowledged != null && Object.hasOwnProperty.call(message, "acknowledged"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.acknowledged);
            if (message.masterKey != null && Object.hasOwnProperty.call(message, "masterKey"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.masterKey);
            if (message.chromeAvatar != null && Object.hasOwnProperty.call(message, "chromeAvatar"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.chromeAvatar);
            if (message.chromeosAvatar != null && Object.hasOwnProperty.call(message, "chromeosAvatar"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.chromeosAvatar);
            if (message.passwordSignatureKey != null && Object.hasOwnProperty.call(message, "passwordSignatureKey"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.passwordSignatureKey);
            if (message.passwordEncryptionKey != null && Object.hasOwnProperty.call(message, "passwordEncryptionKey"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.passwordEncryptionKey);
            return writer;
        };

        /**
         * Encodes the specified ManagedUserSpecifics message, length delimited. Does not implicitly {@link sync_pb.ManagedUserSpecifics.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ManagedUserSpecifics
         * @static
         * @param {sync_pb.IManagedUserSpecifics} message ManagedUserSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ManagedUserSpecifics.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ManagedUserSpecifics message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ManagedUserSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ManagedUserSpecifics} ManagedUserSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ManagedUserSpecifics.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ManagedUserSpecifics();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.acknowledged = reader.bool();
                    break;
                case 4:
                    message.masterKey = reader.string();
                    break;
                case 5:
                    message.chromeAvatar = reader.string();
                    break;
                case 6:
                    message.chromeosAvatar = reader.string();
                    break;
                case 7:
                    message.passwordSignatureKey = reader.string();
                    break;
                case 8:
                    message.passwordEncryptionKey = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ManagedUserSpecifics message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ManagedUserSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ManagedUserSpecifics} ManagedUserSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ManagedUserSpecifics.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ManagedUserSpecifics message.
         * @function verify
         * @memberof sync_pb.ManagedUserSpecifics
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ManagedUserSpecifics.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.acknowledged != null && message.hasOwnProperty("acknowledged"))
                if (typeof message.acknowledged !== "boolean")
                    return "acknowledged: boolean expected";
            if (message.masterKey != null && message.hasOwnProperty("masterKey"))
                if (!$util.isString(message.masterKey))
                    return "masterKey: string expected";
            if (message.chromeAvatar != null && message.hasOwnProperty("chromeAvatar"))
                if (!$util.isString(message.chromeAvatar))
                    return "chromeAvatar: string expected";
            if (message.chromeosAvatar != null && message.hasOwnProperty("chromeosAvatar"))
                if (!$util.isString(message.chromeosAvatar))
                    return "chromeosAvatar: string expected";
            if (message.passwordSignatureKey != null && message.hasOwnProperty("passwordSignatureKey"))
                if (!$util.isString(message.passwordSignatureKey))
                    return "passwordSignatureKey: string expected";
            if (message.passwordEncryptionKey != null && message.hasOwnProperty("passwordEncryptionKey"))
                if (!$util.isString(message.passwordEncryptionKey))
                    return "passwordEncryptionKey: string expected";
            return null;
        };

        /**
         * Creates a ManagedUserSpecifics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ManagedUserSpecifics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ManagedUserSpecifics} ManagedUserSpecifics
         */
        ManagedUserSpecifics.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ManagedUserSpecifics)
                return object;
            let message = new $root.sync_pb.ManagedUserSpecifics();
            if (object.id != null)
                message.id = String(object.id);
            if (object.name != null)
                message.name = String(object.name);
            if (object.acknowledged != null)
                message.acknowledged = Boolean(object.acknowledged);
            if (object.masterKey != null)
                message.masterKey = String(object.masterKey);
            if (object.chromeAvatar != null)
                message.chromeAvatar = String(object.chromeAvatar);
            if (object.chromeosAvatar != null)
                message.chromeosAvatar = String(object.chromeosAvatar);
            if (object.passwordSignatureKey != null)
                message.passwordSignatureKey = String(object.passwordSignatureKey);
            if (object.passwordEncryptionKey != null)
                message.passwordEncryptionKey = String(object.passwordEncryptionKey);
            return message;
        };

        /**
         * Creates a plain object from a ManagedUserSpecifics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ManagedUserSpecifics
         * @static
         * @param {sync_pb.ManagedUserSpecifics} message ManagedUserSpecifics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ManagedUserSpecifics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                object.name = "";
                object.acknowledged = false;
                object.masterKey = "";
                object.chromeAvatar = "";
                object.chromeosAvatar = "";
                object.passwordSignatureKey = "";
                object.passwordEncryptionKey = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.acknowledged != null && message.hasOwnProperty("acknowledged"))
                object.acknowledged = message.acknowledged;
            if (message.masterKey != null && message.hasOwnProperty("masterKey"))
                object.masterKey = message.masterKey;
            if (message.chromeAvatar != null && message.hasOwnProperty("chromeAvatar"))
                object.chromeAvatar = message.chromeAvatar;
            if (message.chromeosAvatar != null && message.hasOwnProperty("chromeosAvatar"))
                object.chromeosAvatar = message.chromeosAvatar;
            if (message.passwordSignatureKey != null && message.hasOwnProperty("passwordSignatureKey"))
                object.passwordSignatureKey = message.passwordSignatureKey;
            if (message.passwordEncryptionKey != null && message.hasOwnProperty("passwordEncryptionKey"))
                object.passwordEncryptionKey = message.passwordEncryptionKey;
            return object;
        };

        /**
         * Converts this ManagedUserSpecifics to JSON.
         * @function toJSON
         * @memberof sync_pb.ManagedUserSpecifics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ManagedUserSpecifics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ManagedUserSpecifics;
    })();

    sync_pb.SyncedNotificationSpecifics = (function() {

        /**
         * Properties of a SyncedNotificationSpecifics.
         * @memberof sync_pb
         * @interface ISyncedNotificationSpecifics
         * @property {sync_pb.ICoalescedSyncedNotification|null} [coalescedNotification] SyncedNotificationSpecifics coalescedNotification
         */

        /**
         * Constructs a new SyncedNotificationSpecifics.
         * @memberof sync_pb
         * @classdesc Represents a SyncedNotificationSpecifics.
         * @implements ISyncedNotificationSpecifics
         * @constructor
         * @param {sync_pb.ISyncedNotificationSpecifics=} [properties] Properties to set
         */
        function SyncedNotificationSpecifics(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncedNotificationSpecifics coalescedNotification.
         * @member {sync_pb.ICoalescedSyncedNotification|null|undefined} coalescedNotification
         * @memberof sync_pb.SyncedNotificationSpecifics
         * @instance
         */
        SyncedNotificationSpecifics.prototype.coalescedNotification = null;

        /**
         * Creates a new SyncedNotificationSpecifics instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncedNotificationSpecifics
         * @static
         * @param {sync_pb.ISyncedNotificationSpecifics=} [properties] Properties to set
         * @returns {sync_pb.SyncedNotificationSpecifics} SyncedNotificationSpecifics instance
         */
        SyncedNotificationSpecifics.create = function create(properties) {
            return new SyncedNotificationSpecifics(properties);
        };

        /**
         * Encodes the specified SyncedNotificationSpecifics message. Does not implicitly {@link sync_pb.SyncedNotificationSpecifics.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncedNotificationSpecifics
         * @static
         * @param {sync_pb.ISyncedNotificationSpecifics} message SyncedNotificationSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationSpecifics.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.coalescedNotification != null && Object.hasOwnProperty.call(message, "coalescedNotification"))
                $root.sync_pb.CoalescedSyncedNotification.encode(message.coalescedNotification, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SyncedNotificationSpecifics message, length delimited. Does not implicitly {@link sync_pb.SyncedNotificationSpecifics.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncedNotificationSpecifics
         * @static
         * @param {sync_pb.ISyncedNotificationSpecifics} message SyncedNotificationSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationSpecifics.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncedNotificationSpecifics message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncedNotificationSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncedNotificationSpecifics} SyncedNotificationSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationSpecifics.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncedNotificationSpecifics();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.coalescedNotification = $root.sync_pb.CoalescedSyncedNotification.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncedNotificationSpecifics message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncedNotificationSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncedNotificationSpecifics} SyncedNotificationSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationSpecifics.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncedNotificationSpecifics message.
         * @function verify
         * @memberof sync_pb.SyncedNotificationSpecifics
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncedNotificationSpecifics.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.coalescedNotification != null && message.hasOwnProperty("coalescedNotification")) {
                let error = $root.sync_pb.CoalescedSyncedNotification.verify(message.coalescedNotification);
                if (error)
                    return "coalescedNotification." + error;
            }
            return null;
        };

        /**
         * Creates a SyncedNotificationSpecifics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncedNotificationSpecifics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncedNotificationSpecifics} SyncedNotificationSpecifics
         */
        SyncedNotificationSpecifics.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncedNotificationSpecifics)
                return object;
            let message = new $root.sync_pb.SyncedNotificationSpecifics();
            if (object.coalescedNotification != null) {
                if (typeof object.coalescedNotification !== "object")
                    throw TypeError(".sync_pb.SyncedNotificationSpecifics.coalescedNotification: object expected");
                message.coalescedNotification = $root.sync_pb.CoalescedSyncedNotification.fromObject(object.coalescedNotification);
            }
            return message;
        };

        /**
         * Creates a plain object from a SyncedNotificationSpecifics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncedNotificationSpecifics
         * @static
         * @param {sync_pb.SyncedNotificationSpecifics} message SyncedNotificationSpecifics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncedNotificationSpecifics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.coalescedNotification = null;
            if (message.coalescedNotification != null && message.hasOwnProperty("coalescedNotification"))
                object.coalescedNotification = $root.sync_pb.CoalescedSyncedNotification.toObject(message.coalescedNotification, options);
            return object;
        };

        /**
         * Converts this SyncedNotificationSpecifics to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncedNotificationSpecifics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncedNotificationSpecifics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncedNotificationSpecifics;
    })();

    sync_pb.SyncedNotificationIdentifier = (function() {

        /**
         * Properties of a SyncedNotificationIdentifier.
         * @memberof sync_pb
         * @interface ISyncedNotificationIdentifier
         * @property {string|null} [appId] SyncedNotificationIdentifier appId
         * @property {string|null} [coalescingKey] SyncedNotificationIdentifier coalescingKey
         */

        /**
         * Constructs a new SyncedNotificationIdentifier.
         * @memberof sync_pb
         * @classdesc Represents a SyncedNotificationIdentifier.
         * @implements ISyncedNotificationIdentifier
         * @constructor
         * @param {sync_pb.ISyncedNotificationIdentifier=} [properties] Properties to set
         */
        function SyncedNotificationIdentifier(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncedNotificationIdentifier appId.
         * @member {string} appId
         * @memberof sync_pb.SyncedNotificationIdentifier
         * @instance
         */
        SyncedNotificationIdentifier.prototype.appId = "";

        /**
         * SyncedNotificationIdentifier coalescingKey.
         * @member {string} coalescingKey
         * @memberof sync_pb.SyncedNotificationIdentifier
         * @instance
         */
        SyncedNotificationIdentifier.prototype.coalescingKey = "";

        /**
         * Creates a new SyncedNotificationIdentifier instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncedNotificationIdentifier
         * @static
         * @param {sync_pb.ISyncedNotificationIdentifier=} [properties] Properties to set
         * @returns {sync_pb.SyncedNotificationIdentifier} SyncedNotificationIdentifier instance
         */
        SyncedNotificationIdentifier.create = function create(properties) {
            return new SyncedNotificationIdentifier(properties);
        };

        /**
         * Encodes the specified SyncedNotificationIdentifier message. Does not implicitly {@link sync_pb.SyncedNotificationIdentifier.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncedNotificationIdentifier
         * @static
         * @param {sync_pb.ISyncedNotificationIdentifier} message SyncedNotificationIdentifier message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationIdentifier.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.appId != null && Object.hasOwnProperty.call(message, "appId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.appId);
            if (message.coalescingKey != null && Object.hasOwnProperty.call(message, "coalescingKey"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.coalescingKey);
            return writer;
        };

        /**
         * Encodes the specified SyncedNotificationIdentifier message, length delimited. Does not implicitly {@link sync_pb.SyncedNotificationIdentifier.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncedNotificationIdentifier
         * @static
         * @param {sync_pb.ISyncedNotificationIdentifier} message SyncedNotificationIdentifier message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationIdentifier.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncedNotificationIdentifier message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncedNotificationIdentifier
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncedNotificationIdentifier} SyncedNotificationIdentifier
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationIdentifier.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncedNotificationIdentifier();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.appId = reader.string();
                    break;
                case 2:
                    message.coalescingKey = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncedNotificationIdentifier message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncedNotificationIdentifier
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncedNotificationIdentifier} SyncedNotificationIdentifier
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationIdentifier.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncedNotificationIdentifier message.
         * @function verify
         * @memberof sync_pb.SyncedNotificationIdentifier
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncedNotificationIdentifier.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.appId != null && message.hasOwnProperty("appId"))
                if (!$util.isString(message.appId))
                    return "appId: string expected";
            if (message.coalescingKey != null && message.hasOwnProperty("coalescingKey"))
                if (!$util.isString(message.coalescingKey))
                    return "coalescingKey: string expected";
            return null;
        };

        /**
         * Creates a SyncedNotificationIdentifier message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncedNotificationIdentifier
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncedNotificationIdentifier} SyncedNotificationIdentifier
         */
        SyncedNotificationIdentifier.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncedNotificationIdentifier)
                return object;
            let message = new $root.sync_pb.SyncedNotificationIdentifier();
            if (object.appId != null)
                message.appId = String(object.appId);
            if (object.coalescingKey != null)
                message.coalescingKey = String(object.coalescingKey);
            return message;
        };

        /**
         * Creates a plain object from a SyncedNotificationIdentifier message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncedNotificationIdentifier
         * @static
         * @param {sync_pb.SyncedNotificationIdentifier} message SyncedNotificationIdentifier
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncedNotificationIdentifier.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.appId = "";
                object.coalescingKey = "";
            }
            if (message.appId != null && message.hasOwnProperty("appId"))
                object.appId = message.appId;
            if (message.coalescingKey != null && message.hasOwnProperty("coalescingKey"))
                object.coalescingKey = message.coalescingKey;
            return object;
        };

        /**
         * Converts this SyncedNotificationIdentifier to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncedNotificationIdentifier
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncedNotificationIdentifier.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncedNotificationIdentifier;
    })();

    sync_pb.SyncedNotificationCreator = (function() {

        /**
         * Properties of a SyncedNotificationCreator.
         * @memberof sync_pb
         * @interface ISyncedNotificationCreator
         * @property {number|Long|null} [gaiaId] SyncedNotificationCreator gaiaId
         * @property {boolean|null} [isSystem] SyncedNotificationCreator isSystem
         * @property {string|null} [appId] SyncedNotificationCreator appId
         */

        /**
         * Constructs a new SyncedNotificationCreator.
         * @memberof sync_pb
         * @classdesc Represents a SyncedNotificationCreator.
         * @implements ISyncedNotificationCreator
         * @constructor
         * @param {sync_pb.ISyncedNotificationCreator=} [properties] Properties to set
         */
        function SyncedNotificationCreator(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncedNotificationCreator gaiaId.
         * @member {number|Long} gaiaId
         * @memberof sync_pb.SyncedNotificationCreator
         * @instance
         */
        SyncedNotificationCreator.prototype.gaiaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SyncedNotificationCreator isSystem.
         * @member {boolean} isSystem
         * @memberof sync_pb.SyncedNotificationCreator
         * @instance
         */
        SyncedNotificationCreator.prototype.isSystem = false;

        /**
         * SyncedNotificationCreator appId.
         * @member {string} appId
         * @memberof sync_pb.SyncedNotificationCreator
         * @instance
         */
        SyncedNotificationCreator.prototype.appId = "";

        /**
         * Creates a new SyncedNotificationCreator instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncedNotificationCreator
         * @static
         * @param {sync_pb.ISyncedNotificationCreator=} [properties] Properties to set
         * @returns {sync_pb.SyncedNotificationCreator} SyncedNotificationCreator instance
         */
        SyncedNotificationCreator.create = function create(properties) {
            return new SyncedNotificationCreator(properties);
        };

        /**
         * Encodes the specified SyncedNotificationCreator message. Does not implicitly {@link sync_pb.SyncedNotificationCreator.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncedNotificationCreator
         * @static
         * @param {sync_pb.ISyncedNotificationCreator} message SyncedNotificationCreator message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationCreator.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.gaiaId != null && Object.hasOwnProperty.call(message, "gaiaId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.gaiaId);
            if (message.isSystem != null && Object.hasOwnProperty.call(message, "isSystem"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isSystem);
            if (message.appId != null && Object.hasOwnProperty.call(message, "appId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.appId);
            return writer;
        };

        /**
         * Encodes the specified SyncedNotificationCreator message, length delimited. Does not implicitly {@link sync_pb.SyncedNotificationCreator.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncedNotificationCreator
         * @static
         * @param {sync_pb.ISyncedNotificationCreator} message SyncedNotificationCreator message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationCreator.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncedNotificationCreator message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncedNotificationCreator
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncedNotificationCreator} SyncedNotificationCreator
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationCreator.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncedNotificationCreator();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.gaiaId = reader.int64();
                    break;
                case 2:
                    message.isSystem = reader.bool();
                    break;
                case 3:
                    message.appId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncedNotificationCreator message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncedNotificationCreator
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncedNotificationCreator} SyncedNotificationCreator
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationCreator.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncedNotificationCreator message.
         * @function verify
         * @memberof sync_pb.SyncedNotificationCreator
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncedNotificationCreator.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.gaiaId != null && message.hasOwnProperty("gaiaId"))
                if (!$util.isInteger(message.gaiaId) && !(message.gaiaId && $util.isInteger(message.gaiaId.low) && $util.isInteger(message.gaiaId.high)))
                    return "gaiaId: integer|Long expected";
            if (message.isSystem != null && message.hasOwnProperty("isSystem"))
                if (typeof message.isSystem !== "boolean")
                    return "isSystem: boolean expected";
            if (message.appId != null && message.hasOwnProperty("appId"))
                if (!$util.isString(message.appId))
                    return "appId: string expected";
            return null;
        };

        /**
         * Creates a SyncedNotificationCreator message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncedNotificationCreator
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncedNotificationCreator} SyncedNotificationCreator
         */
        SyncedNotificationCreator.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncedNotificationCreator)
                return object;
            let message = new $root.sync_pb.SyncedNotificationCreator();
            if (object.gaiaId != null)
                if ($util.Long)
                    (message.gaiaId = $util.Long.fromValue(object.gaiaId)).unsigned = false;
                else if (typeof object.gaiaId === "string")
                    message.gaiaId = parseInt(object.gaiaId, 10);
                else if (typeof object.gaiaId === "number")
                    message.gaiaId = object.gaiaId;
                else if (typeof object.gaiaId === "object")
                    message.gaiaId = new $util.LongBits(object.gaiaId.low >>> 0, object.gaiaId.high >>> 0).toNumber();
            if (object.isSystem != null)
                message.isSystem = Boolean(object.isSystem);
            if (object.appId != null)
                message.appId = String(object.appId);
            return message;
        };

        /**
         * Creates a plain object from a SyncedNotificationCreator message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncedNotificationCreator
         * @static
         * @param {sync_pb.SyncedNotificationCreator} message SyncedNotificationCreator
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncedNotificationCreator.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.gaiaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gaiaId = options.longs === String ? "0" : 0;
                object.isSystem = false;
                object.appId = "";
            }
            if (message.gaiaId != null && message.hasOwnProperty("gaiaId"))
                if (typeof message.gaiaId === "number")
                    object.gaiaId = options.longs === String ? String(message.gaiaId) : message.gaiaId;
                else
                    object.gaiaId = options.longs === String ? $util.Long.prototype.toString.call(message.gaiaId) : options.longs === Number ? new $util.LongBits(message.gaiaId.low >>> 0, message.gaiaId.high >>> 0).toNumber() : message.gaiaId;
            if (message.isSystem != null && message.hasOwnProperty("isSystem"))
                object.isSystem = message.isSystem;
            if (message.appId != null && message.hasOwnProperty("appId"))
                object.appId = message.appId;
            return object;
        };

        /**
         * Converts this SyncedNotificationCreator to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncedNotificationCreator
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncedNotificationCreator.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncedNotificationCreator;
    })();

    sync_pb.SyncedNotificationRecipients = (function() {

        /**
         * Properties of a SyncedNotificationRecipients.
         * @memberof sync_pb
         * @interface ISyncedNotificationRecipients
         * @property {Array.<number|Long>|null} [gaiaId] SyncedNotificationRecipients gaiaId
         */

        /**
         * Constructs a new SyncedNotificationRecipients.
         * @memberof sync_pb
         * @classdesc Represents a SyncedNotificationRecipients.
         * @implements ISyncedNotificationRecipients
         * @constructor
         * @param {sync_pb.ISyncedNotificationRecipients=} [properties] Properties to set
         */
        function SyncedNotificationRecipients(properties) {
            this.gaiaId = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncedNotificationRecipients gaiaId.
         * @member {Array.<number|Long>} gaiaId
         * @memberof sync_pb.SyncedNotificationRecipients
         * @instance
         */
        SyncedNotificationRecipients.prototype.gaiaId = $util.emptyArray;

        /**
         * Creates a new SyncedNotificationRecipients instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncedNotificationRecipients
         * @static
         * @param {sync_pb.ISyncedNotificationRecipients=} [properties] Properties to set
         * @returns {sync_pb.SyncedNotificationRecipients} SyncedNotificationRecipients instance
         */
        SyncedNotificationRecipients.create = function create(properties) {
            return new SyncedNotificationRecipients(properties);
        };

        /**
         * Encodes the specified SyncedNotificationRecipients message. Does not implicitly {@link sync_pb.SyncedNotificationRecipients.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncedNotificationRecipients
         * @static
         * @param {sync_pb.ISyncedNotificationRecipients} message SyncedNotificationRecipients message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationRecipients.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.gaiaId != null && message.gaiaId.length)
                for (let i = 0; i < message.gaiaId.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.gaiaId[i]);
            return writer;
        };

        /**
         * Encodes the specified SyncedNotificationRecipients message, length delimited. Does not implicitly {@link sync_pb.SyncedNotificationRecipients.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncedNotificationRecipients
         * @static
         * @param {sync_pb.ISyncedNotificationRecipients} message SyncedNotificationRecipients message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationRecipients.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncedNotificationRecipients message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncedNotificationRecipients
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncedNotificationRecipients} SyncedNotificationRecipients
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationRecipients.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncedNotificationRecipients();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.gaiaId && message.gaiaId.length))
                        message.gaiaId = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.gaiaId.push(reader.int64());
                    } else
                        message.gaiaId.push(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncedNotificationRecipients message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncedNotificationRecipients
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncedNotificationRecipients} SyncedNotificationRecipients
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationRecipients.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncedNotificationRecipients message.
         * @function verify
         * @memberof sync_pb.SyncedNotificationRecipients
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncedNotificationRecipients.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.gaiaId != null && message.hasOwnProperty("gaiaId")) {
                if (!Array.isArray(message.gaiaId))
                    return "gaiaId: array expected";
                for (let i = 0; i < message.gaiaId.length; ++i)
                    if (!$util.isInteger(message.gaiaId[i]) && !(message.gaiaId[i] && $util.isInteger(message.gaiaId[i].low) && $util.isInteger(message.gaiaId[i].high)))
                        return "gaiaId: integer|Long[] expected";
            }
            return null;
        };

        /**
         * Creates a SyncedNotificationRecipients message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncedNotificationRecipients
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncedNotificationRecipients} SyncedNotificationRecipients
         */
        SyncedNotificationRecipients.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncedNotificationRecipients)
                return object;
            let message = new $root.sync_pb.SyncedNotificationRecipients();
            if (object.gaiaId) {
                if (!Array.isArray(object.gaiaId))
                    throw TypeError(".sync_pb.SyncedNotificationRecipients.gaiaId: array expected");
                message.gaiaId = [];
                for (let i = 0; i < object.gaiaId.length; ++i)
                    if ($util.Long)
                        (message.gaiaId[i] = $util.Long.fromValue(object.gaiaId[i])).unsigned = false;
                    else if (typeof object.gaiaId[i] === "string")
                        message.gaiaId[i] = parseInt(object.gaiaId[i], 10);
                    else if (typeof object.gaiaId[i] === "number")
                        message.gaiaId[i] = object.gaiaId[i];
                    else if (typeof object.gaiaId[i] === "object")
                        message.gaiaId[i] = new $util.LongBits(object.gaiaId[i].low >>> 0, object.gaiaId[i].high >>> 0).toNumber();
            }
            return message;
        };

        /**
         * Creates a plain object from a SyncedNotificationRecipients message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncedNotificationRecipients
         * @static
         * @param {sync_pb.SyncedNotificationRecipients} message SyncedNotificationRecipients
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncedNotificationRecipients.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.gaiaId = [];
            if (message.gaiaId && message.gaiaId.length) {
                object.gaiaId = [];
                for (let j = 0; j < message.gaiaId.length; ++j)
                    if (typeof message.gaiaId[j] === "number")
                        object.gaiaId[j] = options.longs === String ? String(message.gaiaId[j]) : message.gaiaId[j];
                    else
                        object.gaiaId[j] = options.longs === String ? $util.Long.prototype.toString.call(message.gaiaId[j]) : options.longs === Number ? new $util.LongBits(message.gaiaId[j].low >>> 0, message.gaiaId[j].high >>> 0).toNumber() : message.gaiaId[j];
            }
            return object;
        };

        /**
         * Converts this SyncedNotificationRecipients to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncedNotificationRecipients
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncedNotificationRecipients.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncedNotificationRecipients;
    })();

    sync_pb.SyncedNotification = (function() {

        /**
         * Properties of a SyncedNotification.
         * @memberof sync_pb
         * @interface ISyncedNotification
         * @property {string|null} [type] SyncedNotification type
         * @property {string|null} [externalId] SyncedNotification externalId
         * @property {sync_pb.ISyncedNotificationCreator|null} [creator] SyncedNotification creator
         * @property {sync_pb.IMapData|null} [clientData] SyncedNotification clientData
         */

        /**
         * Constructs a new SyncedNotification.
         * @memberof sync_pb
         * @classdesc Represents a SyncedNotification.
         * @implements ISyncedNotification
         * @constructor
         * @param {sync_pb.ISyncedNotification=} [properties] Properties to set
         */
        function SyncedNotification(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncedNotification type.
         * @member {string} type
         * @memberof sync_pb.SyncedNotification
         * @instance
         */
        SyncedNotification.prototype.type = "";

        /**
         * SyncedNotification externalId.
         * @member {string} externalId
         * @memberof sync_pb.SyncedNotification
         * @instance
         */
        SyncedNotification.prototype.externalId = "";

        /**
         * SyncedNotification creator.
         * @member {sync_pb.ISyncedNotificationCreator|null|undefined} creator
         * @memberof sync_pb.SyncedNotification
         * @instance
         */
        SyncedNotification.prototype.creator = null;

        /**
         * SyncedNotification clientData.
         * @member {sync_pb.IMapData|null|undefined} clientData
         * @memberof sync_pb.SyncedNotification
         * @instance
         */
        SyncedNotification.prototype.clientData = null;

        /**
         * Creates a new SyncedNotification instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncedNotification
         * @static
         * @param {sync_pb.ISyncedNotification=} [properties] Properties to set
         * @returns {sync_pb.SyncedNotification} SyncedNotification instance
         */
        SyncedNotification.create = function create(properties) {
            return new SyncedNotification(properties);
        };

        /**
         * Encodes the specified SyncedNotification message. Does not implicitly {@link sync_pb.SyncedNotification.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncedNotification
         * @static
         * @param {sync_pb.ISyncedNotification} message SyncedNotification message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotification.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
            if (message.externalId != null && Object.hasOwnProperty.call(message, "externalId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.externalId);
            if (message.creator != null && Object.hasOwnProperty.call(message, "creator"))
                $root.sync_pb.SyncedNotificationCreator.encode(message.creator, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.clientData != null && Object.hasOwnProperty.call(message, "clientData"))
                $root.sync_pb.MapData.encode(message.clientData, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SyncedNotification message, length delimited. Does not implicitly {@link sync_pb.SyncedNotification.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncedNotification
         * @static
         * @param {sync_pb.ISyncedNotification} message SyncedNotification message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotification.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncedNotification message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncedNotification
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncedNotification} SyncedNotification
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotification.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncedNotification();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.externalId = reader.string();
                    break;
                case 3:
                    message.creator = $root.sync_pb.SyncedNotificationCreator.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.clientData = $root.sync_pb.MapData.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncedNotification message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncedNotification
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncedNotification} SyncedNotification
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotification.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncedNotification message.
         * @function verify
         * @memberof sync_pb.SyncedNotification
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncedNotification.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.externalId != null && message.hasOwnProperty("externalId"))
                if (!$util.isString(message.externalId))
                    return "externalId: string expected";
            if (message.creator != null && message.hasOwnProperty("creator")) {
                let error = $root.sync_pb.SyncedNotificationCreator.verify(message.creator);
                if (error)
                    return "creator." + error;
            }
            if (message.clientData != null && message.hasOwnProperty("clientData")) {
                let error = $root.sync_pb.MapData.verify(message.clientData);
                if (error)
                    return "clientData." + error;
            }
            return null;
        };

        /**
         * Creates a SyncedNotification message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncedNotification
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncedNotification} SyncedNotification
         */
        SyncedNotification.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncedNotification)
                return object;
            let message = new $root.sync_pb.SyncedNotification();
            if (object.type != null)
                message.type = String(object.type);
            if (object.externalId != null)
                message.externalId = String(object.externalId);
            if (object.creator != null) {
                if (typeof object.creator !== "object")
                    throw TypeError(".sync_pb.SyncedNotification.creator: object expected");
                message.creator = $root.sync_pb.SyncedNotificationCreator.fromObject(object.creator);
            }
            if (object.clientData != null) {
                if (typeof object.clientData !== "object")
                    throw TypeError(".sync_pb.SyncedNotification.clientData: object expected");
                message.clientData = $root.sync_pb.MapData.fromObject(object.clientData);
            }
            return message;
        };

        /**
         * Creates a plain object from a SyncedNotification message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncedNotification
         * @static
         * @param {sync_pb.SyncedNotification} message SyncedNotification
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncedNotification.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.type = "";
                object.externalId = "";
                object.creator = null;
                object.clientData = null;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.externalId != null && message.hasOwnProperty("externalId"))
                object.externalId = message.externalId;
            if (message.creator != null && message.hasOwnProperty("creator"))
                object.creator = $root.sync_pb.SyncedNotificationCreator.toObject(message.creator, options);
            if (message.clientData != null && message.hasOwnProperty("clientData"))
                object.clientData = $root.sync_pb.MapData.toObject(message.clientData, options);
            return object;
        };

        /**
         * Converts this SyncedNotification to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncedNotification
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncedNotification.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncedNotification;
    })();

    sync_pb.CoalescedSyncedNotification = (function() {

        /**
         * Properties of a CoalescedSyncedNotification.
         * @memberof sync_pb
         * @interface ICoalescedSyncedNotification
         * @property {string|null} [key] CoalescedSyncedNotification key
         * @property {string|null} [appId] CoalescedSyncedNotification appId
         * @property {Array.<sync_pb.ISyncedNotification>|null} [notification] CoalescedSyncedNotification notification
         * @property {sync_pb.ISyncedNotificationRenderInfo|null} [renderInfo] CoalescedSyncedNotification renderInfo
         * @property {sync_pb.CoalescedSyncedNotification.ReadState|null} [readState] CoalescedSyncedNotification readState
         * @property {number|Long|null} [creationTimeMsec] CoalescedSyncedNotification creationTimeMsec
         * @property {sync_pb.CoalescedSyncedNotification.Priority|null} [priority] CoalescedSyncedNotification priority
         * @property {string|null} [userActionToken] CoalescedSyncedNotification userActionToken
         * @property {number|Long|null} [lastModifiedVersion] CoalescedSyncedNotification lastModifiedVersion
         * @property {number|Long|null} [sortVersion] CoalescedSyncedNotification sortVersion
         */

        /**
         * Constructs a new CoalescedSyncedNotification.
         * @memberof sync_pb
         * @classdesc Represents a CoalescedSyncedNotification.
         * @implements ICoalescedSyncedNotification
         * @constructor
         * @param {sync_pb.ICoalescedSyncedNotification=} [properties] Properties to set
         */
        function CoalescedSyncedNotification(properties) {
            this.notification = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CoalescedSyncedNotification key.
         * @member {string} key
         * @memberof sync_pb.CoalescedSyncedNotification
         * @instance
         */
        CoalescedSyncedNotification.prototype.key = "";

        /**
         * CoalescedSyncedNotification appId.
         * @member {string} appId
         * @memberof sync_pb.CoalescedSyncedNotification
         * @instance
         */
        CoalescedSyncedNotification.prototype.appId = "";

        /**
         * CoalescedSyncedNotification notification.
         * @member {Array.<sync_pb.ISyncedNotification>} notification
         * @memberof sync_pb.CoalescedSyncedNotification
         * @instance
         */
        CoalescedSyncedNotification.prototype.notification = $util.emptyArray;

        /**
         * CoalescedSyncedNotification renderInfo.
         * @member {sync_pb.ISyncedNotificationRenderInfo|null|undefined} renderInfo
         * @memberof sync_pb.CoalescedSyncedNotification
         * @instance
         */
        CoalescedSyncedNotification.prototype.renderInfo = null;

        /**
         * CoalescedSyncedNotification readState.
         * @member {sync_pb.CoalescedSyncedNotification.ReadState} readState
         * @memberof sync_pb.CoalescedSyncedNotification
         * @instance
         */
        CoalescedSyncedNotification.prototype.readState = 1;

        /**
         * CoalescedSyncedNotification creationTimeMsec.
         * @member {number|Long} creationTimeMsec
         * @memberof sync_pb.CoalescedSyncedNotification
         * @instance
         */
        CoalescedSyncedNotification.prototype.creationTimeMsec = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CoalescedSyncedNotification priority.
         * @member {sync_pb.CoalescedSyncedNotification.Priority} priority
         * @memberof sync_pb.CoalescedSyncedNotification
         * @instance
         */
        CoalescedSyncedNotification.prototype.priority = 1;

        /**
         * CoalescedSyncedNotification userActionToken.
         * @member {string} userActionToken
         * @memberof sync_pb.CoalescedSyncedNotification
         * @instance
         */
        CoalescedSyncedNotification.prototype.userActionToken = "";

        /**
         * CoalescedSyncedNotification lastModifiedVersion.
         * @member {number|Long} lastModifiedVersion
         * @memberof sync_pb.CoalescedSyncedNotification
         * @instance
         */
        CoalescedSyncedNotification.prototype.lastModifiedVersion = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CoalescedSyncedNotification sortVersion.
         * @member {number|Long} sortVersion
         * @memberof sync_pb.CoalescedSyncedNotification
         * @instance
         */
        CoalescedSyncedNotification.prototype.sortVersion = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new CoalescedSyncedNotification instance using the specified properties.
         * @function create
         * @memberof sync_pb.CoalescedSyncedNotification
         * @static
         * @param {sync_pb.ICoalescedSyncedNotification=} [properties] Properties to set
         * @returns {sync_pb.CoalescedSyncedNotification} CoalescedSyncedNotification instance
         */
        CoalescedSyncedNotification.create = function create(properties) {
            return new CoalescedSyncedNotification(properties);
        };

        /**
         * Encodes the specified CoalescedSyncedNotification message. Does not implicitly {@link sync_pb.CoalescedSyncedNotification.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.CoalescedSyncedNotification
         * @static
         * @param {sync_pb.ICoalescedSyncedNotification} message CoalescedSyncedNotification message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoalescedSyncedNotification.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
            if (message.appId != null && Object.hasOwnProperty.call(message, "appId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.appId);
            if (message.notification != null && message.notification.length)
                for (let i = 0; i < message.notification.length; ++i)
                    $root.sync_pb.SyncedNotification.encode(message.notification[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.renderInfo != null && Object.hasOwnProperty.call(message, "renderInfo"))
                $root.sync_pb.SyncedNotificationRenderInfo.encode(message.renderInfo, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.readState != null && Object.hasOwnProperty.call(message, "readState"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.readState);
            if (message.creationTimeMsec != null && Object.hasOwnProperty.call(message, "creationTimeMsec"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.creationTimeMsec);
            if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.priority);
            if (message.userActionToken != null && Object.hasOwnProperty.call(message, "userActionToken"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.userActionToken);
            if (message.lastModifiedVersion != null && Object.hasOwnProperty.call(message, "lastModifiedVersion"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint64(message.lastModifiedVersion);
            if (message.sortVersion != null && Object.hasOwnProperty.call(message, "sortVersion"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint64(message.sortVersion);
            return writer;
        };

        /**
         * Encodes the specified CoalescedSyncedNotification message, length delimited. Does not implicitly {@link sync_pb.CoalescedSyncedNotification.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.CoalescedSyncedNotification
         * @static
         * @param {sync_pb.ICoalescedSyncedNotification} message CoalescedSyncedNotification message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoalescedSyncedNotification.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CoalescedSyncedNotification message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.CoalescedSyncedNotification
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.CoalescedSyncedNotification} CoalescedSyncedNotification
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoalescedSyncedNotification.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.CoalescedSyncedNotification();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.appId = reader.string();
                    break;
                case 3:
                    if (!(message.notification && message.notification.length))
                        message.notification = [];
                    message.notification.push($root.sync_pb.SyncedNotification.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.renderInfo = $root.sync_pb.SyncedNotificationRenderInfo.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.readState = reader.int32();
                    break;
                case 6:
                    message.creationTimeMsec = reader.uint64();
                    break;
                case 7:
                    message.priority = reader.int32();
                    break;
                case 8:
                    message.userActionToken = reader.string();
                    break;
                case 9:
                    message.lastModifiedVersion = reader.uint64();
                    break;
                case 10:
                    message.sortVersion = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CoalescedSyncedNotification message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.CoalescedSyncedNotification
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.CoalescedSyncedNotification} CoalescedSyncedNotification
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoalescedSyncedNotification.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CoalescedSyncedNotification message.
         * @function verify
         * @memberof sync_pb.CoalescedSyncedNotification
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CoalescedSyncedNotification.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            if (message.appId != null && message.hasOwnProperty("appId"))
                if (!$util.isString(message.appId))
                    return "appId: string expected";
            if (message.notification != null && message.hasOwnProperty("notification")) {
                if (!Array.isArray(message.notification))
                    return "notification: array expected";
                for (let i = 0; i < message.notification.length; ++i) {
                    let error = $root.sync_pb.SyncedNotification.verify(message.notification[i]);
                    if (error)
                        return "notification." + error;
                }
            }
            if (message.renderInfo != null && message.hasOwnProperty("renderInfo")) {
                let error = $root.sync_pb.SyncedNotificationRenderInfo.verify(message.renderInfo);
                if (error)
                    return "renderInfo." + error;
            }
            if (message.readState != null && message.hasOwnProperty("readState"))
                switch (message.readState) {
                default:
                    return "readState: enum value expected";
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.creationTimeMsec != null && message.hasOwnProperty("creationTimeMsec"))
                if (!$util.isInteger(message.creationTimeMsec) && !(message.creationTimeMsec && $util.isInteger(message.creationTimeMsec.low) && $util.isInteger(message.creationTimeMsec.high)))
                    return "creationTimeMsec: integer|Long expected";
            if (message.priority != null && message.hasOwnProperty("priority"))
                switch (message.priority) {
                default:
                    return "priority: enum value expected";
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.userActionToken != null && message.hasOwnProperty("userActionToken"))
                if (!$util.isString(message.userActionToken))
                    return "userActionToken: string expected";
            if (message.lastModifiedVersion != null && message.hasOwnProperty("lastModifiedVersion"))
                if (!$util.isInteger(message.lastModifiedVersion) && !(message.lastModifiedVersion && $util.isInteger(message.lastModifiedVersion.low) && $util.isInteger(message.lastModifiedVersion.high)))
                    return "lastModifiedVersion: integer|Long expected";
            if (message.sortVersion != null && message.hasOwnProperty("sortVersion"))
                if (!$util.isInteger(message.sortVersion) && !(message.sortVersion && $util.isInteger(message.sortVersion.low) && $util.isInteger(message.sortVersion.high)))
                    return "sortVersion: integer|Long expected";
            return null;
        };

        /**
         * Creates a CoalescedSyncedNotification message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.CoalescedSyncedNotification
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.CoalescedSyncedNotification} CoalescedSyncedNotification
         */
        CoalescedSyncedNotification.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.CoalescedSyncedNotification)
                return object;
            let message = new $root.sync_pb.CoalescedSyncedNotification();
            if (object.key != null)
                message.key = String(object.key);
            if (object.appId != null)
                message.appId = String(object.appId);
            if (object.notification) {
                if (!Array.isArray(object.notification))
                    throw TypeError(".sync_pb.CoalescedSyncedNotification.notification: array expected");
                message.notification = [];
                for (let i = 0; i < object.notification.length; ++i) {
                    if (typeof object.notification[i] !== "object")
                        throw TypeError(".sync_pb.CoalescedSyncedNotification.notification: object expected");
                    message.notification[i] = $root.sync_pb.SyncedNotification.fromObject(object.notification[i]);
                }
            }
            if (object.renderInfo != null) {
                if (typeof object.renderInfo !== "object")
                    throw TypeError(".sync_pb.CoalescedSyncedNotification.renderInfo: object expected");
                message.renderInfo = $root.sync_pb.SyncedNotificationRenderInfo.fromObject(object.renderInfo);
            }
            switch (object.readState) {
            case "UNREAD":
            case 1:
                message.readState = 1;
                break;
            case "READ":
            case 2:
                message.readState = 2;
                break;
            case "DISMISSED":
            case 3:
                message.readState = 3;
                break;
            case "SEEN":
            case 4:
                message.readState = 4;
                break;
            }
            if (object.creationTimeMsec != null)
                if ($util.Long)
                    (message.creationTimeMsec = $util.Long.fromValue(object.creationTimeMsec)).unsigned = true;
                else if (typeof object.creationTimeMsec === "string")
                    message.creationTimeMsec = parseInt(object.creationTimeMsec, 10);
                else if (typeof object.creationTimeMsec === "number")
                    message.creationTimeMsec = object.creationTimeMsec;
                else if (typeof object.creationTimeMsec === "object")
                    message.creationTimeMsec = new $util.LongBits(object.creationTimeMsec.low >>> 0, object.creationTimeMsec.high >>> 0).toNumber(true);
            switch (object.priority) {
            case "INVISIBLE":
            case 1:
                message.priority = 1;
                break;
            case "LOW":
            case 2:
                message.priority = 2;
                break;
            case "HIGH":
            case 3:
                message.priority = 3;
                break;
            }
            if (object.userActionToken != null)
                message.userActionToken = String(object.userActionToken);
            if (object.lastModifiedVersion != null)
                if ($util.Long)
                    (message.lastModifiedVersion = $util.Long.fromValue(object.lastModifiedVersion)).unsigned = true;
                else if (typeof object.lastModifiedVersion === "string")
                    message.lastModifiedVersion = parseInt(object.lastModifiedVersion, 10);
                else if (typeof object.lastModifiedVersion === "number")
                    message.lastModifiedVersion = object.lastModifiedVersion;
                else if (typeof object.lastModifiedVersion === "object")
                    message.lastModifiedVersion = new $util.LongBits(object.lastModifiedVersion.low >>> 0, object.lastModifiedVersion.high >>> 0).toNumber(true);
            if (object.sortVersion != null)
                if ($util.Long)
                    (message.sortVersion = $util.Long.fromValue(object.sortVersion)).unsigned = true;
                else if (typeof object.sortVersion === "string")
                    message.sortVersion = parseInt(object.sortVersion, 10);
                else if (typeof object.sortVersion === "number")
                    message.sortVersion = object.sortVersion;
                else if (typeof object.sortVersion === "object")
                    message.sortVersion = new $util.LongBits(object.sortVersion.low >>> 0, object.sortVersion.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a CoalescedSyncedNotification message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.CoalescedSyncedNotification
         * @static
         * @param {sync_pb.CoalescedSyncedNotification} message CoalescedSyncedNotification
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CoalescedSyncedNotification.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.notification = [];
            if (options.defaults) {
                object.key = "";
                object.appId = "";
                object.renderInfo = null;
                object.readState = options.enums === String ? "UNREAD" : 1;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationTimeMsec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationTimeMsec = options.longs === String ? "0" : 0;
                object.priority = options.enums === String ? "INVISIBLE" : 1;
                object.userActionToken = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.lastModifiedVersion = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastModifiedVersion = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.sortVersion = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sortVersion = options.longs === String ? "0" : 0;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.appId != null && message.hasOwnProperty("appId"))
                object.appId = message.appId;
            if (message.notification && message.notification.length) {
                object.notification = [];
                for (let j = 0; j < message.notification.length; ++j)
                    object.notification[j] = $root.sync_pb.SyncedNotification.toObject(message.notification[j], options);
            }
            if (message.renderInfo != null && message.hasOwnProperty("renderInfo"))
                object.renderInfo = $root.sync_pb.SyncedNotificationRenderInfo.toObject(message.renderInfo, options);
            if (message.readState != null && message.hasOwnProperty("readState"))
                object.readState = options.enums === String ? $root.sync_pb.CoalescedSyncedNotification.ReadState[message.readState] : message.readState;
            if (message.creationTimeMsec != null && message.hasOwnProperty("creationTimeMsec"))
                if (typeof message.creationTimeMsec === "number")
                    object.creationTimeMsec = options.longs === String ? String(message.creationTimeMsec) : message.creationTimeMsec;
                else
                    object.creationTimeMsec = options.longs === String ? $util.Long.prototype.toString.call(message.creationTimeMsec) : options.longs === Number ? new $util.LongBits(message.creationTimeMsec.low >>> 0, message.creationTimeMsec.high >>> 0).toNumber(true) : message.creationTimeMsec;
            if (message.priority != null && message.hasOwnProperty("priority"))
                object.priority = options.enums === String ? $root.sync_pb.CoalescedSyncedNotification.Priority[message.priority] : message.priority;
            if (message.userActionToken != null && message.hasOwnProperty("userActionToken"))
                object.userActionToken = message.userActionToken;
            if (message.lastModifiedVersion != null && message.hasOwnProperty("lastModifiedVersion"))
                if (typeof message.lastModifiedVersion === "number")
                    object.lastModifiedVersion = options.longs === String ? String(message.lastModifiedVersion) : message.lastModifiedVersion;
                else
                    object.lastModifiedVersion = options.longs === String ? $util.Long.prototype.toString.call(message.lastModifiedVersion) : options.longs === Number ? new $util.LongBits(message.lastModifiedVersion.low >>> 0, message.lastModifiedVersion.high >>> 0).toNumber(true) : message.lastModifiedVersion;
            if (message.sortVersion != null && message.hasOwnProperty("sortVersion"))
                if (typeof message.sortVersion === "number")
                    object.sortVersion = options.longs === String ? String(message.sortVersion) : message.sortVersion;
                else
                    object.sortVersion = options.longs === String ? $util.Long.prototype.toString.call(message.sortVersion) : options.longs === Number ? new $util.LongBits(message.sortVersion.low >>> 0, message.sortVersion.high >>> 0).toNumber(true) : message.sortVersion;
            return object;
        };

        /**
         * Converts this CoalescedSyncedNotification to JSON.
         * @function toJSON
         * @memberof sync_pb.CoalescedSyncedNotification
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CoalescedSyncedNotification.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * ReadState enum.
         * @name sync_pb.CoalescedSyncedNotification.ReadState
         * @enum {number}
         * @property {number} UNREAD=1 UNREAD value
         * @property {number} READ=2 READ value
         * @property {number} DISMISSED=3 DISMISSED value
         * @property {number} SEEN=4 SEEN value
         */
        CoalescedSyncedNotification.ReadState = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "UNREAD"] = 1;
            values[valuesById[2] = "READ"] = 2;
            values[valuesById[3] = "DISMISSED"] = 3;
            values[valuesById[4] = "SEEN"] = 4;
            return values;
        })();

        /**
         * Priority enum.
         * @name sync_pb.CoalescedSyncedNotification.Priority
         * @enum {number}
         * @property {number} INVISIBLE=1 INVISIBLE value
         * @property {number} LOW=2 LOW value
         * @property {number} HIGH=3 HIGH value
         */
        CoalescedSyncedNotification.Priority = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "INVISIBLE"] = 1;
            values[valuesById[2] = "LOW"] = 2;
            values[valuesById[3] = "HIGH"] = 3;
            return values;
        })();

        return CoalescedSyncedNotification;
    })();

    sync_pb.SyncedNotificationList = (function() {

        /**
         * Properties of a SyncedNotificationList.
         * @memberof sync_pb
         * @interface ISyncedNotificationList
         * @property {Array.<sync_pb.ICoalescedSyncedNotification>|null} [coalescedNotification] SyncedNotificationList coalescedNotification
         */

        /**
         * Constructs a new SyncedNotificationList.
         * @memberof sync_pb
         * @classdesc Represents a SyncedNotificationList.
         * @implements ISyncedNotificationList
         * @constructor
         * @param {sync_pb.ISyncedNotificationList=} [properties] Properties to set
         */
        function SyncedNotificationList(properties) {
            this.coalescedNotification = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncedNotificationList coalescedNotification.
         * @member {Array.<sync_pb.ICoalescedSyncedNotification>} coalescedNotification
         * @memberof sync_pb.SyncedNotificationList
         * @instance
         */
        SyncedNotificationList.prototype.coalescedNotification = $util.emptyArray;

        /**
         * Creates a new SyncedNotificationList instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncedNotificationList
         * @static
         * @param {sync_pb.ISyncedNotificationList=} [properties] Properties to set
         * @returns {sync_pb.SyncedNotificationList} SyncedNotificationList instance
         */
        SyncedNotificationList.create = function create(properties) {
            return new SyncedNotificationList(properties);
        };

        /**
         * Encodes the specified SyncedNotificationList message. Does not implicitly {@link sync_pb.SyncedNotificationList.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncedNotificationList
         * @static
         * @param {sync_pb.ISyncedNotificationList} message SyncedNotificationList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.coalescedNotification != null && message.coalescedNotification.length)
                for (let i = 0; i < message.coalescedNotification.length; ++i)
                    $root.sync_pb.CoalescedSyncedNotification.encode(message.coalescedNotification[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SyncedNotificationList message, length delimited. Does not implicitly {@link sync_pb.SyncedNotificationList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncedNotificationList
         * @static
         * @param {sync_pb.ISyncedNotificationList} message SyncedNotificationList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncedNotificationList message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncedNotificationList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncedNotificationList} SyncedNotificationList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncedNotificationList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.coalescedNotification && message.coalescedNotification.length))
                        message.coalescedNotification = [];
                    message.coalescedNotification.push($root.sync_pb.CoalescedSyncedNotification.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncedNotificationList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncedNotificationList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncedNotificationList} SyncedNotificationList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncedNotificationList message.
         * @function verify
         * @memberof sync_pb.SyncedNotificationList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncedNotificationList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.coalescedNotification != null && message.hasOwnProperty("coalescedNotification")) {
                if (!Array.isArray(message.coalescedNotification))
                    return "coalescedNotification: array expected";
                for (let i = 0; i < message.coalescedNotification.length; ++i) {
                    let error = $root.sync_pb.CoalescedSyncedNotification.verify(message.coalescedNotification[i]);
                    if (error)
                        return "coalescedNotification." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SyncedNotificationList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncedNotificationList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncedNotificationList} SyncedNotificationList
         */
        SyncedNotificationList.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncedNotificationList)
                return object;
            let message = new $root.sync_pb.SyncedNotificationList();
            if (object.coalescedNotification) {
                if (!Array.isArray(object.coalescedNotification))
                    throw TypeError(".sync_pb.SyncedNotificationList.coalescedNotification: array expected");
                message.coalescedNotification = [];
                for (let i = 0; i < object.coalescedNotification.length; ++i) {
                    if (typeof object.coalescedNotification[i] !== "object")
                        throw TypeError(".sync_pb.SyncedNotificationList.coalescedNotification: object expected");
                    message.coalescedNotification[i] = $root.sync_pb.CoalescedSyncedNotification.fromObject(object.coalescedNotification[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SyncedNotificationList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncedNotificationList
         * @static
         * @param {sync_pb.SyncedNotificationList} message SyncedNotificationList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncedNotificationList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.coalescedNotification = [];
            if (message.coalescedNotification && message.coalescedNotification.length) {
                object.coalescedNotification = [];
                for (let j = 0; j < message.coalescedNotification.length; ++j)
                    object.coalescedNotification[j] = $root.sync_pb.CoalescedSyncedNotification.toObject(message.coalescedNotification[j], options);
            }
            return object;
        };

        /**
         * Converts this SyncedNotificationList to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncedNotificationList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncedNotificationList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncedNotificationList;
    })();

    sync_pb.MapData = (function() {

        /**
         * Properties of a MapData.
         * @memberof sync_pb
         * @interface IMapData
         * @property {Array.<sync_pb.MapData.IEntry>|null} [entry] MapData entry
         */

        /**
         * Constructs a new MapData.
         * @memberof sync_pb
         * @classdesc Represents a MapData.
         * @implements IMapData
         * @constructor
         * @param {sync_pb.IMapData=} [properties] Properties to set
         */
        function MapData(properties) {
            this.entry = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MapData entry.
         * @member {Array.<sync_pb.MapData.IEntry>} entry
         * @memberof sync_pb.MapData
         * @instance
         */
        MapData.prototype.entry = $util.emptyArray;

        /**
         * Creates a new MapData instance using the specified properties.
         * @function create
         * @memberof sync_pb.MapData
         * @static
         * @param {sync_pb.IMapData=} [properties] Properties to set
         * @returns {sync_pb.MapData} MapData instance
         */
        MapData.create = function create(properties) {
            return new MapData(properties);
        };

        /**
         * Encodes the specified MapData message. Does not implicitly {@link sync_pb.MapData.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.MapData
         * @static
         * @param {sync_pb.IMapData} message MapData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MapData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.entry != null && message.entry.length)
                for (let i = 0; i < message.entry.length; ++i)
                    $root.sync_pb.MapData.Entry.encode(message.entry[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MapData message, length delimited. Does not implicitly {@link sync_pb.MapData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.MapData
         * @static
         * @param {sync_pb.IMapData} message MapData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MapData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MapData message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.MapData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.MapData} MapData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MapData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.MapData();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.entry && message.entry.length))
                        message.entry = [];
                    message.entry.push($root.sync_pb.MapData.Entry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MapData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.MapData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.MapData} MapData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MapData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MapData message.
         * @function verify
         * @memberof sync_pb.MapData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MapData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.entry != null && message.hasOwnProperty("entry")) {
                if (!Array.isArray(message.entry))
                    return "entry: array expected";
                for (let i = 0; i < message.entry.length; ++i) {
                    let error = $root.sync_pb.MapData.Entry.verify(message.entry[i]);
                    if (error)
                        return "entry." + error;
                }
            }
            return null;
        };

        /**
         * Creates a MapData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.MapData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.MapData} MapData
         */
        MapData.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.MapData)
                return object;
            let message = new $root.sync_pb.MapData();
            if (object.entry) {
                if (!Array.isArray(object.entry))
                    throw TypeError(".sync_pb.MapData.entry: array expected");
                message.entry = [];
                for (let i = 0; i < object.entry.length; ++i) {
                    if (typeof object.entry[i] !== "object")
                        throw TypeError(".sync_pb.MapData.entry: object expected");
                    message.entry[i] = $root.sync_pb.MapData.Entry.fromObject(object.entry[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a MapData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.MapData
         * @static
         * @param {sync_pb.MapData} message MapData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MapData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.entry = [];
            if (message.entry && message.entry.length) {
                object.entry = [];
                for (let j = 0; j < message.entry.length; ++j)
                    object.entry[j] = $root.sync_pb.MapData.Entry.toObject(message.entry[j], options);
            }
            return object;
        };

        /**
         * Converts this MapData to JSON.
         * @function toJSON
         * @memberof sync_pb.MapData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MapData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        MapData.Entry = (function() {

            /**
             * Properties of an Entry.
             * @memberof sync_pb.MapData
             * @interface IEntry
             * @property {string|null} [key] Entry key
             * @property {sync_pb.IData|null} [value] Entry value
             */

            /**
             * Constructs a new Entry.
             * @memberof sync_pb.MapData
             * @classdesc Represents an Entry.
             * @implements IEntry
             * @constructor
             * @param {sync_pb.MapData.IEntry=} [properties] Properties to set
             */
            function Entry(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Entry key.
             * @member {string} key
             * @memberof sync_pb.MapData.Entry
             * @instance
             */
            Entry.prototype.key = "";

            /**
             * Entry value.
             * @member {sync_pb.IData|null|undefined} value
             * @memberof sync_pb.MapData.Entry
             * @instance
             */
            Entry.prototype.value = null;

            /**
             * Creates a new Entry instance using the specified properties.
             * @function create
             * @memberof sync_pb.MapData.Entry
             * @static
             * @param {sync_pb.MapData.IEntry=} [properties] Properties to set
             * @returns {sync_pb.MapData.Entry} Entry instance
             */
            Entry.create = function create(properties) {
                return new Entry(properties);
            };

            /**
             * Encodes the specified Entry message. Does not implicitly {@link sync_pb.MapData.Entry.verify|verify} messages.
             * @function encode
             * @memberof sync_pb.MapData.Entry
             * @static
             * @param {sync_pb.MapData.IEntry} message Entry message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Entry.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    $root.sync_pb.Data.encode(message.value, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Entry message, length delimited. Does not implicitly {@link sync_pb.MapData.Entry.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync_pb.MapData.Entry
             * @static
             * @param {sync_pb.MapData.IEntry} message Entry message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Entry.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Entry message from the specified reader or buffer.
             * @function decode
             * @memberof sync_pb.MapData.Entry
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync_pb.MapData.Entry} Entry
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Entry.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.MapData.Entry();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.key = reader.string();
                        break;
                    case 2:
                        message.value = $root.sync_pb.Data.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Entry message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync_pb.MapData.Entry
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync_pb.MapData.Entry} Entry
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Entry.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Entry message.
             * @function verify
             * @memberof sync_pb.MapData.Entry
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Entry.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.key != null && message.hasOwnProperty("key"))
                    if (!$util.isString(message.key))
                        return "key: string expected";
                if (message.value != null && message.hasOwnProperty("value")) {
                    let error = $root.sync_pb.Data.verify(message.value);
                    if (error)
                        return "value." + error;
                }
                return null;
            };

            /**
             * Creates an Entry message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync_pb.MapData.Entry
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync_pb.MapData.Entry} Entry
             */
            Entry.fromObject = function fromObject(object) {
                if (object instanceof $root.sync_pb.MapData.Entry)
                    return object;
                let message = new $root.sync_pb.MapData.Entry();
                if (object.key != null)
                    message.key = String(object.key);
                if (object.value != null) {
                    if (typeof object.value !== "object")
                        throw TypeError(".sync_pb.MapData.Entry.value: object expected");
                    message.value = $root.sync_pb.Data.fromObject(object.value);
                }
                return message;
            };

            /**
             * Creates a plain object from an Entry message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync_pb.MapData.Entry
             * @static
             * @param {sync_pb.MapData.Entry} message Entry
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Entry.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.key = "";
                    object.value = null;
                }
                if (message.key != null && message.hasOwnProperty("key"))
                    object.key = message.key;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = $root.sync_pb.Data.toObject(message.value, options);
                return object;
            };

            /**
             * Converts this Entry to JSON.
             * @function toJSON
             * @memberof sync_pb.MapData.Entry
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Entry.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Entry;
        })();

        return MapData;
    })();

    sync_pb.Data = (function() {

        /**
         * Properties of a Data.
         * @memberof sync_pb
         * @interface IData
         * @property {boolean|null} [booleanValue] Data booleanValue
         * @property {number|null} [intValue] Data intValue
         * @property {number|null} [floatValue] Data floatValue
         * @property {string|null} [stringValue] Data stringValue
         * @property {sync_pb.IListData|null} [listValue] Data listValue
         * @property {sync_pb.IMapData|null} [mapValue] Data mapValue
         */

        /**
         * Constructs a new Data.
         * @memberof sync_pb
         * @classdesc Represents a Data.
         * @implements IData
         * @constructor
         * @param {sync_pb.IData=} [properties] Properties to set
         */
        function Data(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Data booleanValue.
         * @member {boolean} booleanValue
         * @memberof sync_pb.Data
         * @instance
         */
        Data.prototype.booleanValue = false;

        /**
         * Data intValue.
         * @member {number} intValue
         * @memberof sync_pb.Data
         * @instance
         */
        Data.prototype.intValue = 0;

        /**
         * Data floatValue.
         * @member {number} floatValue
         * @memberof sync_pb.Data
         * @instance
         */
        Data.prototype.floatValue = 0;

        /**
         * Data stringValue.
         * @member {string} stringValue
         * @memberof sync_pb.Data
         * @instance
         */
        Data.prototype.stringValue = "";

        /**
         * Data listValue.
         * @member {sync_pb.IListData|null|undefined} listValue
         * @memberof sync_pb.Data
         * @instance
         */
        Data.prototype.listValue = null;

        /**
         * Data mapValue.
         * @member {sync_pb.IMapData|null|undefined} mapValue
         * @memberof sync_pb.Data
         * @instance
         */
        Data.prototype.mapValue = null;

        /**
         * Creates a new Data instance using the specified properties.
         * @function create
         * @memberof sync_pb.Data
         * @static
         * @param {sync_pb.IData=} [properties] Properties to set
         * @returns {sync_pb.Data} Data instance
         */
        Data.create = function create(properties) {
            return new Data(properties);
        };

        /**
         * Encodes the specified Data message. Does not implicitly {@link sync_pb.Data.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.Data
         * @static
         * @param {sync_pb.IData} message Data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Data.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.booleanValue != null && Object.hasOwnProperty.call(message, "booleanValue"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.booleanValue);
            if (message.intValue != null && Object.hasOwnProperty.call(message, "intValue"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.intValue);
            if (message.floatValue != null && Object.hasOwnProperty.call(message, "floatValue"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.floatValue);
            if (message.stringValue != null && Object.hasOwnProperty.call(message, "stringValue"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.stringValue);
            if (message.listValue != null && Object.hasOwnProperty.call(message, "listValue"))
                $root.sync_pb.ListData.encode(message.listValue, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.mapValue != null && Object.hasOwnProperty.call(message, "mapValue"))
                $root.sync_pb.MapData.encode(message.mapValue, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Data message, length delimited. Does not implicitly {@link sync_pb.Data.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.Data
         * @static
         * @param {sync_pb.IData} message Data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Data.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Data message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.Data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.Data} Data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Data.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.Data();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.booleanValue = reader.bool();
                    break;
                case 2:
                    message.intValue = reader.int32();
                    break;
                case 3:
                    message.floatValue = reader.double();
                    break;
                case 4:
                    message.stringValue = reader.string();
                    break;
                case 5:
                    message.listValue = $root.sync_pb.ListData.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.mapValue = $root.sync_pb.MapData.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Data message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.Data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.Data} Data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Data.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Data message.
         * @function verify
         * @memberof sync_pb.Data
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Data.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.booleanValue != null && message.hasOwnProperty("booleanValue"))
                if (typeof message.booleanValue !== "boolean")
                    return "booleanValue: boolean expected";
            if (message.intValue != null && message.hasOwnProperty("intValue"))
                if (!$util.isInteger(message.intValue))
                    return "intValue: integer expected";
            if (message.floatValue != null && message.hasOwnProperty("floatValue"))
                if (typeof message.floatValue !== "number")
                    return "floatValue: number expected";
            if (message.stringValue != null && message.hasOwnProperty("stringValue"))
                if (!$util.isString(message.stringValue))
                    return "stringValue: string expected";
            if (message.listValue != null && message.hasOwnProperty("listValue")) {
                let error = $root.sync_pb.ListData.verify(message.listValue);
                if (error)
                    return "listValue." + error;
            }
            if (message.mapValue != null && message.hasOwnProperty("mapValue")) {
                let error = $root.sync_pb.MapData.verify(message.mapValue);
                if (error)
                    return "mapValue." + error;
            }
            return null;
        };

        /**
         * Creates a Data message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.Data
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.Data} Data
         */
        Data.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.Data)
                return object;
            let message = new $root.sync_pb.Data();
            if (object.booleanValue != null)
                message.booleanValue = Boolean(object.booleanValue);
            if (object.intValue != null)
                message.intValue = object.intValue | 0;
            if (object.floatValue != null)
                message.floatValue = Number(object.floatValue);
            if (object.stringValue != null)
                message.stringValue = String(object.stringValue);
            if (object.listValue != null) {
                if (typeof object.listValue !== "object")
                    throw TypeError(".sync_pb.Data.listValue: object expected");
                message.listValue = $root.sync_pb.ListData.fromObject(object.listValue);
            }
            if (object.mapValue != null) {
                if (typeof object.mapValue !== "object")
                    throw TypeError(".sync_pb.Data.mapValue: object expected");
                message.mapValue = $root.sync_pb.MapData.fromObject(object.mapValue);
            }
            return message;
        };

        /**
         * Creates a plain object from a Data message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.Data
         * @static
         * @param {sync_pb.Data} message Data
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Data.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.booleanValue = false;
                object.intValue = 0;
                object.floatValue = 0;
                object.stringValue = "";
                object.listValue = null;
                object.mapValue = null;
            }
            if (message.booleanValue != null && message.hasOwnProperty("booleanValue"))
                object.booleanValue = message.booleanValue;
            if (message.intValue != null && message.hasOwnProperty("intValue"))
                object.intValue = message.intValue;
            if (message.floatValue != null && message.hasOwnProperty("floatValue"))
                object.floatValue = options.json && !isFinite(message.floatValue) ? String(message.floatValue) : message.floatValue;
            if (message.stringValue != null && message.hasOwnProperty("stringValue"))
                object.stringValue = message.stringValue;
            if (message.listValue != null && message.hasOwnProperty("listValue"))
                object.listValue = $root.sync_pb.ListData.toObject(message.listValue, options);
            if (message.mapValue != null && message.hasOwnProperty("mapValue"))
                object.mapValue = $root.sync_pb.MapData.toObject(message.mapValue, options);
            return object;
        };

        /**
         * Converts this Data to JSON.
         * @function toJSON
         * @memberof sync_pb.Data
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Data.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Data;
    })();

    sync_pb.ListData = (function() {

        /**
         * Properties of a ListData.
         * @memberof sync_pb
         * @interface IListData
         * @property {Array.<sync_pb.IData>|null} [value] ListData value
         */

        /**
         * Constructs a new ListData.
         * @memberof sync_pb
         * @classdesc Represents a ListData.
         * @implements IListData
         * @constructor
         * @param {sync_pb.IListData=} [properties] Properties to set
         */
        function ListData(properties) {
            this.value = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListData value.
         * @member {Array.<sync_pb.IData>} value
         * @memberof sync_pb.ListData
         * @instance
         */
        ListData.prototype.value = $util.emptyArray;

        /**
         * Creates a new ListData instance using the specified properties.
         * @function create
         * @memberof sync_pb.ListData
         * @static
         * @param {sync_pb.IListData=} [properties] Properties to set
         * @returns {sync_pb.ListData} ListData instance
         */
        ListData.create = function create(properties) {
            return new ListData(properties);
        };

        /**
         * Encodes the specified ListData message. Does not implicitly {@link sync_pb.ListData.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ListData
         * @static
         * @param {sync_pb.IListData} message ListData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && message.value.length)
                for (let i = 0; i < message.value.length; ++i)
                    $root.sync_pb.Data.encode(message.value[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ListData message, length delimited. Does not implicitly {@link sync_pb.ListData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ListData
         * @static
         * @param {sync_pb.IListData} message ListData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListData message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ListData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ListData} ListData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ListData();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.value && message.value.length))
                        message.value = [];
                    message.value.push($root.sync_pb.Data.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ListData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ListData} ListData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListData message.
         * @function verify
         * @memberof sync_pb.ListData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value")) {
                if (!Array.isArray(message.value))
                    return "value: array expected";
                for (let i = 0; i < message.value.length; ++i) {
                    let error = $root.sync_pb.Data.verify(message.value[i]);
                    if (error)
                        return "value." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ListData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ListData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ListData} ListData
         */
        ListData.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ListData)
                return object;
            let message = new $root.sync_pb.ListData();
            if (object.value) {
                if (!Array.isArray(object.value))
                    throw TypeError(".sync_pb.ListData.value: array expected");
                message.value = [];
                for (let i = 0; i < object.value.length; ++i) {
                    if (typeof object.value[i] !== "object")
                        throw TypeError(".sync_pb.ListData.value: object expected");
                    message.value[i] = $root.sync_pb.Data.fromObject(object.value[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ListData
         * @static
         * @param {sync_pb.ListData} message ListData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.value = [];
            if (message.value && message.value.length) {
                object.value = [];
                for (let j = 0; j < message.value.length; ++j)
                    object.value[j] = $root.sync_pb.Data.toObject(message.value[j], options);
            }
            return object;
        };

        /**
         * Converts this ListData to JSON.
         * @function toJSON
         * @memberof sync_pb.ListData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListData;
    })();

    sync_pb.RenderContext = (function() {

        /**
         * Properties of a RenderContext.
         * @memberof sync_pb
         * @interface IRenderContext
         * @property {sync_pb.RenderContext.DeviceType|null} [deviceType] RenderContext deviceType
         * @property {string|null} [languageCode] RenderContext languageCode
         */

        /**
         * Constructs a new RenderContext.
         * @memberof sync_pb
         * @classdesc Represents a RenderContext.
         * @implements IRenderContext
         * @constructor
         * @param {sync_pb.IRenderContext=} [properties] Properties to set
         */
        function RenderContext(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RenderContext deviceType.
         * @member {sync_pb.RenderContext.DeviceType} deviceType
         * @memberof sync_pb.RenderContext
         * @instance
         */
        RenderContext.prototype.deviceType = 0;

        /**
         * RenderContext languageCode.
         * @member {string} languageCode
         * @memberof sync_pb.RenderContext
         * @instance
         */
        RenderContext.prototype.languageCode = "";

        /**
         * Creates a new RenderContext instance using the specified properties.
         * @function create
         * @memberof sync_pb.RenderContext
         * @static
         * @param {sync_pb.IRenderContext=} [properties] Properties to set
         * @returns {sync_pb.RenderContext} RenderContext instance
         */
        RenderContext.create = function create(properties) {
            return new RenderContext(properties);
        };

        /**
         * Encodes the specified RenderContext message. Does not implicitly {@link sync_pb.RenderContext.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.RenderContext
         * @static
         * @param {sync_pb.IRenderContext} message RenderContext message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RenderContext.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.deviceType != null && Object.hasOwnProperty.call(message, "deviceType"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.deviceType);
            if (message.languageCode != null && Object.hasOwnProperty.call(message, "languageCode"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.languageCode);
            return writer;
        };

        /**
         * Encodes the specified RenderContext message, length delimited. Does not implicitly {@link sync_pb.RenderContext.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.RenderContext
         * @static
         * @param {sync_pb.IRenderContext} message RenderContext message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RenderContext.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RenderContext message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.RenderContext
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.RenderContext} RenderContext
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RenderContext.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.RenderContext();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.deviceType = reader.int32();
                    break;
                case 2:
                    message.languageCode = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RenderContext message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.RenderContext
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.RenderContext} RenderContext
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RenderContext.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RenderContext message.
         * @function verify
         * @memberof sync_pb.RenderContext
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RenderContext.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                switch (message.deviceType) {
                default:
                    return "deviceType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                    break;
                }
            if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                if (!$util.isString(message.languageCode))
                    return "languageCode: string expected";
            return null;
        };

        /**
         * Creates a RenderContext message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.RenderContext
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.RenderContext} RenderContext
         */
        RenderContext.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.RenderContext)
                return object;
            let message = new $root.sync_pb.RenderContext();
            switch (object.deviceType) {
            case "UNKNOWN":
            case 0:
                message.deviceType = 0;
                break;
            case "IOS_NON_RETINA":
            case 1:
                message.deviceType = 1;
                break;
            case "IOS_RETINA":
            case 2:
                message.deviceType = 2;
                break;
            case "ANDROID_MDPI":
            case 3:
                message.deviceType = 3;
                break;
            case "ANDROID_HDPI":
            case 4:
                message.deviceType = 4;
                break;
            case "ANDROID_XHDPI":
            case 5:
                message.deviceType = 5;
                break;
            case "ANDROID_TVDPI":
            case 6:
                message.deviceType = 6;
                break;
            case "DESKTOP_NON_RETINA":
            case 7:
                message.deviceType = 7;
                break;
            case "DESKTOP_RETINA":
            case 8:
                message.deviceType = 8;
                break;
            case "ANDROID_XXHDPI":
            case 9:
                message.deviceType = 9;
                break;
            case "CHROME_1X":
            case 10:
                message.deviceType = 10;
                break;
            case "CHROME_2X":
            case 11:
                message.deviceType = 11;
                break;
            }
            if (object.languageCode != null)
                message.languageCode = String(object.languageCode);
            return message;
        };

        /**
         * Creates a plain object from a RenderContext message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.RenderContext
         * @static
         * @param {sync_pb.RenderContext} message RenderContext
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RenderContext.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.deviceType = options.enums === String ? "UNKNOWN" : 0;
                object.languageCode = "";
            }
            if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                object.deviceType = options.enums === String ? $root.sync_pb.RenderContext.DeviceType[message.deviceType] : message.deviceType;
            if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                object.languageCode = message.languageCode;
            return object;
        };

        /**
         * Converts this RenderContext to JSON.
         * @function toJSON
         * @memberof sync_pb.RenderContext
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RenderContext.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * DeviceType enum.
         * @name sync_pb.RenderContext.DeviceType
         * @enum {number}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} IOS_NON_RETINA=1 IOS_NON_RETINA value
         * @property {number} IOS_RETINA=2 IOS_RETINA value
         * @property {number} ANDROID_MDPI=3 ANDROID_MDPI value
         * @property {number} ANDROID_HDPI=4 ANDROID_HDPI value
         * @property {number} ANDROID_XHDPI=5 ANDROID_XHDPI value
         * @property {number} ANDROID_TVDPI=6 ANDROID_TVDPI value
         * @property {number} DESKTOP_NON_RETINA=7 DESKTOP_NON_RETINA value
         * @property {number} DESKTOP_RETINA=8 DESKTOP_RETINA value
         * @property {number} ANDROID_XXHDPI=9 ANDROID_XXHDPI value
         * @property {number} CHROME_1X=10 CHROME_1X value
         * @property {number} CHROME_2X=11 CHROME_2X value
         */
        RenderContext.DeviceType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "IOS_NON_RETINA"] = 1;
            values[valuesById[2] = "IOS_RETINA"] = 2;
            values[valuesById[3] = "ANDROID_MDPI"] = 3;
            values[valuesById[4] = "ANDROID_HDPI"] = 4;
            values[valuesById[5] = "ANDROID_XHDPI"] = 5;
            values[valuesById[6] = "ANDROID_TVDPI"] = 6;
            values[valuesById[7] = "DESKTOP_NON_RETINA"] = 7;
            values[valuesById[8] = "DESKTOP_RETINA"] = 8;
            values[valuesById[9] = "ANDROID_XXHDPI"] = 9;
            values[valuesById[10] = "CHROME_1X"] = 10;
            values[valuesById[11] = "CHROME_2X"] = 11;
            return values;
        })();

        return RenderContext;
    })();

    sync_pb.AppList = (function() {

        /**
         * Properties of an AppList.
         * @memberof sync_pb
         * @interface IAppList
         * @property {sync_pb.AppList.Type|null} [type] AppList type
         * @property {Array.<string>|null} [appId] AppList appId
         */

        /**
         * Constructs a new AppList.
         * @memberof sync_pb
         * @classdesc Represents an AppList.
         * @implements IAppList
         * @constructor
         * @param {sync_pb.IAppList=} [properties] Properties to set
         */
        function AppList(properties) {
            this.appId = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AppList type.
         * @member {sync_pb.AppList.Type} type
         * @memberof sync_pb.AppList
         * @instance
         */
        AppList.prototype.type = 1;

        /**
         * AppList appId.
         * @member {Array.<string>} appId
         * @memberof sync_pb.AppList
         * @instance
         */
        AppList.prototype.appId = $util.emptyArray;

        /**
         * Creates a new AppList instance using the specified properties.
         * @function create
         * @memberof sync_pb.AppList
         * @static
         * @param {sync_pb.IAppList=} [properties] Properties to set
         * @returns {sync_pb.AppList} AppList instance
         */
        AppList.create = function create(properties) {
            return new AppList(properties);
        };

        /**
         * Encodes the specified AppList message. Does not implicitly {@link sync_pb.AppList.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.AppList
         * @static
         * @param {sync_pb.IAppList} message AppList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AppList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
            if (message.appId != null && message.appId.length)
                for (let i = 0; i < message.appId.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.appId[i]);
            return writer;
        };

        /**
         * Encodes the specified AppList message, length delimited. Does not implicitly {@link sync_pb.AppList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.AppList
         * @static
         * @param {sync_pb.IAppList} message AppList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AppList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AppList message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.AppList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.AppList} AppList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AppList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.AppList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    if (!(message.appId && message.appId.length))
                        message.appId = [];
                    message.appId.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AppList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.AppList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.AppList} AppList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AppList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AppList message.
         * @function verify
         * @memberof sync_pb.AppList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AppList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.type != null && message.hasOwnProperty("type"))
                switch (message.type) {
                default:
                    return "type: enum value expected";
                case 1:
                case 2:
                    break;
                }
            if (message.appId != null && message.hasOwnProperty("appId")) {
                if (!Array.isArray(message.appId))
                    return "appId: array expected";
                for (let i = 0; i < message.appId.length; ++i)
                    if (!$util.isString(message.appId[i]))
                        return "appId: string[] expected";
            }
            return null;
        };

        /**
         * Creates an AppList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.AppList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.AppList} AppList
         */
        AppList.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.AppList)
                return object;
            let message = new $root.sync_pb.AppList();
            switch (object.type) {
            case "WHITELIST":
            case 1:
                message.type = 1;
                break;
            case "BLACKLIST":
            case 2:
                message.type = 2;
                break;
            }
            if (object.appId) {
                if (!Array.isArray(object.appId))
                    throw TypeError(".sync_pb.AppList.appId: array expected");
                message.appId = [];
                for (let i = 0; i < object.appId.length; ++i)
                    message.appId[i] = String(object.appId[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an AppList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.AppList
         * @static
         * @param {sync_pb.AppList} message AppList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AppList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.appId = [];
            if (options.defaults)
                object.type = options.enums === String ? "WHITELIST" : 1;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.sync_pb.AppList.Type[message.type] : message.type;
            if (message.appId && message.appId.length) {
                object.appId = [];
                for (let j = 0; j < message.appId.length; ++j)
                    object.appId[j] = message.appId[j];
            }
            return object;
        };

        /**
         * Converts this AppList to JSON.
         * @function toJSON
         * @memberof sync_pb.AppList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AppList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Type enum.
         * @name sync_pb.AppList.Type
         * @enum {number}
         * @property {number} WHITELIST=1 WHITELIST value
         * @property {number} BLACKLIST=2 BLACKLIST value
         */
        AppList.Type = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "WHITELIST"] = 1;
            values[valuesById[2] = "BLACKLIST"] = 2;
            return values;
        })();

        return AppList;
    })();

    sync_pb.ServerContext = (function() {

        /**
         * Properties of a ServerContext.
         * @memberof sync_pb
         * @interface IServerContext
         * @property {sync_pb.IRenderContext|null} [renderContext] ServerContext renderContext
         * @property {sync_pb.IAppList|null} [appList] ServerContext appList
         * @property {string|null} [viewId] ServerContext viewId
         */

        /**
         * Constructs a new ServerContext.
         * @memberof sync_pb
         * @classdesc Represents a ServerContext.
         * @implements IServerContext
         * @constructor
         * @param {sync_pb.IServerContext=} [properties] Properties to set
         */
        function ServerContext(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ServerContext renderContext.
         * @member {sync_pb.IRenderContext|null|undefined} renderContext
         * @memberof sync_pb.ServerContext
         * @instance
         */
        ServerContext.prototype.renderContext = null;

        /**
         * ServerContext appList.
         * @member {sync_pb.IAppList|null|undefined} appList
         * @memberof sync_pb.ServerContext
         * @instance
         */
        ServerContext.prototype.appList = null;

        /**
         * ServerContext viewId.
         * @member {string} viewId
         * @memberof sync_pb.ServerContext
         * @instance
         */
        ServerContext.prototype.viewId = "";

        /**
         * Creates a new ServerContext instance using the specified properties.
         * @function create
         * @memberof sync_pb.ServerContext
         * @static
         * @param {sync_pb.IServerContext=} [properties] Properties to set
         * @returns {sync_pb.ServerContext} ServerContext instance
         */
        ServerContext.create = function create(properties) {
            return new ServerContext(properties);
        };

        /**
         * Encodes the specified ServerContext message. Does not implicitly {@link sync_pb.ServerContext.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ServerContext
         * @static
         * @param {sync_pb.IServerContext} message ServerContext message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ServerContext.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.renderContext != null && Object.hasOwnProperty.call(message, "renderContext"))
                $root.sync_pb.RenderContext.encode(message.renderContext, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.appList != null && Object.hasOwnProperty.call(message, "appList"))
                $root.sync_pb.AppList.encode(message.appList, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.viewId != null && Object.hasOwnProperty.call(message, "viewId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.viewId);
            return writer;
        };

        /**
         * Encodes the specified ServerContext message, length delimited. Does not implicitly {@link sync_pb.ServerContext.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ServerContext
         * @static
         * @param {sync_pb.IServerContext} message ServerContext message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ServerContext.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ServerContext message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ServerContext
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ServerContext} ServerContext
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ServerContext.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ServerContext();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.renderContext = $root.sync_pb.RenderContext.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.appList = $root.sync_pb.AppList.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.viewId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ServerContext message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ServerContext
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ServerContext} ServerContext
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ServerContext.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ServerContext message.
         * @function verify
         * @memberof sync_pb.ServerContext
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ServerContext.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.renderContext != null && message.hasOwnProperty("renderContext")) {
                let error = $root.sync_pb.RenderContext.verify(message.renderContext);
                if (error)
                    return "renderContext." + error;
            }
            if (message.appList != null && message.hasOwnProperty("appList")) {
                let error = $root.sync_pb.AppList.verify(message.appList);
                if (error)
                    return "appList." + error;
            }
            if (message.viewId != null && message.hasOwnProperty("viewId"))
                if (!$util.isString(message.viewId))
                    return "viewId: string expected";
            return null;
        };

        /**
         * Creates a ServerContext message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ServerContext
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ServerContext} ServerContext
         */
        ServerContext.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ServerContext)
                return object;
            let message = new $root.sync_pb.ServerContext();
            if (object.renderContext != null) {
                if (typeof object.renderContext !== "object")
                    throw TypeError(".sync_pb.ServerContext.renderContext: object expected");
                message.renderContext = $root.sync_pb.RenderContext.fromObject(object.renderContext);
            }
            if (object.appList != null) {
                if (typeof object.appList !== "object")
                    throw TypeError(".sync_pb.ServerContext.appList: object expected");
                message.appList = $root.sync_pb.AppList.fromObject(object.appList);
            }
            if (object.viewId != null)
                message.viewId = String(object.viewId);
            return message;
        };

        /**
         * Creates a plain object from a ServerContext message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ServerContext
         * @static
         * @param {sync_pb.ServerContext} message ServerContext
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ServerContext.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.renderContext = null;
                object.appList = null;
                object.viewId = "";
            }
            if (message.renderContext != null && message.hasOwnProperty("renderContext"))
                object.renderContext = $root.sync_pb.RenderContext.toObject(message.renderContext, options);
            if (message.appList != null && message.hasOwnProperty("appList"))
                object.appList = $root.sync_pb.AppList.toObject(message.appList, options);
            if (message.viewId != null && message.hasOwnProperty("viewId"))
                object.viewId = message.viewId;
            return object;
        };

        /**
         * Converts this ServerContext to JSON.
         * @function toJSON
         * @memberof sync_pb.ServerContext
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ServerContext.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ServerContext;
    })();

    sync_pb.SyncedNotificationRenderInfo = (function() {

        /**
         * Properties of a SyncedNotificationRenderInfo.
         * @memberof sync_pb
         * @interface ISyncedNotificationRenderInfo
         * @property {sync_pb.ICollapsedInfo|null} [collapsedInfo] SyncedNotificationRenderInfo collapsedInfo
         * @property {sync_pb.IExpandedInfo|null} [expandedInfo] SyncedNotificationRenderInfo expandedInfo
         */

        /**
         * Constructs a new SyncedNotificationRenderInfo.
         * @memberof sync_pb
         * @classdesc Represents a SyncedNotificationRenderInfo.
         * @implements ISyncedNotificationRenderInfo
         * @constructor
         * @param {sync_pb.ISyncedNotificationRenderInfo=} [properties] Properties to set
         */
        function SyncedNotificationRenderInfo(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncedNotificationRenderInfo collapsedInfo.
         * @member {sync_pb.ICollapsedInfo|null|undefined} collapsedInfo
         * @memberof sync_pb.SyncedNotificationRenderInfo
         * @instance
         */
        SyncedNotificationRenderInfo.prototype.collapsedInfo = null;

        /**
         * SyncedNotificationRenderInfo expandedInfo.
         * @member {sync_pb.IExpandedInfo|null|undefined} expandedInfo
         * @memberof sync_pb.SyncedNotificationRenderInfo
         * @instance
         */
        SyncedNotificationRenderInfo.prototype.expandedInfo = null;

        /**
         * Creates a new SyncedNotificationRenderInfo instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncedNotificationRenderInfo
         * @static
         * @param {sync_pb.ISyncedNotificationRenderInfo=} [properties] Properties to set
         * @returns {sync_pb.SyncedNotificationRenderInfo} SyncedNotificationRenderInfo instance
         */
        SyncedNotificationRenderInfo.create = function create(properties) {
            return new SyncedNotificationRenderInfo(properties);
        };

        /**
         * Encodes the specified SyncedNotificationRenderInfo message. Does not implicitly {@link sync_pb.SyncedNotificationRenderInfo.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncedNotificationRenderInfo
         * @static
         * @param {sync_pb.ISyncedNotificationRenderInfo} message SyncedNotificationRenderInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationRenderInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.collapsedInfo != null && Object.hasOwnProperty.call(message, "collapsedInfo"))
                $root.sync_pb.CollapsedInfo.encode(message.collapsedInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.expandedInfo != null && Object.hasOwnProperty.call(message, "expandedInfo"))
                $root.sync_pb.ExpandedInfo.encode(message.expandedInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SyncedNotificationRenderInfo message, length delimited. Does not implicitly {@link sync_pb.SyncedNotificationRenderInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncedNotificationRenderInfo
         * @static
         * @param {sync_pb.ISyncedNotificationRenderInfo} message SyncedNotificationRenderInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationRenderInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncedNotificationRenderInfo message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncedNotificationRenderInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncedNotificationRenderInfo} SyncedNotificationRenderInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationRenderInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncedNotificationRenderInfo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.collapsedInfo = $root.sync_pb.CollapsedInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.expandedInfo = $root.sync_pb.ExpandedInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncedNotificationRenderInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncedNotificationRenderInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncedNotificationRenderInfo} SyncedNotificationRenderInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationRenderInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncedNotificationRenderInfo message.
         * @function verify
         * @memberof sync_pb.SyncedNotificationRenderInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncedNotificationRenderInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.collapsedInfo != null && message.hasOwnProperty("collapsedInfo")) {
                let error = $root.sync_pb.CollapsedInfo.verify(message.collapsedInfo);
                if (error)
                    return "collapsedInfo." + error;
            }
            if (message.expandedInfo != null && message.hasOwnProperty("expandedInfo")) {
                let error = $root.sync_pb.ExpandedInfo.verify(message.expandedInfo);
                if (error)
                    return "expandedInfo." + error;
            }
            return null;
        };

        /**
         * Creates a SyncedNotificationRenderInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncedNotificationRenderInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncedNotificationRenderInfo} SyncedNotificationRenderInfo
         */
        SyncedNotificationRenderInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncedNotificationRenderInfo)
                return object;
            let message = new $root.sync_pb.SyncedNotificationRenderInfo();
            if (object.collapsedInfo != null) {
                if (typeof object.collapsedInfo !== "object")
                    throw TypeError(".sync_pb.SyncedNotificationRenderInfo.collapsedInfo: object expected");
                message.collapsedInfo = $root.sync_pb.CollapsedInfo.fromObject(object.collapsedInfo);
            }
            if (object.expandedInfo != null) {
                if (typeof object.expandedInfo !== "object")
                    throw TypeError(".sync_pb.SyncedNotificationRenderInfo.expandedInfo: object expected");
                message.expandedInfo = $root.sync_pb.ExpandedInfo.fromObject(object.expandedInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from a SyncedNotificationRenderInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncedNotificationRenderInfo
         * @static
         * @param {sync_pb.SyncedNotificationRenderInfo} message SyncedNotificationRenderInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncedNotificationRenderInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.collapsedInfo = null;
                object.expandedInfo = null;
            }
            if (message.collapsedInfo != null && message.hasOwnProperty("collapsedInfo"))
                object.collapsedInfo = $root.sync_pb.CollapsedInfo.toObject(message.collapsedInfo, options);
            if (message.expandedInfo != null && message.hasOwnProperty("expandedInfo"))
                object.expandedInfo = $root.sync_pb.ExpandedInfo.toObject(message.expandedInfo, options);
            return object;
        };

        /**
         * Converts this SyncedNotificationRenderInfo to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncedNotificationRenderInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncedNotificationRenderInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncedNotificationRenderInfo;
    })();

    sync_pb.CollapsedInfo = (function() {

        /**
         * Properties of a CollapsedInfo.
         * @memberof sync_pb
         * @interface ICollapsedInfo
         * @property {sync_pb.ISimpleCollapsedLayout|null} [simpleCollapsedLayout] CollapsedInfo simpleCollapsedLayout
         * @property {number|Long|null} [creationTimestampUsec] CollapsedInfo creationTimestampUsec
         * @property {sync_pb.ISyncedNotificationDestination|null} [defaultDestination] CollapsedInfo defaultDestination
         * @property {Array.<sync_pb.ITarget>|null} [target] CollapsedInfo target
         * @property {Array.<string>|null} [metaTag] CollapsedInfo metaTag
         */

        /**
         * Constructs a new CollapsedInfo.
         * @memberof sync_pb
         * @classdesc Represents a CollapsedInfo.
         * @implements ICollapsedInfo
         * @constructor
         * @param {sync_pb.ICollapsedInfo=} [properties] Properties to set
         */
        function CollapsedInfo(properties) {
            this.target = [];
            this.metaTag = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CollapsedInfo simpleCollapsedLayout.
         * @member {sync_pb.ISimpleCollapsedLayout|null|undefined} simpleCollapsedLayout
         * @memberof sync_pb.CollapsedInfo
         * @instance
         */
        CollapsedInfo.prototype.simpleCollapsedLayout = null;

        /**
         * CollapsedInfo creationTimestampUsec.
         * @member {number|Long} creationTimestampUsec
         * @memberof sync_pb.CollapsedInfo
         * @instance
         */
        CollapsedInfo.prototype.creationTimestampUsec = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * CollapsedInfo defaultDestination.
         * @member {sync_pb.ISyncedNotificationDestination|null|undefined} defaultDestination
         * @memberof sync_pb.CollapsedInfo
         * @instance
         */
        CollapsedInfo.prototype.defaultDestination = null;

        /**
         * CollapsedInfo target.
         * @member {Array.<sync_pb.ITarget>} target
         * @memberof sync_pb.CollapsedInfo
         * @instance
         */
        CollapsedInfo.prototype.target = $util.emptyArray;

        /**
         * CollapsedInfo metaTag.
         * @member {Array.<string>} metaTag
         * @memberof sync_pb.CollapsedInfo
         * @instance
         */
        CollapsedInfo.prototype.metaTag = $util.emptyArray;

        /**
         * Creates a new CollapsedInfo instance using the specified properties.
         * @function create
         * @memberof sync_pb.CollapsedInfo
         * @static
         * @param {sync_pb.ICollapsedInfo=} [properties] Properties to set
         * @returns {sync_pb.CollapsedInfo} CollapsedInfo instance
         */
        CollapsedInfo.create = function create(properties) {
            return new CollapsedInfo(properties);
        };

        /**
         * Encodes the specified CollapsedInfo message. Does not implicitly {@link sync_pb.CollapsedInfo.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.CollapsedInfo
         * @static
         * @param {sync_pb.ICollapsedInfo} message CollapsedInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CollapsedInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.simpleCollapsedLayout != null && Object.hasOwnProperty.call(message, "simpleCollapsedLayout"))
                $root.sync_pb.SimpleCollapsedLayout.encode(message.simpleCollapsedLayout, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.creationTimestampUsec != null && Object.hasOwnProperty.call(message, "creationTimestampUsec"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.creationTimestampUsec);
            if (message.defaultDestination != null && Object.hasOwnProperty.call(message, "defaultDestination"))
                $root.sync_pb.SyncedNotificationDestination.encode(message.defaultDestination, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.target != null && message.target.length)
                for (let i = 0; i < message.target.length; ++i)
                    $root.sync_pb.Target.encode(message.target[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.metaTag != null && message.metaTag.length)
                for (let i = 0; i < message.metaTag.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.metaTag[i]);
            return writer;
        };

        /**
         * Encodes the specified CollapsedInfo message, length delimited. Does not implicitly {@link sync_pb.CollapsedInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.CollapsedInfo
         * @static
         * @param {sync_pb.ICollapsedInfo} message CollapsedInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CollapsedInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CollapsedInfo message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.CollapsedInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.CollapsedInfo} CollapsedInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CollapsedInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.CollapsedInfo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.simpleCollapsedLayout = $root.sync_pb.SimpleCollapsedLayout.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.creationTimestampUsec = reader.uint64();
                    break;
                case 3:
                    message.defaultDestination = $root.sync_pb.SyncedNotificationDestination.decode(reader, reader.uint32());
                    break;
                case 4:
                    if (!(message.target && message.target.length))
                        message.target = [];
                    message.target.push($root.sync_pb.Target.decode(reader, reader.uint32()));
                    break;
                case 5:
                    if (!(message.metaTag && message.metaTag.length))
                        message.metaTag = [];
                    message.metaTag.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CollapsedInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.CollapsedInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.CollapsedInfo} CollapsedInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CollapsedInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CollapsedInfo message.
         * @function verify
         * @memberof sync_pb.CollapsedInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CollapsedInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.simpleCollapsedLayout != null && message.hasOwnProperty("simpleCollapsedLayout")) {
                let error = $root.sync_pb.SimpleCollapsedLayout.verify(message.simpleCollapsedLayout);
                if (error)
                    return "simpleCollapsedLayout." + error;
            }
            if (message.creationTimestampUsec != null && message.hasOwnProperty("creationTimestampUsec"))
                if (!$util.isInteger(message.creationTimestampUsec) && !(message.creationTimestampUsec && $util.isInteger(message.creationTimestampUsec.low) && $util.isInteger(message.creationTimestampUsec.high)))
                    return "creationTimestampUsec: integer|Long expected";
            if (message.defaultDestination != null && message.hasOwnProperty("defaultDestination")) {
                let error = $root.sync_pb.SyncedNotificationDestination.verify(message.defaultDestination);
                if (error)
                    return "defaultDestination." + error;
            }
            if (message.target != null && message.hasOwnProperty("target")) {
                if (!Array.isArray(message.target))
                    return "target: array expected";
                for (let i = 0; i < message.target.length; ++i) {
                    let error = $root.sync_pb.Target.verify(message.target[i]);
                    if (error)
                        return "target." + error;
                }
            }
            if (message.metaTag != null && message.hasOwnProperty("metaTag")) {
                if (!Array.isArray(message.metaTag))
                    return "metaTag: array expected";
                for (let i = 0; i < message.metaTag.length; ++i)
                    if (!$util.isString(message.metaTag[i]))
                        return "metaTag: string[] expected";
            }
            return null;
        };

        /**
         * Creates a CollapsedInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.CollapsedInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.CollapsedInfo} CollapsedInfo
         */
        CollapsedInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.CollapsedInfo)
                return object;
            let message = new $root.sync_pb.CollapsedInfo();
            if (object.simpleCollapsedLayout != null) {
                if (typeof object.simpleCollapsedLayout !== "object")
                    throw TypeError(".sync_pb.CollapsedInfo.simpleCollapsedLayout: object expected");
                message.simpleCollapsedLayout = $root.sync_pb.SimpleCollapsedLayout.fromObject(object.simpleCollapsedLayout);
            }
            if (object.creationTimestampUsec != null)
                if ($util.Long)
                    (message.creationTimestampUsec = $util.Long.fromValue(object.creationTimestampUsec)).unsigned = true;
                else if (typeof object.creationTimestampUsec === "string")
                    message.creationTimestampUsec = parseInt(object.creationTimestampUsec, 10);
                else if (typeof object.creationTimestampUsec === "number")
                    message.creationTimestampUsec = object.creationTimestampUsec;
                else if (typeof object.creationTimestampUsec === "object")
                    message.creationTimestampUsec = new $util.LongBits(object.creationTimestampUsec.low >>> 0, object.creationTimestampUsec.high >>> 0).toNumber(true);
            if (object.defaultDestination != null) {
                if (typeof object.defaultDestination !== "object")
                    throw TypeError(".sync_pb.CollapsedInfo.defaultDestination: object expected");
                message.defaultDestination = $root.sync_pb.SyncedNotificationDestination.fromObject(object.defaultDestination);
            }
            if (object.target) {
                if (!Array.isArray(object.target))
                    throw TypeError(".sync_pb.CollapsedInfo.target: array expected");
                message.target = [];
                for (let i = 0; i < object.target.length; ++i) {
                    if (typeof object.target[i] !== "object")
                        throw TypeError(".sync_pb.CollapsedInfo.target: object expected");
                    message.target[i] = $root.sync_pb.Target.fromObject(object.target[i]);
                }
            }
            if (object.metaTag) {
                if (!Array.isArray(object.metaTag))
                    throw TypeError(".sync_pb.CollapsedInfo.metaTag: array expected");
                message.metaTag = [];
                for (let i = 0; i < object.metaTag.length; ++i)
                    message.metaTag[i] = String(object.metaTag[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a CollapsedInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.CollapsedInfo
         * @static
         * @param {sync_pb.CollapsedInfo} message CollapsedInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CollapsedInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.target = [];
                object.metaTag = [];
            }
            if (options.defaults) {
                object.simpleCollapsedLayout = null;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationTimestampUsec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationTimestampUsec = options.longs === String ? "0" : 0;
                object.defaultDestination = null;
            }
            if (message.simpleCollapsedLayout != null && message.hasOwnProperty("simpleCollapsedLayout"))
                object.simpleCollapsedLayout = $root.sync_pb.SimpleCollapsedLayout.toObject(message.simpleCollapsedLayout, options);
            if (message.creationTimestampUsec != null && message.hasOwnProperty("creationTimestampUsec"))
                if (typeof message.creationTimestampUsec === "number")
                    object.creationTimestampUsec = options.longs === String ? String(message.creationTimestampUsec) : message.creationTimestampUsec;
                else
                    object.creationTimestampUsec = options.longs === String ? $util.Long.prototype.toString.call(message.creationTimestampUsec) : options.longs === Number ? new $util.LongBits(message.creationTimestampUsec.low >>> 0, message.creationTimestampUsec.high >>> 0).toNumber(true) : message.creationTimestampUsec;
            if (message.defaultDestination != null && message.hasOwnProperty("defaultDestination"))
                object.defaultDestination = $root.sync_pb.SyncedNotificationDestination.toObject(message.defaultDestination, options);
            if (message.target && message.target.length) {
                object.target = [];
                for (let j = 0; j < message.target.length; ++j)
                    object.target[j] = $root.sync_pb.Target.toObject(message.target[j], options);
            }
            if (message.metaTag && message.metaTag.length) {
                object.metaTag = [];
                for (let j = 0; j < message.metaTag.length; ++j)
                    object.metaTag[j] = message.metaTag[j];
            }
            return object;
        };

        /**
         * Converts this CollapsedInfo to JSON.
         * @function toJSON
         * @memberof sync_pb.CollapsedInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CollapsedInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CollapsedInfo;
    })();

    sync_pb.ExpandedInfo = (function() {

        /**
         * Properties of an ExpandedInfo.
         * @memberof sync_pb
         * @interface IExpandedInfo
         * @property {sync_pb.ISimpleExpandedLayout|null} [simpleExpandedLayout] ExpandedInfo simpleExpandedLayout
         * @property {Array.<sync_pb.ICollapsedInfo>|null} [collapsedInfo] ExpandedInfo collapsedInfo
         * @property {Array.<sync_pb.ITarget>|null} [target] ExpandedInfo target
         * @property {Array.<string>|null} [metaTag] ExpandedInfo metaTag
         */

        /**
         * Constructs a new ExpandedInfo.
         * @memberof sync_pb
         * @classdesc Represents an ExpandedInfo.
         * @implements IExpandedInfo
         * @constructor
         * @param {sync_pb.IExpandedInfo=} [properties] Properties to set
         */
        function ExpandedInfo(properties) {
            this.collapsedInfo = [];
            this.target = [];
            this.metaTag = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExpandedInfo simpleExpandedLayout.
         * @member {sync_pb.ISimpleExpandedLayout|null|undefined} simpleExpandedLayout
         * @memberof sync_pb.ExpandedInfo
         * @instance
         */
        ExpandedInfo.prototype.simpleExpandedLayout = null;

        /**
         * ExpandedInfo collapsedInfo.
         * @member {Array.<sync_pb.ICollapsedInfo>} collapsedInfo
         * @memberof sync_pb.ExpandedInfo
         * @instance
         */
        ExpandedInfo.prototype.collapsedInfo = $util.emptyArray;

        /**
         * ExpandedInfo target.
         * @member {Array.<sync_pb.ITarget>} target
         * @memberof sync_pb.ExpandedInfo
         * @instance
         */
        ExpandedInfo.prototype.target = $util.emptyArray;

        /**
         * ExpandedInfo metaTag.
         * @member {Array.<string>} metaTag
         * @memberof sync_pb.ExpandedInfo
         * @instance
         */
        ExpandedInfo.prototype.metaTag = $util.emptyArray;

        /**
         * Creates a new ExpandedInfo instance using the specified properties.
         * @function create
         * @memberof sync_pb.ExpandedInfo
         * @static
         * @param {sync_pb.IExpandedInfo=} [properties] Properties to set
         * @returns {sync_pb.ExpandedInfo} ExpandedInfo instance
         */
        ExpandedInfo.create = function create(properties) {
            return new ExpandedInfo(properties);
        };

        /**
         * Encodes the specified ExpandedInfo message. Does not implicitly {@link sync_pb.ExpandedInfo.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ExpandedInfo
         * @static
         * @param {sync_pb.IExpandedInfo} message ExpandedInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExpandedInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.simpleExpandedLayout != null && Object.hasOwnProperty.call(message, "simpleExpandedLayout"))
                $root.sync_pb.SimpleExpandedLayout.encode(message.simpleExpandedLayout, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.collapsedInfo != null && message.collapsedInfo.length)
                for (let i = 0; i < message.collapsedInfo.length; ++i)
                    $root.sync_pb.CollapsedInfo.encode(message.collapsedInfo[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.target != null && message.target.length)
                for (let i = 0; i < message.target.length; ++i)
                    $root.sync_pb.Target.encode(message.target[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.metaTag != null && message.metaTag.length)
                for (let i = 0; i < message.metaTag.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.metaTag[i]);
            return writer;
        };

        /**
         * Encodes the specified ExpandedInfo message, length delimited. Does not implicitly {@link sync_pb.ExpandedInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ExpandedInfo
         * @static
         * @param {sync_pb.IExpandedInfo} message ExpandedInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExpandedInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ExpandedInfo message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ExpandedInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ExpandedInfo} ExpandedInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExpandedInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ExpandedInfo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.simpleExpandedLayout = $root.sync_pb.SimpleExpandedLayout.decode(reader, reader.uint32());
                    break;
                case 2:
                    if (!(message.collapsedInfo && message.collapsedInfo.length))
                        message.collapsedInfo = [];
                    message.collapsedInfo.push($root.sync_pb.CollapsedInfo.decode(reader, reader.uint32()));
                    break;
                case 3:
                    if (!(message.target && message.target.length))
                        message.target = [];
                    message.target.push($root.sync_pb.Target.decode(reader, reader.uint32()));
                    break;
                case 4:
                    if (!(message.metaTag && message.metaTag.length))
                        message.metaTag = [];
                    message.metaTag.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ExpandedInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ExpandedInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ExpandedInfo} ExpandedInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExpandedInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ExpandedInfo message.
         * @function verify
         * @memberof sync_pb.ExpandedInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ExpandedInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.simpleExpandedLayout != null && message.hasOwnProperty("simpleExpandedLayout")) {
                let error = $root.sync_pb.SimpleExpandedLayout.verify(message.simpleExpandedLayout);
                if (error)
                    return "simpleExpandedLayout." + error;
            }
            if (message.collapsedInfo != null && message.hasOwnProperty("collapsedInfo")) {
                if (!Array.isArray(message.collapsedInfo))
                    return "collapsedInfo: array expected";
                for (let i = 0; i < message.collapsedInfo.length; ++i) {
                    let error = $root.sync_pb.CollapsedInfo.verify(message.collapsedInfo[i]);
                    if (error)
                        return "collapsedInfo." + error;
                }
            }
            if (message.target != null && message.hasOwnProperty("target")) {
                if (!Array.isArray(message.target))
                    return "target: array expected";
                for (let i = 0; i < message.target.length; ++i) {
                    let error = $root.sync_pb.Target.verify(message.target[i]);
                    if (error)
                        return "target." + error;
                }
            }
            if (message.metaTag != null && message.hasOwnProperty("metaTag")) {
                if (!Array.isArray(message.metaTag))
                    return "metaTag: array expected";
                for (let i = 0; i < message.metaTag.length; ++i)
                    if (!$util.isString(message.metaTag[i]))
                        return "metaTag: string[] expected";
            }
            return null;
        };

        /**
         * Creates an ExpandedInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ExpandedInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ExpandedInfo} ExpandedInfo
         */
        ExpandedInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ExpandedInfo)
                return object;
            let message = new $root.sync_pb.ExpandedInfo();
            if (object.simpleExpandedLayout != null) {
                if (typeof object.simpleExpandedLayout !== "object")
                    throw TypeError(".sync_pb.ExpandedInfo.simpleExpandedLayout: object expected");
                message.simpleExpandedLayout = $root.sync_pb.SimpleExpandedLayout.fromObject(object.simpleExpandedLayout);
            }
            if (object.collapsedInfo) {
                if (!Array.isArray(object.collapsedInfo))
                    throw TypeError(".sync_pb.ExpandedInfo.collapsedInfo: array expected");
                message.collapsedInfo = [];
                for (let i = 0; i < object.collapsedInfo.length; ++i) {
                    if (typeof object.collapsedInfo[i] !== "object")
                        throw TypeError(".sync_pb.ExpandedInfo.collapsedInfo: object expected");
                    message.collapsedInfo[i] = $root.sync_pb.CollapsedInfo.fromObject(object.collapsedInfo[i]);
                }
            }
            if (object.target) {
                if (!Array.isArray(object.target))
                    throw TypeError(".sync_pb.ExpandedInfo.target: array expected");
                message.target = [];
                for (let i = 0; i < object.target.length; ++i) {
                    if (typeof object.target[i] !== "object")
                        throw TypeError(".sync_pb.ExpandedInfo.target: object expected");
                    message.target[i] = $root.sync_pb.Target.fromObject(object.target[i]);
                }
            }
            if (object.metaTag) {
                if (!Array.isArray(object.metaTag))
                    throw TypeError(".sync_pb.ExpandedInfo.metaTag: array expected");
                message.metaTag = [];
                for (let i = 0; i < object.metaTag.length; ++i)
                    message.metaTag[i] = String(object.metaTag[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an ExpandedInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ExpandedInfo
         * @static
         * @param {sync_pb.ExpandedInfo} message ExpandedInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExpandedInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.collapsedInfo = [];
                object.target = [];
                object.metaTag = [];
            }
            if (options.defaults)
                object.simpleExpandedLayout = null;
            if (message.simpleExpandedLayout != null && message.hasOwnProperty("simpleExpandedLayout"))
                object.simpleExpandedLayout = $root.sync_pb.SimpleExpandedLayout.toObject(message.simpleExpandedLayout, options);
            if (message.collapsedInfo && message.collapsedInfo.length) {
                object.collapsedInfo = [];
                for (let j = 0; j < message.collapsedInfo.length; ++j)
                    object.collapsedInfo[j] = $root.sync_pb.CollapsedInfo.toObject(message.collapsedInfo[j], options);
            }
            if (message.target && message.target.length) {
                object.target = [];
                for (let j = 0; j < message.target.length; ++j)
                    object.target[j] = $root.sync_pb.Target.toObject(message.target[j], options);
            }
            if (message.metaTag && message.metaTag.length) {
                object.metaTag = [];
                for (let j = 0; j < message.metaTag.length; ++j)
                    object.metaTag[j] = message.metaTag[j];
            }
            return object;
        };

        /**
         * Converts this ExpandedInfo to JSON.
         * @function toJSON
         * @memberof sync_pb.ExpandedInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExpandedInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ExpandedInfo;
    })();

    sync_pb.SimpleCollapsedLayout = (function() {

        /**
         * Properties of a SimpleCollapsedLayout.
         * @memberof sync_pb
         * @interface ISimpleCollapsedLayout
         * @property {sync_pb.ISyncedNotificationImage|null} [appIcon] SimpleCollapsedLayout appIcon
         * @property {Array.<sync_pb.ISyncedNotificationProfileImage>|null} [profileImage] SimpleCollapsedLayout profileImage
         * @property {string|null} [heading] SimpleCollapsedLayout heading
         * @property {string|null} [description] SimpleCollapsedLayout description
         * @property {Array.<sync_pb.IMedia>|null} [media] SimpleCollapsedLayout media
         * @property {string|null} [annotation] SimpleCollapsedLayout annotation
         */

        /**
         * Constructs a new SimpleCollapsedLayout.
         * @memberof sync_pb
         * @classdesc Represents a SimpleCollapsedLayout.
         * @implements ISimpleCollapsedLayout
         * @constructor
         * @param {sync_pb.ISimpleCollapsedLayout=} [properties] Properties to set
         */
        function SimpleCollapsedLayout(properties) {
            this.profileImage = [];
            this.media = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SimpleCollapsedLayout appIcon.
         * @member {sync_pb.ISyncedNotificationImage|null|undefined} appIcon
         * @memberof sync_pb.SimpleCollapsedLayout
         * @instance
         */
        SimpleCollapsedLayout.prototype.appIcon = null;

        /**
         * SimpleCollapsedLayout profileImage.
         * @member {Array.<sync_pb.ISyncedNotificationProfileImage>} profileImage
         * @memberof sync_pb.SimpleCollapsedLayout
         * @instance
         */
        SimpleCollapsedLayout.prototype.profileImage = $util.emptyArray;

        /**
         * SimpleCollapsedLayout heading.
         * @member {string} heading
         * @memberof sync_pb.SimpleCollapsedLayout
         * @instance
         */
        SimpleCollapsedLayout.prototype.heading = "";

        /**
         * SimpleCollapsedLayout description.
         * @member {string} description
         * @memberof sync_pb.SimpleCollapsedLayout
         * @instance
         */
        SimpleCollapsedLayout.prototype.description = "";

        /**
         * SimpleCollapsedLayout media.
         * @member {Array.<sync_pb.IMedia>} media
         * @memberof sync_pb.SimpleCollapsedLayout
         * @instance
         */
        SimpleCollapsedLayout.prototype.media = $util.emptyArray;

        /**
         * SimpleCollapsedLayout annotation.
         * @member {string} annotation
         * @memberof sync_pb.SimpleCollapsedLayout
         * @instance
         */
        SimpleCollapsedLayout.prototype.annotation = "";

        /**
         * Creates a new SimpleCollapsedLayout instance using the specified properties.
         * @function create
         * @memberof sync_pb.SimpleCollapsedLayout
         * @static
         * @param {sync_pb.ISimpleCollapsedLayout=} [properties] Properties to set
         * @returns {sync_pb.SimpleCollapsedLayout} SimpleCollapsedLayout instance
         */
        SimpleCollapsedLayout.create = function create(properties) {
            return new SimpleCollapsedLayout(properties);
        };

        /**
         * Encodes the specified SimpleCollapsedLayout message. Does not implicitly {@link sync_pb.SimpleCollapsedLayout.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SimpleCollapsedLayout
         * @static
         * @param {sync_pb.ISimpleCollapsedLayout} message SimpleCollapsedLayout message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SimpleCollapsedLayout.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.appIcon != null && Object.hasOwnProperty.call(message, "appIcon"))
                $root.sync_pb.SyncedNotificationImage.encode(message.appIcon, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.profileImage != null && message.profileImage.length)
                for (let i = 0; i < message.profileImage.length; ++i)
                    $root.sync_pb.SyncedNotificationProfileImage.encode(message.profileImage[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.heading != null && Object.hasOwnProperty.call(message, "heading"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.heading);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.description);
            if (message.media != null && message.media.length)
                for (let i = 0; i < message.media.length; ++i)
                    $root.sync_pb.Media.encode(message.media[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.annotation != null && Object.hasOwnProperty.call(message, "annotation"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.annotation);
            return writer;
        };

        /**
         * Encodes the specified SimpleCollapsedLayout message, length delimited. Does not implicitly {@link sync_pb.SimpleCollapsedLayout.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SimpleCollapsedLayout
         * @static
         * @param {sync_pb.ISimpleCollapsedLayout} message SimpleCollapsedLayout message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SimpleCollapsedLayout.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SimpleCollapsedLayout message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SimpleCollapsedLayout
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SimpleCollapsedLayout} SimpleCollapsedLayout
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SimpleCollapsedLayout.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SimpleCollapsedLayout();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.appIcon = $root.sync_pb.SyncedNotificationImage.decode(reader, reader.uint32());
                    break;
                case 2:
                    if (!(message.profileImage && message.profileImage.length))
                        message.profileImage = [];
                    message.profileImage.push($root.sync_pb.SyncedNotificationProfileImage.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.heading = reader.string();
                    break;
                case 4:
                    message.description = reader.string();
                    break;
                case 5:
                    if (!(message.media && message.media.length))
                        message.media = [];
                    message.media.push($root.sync_pb.Media.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.annotation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SimpleCollapsedLayout message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SimpleCollapsedLayout
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SimpleCollapsedLayout} SimpleCollapsedLayout
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SimpleCollapsedLayout.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SimpleCollapsedLayout message.
         * @function verify
         * @memberof sync_pb.SimpleCollapsedLayout
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SimpleCollapsedLayout.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.appIcon != null && message.hasOwnProperty("appIcon")) {
                let error = $root.sync_pb.SyncedNotificationImage.verify(message.appIcon);
                if (error)
                    return "appIcon." + error;
            }
            if (message.profileImage != null && message.hasOwnProperty("profileImage")) {
                if (!Array.isArray(message.profileImage))
                    return "profileImage: array expected";
                for (let i = 0; i < message.profileImage.length; ++i) {
                    let error = $root.sync_pb.SyncedNotificationProfileImage.verify(message.profileImage[i]);
                    if (error)
                        return "profileImage." + error;
                }
            }
            if (message.heading != null && message.hasOwnProperty("heading"))
                if (!$util.isString(message.heading))
                    return "heading: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.media != null && message.hasOwnProperty("media")) {
                if (!Array.isArray(message.media))
                    return "media: array expected";
                for (let i = 0; i < message.media.length; ++i) {
                    let error = $root.sync_pb.Media.verify(message.media[i]);
                    if (error)
                        return "media." + error;
                }
            }
            if (message.annotation != null && message.hasOwnProperty("annotation"))
                if (!$util.isString(message.annotation))
                    return "annotation: string expected";
            return null;
        };

        /**
         * Creates a SimpleCollapsedLayout message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SimpleCollapsedLayout
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SimpleCollapsedLayout} SimpleCollapsedLayout
         */
        SimpleCollapsedLayout.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SimpleCollapsedLayout)
                return object;
            let message = new $root.sync_pb.SimpleCollapsedLayout();
            if (object.appIcon != null) {
                if (typeof object.appIcon !== "object")
                    throw TypeError(".sync_pb.SimpleCollapsedLayout.appIcon: object expected");
                message.appIcon = $root.sync_pb.SyncedNotificationImage.fromObject(object.appIcon);
            }
            if (object.profileImage) {
                if (!Array.isArray(object.profileImage))
                    throw TypeError(".sync_pb.SimpleCollapsedLayout.profileImage: array expected");
                message.profileImage = [];
                for (let i = 0; i < object.profileImage.length; ++i) {
                    if (typeof object.profileImage[i] !== "object")
                        throw TypeError(".sync_pb.SimpleCollapsedLayout.profileImage: object expected");
                    message.profileImage[i] = $root.sync_pb.SyncedNotificationProfileImage.fromObject(object.profileImage[i]);
                }
            }
            if (object.heading != null)
                message.heading = String(object.heading);
            if (object.description != null)
                message.description = String(object.description);
            if (object.media) {
                if (!Array.isArray(object.media))
                    throw TypeError(".sync_pb.SimpleCollapsedLayout.media: array expected");
                message.media = [];
                for (let i = 0; i < object.media.length; ++i) {
                    if (typeof object.media[i] !== "object")
                        throw TypeError(".sync_pb.SimpleCollapsedLayout.media: object expected");
                    message.media[i] = $root.sync_pb.Media.fromObject(object.media[i]);
                }
            }
            if (object.annotation != null)
                message.annotation = String(object.annotation);
            return message;
        };

        /**
         * Creates a plain object from a SimpleCollapsedLayout message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SimpleCollapsedLayout
         * @static
         * @param {sync_pb.SimpleCollapsedLayout} message SimpleCollapsedLayout
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SimpleCollapsedLayout.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.profileImage = [];
                object.media = [];
            }
            if (options.defaults) {
                object.appIcon = null;
                object.heading = "";
                object.description = "";
                object.annotation = "";
            }
            if (message.appIcon != null && message.hasOwnProperty("appIcon"))
                object.appIcon = $root.sync_pb.SyncedNotificationImage.toObject(message.appIcon, options);
            if (message.profileImage && message.profileImage.length) {
                object.profileImage = [];
                for (let j = 0; j < message.profileImage.length; ++j)
                    object.profileImage[j] = $root.sync_pb.SyncedNotificationProfileImage.toObject(message.profileImage[j], options);
            }
            if (message.heading != null && message.hasOwnProperty("heading"))
                object.heading = message.heading;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.media && message.media.length) {
                object.media = [];
                for (let j = 0; j < message.media.length; ++j)
                    object.media[j] = $root.sync_pb.Media.toObject(message.media[j], options);
            }
            if (message.annotation != null && message.hasOwnProperty("annotation"))
                object.annotation = message.annotation;
            return object;
        };

        /**
         * Converts this SimpleCollapsedLayout to JSON.
         * @function toJSON
         * @memberof sync_pb.SimpleCollapsedLayout
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SimpleCollapsedLayout.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SimpleCollapsedLayout;
    })();

    sync_pb.SimpleExpandedLayout = (function() {

        /**
         * Properties of a SimpleExpandedLayout.
         * @memberof sync_pb
         * @interface ISimpleExpandedLayout
         * @property {string|null} [title] SimpleExpandedLayout title
         * @property {string|null} [text] SimpleExpandedLayout text
         * @property {Array.<sync_pb.IMedia>|null} [media] SimpleExpandedLayout media
         * @property {sync_pb.ISyncedNotificationProfileImage|null} [profileImage] SimpleExpandedLayout profileImage
         * @property {Array.<sync_pb.ITarget>|null} [target] SimpleExpandedLayout target
         */

        /**
         * Constructs a new SimpleExpandedLayout.
         * @memberof sync_pb
         * @classdesc Represents a SimpleExpandedLayout.
         * @implements ISimpleExpandedLayout
         * @constructor
         * @param {sync_pb.ISimpleExpandedLayout=} [properties] Properties to set
         */
        function SimpleExpandedLayout(properties) {
            this.media = [];
            this.target = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SimpleExpandedLayout title.
         * @member {string} title
         * @memberof sync_pb.SimpleExpandedLayout
         * @instance
         */
        SimpleExpandedLayout.prototype.title = "";

        /**
         * SimpleExpandedLayout text.
         * @member {string} text
         * @memberof sync_pb.SimpleExpandedLayout
         * @instance
         */
        SimpleExpandedLayout.prototype.text = "";

        /**
         * SimpleExpandedLayout media.
         * @member {Array.<sync_pb.IMedia>} media
         * @memberof sync_pb.SimpleExpandedLayout
         * @instance
         */
        SimpleExpandedLayout.prototype.media = $util.emptyArray;

        /**
         * SimpleExpandedLayout profileImage.
         * @member {sync_pb.ISyncedNotificationProfileImage|null|undefined} profileImage
         * @memberof sync_pb.SimpleExpandedLayout
         * @instance
         */
        SimpleExpandedLayout.prototype.profileImage = null;

        /**
         * SimpleExpandedLayout target.
         * @member {Array.<sync_pb.ITarget>} target
         * @memberof sync_pb.SimpleExpandedLayout
         * @instance
         */
        SimpleExpandedLayout.prototype.target = $util.emptyArray;

        /**
         * Creates a new SimpleExpandedLayout instance using the specified properties.
         * @function create
         * @memberof sync_pb.SimpleExpandedLayout
         * @static
         * @param {sync_pb.ISimpleExpandedLayout=} [properties] Properties to set
         * @returns {sync_pb.SimpleExpandedLayout} SimpleExpandedLayout instance
         */
        SimpleExpandedLayout.create = function create(properties) {
            return new SimpleExpandedLayout(properties);
        };

        /**
         * Encodes the specified SimpleExpandedLayout message. Does not implicitly {@link sync_pb.SimpleExpandedLayout.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SimpleExpandedLayout
         * @static
         * @param {sync_pb.ISimpleExpandedLayout} message SimpleExpandedLayout message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SimpleExpandedLayout.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.title);
            if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.text);
            if (message.media != null && message.media.length)
                for (let i = 0; i < message.media.length; ++i)
                    $root.sync_pb.Media.encode(message.media[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.profileImage != null && Object.hasOwnProperty.call(message, "profileImage"))
                $root.sync_pb.SyncedNotificationProfileImage.encode(message.profileImage, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.target != null && message.target.length)
                for (let i = 0; i < message.target.length; ++i)
                    $root.sync_pb.Target.encode(message.target[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SimpleExpandedLayout message, length delimited. Does not implicitly {@link sync_pb.SimpleExpandedLayout.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SimpleExpandedLayout
         * @static
         * @param {sync_pb.ISimpleExpandedLayout} message SimpleExpandedLayout message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SimpleExpandedLayout.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SimpleExpandedLayout message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SimpleExpandedLayout
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SimpleExpandedLayout} SimpleExpandedLayout
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SimpleExpandedLayout.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SimpleExpandedLayout();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.text = reader.string();
                    break;
                case 3:
                    if (!(message.media && message.media.length))
                        message.media = [];
                    message.media.push($root.sync_pb.Media.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.profileImage = $root.sync_pb.SyncedNotificationProfileImage.decode(reader, reader.uint32());
                    break;
                case 5:
                    if (!(message.target && message.target.length))
                        message.target = [];
                    message.target.push($root.sync_pb.Target.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SimpleExpandedLayout message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SimpleExpandedLayout
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SimpleExpandedLayout} SimpleExpandedLayout
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SimpleExpandedLayout.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SimpleExpandedLayout message.
         * @function verify
         * @memberof sync_pb.SimpleExpandedLayout
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SimpleExpandedLayout.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.text != null && message.hasOwnProperty("text"))
                if (!$util.isString(message.text))
                    return "text: string expected";
            if (message.media != null && message.hasOwnProperty("media")) {
                if (!Array.isArray(message.media))
                    return "media: array expected";
                for (let i = 0; i < message.media.length; ++i) {
                    let error = $root.sync_pb.Media.verify(message.media[i]);
                    if (error)
                        return "media." + error;
                }
            }
            if (message.profileImage != null && message.hasOwnProperty("profileImage")) {
                let error = $root.sync_pb.SyncedNotificationProfileImage.verify(message.profileImage);
                if (error)
                    return "profileImage." + error;
            }
            if (message.target != null && message.hasOwnProperty("target")) {
                if (!Array.isArray(message.target))
                    return "target: array expected";
                for (let i = 0; i < message.target.length; ++i) {
                    let error = $root.sync_pb.Target.verify(message.target[i]);
                    if (error)
                        return "target." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SimpleExpandedLayout message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SimpleExpandedLayout
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SimpleExpandedLayout} SimpleExpandedLayout
         */
        SimpleExpandedLayout.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SimpleExpandedLayout)
                return object;
            let message = new $root.sync_pb.SimpleExpandedLayout();
            if (object.title != null)
                message.title = String(object.title);
            if (object.text != null)
                message.text = String(object.text);
            if (object.media) {
                if (!Array.isArray(object.media))
                    throw TypeError(".sync_pb.SimpleExpandedLayout.media: array expected");
                message.media = [];
                for (let i = 0; i < object.media.length; ++i) {
                    if (typeof object.media[i] !== "object")
                        throw TypeError(".sync_pb.SimpleExpandedLayout.media: object expected");
                    message.media[i] = $root.sync_pb.Media.fromObject(object.media[i]);
                }
            }
            if (object.profileImage != null) {
                if (typeof object.profileImage !== "object")
                    throw TypeError(".sync_pb.SimpleExpandedLayout.profileImage: object expected");
                message.profileImage = $root.sync_pb.SyncedNotificationProfileImage.fromObject(object.profileImage);
            }
            if (object.target) {
                if (!Array.isArray(object.target))
                    throw TypeError(".sync_pb.SimpleExpandedLayout.target: array expected");
                message.target = [];
                for (let i = 0; i < object.target.length; ++i) {
                    if (typeof object.target[i] !== "object")
                        throw TypeError(".sync_pb.SimpleExpandedLayout.target: object expected");
                    message.target[i] = $root.sync_pb.Target.fromObject(object.target[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SimpleExpandedLayout message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SimpleExpandedLayout
         * @static
         * @param {sync_pb.SimpleExpandedLayout} message SimpleExpandedLayout
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SimpleExpandedLayout.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.media = [];
                object.target = [];
            }
            if (options.defaults) {
                object.title = "";
                object.text = "";
                object.profileImage = null;
            }
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.text != null && message.hasOwnProperty("text"))
                object.text = message.text;
            if (message.media && message.media.length) {
                object.media = [];
                for (let j = 0; j < message.media.length; ++j)
                    object.media[j] = $root.sync_pb.Media.toObject(message.media[j], options);
            }
            if (message.profileImage != null && message.hasOwnProperty("profileImage"))
                object.profileImage = $root.sync_pb.SyncedNotificationProfileImage.toObject(message.profileImage, options);
            if (message.target && message.target.length) {
                object.target = [];
                for (let j = 0; j < message.target.length; ++j)
                    object.target[j] = $root.sync_pb.Target.toObject(message.target[j], options);
            }
            return object;
        };

        /**
         * Converts this SimpleExpandedLayout to JSON.
         * @function toJSON
         * @memberof sync_pb.SimpleExpandedLayout
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SimpleExpandedLayout.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SimpleExpandedLayout;
    })();

    sync_pb.Media = (function() {

        /**
         * Properties of a Media.
         * @memberof sync_pb
         * @interface IMedia
         * @property {sync_pb.ISyncedNotificationImage|null} [image] Media image
         */

        /**
         * Constructs a new Media.
         * @memberof sync_pb
         * @classdesc Represents a Media.
         * @implements IMedia
         * @constructor
         * @param {sync_pb.IMedia=} [properties] Properties to set
         */
        function Media(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Media image.
         * @member {sync_pb.ISyncedNotificationImage|null|undefined} image
         * @memberof sync_pb.Media
         * @instance
         */
        Media.prototype.image = null;

        /**
         * Creates a new Media instance using the specified properties.
         * @function create
         * @memberof sync_pb.Media
         * @static
         * @param {sync_pb.IMedia=} [properties] Properties to set
         * @returns {sync_pb.Media} Media instance
         */
        Media.create = function create(properties) {
            return new Media(properties);
        };

        /**
         * Encodes the specified Media message. Does not implicitly {@link sync_pb.Media.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.Media
         * @static
         * @param {sync_pb.IMedia} message Media message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Media.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                $root.sync_pb.SyncedNotificationImage.encode(message.image, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Media message, length delimited. Does not implicitly {@link sync_pb.Media.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.Media
         * @static
         * @param {sync_pb.IMedia} message Media message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Media.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Media message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.Media
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.Media} Media
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Media.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.Media();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.image = $root.sync_pb.SyncedNotificationImage.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Media message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.Media
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.Media} Media
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Media.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Media message.
         * @function verify
         * @memberof sync_pb.Media
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Media.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.image != null && message.hasOwnProperty("image")) {
                let error = $root.sync_pb.SyncedNotificationImage.verify(message.image);
                if (error)
                    return "image." + error;
            }
            return null;
        };

        /**
         * Creates a Media message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.Media
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.Media} Media
         */
        Media.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.Media)
                return object;
            let message = new $root.sync_pb.Media();
            if (object.image != null) {
                if (typeof object.image !== "object")
                    throw TypeError(".sync_pb.Media.image: object expected");
                message.image = $root.sync_pb.SyncedNotificationImage.fromObject(object.image);
            }
            return message;
        };

        /**
         * Creates a plain object from a Media message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.Media
         * @static
         * @param {sync_pb.Media} message Media
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Media.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.image = null;
            if (message.image != null && message.hasOwnProperty("image"))
                object.image = $root.sync_pb.SyncedNotificationImage.toObject(message.image, options);
            return object;
        };

        /**
         * Converts this Media to JSON.
         * @function toJSON
         * @memberof sync_pb.Media
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Media.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Media;
    })();

    sync_pb.Target = (function() {

        /**
         * Properties of a Target.
         * @memberof sync_pb
         * @interface ITarget
         * @property {sync_pb.ISyncedNotificationDestination|null} [destination] Target destination
         * @property {sync_pb.ISyncedNotificationAction|null} [action] Target action
         * @property {string|null} [targetKey] Target targetKey
         */

        /**
         * Constructs a new Target.
         * @memberof sync_pb
         * @classdesc Represents a Target.
         * @implements ITarget
         * @constructor
         * @param {sync_pb.ITarget=} [properties] Properties to set
         */
        function Target(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Target destination.
         * @member {sync_pb.ISyncedNotificationDestination|null|undefined} destination
         * @memberof sync_pb.Target
         * @instance
         */
        Target.prototype.destination = null;

        /**
         * Target action.
         * @member {sync_pb.ISyncedNotificationAction|null|undefined} action
         * @memberof sync_pb.Target
         * @instance
         */
        Target.prototype.action = null;

        /**
         * Target targetKey.
         * @member {string} targetKey
         * @memberof sync_pb.Target
         * @instance
         */
        Target.prototype.targetKey = "";

        /**
         * Creates a new Target instance using the specified properties.
         * @function create
         * @memberof sync_pb.Target
         * @static
         * @param {sync_pb.ITarget=} [properties] Properties to set
         * @returns {sync_pb.Target} Target instance
         */
        Target.create = function create(properties) {
            return new Target(properties);
        };

        /**
         * Encodes the specified Target message. Does not implicitly {@link sync_pb.Target.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.Target
         * @static
         * @param {sync_pb.ITarget} message Target message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Target.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.destination != null && Object.hasOwnProperty.call(message, "destination"))
                $root.sync_pb.SyncedNotificationDestination.encode(message.destination, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.action != null && Object.hasOwnProperty.call(message, "action"))
                $root.sync_pb.SyncedNotificationAction.encode(message.action, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.targetKey != null && Object.hasOwnProperty.call(message, "targetKey"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.targetKey);
            return writer;
        };

        /**
         * Encodes the specified Target message, length delimited. Does not implicitly {@link sync_pb.Target.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.Target
         * @static
         * @param {sync_pb.ITarget} message Target message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Target.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Target message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.Target
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.Target} Target
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Target.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.Target();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.destination = $root.sync_pb.SyncedNotificationDestination.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.action = $root.sync_pb.SyncedNotificationAction.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.targetKey = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Target message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.Target
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.Target} Target
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Target.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Target message.
         * @function verify
         * @memberof sync_pb.Target
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Target.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.destination != null && message.hasOwnProperty("destination")) {
                let error = $root.sync_pb.SyncedNotificationDestination.verify(message.destination);
                if (error)
                    return "destination." + error;
            }
            if (message.action != null && message.hasOwnProperty("action")) {
                let error = $root.sync_pb.SyncedNotificationAction.verify(message.action);
                if (error)
                    return "action." + error;
            }
            if (message.targetKey != null && message.hasOwnProperty("targetKey"))
                if (!$util.isString(message.targetKey))
                    return "targetKey: string expected";
            return null;
        };

        /**
         * Creates a Target message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.Target
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.Target} Target
         */
        Target.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.Target)
                return object;
            let message = new $root.sync_pb.Target();
            if (object.destination != null) {
                if (typeof object.destination !== "object")
                    throw TypeError(".sync_pb.Target.destination: object expected");
                message.destination = $root.sync_pb.SyncedNotificationDestination.fromObject(object.destination);
            }
            if (object.action != null) {
                if (typeof object.action !== "object")
                    throw TypeError(".sync_pb.Target.action: object expected");
                message.action = $root.sync_pb.SyncedNotificationAction.fromObject(object.action);
            }
            if (object.targetKey != null)
                message.targetKey = String(object.targetKey);
            return message;
        };

        /**
         * Creates a plain object from a Target message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.Target
         * @static
         * @param {sync_pb.Target} message Target
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Target.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.destination = null;
                object.action = null;
                object.targetKey = "";
            }
            if (message.destination != null && message.hasOwnProperty("destination"))
                object.destination = $root.sync_pb.SyncedNotificationDestination.toObject(message.destination, options);
            if (message.action != null && message.hasOwnProperty("action"))
                object.action = $root.sync_pb.SyncedNotificationAction.toObject(message.action, options);
            if (message.targetKey != null && message.hasOwnProperty("targetKey"))
                object.targetKey = message.targetKey;
            return object;
        };

        /**
         * Converts this Target to JSON.
         * @function toJSON
         * @memberof sync_pb.Target
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Target.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Target;
    })();

    sync_pb.SyncedNotificationDestination = (function() {

        /**
         * Properties of a SyncedNotificationDestination.
         * @memberof sync_pb
         * @interface ISyncedNotificationDestination
         * @property {string|null} [text] SyncedNotificationDestination text
         * @property {sync_pb.ISyncedNotificationImage|null} [icon] SyncedNotificationDestination icon
         * @property {string|null} [url] SyncedNotificationDestination url
         * @property {string|null} [accessibilityLabel] SyncedNotificationDestination accessibilityLabel
         */

        /**
         * Constructs a new SyncedNotificationDestination.
         * @memberof sync_pb
         * @classdesc Represents a SyncedNotificationDestination.
         * @implements ISyncedNotificationDestination
         * @constructor
         * @param {sync_pb.ISyncedNotificationDestination=} [properties] Properties to set
         */
        function SyncedNotificationDestination(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncedNotificationDestination text.
         * @member {string} text
         * @memberof sync_pb.SyncedNotificationDestination
         * @instance
         */
        SyncedNotificationDestination.prototype.text = "";

        /**
         * SyncedNotificationDestination icon.
         * @member {sync_pb.ISyncedNotificationImage|null|undefined} icon
         * @memberof sync_pb.SyncedNotificationDestination
         * @instance
         */
        SyncedNotificationDestination.prototype.icon = null;

        /**
         * SyncedNotificationDestination url.
         * @member {string} url
         * @memberof sync_pb.SyncedNotificationDestination
         * @instance
         */
        SyncedNotificationDestination.prototype.url = "";

        /**
         * SyncedNotificationDestination accessibilityLabel.
         * @member {string} accessibilityLabel
         * @memberof sync_pb.SyncedNotificationDestination
         * @instance
         */
        SyncedNotificationDestination.prototype.accessibilityLabel = "";

        /**
         * Creates a new SyncedNotificationDestination instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncedNotificationDestination
         * @static
         * @param {sync_pb.ISyncedNotificationDestination=} [properties] Properties to set
         * @returns {sync_pb.SyncedNotificationDestination} SyncedNotificationDestination instance
         */
        SyncedNotificationDestination.create = function create(properties) {
            return new SyncedNotificationDestination(properties);
        };

        /**
         * Encodes the specified SyncedNotificationDestination message. Does not implicitly {@link sync_pb.SyncedNotificationDestination.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncedNotificationDestination
         * @static
         * @param {sync_pb.ISyncedNotificationDestination} message SyncedNotificationDestination message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationDestination.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.text);
            if (message.icon != null && Object.hasOwnProperty.call(message, "icon"))
                $root.sync_pb.SyncedNotificationImage.encode(message.icon, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.url);
            if (message.accessibilityLabel != null && Object.hasOwnProperty.call(message, "accessibilityLabel"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.accessibilityLabel);
            return writer;
        };

        /**
         * Encodes the specified SyncedNotificationDestination message, length delimited. Does not implicitly {@link sync_pb.SyncedNotificationDestination.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncedNotificationDestination
         * @static
         * @param {sync_pb.ISyncedNotificationDestination} message SyncedNotificationDestination message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationDestination.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncedNotificationDestination message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncedNotificationDestination
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncedNotificationDestination} SyncedNotificationDestination
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationDestination.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncedNotificationDestination();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.text = reader.string();
                    break;
                case 2:
                    message.icon = $root.sync_pb.SyncedNotificationImage.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.url = reader.string();
                    break;
                case 4:
                    message.accessibilityLabel = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncedNotificationDestination message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncedNotificationDestination
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncedNotificationDestination} SyncedNotificationDestination
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationDestination.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncedNotificationDestination message.
         * @function verify
         * @memberof sync_pb.SyncedNotificationDestination
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncedNotificationDestination.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.text != null && message.hasOwnProperty("text"))
                if (!$util.isString(message.text))
                    return "text: string expected";
            if (message.icon != null && message.hasOwnProperty("icon")) {
                let error = $root.sync_pb.SyncedNotificationImage.verify(message.icon);
                if (error)
                    return "icon." + error;
            }
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            if (message.accessibilityLabel != null && message.hasOwnProperty("accessibilityLabel"))
                if (!$util.isString(message.accessibilityLabel))
                    return "accessibilityLabel: string expected";
            return null;
        };

        /**
         * Creates a SyncedNotificationDestination message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncedNotificationDestination
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncedNotificationDestination} SyncedNotificationDestination
         */
        SyncedNotificationDestination.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncedNotificationDestination)
                return object;
            let message = new $root.sync_pb.SyncedNotificationDestination();
            if (object.text != null)
                message.text = String(object.text);
            if (object.icon != null) {
                if (typeof object.icon !== "object")
                    throw TypeError(".sync_pb.SyncedNotificationDestination.icon: object expected");
                message.icon = $root.sync_pb.SyncedNotificationImage.fromObject(object.icon);
            }
            if (object.url != null)
                message.url = String(object.url);
            if (object.accessibilityLabel != null)
                message.accessibilityLabel = String(object.accessibilityLabel);
            return message;
        };

        /**
         * Creates a plain object from a SyncedNotificationDestination message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncedNotificationDestination
         * @static
         * @param {sync_pb.SyncedNotificationDestination} message SyncedNotificationDestination
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncedNotificationDestination.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.text = "";
                object.icon = null;
                object.url = "";
                object.accessibilityLabel = "";
            }
            if (message.text != null && message.hasOwnProperty("text"))
                object.text = message.text;
            if (message.icon != null && message.hasOwnProperty("icon"))
                object.icon = $root.sync_pb.SyncedNotificationImage.toObject(message.icon, options);
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            if (message.accessibilityLabel != null && message.hasOwnProperty("accessibilityLabel"))
                object.accessibilityLabel = message.accessibilityLabel;
            return object;
        };

        /**
         * Converts this SyncedNotificationDestination to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncedNotificationDestination
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncedNotificationDestination.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncedNotificationDestination;
    })();

    sync_pb.SyncedNotificationAction = (function() {

        /**
         * Properties of a SyncedNotificationAction.
         * @memberof sync_pb
         * @interface ISyncedNotificationAction
         * @property {string|null} [text] SyncedNotificationAction text
         * @property {sync_pb.ISyncedNotificationImage|null} [icon] SyncedNotificationAction icon
         * @property {string|null} [url] SyncedNotificationAction url
         * @property {string|null} [requestData] SyncedNotificationAction requestData
         * @property {string|null} [accessibilityLabel] SyncedNotificationAction accessibilityLabel
         * @property {Array.<string>|null} [metaTag] SyncedNotificationAction metaTag
         */

        /**
         * Constructs a new SyncedNotificationAction.
         * @memberof sync_pb
         * @classdesc Represents a SyncedNotificationAction.
         * @implements ISyncedNotificationAction
         * @constructor
         * @param {sync_pb.ISyncedNotificationAction=} [properties] Properties to set
         */
        function SyncedNotificationAction(properties) {
            this.metaTag = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncedNotificationAction text.
         * @member {string} text
         * @memberof sync_pb.SyncedNotificationAction
         * @instance
         */
        SyncedNotificationAction.prototype.text = "";

        /**
         * SyncedNotificationAction icon.
         * @member {sync_pb.ISyncedNotificationImage|null|undefined} icon
         * @memberof sync_pb.SyncedNotificationAction
         * @instance
         */
        SyncedNotificationAction.prototype.icon = null;

        /**
         * SyncedNotificationAction url.
         * @member {string} url
         * @memberof sync_pb.SyncedNotificationAction
         * @instance
         */
        SyncedNotificationAction.prototype.url = "";

        /**
         * SyncedNotificationAction requestData.
         * @member {string} requestData
         * @memberof sync_pb.SyncedNotificationAction
         * @instance
         */
        SyncedNotificationAction.prototype.requestData = "";

        /**
         * SyncedNotificationAction accessibilityLabel.
         * @member {string} accessibilityLabel
         * @memberof sync_pb.SyncedNotificationAction
         * @instance
         */
        SyncedNotificationAction.prototype.accessibilityLabel = "";

        /**
         * SyncedNotificationAction metaTag.
         * @member {Array.<string>} metaTag
         * @memberof sync_pb.SyncedNotificationAction
         * @instance
         */
        SyncedNotificationAction.prototype.metaTag = $util.emptyArray;

        /**
         * Creates a new SyncedNotificationAction instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncedNotificationAction
         * @static
         * @param {sync_pb.ISyncedNotificationAction=} [properties] Properties to set
         * @returns {sync_pb.SyncedNotificationAction} SyncedNotificationAction instance
         */
        SyncedNotificationAction.create = function create(properties) {
            return new SyncedNotificationAction(properties);
        };

        /**
         * Encodes the specified SyncedNotificationAction message. Does not implicitly {@link sync_pb.SyncedNotificationAction.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncedNotificationAction
         * @static
         * @param {sync_pb.ISyncedNotificationAction} message SyncedNotificationAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationAction.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.text);
            if (message.icon != null && Object.hasOwnProperty.call(message, "icon"))
                $root.sync_pb.SyncedNotificationImage.encode(message.icon, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.url);
            if (message.requestData != null && Object.hasOwnProperty.call(message, "requestData"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.requestData);
            if (message.accessibilityLabel != null && Object.hasOwnProperty.call(message, "accessibilityLabel"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.accessibilityLabel);
            if (message.metaTag != null && message.metaTag.length)
                for (let i = 0; i < message.metaTag.length; ++i)
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.metaTag[i]);
            return writer;
        };

        /**
         * Encodes the specified SyncedNotificationAction message, length delimited. Does not implicitly {@link sync_pb.SyncedNotificationAction.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncedNotificationAction
         * @static
         * @param {sync_pb.ISyncedNotificationAction} message SyncedNotificationAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationAction.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncedNotificationAction message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncedNotificationAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncedNotificationAction} SyncedNotificationAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationAction.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncedNotificationAction();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.text = reader.string();
                    break;
                case 2:
                    message.icon = $root.sync_pb.SyncedNotificationImage.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.url = reader.string();
                    break;
                case 4:
                    message.requestData = reader.string();
                    break;
                case 5:
                    message.accessibilityLabel = reader.string();
                    break;
                case 6:
                    if (!(message.metaTag && message.metaTag.length))
                        message.metaTag = [];
                    message.metaTag.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncedNotificationAction message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncedNotificationAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncedNotificationAction} SyncedNotificationAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationAction.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncedNotificationAction message.
         * @function verify
         * @memberof sync_pb.SyncedNotificationAction
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncedNotificationAction.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.text != null && message.hasOwnProperty("text"))
                if (!$util.isString(message.text))
                    return "text: string expected";
            if (message.icon != null && message.hasOwnProperty("icon")) {
                let error = $root.sync_pb.SyncedNotificationImage.verify(message.icon);
                if (error)
                    return "icon." + error;
            }
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            if (message.requestData != null && message.hasOwnProperty("requestData"))
                if (!$util.isString(message.requestData))
                    return "requestData: string expected";
            if (message.accessibilityLabel != null && message.hasOwnProperty("accessibilityLabel"))
                if (!$util.isString(message.accessibilityLabel))
                    return "accessibilityLabel: string expected";
            if (message.metaTag != null && message.hasOwnProperty("metaTag")) {
                if (!Array.isArray(message.metaTag))
                    return "metaTag: array expected";
                for (let i = 0; i < message.metaTag.length; ++i)
                    if (!$util.isString(message.metaTag[i]))
                        return "metaTag: string[] expected";
            }
            return null;
        };

        /**
         * Creates a SyncedNotificationAction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncedNotificationAction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncedNotificationAction} SyncedNotificationAction
         */
        SyncedNotificationAction.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncedNotificationAction)
                return object;
            let message = new $root.sync_pb.SyncedNotificationAction();
            if (object.text != null)
                message.text = String(object.text);
            if (object.icon != null) {
                if (typeof object.icon !== "object")
                    throw TypeError(".sync_pb.SyncedNotificationAction.icon: object expected");
                message.icon = $root.sync_pb.SyncedNotificationImage.fromObject(object.icon);
            }
            if (object.url != null)
                message.url = String(object.url);
            if (object.requestData != null)
                message.requestData = String(object.requestData);
            if (object.accessibilityLabel != null)
                message.accessibilityLabel = String(object.accessibilityLabel);
            if (object.metaTag) {
                if (!Array.isArray(object.metaTag))
                    throw TypeError(".sync_pb.SyncedNotificationAction.metaTag: array expected");
                message.metaTag = [];
                for (let i = 0; i < object.metaTag.length; ++i)
                    message.metaTag[i] = String(object.metaTag[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a SyncedNotificationAction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncedNotificationAction
         * @static
         * @param {sync_pb.SyncedNotificationAction} message SyncedNotificationAction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncedNotificationAction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.metaTag = [];
            if (options.defaults) {
                object.text = "";
                object.icon = null;
                object.url = "";
                object.requestData = "";
                object.accessibilityLabel = "";
            }
            if (message.text != null && message.hasOwnProperty("text"))
                object.text = message.text;
            if (message.icon != null && message.hasOwnProperty("icon"))
                object.icon = $root.sync_pb.SyncedNotificationImage.toObject(message.icon, options);
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            if (message.requestData != null && message.hasOwnProperty("requestData"))
                object.requestData = message.requestData;
            if (message.accessibilityLabel != null && message.hasOwnProperty("accessibilityLabel"))
                object.accessibilityLabel = message.accessibilityLabel;
            if (message.metaTag && message.metaTag.length) {
                object.metaTag = [];
                for (let j = 0; j < message.metaTag.length; ++j)
                    object.metaTag[j] = message.metaTag[j];
            }
            return object;
        };

        /**
         * Converts this SyncedNotificationAction to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncedNotificationAction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncedNotificationAction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncedNotificationAction;
    })();

    sync_pb.SyncedNotificationImage = (function() {

        /**
         * Properties of a SyncedNotificationImage.
         * @memberof sync_pb
         * @interface ISyncedNotificationImage
         * @property {string|null} [url] SyncedNotificationImage url
         * @property {string|null} [altText] SyncedNotificationImage altText
         * @property {number|null} [preferredWidth] SyncedNotificationImage preferredWidth
         * @property {number|null} [preferredHeight] SyncedNotificationImage preferredHeight
         */

        /**
         * Constructs a new SyncedNotificationImage.
         * @memberof sync_pb
         * @classdesc Represents a SyncedNotificationImage.
         * @implements ISyncedNotificationImage
         * @constructor
         * @param {sync_pb.ISyncedNotificationImage=} [properties] Properties to set
         */
        function SyncedNotificationImage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncedNotificationImage url.
         * @member {string} url
         * @memberof sync_pb.SyncedNotificationImage
         * @instance
         */
        SyncedNotificationImage.prototype.url = "";

        /**
         * SyncedNotificationImage altText.
         * @member {string} altText
         * @memberof sync_pb.SyncedNotificationImage
         * @instance
         */
        SyncedNotificationImage.prototype.altText = "";

        /**
         * SyncedNotificationImage preferredWidth.
         * @member {number} preferredWidth
         * @memberof sync_pb.SyncedNotificationImage
         * @instance
         */
        SyncedNotificationImage.prototype.preferredWidth = 0;

        /**
         * SyncedNotificationImage preferredHeight.
         * @member {number} preferredHeight
         * @memberof sync_pb.SyncedNotificationImage
         * @instance
         */
        SyncedNotificationImage.prototype.preferredHeight = 0;

        /**
         * Creates a new SyncedNotificationImage instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncedNotificationImage
         * @static
         * @param {sync_pb.ISyncedNotificationImage=} [properties] Properties to set
         * @returns {sync_pb.SyncedNotificationImage} SyncedNotificationImage instance
         */
        SyncedNotificationImage.create = function create(properties) {
            return new SyncedNotificationImage(properties);
        };

        /**
         * Encodes the specified SyncedNotificationImage message. Does not implicitly {@link sync_pb.SyncedNotificationImage.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncedNotificationImage
         * @static
         * @param {sync_pb.ISyncedNotificationImage} message SyncedNotificationImage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationImage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.url);
            if (message.altText != null && Object.hasOwnProperty.call(message, "altText"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.altText);
            if (message.preferredWidth != null && Object.hasOwnProperty.call(message, "preferredWidth"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.preferredWidth);
            if (message.preferredHeight != null && Object.hasOwnProperty.call(message, "preferredHeight"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.preferredHeight);
            return writer;
        };

        /**
         * Encodes the specified SyncedNotificationImage message, length delimited. Does not implicitly {@link sync_pb.SyncedNotificationImage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncedNotificationImage
         * @static
         * @param {sync_pb.ISyncedNotificationImage} message SyncedNotificationImage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationImage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncedNotificationImage message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncedNotificationImage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncedNotificationImage} SyncedNotificationImage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationImage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncedNotificationImage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.url = reader.string();
                    break;
                case 2:
                    message.altText = reader.string();
                    break;
                case 3:
                    message.preferredWidth = reader.int32();
                    break;
                case 4:
                    message.preferredHeight = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncedNotificationImage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncedNotificationImage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncedNotificationImage} SyncedNotificationImage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationImage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncedNotificationImage message.
         * @function verify
         * @memberof sync_pb.SyncedNotificationImage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncedNotificationImage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            if (message.altText != null && message.hasOwnProperty("altText"))
                if (!$util.isString(message.altText))
                    return "altText: string expected";
            if (message.preferredWidth != null && message.hasOwnProperty("preferredWidth"))
                if (!$util.isInteger(message.preferredWidth))
                    return "preferredWidth: integer expected";
            if (message.preferredHeight != null && message.hasOwnProperty("preferredHeight"))
                if (!$util.isInteger(message.preferredHeight))
                    return "preferredHeight: integer expected";
            return null;
        };

        /**
         * Creates a SyncedNotificationImage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncedNotificationImage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncedNotificationImage} SyncedNotificationImage
         */
        SyncedNotificationImage.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncedNotificationImage)
                return object;
            let message = new $root.sync_pb.SyncedNotificationImage();
            if (object.url != null)
                message.url = String(object.url);
            if (object.altText != null)
                message.altText = String(object.altText);
            if (object.preferredWidth != null)
                message.preferredWidth = object.preferredWidth | 0;
            if (object.preferredHeight != null)
                message.preferredHeight = object.preferredHeight | 0;
            return message;
        };

        /**
         * Creates a plain object from a SyncedNotificationImage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncedNotificationImage
         * @static
         * @param {sync_pb.SyncedNotificationImage} message SyncedNotificationImage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncedNotificationImage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.url = "";
                object.altText = "";
                object.preferredWidth = 0;
                object.preferredHeight = 0;
            }
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            if (message.altText != null && message.hasOwnProperty("altText"))
                object.altText = message.altText;
            if (message.preferredWidth != null && message.hasOwnProperty("preferredWidth"))
                object.preferredWidth = message.preferredWidth;
            if (message.preferredHeight != null && message.hasOwnProperty("preferredHeight"))
                object.preferredHeight = message.preferredHeight;
            return object;
        };

        /**
         * Converts this SyncedNotificationImage to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncedNotificationImage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncedNotificationImage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncedNotificationImage;
    })();

    sync_pb.SyncedNotificationProfileImage = (function() {

        /**
         * Properties of a SyncedNotificationProfileImage.
         * @memberof sync_pb
         * @interface ISyncedNotificationProfileImage
         * @property {string|null} [imageUrl] SyncedNotificationProfileImage imageUrl
         * @property {string|null} [oid] SyncedNotificationProfileImage oid
         * @property {string|null} [displayName] SyncedNotificationProfileImage displayName
         */

        /**
         * Constructs a new SyncedNotificationProfileImage.
         * @memberof sync_pb
         * @classdesc Represents a SyncedNotificationProfileImage.
         * @implements ISyncedNotificationProfileImage
         * @constructor
         * @param {sync_pb.ISyncedNotificationProfileImage=} [properties] Properties to set
         */
        function SyncedNotificationProfileImage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncedNotificationProfileImage imageUrl.
         * @member {string} imageUrl
         * @memberof sync_pb.SyncedNotificationProfileImage
         * @instance
         */
        SyncedNotificationProfileImage.prototype.imageUrl = "";

        /**
         * SyncedNotificationProfileImage oid.
         * @member {string} oid
         * @memberof sync_pb.SyncedNotificationProfileImage
         * @instance
         */
        SyncedNotificationProfileImage.prototype.oid = "";

        /**
         * SyncedNotificationProfileImage displayName.
         * @member {string} displayName
         * @memberof sync_pb.SyncedNotificationProfileImage
         * @instance
         */
        SyncedNotificationProfileImage.prototype.displayName = "";

        /**
         * Creates a new SyncedNotificationProfileImage instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncedNotificationProfileImage
         * @static
         * @param {sync_pb.ISyncedNotificationProfileImage=} [properties] Properties to set
         * @returns {sync_pb.SyncedNotificationProfileImage} SyncedNotificationProfileImage instance
         */
        SyncedNotificationProfileImage.create = function create(properties) {
            return new SyncedNotificationProfileImage(properties);
        };

        /**
         * Encodes the specified SyncedNotificationProfileImage message. Does not implicitly {@link sync_pb.SyncedNotificationProfileImage.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncedNotificationProfileImage
         * @static
         * @param {sync_pb.ISyncedNotificationProfileImage} message SyncedNotificationProfileImage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationProfileImage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.imageUrl);
            if (message.oid != null && Object.hasOwnProperty.call(message, "oid"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.oid);
            if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.displayName);
            return writer;
        };

        /**
         * Encodes the specified SyncedNotificationProfileImage message, length delimited. Does not implicitly {@link sync_pb.SyncedNotificationProfileImage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncedNotificationProfileImage
         * @static
         * @param {sync_pb.ISyncedNotificationProfileImage} message SyncedNotificationProfileImage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationProfileImage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncedNotificationProfileImage message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncedNotificationProfileImage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncedNotificationProfileImage} SyncedNotificationProfileImage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationProfileImage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncedNotificationProfileImage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.imageUrl = reader.string();
                    break;
                case 2:
                    message.oid = reader.string();
                    break;
                case 3:
                    message.displayName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncedNotificationProfileImage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncedNotificationProfileImage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncedNotificationProfileImage} SyncedNotificationProfileImage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationProfileImage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncedNotificationProfileImage message.
         * @function verify
         * @memberof sync_pb.SyncedNotificationProfileImage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncedNotificationProfileImage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                if (!$util.isString(message.imageUrl))
                    return "imageUrl: string expected";
            if (message.oid != null && message.hasOwnProperty("oid"))
                if (!$util.isString(message.oid))
                    return "oid: string expected";
            if (message.displayName != null && message.hasOwnProperty("displayName"))
                if (!$util.isString(message.displayName))
                    return "displayName: string expected";
            return null;
        };

        /**
         * Creates a SyncedNotificationProfileImage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncedNotificationProfileImage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncedNotificationProfileImage} SyncedNotificationProfileImage
         */
        SyncedNotificationProfileImage.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncedNotificationProfileImage)
                return object;
            let message = new $root.sync_pb.SyncedNotificationProfileImage();
            if (object.imageUrl != null)
                message.imageUrl = String(object.imageUrl);
            if (object.oid != null)
                message.oid = String(object.oid);
            if (object.displayName != null)
                message.displayName = String(object.displayName);
            return message;
        };

        /**
         * Creates a plain object from a SyncedNotificationProfileImage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncedNotificationProfileImage
         * @static
         * @param {sync_pb.SyncedNotificationProfileImage} message SyncedNotificationProfileImage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncedNotificationProfileImage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.imageUrl = "";
                object.oid = "";
                object.displayName = "";
            }
            if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                object.imageUrl = message.imageUrl;
            if (message.oid != null && message.hasOwnProperty("oid"))
                object.oid = message.oid;
            if (message.displayName != null && message.hasOwnProperty("displayName"))
                object.displayName = message.displayName;
            return object;
        };

        /**
         * Converts this SyncedNotificationProfileImage to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncedNotificationProfileImage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncedNotificationProfileImage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncedNotificationProfileImage;
    })();

    sync_pb.PasswordSpecificsData = (function() {

        /**
         * Properties of a PasswordSpecificsData.
         * @memberof sync_pb
         * @interface IPasswordSpecificsData
         * @property {number|null} [scheme] PasswordSpecificsData scheme
         * @property {string|null} [signonRealm] PasswordSpecificsData signonRealm
         * @property {string|null} [origin] PasswordSpecificsData origin
         * @property {string|null} [action] PasswordSpecificsData action
         * @property {string|null} [usernameElement] PasswordSpecificsData usernameElement
         * @property {string|null} [usernameValue] PasswordSpecificsData usernameValue
         * @property {string|null} [passwordElement] PasswordSpecificsData passwordElement
         * @property {string|null} [passwordValue] PasswordSpecificsData passwordValue
         * @property {boolean|null} [sslValid] PasswordSpecificsData sslValid
         * @property {boolean|null} [preferred] PasswordSpecificsData preferred
         * @property {number|Long|null} [dateCreated] PasswordSpecificsData dateCreated
         * @property {boolean|null} [blacklisted] PasswordSpecificsData blacklisted
         * @property {number|null} [type] PasswordSpecificsData type
         * @property {number|null} [timesUsed] PasswordSpecificsData timesUsed
         * @property {string|null} [displayName] PasswordSpecificsData displayName
         * @property {string|null} [avatarUrl] PasswordSpecificsData avatarUrl
         * @property {string|null} [federationUrl] PasswordSpecificsData federationUrl
         * @property {number|Long|null} [dateLastUsed] PasswordSpecificsData dateLastUsed
         */

        /**
         * Constructs a new PasswordSpecificsData.
         * @memberof sync_pb
         * @classdesc Represents a PasswordSpecificsData.
         * @implements IPasswordSpecificsData
         * @constructor
         * @param {sync_pb.IPasswordSpecificsData=} [properties] Properties to set
         */
        function PasswordSpecificsData(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PasswordSpecificsData scheme.
         * @member {number} scheme
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.scheme = 0;

        /**
         * PasswordSpecificsData signonRealm.
         * @member {string} signonRealm
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.signonRealm = "";

        /**
         * PasswordSpecificsData origin.
         * @member {string} origin
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.origin = "";

        /**
         * PasswordSpecificsData action.
         * @member {string} action
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.action = "";

        /**
         * PasswordSpecificsData usernameElement.
         * @member {string} usernameElement
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.usernameElement = "";

        /**
         * PasswordSpecificsData usernameValue.
         * @member {string} usernameValue
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.usernameValue = "";

        /**
         * PasswordSpecificsData passwordElement.
         * @member {string} passwordElement
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.passwordElement = "";

        /**
         * PasswordSpecificsData passwordValue.
         * @member {string} passwordValue
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.passwordValue = "";

        /**
         * PasswordSpecificsData sslValid.
         * @member {boolean} sslValid
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.sslValid = false;

        /**
         * PasswordSpecificsData preferred.
         * @member {boolean} preferred
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.preferred = false;

        /**
         * PasswordSpecificsData dateCreated.
         * @member {number|Long} dateCreated
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.dateCreated = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * PasswordSpecificsData blacklisted.
         * @member {boolean} blacklisted
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.blacklisted = false;

        /**
         * PasswordSpecificsData type.
         * @member {number} type
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.type = 0;

        /**
         * PasswordSpecificsData timesUsed.
         * @member {number} timesUsed
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.timesUsed = 0;

        /**
         * PasswordSpecificsData displayName.
         * @member {string} displayName
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.displayName = "";

        /**
         * PasswordSpecificsData avatarUrl.
         * @member {string} avatarUrl
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.avatarUrl = "";

        /**
         * PasswordSpecificsData federationUrl.
         * @member {string} federationUrl
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.federationUrl = "";

        /**
         * PasswordSpecificsData dateLastUsed.
         * @member {number|Long} dateLastUsed
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         */
        PasswordSpecificsData.prototype.dateLastUsed = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new PasswordSpecificsData instance using the specified properties.
         * @function create
         * @memberof sync_pb.PasswordSpecificsData
         * @static
         * @param {sync_pb.IPasswordSpecificsData=} [properties] Properties to set
         * @returns {sync_pb.PasswordSpecificsData} PasswordSpecificsData instance
         */
        PasswordSpecificsData.create = function create(properties) {
            return new PasswordSpecificsData(properties);
        };

        /**
         * Encodes the specified PasswordSpecificsData message. Does not implicitly {@link sync_pb.PasswordSpecificsData.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.PasswordSpecificsData
         * @static
         * @param {sync_pb.IPasswordSpecificsData} message PasswordSpecificsData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PasswordSpecificsData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.scheme != null && Object.hasOwnProperty.call(message, "scheme"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.scheme);
            if (message.signonRealm != null && Object.hasOwnProperty.call(message, "signonRealm"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.signonRealm);
            if (message.origin != null && Object.hasOwnProperty.call(message, "origin"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.origin);
            if (message.action != null && Object.hasOwnProperty.call(message, "action"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.action);
            if (message.usernameElement != null && Object.hasOwnProperty.call(message, "usernameElement"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.usernameElement);
            if (message.usernameValue != null && Object.hasOwnProperty.call(message, "usernameValue"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.usernameValue);
            if (message.passwordElement != null && Object.hasOwnProperty.call(message, "passwordElement"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.passwordElement);
            if (message.passwordValue != null && Object.hasOwnProperty.call(message, "passwordValue"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.passwordValue);
            if (message.sslValid != null && Object.hasOwnProperty.call(message, "sslValid"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.sslValid);
            if (message.preferred != null && Object.hasOwnProperty.call(message, "preferred"))
                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.preferred);
            if (message.dateCreated != null && Object.hasOwnProperty.call(message, "dateCreated"))
                writer.uint32(/* id 11, wireType 0 =*/88).int64(message.dateCreated);
            if (message.blacklisted != null && Object.hasOwnProperty.call(message, "blacklisted"))
                writer.uint32(/* id 12, wireType 0 =*/96).bool(message.blacklisted);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.type);
            if (message.timesUsed != null && Object.hasOwnProperty.call(message, "timesUsed"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.timesUsed);
            if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.displayName);
            if (message.avatarUrl != null && Object.hasOwnProperty.call(message, "avatarUrl"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.avatarUrl);
            if (message.federationUrl != null && Object.hasOwnProperty.call(message, "federationUrl"))
                writer.uint32(/* id 17, wireType 2 =*/138).string(message.federationUrl);
            if (message.dateLastUsed != null && Object.hasOwnProperty.call(message, "dateLastUsed"))
                writer.uint32(/* id 18, wireType 0 =*/144).int64(message.dateLastUsed);
            return writer;
        };

        /**
         * Encodes the specified PasswordSpecificsData message, length delimited. Does not implicitly {@link sync_pb.PasswordSpecificsData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.PasswordSpecificsData
         * @static
         * @param {sync_pb.IPasswordSpecificsData} message PasswordSpecificsData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PasswordSpecificsData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PasswordSpecificsData message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.PasswordSpecificsData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.PasswordSpecificsData} PasswordSpecificsData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PasswordSpecificsData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.PasswordSpecificsData();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.scheme = reader.int32();
                    break;
                case 2:
                    message.signonRealm = reader.string();
                    break;
                case 3:
                    message.origin = reader.string();
                    break;
                case 4:
                    message.action = reader.string();
                    break;
                case 5:
                    message.usernameElement = reader.string();
                    break;
                case 6:
                    message.usernameValue = reader.string();
                    break;
                case 7:
                    message.passwordElement = reader.string();
                    break;
                case 8:
                    message.passwordValue = reader.string();
                    break;
                case 9:
                    message.sslValid = reader.bool();
                    break;
                case 10:
                    message.preferred = reader.bool();
                    break;
                case 11:
                    message.dateCreated = reader.int64();
                    break;
                case 12:
                    message.blacklisted = reader.bool();
                    break;
                case 13:
                    message.type = reader.int32();
                    break;
                case 14:
                    message.timesUsed = reader.int32();
                    break;
                case 15:
                    message.displayName = reader.string();
                    break;
                case 16:
                    message.avatarUrl = reader.string();
                    break;
                case 17:
                    message.federationUrl = reader.string();
                    break;
                case 18:
                    message.dateLastUsed = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PasswordSpecificsData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.PasswordSpecificsData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.PasswordSpecificsData} PasswordSpecificsData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PasswordSpecificsData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PasswordSpecificsData message.
         * @function verify
         * @memberof sync_pb.PasswordSpecificsData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PasswordSpecificsData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.scheme != null && message.hasOwnProperty("scheme"))
                if (!$util.isInteger(message.scheme))
                    return "scheme: integer expected";
            if (message.signonRealm != null && message.hasOwnProperty("signonRealm"))
                if (!$util.isString(message.signonRealm))
                    return "signonRealm: string expected";
            if (message.origin != null && message.hasOwnProperty("origin"))
                if (!$util.isString(message.origin))
                    return "origin: string expected";
            if (message.action != null && message.hasOwnProperty("action"))
                if (!$util.isString(message.action))
                    return "action: string expected";
            if (message.usernameElement != null && message.hasOwnProperty("usernameElement"))
                if (!$util.isString(message.usernameElement))
                    return "usernameElement: string expected";
            if (message.usernameValue != null && message.hasOwnProperty("usernameValue"))
                if (!$util.isString(message.usernameValue))
                    return "usernameValue: string expected";
            if (message.passwordElement != null && message.hasOwnProperty("passwordElement"))
                if (!$util.isString(message.passwordElement))
                    return "passwordElement: string expected";
            if (message.passwordValue != null && message.hasOwnProperty("passwordValue"))
                if (!$util.isString(message.passwordValue))
                    return "passwordValue: string expected";
            if (message.sslValid != null && message.hasOwnProperty("sslValid"))
                if (typeof message.sslValid !== "boolean")
                    return "sslValid: boolean expected";
            if (message.preferred != null && message.hasOwnProperty("preferred"))
                if (typeof message.preferred !== "boolean")
                    return "preferred: boolean expected";
            if (message.dateCreated != null && message.hasOwnProperty("dateCreated"))
                if (!$util.isInteger(message.dateCreated) && !(message.dateCreated && $util.isInteger(message.dateCreated.low) && $util.isInteger(message.dateCreated.high)))
                    return "dateCreated: integer|Long expected";
            if (message.blacklisted != null && message.hasOwnProperty("blacklisted"))
                if (typeof message.blacklisted !== "boolean")
                    return "blacklisted: boolean expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isInteger(message.type))
                    return "type: integer expected";
            if (message.timesUsed != null && message.hasOwnProperty("timesUsed"))
                if (!$util.isInteger(message.timesUsed))
                    return "timesUsed: integer expected";
            if (message.displayName != null && message.hasOwnProperty("displayName"))
                if (!$util.isString(message.displayName))
                    return "displayName: string expected";
            if (message.avatarUrl != null && message.hasOwnProperty("avatarUrl"))
                if (!$util.isString(message.avatarUrl))
                    return "avatarUrl: string expected";
            if (message.federationUrl != null && message.hasOwnProperty("federationUrl"))
                if (!$util.isString(message.federationUrl))
                    return "federationUrl: string expected";
            if (message.dateLastUsed != null && message.hasOwnProperty("dateLastUsed"))
                if (!$util.isInteger(message.dateLastUsed) && !(message.dateLastUsed && $util.isInteger(message.dateLastUsed.low) && $util.isInteger(message.dateLastUsed.high)))
                    return "dateLastUsed: integer|Long expected";
            return null;
        };

        /**
         * Creates a PasswordSpecificsData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.PasswordSpecificsData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.PasswordSpecificsData} PasswordSpecificsData
         */
        PasswordSpecificsData.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.PasswordSpecificsData)
                return object;
            let message = new $root.sync_pb.PasswordSpecificsData();
            if (object.scheme != null)
                message.scheme = object.scheme | 0;
            if (object.signonRealm != null)
                message.signonRealm = String(object.signonRealm);
            if (object.origin != null)
                message.origin = String(object.origin);
            if (object.action != null)
                message.action = String(object.action);
            if (object.usernameElement != null)
                message.usernameElement = String(object.usernameElement);
            if (object.usernameValue != null)
                message.usernameValue = String(object.usernameValue);
            if (object.passwordElement != null)
                message.passwordElement = String(object.passwordElement);
            if (object.passwordValue != null)
                message.passwordValue = String(object.passwordValue);
            if (object.sslValid != null)
                message.sslValid = Boolean(object.sslValid);
            if (object.preferred != null)
                message.preferred = Boolean(object.preferred);
            if (object.dateCreated != null)
                if ($util.Long)
                    (message.dateCreated = $util.Long.fromValue(object.dateCreated)).unsigned = false;
                else if (typeof object.dateCreated === "string")
                    message.dateCreated = parseInt(object.dateCreated, 10);
                else if (typeof object.dateCreated === "number")
                    message.dateCreated = object.dateCreated;
                else if (typeof object.dateCreated === "object")
                    message.dateCreated = new $util.LongBits(object.dateCreated.low >>> 0, object.dateCreated.high >>> 0).toNumber();
            if (object.blacklisted != null)
                message.blacklisted = Boolean(object.blacklisted);
            if (object.type != null)
                message.type = object.type | 0;
            if (object.timesUsed != null)
                message.timesUsed = object.timesUsed | 0;
            if (object.displayName != null)
                message.displayName = String(object.displayName);
            if (object.avatarUrl != null)
                message.avatarUrl = String(object.avatarUrl);
            if (object.federationUrl != null)
                message.federationUrl = String(object.federationUrl);
            if (object.dateLastUsed != null)
                if ($util.Long)
                    (message.dateLastUsed = $util.Long.fromValue(object.dateLastUsed)).unsigned = false;
                else if (typeof object.dateLastUsed === "string")
                    message.dateLastUsed = parseInt(object.dateLastUsed, 10);
                else if (typeof object.dateLastUsed === "number")
                    message.dateLastUsed = object.dateLastUsed;
                else if (typeof object.dateLastUsed === "object")
                    message.dateLastUsed = new $util.LongBits(object.dateLastUsed.low >>> 0, object.dateLastUsed.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a PasswordSpecificsData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.PasswordSpecificsData
         * @static
         * @param {sync_pb.PasswordSpecificsData} message PasswordSpecificsData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PasswordSpecificsData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.scheme = 0;
                object.signonRealm = "";
                object.origin = "";
                object.action = "";
                object.usernameElement = "";
                object.usernameValue = "";
                object.passwordElement = "";
                object.passwordValue = "";
                object.sslValid = false;
                object.preferred = false;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.dateCreated = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.dateCreated = options.longs === String ? "0" : 0;
                object.blacklisted = false;
                object.type = 0;
                object.timesUsed = 0;
                object.displayName = "";
                object.avatarUrl = "";
                object.federationUrl = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.dateLastUsed = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.dateLastUsed = options.longs === String ? "0" : 0;
            }
            if (message.scheme != null && message.hasOwnProperty("scheme"))
                object.scheme = message.scheme;
            if (message.signonRealm != null && message.hasOwnProperty("signonRealm"))
                object.signonRealm = message.signonRealm;
            if (message.origin != null && message.hasOwnProperty("origin"))
                object.origin = message.origin;
            if (message.action != null && message.hasOwnProperty("action"))
                object.action = message.action;
            if (message.usernameElement != null && message.hasOwnProperty("usernameElement"))
                object.usernameElement = message.usernameElement;
            if (message.usernameValue != null && message.hasOwnProperty("usernameValue"))
                object.usernameValue = message.usernameValue;
            if (message.passwordElement != null && message.hasOwnProperty("passwordElement"))
                object.passwordElement = message.passwordElement;
            if (message.passwordValue != null && message.hasOwnProperty("passwordValue"))
                object.passwordValue = message.passwordValue;
            if (message.sslValid != null && message.hasOwnProperty("sslValid"))
                object.sslValid = message.sslValid;
            if (message.preferred != null && message.hasOwnProperty("preferred"))
                object.preferred = message.preferred;
            if (message.dateCreated != null && message.hasOwnProperty("dateCreated"))
                if (typeof message.dateCreated === "number")
                    object.dateCreated = options.longs === String ? String(message.dateCreated) : message.dateCreated;
                else
                    object.dateCreated = options.longs === String ? $util.Long.prototype.toString.call(message.dateCreated) : options.longs === Number ? new $util.LongBits(message.dateCreated.low >>> 0, message.dateCreated.high >>> 0).toNumber() : message.dateCreated;
            if (message.blacklisted != null && message.hasOwnProperty("blacklisted"))
                object.blacklisted = message.blacklisted;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.timesUsed != null && message.hasOwnProperty("timesUsed"))
                object.timesUsed = message.timesUsed;
            if (message.displayName != null && message.hasOwnProperty("displayName"))
                object.displayName = message.displayName;
            if (message.avatarUrl != null && message.hasOwnProperty("avatarUrl"))
                object.avatarUrl = message.avatarUrl;
            if (message.federationUrl != null && message.hasOwnProperty("federationUrl"))
                object.federationUrl = message.federationUrl;
            if (message.dateLastUsed != null && message.hasOwnProperty("dateLastUsed"))
                if (typeof message.dateLastUsed === "number")
                    object.dateLastUsed = options.longs === String ? String(message.dateLastUsed) : message.dateLastUsed;
                else
                    object.dateLastUsed = options.longs === String ? $util.Long.prototype.toString.call(message.dateLastUsed) : options.longs === Number ? new $util.LongBits(message.dateLastUsed.low >>> 0, message.dateLastUsed.high >>> 0).toNumber() : message.dateLastUsed;
            return object;
        };

        /**
         * Converts this PasswordSpecificsData to JSON.
         * @function toJSON
         * @memberof sync_pb.PasswordSpecificsData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PasswordSpecificsData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PasswordSpecificsData;
    })();

    sync_pb.PasswordSpecificsMetadata = (function() {

        /**
         * Properties of a PasswordSpecificsMetadata.
         * @memberof sync_pb
         * @interface IPasswordSpecificsMetadata
         * @property {string|null} [url] PasswordSpecificsMetadata url
         * @property {boolean|null} [blacklisted] PasswordSpecificsMetadata blacklisted
         */

        /**
         * Constructs a new PasswordSpecificsMetadata.
         * @memberof sync_pb
         * @classdesc Represents a PasswordSpecificsMetadata.
         * @implements IPasswordSpecificsMetadata
         * @constructor
         * @param {sync_pb.IPasswordSpecificsMetadata=} [properties] Properties to set
         */
        function PasswordSpecificsMetadata(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PasswordSpecificsMetadata url.
         * @member {string} url
         * @memberof sync_pb.PasswordSpecificsMetadata
         * @instance
         */
        PasswordSpecificsMetadata.prototype.url = "";

        /**
         * PasswordSpecificsMetadata blacklisted.
         * @member {boolean} blacklisted
         * @memberof sync_pb.PasswordSpecificsMetadata
         * @instance
         */
        PasswordSpecificsMetadata.prototype.blacklisted = false;

        /**
         * Creates a new PasswordSpecificsMetadata instance using the specified properties.
         * @function create
         * @memberof sync_pb.PasswordSpecificsMetadata
         * @static
         * @param {sync_pb.IPasswordSpecificsMetadata=} [properties] Properties to set
         * @returns {sync_pb.PasswordSpecificsMetadata} PasswordSpecificsMetadata instance
         */
        PasswordSpecificsMetadata.create = function create(properties) {
            return new PasswordSpecificsMetadata(properties);
        };

        /**
         * Encodes the specified PasswordSpecificsMetadata message. Does not implicitly {@link sync_pb.PasswordSpecificsMetadata.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.PasswordSpecificsMetadata
         * @static
         * @param {sync_pb.IPasswordSpecificsMetadata} message PasswordSpecificsMetadata message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PasswordSpecificsMetadata.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.url);
            if (message.blacklisted != null && Object.hasOwnProperty.call(message, "blacklisted"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.blacklisted);
            return writer;
        };

        /**
         * Encodes the specified PasswordSpecificsMetadata message, length delimited. Does not implicitly {@link sync_pb.PasswordSpecificsMetadata.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.PasswordSpecificsMetadata
         * @static
         * @param {sync_pb.IPasswordSpecificsMetadata} message PasswordSpecificsMetadata message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PasswordSpecificsMetadata.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PasswordSpecificsMetadata message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.PasswordSpecificsMetadata
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.PasswordSpecificsMetadata} PasswordSpecificsMetadata
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PasswordSpecificsMetadata.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.PasswordSpecificsMetadata();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.url = reader.string();
                    break;
                case 2:
                    message.blacklisted = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PasswordSpecificsMetadata message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.PasswordSpecificsMetadata
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.PasswordSpecificsMetadata} PasswordSpecificsMetadata
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PasswordSpecificsMetadata.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PasswordSpecificsMetadata message.
         * @function verify
         * @memberof sync_pb.PasswordSpecificsMetadata
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PasswordSpecificsMetadata.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            if (message.blacklisted != null && message.hasOwnProperty("blacklisted"))
                if (typeof message.blacklisted !== "boolean")
                    return "blacklisted: boolean expected";
            return null;
        };

        /**
         * Creates a PasswordSpecificsMetadata message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.PasswordSpecificsMetadata
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.PasswordSpecificsMetadata} PasswordSpecificsMetadata
         */
        PasswordSpecificsMetadata.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.PasswordSpecificsMetadata)
                return object;
            let message = new $root.sync_pb.PasswordSpecificsMetadata();
            if (object.url != null)
                message.url = String(object.url);
            if (object.blacklisted != null)
                message.blacklisted = Boolean(object.blacklisted);
            return message;
        };

        /**
         * Creates a plain object from a PasswordSpecificsMetadata message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.PasswordSpecificsMetadata
         * @static
         * @param {sync_pb.PasswordSpecificsMetadata} message PasswordSpecificsMetadata
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PasswordSpecificsMetadata.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.url = "";
                object.blacklisted = false;
            }
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            if (message.blacklisted != null && message.hasOwnProperty("blacklisted"))
                object.blacklisted = message.blacklisted;
            return object;
        };

        /**
         * Converts this PasswordSpecificsMetadata to JSON.
         * @function toJSON
         * @memberof sync_pb.PasswordSpecificsMetadata
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PasswordSpecificsMetadata.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PasswordSpecificsMetadata;
    })();

    sync_pb.PasswordSpecifics = (function() {

        /**
         * Properties of a PasswordSpecifics.
         * @memberof sync_pb
         * @interface IPasswordSpecifics
         * @property {sync_pb.IEncryptedData|null} [encrypted] PasswordSpecifics encrypted
         * @property {sync_pb.IPasswordSpecificsData|null} [clientOnlyEncryptedData] PasswordSpecifics clientOnlyEncryptedData
         * @property {sync_pb.IPasswordSpecificsMetadata|null} [unencryptedMetadata] PasswordSpecifics unencryptedMetadata
         */

        /**
         * Constructs a new PasswordSpecifics.
         * @memberof sync_pb
         * @classdesc Represents a PasswordSpecifics.
         * @implements IPasswordSpecifics
         * @constructor
         * @param {sync_pb.IPasswordSpecifics=} [properties] Properties to set
         */
        function PasswordSpecifics(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PasswordSpecifics encrypted.
         * @member {sync_pb.IEncryptedData|null|undefined} encrypted
         * @memberof sync_pb.PasswordSpecifics
         * @instance
         */
        PasswordSpecifics.prototype.encrypted = null;

        /**
         * PasswordSpecifics clientOnlyEncryptedData.
         * @member {sync_pb.IPasswordSpecificsData|null|undefined} clientOnlyEncryptedData
         * @memberof sync_pb.PasswordSpecifics
         * @instance
         */
        PasswordSpecifics.prototype.clientOnlyEncryptedData = null;

        /**
         * PasswordSpecifics unencryptedMetadata.
         * @member {sync_pb.IPasswordSpecificsMetadata|null|undefined} unencryptedMetadata
         * @memberof sync_pb.PasswordSpecifics
         * @instance
         */
        PasswordSpecifics.prototype.unencryptedMetadata = null;

        /**
         * Creates a new PasswordSpecifics instance using the specified properties.
         * @function create
         * @memberof sync_pb.PasswordSpecifics
         * @static
         * @param {sync_pb.IPasswordSpecifics=} [properties] Properties to set
         * @returns {sync_pb.PasswordSpecifics} PasswordSpecifics instance
         */
        PasswordSpecifics.create = function create(properties) {
            return new PasswordSpecifics(properties);
        };

        /**
         * Encodes the specified PasswordSpecifics message. Does not implicitly {@link sync_pb.PasswordSpecifics.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.PasswordSpecifics
         * @static
         * @param {sync_pb.IPasswordSpecifics} message PasswordSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PasswordSpecifics.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.encrypted != null && Object.hasOwnProperty.call(message, "encrypted"))
                $root.sync_pb.EncryptedData.encode(message.encrypted, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.clientOnlyEncryptedData != null && Object.hasOwnProperty.call(message, "clientOnlyEncryptedData"))
                $root.sync_pb.PasswordSpecificsData.encode(message.clientOnlyEncryptedData, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.unencryptedMetadata != null && Object.hasOwnProperty.call(message, "unencryptedMetadata"))
                $root.sync_pb.PasswordSpecificsMetadata.encode(message.unencryptedMetadata, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PasswordSpecifics message, length delimited. Does not implicitly {@link sync_pb.PasswordSpecifics.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.PasswordSpecifics
         * @static
         * @param {sync_pb.IPasswordSpecifics} message PasswordSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PasswordSpecifics.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PasswordSpecifics message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.PasswordSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.PasswordSpecifics} PasswordSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PasswordSpecifics.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.PasswordSpecifics();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.encrypted = $root.sync_pb.EncryptedData.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientOnlyEncryptedData = $root.sync_pb.PasswordSpecificsData.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.unencryptedMetadata = $root.sync_pb.PasswordSpecificsMetadata.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PasswordSpecifics message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.PasswordSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.PasswordSpecifics} PasswordSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PasswordSpecifics.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PasswordSpecifics message.
         * @function verify
         * @memberof sync_pb.PasswordSpecifics
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PasswordSpecifics.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.encrypted != null && message.hasOwnProperty("encrypted")) {
                let error = $root.sync_pb.EncryptedData.verify(message.encrypted);
                if (error)
                    return "encrypted." + error;
            }
            if (message.clientOnlyEncryptedData != null && message.hasOwnProperty("clientOnlyEncryptedData")) {
                let error = $root.sync_pb.PasswordSpecificsData.verify(message.clientOnlyEncryptedData);
                if (error)
                    return "clientOnlyEncryptedData." + error;
            }
            if (message.unencryptedMetadata != null && message.hasOwnProperty("unencryptedMetadata")) {
                let error = $root.sync_pb.PasswordSpecificsMetadata.verify(message.unencryptedMetadata);
                if (error)
                    return "unencryptedMetadata." + error;
            }
            return null;
        };

        /**
         * Creates a PasswordSpecifics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.PasswordSpecifics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.PasswordSpecifics} PasswordSpecifics
         */
        PasswordSpecifics.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.PasswordSpecifics)
                return object;
            let message = new $root.sync_pb.PasswordSpecifics();
            if (object.encrypted != null) {
                if (typeof object.encrypted !== "object")
                    throw TypeError(".sync_pb.PasswordSpecifics.encrypted: object expected");
                message.encrypted = $root.sync_pb.EncryptedData.fromObject(object.encrypted);
            }
            if (object.clientOnlyEncryptedData != null) {
                if (typeof object.clientOnlyEncryptedData !== "object")
                    throw TypeError(".sync_pb.PasswordSpecifics.clientOnlyEncryptedData: object expected");
                message.clientOnlyEncryptedData = $root.sync_pb.PasswordSpecificsData.fromObject(object.clientOnlyEncryptedData);
            }
            if (object.unencryptedMetadata != null) {
                if (typeof object.unencryptedMetadata !== "object")
                    throw TypeError(".sync_pb.PasswordSpecifics.unencryptedMetadata: object expected");
                message.unencryptedMetadata = $root.sync_pb.PasswordSpecificsMetadata.fromObject(object.unencryptedMetadata);
            }
            return message;
        };

        /**
         * Creates a plain object from a PasswordSpecifics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.PasswordSpecifics
         * @static
         * @param {sync_pb.PasswordSpecifics} message PasswordSpecifics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PasswordSpecifics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.encrypted = null;
                object.clientOnlyEncryptedData = null;
                object.unencryptedMetadata = null;
            }
            if (message.encrypted != null && message.hasOwnProperty("encrypted"))
                object.encrypted = $root.sync_pb.EncryptedData.toObject(message.encrypted, options);
            if (message.clientOnlyEncryptedData != null && message.hasOwnProperty("clientOnlyEncryptedData"))
                object.clientOnlyEncryptedData = $root.sync_pb.PasswordSpecificsData.toObject(message.clientOnlyEncryptedData, options);
            if (message.unencryptedMetadata != null && message.hasOwnProperty("unencryptedMetadata"))
                object.unencryptedMetadata = $root.sync_pb.PasswordSpecificsMetadata.toObject(message.unencryptedMetadata, options);
            return object;
        };

        /**
         * Converts this PasswordSpecifics to JSON.
         * @function toJSON
         * @memberof sync_pb.PasswordSpecifics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PasswordSpecifics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PasswordSpecifics;
    })();

    sync_pb.UniquePosition = (function() {

        /**
         * Properties of an UniquePosition.
         * @memberof sync_pb
         * @interface IUniquePosition
         * @property {Uint8Array|null} [value] UniquePosition value
         * @property {Uint8Array|null} [compressedValue] UniquePosition compressedValue
         * @property {number|Long|null} [uncompressedLength] UniquePosition uncompressedLength
         * @property {Uint8Array|null} [customCompressedV1] UniquePosition customCompressedV1
         */

        /**
         * Constructs a new UniquePosition.
         * @memberof sync_pb
         * @classdesc Represents an UniquePosition.
         * @implements IUniquePosition
         * @constructor
         * @param {sync_pb.IUniquePosition=} [properties] Properties to set
         */
        function UniquePosition(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UniquePosition value.
         * @member {Uint8Array} value
         * @memberof sync_pb.UniquePosition
         * @instance
         */
        UniquePosition.prototype.value = $util.newBuffer([]);

        /**
         * UniquePosition compressedValue.
         * @member {Uint8Array} compressedValue
         * @memberof sync_pb.UniquePosition
         * @instance
         */
        UniquePosition.prototype.compressedValue = $util.newBuffer([]);

        /**
         * UniquePosition uncompressedLength.
         * @member {number|Long} uncompressedLength
         * @memberof sync_pb.UniquePosition
         * @instance
         */
        UniquePosition.prototype.uncompressedLength = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * UniquePosition customCompressedV1.
         * @member {Uint8Array} customCompressedV1
         * @memberof sync_pb.UniquePosition
         * @instance
         */
        UniquePosition.prototype.customCompressedV1 = $util.newBuffer([]);

        /**
         * Creates a new UniquePosition instance using the specified properties.
         * @function create
         * @memberof sync_pb.UniquePosition
         * @static
         * @param {sync_pb.IUniquePosition=} [properties] Properties to set
         * @returns {sync_pb.UniquePosition} UniquePosition instance
         */
        UniquePosition.create = function create(properties) {
            return new UniquePosition(properties);
        };

        /**
         * Encodes the specified UniquePosition message. Does not implicitly {@link sync_pb.UniquePosition.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.UniquePosition
         * @static
         * @param {sync_pb.IUniquePosition} message UniquePosition message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UniquePosition.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.value);
            if (message.compressedValue != null && Object.hasOwnProperty.call(message, "compressedValue"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.compressedValue);
            if (message.uncompressedLength != null && Object.hasOwnProperty.call(message, "uncompressedLength"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.uncompressedLength);
            if (message.customCompressedV1 != null && Object.hasOwnProperty.call(message, "customCompressedV1"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.customCompressedV1);
            return writer;
        };

        /**
         * Encodes the specified UniquePosition message, length delimited. Does not implicitly {@link sync_pb.UniquePosition.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.UniquePosition
         * @static
         * @param {sync_pb.IUniquePosition} message UniquePosition message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UniquePosition.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UniquePosition message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.UniquePosition
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.UniquePosition} UniquePosition
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UniquePosition.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.UniquePosition();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.value = reader.bytes();
                    break;
                case 2:
                    message.compressedValue = reader.bytes();
                    break;
                case 3:
                    message.uncompressedLength = reader.uint64();
                    break;
                case 4:
                    message.customCompressedV1 = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UniquePosition message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.UniquePosition
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.UniquePosition} UniquePosition
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UniquePosition.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UniquePosition message.
         * @function verify
         * @memberof sync_pb.UniquePosition
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UniquePosition.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                    return "value: buffer expected";
            if (message.compressedValue != null && message.hasOwnProperty("compressedValue"))
                if (!(message.compressedValue && typeof message.compressedValue.length === "number" || $util.isString(message.compressedValue)))
                    return "compressedValue: buffer expected";
            if (message.uncompressedLength != null && message.hasOwnProperty("uncompressedLength"))
                if (!$util.isInteger(message.uncompressedLength) && !(message.uncompressedLength && $util.isInteger(message.uncompressedLength.low) && $util.isInteger(message.uncompressedLength.high)))
                    return "uncompressedLength: integer|Long expected";
            if (message.customCompressedV1 != null && message.hasOwnProperty("customCompressedV1"))
                if (!(message.customCompressedV1 && typeof message.customCompressedV1.length === "number" || $util.isString(message.customCompressedV1)))
                    return "customCompressedV1: buffer expected";
            return null;
        };

        /**
         * Creates an UniquePosition message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.UniquePosition
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.UniquePosition} UniquePosition
         */
        UniquePosition.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.UniquePosition)
                return object;
            let message = new $root.sync_pb.UniquePosition();
            if (object.value != null)
                if (typeof object.value === "string")
                    $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                else if (object.value.length)
                    message.value = object.value;
            if (object.compressedValue != null)
                if (typeof object.compressedValue === "string")
                    $util.base64.decode(object.compressedValue, message.compressedValue = $util.newBuffer($util.base64.length(object.compressedValue)), 0);
                else if (object.compressedValue.length)
                    message.compressedValue = object.compressedValue;
            if (object.uncompressedLength != null)
                if ($util.Long)
                    (message.uncompressedLength = $util.Long.fromValue(object.uncompressedLength)).unsigned = true;
                else if (typeof object.uncompressedLength === "string")
                    message.uncompressedLength = parseInt(object.uncompressedLength, 10);
                else if (typeof object.uncompressedLength === "number")
                    message.uncompressedLength = object.uncompressedLength;
                else if (typeof object.uncompressedLength === "object")
                    message.uncompressedLength = new $util.LongBits(object.uncompressedLength.low >>> 0, object.uncompressedLength.high >>> 0).toNumber(true);
            if (object.customCompressedV1 != null)
                if (typeof object.customCompressedV1 === "string")
                    $util.base64.decode(object.customCompressedV1, message.customCompressedV1 = $util.newBuffer($util.base64.length(object.customCompressedV1)), 0);
                else if (object.customCompressedV1.length)
                    message.customCompressedV1 = object.customCompressedV1;
            return message;
        };

        /**
         * Creates a plain object from an UniquePosition message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.UniquePosition
         * @static
         * @param {sync_pb.UniquePosition} message UniquePosition
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UniquePosition.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array)
                        object.value = $util.newBuffer(object.value);
                }
                if (options.bytes === String)
                    object.compressedValue = "";
                else {
                    object.compressedValue = [];
                    if (options.bytes !== Array)
                        object.compressedValue = $util.newBuffer(object.compressedValue);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.uncompressedLength = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.uncompressedLength = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.customCompressedV1 = "";
                else {
                    object.customCompressedV1 = [];
                    if (options.bytes !== Array)
                        object.customCompressedV1 = $util.newBuffer(object.customCompressedV1);
                }
            }
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            if (message.compressedValue != null && message.hasOwnProperty("compressedValue"))
                object.compressedValue = options.bytes === String ? $util.base64.encode(message.compressedValue, 0, message.compressedValue.length) : options.bytes === Array ? Array.prototype.slice.call(message.compressedValue) : message.compressedValue;
            if (message.uncompressedLength != null && message.hasOwnProperty("uncompressedLength"))
                if (typeof message.uncompressedLength === "number")
                    object.uncompressedLength = options.longs === String ? String(message.uncompressedLength) : message.uncompressedLength;
                else
                    object.uncompressedLength = options.longs === String ? $util.Long.prototype.toString.call(message.uncompressedLength) : options.longs === Number ? new $util.LongBits(message.uncompressedLength.low >>> 0, message.uncompressedLength.high >>> 0).toNumber(true) : message.uncompressedLength;
            if (message.customCompressedV1 != null && message.hasOwnProperty("customCompressedV1"))
                object.customCompressedV1 = options.bytes === String ? $util.base64.encode(message.customCompressedV1, 0, message.customCompressedV1.length) : options.bytes === Array ? Array.prototype.slice.call(message.customCompressedV1) : message.customCompressedV1;
            return object;
        };

        /**
         * Converts this UniquePosition to JSON.
         * @function toJSON
         * @memberof sync_pb.UniquePosition
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UniquePosition.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UniquePosition;
    })();

    sync_pb.SyncedNotificationAppInfoSpecifics = (function() {

        /**
         * Properties of a SyncedNotificationAppInfoSpecifics.
         * @memberof sync_pb
         * @interface ISyncedNotificationAppInfoSpecifics
         * @property {Array.<sync_pb.ISyncedNotificationAppInfo>|null} [syncedNotificationAppInfo] SyncedNotificationAppInfoSpecifics syncedNotificationAppInfo
         */

        /**
         * Constructs a new SyncedNotificationAppInfoSpecifics.
         * @memberof sync_pb
         * @classdesc Represents a SyncedNotificationAppInfoSpecifics.
         * @implements ISyncedNotificationAppInfoSpecifics
         * @constructor
         * @param {sync_pb.ISyncedNotificationAppInfoSpecifics=} [properties] Properties to set
         */
        function SyncedNotificationAppInfoSpecifics(properties) {
            this.syncedNotificationAppInfo = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncedNotificationAppInfoSpecifics syncedNotificationAppInfo.
         * @member {Array.<sync_pb.ISyncedNotificationAppInfo>} syncedNotificationAppInfo
         * @memberof sync_pb.SyncedNotificationAppInfoSpecifics
         * @instance
         */
        SyncedNotificationAppInfoSpecifics.prototype.syncedNotificationAppInfo = $util.emptyArray;

        /**
         * Creates a new SyncedNotificationAppInfoSpecifics instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncedNotificationAppInfoSpecifics
         * @static
         * @param {sync_pb.ISyncedNotificationAppInfoSpecifics=} [properties] Properties to set
         * @returns {sync_pb.SyncedNotificationAppInfoSpecifics} SyncedNotificationAppInfoSpecifics instance
         */
        SyncedNotificationAppInfoSpecifics.create = function create(properties) {
            return new SyncedNotificationAppInfoSpecifics(properties);
        };

        /**
         * Encodes the specified SyncedNotificationAppInfoSpecifics message. Does not implicitly {@link sync_pb.SyncedNotificationAppInfoSpecifics.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncedNotificationAppInfoSpecifics
         * @static
         * @param {sync_pb.ISyncedNotificationAppInfoSpecifics} message SyncedNotificationAppInfoSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationAppInfoSpecifics.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.syncedNotificationAppInfo != null && message.syncedNotificationAppInfo.length)
                for (let i = 0; i < message.syncedNotificationAppInfo.length; ++i)
                    $root.sync_pb.SyncedNotificationAppInfo.encode(message.syncedNotificationAppInfo[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SyncedNotificationAppInfoSpecifics message, length delimited. Does not implicitly {@link sync_pb.SyncedNotificationAppInfoSpecifics.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncedNotificationAppInfoSpecifics
         * @static
         * @param {sync_pb.ISyncedNotificationAppInfoSpecifics} message SyncedNotificationAppInfoSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationAppInfoSpecifics.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncedNotificationAppInfoSpecifics message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncedNotificationAppInfoSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncedNotificationAppInfoSpecifics} SyncedNotificationAppInfoSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationAppInfoSpecifics.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncedNotificationAppInfoSpecifics();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.syncedNotificationAppInfo && message.syncedNotificationAppInfo.length))
                        message.syncedNotificationAppInfo = [];
                    message.syncedNotificationAppInfo.push($root.sync_pb.SyncedNotificationAppInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncedNotificationAppInfoSpecifics message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncedNotificationAppInfoSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncedNotificationAppInfoSpecifics} SyncedNotificationAppInfoSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationAppInfoSpecifics.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncedNotificationAppInfoSpecifics message.
         * @function verify
         * @memberof sync_pb.SyncedNotificationAppInfoSpecifics
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncedNotificationAppInfoSpecifics.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.syncedNotificationAppInfo != null && message.hasOwnProperty("syncedNotificationAppInfo")) {
                if (!Array.isArray(message.syncedNotificationAppInfo))
                    return "syncedNotificationAppInfo: array expected";
                for (let i = 0; i < message.syncedNotificationAppInfo.length; ++i) {
                    let error = $root.sync_pb.SyncedNotificationAppInfo.verify(message.syncedNotificationAppInfo[i]);
                    if (error)
                        return "syncedNotificationAppInfo." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SyncedNotificationAppInfoSpecifics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncedNotificationAppInfoSpecifics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncedNotificationAppInfoSpecifics} SyncedNotificationAppInfoSpecifics
         */
        SyncedNotificationAppInfoSpecifics.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncedNotificationAppInfoSpecifics)
                return object;
            let message = new $root.sync_pb.SyncedNotificationAppInfoSpecifics();
            if (object.syncedNotificationAppInfo) {
                if (!Array.isArray(object.syncedNotificationAppInfo))
                    throw TypeError(".sync_pb.SyncedNotificationAppInfoSpecifics.syncedNotificationAppInfo: array expected");
                message.syncedNotificationAppInfo = [];
                for (let i = 0; i < object.syncedNotificationAppInfo.length; ++i) {
                    if (typeof object.syncedNotificationAppInfo[i] !== "object")
                        throw TypeError(".sync_pb.SyncedNotificationAppInfoSpecifics.syncedNotificationAppInfo: object expected");
                    message.syncedNotificationAppInfo[i] = $root.sync_pb.SyncedNotificationAppInfo.fromObject(object.syncedNotificationAppInfo[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SyncedNotificationAppInfoSpecifics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncedNotificationAppInfoSpecifics
         * @static
         * @param {sync_pb.SyncedNotificationAppInfoSpecifics} message SyncedNotificationAppInfoSpecifics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncedNotificationAppInfoSpecifics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.syncedNotificationAppInfo = [];
            if (message.syncedNotificationAppInfo && message.syncedNotificationAppInfo.length) {
                object.syncedNotificationAppInfo = [];
                for (let j = 0; j < message.syncedNotificationAppInfo.length; ++j)
                    object.syncedNotificationAppInfo[j] = $root.sync_pb.SyncedNotificationAppInfo.toObject(message.syncedNotificationAppInfo[j], options);
            }
            return object;
        };

        /**
         * Converts this SyncedNotificationAppInfoSpecifics to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncedNotificationAppInfoSpecifics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncedNotificationAppInfoSpecifics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncedNotificationAppInfoSpecifics;
    })();

    sync_pb.SyncedNotificationAppInfo = (function() {

        /**
         * Properties of a SyncedNotificationAppInfo.
         * @memberof sync_pb
         * @interface ISyncedNotificationAppInfo
         * @property {Array.<string>|null} [appId] SyncedNotificationAppInfo appId
         * @property {string|null} [settingsDisplayName] SyncedNotificationAppInfo settingsDisplayName
         * @property {sync_pb.ISyncedNotificationImage|null} [icon] SyncedNotificationAppInfo icon
         * @property {string|null} [appName] SyncedNotificationAppInfo appName
         * @property {string|null} [settingsUrl] SyncedNotificationAppInfo settingsUrl
         * @property {string|null} [infoUrl] SyncedNotificationAppInfo infoUrl
         * @property {Array.<sync_pb.SyncedNotificationAppInfo.IIcon>|null} [appIcon] SyncedNotificationAppInfo appIcon
         */

        /**
         * Constructs a new SyncedNotificationAppInfo.
         * @memberof sync_pb
         * @classdesc Represents a SyncedNotificationAppInfo.
         * @implements ISyncedNotificationAppInfo
         * @constructor
         * @param {sync_pb.ISyncedNotificationAppInfo=} [properties] Properties to set
         */
        function SyncedNotificationAppInfo(properties) {
            this.appId = [];
            this.appIcon = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SyncedNotificationAppInfo appId.
         * @member {Array.<string>} appId
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @instance
         */
        SyncedNotificationAppInfo.prototype.appId = $util.emptyArray;

        /**
         * SyncedNotificationAppInfo settingsDisplayName.
         * @member {string} settingsDisplayName
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @instance
         */
        SyncedNotificationAppInfo.prototype.settingsDisplayName = "";

        /**
         * SyncedNotificationAppInfo icon.
         * @member {sync_pb.ISyncedNotificationImage|null|undefined} icon
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @instance
         */
        SyncedNotificationAppInfo.prototype.icon = null;

        /**
         * SyncedNotificationAppInfo appName.
         * @member {string} appName
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @instance
         */
        SyncedNotificationAppInfo.prototype.appName = "";

        /**
         * SyncedNotificationAppInfo settingsUrl.
         * @member {string} settingsUrl
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @instance
         */
        SyncedNotificationAppInfo.prototype.settingsUrl = "";

        /**
         * SyncedNotificationAppInfo infoUrl.
         * @member {string} infoUrl
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @instance
         */
        SyncedNotificationAppInfo.prototype.infoUrl = "";

        /**
         * SyncedNotificationAppInfo appIcon.
         * @member {Array.<sync_pb.SyncedNotificationAppInfo.IIcon>} appIcon
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @instance
         */
        SyncedNotificationAppInfo.prototype.appIcon = $util.emptyArray;

        /**
         * Creates a new SyncedNotificationAppInfo instance using the specified properties.
         * @function create
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @static
         * @param {sync_pb.ISyncedNotificationAppInfo=} [properties] Properties to set
         * @returns {sync_pb.SyncedNotificationAppInfo} SyncedNotificationAppInfo instance
         */
        SyncedNotificationAppInfo.create = function create(properties) {
            return new SyncedNotificationAppInfo(properties);
        };

        /**
         * Encodes the specified SyncedNotificationAppInfo message. Does not implicitly {@link sync_pb.SyncedNotificationAppInfo.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @static
         * @param {sync_pb.ISyncedNotificationAppInfo} message SyncedNotificationAppInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationAppInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.appId != null && message.appId.length)
                for (let i = 0; i < message.appId.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.appId[i]);
            if (message.settingsDisplayName != null && Object.hasOwnProperty.call(message, "settingsDisplayName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.settingsDisplayName);
            if (message.icon != null && Object.hasOwnProperty.call(message, "icon"))
                $root.sync_pb.SyncedNotificationImage.encode(message.icon, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.appName != null && Object.hasOwnProperty.call(message, "appName"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.appName);
            if (message.settingsUrl != null && Object.hasOwnProperty.call(message, "settingsUrl"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.settingsUrl);
            if (message.infoUrl != null && Object.hasOwnProperty.call(message, "infoUrl"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.infoUrl);
            if (message.appIcon != null && message.appIcon.length)
                for (let i = 0; i < message.appIcon.length; ++i)
                    $root.sync_pb.SyncedNotificationAppInfo.Icon.encode(message.appIcon[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SyncedNotificationAppInfo message, length delimited. Does not implicitly {@link sync_pb.SyncedNotificationAppInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @static
         * @param {sync_pb.ISyncedNotificationAppInfo} message SyncedNotificationAppInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SyncedNotificationAppInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SyncedNotificationAppInfo message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SyncedNotificationAppInfo} SyncedNotificationAppInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationAppInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncedNotificationAppInfo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.appId && message.appId.length))
                        message.appId = [];
                    message.appId.push(reader.string());
                    break;
                case 2:
                    message.settingsDisplayName = reader.string();
                    break;
                case 3:
                    message.icon = $root.sync_pb.SyncedNotificationImage.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.appName = reader.string();
                    break;
                case 5:
                    message.settingsUrl = reader.string();
                    break;
                case 6:
                    message.infoUrl = reader.string();
                    break;
                case 7:
                    if (!(message.appIcon && message.appIcon.length))
                        message.appIcon = [];
                    message.appIcon.push($root.sync_pb.SyncedNotificationAppInfo.Icon.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SyncedNotificationAppInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SyncedNotificationAppInfo} SyncedNotificationAppInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SyncedNotificationAppInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SyncedNotificationAppInfo message.
         * @function verify
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SyncedNotificationAppInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.appId != null && message.hasOwnProperty("appId")) {
                if (!Array.isArray(message.appId))
                    return "appId: array expected";
                for (let i = 0; i < message.appId.length; ++i)
                    if (!$util.isString(message.appId[i]))
                        return "appId: string[] expected";
            }
            if (message.settingsDisplayName != null && message.hasOwnProperty("settingsDisplayName"))
                if (!$util.isString(message.settingsDisplayName))
                    return "settingsDisplayName: string expected";
            if (message.icon != null && message.hasOwnProperty("icon")) {
                let error = $root.sync_pb.SyncedNotificationImage.verify(message.icon);
                if (error)
                    return "icon." + error;
            }
            if (message.appName != null && message.hasOwnProperty("appName"))
                if (!$util.isString(message.appName))
                    return "appName: string expected";
            if (message.settingsUrl != null && message.hasOwnProperty("settingsUrl"))
                if (!$util.isString(message.settingsUrl))
                    return "settingsUrl: string expected";
            if (message.infoUrl != null && message.hasOwnProperty("infoUrl"))
                if (!$util.isString(message.infoUrl))
                    return "infoUrl: string expected";
            if (message.appIcon != null && message.hasOwnProperty("appIcon")) {
                if (!Array.isArray(message.appIcon))
                    return "appIcon: array expected";
                for (let i = 0; i < message.appIcon.length; ++i) {
                    let error = $root.sync_pb.SyncedNotificationAppInfo.Icon.verify(message.appIcon[i]);
                    if (error)
                        return "appIcon." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SyncedNotificationAppInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SyncedNotificationAppInfo} SyncedNotificationAppInfo
         */
        SyncedNotificationAppInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SyncedNotificationAppInfo)
                return object;
            let message = new $root.sync_pb.SyncedNotificationAppInfo();
            if (object.appId) {
                if (!Array.isArray(object.appId))
                    throw TypeError(".sync_pb.SyncedNotificationAppInfo.appId: array expected");
                message.appId = [];
                for (let i = 0; i < object.appId.length; ++i)
                    message.appId[i] = String(object.appId[i]);
            }
            if (object.settingsDisplayName != null)
                message.settingsDisplayName = String(object.settingsDisplayName);
            if (object.icon != null) {
                if (typeof object.icon !== "object")
                    throw TypeError(".sync_pb.SyncedNotificationAppInfo.icon: object expected");
                message.icon = $root.sync_pb.SyncedNotificationImage.fromObject(object.icon);
            }
            if (object.appName != null)
                message.appName = String(object.appName);
            if (object.settingsUrl != null)
                message.settingsUrl = String(object.settingsUrl);
            if (object.infoUrl != null)
                message.infoUrl = String(object.infoUrl);
            if (object.appIcon) {
                if (!Array.isArray(object.appIcon))
                    throw TypeError(".sync_pb.SyncedNotificationAppInfo.appIcon: array expected");
                message.appIcon = [];
                for (let i = 0; i < object.appIcon.length; ++i) {
                    if (typeof object.appIcon[i] !== "object")
                        throw TypeError(".sync_pb.SyncedNotificationAppInfo.appIcon: object expected");
                    message.appIcon[i] = $root.sync_pb.SyncedNotificationAppInfo.Icon.fromObject(object.appIcon[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SyncedNotificationAppInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @static
         * @param {sync_pb.SyncedNotificationAppInfo} message SyncedNotificationAppInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncedNotificationAppInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.appId = [];
                object.appIcon = [];
            }
            if (options.defaults) {
                object.settingsDisplayName = "";
                object.icon = null;
                object.appName = "";
                object.settingsUrl = "";
                object.infoUrl = "";
            }
            if (message.appId && message.appId.length) {
                object.appId = [];
                for (let j = 0; j < message.appId.length; ++j)
                    object.appId[j] = message.appId[j];
            }
            if (message.settingsDisplayName != null && message.hasOwnProperty("settingsDisplayName"))
                object.settingsDisplayName = message.settingsDisplayName;
            if (message.icon != null && message.hasOwnProperty("icon"))
                object.icon = $root.sync_pb.SyncedNotificationImage.toObject(message.icon, options);
            if (message.appName != null && message.hasOwnProperty("appName"))
                object.appName = message.appName;
            if (message.settingsUrl != null && message.hasOwnProperty("settingsUrl"))
                object.settingsUrl = message.settingsUrl;
            if (message.infoUrl != null && message.hasOwnProperty("infoUrl"))
                object.infoUrl = message.infoUrl;
            if (message.appIcon && message.appIcon.length) {
                object.appIcon = [];
                for (let j = 0; j < message.appIcon.length; ++j)
                    object.appIcon[j] = $root.sync_pb.SyncedNotificationAppInfo.Icon.toObject(message.appIcon[j], options);
            }
            return object;
        };

        /**
         * Converts this SyncedNotificationAppInfo to JSON.
         * @function toJSON
         * @memberof sync_pb.SyncedNotificationAppInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncedNotificationAppInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SyncedNotificationAppInfo.Icon = (function() {

            /**
             * Properties of an Icon.
             * @memberof sync_pb.SyncedNotificationAppInfo
             * @interface IIcon
             * @property {sync_pb.SyncedNotificationAppInfo.Icon.Type|null} [type] Icon type
             * @property {string|null} [url] Icon url
             */

            /**
             * Constructs a new Icon.
             * @memberof sync_pb.SyncedNotificationAppInfo
             * @classdesc Represents an Icon.
             * @implements IIcon
             * @constructor
             * @param {sync_pb.SyncedNotificationAppInfo.IIcon=} [properties] Properties to set
             */
            function Icon(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Icon type.
             * @member {sync_pb.SyncedNotificationAppInfo.Icon.Type} type
             * @memberof sync_pb.SyncedNotificationAppInfo.Icon
             * @instance
             */
            Icon.prototype.type = 1;

            /**
             * Icon url.
             * @member {string} url
             * @memberof sync_pb.SyncedNotificationAppInfo.Icon
             * @instance
             */
            Icon.prototype.url = "";

            /**
             * Creates a new Icon instance using the specified properties.
             * @function create
             * @memberof sync_pb.SyncedNotificationAppInfo.Icon
             * @static
             * @param {sync_pb.SyncedNotificationAppInfo.IIcon=} [properties] Properties to set
             * @returns {sync_pb.SyncedNotificationAppInfo.Icon} Icon instance
             */
            Icon.create = function create(properties) {
                return new Icon(properties);
            };

            /**
             * Encodes the specified Icon message. Does not implicitly {@link sync_pb.SyncedNotificationAppInfo.Icon.verify|verify} messages.
             * @function encode
             * @memberof sync_pb.SyncedNotificationAppInfo.Icon
             * @static
             * @param {sync_pb.SyncedNotificationAppInfo.IIcon} message Icon message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Icon.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.url);
                return writer;
            };

            /**
             * Encodes the specified Icon message, length delimited. Does not implicitly {@link sync_pb.SyncedNotificationAppInfo.Icon.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sync_pb.SyncedNotificationAppInfo.Icon
             * @static
             * @param {sync_pb.SyncedNotificationAppInfo.IIcon} message Icon message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Icon.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Icon message from the specified reader or buffer.
             * @function decode
             * @memberof sync_pb.SyncedNotificationAppInfo.Icon
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sync_pb.SyncedNotificationAppInfo.Icon} Icon
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Icon.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SyncedNotificationAppInfo.Icon();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.int32();
                        break;
                    case 2:
                        message.url = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Icon message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sync_pb.SyncedNotificationAppInfo.Icon
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sync_pb.SyncedNotificationAppInfo.Icon} Icon
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Icon.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Icon message.
             * @function verify
             * @memberof sync_pb.SyncedNotificationAppInfo.Icon
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Icon.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    switch (message.type) {
                    default:
                        return "type: enum value expected";
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                        break;
                    }
                if (message.url != null && message.hasOwnProperty("url"))
                    if (!$util.isString(message.url))
                        return "url: string expected";
                return null;
            };

            /**
             * Creates an Icon message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sync_pb.SyncedNotificationAppInfo.Icon
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sync_pb.SyncedNotificationAppInfo.Icon} Icon
             */
            Icon.fromObject = function fromObject(object) {
                if (object instanceof $root.sync_pb.SyncedNotificationAppInfo.Icon)
                    return object;
                let message = new $root.sync_pb.SyncedNotificationAppInfo.Icon();
                switch (object.type) {
                case "GRAYSCALE_FAVICON_1X":
                case 1:
                    message.type = 1;
                    break;
                case "GRAYSCALE_FAVICON_2X":
                case 2:
                    message.type = 2;
                    break;
                case "COLOR_FAVICON_1X":
                case 3:
                    message.type = 3;
                    break;
                case "COLOR_FAVICON_2X":
                case 4:
                    message.type = 4;
                    break;
                case "COLOR_APPICON_1X":
                case 5:
                    message.type = 5;
                    break;
                case "COLOR_APPICON_2X":
                case 6:
                    message.type = 6;
                    break;
                }
                if (object.url != null)
                    message.url = String(object.url);
                return message;
            };

            /**
             * Creates a plain object from an Icon message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sync_pb.SyncedNotificationAppInfo.Icon
             * @static
             * @param {sync_pb.SyncedNotificationAppInfo.Icon} message Icon
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Icon.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.type = options.enums === String ? "GRAYSCALE_FAVICON_1X" : 1;
                    object.url = "";
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.sync_pb.SyncedNotificationAppInfo.Icon.Type[message.type] : message.type;
                if (message.url != null && message.hasOwnProperty("url"))
                    object.url = message.url;
                return object;
            };

            /**
             * Converts this Icon to JSON.
             * @function toJSON
             * @memberof sync_pb.SyncedNotificationAppInfo.Icon
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Icon.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Type enum.
             * @name sync_pb.SyncedNotificationAppInfo.Icon.Type
             * @enum {number}
             * @property {number} GRAYSCALE_FAVICON_1X=1 GRAYSCALE_FAVICON_1X value
             * @property {number} GRAYSCALE_FAVICON_2X=2 GRAYSCALE_FAVICON_2X value
             * @property {number} COLOR_FAVICON_1X=3 COLOR_FAVICON_1X value
             * @property {number} COLOR_FAVICON_2X=4 COLOR_FAVICON_2X value
             * @property {number} COLOR_APPICON_1X=5 COLOR_APPICON_1X value
             * @property {number} COLOR_APPICON_2X=6 COLOR_APPICON_2X value
             */
            Icon.Type = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "GRAYSCALE_FAVICON_1X"] = 1;
                values[valuesById[2] = "GRAYSCALE_FAVICON_2X"] = 2;
                values[valuesById[3] = "COLOR_FAVICON_1X"] = 3;
                values[valuesById[4] = "COLOR_FAVICON_2X"] = 4;
                values[valuesById[5] = "COLOR_APPICON_1X"] = 5;
                values[valuesById[6] = "COLOR_APPICON_2X"] = 6;
                return values;
            })();

            return Icon;
        })();

        return SyncedNotificationAppInfo;
    })();

    sync_pb.SessionSpecifics = (function() {

        /**
         * Properties of a SessionSpecifics.
         * @memberof sync_pb
         * @interface ISessionSpecifics
         * @property {string|null} [sessionTag] SessionSpecifics sessionTag
         * @property {sync_pb.ISessionHeader|null} [header] SessionSpecifics header
         * @property {sync_pb.ISessionTab|null} [tab] SessionSpecifics tab
         * @property {number|null} [tabNodeId] SessionSpecifics tabNodeId
         */

        /**
         * Constructs a new SessionSpecifics.
         * @memberof sync_pb
         * @classdesc Represents a SessionSpecifics.
         * @implements ISessionSpecifics
         * @constructor
         * @param {sync_pb.ISessionSpecifics=} [properties] Properties to set
         */
        function SessionSpecifics(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SessionSpecifics sessionTag.
         * @member {string} sessionTag
         * @memberof sync_pb.SessionSpecifics
         * @instance
         */
        SessionSpecifics.prototype.sessionTag = "";

        /**
         * SessionSpecifics header.
         * @member {sync_pb.ISessionHeader|null|undefined} header
         * @memberof sync_pb.SessionSpecifics
         * @instance
         */
        SessionSpecifics.prototype.header = null;

        /**
         * SessionSpecifics tab.
         * @member {sync_pb.ISessionTab|null|undefined} tab
         * @memberof sync_pb.SessionSpecifics
         * @instance
         */
        SessionSpecifics.prototype.tab = null;

        /**
         * SessionSpecifics tabNodeId.
         * @member {number} tabNodeId
         * @memberof sync_pb.SessionSpecifics
         * @instance
         */
        SessionSpecifics.prototype.tabNodeId = -1;

        /**
         * Creates a new SessionSpecifics instance using the specified properties.
         * @function create
         * @memberof sync_pb.SessionSpecifics
         * @static
         * @param {sync_pb.ISessionSpecifics=} [properties] Properties to set
         * @returns {sync_pb.SessionSpecifics} SessionSpecifics instance
         */
        SessionSpecifics.create = function create(properties) {
            return new SessionSpecifics(properties);
        };

        /**
         * Encodes the specified SessionSpecifics message. Does not implicitly {@link sync_pb.SessionSpecifics.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SessionSpecifics
         * @static
         * @param {sync_pb.ISessionSpecifics} message SessionSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionSpecifics.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sessionTag != null && Object.hasOwnProperty.call(message, "sessionTag"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.sessionTag);
            if (message.header != null && Object.hasOwnProperty.call(message, "header"))
                $root.sync_pb.SessionHeader.encode(message.header, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.tab != null && Object.hasOwnProperty.call(message, "tab"))
                $root.sync_pb.SessionTab.encode(message.tab, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.tabNodeId != null && Object.hasOwnProperty.call(message, "tabNodeId"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.tabNodeId);
            return writer;
        };

        /**
         * Encodes the specified SessionSpecifics message, length delimited. Does not implicitly {@link sync_pb.SessionSpecifics.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SessionSpecifics
         * @static
         * @param {sync_pb.ISessionSpecifics} message SessionSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionSpecifics.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SessionSpecifics message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SessionSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SessionSpecifics} SessionSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionSpecifics.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SessionSpecifics();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.sessionTag = reader.string();
                    break;
                case 2:
                    message.header = $root.sync_pb.SessionHeader.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tab = $root.sync_pb.SessionTab.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.tabNodeId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SessionSpecifics message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SessionSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SessionSpecifics} SessionSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionSpecifics.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SessionSpecifics message.
         * @function verify
         * @memberof sync_pb.SessionSpecifics
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SessionSpecifics.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sessionTag != null && message.hasOwnProperty("sessionTag"))
                if (!$util.isString(message.sessionTag))
                    return "sessionTag: string expected";
            if (message.header != null && message.hasOwnProperty("header")) {
                let error = $root.sync_pb.SessionHeader.verify(message.header);
                if (error)
                    return "header." + error;
            }
            if (message.tab != null && message.hasOwnProperty("tab")) {
                let error = $root.sync_pb.SessionTab.verify(message.tab);
                if (error)
                    return "tab." + error;
            }
            if (message.tabNodeId != null && message.hasOwnProperty("tabNodeId"))
                if (!$util.isInteger(message.tabNodeId))
                    return "tabNodeId: integer expected";
            return null;
        };

        /**
         * Creates a SessionSpecifics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SessionSpecifics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SessionSpecifics} SessionSpecifics
         */
        SessionSpecifics.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SessionSpecifics)
                return object;
            let message = new $root.sync_pb.SessionSpecifics();
            if (object.sessionTag != null)
                message.sessionTag = String(object.sessionTag);
            if (object.header != null) {
                if (typeof object.header !== "object")
                    throw TypeError(".sync_pb.SessionSpecifics.header: object expected");
                message.header = $root.sync_pb.SessionHeader.fromObject(object.header);
            }
            if (object.tab != null) {
                if (typeof object.tab !== "object")
                    throw TypeError(".sync_pb.SessionSpecifics.tab: object expected");
                message.tab = $root.sync_pb.SessionTab.fromObject(object.tab);
            }
            if (object.tabNodeId != null)
                message.tabNodeId = object.tabNodeId | 0;
            return message;
        };

        /**
         * Creates a plain object from a SessionSpecifics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SessionSpecifics
         * @static
         * @param {sync_pb.SessionSpecifics} message SessionSpecifics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SessionSpecifics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.sessionTag = "";
                object.header = null;
                object.tab = null;
                object.tabNodeId = -1;
            }
            if (message.sessionTag != null && message.hasOwnProperty("sessionTag"))
                object.sessionTag = message.sessionTag;
            if (message.header != null && message.hasOwnProperty("header"))
                object.header = $root.sync_pb.SessionHeader.toObject(message.header, options);
            if (message.tab != null && message.hasOwnProperty("tab"))
                object.tab = $root.sync_pb.SessionTab.toObject(message.tab, options);
            if (message.tabNodeId != null && message.hasOwnProperty("tabNodeId"))
                object.tabNodeId = message.tabNodeId;
            return object;
        };

        /**
         * Converts this SessionSpecifics to JSON.
         * @function toJSON
         * @memberof sync_pb.SessionSpecifics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SessionSpecifics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SessionSpecifics;
    })();

    sync_pb.SessionHeader = (function() {

        /**
         * Properties of a SessionHeader.
         * @memberof sync_pb
         * @interface ISessionHeader
         * @property {Array.<sync_pb.ISessionWindow>|null} [window] SessionHeader window
         * @property {string|null} [clientName] SessionHeader clientName
         * @property {sync_pb.SyncEnums.DeviceType|null} [deviceType] SessionHeader deviceType
         */

        /**
         * Constructs a new SessionHeader.
         * @memberof sync_pb
         * @classdesc Represents a SessionHeader.
         * @implements ISessionHeader
         * @constructor
         * @param {sync_pb.ISessionHeader=} [properties] Properties to set
         */
        function SessionHeader(properties) {
            this.window = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SessionHeader window.
         * @member {Array.<sync_pb.ISessionWindow>} window
         * @memberof sync_pb.SessionHeader
         * @instance
         */
        SessionHeader.prototype.window = $util.emptyArray;

        /**
         * SessionHeader clientName.
         * @member {string} clientName
         * @memberof sync_pb.SessionHeader
         * @instance
         */
        SessionHeader.prototype.clientName = "";

        /**
         * SessionHeader deviceType.
         * @member {sync_pb.SyncEnums.DeviceType} deviceType
         * @memberof sync_pb.SessionHeader
         * @instance
         */
        SessionHeader.prototype.deviceType = 0;

        /**
         * Creates a new SessionHeader instance using the specified properties.
         * @function create
         * @memberof sync_pb.SessionHeader
         * @static
         * @param {sync_pb.ISessionHeader=} [properties] Properties to set
         * @returns {sync_pb.SessionHeader} SessionHeader instance
         */
        SessionHeader.create = function create(properties) {
            return new SessionHeader(properties);
        };

        /**
         * Encodes the specified SessionHeader message. Does not implicitly {@link sync_pb.SessionHeader.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SessionHeader
         * @static
         * @param {sync_pb.ISessionHeader} message SessionHeader message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionHeader.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.window != null && message.window.length)
                for (let i = 0; i < message.window.length; ++i)
                    $root.sync_pb.SessionWindow.encode(message.window[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.clientName != null && Object.hasOwnProperty.call(message, "clientName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.clientName);
            if (message.deviceType != null && Object.hasOwnProperty.call(message, "deviceType"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.deviceType);
            return writer;
        };

        /**
         * Encodes the specified SessionHeader message, length delimited. Does not implicitly {@link sync_pb.SessionHeader.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SessionHeader
         * @static
         * @param {sync_pb.ISessionHeader} message SessionHeader message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionHeader.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SessionHeader message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SessionHeader
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SessionHeader} SessionHeader
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionHeader.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SessionHeader();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    if (!(message.window && message.window.length))
                        message.window = [];
                    message.window.push($root.sync_pb.SessionWindow.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.clientName = reader.string();
                    break;
                case 4:
                    message.deviceType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SessionHeader message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SessionHeader
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SessionHeader} SessionHeader
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionHeader.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SessionHeader message.
         * @function verify
         * @memberof sync_pb.SessionHeader
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SessionHeader.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.window != null && message.hasOwnProperty("window")) {
                if (!Array.isArray(message.window))
                    return "window: array expected";
                for (let i = 0; i < message.window.length; ++i) {
                    let error = $root.sync_pb.SessionWindow.verify(message.window[i]);
                    if (error)
                        return "window." + error;
                }
            }
            if (message.clientName != null && message.hasOwnProperty("clientName"))
                if (!$util.isString(message.clientName))
                    return "clientName: string expected";
            if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                switch (message.deviceType) {
                default:
                    return "deviceType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                    break;
                }
            return null;
        };

        /**
         * Creates a SessionHeader message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SessionHeader
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SessionHeader} SessionHeader
         */
        SessionHeader.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SessionHeader)
                return object;
            let message = new $root.sync_pb.SessionHeader();
            if (object.window) {
                if (!Array.isArray(object.window))
                    throw TypeError(".sync_pb.SessionHeader.window: array expected");
                message.window = [];
                for (let i = 0; i < object.window.length; ++i) {
                    if (typeof object.window[i] !== "object")
                        throw TypeError(".sync_pb.SessionHeader.window: object expected");
                    message.window[i] = $root.sync_pb.SessionWindow.fromObject(object.window[i]);
                }
            }
            if (object.clientName != null)
                message.clientName = String(object.clientName);
            switch (object.deviceType) {
            case "TYPE_UNSET":
            case 0:
                message.deviceType = 0;
                break;
            case "TYPE_WIN":
            case 1:
                message.deviceType = 1;
                break;
            case "TYPE_MAC":
            case 2:
                message.deviceType = 2;
                break;
            case "TYPE_LINUX":
            case 3:
                message.deviceType = 3;
                break;
            case "TYPE_CROS":
            case 4:
                message.deviceType = 4;
                break;
            case "TYPE_OTHER":
            case 5:
                message.deviceType = 5;
                break;
            case "TYPE_PHONE":
            case 6:
                message.deviceType = 6;
                break;
            case "TYPE_TABLET":
            case 7:
                message.deviceType = 7;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a SessionHeader message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SessionHeader
         * @static
         * @param {sync_pb.SessionHeader} message SessionHeader
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SessionHeader.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.window = [];
            if (options.defaults) {
                object.clientName = "";
                object.deviceType = options.enums === String ? "TYPE_UNSET" : 0;
            }
            if (message.window && message.window.length) {
                object.window = [];
                for (let j = 0; j < message.window.length; ++j)
                    object.window[j] = $root.sync_pb.SessionWindow.toObject(message.window[j], options);
            }
            if (message.clientName != null && message.hasOwnProperty("clientName"))
                object.clientName = message.clientName;
            if (message.deviceType != null && message.hasOwnProperty("deviceType"))
                object.deviceType = options.enums === String ? $root.sync_pb.SyncEnums.DeviceType[message.deviceType] : message.deviceType;
            return object;
        };

        /**
         * Converts this SessionHeader to JSON.
         * @function toJSON
         * @memberof sync_pb.SessionHeader
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SessionHeader.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SessionHeader;
    })();

    sync_pb.SessionWindow = (function() {

        /**
         * Properties of a SessionWindow.
         * @memberof sync_pb
         * @interface ISessionWindow
         * @property {number|null} [windowId] SessionWindow windowId
         * @property {number|null} [selectedTabIndex] SessionWindow selectedTabIndex
         * @property {sync_pb.SessionWindow.BrowserType|null} [browserType] SessionWindow browserType
         * @property {Array.<number>|null} [tab] SessionWindow tab
         */

        /**
         * Constructs a new SessionWindow.
         * @memberof sync_pb
         * @classdesc Represents a SessionWindow.
         * @implements ISessionWindow
         * @constructor
         * @param {sync_pb.ISessionWindow=} [properties] Properties to set
         */
        function SessionWindow(properties) {
            this.tab = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SessionWindow windowId.
         * @member {number} windowId
         * @memberof sync_pb.SessionWindow
         * @instance
         */
        SessionWindow.prototype.windowId = 0;

        /**
         * SessionWindow selectedTabIndex.
         * @member {number} selectedTabIndex
         * @memberof sync_pb.SessionWindow
         * @instance
         */
        SessionWindow.prototype.selectedTabIndex = -1;

        /**
         * SessionWindow browserType.
         * @member {sync_pb.SessionWindow.BrowserType} browserType
         * @memberof sync_pb.SessionWindow
         * @instance
         */
        SessionWindow.prototype.browserType = 1;

        /**
         * SessionWindow tab.
         * @member {Array.<number>} tab
         * @memberof sync_pb.SessionWindow
         * @instance
         */
        SessionWindow.prototype.tab = $util.emptyArray;

        /**
         * Creates a new SessionWindow instance using the specified properties.
         * @function create
         * @memberof sync_pb.SessionWindow
         * @static
         * @param {sync_pb.ISessionWindow=} [properties] Properties to set
         * @returns {sync_pb.SessionWindow} SessionWindow instance
         */
        SessionWindow.create = function create(properties) {
            return new SessionWindow(properties);
        };

        /**
         * Encodes the specified SessionWindow message. Does not implicitly {@link sync_pb.SessionWindow.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SessionWindow
         * @static
         * @param {sync_pb.ISessionWindow} message SessionWindow message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionWindow.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.windowId != null && Object.hasOwnProperty.call(message, "windowId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.windowId);
            if (message.selectedTabIndex != null && Object.hasOwnProperty.call(message, "selectedTabIndex"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.selectedTabIndex);
            if (message.browserType != null && Object.hasOwnProperty.call(message, "browserType"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.browserType);
            if (message.tab != null && message.tab.length)
                for (let i = 0; i < message.tab.length; ++i)
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.tab[i]);
            return writer;
        };

        /**
         * Encodes the specified SessionWindow message, length delimited. Does not implicitly {@link sync_pb.SessionWindow.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SessionWindow
         * @static
         * @param {sync_pb.ISessionWindow} message SessionWindow message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionWindow.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SessionWindow message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SessionWindow
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SessionWindow} SessionWindow
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionWindow.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SessionWindow();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.windowId = reader.int32();
                    break;
                case 2:
                    message.selectedTabIndex = reader.int32();
                    break;
                case 3:
                    message.browserType = reader.int32();
                    break;
                case 4:
                    if (!(message.tab && message.tab.length))
                        message.tab = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.tab.push(reader.int32());
                    } else
                        message.tab.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SessionWindow message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SessionWindow
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SessionWindow} SessionWindow
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionWindow.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SessionWindow message.
         * @function verify
         * @memberof sync_pb.SessionWindow
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SessionWindow.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.windowId != null && message.hasOwnProperty("windowId"))
                if (!$util.isInteger(message.windowId))
                    return "windowId: integer expected";
            if (message.selectedTabIndex != null && message.hasOwnProperty("selectedTabIndex"))
                if (!$util.isInteger(message.selectedTabIndex))
                    return "selectedTabIndex: integer expected";
            if (message.browserType != null && message.hasOwnProperty("browserType"))
                switch (message.browserType) {
                default:
                    return "browserType: enum value expected";
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.tab != null && message.hasOwnProperty("tab")) {
                if (!Array.isArray(message.tab))
                    return "tab: array expected";
                for (let i = 0; i < message.tab.length; ++i)
                    if (!$util.isInteger(message.tab[i]))
                        return "tab: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a SessionWindow message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SessionWindow
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SessionWindow} SessionWindow
         */
        SessionWindow.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SessionWindow)
                return object;
            let message = new $root.sync_pb.SessionWindow();
            if (object.windowId != null)
                message.windowId = object.windowId | 0;
            if (object.selectedTabIndex != null)
                message.selectedTabIndex = object.selectedTabIndex | 0;
            switch (object.browserType) {
            case "TYPE_TABBED":
            case 1:
                message.browserType = 1;
                break;
            case "TYPE_POPUP":
            case 2:
                message.browserType = 2;
                break;
            case "TYPE_CUSTOM_TAB":
            case 3:
                message.browserType = 3;
                break;
            }
            if (object.tab) {
                if (!Array.isArray(object.tab))
                    throw TypeError(".sync_pb.SessionWindow.tab: array expected");
                message.tab = [];
                for (let i = 0; i < object.tab.length; ++i)
                    message.tab[i] = object.tab[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a SessionWindow message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SessionWindow
         * @static
         * @param {sync_pb.SessionWindow} message SessionWindow
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SessionWindow.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.tab = [];
            if (options.defaults) {
                object.windowId = 0;
                object.selectedTabIndex = -1;
                object.browserType = options.enums === String ? "TYPE_TABBED" : 1;
            }
            if (message.windowId != null && message.hasOwnProperty("windowId"))
                object.windowId = message.windowId;
            if (message.selectedTabIndex != null && message.hasOwnProperty("selectedTabIndex"))
                object.selectedTabIndex = message.selectedTabIndex;
            if (message.browserType != null && message.hasOwnProperty("browserType"))
                object.browserType = options.enums === String ? $root.sync_pb.SessionWindow.BrowserType[message.browserType] : message.browserType;
            if (message.tab && message.tab.length) {
                object.tab = [];
                for (let j = 0; j < message.tab.length; ++j)
                    object.tab[j] = message.tab[j];
            }
            return object;
        };

        /**
         * Converts this SessionWindow to JSON.
         * @function toJSON
         * @memberof sync_pb.SessionWindow
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SessionWindow.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * BrowserType enum.
         * @name sync_pb.SessionWindow.BrowserType
         * @enum {number}
         * @property {number} TYPE_TABBED=1 TYPE_TABBED value
         * @property {number} TYPE_POPUP=2 TYPE_POPUP value
         * @property {number} TYPE_CUSTOM_TAB=3 TYPE_CUSTOM_TAB value
         */
        SessionWindow.BrowserType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "TYPE_TABBED"] = 1;
            values[valuesById[2] = "TYPE_POPUP"] = 2;
            values[valuesById[3] = "TYPE_CUSTOM_TAB"] = 3;
            return values;
        })();

        return SessionWindow;
    })();

    sync_pb.SessionTab = (function() {

        /**
         * Properties of a SessionTab.
         * @memberof sync_pb
         * @interface ISessionTab
         * @property {number|null} [tabId] SessionTab tabId
         * @property {number|null} [windowId] SessionTab windowId
         * @property {number|null} [tabVisualIndex] SessionTab tabVisualIndex
         * @property {number|null} [currentNavigationIndex] SessionTab currentNavigationIndex
         * @property {boolean|null} [pinned] SessionTab pinned
         * @property {string|null} [extensionAppId] SessionTab extensionAppId
         * @property {Array.<sync_pb.ITabNavigation>|null} [navigation] SessionTab navigation
         * @property {Uint8Array|null} [favicon] SessionTab favicon
         * @property {sync_pb.SessionTab.FaviconType|null} [faviconType] SessionTab faviconType
         * @property {string|null} [faviconSource] SessionTab faviconSource
         * @property {Array.<number|Long>|null} [variationId] SessionTab variationId
         */

        /**
         * Constructs a new SessionTab.
         * @memberof sync_pb
         * @classdesc Represents a SessionTab.
         * @implements ISessionTab
         * @constructor
         * @param {sync_pb.ISessionTab=} [properties] Properties to set
         */
        function SessionTab(properties) {
            this.navigation = [];
            this.variationId = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SessionTab tabId.
         * @member {number} tabId
         * @memberof sync_pb.SessionTab
         * @instance
         */
        SessionTab.prototype.tabId = -1;

        /**
         * SessionTab windowId.
         * @member {number} windowId
         * @memberof sync_pb.SessionTab
         * @instance
         */
        SessionTab.prototype.windowId = 0;

        /**
         * SessionTab tabVisualIndex.
         * @member {number} tabVisualIndex
         * @memberof sync_pb.SessionTab
         * @instance
         */
        SessionTab.prototype.tabVisualIndex = -1;

        /**
         * SessionTab currentNavigationIndex.
         * @member {number} currentNavigationIndex
         * @memberof sync_pb.SessionTab
         * @instance
         */
        SessionTab.prototype.currentNavigationIndex = -1;

        /**
         * SessionTab pinned.
         * @member {boolean} pinned
         * @memberof sync_pb.SessionTab
         * @instance
         */
        SessionTab.prototype.pinned = false;

        /**
         * SessionTab extensionAppId.
         * @member {string} extensionAppId
         * @memberof sync_pb.SessionTab
         * @instance
         */
        SessionTab.prototype.extensionAppId = "";

        /**
         * SessionTab navigation.
         * @member {Array.<sync_pb.ITabNavigation>} navigation
         * @memberof sync_pb.SessionTab
         * @instance
         */
        SessionTab.prototype.navigation = $util.emptyArray;

        /**
         * SessionTab favicon.
         * @member {Uint8Array} favicon
         * @memberof sync_pb.SessionTab
         * @instance
         */
        SessionTab.prototype.favicon = $util.newBuffer([]);

        /**
         * SessionTab faviconType.
         * @member {sync_pb.SessionTab.FaviconType} faviconType
         * @memberof sync_pb.SessionTab
         * @instance
         */
        SessionTab.prototype.faviconType = 1;

        /**
         * SessionTab faviconSource.
         * @member {string} faviconSource
         * @memberof sync_pb.SessionTab
         * @instance
         */
        SessionTab.prototype.faviconSource = "";

        /**
         * SessionTab variationId.
         * @member {Array.<number|Long>} variationId
         * @memberof sync_pb.SessionTab
         * @instance
         */
        SessionTab.prototype.variationId = $util.emptyArray;

        /**
         * Creates a new SessionTab instance using the specified properties.
         * @function create
         * @memberof sync_pb.SessionTab
         * @static
         * @param {sync_pb.ISessionTab=} [properties] Properties to set
         * @returns {sync_pb.SessionTab} SessionTab instance
         */
        SessionTab.create = function create(properties) {
            return new SessionTab(properties);
        };

        /**
         * Encodes the specified SessionTab message. Does not implicitly {@link sync_pb.SessionTab.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.SessionTab
         * @static
         * @param {sync_pb.ISessionTab} message SessionTab message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionTab.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.tabId != null && Object.hasOwnProperty.call(message, "tabId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.tabId);
            if (message.windowId != null && Object.hasOwnProperty.call(message, "windowId"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.windowId);
            if (message.tabVisualIndex != null && Object.hasOwnProperty.call(message, "tabVisualIndex"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.tabVisualIndex);
            if (message.currentNavigationIndex != null && Object.hasOwnProperty.call(message, "currentNavigationIndex"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.currentNavigationIndex);
            if (message.pinned != null && Object.hasOwnProperty.call(message, "pinned"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.pinned);
            if (message.extensionAppId != null && Object.hasOwnProperty.call(message, "extensionAppId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.extensionAppId);
            if (message.navigation != null && message.navigation.length)
                for (let i = 0; i < message.navigation.length; ++i)
                    $root.sync_pb.TabNavigation.encode(message.navigation[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.favicon != null && Object.hasOwnProperty.call(message, "favicon"))
                writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.favicon);
            if (message.faviconType != null && Object.hasOwnProperty.call(message, "faviconType"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.faviconType);
            if (message.faviconSource != null && Object.hasOwnProperty.call(message, "faviconSource"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.faviconSource);
            if (message.variationId != null && message.variationId.length)
                for (let i = 0; i < message.variationId.length; ++i)
                    writer.uint32(/* id 12, wireType 0 =*/96).uint64(message.variationId[i]);
            return writer;
        };

        /**
         * Encodes the specified SessionTab message, length delimited. Does not implicitly {@link sync_pb.SessionTab.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.SessionTab
         * @static
         * @param {sync_pb.ISessionTab} message SessionTab message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionTab.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SessionTab message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.SessionTab
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.SessionTab} SessionTab
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionTab.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.SessionTab();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.tabId = reader.int32();
                    break;
                case 2:
                    message.windowId = reader.int32();
                    break;
                case 3:
                    message.tabVisualIndex = reader.int32();
                    break;
                case 4:
                    message.currentNavigationIndex = reader.int32();
                    break;
                case 5:
                    message.pinned = reader.bool();
                    break;
                case 6:
                    message.extensionAppId = reader.string();
                    break;
                case 7:
                    if (!(message.navigation && message.navigation.length))
                        message.navigation = [];
                    message.navigation.push($root.sync_pb.TabNavigation.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.favicon = reader.bytes();
                    break;
                case 9:
                    message.faviconType = reader.int32();
                    break;
                case 11:
                    message.faviconSource = reader.string();
                    break;
                case 12:
                    if (!(message.variationId && message.variationId.length))
                        message.variationId = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.variationId.push(reader.uint64());
                    } else
                        message.variationId.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SessionTab message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.SessionTab
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.SessionTab} SessionTab
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionTab.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SessionTab message.
         * @function verify
         * @memberof sync_pb.SessionTab
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SessionTab.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.tabId != null && message.hasOwnProperty("tabId"))
                if (!$util.isInteger(message.tabId))
                    return "tabId: integer expected";
            if (message.windowId != null && message.hasOwnProperty("windowId"))
                if (!$util.isInteger(message.windowId))
                    return "windowId: integer expected";
            if (message.tabVisualIndex != null && message.hasOwnProperty("tabVisualIndex"))
                if (!$util.isInteger(message.tabVisualIndex))
                    return "tabVisualIndex: integer expected";
            if (message.currentNavigationIndex != null && message.hasOwnProperty("currentNavigationIndex"))
                if (!$util.isInteger(message.currentNavigationIndex))
                    return "currentNavigationIndex: integer expected";
            if (message.pinned != null && message.hasOwnProperty("pinned"))
                if (typeof message.pinned !== "boolean")
                    return "pinned: boolean expected";
            if (message.extensionAppId != null && message.hasOwnProperty("extensionAppId"))
                if (!$util.isString(message.extensionAppId))
                    return "extensionAppId: string expected";
            if (message.navigation != null && message.hasOwnProperty("navigation")) {
                if (!Array.isArray(message.navigation))
                    return "navigation: array expected";
                for (let i = 0; i < message.navigation.length; ++i) {
                    let error = $root.sync_pb.TabNavigation.verify(message.navigation[i]);
                    if (error)
                        return "navigation." + error;
                }
            }
            if (message.favicon != null && message.hasOwnProperty("favicon"))
                if (!(message.favicon && typeof message.favicon.length === "number" || $util.isString(message.favicon)))
                    return "favicon: buffer expected";
            if (message.faviconType != null && message.hasOwnProperty("faviconType"))
                switch (message.faviconType) {
                default:
                    return "faviconType: enum value expected";
                case 1:
                    break;
                }
            if (message.faviconSource != null && message.hasOwnProperty("faviconSource"))
                if (!$util.isString(message.faviconSource))
                    return "faviconSource: string expected";
            if (message.variationId != null && message.hasOwnProperty("variationId")) {
                if (!Array.isArray(message.variationId))
                    return "variationId: array expected";
                for (let i = 0; i < message.variationId.length; ++i)
                    if (!$util.isInteger(message.variationId[i]) && !(message.variationId[i] && $util.isInteger(message.variationId[i].low) && $util.isInteger(message.variationId[i].high)))
                        return "variationId: integer|Long[] expected";
            }
            return null;
        };

        /**
         * Creates a SessionTab message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.SessionTab
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.SessionTab} SessionTab
         */
        SessionTab.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.SessionTab)
                return object;
            let message = new $root.sync_pb.SessionTab();
            if (object.tabId != null)
                message.tabId = object.tabId | 0;
            if (object.windowId != null)
                message.windowId = object.windowId | 0;
            if (object.tabVisualIndex != null)
                message.tabVisualIndex = object.tabVisualIndex | 0;
            if (object.currentNavigationIndex != null)
                message.currentNavigationIndex = object.currentNavigationIndex | 0;
            if (object.pinned != null)
                message.pinned = Boolean(object.pinned);
            if (object.extensionAppId != null)
                message.extensionAppId = String(object.extensionAppId);
            if (object.navigation) {
                if (!Array.isArray(object.navigation))
                    throw TypeError(".sync_pb.SessionTab.navigation: array expected");
                message.navigation = [];
                for (let i = 0; i < object.navigation.length; ++i) {
                    if (typeof object.navigation[i] !== "object")
                        throw TypeError(".sync_pb.SessionTab.navigation: object expected");
                    message.navigation[i] = $root.sync_pb.TabNavigation.fromObject(object.navigation[i]);
                }
            }
            if (object.favicon != null)
                if (typeof object.favicon === "string")
                    $util.base64.decode(object.favicon, message.favicon = $util.newBuffer($util.base64.length(object.favicon)), 0);
                else if (object.favicon.length)
                    message.favicon = object.favicon;
            switch (object.faviconType) {
            case "TYPE_WEB_FAVICON":
            case 1:
                message.faviconType = 1;
                break;
            }
            if (object.faviconSource != null)
                message.faviconSource = String(object.faviconSource);
            if (object.variationId) {
                if (!Array.isArray(object.variationId))
                    throw TypeError(".sync_pb.SessionTab.variationId: array expected");
                message.variationId = [];
                for (let i = 0; i < object.variationId.length; ++i)
                    if ($util.Long)
                        (message.variationId[i] = $util.Long.fromValue(object.variationId[i])).unsigned = true;
                    else if (typeof object.variationId[i] === "string")
                        message.variationId[i] = parseInt(object.variationId[i], 10);
                    else if (typeof object.variationId[i] === "number")
                        message.variationId[i] = object.variationId[i];
                    else if (typeof object.variationId[i] === "object")
                        message.variationId[i] = new $util.LongBits(object.variationId[i].low >>> 0, object.variationId[i].high >>> 0).toNumber(true);
            }
            return message;
        };

        /**
         * Creates a plain object from a SessionTab message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.SessionTab
         * @static
         * @param {sync_pb.SessionTab} message SessionTab
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SessionTab.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.navigation = [];
                object.variationId = [];
            }
            if (options.defaults) {
                object.tabId = -1;
                object.windowId = 0;
                object.tabVisualIndex = -1;
                object.currentNavigationIndex = -1;
                object.pinned = false;
                object.extensionAppId = "";
                if (options.bytes === String)
                    object.favicon = "";
                else {
                    object.favicon = [];
                    if (options.bytes !== Array)
                        object.favicon = $util.newBuffer(object.favicon);
                }
                object.faviconType = options.enums === String ? "TYPE_WEB_FAVICON" : 1;
                object.faviconSource = "";
            }
            if (message.tabId != null && message.hasOwnProperty("tabId"))
                object.tabId = message.tabId;
            if (message.windowId != null && message.hasOwnProperty("windowId"))
                object.windowId = message.windowId;
            if (message.tabVisualIndex != null && message.hasOwnProperty("tabVisualIndex"))
                object.tabVisualIndex = message.tabVisualIndex;
            if (message.currentNavigationIndex != null && message.hasOwnProperty("currentNavigationIndex"))
                object.currentNavigationIndex = message.currentNavigationIndex;
            if (message.pinned != null && message.hasOwnProperty("pinned"))
                object.pinned = message.pinned;
            if (message.extensionAppId != null && message.hasOwnProperty("extensionAppId"))
                object.extensionAppId = message.extensionAppId;
            if (message.navigation && message.navigation.length) {
                object.navigation = [];
                for (let j = 0; j < message.navigation.length; ++j)
                    object.navigation[j] = $root.sync_pb.TabNavigation.toObject(message.navigation[j], options);
            }
            if (message.favicon != null && message.hasOwnProperty("favicon"))
                object.favicon = options.bytes === String ? $util.base64.encode(message.favicon, 0, message.favicon.length) : options.bytes === Array ? Array.prototype.slice.call(message.favicon) : message.favicon;
            if (message.faviconType != null && message.hasOwnProperty("faviconType"))
                object.faviconType = options.enums === String ? $root.sync_pb.SessionTab.FaviconType[message.faviconType] : message.faviconType;
            if (message.faviconSource != null && message.hasOwnProperty("faviconSource"))
                object.faviconSource = message.faviconSource;
            if (message.variationId && message.variationId.length) {
                object.variationId = [];
                for (let j = 0; j < message.variationId.length; ++j)
                    if (typeof message.variationId[j] === "number")
                        object.variationId[j] = options.longs === String ? String(message.variationId[j]) : message.variationId[j];
                    else
                        object.variationId[j] = options.longs === String ? $util.Long.prototype.toString.call(message.variationId[j]) : options.longs === Number ? new $util.LongBits(message.variationId[j].low >>> 0, message.variationId[j].high >>> 0).toNumber(true) : message.variationId[j];
            }
            return object;
        };

        /**
         * Converts this SessionTab to JSON.
         * @function toJSON
         * @memberof sync_pb.SessionTab
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SessionTab.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * FaviconType enum.
         * @name sync_pb.SessionTab.FaviconType
         * @enum {number}
         * @property {number} TYPE_WEB_FAVICON=1 TYPE_WEB_FAVICON value
         */
        SessionTab.FaviconType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "TYPE_WEB_FAVICON"] = 1;
            return values;
        })();

        return SessionTab;
    })();

    sync_pb.TabNavigation = (function() {

        /**
         * Properties of a TabNavigation.
         * @memberof sync_pb
         * @interface ITabNavigation
         * @property {string|null} [virtualUrl] TabNavigation virtualUrl
         * @property {string|null} [referrer] TabNavigation referrer
         * @property {string|null} [title] TabNavigation title
         * @property {sync_pb.SyncEnums.PageTransition|null} [pageTransition] TabNavigation pageTransition
         * @property {sync_pb.SyncEnums.PageTransitionRedirectType|null} [redirectType] TabNavigation redirectType
         * @property {number|null} [uniqueId] TabNavigation uniqueId
         * @property {number|Long|null} [timestampMsec] TabNavigation timestampMsec
         * @property {boolean|null} [navigationForwardBack] TabNavigation navigationForwardBack
         * @property {boolean|null} [navigationFromAddressBar] TabNavigation navigationFromAddressBar
         * @property {boolean|null} [navigationHomePage] TabNavigation navigationHomePage
         * @property {boolean|null} [navigationChainStart] TabNavigation navigationChainStart
         * @property {boolean|null} [navigationChainEnd] TabNavigation navigationChainEnd
         * @property {number|Long|null} [globalId] TabNavigation globalId
         * @property {string|null} [searchTerms] TabNavigation searchTerms
         * @property {string|null} [faviconUrl] TabNavigation faviconUrl
         * @property {sync_pb.TabNavigation.BlockedState|null} [blockedState] TabNavigation blockedState
         * @property {Array.<string>|null} [contentPackCategories] TabNavigation contentPackCategories
         * @property {number|null} [httpStatusCode] TabNavigation httpStatusCode
         * @property {number|null} [obsoleteReferrerPolicy] TabNavigation obsoleteReferrerPolicy
         * @property {boolean|null} [isRestored] TabNavigation isRestored
         * @property {Array.<sync_pb.INavigationRedirect>|null} [navigationRedirect] TabNavigation navigationRedirect
         * @property {string|null} [lastNavigationRedirectUrl] TabNavigation lastNavigationRedirectUrl
         * @property {number|null} [correctReferrerPolicy] TabNavigation correctReferrerPolicy
         * @property {sync_pb.TabNavigation.PasswordState|null} [passwordState] TabNavigation passwordState
         * @property {number|Long|null} [taskId] TabNavigation taskId
         * @property {Array.<number|Long>|null} [ancestorTaskId] TabNavigation ancestorTaskId
         * @property {sync_pb.IReplacedNavigation|null} [replacedNavigation] TabNavigation replacedNavigation
         * @property {string|null} [pageLanguage] TabNavigation pageLanguage
         */

        /**
         * Constructs a new TabNavigation.
         * @memberof sync_pb
         * @classdesc Represents a TabNavigation.
         * @implements ITabNavigation
         * @constructor
         * @param {sync_pb.ITabNavigation=} [properties] Properties to set
         */
        function TabNavigation(properties) {
            this.contentPackCategories = [];
            this.navigationRedirect = [];
            this.ancestorTaskId = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TabNavigation virtualUrl.
         * @member {string} virtualUrl
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.virtualUrl = "";

        /**
         * TabNavigation referrer.
         * @member {string} referrer
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.referrer = "";

        /**
         * TabNavigation title.
         * @member {string} title
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.title = "";

        /**
         * TabNavigation pageTransition.
         * @member {sync_pb.SyncEnums.PageTransition} pageTransition
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.pageTransition = 0;

        /**
         * TabNavigation redirectType.
         * @member {sync_pb.SyncEnums.PageTransitionRedirectType} redirectType
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.redirectType = 1;

        /**
         * TabNavigation uniqueId.
         * @member {number} uniqueId
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.uniqueId = 0;

        /**
         * TabNavigation timestampMsec.
         * @member {number|Long} timestampMsec
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.timestampMsec = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TabNavigation navigationForwardBack.
         * @member {boolean} navigationForwardBack
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.navigationForwardBack = false;

        /**
         * TabNavigation navigationFromAddressBar.
         * @member {boolean} navigationFromAddressBar
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.navigationFromAddressBar = false;

        /**
         * TabNavigation navigationHomePage.
         * @member {boolean} navigationHomePage
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.navigationHomePage = false;

        /**
         * TabNavigation navigationChainStart.
         * @member {boolean} navigationChainStart
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.navigationChainStart = false;

        /**
         * TabNavigation navigationChainEnd.
         * @member {boolean} navigationChainEnd
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.navigationChainEnd = false;

        /**
         * TabNavigation globalId.
         * @member {number|Long} globalId
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.globalId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TabNavigation searchTerms.
         * @member {string} searchTerms
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.searchTerms = "";

        /**
         * TabNavigation faviconUrl.
         * @member {string} faviconUrl
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.faviconUrl = "";

        /**
         * TabNavigation blockedState.
         * @member {sync_pb.TabNavigation.BlockedState} blockedState
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.blockedState = 1;

        /**
         * TabNavigation contentPackCategories.
         * @member {Array.<string>} contentPackCategories
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.contentPackCategories = $util.emptyArray;

        /**
         * TabNavigation httpStatusCode.
         * @member {number} httpStatusCode
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.httpStatusCode = 0;

        /**
         * TabNavigation obsoleteReferrerPolicy.
         * @member {number} obsoleteReferrerPolicy
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.obsoleteReferrerPolicy = 0;

        /**
         * TabNavigation isRestored.
         * @member {boolean} isRestored
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.isRestored = false;

        /**
         * TabNavigation navigationRedirect.
         * @member {Array.<sync_pb.INavigationRedirect>} navigationRedirect
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.navigationRedirect = $util.emptyArray;

        /**
         * TabNavigation lastNavigationRedirectUrl.
         * @member {string} lastNavigationRedirectUrl
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.lastNavigationRedirectUrl = "";

        /**
         * TabNavigation correctReferrerPolicy.
         * @member {number} correctReferrerPolicy
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.correctReferrerPolicy = 1;

        /**
         * TabNavigation passwordState.
         * @member {sync_pb.TabNavigation.PasswordState} passwordState
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.passwordState = 0;

        /**
         * TabNavigation taskId.
         * @member {number|Long} taskId
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.taskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TabNavigation ancestorTaskId.
         * @member {Array.<number|Long>} ancestorTaskId
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.ancestorTaskId = $util.emptyArray;

        /**
         * TabNavigation replacedNavigation.
         * @member {sync_pb.IReplacedNavigation|null|undefined} replacedNavigation
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.replacedNavigation = null;

        /**
         * TabNavigation pageLanguage.
         * @member {string} pageLanguage
         * @memberof sync_pb.TabNavigation
         * @instance
         */
        TabNavigation.prototype.pageLanguage = "";

        /**
         * Creates a new TabNavigation instance using the specified properties.
         * @function create
         * @memberof sync_pb.TabNavigation
         * @static
         * @param {sync_pb.ITabNavigation=} [properties] Properties to set
         * @returns {sync_pb.TabNavigation} TabNavigation instance
         */
        TabNavigation.create = function create(properties) {
            return new TabNavigation(properties);
        };

        /**
         * Encodes the specified TabNavigation message. Does not implicitly {@link sync_pb.TabNavigation.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.TabNavigation
         * @static
         * @param {sync_pb.ITabNavigation} message TabNavigation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TabNavigation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.virtualUrl != null && Object.hasOwnProperty.call(message, "virtualUrl"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.virtualUrl);
            if (message.referrer != null && Object.hasOwnProperty.call(message, "referrer"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.referrer);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.title);
            if (message.pageTransition != null && Object.hasOwnProperty.call(message, "pageTransition"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.pageTransition);
            if (message.redirectType != null && Object.hasOwnProperty.call(message, "redirectType"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.redirectType);
            if (message.uniqueId != null && Object.hasOwnProperty.call(message, "uniqueId"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.uniqueId);
            if (message.timestampMsec != null && Object.hasOwnProperty.call(message, "timestampMsec"))
                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.timestampMsec);
            if (message.navigationForwardBack != null && Object.hasOwnProperty.call(message, "navigationForwardBack"))
                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.navigationForwardBack);
            if (message.navigationFromAddressBar != null && Object.hasOwnProperty.call(message, "navigationFromAddressBar"))
                writer.uint32(/* id 11, wireType 0 =*/88).bool(message.navigationFromAddressBar);
            if (message.navigationHomePage != null && Object.hasOwnProperty.call(message, "navigationHomePage"))
                writer.uint32(/* id 12, wireType 0 =*/96).bool(message.navigationHomePage);
            if (message.navigationChainStart != null && Object.hasOwnProperty.call(message, "navigationChainStart"))
                writer.uint32(/* id 13, wireType 0 =*/104).bool(message.navigationChainStart);
            if (message.navigationChainEnd != null && Object.hasOwnProperty.call(message, "navigationChainEnd"))
                writer.uint32(/* id 14, wireType 0 =*/112).bool(message.navigationChainEnd);
            if (message.globalId != null && Object.hasOwnProperty.call(message, "globalId"))
                writer.uint32(/* id 15, wireType 0 =*/120).int64(message.globalId);
            if (message.searchTerms != null && Object.hasOwnProperty.call(message, "searchTerms"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.searchTerms);
            if (message.faviconUrl != null && Object.hasOwnProperty.call(message, "faviconUrl"))
                writer.uint32(/* id 17, wireType 2 =*/138).string(message.faviconUrl);
            if (message.blockedState != null && Object.hasOwnProperty.call(message, "blockedState"))
                writer.uint32(/* id 18, wireType 0 =*/144).int32(message.blockedState);
            if (message.contentPackCategories != null && message.contentPackCategories.length)
                for (let i = 0; i < message.contentPackCategories.length; ++i)
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.contentPackCategories[i]);
            if (message.httpStatusCode != null && Object.hasOwnProperty.call(message, "httpStatusCode"))
                writer.uint32(/* id 20, wireType 0 =*/160).int32(message.httpStatusCode);
            if (message.obsoleteReferrerPolicy != null && Object.hasOwnProperty.call(message, "obsoleteReferrerPolicy"))
                writer.uint32(/* id 21, wireType 0 =*/168).int32(message.obsoleteReferrerPolicy);
            if (message.isRestored != null && Object.hasOwnProperty.call(message, "isRestored"))
                writer.uint32(/* id 22, wireType 0 =*/176).bool(message.isRestored);
            if (message.navigationRedirect != null && message.navigationRedirect.length)
                for (let i = 0; i < message.navigationRedirect.length; ++i)
                    $root.sync_pb.NavigationRedirect.encode(message.navigationRedirect[i], writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
            if (message.lastNavigationRedirectUrl != null && Object.hasOwnProperty.call(message, "lastNavigationRedirectUrl"))
                writer.uint32(/* id 24, wireType 2 =*/194).string(message.lastNavigationRedirectUrl);
            if (message.correctReferrerPolicy != null && Object.hasOwnProperty.call(message, "correctReferrerPolicy"))
                writer.uint32(/* id 25, wireType 0 =*/200).int32(message.correctReferrerPolicy);
            if (message.passwordState != null && Object.hasOwnProperty.call(message, "passwordState"))
                writer.uint32(/* id 26, wireType 0 =*/208).int32(message.passwordState);
            if (message.taskId != null && Object.hasOwnProperty.call(message, "taskId"))
                writer.uint32(/* id 27, wireType 0 =*/216).int64(message.taskId);
            if (message.ancestorTaskId != null && message.ancestorTaskId.length)
                for (let i = 0; i < message.ancestorTaskId.length; ++i)
                    writer.uint32(/* id 28, wireType 0 =*/224).int64(message.ancestorTaskId[i]);
            if (message.replacedNavigation != null && Object.hasOwnProperty.call(message, "replacedNavigation"))
                $root.sync_pb.ReplacedNavigation.encode(message.replacedNavigation, writer.uint32(/* id 29, wireType 2 =*/234).fork()).ldelim();
            if (message.pageLanguage != null && Object.hasOwnProperty.call(message, "pageLanguage"))
                writer.uint32(/* id 30, wireType 2 =*/242).string(message.pageLanguage);
            return writer;
        };

        /**
         * Encodes the specified TabNavigation message, length delimited. Does not implicitly {@link sync_pb.TabNavigation.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.TabNavigation
         * @static
         * @param {sync_pb.ITabNavigation} message TabNavigation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TabNavigation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TabNavigation message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.TabNavigation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.TabNavigation} TabNavigation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TabNavigation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.TabNavigation();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 2:
                    message.virtualUrl = reader.string();
                    break;
                case 3:
                    message.referrer = reader.string();
                    break;
                case 4:
                    message.title = reader.string();
                    break;
                case 6:
                    message.pageTransition = reader.int32();
                    break;
                case 7:
                    message.redirectType = reader.int32();
                    break;
                case 8:
                    message.uniqueId = reader.int32();
                    break;
                case 9:
                    message.timestampMsec = reader.int64();
                    break;
                case 10:
                    message.navigationForwardBack = reader.bool();
                    break;
                case 11:
                    message.navigationFromAddressBar = reader.bool();
                    break;
                case 12:
                    message.navigationHomePage = reader.bool();
                    break;
                case 13:
                    message.navigationChainStart = reader.bool();
                    break;
                case 14:
                    message.navigationChainEnd = reader.bool();
                    break;
                case 15:
                    message.globalId = reader.int64();
                    break;
                case 16:
                    message.searchTerms = reader.string();
                    break;
                case 17:
                    message.faviconUrl = reader.string();
                    break;
                case 18:
                    message.blockedState = reader.int32();
                    break;
                case 19:
                    if (!(message.contentPackCategories && message.contentPackCategories.length))
                        message.contentPackCategories = [];
                    message.contentPackCategories.push(reader.string());
                    break;
                case 20:
                    message.httpStatusCode = reader.int32();
                    break;
                case 21:
                    message.obsoleteReferrerPolicy = reader.int32();
                    break;
                case 22:
                    message.isRestored = reader.bool();
                    break;
                case 23:
                    if (!(message.navigationRedirect && message.navigationRedirect.length))
                        message.navigationRedirect = [];
                    message.navigationRedirect.push($root.sync_pb.NavigationRedirect.decode(reader, reader.uint32()));
                    break;
                case 24:
                    message.lastNavigationRedirectUrl = reader.string();
                    break;
                case 25:
                    message.correctReferrerPolicy = reader.int32();
                    break;
                case 26:
                    message.passwordState = reader.int32();
                    break;
                case 27:
                    message.taskId = reader.int64();
                    break;
                case 28:
                    if (!(message.ancestorTaskId && message.ancestorTaskId.length))
                        message.ancestorTaskId = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.ancestorTaskId.push(reader.int64());
                    } else
                        message.ancestorTaskId.push(reader.int64());
                    break;
                case 29:
                    message.replacedNavigation = $root.sync_pb.ReplacedNavigation.decode(reader, reader.uint32());
                    break;
                case 30:
                    message.pageLanguage = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TabNavigation message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.TabNavigation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.TabNavigation} TabNavigation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TabNavigation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TabNavigation message.
         * @function verify
         * @memberof sync_pb.TabNavigation
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TabNavigation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.virtualUrl != null && message.hasOwnProperty("virtualUrl"))
                if (!$util.isString(message.virtualUrl))
                    return "virtualUrl: string expected";
            if (message.referrer != null && message.hasOwnProperty("referrer"))
                if (!$util.isString(message.referrer))
                    return "referrer: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.pageTransition != null && message.hasOwnProperty("pageTransition"))
                switch (message.pageTransition) {
                default:
                    return "pageTransition: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                    break;
                }
            if (message.redirectType != null && message.hasOwnProperty("redirectType"))
                switch (message.redirectType) {
                default:
                    return "redirectType: enum value expected";
                case 1:
                case 2:
                    break;
                }
            if (message.uniqueId != null && message.hasOwnProperty("uniqueId"))
                if (!$util.isInteger(message.uniqueId))
                    return "uniqueId: integer expected";
            if (message.timestampMsec != null && message.hasOwnProperty("timestampMsec"))
                if (!$util.isInteger(message.timestampMsec) && !(message.timestampMsec && $util.isInteger(message.timestampMsec.low) && $util.isInteger(message.timestampMsec.high)))
                    return "timestampMsec: integer|Long expected";
            if (message.navigationForwardBack != null && message.hasOwnProperty("navigationForwardBack"))
                if (typeof message.navigationForwardBack !== "boolean")
                    return "navigationForwardBack: boolean expected";
            if (message.navigationFromAddressBar != null && message.hasOwnProperty("navigationFromAddressBar"))
                if (typeof message.navigationFromAddressBar !== "boolean")
                    return "navigationFromAddressBar: boolean expected";
            if (message.navigationHomePage != null && message.hasOwnProperty("navigationHomePage"))
                if (typeof message.navigationHomePage !== "boolean")
                    return "navigationHomePage: boolean expected";
            if (message.navigationChainStart != null && message.hasOwnProperty("navigationChainStart"))
                if (typeof message.navigationChainStart !== "boolean")
                    return "navigationChainStart: boolean expected";
            if (message.navigationChainEnd != null && message.hasOwnProperty("navigationChainEnd"))
                if (typeof message.navigationChainEnd !== "boolean")
                    return "navigationChainEnd: boolean expected";
            if (message.globalId != null && message.hasOwnProperty("globalId"))
                if (!$util.isInteger(message.globalId) && !(message.globalId && $util.isInteger(message.globalId.low) && $util.isInteger(message.globalId.high)))
                    return "globalId: integer|Long expected";
            if (message.searchTerms != null && message.hasOwnProperty("searchTerms"))
                if (!$util.isString(message.searchTerms))
                    return "searchTerms: string expected";
            if (message.faviconUrl != null && message.hasOwnProperty("faviconUrl"))
                if (!$util.isString(message.faviconUrl))
                    return "faviconUrl: string expected";
            if (message.blockedState != null && message.hasOwnProperty("blockedState"))
                switch (message.blockedState) {
                default:
                    return "blockedState: enum value expected";
                case 1:
                case 2:
                    break;
                }
            if (message.contentPackCategories != null && message.hasOwnProperty("contentPackCategories")) {
                if (!Array.isArray(message.contentPackCategories))
                    return "contentPackCategories: array expected";
                for (let i = 0; i < message.contentPackCategories.length; ++i)
                    if (!$util.isString(message.contentPackCategories[i]))
                        return "contentPackCategories: string[] expected";
            }
            if (message.httpStatusCode != null && message.hasOwnProperty("httpStatusCode"))
                if (!$util.isInteger(message.httpStatusCode))
                    return "httpStatusCode: integer expected";
            if (message.obsoleteReferrerPolicy != null && message.hasOwnProperty("obsoleteReferrerPolicy"))
                if (!$util.isInteger(message.obsoleteReferrerPolicy))
                    return "obsoleteReferrerPolicy: integer expected";
            if (message.isRestored != null && message.hasOwnProperty("isRestored"))
                if (typeof message.isRestored !== "boolean")
                    return "isRestored: boolean expected";
            if (message.navigationRedirect != null && message.hasOwnProperty("navigationRedirect")) {
                if (!Array.isArray(message.navigationRedirect))
                    return "navigationRedirect: array expected";
                for (let i = 0; i < message.navigationRedirect.length; ++i) {
                    let error = $root.sync_pb.NavigationRedirect.verify(message.navigationRedirect[i]);
                    if (error)
                        return "navigationRedirect." + error;
                }
            }
            if (message.lastNavigationRedirectUrl != null && message.hasOwnProperty("lastNavigationRedirectUrl"))
                if (!$util.isString(message.lastNavigationRedirectUrl))
                    return "lastNavigationRedirectUrl: string expected";
            if (message.correctReferrerPolicy != null && message.hasOwnProperty("correctReferrerPolicy"))
                if (!$util.isInteger(message.correctReferrerPolicy))
                    return "correctReferrerPolicy: integer expected";
            if (message.passwordState != null && message.hasOwnProperty("passwordState"))
                switch (message.passwordState) {
                default:
                    return "passwordState: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.taskId != null && message.hasOwnProperty("taskId"))
                if (!$util.isInteger(message.taskId) && !(message.taskId && $util.isInteger(message.taskId.low) && $util.isInteger(message.taskId.high)))
                    return "taskId: integer|Long expected";
            if (message.ancestorTaskId != null && message.hasOwnProperty("ancestorTaskId")) {
                if (!Array.isArray(message.ancestorTaskId))
                    return "ancestorTaskId: array expected";
                for (let i = 0; i < message.ancestorTaskId.length; ++i)
                    if (!$util.isInteger(message.ancestorTaskId[i]) && !(message.ancestorTaskId[i] && $util.isInteger(message.ancestorTaskId[i].low) && $util.isInteger(message.ancestorTaskId[i].high)))
                        return "ancestorTaskId: integer|Long[] expected";
            }
            if (message.replacedNavigation != null && message.hasOwnProperty("replacedNavigation")) {
                let error = $root.sync_pb.ReplacedNavigation.verify(message.replacedNavigation);
                if (error)
                    return "replacedNavigation." + error;
            }
            if (message.pageLanguage != null && message.hasOwnProperty("pageLanguage"))
                if (!$util.isString(message.pageLanguage))
                    return "pageLanguage: string expected";
            return null;
        };

        /**
         * Creates a TabNavigation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.TabNavigation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.TabNavigation} TabNavigation
         */
        TabNavigation.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.TabNavigation)
                return object;
            let message = new $root.sync_pb.TabNavigation();
            if (object.virtualUrl != null)
                message.virtualUrl = String(object.virtualUrl);
            if (object.referrer != null)
                message.referrer = String(object.referrer);
            if (object.title != null)
                message.title = String(object.title);
            switch (object.pageTransition) {
            case "LINK":
            case 0:
                message.pageTransition = 0;
                break;
            case "TYPED":
            case 1:
                message.pageTransition = 1;
                break;
            case "AUTO_BOOKMARK":
            case 2:
                message.pageTransition = 2;
                break;
            case "AUTO_SUBFRAME":
            case 3:
                message.pageTransition = 3;
                break;
            case "MANUAL_SUBFRAME":
            case 4:
                message.pageTransition = 4;
                break;
            case "GENERATED":
            case 5:
                message.pageTransition = 5;
                break;
            case "AUTO_TOPLEVEL":
            case 6:
                message.pageTransition = 6;
                break;
            case "FORM_SUBMIT":
            case 7:
                message.pageTransition = 7;
                break;
            case "RELOAD":
            case 8:
                message.pageTransition = 8;
                break;
            case "KEYWORD":
            case 9:
                message.pageTransition = 9;
                break;
            case "KEYWORD_GENERATED":
            case 10:
                message.pageTransition = 10;
                break;
            }
            switch (object.redirectType) {
            case "CLIENT_REDIRECT":
            case 1:
                message.redirectType = 1;
                break;
            case "SERVER_REDIRECT":
            case 2:
                message.redirectType = 2;
                break;
            }
            if (object.uniqueId != null)
                message.uniqueId = object.uniqueId | 0;
            if (object.timestampMsec != null)
                if ($util.Long)
                    (message.timestampMsec = $util.Long.fromValue(object.timestampMsec)).unsigned = false;
                else if (typeof object.timestampMsec === "string")
                    message.timestampMsec = parseInt(object.timestampMsec, 10);
                else if (typeof object.timestampMsec === "number")
                    message.timestampMsec = object.timestampMsec;
                else if (typeof object.timestampMsec === "object")
                    message.timestampMsec = new $util.LongBits(object.timestampMsec.low >>> 0, object.timestampMsec.high >>> 0).toNumber();
            if (object.navigationForwardBack != null)
                message.navigationForwardBack = Boolean(object.navigationForwardBack);
            if (object.navigationFromAddressBar != null)
                message.navigationFromAddressBar = Boolean(object.navigationFromAddressBar);
            if (object.navigationHomePage != null)
                message.navigationHomePage = Boolean(object.navigationHomePage);
            if (object.navigationChainStart != null)
                message.navigationChainStart = Boolean(object.navigationChainStart);
            if (object.navigationChainEnd != null)
                message.navigationChainEnd = Boolean(object.navigationChainEnd);
            if (object.globalId != null)
                if ($util.Long)
                    (message.globalId = $util.Long.fromValue(object.globalId)).unsigned = false;
                else if (typeof object.globalId === "string")
                    message.globalId = parseInt(object.globalId, 10);
                else if (typeof object.globalId === "number")
                    message.globalId = object.globalId;
                else if (typeof object.globalId === "object")
                    message.globalId = new $util.LongBits(object.globalId.low >>> 0, object.globalId.high >>> 0).toNumber();
            if (object.searchTerms != null)
                message.searchTerms = String(object.searchTerms);
            if (object.faviconUrl != null)
                message.faviconUrl = String(object.faviconUrl);
            switch (object.blockedState) {
            case "STATE_ALLOWED":
            case 1:
                message.blockedState = 1;
                break;
            case "STATE_BLOCKED":
            case 2:
                message.blockedState = 2;
                break;
            }
            if (object.contentPackCategories) {
                if (!Array.isArray(object.contentPackCategories))
                    throw TypeError(".sync_pb.TabNavigation.contentPackCategories: array expected");
                message.contentPackCategories = [];
                for (let i = 0; i < object.contentPackCategories.length; ++i)
                    message.contentPackCategories[i] = String(object.contentPackCategories[i]);
            }
            if (object.httpStatusCode != null)
                message.httpStatusCode = object.httpStatusCode | 0;
            if (object.obsoleteReferrerPolicy != null)
                message.obsoleteReferrerPolicy = object.obsoleteReferrerPolicy | 0;
            if (object.isRestored != null)
                message.isRestored = Boolean(object.isRestored);
            if (object.navigationRedirect) {
                if (!Array.isArray(object.navigationRedirect))
                    throw TypeError(".sync_pb.TabNavigation.navigationRedirect: array expected");
                message.navigationRedirect = [];
                for (let i = 0; i < object.navigationRedirect.length; ++i) {
                    if (typeof object.navigationRedirect[i] !== "object")
                        throw TypeError(".sync_pb.TabNavigation.navigationRedirect: object expected");
                    message.navigationRedirect[i] = $root.sync_pb.NavigationRedirect.fromObject(object.navigationRedirect[i]);
                }
            }
            if (object.lastNavigationRedirectUrl != null)
                message.lastNavigationRedirectUrl = String(object.lastNavigationRedirectUrl);
            if (object.correctReferrerPolicy != null)
                message.correctReferrerPolicy = object.correctReferrerPolicy | 0;
            switch (object.passwordState) {
            case "PASSWORD_STATE_UNKNOWN":
            case 0:
                message.passwordState = 0;
                break;
            case "NO_PASSWORD_FIELD":
            case 1:
                message.passwordState = 1;
                break;
            case "HAS_PASSWORD_FIELD":
            case 2:
                message.passwordState = 2;
                break;
            }
            if (object.taskId != null)
                if ($util.Long)
                    (message.taskId = $util.Long.fromValue(object.taskId)).unsigned = false;
                else if (typeof object.taskId === "string")
                    message.taskId = parseInt(object.taskId, 10);
                else if (typeof object.taskId === "number")
                    message.taskId = object.taskId;
                else if (typeof object.taskId === "object")
                    message.taskId = new $util.LongBits(object.taskId.low >>> 0, object.taskId.high >>> 0).toNumber();
            if (object.ancestorTaskId) {
                if (!Array.isArray(object.ancestorTaskId))
                    throw TypeError(".sync_pb.TabNavigation.ancestorTaskId: array expected");
                message.ancestorTaskId = [];
                for (let i = 0; i < object.ancestorTaskId.length; ++i)
                    if ($util.Long)
                        (message.ancestorTaskId[i] = $util.Long.fromValue(object.ancestorTaskId[i])).unsigned = false;
                    else if (typeof object.ancestorTaskId[i] === "string")
                        message.ancestorTaskId[i] = parseInt(object.ancestorTaskId[i], 10);
                    else if (typeof object.ancestorTaskId[i] === "number")
                        message.ancestorTaskId[i] = object.ancestorTaskId[i];
                    else if (typeof object.ancestorTaskId[i] === "object")
                        message.ancestorTaskId[i] = new $util.LongBits(object.ancestorTaskId[i].low >>> 0, object.ancestorTaskId[i].high >>> 0).toNumber();
            }
            if (object.replacedNavigation != null) {
                if (typeof object.replacedNavigation !== "object")
                    throw TypeError(".sync_pb.TabNavigation.replacedNavigation: object expected");
                message.replacedNavigation = $root.sync_pb.ReplacedNavigation.fromObject(object.replacedNavigation);
            }
            if (object.pageLanguage != null)
                message.pageLanguage = String(object.pageLanguage);
            return message;
        };

        /**
         * Creates a plain object from a TabNavigation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.TabNavigation
         * @static
         * @param {sync_pb.TabNavigation} message TabNavigation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TabNavigation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.contentPackCategories = [];
                object.navigationRedirect = [];
                object.ancestorTaskId = [];
            }
            if (options.defaults) {
                object.virtualUrl = "";
                object.referrer = "";
                object.title = "";
                object.pageTransition = options.enums === String ? "LINK" : 0;
                object.redirectType = options.enums === String ? "CLIENT_REDIRECT" : 1;
                object.uniqueId = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.timestampMsec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestampMsec = options.longs === String ? "0" : 0;
                object.navigationForwardBack = false;
                object.navigationFromAddressBar = false;
                object.navigationHomePage = false;
                object.navigationChainStart = false;
                object.navigationChainEnd = false;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.globalId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.globalId = options.longs === String ? "0" : 0;
                object.searchTerms = "";
                object.faviconUrl = "";
                object.blockedState = options.enums === String ? "STATE_ALLOWED" : 1;
                object.httpStatusCode = 0;
                object.obsoleteReferrerPolicy = 0;
                object.isRestored = false;
                object.lastNavigationRedirectUrl = "";
                object.correctReferrerPolicy = 1;
                object.passwordState = options.enums === String ? "PASSWORD_STATE_UNKNOWN" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.taskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.taskId = options.longs === String ? "0" : 0;
                object.replacedNavigation = null;
                object.pageLanguage = "";
            }
            if (message.virtualUrl != null && message.hasOwnProperty("virtualUrl"))
                object.virtualUrl = message.virtualUrl;
            if (message.referrer != null && message.hasOwnProperty("referrer"))
                object.referrer = message.referrer;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.pageTransition != null && message.hasOwnProperty("pageTransition"))
                object.pageTransition = options.enums === String ? $root.sync_pb.SyncEnums.PageTransition[message.pageTransition] : message.pageTransition;
            if (message.redirectType != null && message.hasOwnProperty("redirectType"))
                object.redirectType = options.enums === String ? $root.sync_pb.SyncEnums.PageTransitionRedirectType[message.redirectType] : message.redirectType;
            if (message.uniqueId != null && message.hasOwnProperty("uniqueId"))
                object.uniqueId = message.uniqueId;
            if (message.timestampMsec != null && message.hasOwnProperty("timestampMsec"))
                if (typeof message.timestampMsec === "number")
                    object.timestampMsec = options.longs === String ? String(message.timestampMsec) : message.timestampMsec;
                else
                    object.timestampMsec = options.longs === String ? $util.Long.prototype.toString.call(message.timestampMsec) : options.longs === Number ? new $util.LongBits(message.timestampMsec.low >>> 0, message.timestampMsec.high >>> 0).toNumber() : message.timestampMsec;
            if (message.navigationForwardBack != null && message.hasOwnProperty("navigationForwardBack"))
                object.navigationForwardBack = message.navigationForwardBack;
            if (message.navigationFromAddressBar != null && message.hasOwnProperty("navigationFromAddressBar"))
                object.navigationFromAddressBar = message.navigationFromAddressBar;
            if (message.navigationHomePage != null && message.hasOwnProperty("navigationHomePage"))
                object.navigationHomePage = message.navigationHomePage;
            if (message.navigationChainStart != null && message.hasOwnProperty("navigationChainStart"))
                object.navigationChainStart = message.navigationChainStart;
            if (message.navigationChainEnd != null && message.hasOwnProperty("navigationChainEnd"))
                object.navigationChainEnd = message.navigationChainEnd;
            if (message.globalId != null && message.hasOwnProperty("globalId"))
                if (typeof message.globalId === "number")
                    object.globalId = options.longs === String ? String(message.globalId) : message.globalId;
                else
                    object.globalId = options.longs === String ? $util.Long.prototype.toString.call(message.globalId) : options.longs === Number ? new $util.LongBits(message.globalId.low >>> 0, message.globalId.high >>> 0).toNumber() : message.globalId;
            if (message.searchTerms != null && message.hasOwnProperty("searchTerms"))
                object.searchTerms = message.searchTerms;
            if (message.faviconUrl != null && message.hasOwnProperty("faviconUrl"))
                object.faviconUrl = message.faviconUrl;
            if (message.blockedState != null && message.hasOwnProperty("blockedState"))
                object.blockedState = options.enums === String ? $root.sync_pb.TabNavigation.BlockedState[message.blockedState] : message.blockedState;
            if (message.contentPackCategories && message.contentPackCategories.length) {
                object.contentPackCategories = [];
                for (let j = 0; j < message.contentPackCategories.length; ++j)
                    object.contentPackCategories[j] = message.contentPackCategories[j];
            }
            if (message.httpStatusCode != null && message.hasOwnProperty("httpStatusCode"))
                object.httpStatusCode = message.httpStatusCode;
            if (message.obsoleteReferrerPolicy != null && message.hasOwnProperty("obsoleteReferrerPolicy"))
                object.obsoleteReferrerPolicy = message.obsoleteReferrerPolicy;
            if (message.isRestored != null && message.hasOwnProperty("isRestored"))
                object.isRestored = message.isRestored;
            if (message.navigationRedirect && message.navigationRedirect.length) {
                object.navigationRedirect = [];
                for (let j = 0; j < message.navigationRedirect.length; ++j)
                    object.navigationRedirect[j] = $root.sync_pb.NavigationRedirect.toObject(message.navigationRedirect[j], options);
            }
            if (message.lastNavigationRedirectUrl != null && message.hasOwnProperty("lastNavigationRedirectUrl"))
                object.lastNavigationRedirectUrl = message.lastNavigationRedirectUrl;
            if (message.correctReferrerPolicy != null && message.hasOwnProperty("correctReferrerPolicy"))
                object.correctReferrerPolicy = message.correctReferrerPolicy;
            if (message.passwordState != null && message.hasOwnProperty("passwordState"))
                object.passwordState = options.enums === String ? $root.sync_pb.TabNavigation.PasswordState[message.passwordState] : message.passwordState;
            if (message.taskId != null && message.hasOwnProperty("taskId"))
                if (typeof message.taskId === "number")
                    object.taskId = options.longs === String ? String(message.taskId) : message.taskId;
                else
                    object.taskId = options.longs === String ? $util.Long.prototype.toString.call(message.taskId) : options.longs === Number ? new $util.LongBits(message.taskId.low >>> 0, message.taskId.high >>> 0).toNumber() : message.taskId;
            if (message.ancestorTaskId && message.ancestorTaskId.length) {
                object.ancestorTaskId = [];
                for (let j = 0; j < message.ancestorTaskId.length; ++j)
                    if (typeof message.ancestorTaskId[j] === "number")
                        object.ancestorTaskId[j] = options.longs === String ? String(message.ancestorTaskId[j]) : message.ancestorTaskId[j];
                    else
                        object.ancestorTaskId[j] = options.longs === String ? $util.Long.prototype.toString.call(message.ancestorTaskId[j]) : options.longs === Number ? new $util.LongBits(message.ancestorTaskId[j].low >>> 0, message.ancestorTaskId[j].high >>> 0).toNumber() : message.ancestorTaskId[j];
            }
            if (message.replacedNavigation != null && message.hasOwnProperty("replacedNavigation"))
                object.replacedNavigation = $root.sync_pb.ReplacedNavigation.toObject(message.replacedNavigation, options);
            if (message.pageLanguage != null && message.hasOwnProperty("pageLanguage"))
                object.pageLanguage = message.pageLanguage;
            return object;
        };

        /**
         * Converts this TabNavigation to JSON.
         * @function toJSON
         * @memberof sync_pb.TabNavigation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TabNavigation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * BlockedState enum.
         * @name sync_pb.TabNavigation.BlockedState
         * @enum {number}
         * @property {number} STATE_ALLOWED=1 STATE_ALLOWED value
         * @property {number} STATE_BLOCKED=2 STATE_BLOCKED value
         */
        TabNavigation.BlockedState = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "STATE_ALLOWED"] = 1;
            values[valuesById[2] = "STATE_BLOCKED"] = 2;
            return values;
        })();

        /**
         * PasswordState enum.
         * @name sync_pb.TabNavigation.PasswordState
         * @enum {number}
         * @property {number} PASSWORD_STATE_UNKNOWN=0 PASSWORD_STATE_UNKNOWN value
         * @property {number} NO_PASSWORD_FIELD=1 NO_PASSWORD_FIELD value
         * @property {number} HAS_PASSWORD_FIELD=2 HAS_PASSWORD_FIELD value
         */
        TabNavigation.PasswordState = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "PASSWORD_STATE_UNKNOWN"] = 0;
            values[valuesById[1] = "NO_PASSWORD_FIELD"] = 1;
            values[valuesById[2] = "HAS_PASSWORD_FIELD"] = 2;
            return values;
        })();

        return TabNavigation;
    })();

    sync_pb.NavigationRedirect = (function() {

        /**
         * Properties of a NavigationRedirect.
         * @memberof sync_pb
         * @interface INavigationRedirect
         * @property {string|null} [url] NavigationRedirect url
         */

        /**
         * Constructs a new NavigationRedirect.
         * @memberof sync_pb
         * @classdesc Represents a NavigationRedirect.
         * @implements INavigationRedirect
         * @constructor
         * @param {sync_pb.INavigationRedirect=} [properties] Properties to set
         */
        function NavigationRedirect(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NavigationRedirect url.
         * @member {string} url
         * @memberof sync_pb.NavigationRedirect
         * @instance
         */
        NavigationRedirect.prototype.url = "";

        /**
         * Creates a new NavigationRedirect instance using the specified properties.
         * @function create
         * @memberof sync_pb.NavigationRedirect
         * @static
         * @param {sync_pb.INavigationRedirect=} [properties] Properties to set
         * @returns {sync_pb.NavigationRedirect} NavigationRedirect instance
         */
        NavigationRedirect.create = function create(properties) {
            return new NavigationRedirect(properties);
        };

        /**
         * Encodes the specified NavigationRedirect message. Does not implicitly {@link sync_pb.NavigationRedirect.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.NavigationRedirect
         * @static
         * @param {sync_pb.INavigationRedirect} message NavigationRedirect message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NavigationRedirect.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.url);
            return writer;
        };

        /**
         * Encodes the specified NavigationRedirect message, length delimited. Does not implicitly {@link sync_pb.NavigationRedirect.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.NavigationRedirect
         * @static
         * @param {sync_pb.INavigationRedirect} message NavigationRedirect message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NavigationRedirect.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NavigationRedirect message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.NavigationRedirect
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.NavigationRedirect} NavigationRedirect
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NavigationRedirect.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.NavigationRedirect();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.url = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NavigationRedirect message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.NavigationRedirect
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.NavigationRedirect} NavigationRedirect
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NavigationRedirect.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NavigationRedirect message.
         * @function verify
         * @memberof sync_pb.NavigationRedirect
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NavigationRedirect.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            return null;
        };

        /**
         * Creates a NavigationRedirect message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.NavigationRedirect
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.NavigationRedirect} NavigationRedirect
         */
        NavigationRedirect.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.NavigationRedirect)
                return object;
            let message = new $root.sync_pb.NavigationRedirect();
            if (object.url != null)
                message.url = String(object.url);
            return message;
        };

        /**
         * Creates a plain object from a NavigationRedirect message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.NavigationRedirect
         * @static
         * @param {sync_pb.NavigationRedirect} message NavigationRedirect
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NavigationRedirect.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.url = "";
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            return object;
        };

        /**
         * Converts this NavigationRedirect to JSON.
         * @function toJSON
         * @memberof sync_pb.NavigationRedirect
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NavigationRedirect.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NavigationRedirect;
    })();

    sync_pb.ReplacedNavigation = (function() {

        /**
         * Properties of a ReplacedNavigation.
         * @memberof sync_pb
         * @interface IReplacedNavigation
         * @property {string|null} [firstCommittedUrl] ReplacedNavigation firstCommittedUrl
         * @property {number|Long|null} [firstTimestampMsec] ReplacedNavigation firstTimestampMsec
         * @property {sync_pb.SyncEnums.PageTransition|null} [firstPageTransition] ReplacedNavigation firstPageTransition
         */

        /**
         * Constructs a new ReplacedNavigation.
         * @memberof sync_pb
         * @classdesc Represents a ReplacedNavigation.
         * @implements IReplacedNavigation
         * @constructor
         * @param {sync_pb.IReplacedNavigation=} [properties] Properties to set
         */
        function ReplacedNavigation(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReplacedNavigation firstCommittedUrl.
         * @member {string} firstCommittedUrl
         * @memberof sync_pb.ReplacedNavigation
         * @instance
         */
        ReplacedNavigation.prototype.firstCommittedUrl = "";

        /**
         * ReplacedNavigation firstTimestampMsec.
         * @member {number|Long} firstTimestampMsec
         * @memberof sync_pb.ReplacedNavigation
         * @instance
         */
        ReplacedNavigation.prototype.firstTimestampMsec = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ReplacedNavigation firstPageTransition.
         * @member {sync_pb.SyncEnums.PageTransition} firstPageTransition
         * @memberof sync_pb.ReplacedNavigation
         * @instance
         */
        ReplacedNavigation.prototype.firstPageTransition = 0;

        /**
         * Creates a new ReplacedNavigation instance using the specified properties.
         * @function create
         * @memberof sync_pb.ReplacedNavigation
         * @static
         * @param {sync_pb.IReplacedNavigation=} [properties] Properties to set
         * @returns {sync_pb.ReplacedNavigation} ReplacedNavigation instance
         */
        ReplacedNavigation.create = function create(properties) {
            return new ReplacedNavigation(properties);
        };

        /**
         * Encodes the specified ReplacedNavigation message. Does not implicitly {@link sync_pb.ReplacedNavigation.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.ReplacedNavigation
         * @static
         * @param {sync_pb.IReplacedNavigation} message ReplacedNavigation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReplacedNavigation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.firstCommittedUrl != null && Object.hasOwnProperty.call(message, "firstCommittedUrl"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.firstCommittedUrl);
            if (message.firstTimestampMsec != null && Object.hasOwnProperty.call(message, "firstTimestampMsec"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.firstTimestampMsec);
            if (message.firstPageTransition != null && Object.hasOwnProperty.call(message, "firstPageTransition"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.firstPageTransition);
            return writer;
        };

        /**
         * Encodes the specified ReplacedNavigation message, length delimited. Does not implicitly {@link sync_pb.ReplacedNavigation.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.ReplacedNavigation
         * @static
         * @param {sync_pb.IReplacedNavigation} message ReplacedNavigation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReplacedNavigation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReplacedNavigation message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.ReplacedNavigation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.ReplacedNavigation} ReplacedNavigation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReplacedNavigation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.ReplacedNavigation();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.firstCommittedUrl = reader.string();
                    break;
                case 2:
                    message.firstTimestampMsec = reader.int64();
                    break;
                case 3:
                    message.firstPageTransition = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReplacedNavigation message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.ReplacedNavigation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.ReplacedNavigation} ReplacedNavigation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReplacedNavigation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReplacedNavigation message.
         * @function verify
         * @memberof sync_pb.ReplacedNavigation
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReplacedNavigation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.firstCommittedUrl != null && message.hasOwnProperty("firstCommittedUrl"))
                if (!$util.isString(message.firstCommittedUrl))
                    return "firstCommittedUrl: string expected";
            if (message.firstTimestampMsec != null && message.hasOwnProperty("firstTimestampMsec"))
                if (!$util.isInteger(message.firstTimestampMsec) && !(message.firstTimestampMsec && $util.isInteger(message.firstTimestampMsec.low) && $util.isInteger(message.firstTimestampMsec.high)))
                    return "firstTimestampMsec: integer|Long expected";
            if (message.firstPageTransition != null && message.hasOwnProperty("firstPageTransition"))
                switch (message.firstPageTransition) {
                default:
                    return "firstPageTransition: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                    break;
                }
            return null;
        };

        /**
         * Creates a ReplacedNavigation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.ReplacedNavigation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.ReplacedNavigation} ReplacedNavigation
         */
        ReplacedNavigation.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.ReplacedNavigation)
                return object;
            let message = new $root.sync_pb.ReplacedNavigation();
            if (object.firstCommittedUrl != null)
                message.firstCommittedUrl = String(object.firstCommittedUrl);
            if (object.firstTimestampMsec != null)
                if ($util.Long)
                    (message.firstTimestampMsec = $util.Long.fromValue(object.firstTimestampMsec)).unsigned = false;
                else if (typeof object.firstTimestampMsec === "string")
                    message.firstTimestampMsec = parseInt(object.firstTimestampMsec, 10);
                else if (typeof object.firstTimestampMsec === "number")
                    message.firstTimestampMsec = object.firstTimestampMsec;
                else if (typeof object.firstTimestampMsec === "object")
                    message.firstTimestampMsec = new $util.LongBits(object.firstTimestampMsec.low >>> 0, object.firstTimestampMsec.high >>> 0).toNumber();
            switch (object.firstPageTransition) {
            case "LINK":
            case 0:
                message.firstPageTransition = 0;
                break;
            case "TYPED":
            case 1:
                message.firstPageTransition = 1;
                break;
            case "AUTO_BOOKMARK":
            case 2:
                message.firstPageTransition = 2;
                break;
            case "AUTO_SUBFRAME":
            case 3:
                message.firstPageTransition = 3;
                break;
            case "MANUAL_SUBFRAME":
            case 4:
                message.firstPageTransition = 4;
                break;
            case "GENERATED":
            case 5:
                message.firstPageTransition = 5;
                break;
            case "AUTO_TOPLEVEL":
            case 6:
                message.firstPageTransition = 6;
                break;
            case "FORM_SUBMIT":
            case 7:
                message.firstPageTransition = 7;
                break;
            case "RELOAD":
            case 8:
                message.firstPageTransition = 8;
                break;
            case "KEYWORD":
            case 9:
                message.firstPageTransition = 9;
                break;
            case "KEYWORD_GENERATED":
            case 10:
                message.firstPageTransition = 10;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a ReplacedNavigation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.ReplacedNavigation
         * @static
         * @param {sync_pb.ReplacedNavigation} message ReplacedNavigation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReplacedNavigation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.firstCommittedUrl = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.firstTimestampMsec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.firstTimestampMsec = options.longs === String ? "0" : 0;
                object.firstPageTransition = options.enums === String ? "LINK" : 0;
            }
            if (message.firstCommittedUrl != null && message.hasOwnProperty("firstCommittedUrl"))
                object.firstCommittedUrl = message.firstCommittedUrl;
            if (message.firstTimestampMsec != null && message.hasOwnProperty("firstTimestampMsec"))
                if (typeof message.firstTimestampMsec === "number")
                    object.firstTimestampMsec = options.longs === String ? String(message.firstTimestampMsec) : message.firstTimestampMsec;
                else
                    object.firstTimestampMsec = options.longs === String ? $util.Long.prototype.toString.call(message.firstTimestampMsec) : options.longs === Number ? new $util.LongBits(message.firstTimestampMsec.low >>> 0, message.firstTimestampMsec.high >>> 0).toNumber() : message.firstTimestampMsec;
            if (message.firstPageTransition != null && message.hasOwnProperty("firstPageTransition"))
                object.firstPageTransition = options.enums === String ? $root.sync_pb.SyncEnums.PageTransition[message.firstPageTransition] : message.firstPageTransition;
            return object;
        };

        /**
         * Converts this ReplacedNavigation to JSON.
         * @function toJSON
         * @memberof sync_pb.ReplacedNavigation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReplacedNavigation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ReplacedNavigation;
    })();

    sync_pb.HistoryDeleteDirectiveSpecifics = (function() {

        /**
         * Properties of a HistoryDeleteDirectiveSpecifics.
         * @memberof sync_pb
         * @interface IHistoryDeleteDirectiveSpecifics
         * @property {sync_pb.IGlobalIdDirective|null} [globalIdDirective] HistoryDeleteDirectiveSpecifics globalIdDirective
         * @property {sync_pb.ITimeRangeDirective|null} [timeRangeDirective] HistoryDeleteDirectiveSpecifics timeRangeDirective
         * @property {sync_pb.IUrlDirective|null} [urlDirective] HistoryDeleteDirectiveSpecifics urlDirective
         */

        /**
         * Constructs a new HistoryDeleteDirectiveSpecifics.
         * @memberof sync_pb
         * @classdesc Represents a HistoryDeleteDirectiveSpecifics.
         * @implements IHistoryDeleteDirectiveSpecifics
         * @constructor
         * @param {sync_pb.IHistoryDeleteDirectiveSpecifics=} [properties] Properties to set
         */
        function HistoryDeleteDirectiveSpecifics(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HistoryDeleteDirectiveSpecifics globalIdDirective.
         * @member {sync_pb.IGlobalIdDirective|null|undefined} globalIdDirective
         * @memberof sync_pb.HistoryDeleteDirectiveSpecifics
         * @instance
         */
        HistoryDeleteDirectiveSpecifics.prototype.globalIdDirective = null;

        /**
         * HistoryDeleteDirectiveSpecifics timeRangeDirective.
         * @member {sync_pb.ITimeRangeDirective|null|undefined} timeRangeDirective
         * @memberof sync_pb.HistoryDeleteDirectiveSpecifics
         * @instance
         */
        HistoryDeleteDirectiveSpecifics.prototype.timeRangeDirective = null;

        /**
         * HistoryDeleteDirectiveSpecifics urlDirective.
         * @member {sync_pb.IUrlDirective|null|undefined} urlDirective
         * @memberof sync_pb.HistoryDeleteDirectiveSpecifics
         * @instance
         */
        HistoryDeleteDirectiveSpecifics.prototype.urlDirective = null;

        /**
         * Creates a new HistoryDeleteDirectiveSpecifics instance using the specified properties.
         * @function create
         * @memberof sync_pb.HistoryDeleteDirectiveSpecifics
         * @static
         * @param {sync_pb.IHistoryDeleteDirectiveSpecifics=} [properties] Properties to set
         * @returns {sync_pb.HistoryDeleteDirectiveSpecifics} HistoryDeleteDirectiveSpecifics instance
         */
        HistoryDeleteDirectiveSpecifics.create = function create(properties) {
            return new HistoryDeleteDirectiveSpecifics(properties);
        };

        /**
         * Encodes the specified HistoryDeleteDirectiveSpecifics message. Does not implicitly {@link sync_pb.HistoryDeleteDirectiveSpecifics.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.HistoryDeleteDirectiveSpecifics
         * @static
         * @param {sync_pb.IHistoryDeleteDirectiveSpecifics} message HistoryDeleteDirectiveSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HistoryDeleteDirectiveSpecifics.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.globalIdDirective != null && Object.hasOwnProperty.call(message, "globalIdDirective"))
                $root.sync_pb.GlobalIdDirective.encode(message.globalIdDirective, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.timeRangeDirective != null && Object.hasOwnProperty.call(message, "timeRangeDirective"))
                $root.sync_pb.TimeRangeDirective.encode(message.timeRangeDirective, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.urlDirective != null && Object.hasOwnProperty.call(message, "urlDirective"))
                $root.sync_pb.UrlDirective.encode(message.urlDirective, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified HistoryDeleteDirectiveSpecifics message, length delimited. Does not implicitly {@link sync_pb.HistoryDeleteDirectiveSpecifics.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.HistoryDeleteDirectiveSpecifics
         * @static
         * @param {sync_pb.IHistoryDeleteDirectiveSpecifics} message HistoryDeleteDirectiveSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HistoryDeleteDirectiveSpecifics.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a HistoryDeleteDirectiveSpecifics message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.HistoryDeleteDirectiveSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.HistoryDeleteDirectiveSpecifics} HistoryDeleteDirectiveSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HistoryDeleteDirectiveSpecifics.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.HistoryDeleteDirectiveSpecifics();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.globalIdDirective = $root.sync_pb.GlobalIdDirective.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.timeRangeDirective = $root.sync_pb.TimeRangeDirective.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.urlDirective = $root.sync_pb.UrlDirective.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a HistoryDeleteDirectiveSpecifics message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.HistoryDeleteDirectiveSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.HistoryDeleteDirectiveSpecifics} HistoryDeleteDirectiveSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HistoryDeleteDirectiveSpecifics.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a HistoryDeleteDirectiveSpecifics message.
         * @function verify
         * @memberof sync_pb.HistoryDeleteDirectiveSpecifics
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        HistoryDeleteDirectiveSpecifics.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.globalIdDirective != null && message.hasOwnProperty("globalIdDirective")) {
                let error = $root.sync_pb.GlobalIdDirective.verify(message.globalIdDirective);
                if (error)
                    return "globalIdDirective." + error;
            }
            if (message.timeRangeDirective != null && message.hasOwnProperty("timeRangeDirective")) {
                let error = $root.sync_pb.TimeRangeDirective.verify(message.timeRangeDirective);
                if (error)
                    return "timeRangeDirective." + error;
            }
            if (message.urlDirective != null && message.hasOwnProperty("urlDirective")) {
                let error = $root.sync_pb.UrlDirective.verify(message.urlDirective);
                if (error)
                    return "urlDirective." + error;
            }
            return null;
        };

        /**
         * Creates a HistoryDeleteDirectiveSpecifics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.HistoryDeleteDirectiveSpecifics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.HistoryDeleteDirectiveSpecifics} HistoryDeleteDirectiveSpecifics
         */
        HistoryDeleteDirectiveSpecifics.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.HistoryDeleteDirectiveSpecifics)
                return object;
            let message = new $root.sync_pb.HistoryDeleteDirectiveSpecifics();
            if (object.globalIdDirective != null) {
                if (typeof object.globalIdDirective !== "object")
                    throw TypeError(".sync_pb.HistoryDeleteDirectiveSpecifics.globalIdDirective: object expected");
                message.globalIdDirective = $root.sync_pb.GlobalIdDirective.fromObject(object.globalIdDirective);
            }
            if (object.timeRangeDirective != null) {
                if (typeof object.timeRangeDirective !== "object")
                    throw TypeError(".sync_pb.HistoryDeleteDirectiveSpecifics.timeRangeDirective: object expected");
                message.timeRangeDirective = $root.sync_pb.TimeRangeDirective.fromObject(object.timeRangeDirective);
            }
            if (object.urlDirective != null) {
                if (typeof object.urlDirective !== "object")
                    throw TypeError(".sync_pb.HistoryDeleteDirectiveSpecifics.urlDirective: object expected");
                message.urlDirective = $root.sync_pb.UrlDirective.fromObject(object.urlDirective);
            }
            return message;
        };

        /**
         * Creates a plain object from a HistoryDeleteDirectiveSpecifics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.HistoryDeleteDirectiveSpecifics
         * @static
         * @param {sync_pb.HistoryDeleteDirectiveSpecifics} message HistoryDeleteDirectiveSpecifics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HistoryDeleteDirectiveSpecifics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.globalIdDirective = null;
                object.timeRangeDirective = null;
                object.urlDirective = null;
            }
            if (message.globalIdDirective != null && message.hasOwnProperty("globalIdDirective"))
                object.globalIdDirective = $root.sync_pb.GlobalIdDirective.toObject(message.globalIdDirective, options);
            if (message.timeRangeDirective != null && message.hasOwnProperty("timeRangeDirective"))
                object.timeRangeDirective = $root.sync_pb.TimeRangeDirective.toObject(message.timeRangeDirective, options);
            if (message.urlDirective != null && message.hasOwnProperty("urlDirective"))
                object.urlDirective = $root.sync_pb.UrlDirective.toObject(message.urlDirective, options);
            return object;
        };

        /**
         * Converts this HistoryDeleteDirectiveSpecifics to JSON.
         * @function toJSON
         * @memberof sync_pb.HistoryDeleteDirectiveSpecifics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HistoryDeleteDirectiveSpecifics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HistoryDeleteDirectiveSpecifics;
    })();

    sync_pb.GlobalIdDirective = (function() {

        /**
         * Properties of a GlobalIdDirective.
         * @memberof sync_pb
         * @interface IGlobalIdDirective
         * @property {Array.<number|Long>|null} [globalId] GlobalIdDirective globalId
         * @property {number|Long|null} [startTimeUsec] GlobalIdDirective startTimeUsec
         * @property {number|Long|null} [endTimeUsec] GlobalIdDirective endTimeUsec
         */

        /**
         * Constructs a new GlobalIdDirective.
         * @memberof sync_pb
         * @classdesc Represents a GlobalIdDirective.
         * @implements IGlobalIdDirective
         * @constructor
         * @param {sync_pb.IGlobalIdDirective=} [properties] Properties to set
         */
        function GlobalIdDirective(properties) {
            this.globalId = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GlobalIdDirective globalId.
         * @member {Array.<number|Long>} globalId
         * @memberof sync_pb.GlobalIdDirective
         * @instance
         */
        GlobalIdDirective.prototype.globalId = $util.emptyArray;

        /**
         * GlobalIdDirective startTimeUsec.
         * @member {number|Long} startTimeUsec
         * @memberof sync_pb.GlobalIdDirective
         * @instance
         */
        GlobalIdDirective.prototype.startTimeUsec = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * GlobalIdDirective endTimeUsec.
         * @member {number|Long} endTimeUsec
         * @memberof sync_pb.GlobalIdDirective
         * @instance
         */
        GlobalIdDirective.prototype.endTimeUsec = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new GlobalIdDirective instance using the specified properties.
         * @function create
         * @memberof sync_pb.GlobalIdDirective
         * @static
         * @param {sync_pb.IGlobalIdDirective=} [properties] Properties to set
         * @returns {sync_pb.GlobalIdDirective} GlobalIdDirective instance
         */
        GlobalIdDirective.create = function create(properties) {
            return new GlobalIdDirective(properties);
        };

        /**
         * Encodes the specified GlobalIdDirective message. Does not implicitly {@link sync_pb.GlobalIdDirective.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.GlobalIdDirective
         * @static
         * @param {sync_pb.IGlobalIdDirective} message GlobalIdDirective message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GlobalIdDirective.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.globalId != null && message.globalId.length)
                for (let i = 0; i < message.globalId.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.globalId[i]);
            if (message.startTimeUsec != null && Object.hasOwnProperty.call(message, "startTimeUsec"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.startTimeUsec);
            if (message.endTimeUsec != null && Object.hasOwnProperty.call(message, "endTimeUsec"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.endTimeUsec);
            return writer;
        };

        /**
         * Encodes the specified GlobalIdDirective message, length delimited. Does not implicitly {@link sync_pb.GlobalIdDirective.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.GlobalIdDirective
         * @static
         * @param {sync_pb.IGlobalIdDirective} message GlobalIdDirective message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GlobalIdDirective.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GlobalIdDirective message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.GlobalIdDirective
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.GlobalIdDirective} GlobalIdDirective
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GlobalIdDirective.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.GlobalIdDirective();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.globalId && message.globalId.length))
                        message.globalId = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.globalId.push(reader.int64());
                    } else
                        message.globalId.push(reader.int64());
                    break;
                case 2:
                    message.startTimeUsec = reader.int64();
                    break;
                case 3:
                    message.endTimeUsec = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GlobalIdDirective message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.GlobalIdDirective
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.GlobalIdDirective} GlobalIdDirective
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GlobalIdDirective.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GlobalIdDirective message.
         * @function verify
         * @memberof sync_pb.GlobalIdDirective
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GlobalIdDirective.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.globalId != null && message.hasOwnProperty("globalId")) {
                if (!Array.isArray(message.globalId))
                    return "globalId: array expected";
                for (let i = 0; i < message.globalId.length; ++i)
                    if (!$util.isInteger(message.globalId[i]) && !(message.globalId[i] && $util.isInteger(message.globalId[i].low) && $util.isInteger(message.globalId[i].high)))
                        return "globalId: integer|Long[] expected";
            }
            if (message.startTimeUsec != null && message.hasOwnProperty("startTimeUsec"))
                if (!$util.isInteger(message.startTimeUsec) && !(message.startTimeUsec && $util.isInteger(message.startTimeUsec.low) && $util.isInteger(message.startTimeUsec.high)))
                    return "startTimeUsec: integer|Long expected";
            if (message.endTimeUsec != null && message.hasOwnProperty("endTimeUsec"))
                if (!$util.isInteger(message.endTimeUsec) && !(message.endTimeUsec && $util.isInteger(message.endTimeUsec.low) && $util.isInteger(message.endTimeUsec.high)))
                    return "endTimeUsec: integer|Long expected";
            return null;
        };

        /**
         * Creates a GlobalIdDirective message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.GlobalIdDirective
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.GlobalIdDirective} GlobalIdDirective
         */
        GlobalIdDirective.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.GlobalIdDirective)
                return object;
            let message = new $root.sync_pb.GlobalIdDirective();
            if (object.globalId) {
                if (!Array.isArray(object.globalId))
                    throw TypeError(".sync_pb.GlobalIdDirective.globalId: array expected");
                message.globalId = [];
                for (let i = 0; i < object.globalId.length; ++i)
                    if ($util.Long)
                        (message.globalId[i] = $util.Long.fromValue(object.globalId[i])).unsigned = false;
                    else if (typeof object.globalId[i] === "string")
                        message.globalId[i] = parseInt(object.globalId[i], 10);
                    else if (typeof object.globalId[i] === "number")
                        message.globalId[i] = object.globalId[i];
                    else if (typeof object.globalId[i] === "object")
                        message.globalId[i] = new $util.LongBits(object.globalId[i].low >>> 0, object.globalId[i].high >>> 0).toNumber();
            }
            if (object.startTimeUsec != null)
                if ($util.Long)
                    (message.startTimeUsec = $util.Long.fromValue(object.startTimeUsec)).unsigned = false;
                else if (typeof object.startTimeUsec === "string")
                    message.startTimeUsec = parseInt(object.startTimeUsec, 10);
                else if (typeof object.startTimeUsec === "number")
                    message.startTimeUsec = object.startTimeUsec;
                else if (typeof object.startTimeUsec === "object")
                    message.startTimeUsec = new $util.LongBits(object.startTimeUsec.low >>> 0, object.startTimeUsec.high >>> 0).toNumber();
            if (object.endTimeUsec != null)
                if ($util.Long)
                    (message.endTimeUsec = $util.Long.fromValue(object.endTimeUsec)).unsigned = false;
                else if (typeof object.endTimeUsec === "string")
                    message.endTimeUsec = parseInt(object.endTimeUsec, 10);
                else if (typeof object.endTimeUsec === "number")
                    message.endTimeUsec = object.endTimeUsec;
                else if (typeof object.endTimeUsec === "object")
                    message.endTimeUsec = new $util.LongBits(object.endTimeUsec.low >>> 0, object.endTimeUsec.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a GlobalIdDirective message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.GlobalIdDirective
         * @static
         * @param {sync_pb.GlobalIdDirective} message GlobalIdDirective
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GlobalIdDirective.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.globalId = [];
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.startTimeUsec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startTimeUsec = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.endTimeUsec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTimeUsec = options.longs === String ? "0" : 0;
            }
            if (message.globalId && message.globalId.length) {
                object.globalId = [];
                for (let j = 0; j < message.globalId.length; ++j)
                    if (typeof message.globalId[j] === "number")
                        object.globalId[j] = options.longs === String ? String(message.globalId[j]) : message.globalId[j];
                    else
                        object.globalId[j] = options.longs === String ? $util.Long.prototype.toString.call(message.globalId[j]) : options.longs === Number ? new $util.LongBits(message.globalId[j].low >>> 0, message.globalId[j].high >>> 0).toNumber() : message.globalId[j];
            }
            if (message.startTimeUsec != null && message.hasOwnProperty("startTimeUsec"))
                if (typeof message.startTimeUsec === "number")
                    object.startTimeUsec = options.longs === String ? String(message.startTimeUsec) : message.startTimeUsec;
                else
                    object.startTimeUsec = options.longs === String ? $util.Long.prototype.toString.call(message.startTimeUsec) : options.longs === Number ? new $util.LongBits(message.startTimeUsec.low >>> 0, message.startTimeUsec.high >>> 0).toNumber() : message.startTimeUsec;
            if (message.endTimeUsec != null && message.hasOwnProperty("endTimeUsec"))
                if (typeof message.endTimeUsec === "number")
                    object.endTimeUsec = options.longs === String ? String(message.endTimeUsec) : message.endTimeUsec;
                else
                    object.endTimeUsec = options.longs === String ? $util.Long.prototype.toString.call(message.endTimeUsec) : options.longs === Number ? new $util.LongBits(message.endTimeUsec.low >>> 0, message.endTimeUsec.high >>> 0).toNumber() : message.endTimeUsec;
            return object;
        };

        /**
         * Converts this GlobalIdDirective to JSON.
         * @function toJSON
         * @memberof sync_pb.GlobalIdDirective
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GlobalIdDirective.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GlobalIdDirective;
    })();

    sync_pb.TimeRangeDirective = (function() {

        /**
         * Properties of a TimeRangeDirective.
         * @memberof sync_pb
         * @interface ITimeRangeDirective
         * @property {number|Long|null} [startTimeUsec] TimeRangeDirective startTimeUsec
         * @property {number|Long|null} [endTimeUsec] TimeRangeDirective endTimeUsec
         */

        /**
         * Constructs a new TimeRangeDirective.
         * @memberof sync_pb
         * @classdesc Represents a TimeRangeDirective.
         * @implements ITimeRangeDirective
         * @constructor
         * @param {sync_pb.ITimeRangeDirective=} [properties] Properties to set
         */
        function TimeRangeDirective(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TimeRangeDirective startTimeUsec.
         * @member {number|Long} startTimeUsec
         * @memberof sync_pb.TimeRangeDirective
         * @instance
         */
        TimeRangeDirective.prototype.startTimeUsec = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TimeRangeDirective endTimeUsec.
         * @member {number|Long} endTimeUsec
         * @memberof sync_pb.TimeRangeDirective
         * @instance
         */
        TimeRangeDirective.prototype.endTimeUsec = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new TimeRangeDirective instance using the specified properties.
         * @function create
         * @memberof sync_pb.TimeRangeDirective
         * @static
         * @param {sync_pb.ITimeRangeDirective=} [properties] Properties to set
         * @returns {sync_pb.TimeRangeDirective} TimeRangeDirective instance
         */
        TimeRangeDirective.create = function create(properties) {
            return new TimeRangeDirective(properties);
        };

        /**
         * Encodes the specified TimeRangeDirective message. Does not implicitly {@link sync_pb.TimeRangeDirective.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.TimeRangeDirective
         * @static
         * @param {sync_pb.ITimeRangeDirective} message TimeRangeDirective message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TimeRangeDirective.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.startTimeUsec != null && Object.hasOwnProperty.call(message, "startTimeUsec"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.startTimeUsec);
            if (message.endTimeUsec != null && Object.hasOwnProperty.call(message, "endTimeUsec"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.endTimeUsec);
            return writer;
        };

        /**
         * Encodes the specified TimeRangeDirective message, length delimited. Does not implicitly {@link sync_pb.TimeRangeDirective.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.TimeRangeDirective
         * @static
         * @param {sync_pb.ITimeRangeDirective} message TimeRangeDirective message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TimeRangeDirective.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TimeRangeDirective message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.TimeRangeDirective
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.TimeRangeDirective} TimeRangeDirective
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TimeRangeDirective.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.TimeRangeDirective();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.startTimeUsec = reader.int64();
                    break;
                case 2:
                    message.endTimeUsec = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TimeRangeDirective message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.TimeRangeDirective
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.TimeRangeDirective} TimeRangeDirective
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TimeRangeDirective.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TimeRangeDirective message.
         * @function verify
         * @memberof sync_pb.TimeRangeDirective
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TimeRangeDirective.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.startTimeUsec != null && message.hasOwnProperty("startTimeUsec"))
                if (!$util.isInteger(message.startTimeUsec) && !(message.startTimeUsec && $util.isInteger(message.startTimeUsec.low) && $util.isInteger(message.startTimeUsec.high)))
                    return "startTimeUsec: integer|Long expected";
            if (message.endTimeUsec != null && message.hasOwnProperty("endTimeUsec"))
                if (!$util.isInteger(message.endTimeUsec) && !(message.endTimeUsec && $util.isInteger(message.endTimeUsec.low) && $util.isInteger(message.endTimeUsec.high)))
                    return "endTimeUsec: integer|Long expected";
            return null;
        };

        /**
         * Creates a TimeRangeDirective message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.TimeRangeDirective
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.TimeRangeDirective} TimeRangeDirective
         */
        TimeRangeDirective.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.TimeRangeDirective)
                return object;
            let message = new $root.sync_pb.TimeRangeDirective();
            if (object.startTimeUsec != null)
                if ($util.Long)
                    (message.startTimeUsec = $util.Long.fromValue(object.startTimeUsec)).unsigned = false;
                else if (typeof object.startTimeUsec === "string")
                    message.startTimeUsec = parseInt(object.startTimeUsec, 10);
                else if (typeof object.startTimeUsec === "number")
                    message.startTimeUsec = object.startTimeUsec;
                else if (typeof object.startTimeUsec === "object")
                    message.startTimeUsec = new $util.LongBits(object.startTimeUsec.low >>> 0, object.startTimeUsec.high >>> 0).toNumber();
            if (object.endTimeUsec != null)
                if ($util.Long)
                    (message.endTimeUsec = $util.Long.fromValue(object.endTimeUsec)).unsigned = false;
                else if (typeof object.endTimeUsec === "string")
                    message.endTimeUsec = parseInt(object.endTimeUsec, 10);
                else if (typeof object.endTimeUsec === "number")
                    message.endTimeUsec = object.endTimeUsec;
                else if (typeof object.endTimeUsec === "object")
                    message.endTimeUsec = new $util.LongBits(object.endTimeUsec.low >>> 0, object.endTimeUsec.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a TimeRangeDirective message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.TimeRangeDirective
         * @static
         * @param {sync_pb.TimeRangeDirective} message TimeRangeDirective
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TimeRangeDirective.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.startTimeUsec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startTimeUsec = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.endTimeUsec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTimeUsec = options.longs === String ? "0" : 0;
            }
            if (message.startTimeUsec != null && message.hasOwnProperty("startTimeUsec"))
                if (typeof message.startTimeUsec === "number")
                    object.startTimeUsec = options.longs === String ? String(message.startTimeUsec) : message.startTimeUsec;
                else
                    object.startTimeUsec = options.longs === String ? $util.Long.prototype.toString.call(message.startTimeUsec) : options.longs === Number ? new $util.LongBits(message.startTimeUsec.low >>> 0, message.startTimeUsec.high >>> 0).toNumber() : message.startTimeUsec;
            if (message.endTimeUsec != null && message.hasOwnProperty("endTimeUsec"))
                if (typeof message.endTimeUsec === "number")
                    object.endTimeUsec = options.longs === String ? String(message.endTimeUsec) : message.endTimeUsec;
                else
                    object.endTimeUsec = options.longs === String ? $util.Long.prototype.toString.call(message.endTimeUsec) : options.longs === Number ? new $util.LongBits(message.endTimeUsec.low >>> 0, message.endTimeUsec.high >>> 0).toNumber() : message.endTimeUsec;
            return object;
        };

        /**
         * Converts this TimeRangeDirective to JSON.
         * @function toJSON
         * @memberof sync_pb.TimeRangeDirective
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TimeRangeDirective.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TimeRangeDirective;
    })();

    sync_pb.UrlDirective = (function() {

        /**
         * Properties of an UrlDirective.
         * @memberof sync_pb
         * @interface IUrlDirective
         * @property {string|null} [url] UrlDirective url
         * @property {number|Long|null} [endTimeUsec] UrlDirective endTimeUsec
         */

        /**
         * Constructs a new UrlDirective.
         * @memberof sync_pb
         * @classdesc Represents an UrlDirective.
         * @implements IUrlDirective
         * @constructor
         * @param {sync_pb.IUrlDirective=} [properties] Properties to set
         */
        function UrlDirective(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UrlDirective url.
         * @member {string} url
         * @memberof sync_pb.UrlDirective
         * @instance
         */
        UrlDirective.prototype.url = "";

        /**
         * UrlDirective endTimeUsec.
         * @member {number|Long} endTimeUsec
         * @memberof sync_pb.UrlDirective
         * @instance
         */
        UrlDirective.prototype.endTimeUsec = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new UrlDirective instance using the specified properties.
         * @function create
         * @memberof sync_pb.UrlDirective
         * @static
         * @param {sync_pb.IUrlDirective=} [properties] Properties to set
         * @returns {sync_pb.UrlDirective} UrlDirective instance
         */
        UrlDirective.create = function create(properties) {
            return new UrlDirective(properties);
        };

        /**
         * Encodes the specified UrlDirective message. Does not implicitly {@link sync_pb.UrlDirective.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.UrlDirective
         * @static
         * @param {sync_pb.IUrlDirective} message UrlDirective message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UrlDirective.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.url);
            if (message.endTimeUsec != null && Object.hasOwnProperty.call(message, "endTimeUsec"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.endTimeUsec);
            return writer;
        };

        /**
         * Encodes the specified UrlDirective message, length delimited. Does not implicitly {@link sync_pb.UrlDirective.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.UrlDirective
         * @static
         * @param {sync_pb.IUrlDirective} message UrlDirective message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UrlDirective.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UrlDirective message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.UrlDirective
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.UrlDirective} UrlDirective
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UrlDirective.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.UrlDirective();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.url = reader.string();
                    break;
                case 2:
                    message.endTimeUsec = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UrlDirective message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.UrlDirective
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.UrlDirective} UrlDirective
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UrlDirective.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UrlDirective message.
         * @function verify
         * @memberof sync_pb.UrlDirective
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UrlDirective.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            if (message.endTimeUsec != null && message.hasOwnProperty("endTimeUsec"))
                if (!$util.isInteger(message.endTimeUsec) && !(message.endTimeUsec && $util.isInteger(message.endTimeUsec.low) && $util.isInteger(message.endTimeUsec.high)))
                    return "endTimeUsec: integer|Long expected";
            return null;
        };

        /**
         * Creates an UrlDirective message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.UrlDirective
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.UrlDirective} UrlDirective
         */
        UrlDirective.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.UrlDirective)
                return object;
            let message = new $root.sync_pb.UrlDirective();
            if (object.url != null)
                message.url = String(object.url);
            if (object.endTimeUsec != null)
                if ($util.Long)
                    (message.endTimeUsec = $util.Long.fromValue(object.endTimeUsec)).unsigned = false;
                else if (typeof object.endTimeUsec === "string")
                    message.endTimeUsec = parseInt(object.endTimeUsec, 10);
                else if (typeof object.endTimeUsec === "number")
                    message.endTimeUsec = object.endTimeUsec;
                else if (typeof object.endTimeUsec === "object")
                    message.endTimeUsec = new $util.LongBits(object.endTimeUsec.low >>> 0, object.endTimeUsec.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from an UrlDirective message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.UrlDirective
         * @static
         * @param {sync_pb.UrlDirective} message UrlDirective
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UrlDirective.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.url = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.endTimeUsec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTimeUsec = options.longs === String ? "0" : 0;
            }
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            if (message.endTimeUsec != null && message.hasOwnProperty("endTimeUsec"))
                if (typeof message.endTimeUsec === "number")
                    object.endTimeUsec = options.longs === String ? String(message.endTimeUsec) : message.endTimeUsec;
                else
                    object.endTimeUsec = options.longs === String ? $util.Long.prototype.toString.call(message.endTimeUsec) : options.longs === Number ? new $util.LongBits(message.endTimeUsec.low >>> 0, message.endTimeUsec.high >>> 0).toNumber() : message.endTimeUsec;
            return object;
        };

        /**
         * Converts this UrlDirective to JSON.
         * @function toJSON
         * @memberof sync_pb.UrlDirective
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UrlDirective.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UrlDirective;
    })();

    sync_pb.PreferenceSpecifics = (function() {

        /**
         * Properties of a PreferenceSpecifics.
         * @memberof sync_pb
         * @interface IPreferenceSpecifics
         * @property {string|null} [name] PreferenceSpecifics name
         * @property {string|null} [value] PreferenceSpecifics value
         */

        /**
         * Constructs a new PreferenceSpecifics.
         * @memberof sync_pb
         * @classdesc Represents a PreferenceSpecifics.
         * @implements IPreferenceSpecifics
         * @constructor
         * @param {sync_pb.IPreferenceSpecifics=} [properties] Properties to set
         */
        function PreferenceSpecifics(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PreferenceSpecifics name.
         * @member {string} name
         * @memberof sync_pb.PreferenceSpecifics
         * @instance
         */
        PreferenceSpecifics.prototype.name = "";

        /**
         * PreferenceSpecifics value.
         * @member {string} value
         * @memberof sync_pb.PreferenceSpecifics
         * @instance
         */
        PreferenceSpecifics.prototype.value = "";

        /**
         * Creates a new PreferenceSpecifics instance using the specified properties.
         * @function create
         * @memberof sync_pb.PreferenceSpecifics
         * @static
         * @param {sync_pb.IPreferenceSpecifics=} [properties] Properties to set
         * @returns {sync_pb.PreferenceSpecifics} PreferenceSpecifics instance
         */
        PreferenceSpecifics.create = function create(properties) {
            return new PreferenceSpecifics(properties);
        };

        /**
         * Encodes the specified PreferenceSpecifics message. Does not implicitly {@link sync_pb.PreferenceSpecifics.verify|verify} messages.
         * @function encode
         * @memberof sync_pb.PreferenceSpecifics
         * @static
         * @param {sync_pb.IPreferenceSpecifics} message PreferenceSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PreferenceSpecifics.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
            return writer;
        };

        /**
         * Encodes the specified PreferenceSpecifics message, length delimited. Does not implicitly {@link sync_pb.PreferenceSpecifics.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sync_pb.PreferenceSpecifics
         * @static
         * @param {sync_pb.IPreferenceSpecifics} message PreferenceSpecifics message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PreferenceSpecifics.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PreferenceSpecifics message from the specified reader or buffer.
         * @function decode
         * @memberof sync_pb.PreferenceSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sync_pb.PreferenceSpecifics} PreferenceSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PreferenceSpecifics.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sync_pb.PreferenceSpecifics();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PreferenceSpecifics message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sync_pb.PreferenceSpecifics
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sync_pb.PreferenceSpecifics} PreferenceSpecifics
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PreferenceSpecifics.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PreferenceSpecifics message.
         * @function verify
         * @memberof sync_pb.PreferenceSpecifics
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PreferenceSpecifics.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!$util.isString(message.value))
                    return "value: string expected";
            return null;
        };

        /**
         * Creates a PreferenceSpecifics message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sync_pb.PreferenceSpecifics
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sync_pb.PreferenceSpecifics} PreferenceSpecifics
         */
        PreferenceSpecifics.fromObject = function fromObject(object) {
            if (object instanceof $root.sync_pb.PreferenceSpecifics)
                return object;
            let message = new $root.sync_pb.PreferenceSpecifics();
            if (object.name != null)
                message.name = String(object.name);
            if (object.value != null)
                message.value = String(object.value);
            return message;
        };

        /**
         * Creates a plain object from a PreferenceSpecifics message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sync_pb.PreferenceSpecifics
         * @static
         * @param {sync_pb.PreferenceSpecifics} message PreferenceSpecifics
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PreferenceSpecifics.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.name = "";
                object.value = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            return object;
        };

        /**
         * Converts this PreferenceSpecifics to JSON.
         * @function toJSON
         * @memberof sync_pb.PreferenceSpecifics
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PreferenceSpecifics.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PreferenceSpecifics;
    })();

    return sync_pb;
})();

export { $root as default };
